{
  "analyzer.mapping.error.profileUnavailable": "The analyzer profile could not be read. Retry confirmation when the Bridge is available.",
  "reporting.title": "Custom Data Export",
  "reporting.description": "Choose your report, reporting period and columns, then download a spreadsheet-ready CSV.",
  "reporting.builder": "Back to report builder",
  "reporting.queue": "My Report Queue",
  "reporting.queueEmpty": "Your generated reports will appear here.",
  "reporting.design.emptyQueuePage": "There are no reports on this page.",
  "reporting.design.firstQueuePage": "Return to the first page",
  "reporting.reportType": "Report type",
  "reporting.layout": "CSV layout",
  "reporting.layout.SPREADSHEET": "Spreadsheet — tests in columns",
  "reporting.layout.RESULT_LIST": "Detailed list — results in rows",
  "reporting.layout.TABLE": "Table",
  "reporting.meaning.SPREADSHEET": "Tests appear as columns for each specimen. Repeated results use extra rows; unrelated repeat readings are kept separate.",
  "reporting.meaning.RESULT_LIST": "Each independent result appears on its own row. Repeated results are preserved.",
  "reporting.meaning.TABLE": "Each recorded occurrence appears on its own row.",
  "reporting.dateFrom": "Date from",
  "reporting.dateTo": "Date to",
  "reporting.dates.required": "Required",
  "reporting.dates.requiredFrom": "Choose a start date.",
  "reporting.dates.requiredTo": "Choose an end date.",
  "reporting.dates.invalid": "Choose a valid calendar date.",
  "reporting.dates.reversed": "End date must be on or after the start date.",
  "reporting.dates.tooLong": "Choose a period of {days} days or fewer, including both dates.",
  "reporting.dates.range": "Choose an ordered period within the maximum shown above.",
  "reporting.periodHelp": "Uses {dateMeaning} in {timezone}, including both dates. Maximum period: {days} days.",
  "reporting.dateAnchor.collectionDate": "specimen collection dates",
  "reporting.dateAnchor.requestDate": "referral request dates",
  "reporting.dateAnchor.sentDate": "referral sent dates",
  "reporting.dateAnchor.eventOrRecordedDate": "event dates when known, otherwise recorded dates (identified by Date Basis)",
  "reporting.dateAnchor.dateOfEvent": "non-conformance event dates",
  "reporting.dateAnchor.enteredDate": "recorded rejection dates",
  "reporting.labSections": "Lab sections",
  "reporting.allAccessibleSections": "All accessible lab sections",
  "reporting.tests": "Tests",
  "reporting.allTests": "All tests",
  "reporting.resultStatuses": "Result statuses",
  "reporting.finalized": "Finalized",
  "reporting.all": "All",
  "reporting.available": "Available columns",
  "reporting.search": "Search columns",
  "reporting.selected": "Selected columns",
  "reporting.selectedCount": "Selected columns ({count})",
  "reporting.group.sample": "Sample and order",
  "reporting.group.referrals": "Referrals",
  "reporting.group.nonConformance": "Non-Conformance / Rejections",
  "reporting.group.patient": "Patient",
  "reporting.group.result": "Result details",
  "reporting.group.tests": "Configured tests",
  "reporting.group.components": "Configured result components",
  "reporting.group.turnaround": "Turnaround time",
  "reporting.group.testTurnaround": "Turnaround by test",
  "reporting.group.componentTurnaround": "Turnaround by result component",
  "reporting.group.observations": "Additional questions",
  "reporting.headerPreview": "CSV header preview",
  "reporting.moveUp": "Move {field} up",
  "reporting.moveDown": "Move {field} down",
  "reporting.remove": "Remove {field}",
  "reporting.position": "{field}: position {position} of {count}",
  "reporting.review": "Review report",
  "reporting.edit": "Edit report",
  "reporting.generate": "Generate CSV",
  "reporting.submitting": "Submitting report…",
  "reporting.generating": "Preparing your CSV…",
  "reporting.download": "Download CSV",
  "reporting.loading": "Loading report options…",
  "reporting.currentReport": "Your current report",
  "reporting.previous": "Previous",
  "reporting.next": "Next",
  "reporting.rows": "{count, plural, one {# row} other {# rows}}",
  "reporting.state.QUEUED": "Queued",
  "reporting.state.GENERATING": "Generating",
  "reporting.state.READY": "Ready to download",
  "reporting.state.FAILED": "Failed",
  "reporting.state.EXPIRED": "Expired",
  "reporting.state.CANCELLED": "Cancelled",
  "reporting.loadError": "Could not load reporting information",
  "reporting.submitError": "Could not generate the report",
  "reporting.requestError": "The request could not be completed. Your choices have been retained; try again.",
  "reporting.networkError": "The server could not be reached. Your choices have been retained; try again.",
  "reporting.request.invalid": "Check your reporting period, filters and selected columns, then try again.",
  "reporting.request.conflict": "This submission identifier was already used for different report choices. Start a new report.",
  "reporting.columns.stale": "Some selected columns are no longer available. Remove them and choose from the current catalog.",
  "reporting.jobs.limit": "You have reached the active-report limit. Wait for a report to finish, then try again.",
  "reporting.access.denied": "Your current OpenELIS access does not permit this report.",
  "reporting.access.scopeChanged": "Your access to the selected lab sections has changed. Review the report with your current access.",
  "reporting.access.noSections": "No accessible lab sections are available for this report.",
  "reporting.access.signIn": "Sign in to OpenELIS to continue.",
  "reporting.definition.changed": "The report definition has changed. Review the current report options before running again.",
  "reporting.definition.unavailable": "This report type is no longer available.",
  "reporting.tests.stale": "Some selected tests are no longer available. Review your test selection.",
  "reporting.status.invalid": "Choose an available result status.",
  "reporting.filters.unsupported": "Some requested filters are unavailable for this report. Review the current report options.",
  "reporting.filters.unavailable": "Some previous filters are unavailable for this report. Review the current filters before generating.",
  "reporting.job.generationFailed": "The CSV could not be generated. Your report request has been retained.",
  "reporting.job.outputUnavailable": "The server cannot save export files. Ask your administrator to make the export folder writable, then retry this report.",
  "reporting.job.expired": "This file has expired. Run the report again with a new reporting period.",
  "reporting.job.notReady": "This report is not ready to download yet.",
  "reporting.job.notFound": "This report could not be found.",
  "reporting.saved.library": "Shared reports",
  "reporting.saved.search": "Search shared reports",
  "reporting.saved.loading": "Loading shared reports…",
  "reporting.saved.loadError": "Could not load shared reports",
  "reporting.saved.empty": "No shared reports have been saved yet.",
  "reporting.saved.shared": "Available to everyone who can use reports.",
  "reporting.saved.open": "Open",
  "reporting.saved.save": "Save report",
  "reporting.saved.update": "Update shared report",
  "reporting.saved.copy": "Save a copy",
  "reporting.saved.delete": "Delete shared report",
  "reporting.saved.name": "Report name",
  "reporting.saved.confirmSave": "Save shared report",
  "reporting.saved.confirmDelete": "Delete",
  "reporting.saved.confirmUpdate": "Update",
  "reporting.saved.cancel": "Cancel",
  "reporting.saved.copyName": "Copy of {name}",
  "reporting.saved.created": "Saved as {name}.",
  "reporting.saved.updated": "Updated {name}.",
  "reporting.saved.freshDates": "Choose fresh dates before running this report.",
  "reporting.saved.deleteHelp": "Delete {name} from the shared report library? Existing generated files are retained.",
  "reporting.saved.updateHelp": "Replace {name} with the choices currently shown in the builder?",
  "reporting.saved.changed": "Someone changed this shared report after you opened it. Your choices are still here; reopen the current saved report or save a copy.",
  "reporting.saved.invalid": "Review the report choices before saving.",
  "reporting.saved.nameInvalid": "Enter a report name of 200 characters or fewer.",
  "reporting.saved.notFound": "This shared report is no longer available.",
  "reporting.saved.pageInvalid": "The shared report list request was invalid.",
  "accept.action.button": "Accept",
  "accessDenied.message": "You do not have access to this module ,please contact your system administrator",
  "accessDenied.okButton": "OK",
  "accessDenied.title": "Access Denied",
  "accession.entry": "Accession Number Entry",
  "activityReportByPanel": "Activity report By Panel",
  "activityReportByTest": "Activity report By test",
  "activityReportByTestSection": "Activity report By Test Section",
  "add.age.range": "Add Another Age Range +",
  "add.aliquot": "Add Aliquot",
  "add.new.dictionary.menu": "Add New Dictionary Menu",
  "address.search.label": "Quick Address Search",
  "address.level.provinsi": "Province",
  "address.level.kabupaten": "Regency/City",
  "address.level.kecamatan": "District",
  "address.level.kelurahan": "Village",
  "adjustment.button": "Adjust Quantity",
  "adjustment.newQuantity": "New Quantity",
  "adjustment.notes": "Notes",
  "adjustment.notes.placeholder": "Provide details about this adjustment",
  "adjustment.reason": "Reason for Adjustment",
  "adjustment.reason.select": "Select reason",
  "adjustment.success": "Lot quantity adjusted successfully",
  "adjustment.title": "Adjust Lot Quantity",
  "admin.dashboard.subtitle": "Choose an administration area to configure OpenELIS.",
  "admin.dashboard.title": "Admin dashboard",
  "admin.formEntryConfig": "General Configurations",
  "admin.programs.title": "Programs",
  "admin.programs.subtitle": "The initiatives that orders are filed under — each with a domain, one or more lab units, and an optional order-entry questionnaire.",
  "admin.programs.add": "Add Program",
  "admin.programs.search": "Search by name",
  "admin.programs.selector.new": "New Program",
  "admin.programs.row.expand.aria": "Edit program",
  "admin.programs.row.actions.aria": "Program actions",
  "admin.programs.list.column.name": "Name",
  "admin.programs.list.column.domain": "Domain",
  "admin.programs.list.column.active": "Status",
  "admin.programs.list.column.units": "Lab unit(s)",
  "admin.programs.list.status.active": "Active",
  "admin.programs.list.status.inactive": "Inactive",
  "admin.programs.list.filter.domain.label": "Domain",
  "admin.programs.list.filter.domain.all": "All domains",
  "admin.programs.list.toggle.showDeactivated": "Show deactivated",
  "admin.programs.action.deactivate": "Deactivate",
  "admin.programs.action.reactivate": "Reactivate",
  "admin.programs.deactivate.modal.title": "Deactivate this Program?",
  "admin.programs.deactivate.modal.body.noOrders": "\"{programName}\" has no orders and will simply stop appearing for new orders. You can reactivate it at any time from the Programs list.",
  "admin.programs.deactivate.modal.confirm": "Deactivate",
  "admin.programs.deactivate.modal.cancel": "Cancel",
  "admin.programs.reactivate.success": "{programName} reactivated",
  "admin.programs.deactivate.success": "{programName} deactivated",
  "admin.programs.domain.confirm.heading": "Change Program Domain?",
  "admin.programs.domain.confirm.body": "Historical orders were evaluated against the {from} domain's rules. Changing to {to} is forward-looking: existing orders keep their program coding and are not re-coded, and the program will only be offered on {to} orders from now on.",
  "admin.programs.list.empty": "No programs match the current search and filters.",
  "admin.programs.basicInfo.labUnits.selectAll": "Select all",
  "admin.programs.basicInfo.labUnits.placeholder": "Type to filter lab units",
  "orderEntry.programPicker.empty": "No programs are currently active. An administrator can activate one under Admin › Programs.",
  "orderEntry.programPicker.empty.domain": "No {domain} programs are currently active. An administrator can activate one under Admin › Programs.",
  "admin.programs.basicInfo.programName.label": "Program Name",
  "admin.programs.basicInfo.programName.placeholder": "e.g. HBV Antenatal Screening",
  "admin.programs.basicInfo.code.label": "Programme Code",
  "admin.programs.basicInfo.code.placeholder": "e.g. HBV_ANC",
  "admin.programs.basicInfo.code.invalid": "Use letters, digits, spaces, or underscores only.",
  "admin.programs.basicInfo.programName.tooLong": "Use at most {max} characters.",
  "admin.programs.basicInfo.labUnits.label": "Lab unit(s)",
  "admin.programs.basicInfo.showOnMicroCase.off": "Off",
  "admin.programs.basicInfo.showOnMicroCase.on": "On",
  "admin.programs.basicInfo.showOnMicroCase.label": "Show on Microbiology case",
  "admin.programs.basicInfo.showOnMicroCase.helper": "Allow this Program on microbiology cases. New cases inherit it from the order; it does not change how work is routed.",
  "admin.programs.basicInfo.domain.label": "Domain",
  "admin.programs.basicInfo.domain.required": "Domain is required",
  "admin.programs.editor.status.label": "Status:",
  "admin.programs.guidance.domain.toggle.show": "What does each Domain mean?",
  "admin.programs.guidance.domain.toggle.hide": "Hide",
  "admin.programs.guidance.domain.clinical": "Patient testing — form captures patient identifiers, provider, prior history.",
  "admin.programs.guidance.domain.environmental": "Compliance/surveillance sampling (water, food, air). No patient fields.",
  "admin.programs.guidance.domain.vector": "Specimen surveillance (mosquito, tick) — species, pool manifest.",
  "admin.programs.guidance.gui.emptyState.body": "No questions yet — add questions one at a time, or paste a Questionnaire in JSON mode.",
  "admin.programs.guidance.gui.emptyState.action": "Add First Question",
  "admin.programs.guidance.json.referenceCard.format": "Format: FHIR R4 Questionnaire",
  "admin.programs.guidance.json.referenceCard.allowedTypes": "— allowed item.type: {allowed}.",
  "admin.programs.questionnaire.mode.visualBuilder": "Visual Builder",
  "admin.programs.questionnaire.mode.json": "JSON",
  "admin.programs.questionnaire.question.text.label": "Question Text",
  "admin.programs.questionnaire.question.type.label": "Question Type",
  "admin.programs.questionnaire.question.addNew": "Add New Question",
  "admin.programs.questionnaire.question.actions.aria": "Question actions",
  "admin.programs.questionnaire.question.actions.delete": "Delete question",
  "admin.programs.questionnaire.answerOptions.section.title": "Answer options",
  "admin.programs.questionnaire.answerOptions.addOption": "Add option",
  "admin.programs.questionnaire.answerOptions.deleteOption": "Delete option",
  "admin.programs.questionnaire.answerOptions.empty": "No options yet — add at least one so reception can pick a value.",
  "admin.programs.questionnaire.answerOptions.coded": "coded",
  "admin.programs.questionnaire.answerOptions.codedHelp": "Coded options come from a terminology and are shown read-only here. Edit them in JSON mode.",
  "admin.programs.questionnaire.preview.label": "Example",
  "admin.programs.questionnaire.preview.empty": "No questions yet — start adding questions to see the preview.",
  "admin.programs.questionnaire.preview.untitled": "(untitled)",
  "admin.programs.questionnaire.preview.boolean.example": "◯ Yes ◯ No",
  "admin.programs.questionnaire.preview.quantity.numberPlaceholder": "number",
  "admin.programs.questionnaire.preview.quantity.unit": "unit",
  "admin.programs.questionnaire.json.validate": "Validate JSON",
  "admin.programs.questionnaire.json.reformat": "Reformat",
  "admin.programs.questionnaire.json.validated": "Validated — {count} question(s)",
  "admin.programs.questionnaire.json.error.title": "Invalid Questionnaire",
  "admin.programs.questionnaire.json.error.resourceType": "resourceType must be \"Questionnaire\"",
  "admin.programs.questionnaire.json.error.itemArray": "item must be an array",
  "admin.programs.questionnaire.json.error.itemShape": "each item must have linkId, text, and type in [{allowed}]",
  "admin.programs.questionnaire.json.error.duplicateLinkId": "duplicate linkId \"{linkId}\" — each item must have a unique linkId",
  "admin.programs.guidance.json.referenceCard.advanced": "Advanced features (enableWhen, Quantity units via unit/unitOption, nested items) are edited here in JSON — the Visual Builder preserves them but does not surface them.",
  "admin.programs.basicInfo.domain.helper": "Controls where this program appears — reception only sees programs matching the order's domain.",
  "admin.programs.editor.status.noHardDelete": "No hard delete — deactivate preserves history.",
  "admin.programs.deactivate.modal.body": "\"{programName}\" will stop appearing in the order-entry Program picker for new orders. {orderCount, plural, one {Its # historical order keeps its program coding} other {Its # historical orders keep their program coding}} and all indicator counts are preserved. You can reactivate it at any time from the Programs list.",
  "admin.programs.deactivate.modal.body.unknownCount": "\"{programName}\" will stop appearing in the order-entry Program picker for new orders. Historical orders keep their program coding and all indicator counts are preserved. You can reactivate it at any time from the Programs list.",
  "admin.programs.questionnaire.question.unsupported": "This is a \"{type}\" item, which this builder does not edit. It is kept exactly as it is when you save. Edit it in JSON mode.",
  "admin.programs.questionnaire.question.type.boolean": "Yes / No",
  "admin.programs.questionnaire.question.type.choice": "Choice",
  "admin.programs.questionnaire.question.type.checkbox": "Checkbox",
  "admin.programs.questionnaire.question.type.integer": "Whole number",
  "admin.programs.questionnaire.question.type.decimal": "Decimal number",
  "admin.programs.questionnaire.question.type.date": "Date",
  "admin.programs.questionnaire.question.type.time": "Time",
  "admin.programs.questionnaire.question.type.string": "Short text",
  "admin.programs.questionnaire.question.type.text": "Long text",
  "admin.programs.questionnaire.question.type.quantity": "Quantity",
  "admin.programs.questionnaire.question.typeExample.boolean": "Yes/no answer. Example: \"First antenatal visit?\"",
  "admin.programs.questionnaire.question.typeExample.choice": "One option from a fixed list. Example: \"Specimen condition\".",
  "admin.programs.questionnaire.question.typeExample.checkbox": "Multiple options can be selected. Example: \"Symptoms present\".",
  "admin.programs.questionnaire.question.typeExample.integer": "Whole numbers only. Example: \"Gestational age (weeks)\".",
  "admin.programs.questionnaire.question.typeExample.decimal": "Numbers with decimals. Example: \"Maternal weight (kg)\".",
  "admin.programs.questionnaire.question.typeExample.date": "Calendar date. Example: \"Date of last menstrual period\".",
  "admin.programs.questionnaire.question.typeExample.time": "Time of day. Example: \"Time of sample collection\".",
  "admin.programs.questionnaire.question.typeExample.string": "Short free-text. Example: \"Provider name\".",
  "admin.programs.questionnaire.question.typeExample.text": "Long free-text. Example: \"Clinical notes\".",
  "admin.programs.questionnaire.question.typeExample.quantity": "A number plus a unit (e.g. \"Volume collected — 5 mL\"). The allowed unit(s) come from a FHIR extension set in JSON mode; a GUI-only Quantity accepts any unit.",
  "admin.config.logo.error.fileTooLarge": "Image is too large. Maximum size is 2MB.",
  "admin.config.logo.formats": "Formats: JPG, PNG, GIF (max 2MB)",
  "admin.label": "Admin",
  "admin.labUnit.basicInfo.domain.clinical": "Clinical",
  "admin.labUnit.basicInfo.domain.environmental": "Environmental",
  "admin.labUnit.basicInfo.domain.label": "Domain",
  "admin.labUnit.basicInfo.domain.vector": "Vector",
  "admin.labUnit.domain.confirm.body": "Historical orders/results were evaluated against the prior domain's rules. New orders will use the new domain's rules.",
  "admin.labUnit.domain.confirm.heading": "Change Lab Unit Domain?",
  "admin.labUnit.edit.select": "Select Lab Unit",
  "admin.labUnit.edit.title": "Edit Lab Unit Domain",
  "admin.labUnit.list.filter.domain": "Filter by Domain",
  "admin.legacy": "Legacy Admin",
  "button.back": "← Back to List",
  "button.labUnit.add": "Add Lab Unit",
  "button.labUnit.create": "Create Lab Unit",
  "button.labUnit.creating": "Creating...",
  "button.labUnit.tests.assign": "Assign tests",
  "button.labUnit.tests.assign.confirm": "Assign {count, plural, one {# test} other {# tests}}",
  "button.labUnit.tests.reassign": "Reassign selected ({count})",
  "button.labUnit.tests.reassign.confirm": "Reassign {count, plural, one {# test} other {# tests}}",
  "configuration.labUnit.manage": "Lab Unit Management",
  "error.labUnit.description.maxLength": "Description must be {max} characters or less",
  "error.labUnit.domain.required": "Domain is required",
  "error.labUnit.list.load": "Error loading lab units",
  "error.labUnit.name.duplicate": "This lab unit name already exists",
  "error.labUnit.name.maxLength": "Name must be {max} characters or less",
  "error.request.unreadable": "Nothing was saved: the server did not accept one of the values sent. Check the form and try again.",
  "error.labUnit.name.required": "Name is required",
  "heading.labUnit.add": "Add New Lab Unit",
  "heading.labUnit.editing": "Editing: {name}",
  "heading.labUnit.filtered": "Showing {filtered} of {total} lab units",
  "heading.labUnit.management": "Lab Unit Management",
  "heading.labUnit.subtitle": "Configure lab units (lab sections), domain classification, test assignments, and display order.",
  "heading.labUnit.total": "Total: {total} lab units",
  "helper.labUnit.description": "Short internal description of this lab unit for lab staff reference",
  "helper.labUnit.domain": "Determines which order entry and sample collection fields apply to orders routed to this lab unit.",
  "helper.labUnit.name": "Enter a unique name for this lab unit (e.g., \"Hematology\", \"Microbiology\")",
  "label.labUnit.actions": "Actions",
  "label.labUnit.active": "Active",
  "label.labUnit.description": "Description",
  "label.labUnit.displayOrder": "Position",
  "label.labUnit.displayOrder.addHint": "Save this lab unit first, then set its display order.",
  "label.labUnit.displayOrder.current": "Current",
  "label.labUnit.displayOrder.intro": "Position this lab unit in the system-wide lab unit menus and dropdowns. Enter a position and save — the remaining lab units are renumbered automatically.",
  "label.labUnit.displayOrder.loading": "Loading display order...",
  "label.labUnit.displayOrder.saved": "Display order saved",
  "label.labUnit.displayOrder.saveError": "Failed to save display order",
  "label.labUnit.domain": "Domain",
  "label.labUnit.filterStatus": "Filter by status",
  "label.labUnit.list.loading": "Loading lab units...",
  "label.labUnit.loading": "Loading lab unit...",
  "label.labUnit.notFound": "This lab unit does not exist. Go back to the list to choose another.",
  "label.labUnit.editorLoadError": "The lab units could not be loaded. Refresh the page to try again.",
  "label.labUnit.name": "Name",
  "label.labUnit.nameInLocale": "Name ({language})",
  "error.labUnit.tests.action": "Test assignment action failed",
  "error.labUnit.deactivate.failed": "The lab unit was not deactivated. Check the options and try again.",
  "error.labUnit.deactivate.destinationInactive": "The destination lab unit is inactive. Choose an active unit, or reactivate it first.",
  "heading.labUnit.tests.assign": "Assign Tests to This Lab Unit",
  "heading.labUnit.tests.reassign": "Reassign Tests",
  "label.labUnit.tests.assign.explain": "Tests belong to exactly one lab unit. Assigning a test here moves it out of its current lab unit (shown next to each test).",
  "label.labUnit.tests.assign.none": "No assignable tests found.",
  "label.labUnit.tests.reassign.destination": "Destination lab unit",
  "label.labUnit.tests.reassign.explain": "Reassignment takes effect immediately. New orders route to the destination lab unit; completed results keep their original data.",
  "label.labUnit.tests.reassign.inactiveDestination": "This lab unit is inactive: the moved tests cannot be ordered until it is reactivated. Completed results keep their original data.",
  "label.labUnit.inactiveOption": "{name} (inactive)",
  "label.labUnit.tests.reassign.moving": "{count, plural, one {# test} other {# tests}} will be moved:",
  "message.labUnit.tests.assigned": "Tests assigned to this lab unit.",
  "message.labUnit.tests.reassigned": "Tests reassigned successfully.",
  "placeholder.labUnit.tests.reassign.destination": "Select destination...",
  "placeholder.labUnit.tests.search": "Search tests...",
  "label.labUnit.section.assigned-tests": "Assigned Tests",
  "label.labUnit.section.basic-info": "Basic Info",
  "label.labUnit.section.display-order": "Display Order",
  "label.labUnit.status": "Status",
  "label.labUnit.testCount": "Tests",
  "label.labUnit.tests.addHint": "Save this lab unit first, then assign tests to it.",
  "label.labUnit.tests.count": "{count, plural, one {# test assigned} other {# tests assigned}}",
  "label.labUnit.tests.loadError": "Unable to load assigned tests",
  "label.labUnit.tests.loading": "Loading assigned tests...",
  "label.labUnit.tests.none": "No tests are assigned to this lab unit yet.",
  "label.labUnit.tests.testName": "Test Name",
  "message.labUnit.add.success": "Lab unit created successfully.",
  "message.labUnit.edit.success": "Lab unit saved successfully.",
  "message.labUnit.noResults": "No lab units found matching your criteria",
  "placeholder.labUnit.filter.domain": "All domains",
  "placeholder.labUnit.filter.status": "All statuses",
  "placeholder.labUnit.search": "Search lab units...",
  "sidenav.label.admin.labUnit.addingNew": "Adding new lab unit",
  "sidenav.label.admin.labUnit.backToList": "← All Lab Units",
  "sidenav.label.admin.labUnit.editing": "Editing: {name}",
  "sidenav.label.admin.labUnit.editingGeneric": "Editing lab unit",
  "sidenav.label.admin.labUnit.sectionsHelper": "Click a lab unit to edit its sections",
  "sidenav.label.admin.labUnitManagement": "Lab Units Editor",
  "warning.labUnit.deactivateInUse": "{count, plural, one {# active test is assigned to this lab unit. Deactivating hides it from ordering but keeps the assignment.} other {# active tests are assigned to this lab unit. Deactivating hides it from ordering but keeps the assignments.}}",
  "heading.labUnit.deactivate": "Deactivate lab unit",
  "button.labUnit.deactivate.confirm": "Deactivate lab unit",
  "label.labUnit.deactivate.loading": "Checking what this would affect…",
  "label.labUnit.deactivate.impact": "This lab unit currently holds:",
  "label.labUnit.deactivate.impact.tests": "{count} assigned tests ({active} active)",
  "label.labUnit.deactivate.impact.pending": "{count} pending analyses",
  "label.labUnit.deactivate.impact.historical": "{count} completed analyses (history is never removed)",
  "info.labUnit.deactivate.pending": "This lab unit stays on the worklists until its {count} pending analyses are completed.",
  "label.labUnit.deactivate.option": "What should happen to the assigned tests?",
  "label.labUnit.deactivate.option.keep": "Keep assignments — tests stay assigned, the unit stops taking new orders",
  "label.labUnit.deactivate.option.deactivateAll": "Deactivate all assigned tests as well",
  "label.labUnit.deactivate.option.reassign": "Reassign the tests to another lab unit first",
  "label.labUnit.deactivate.confirm": "Type DEACTIVATE to confirm",
  "admin.page.configuration.formEntryConfigMenu.button.add": "Add",
  "admin.page.configuration.formEntryConfigMenu.button.deactivate": "Deactivate",
  "admin.page.configuration.formEntryConfigMenu.button.exit": "Exit",
  "admin.page.configuration.formEntryConfigMenu.button.modify": "Modify",
  "admin.page.configuration.formEntryConfigMenu.button.save": "Save",
  "admin.page.configuration.formEntryConfigMenu.description": "Description",
  "admin.page.configuration.formEntryConfigMenu.editRecord": "Edit Record",
  "siteInformation.name.sampleAcceptCheck.clinical": "Sample acceptance checklist: Clinical",
  "siteInformation.name.sampleAcceptCheck.environmental": "Sample acceptance checklist: Environmental",
  "siteInformation.name.sampleAcceptCheck.vector": "Sample acceptance checklist: Vector",
  "siteInformation.name.freezer.monitoring.enabled": "Freezer monitoring",
  "siteInformation.name.freezer.modbus.tcp.port": "Freezer monitoring: Modbus TCP port",
  "siteInformation.name.freezer.modbus.timeout.ms": "Freezer monitoring: Modbus timeout (ms)",
  "siteInformation.name.freezer.bacnet.udp.port": "Freezer monitoring: BACnet UDP port",
  "siteInformation.name.pathology.identifier.partScheme": "Pathology: part designation",
  "siteInformation.description.pathology.identifier.partScheme": "How specimen parts are designated: ALPHA gives A, B, C; NUMERIC gives 1, 2, 3",
  "siteInformation.name.pathology.identifier.blockFormat": "Pathology: block designation pattern",
  "siteInformation.description.pathology.identifier.blockFormat": "Pattern for a block designation; '{part}' is the part, '{n}' the block number within it",
  "siteInformation.name.pathology.identifier.slideFormat": "Pathology: slide designation pattern",
  "siteInformation.description.pathology.identifier.slideFormat": "Pattern for a slide designation within its block; '{n}' is the slide number",
  "siteInformation.name.pathology.identifier.separator": "Pathology: barcode separator",
  "siteInformation.description.pathology.identifier.separator": "Separator between the accession number, block and slide designations in a barcode",
  "siteInformation.name.pathology.stage.DECALCIFICATION.enabled": "Pathology stage: Decalcification",
  "siteInformation.description.pathology.stage.DECALCIFICATION.enabled": "If true, cases pass through the Decalcification stage; if false, it cannot be chosen and is not applicable",
  "siteInformation.name.pathology.stage.PROCESSING.enabled": "Pathology stage: Processing",
  "siteInformation.description.pathology.stage.PROCESSING.enabled": "If true, cases pass through the Processing stage; if false, it cannot be chosen and is not applicable",
  "siteInformation.name.pathology.stage.EMBEDDING.enabled": "Pathology stage: Embedding",
  "siteInformation.description.pathology.stage.EMBEDDING.enabled": "If true, cases pass through the Embedding stage; if false, it cannot be chosen and is not applicable",
  "siteInformation.name.pathology.stage.MICROTOMY.enabled": "Pathology stage: Microtomy",
  "siteInformation.description.pathology.stage.MICROTOMY.enabled": "If true, cases pass through the Microtomy stage; if false, it cannot be chosen and is not applicable",
  "siteInformation.name.pathology.stage.STAINING.enabled": "Pathology stage: Staining",
  "siteInformation.description.pathology.stage.STAINING.enabled": "If true, cases pass through the Staining stage; if false, it cannot be chosen and is not applicable",
  "siteInformation.name.pathology.stage.COVERSLIPPING.enabled": "Pathology stage: Coverslipping & QC",
  "siteInformation.description.pathology.stage.COVERSLIPPING.enabled": "If true, cases pass through the Coverslipping & QC stage; if false, it cannot be chosen and is not applicable",
  "siteInformation.name.pathology.stage.UNDER_REVIEW.enabled": "Pathology stage: Under Pathologist Review",
  "siteInformation.description.pathology.stage.UNDER_REVIEW.enabled": "If true, cases pass through the Under Pathologist Review stage; if false, it cannot be chosen and is not applicable",
  "admin.page.configuration.formEntryConfigMenu.name": "Name",
  "admin.page.configuration.formEntryConfigMenu.select": "Select",
  "admin.page.configuration.formEntryConfigMenu.value": "Value",
  "admin.page.configuration.search": "Search settings",
  "admin.labelPresets.title": "Label Presets",
  "admin.labelPresets.addButton": "Add Preset",
  "admin.labelPresets.search.placeholder": "Search presets...",
  "admin.labelPresets.col.name": "Name",
  "admin.labelPresets.col.barcodeType": "Barcode Type",
  "admin.labelPresets.col.dimensions": "Dimensions",
  "admin.labelPresets.col.scope": "Scope",
  "admin.labelPresets.col.status": "Status",
  "admin.labelPresets.col.actions": "Actions",
  "admin.labelPresets.systemTag": "System",
  "admin.labelPresets.status.active": "Active",
  "admin.labelPresets.status.inactive": "Inactive",
  "admin.labelPresets.scope.order": "Order",
  "admin.labelPresets.scope.sample": "Sample",
  "admin.labelPresets.action.edit": "Edit",
  "admin.labelPresets.action.duplicate": "Duplicate",
  "admin.labelPresets.action.activate": "Activate",
  "admin.labelPresets.action.deactivate": "Deactivate",
  "admin.labelPresets.duplicateName": "Copy of {name}",
  "admin.labelPresets.duplicated": "Preset duplicated",
  "admin.labelPresets.duplicateFailed": "Duplicate failed",
  "admin.labelPresets.activated": "Preset activated",
  "admin.labelPresets.deactivated": "Preset deactivated",
  "admin.labelPresets.toggleFailed": "Status change failed",
  "admin.labelPresets.saveFailed": "Save failed",
  "admin.labelPresets.saveFailed.detail": "The server answered {status}: {message}",
  "admin.labelPresets.saveFailed.noResponse": "No response from the server. Check the connection and try again.",
  "error.labelpreset.fields.unique": "Each content field and each display position may be used only once per preset.",
  "error.labelpreset.field.required": "Every content field entry must name a field.",
  "admin.labelPresets.created": "Preset created",
  "admin.labelPresets.updated": "Preset updated",
  "admin.labelPresets.editor.titleAdd": "Add Label Preset",
  "admin.labelPresets.editor.titleEdit": "Edit Label Preset",
  "admin.labelPresets.editor.section.basicInfo": "Basic Info",
  "admin.labelPresets.editor.section.dimensions": "Dimensions (mm)",
  "admin.labelPresets.editor.section.barcodeSettings": "Barcode Settings",
  "admin.labelPresets.editor.section.printScope": "Print Scope & Quantities",
  "admin.labelPresets.field.name": "Preset Name",
  "admin.labelPresets.field.isActive": "Active",
  "admin.labelPresets.field.heightMm": "Height (mm)",
  "admin.labelPresets.field.widthMm": "Width (mm)",
  "admin.labelPresets.field.barcodeType": "Barcode Type",
  "admin.labelPresets.field.defaultPerOrder": "Default per Order",
  "admin.labelPresets.field.maxPerOrder": "Max per Order",
  "admin.labelPresets.field.defaultPerSample": "Default per Sample",
  "admin.labelPresets.field.maxPerSample": "Max per Sample",
  "admin.labelPresets.validation.name.required": "Name is required",
  "admin.labelPresets.validation.name.toolong": "Name must not exceed 120 characters",
  "admin.labelPresets.validation.dimension.range": "Dimension must be between 5 and 200 mm",
  "admin.labelPresets.validation.barcodeType.required": "Barcode type is required",
  "admin.labelPresets.validation.scope.required": "At least one print scope (Order or Sample) must be selected",
  "admin.labelPresets.validation.max.lte": "Max must be greater than or equal to default",
  "admin.labelPresets.editor.section.fields": "Content fields",
  "admin.labelPresets.fields.helper": "The fields printed above the barcode, in this order. Lab Number is always first.",
  "admin.labelPresets.fields.locked": "Always first",
  "admin.labelPresets.fields.required": "Required",
  "admin.labelPresets.fields.required.aria": "Required: {field}",
  "admin.labelPresets.fields.moveUp": "Move {field} up",
  "admin.labelPresets.fields.moveDown": "Move {field} down",
  "admin.labelPresets.fields.remove": "Remove {field}",
  "admin.labelPresets.fields.add.label": "Add a field",
  "admin.labelPresets.fields.add.placeholder": "Choose a field",
  "admin.labelPresets.fields.add.button": "Add",
  "admin.labelPresets.fields.allAdded": "Every available field is on this label.",
  "admin.labelPresets.fields.fitHint": "The {count, plural, one {selected field} other {# selected fields}} may not fit a {height} mm label; about {rows, plural, one {# row fits} other {# rows fit}} above the barcode. You can still save.",
  "admin.labelPresets.fields.position": "Position {position}",
  "admin.labelPresets.fieldKey.LAB_NUMBER": "Lab Number",
  "admin.labelPresets.fieldKey.PATIENT_NAME": "Patient Name",
  "admin.labelPresets.fieldKey.PATIENT_ID": "Patient ID",
  "admin.labelPresets.fieldKey.PATIENT_DOB": "Patient Date of Birth",
  "admin.labelPresets.fieldKey.PATIENT_SEX": "Patient Sex",
  "admin.labelPresets.fieldKey.SITE_ID": "Site ID",
  "admin.labelPresets.fieldKey.COLLECTION_DATETIME": "Collection Date and Time",
  "admin.labelPresets.fieldKey.COLLECTED_BY": "Collected By",
  "admin.labelPresets.fieldKey.TESTS": "Tests",
  "admin.labelPresets.fieldKey.SPECIMEN_TYPE": "Specimen Type",
  "admin.labelPresets.fieldKey.BLOCK_ID": "Block ID",
  "admin.labelPresets.fieldKey.SLIDE_ID": "Slide ID",
  "admin.labelPresets.fieldKey.STAIN_TYPE": "Stain Type",
  "admin.labelPresets.fieldKey.CASE_NUMBER": "Case Number",
  "admin.labelPresets.fieldKey.STORAGE_LOCATION": "Storage Location",
  "admin.labelPresets.fieldKey.EXPIRY_DATE": "Expiry Date",
  "error.labelpreset.field.key.unknown": "Unknown content field.",
  "admin.labelPresets.siteWide.title": "Site-wide Barcode Settings",
  "admin.labelPresets.siteWide.scope": "Applies laboratory-wide",
  "admin.labelPresets.siteWide.prePrint.legend": "Pre-printed label numbers come from",
  "admin.labelPresets.siteWide.prePrint.orderEntry": "The same format and number pool as order entry",
  "admin.labelPresets.siteWide.prePrint.separate": "A separate pre-printed series",
  "admin.labelPresets.siteWide.prefix.label": "Prefix",
  "admin.labelPresets.siteWide.prefix.helper": "Exactly 4 letters or digits. Pre-printed numbers start with this prefix, then the year and a sequence number.",
  "admin.labelPresets.siteWide.prefix.invalid": "The prefix must be exactly 4 letters or digits",
  "admin.labelPresets.siteWide.save": "Save settings",
  "admin.labelPresets.siteWide.saved": "Site-wide barcode settings saved",
  "admin.labelPresets.siteWide.saveFailed": "Site-wide barcode settings were not saved",
  "admin.labelPresets.siteWide.loadFailed": "The site-wide barcode settings could not be loaded. Reload the page to try again.",
  "error.sitesettings.barcode.prefix.format": "The pre-printed prefix must be exactly 4 letters or digits when a separate series is used",
  "advanced.search": "Advanced Search",
  "alert.expired.title": "Expired Items",
  "alert.expiring.title": "Expiring Soon",
  "alert.lowStock.title": "Low Stock Alert",
  "alerts.acknowledge.button": "Acknowledge",
  "alerts.acknowledge.comment": "Resolution Comment",
  "alerts.acknowledge.comment.placeholder": "Describe how this alert was addressed...",
  "alerts.acknowledge.comment.required": "Resolution comment is required for critical alerts",
  "alerts.acknowledge.error": "Failed to acknowledge alert",
  "alerts.acknowledge.success": "Alert acknowledged successfully",
  "alerts.acknowledge.title": "Acknowledge Alert",
  "alerts.autoRefresh": "Auto-refresh every 60 seconds",
  "alerts.dashboard.title": "Alerts Dashboard",
  "alerts.empty": "No alerts to display",
  "alerts.eqaDeadlineSummary.critical": "Critical",
  "alerts.eqaDeadlineSummary.deadlineCount": "{count} upcoming deadlines",
  "alerts.eqaDeadlineSummary.subtitle": "Upcoming EQA submission deadlines grouped by provider",
  "alerts.eqaDeadlineSummary.title": "EQA Deadline Summary",
  "alerts.eqaDeadlineSummary.viewAll": "View All",
  "alerts.filter.myAlerts": "My Alerts",
  "alerts.filter.search": "Search alerts...",
  "alerts.filter.severity": "Severity",
  "alerts.filter.status": "Status",
  "alerts.filter.type": "Alert Type",
  "alerts.filter.type.search": "Type to search alert types",
  "alerts.severity.critical": "Critical",
  "alerts.severity.warning": "Warning",
  "alerts.status.acknowledged": "Acknowledged",
  "alerts.status.open": "Open",
  "alerts.status.resolved": "Resolved",
  "alerts.summary.critical": "Critical Alerts",
  "alerts.summary.eqaDeadlines": "EQA Deadlines",
  "alerts.summary.sampleExpiration": "Samples Expiring",
  "alerts.summary.statOverdue": "Overdue STAT Orders",
  "alerts.summary.totalOpen": "Total Open",
  "alerts.table.actions": "Actions",
  "alerts.table.created": "Created",
  "alerts.table.message": "Message",
  "alerts.table.severity": "Severity",
  "alerts.table.status": "Status",
  "alerts.table.type": "Type",
  "alerts.type.critical_result": "Critical Result",
  "alerts.type.equipment_failure": "Equipment Failure",
  "alerts.type.freezer_humidity": "Freezer Humidity",
  "alerts.type.freezer_offline": "Freezer Offline",
  "alerts.type.freezer_temperature": "Freezer Temperature",
  "alerts.type.inventory_low": "Low stock",
  "alerts.type.other": "Other",
  "alerts.type.referral_critical_result": "Referral Critical Result",
  "alerts.type.referral_rejected": "Referral Rejected",
  "alerts.type.sample_tracking": "Sample Tracking",
  "alerts.type.critical_unacknowledged": "Unacknowledged Critical",
  "alerts.type.eqa_deadline": "EQA Deadline",
  "alerts.type.eqa_submission_failed": "EQA Submission Failed",
  "alerts.type.microbiology_critical": "Microbiology Critical",
  "alerts.type.required_by_deadline": "Required By Deadline",
  "alerts.type.sample_expiration": "Sample Expiration",
  "alerts.type.stat_overdue": "STAT Overdue",
  "alerts.type.stat_upcoming": "STAT Upcoming",
  "aliquot": "Aliquot",
  "aliquot.analyses.count": "Analyses: {count}",
  "aliquot.id": "Aliquot ID",
  "aliquot.quantity": "Aliquot Quantity",
  "aliquot.quantity.not.balanced": "Quantity not balanced for sample type",
  "aliquot.save.error": "Error saving aliquoting data.",
  "aliquot.save.success": "Aliquoting data saved successfully.",
  "aliquot.tests.not.assigned": "Tests not assigned for sample type",
  "aliquot.validation.errors": "Validation Errors",
  "aliquoting": "Aliquoting",
  "aliquoting.section": "Aliquoting Section",
  "all.label": "All",
  "all.tests.assigned": "All tests assigned",
  "allocated.to.aliquots": "Allocated to Aliquots",
  "analysis.count": "Analysis Count",
  "analysis.details": "Analysis Details",
  "analyzer.adoption.error.heldResults": "{record} still has held results from revision {revision}. Resolve them before adopting.",
  "analyzer.adoption.error.inactiveTest": "{record} is mapped to a test that is no longer active. Choose another test before adopting.",
  "analyzer.adoption.error.missingAnswers": "{record} needs a decision for each of its answers. Missing: {answers}.",
  "analyzer.adoption.error.missingDecisions": "Every record the newer revision keeps needs a decision. Missing: {records}.",
  "analyzer.adoption.error.notNewer": "Adoption moves an analyzer to a revision newer than revision {revision}.",
  "analyzer.adoption.error.revisionInactive": "Revision {revision} of this analyzer type is not active.",
  "analyzer.bridge.connection.httpStatus": "The Analyzer Bridge refused the request.",
  "analyzer.bridge.connection.invalidEvidence": "The Analyzer Bridge answered for a different analyzer or analyzer type.",
  "analyzer.bridge.connection.invalidRequest": "The request to the Analyzer Bridge was incomplete.",
  "analyzer.bridge.connection.notConfigured": "No Analyzer Bridge is configured for this server.",
  "analyzer.bridge.connection.reconcileRequired": "OpenELIS kept the analyzer's previous mapping, but the Analyzer Bridge may still be on the new one. Apply the mapping again when the Bridge is reachable to bring them back in step.",
  "analyzer.bridge.connection.referenceNotStored": "The Analyzer Bridge connection could not be saved with this analyzer.",
  "analyzer.bridge.connection.unreachable": "The Analyzer Bridge could not be reached.",
  "analyzer.mapping.error.catalogNotCurrent": "A mapped test or answer is no longer active in the test catalog. Choose another before confirming.",
  "analyzer.mapping.error.changedSinceLoaded": "This analyzer's mapping changed after this page was loaded. Reload the page to see the current mapping.",
  "analyzer.mapping.error.componentRequired": "{record} lands on a component of its test. Choose that component, or leave the record unresolved.",
  "analyzer.mapping.error.confirmBeforeApply": "Confirm the analyzer's current mapping before applying it.",
  "analyzer.mapping.error.resultNotCurrent": "A mapped answer is no longer active for its test. Choose another answer.",
  "analyzer.mapping.error.testNotCurrent": "A mapped test is no longer active in the test catalog. Choose another test.",
  "analyzer.setup.assays.continue": "Continue to Verify",
  "analyzer.setup.assays.count": "{on} of {total} assays on",
  "analyzer.setup.assays.help": "Turn on the assays this instrument runs, as in its own host test code settings. Verify maps only the assays that are on. A result for an assay that is off is held, never lost.",
  "analyzer.setup.assays.loadError": "The analyzer's assays could not be loaded.",
  "analyzer.setup.assays.loading": "Loading assays",
  "analyzer.setup.assays.match.ambiguous": "Several tests in this lab's catalog match",
  "analyzer.setup.assays.match.bound": "Matches {name}",
  "analyzer.setup.assays.match.excluded": "Set not to be received",
  "analyzer.setup.assays.match.incompatible": "A test matches but cannot hold these results",
  "analyzer.setup.assays.match.noMatch": "No test in this lab's catalog",
  "analyzer.setup.assays.none": "This analyzer type declares no assays, so there is nothing to map. Results it sends are held as unknown tests and can be mapped from the held result.",
  "analyzer.setup.assays.saveError": "The assays could not be saved.",
  "analyzer.setup.assays.title": "Assays",
  "analyzer.setup.error.adoptToMove": "To move this analyzer to revision {revision}, adopt it from the analyzer type page.",
  "analyzer.setup.error.profileKept": "A configured analyzer keeps its analyzer type.",
  "analyzer.reset.error.profileAvailable": "This analyzer's type is still available. Adopt a newer revision to move it.",
  "analyzer.setup.connect.reset": "Reset analyzer type",
  "analyzer.setup.connect.reset.failed": "The analyzer type could not be reset. Try again.",
  "analyzer.action.activate": "Activate",
  "analyzer.action.add": "Add Analyzer",
  "analyzer.action.configureConnection": "Configure connection",
  "analyzer.action.deactivate": "Deactivate",
  "analyzer.action.editSetup": "Edit setup",
  "analyzer.action.qualityControl": "Quality Control",
  "analyzer.action.reactivate": "Reactivate",
  "analyzer.action.restore": "Restore",
  "analyzer.action.retire": "Retire",
  "analyzer.bridgePairing.automatic": "OpenELIS pairs with the code it is configured with on its own. You can also enter the code here.",
  "analyzer.bridgePairing.cancel": "Cancel",
  "analyzer.bridgePairing.code.label": "Pairing code",
  "analyzer.bridgePairing.error.certificateMismatch": "The Bridge answered for a different certificate than the one it presented, so OpenELIS did not pair with it.",
  "analyzer.bridgePairing.error.closed": "The Bridge is not accepting a pairing. Configure a new pairing code on the Bridge, restart it, and pair again.",
  "analyzer.bridgePairing.error.codeRequired": "Enter the pairing code.",
  "analyzer.bridgePairing.error.identity": "OpenELIS could not create or read its key for the Bridge.",
  "analyzer.bridgePairing.error.invalidAnswer": "The Bridge's answer could not be read.",
  "analyzer.bridgePairing.error.notConfigured": "No Analyzer Bridge address is configured for OpenELIS.",
  "analyzer.bridgePairing.error.refused": "The Bridge refused the pairing.",
  "analyzer.bridgePairing.error.unreachable": "OpenELIS could not reach the Analyzer Bridge.",
  "analyzer.bridgePairing.error.wrongCode": "The Bridge did not accept that code.",
  "analyzer.bridgePairing.keyUnreadable.subtitle": "OpenELIS cannot read the key it stored for the Bridge, because it was saved under another encryption key. Set a new pairing code on the Bridge, restart it, and enter the code here to pair with a new key.",
  "analyzer.bridgePairing.pair": "Pair",
  "analyzer.bridgePairing.pairAgain": "Pair again",
  "analyzer.bridgePairing.paired.detail": "{url} · Bridge certificate {fingerprint} · paired {pairedAt}",
  "analyzer.bridgePairing.paired.title": "Paired with the Analyzer Bridge",
  "analyzer.bridgePairing.stale.bridgeUnpaired.subtitle": "The Bridge at {url} presents the paired certificate {fingerprint} but no longer holds a pairing, so it refuses OpenELIS's calls and holds results.",
  "analyzer.bridgePairing.stale.bridgeUnpaired.title": "The Analyzer Bridge lost its pairing",
  "analyzer.bridgePairing.stale.otherCertificate.subtitle": "The Bridge at {url} presents a certificate other than the paired one ({fingerprint}). OpenELIS refuses its results until it pairs again.",
  "analyzer.bridgePairing.stale.otherCertificate.title": "Paired with a different Bridge certificate",
  "analyzer.bridgePairing.unpaired.subtitle": "Enter the pairing code the Bridge shows in its log, or the one it was configured with. Results wait in the Bridge until it is paired.",
  "analyzer.bridgePairing.unpaired.title": "The Analyzer Bridge is not paired",
  "analyzer.combinationName.notification": "The combination of analyzer and analyzer test name must be unique",
  "analyzer.fhirImport.error.importFailed": "FHIR bundle import failed",
  "analyzer.fhirImport.error.invalidBundleType": "Bundle type must be 'transaction' or 'batch', got: {bundleType}",
  "analyzer.fhirImport.error.noObservations": "Bundle contains no Observation resources with results",
  "analyzer.deliveryIssues.attention.review": "Review undelivered results",
  "analyzer.deliveryIssues.attention.subtitle": "The Analyzer Bridge is holding results it could not deliver to OpenELIS.",
  "analyzer.deliveryIssues.attention.title": "{count, plural, one {# analyzer result was} other {# analyzer results were}} not delivered",
  "analyzer.deliveryIssues.column.actions": "Actions",
  "analyzer.deliveryIssues.column.analyzer": "Analyzer",
  "analyzer.deliveryIssues.column.detail": "Details",
  "analyzer.deliveryIssues.column.reason": "Reason",
  "analyzer.deliveryIssues.column.received": "Received",
  "analyzer.deliveryIssues.column.sender": "Sender",
  "analyzer.deliveryIssues.column.status": "Status",
  "analyzer.deliveryIssues.description": "Results the Analyzer Bridge received but has not delivered to OpenELIS. Retry sends a result again once its cause is fixed; Dismiss hides it and keeps it in the Bridge for audit.",
  "analyzer.deliveryIssues.dismiss": "Dismiss",
  "analyzer.deliveryIssues.empty": "The Bridge has no undelivered results.",
  "analyzer.deliveryIssues.error.actionFailed": "The action could not be completed. Reload and try again.",
  "analyzer.deliveryIssues.error.bridgeInvalidResponse": "The Analyzer Bridge sent a response OpenELIS could not read.",
  "analyzer.deliveryIssues.error.incompleteList": "The Analyzer Bridge has more undelivered results than this view can load. Review the Bridge outbox directly.",
  "analyzer.deliveryIssues.error.bridgeNotConfigured": "OpenELIS has no Analyzer Bridge address configured.",
  "analyzer.deliveryIssues.error.bridgeNotPaired": "The Analyzer Bridge is not paired with OpenELIS. Pair it on the Analyzers page.",
  "analyzer.deliveryIssues.error.bridgeRefused": "The Bridge refused this action ({reason}). Reload to see its current state.",
  "analyzer.deliveryIssues.error.bridgeUnreachable": "The Analyzer Bridge could not be reached.",
  "analyzer.deliveryIssues.error.invalidId": "This result reference is not valid.",
  "analyzer.deliveryIssues.loadFailed": "Undelivered results could not be loaded from the Analyzer Bridge.",
  "analyzer.deliveryIssues.notPaired.subtitle": "Results it holds are listed here once it is paired on the Analyzers page.",
  "analyzer.deliveryIssues.loading": "Checking the Analyzer Bridge for undelivered results",
  "analyzer.deliveryIssues.reason.AMBIGUOUS_SOURCE": "More than one analyzer connection could own this message. Give each analyzer a distinct address, then retry.",
  "analyzer.deliveryIssues.reason.CONNECTION_TRANSPORT_MISMATCH": "The analyzer sent over a connection type its setup does not accept.",
  "analyzer.deliveryIssues.reason.OE_CONFIG_STATE": "OpenELIS declined the result because of its own setup. Fix the analyzer setup, then retry.",
  "analyzer.deliveryIssues.reason.OE_REJECTED": "OpenELIS rejected the result.",
  "analyzer.deliveryIssues.reason.OE_UNEXPECTED_REDIRECT": "OpenELIS answered with a redirect, so the result was not delivered. Check the Bridge's OpenELIS address.",
  "analyzer.deliveryIssues.reason.PARSE_NO_RESULTS": "The message contained no results to deliver.",
  "analyzer.deliveryIssues.reason.RENDER_ERROR": "The Bridge could not convert the message for OpenELIS.",
  "analyzer.deliveryIssues.reason.RETRY_EXHAUSTED": "OpenELIS stayed unreachable until every retry was used. The result is intact; retry once OpenELIS is reachable.",
  "analyzer.deliveryIssues.reason.UNPINNED_PROFILE": "The analyzer's connection has no analyzer type revision, so its results cannot be read.",
  "analyzer.deliveryIssues.reason.UNREGISTERED_SOURCE": "The sender matches no saved analyzer connection. Set up the analyzer, then retry.",
  "analyzer.deliveryIssues.reason.none": "OpenELIS has not accepted the result yet; the Bridge keeps retrying.",
  "analyzer.deliveryIssues.reason.unknown": "The Bridge could not deliver this result ({code}).",
  "analyzer.deliveryIssues.retry": "Retry",
  "analyzer.deliveryIssues.state.deadLettered": "Not delivered",
  "analyzer.deliveryIssues.state.retrying": "Retrying",
  "analyzer.deliveryIssues.title": "Undelivered analyzer results",
  "analyzer.deliveryIssues.unrecognizedSender": "Unrecognized sender {source}",
  "analyzer.importIssues.accession": "Accession number",
  "analyzer.importIssues.action": "Action",
  "analyzer.importIssues.description": "Review microbiology analyzer events that could not be matched or processed. Held results are reviewed in each analyzer's results worklist.",
  "analyzer.importIssues.empty": "No failed microbiology analyzer events require attention",
  "analyzer.importIssues.event": "Event",
  "analyzer.importIssues.event.astQcFail": "AST quality control failure",
  "analyzer.importIssues.event.astResultAvailable": "AST result available",
  "analyzer.importIssues.event.unknown": "Analyzer event ({code})",
  "analyzer.importIssues.events.description": "Correct the analyzer mapping or target information before the source sends the result again.",
  "analyzer.importIssues.events.title": "Stuck analyzer events",
  "analyzer.importIssues.failure.astRunNotMatched": "No AST run matched the analyzer and card identifiers.",
  "analyzer.importIssues.failure.processingFailed": "The analyzer event could not be processed.",
  "analyzer.importIssues.failure.unknown": "The analyzer event could not be processed ({code}).",
  "analyzer.importIssues.loadFailed": "Analyzer import issues could not be loaded",
  "analyzer.importIssues.loading": "Loading analyzer import issues",
  "analyzer.importIssues.openMappings": "Open mappings",
  "analyzer.importIssues.openResults": "Open analyzer results",
  "analyzer.importIssues.reason": "Failure reason",
  "analyzer.importIssues.received": "Received",
  "analyzer.importIssues.result": "Result",
  "analyzer.importIssues.source": "Source ID",
  "analyzer.importIssues.staging.description": "These imported result rows need corrected analyzer configuration before validation.",
  "analyzer.importIssues.staging.title": "Staged result issues",
  "analyzer.importIssues.target": "Target reference",
  "analyzer.importIssues.test": "Test",
  "analyzer.importIssues.title": "Analyzer import issues",
  "analyzer.fieldCreation.acceptedUnits.label": "Accepted Units",
  "analyzer.fieldCreation.acceptedUnits.placeholder": "Select accepted units",
  "analyzer.fieldCreation.cancel": "Cancel",
  "analyzer.fieldCreation.confirmation": "I understand this field will be available for mapping immediately after creation",
  "analyzer.fieldCreation.create": "Create Field",
  "analyzer.fieldCreation.createNew": "Create New Field",
  "analyzer.fieldCreation.description.label": "Description (Optional)",
  "analyzer.fieldCreation.description.placeholder": "Enter field description",
  "analyzer.fieldCreation.entityType.label": "Entity Type",
  "analyzer.fieldCreation.entityType.placeholder": "Select entity type",
  "analyzer.fieldCreation.error.generic": "Failed to create field",
  "analyzer.fieldCreation.error.title": "Error creating field",
  "analyzer.fieldCreation.fieldName.label": "Field Name",
  "analyzer.fieldCreation.fieldName.placeholder": "Enter field name",
  "analyzer.fieldCreation.fieldType.label": "Field Type",
  "analyzer.fieldCreation.fieldType.placeholder": "Select field type",
  "analyzer.fieldCreation.loincCode.label": "LOINC Code (Optional)",
  "analyzer.fieldCreation.loincCode.placeholder": "Enter LOINC code",
  "analyzer.fieldCreation.modal.subtitle": "Create a new field that will be available for mapping immediately",
  "analyzer.fieldCreation.modal.title": "Create New OpenELIS Field",
  "analyzer.fieldCreation.success.message": "Field is now available for mapping",
  "analyzer.fieldCreation.success.title": "Field created successfully",
  "analyzer.fieldCreation.validation.entityType.required": "Entity type is required",
  "analyzer.fieldCreation.validation.fieldName.required": "Field name is required",
  "analyzer.fieldCreation.validation.unique": "A field with this name already exists",
  "analyzer.fieldCreation.validation.units.required": "Accepted units are required for numeric fields",
  "analyzer.filter.lifecycleStage.all": "All Lifecycle Stages",
  "analyzer.filter.lifecycleStage.label": "Lifecycle Stage",
  "analyzer.filter.showRetired": "Show retired analyzers",
  "analyzer.filter.status": "Status",
  "analyzer.filter.status.all": "All Statuses",
  "analyzer.filter.status.label": "Status",
  "analyzer.filter.testUnit": "Test Unit",
  "analyzer.filter.type": "Analyzer Type",
  "analyzer.form.activeStatus": "Active Status",
  "analyzer.form.activeStatus.description": "Enable this analyzer for data collection",
  "analyzer.form.addTitle": "Add New Analyzer",
  "analyzer.form.cancel": "Cancel",
  "analyzer.form.communicationMode": "Communication Mode",
  "analyzer.form.communicationMode.analyzerInitiated": "Analyzer → LIS (analyzer connects to OpenELIS)",
  "analyzer.form.communicationMode.both": "Bidirectional (both directions)",
  "analyzer.form.communicationMode.help": "Who initiates the connection. Most analyzers use Analyzer → LIS.",
  "analyzer.form.communicationMode.lisInitiated": "LIS → Analyzer (OpenELIS connects to analyzer)",
  "analyzer.form.createdBy": "Created By",
  "analyzer.form.createdDate": "Created Date/Time",
  "analyzer.form.defaults.error": "Failed to load default configuration",
  "analyzer.form.defaults.loaded": "Default configuration loaded",
  "analyzer.form.defaults.loaded.subtitle": "Template for {name} has been loaded. Customize as needed before saving.",
  "analyzer.form.editTitle": "Edit Analyzer",
  "analyzer.form.error.invalidCommunicationMode": "Invalid communication mode: {value}. Valid values: {validValues}",
  "analyzer.form.error.invalidProtocolVersion": "Invalid protocol version: {value}. Valid values: {validValues}",
  "analyzer.form.error.save": "Failed to save analyzer",
  "analyzer.form.error.unknown": "An unknown error occurred",
  "analyzer.form.fileProtocol.description": "This analyzer imports results from files. File import settings will be configured after saving.",
  "analyzer.form.fileProtocol.title": "File Import Protocol",
  "analyzer.form.identifierPattern": "Identifier Pattern",
  "analyzer.form.identifierPattern.helperText": "Regex pattern to match incoming message identifiers for routing",
  "analyzer.form.identifierPattern.placeholder": "e.g., ^ABX\\^PENTRA.*",
  "analyzer.form.ipAddress": "IP Address",
  "analyzer.form.ipAddress.placeholder": "192.168.1.10",
  "analyzer.form.lastModified": "Last Modified Date/Time",
  "analyzer.form.loadDefaultConfig": "Load Analyzer Profile",
  "analyzer.form.loadDefaultConfig.helperText": "Quick setup using built-in analyzer profile templates",
  "analyzer.form.loadDefaultConfig.placeholder": "Select a built-in analyzer profile",
  "analyzer.form.name": "Analyzer Name",
  "analyzer.form.name.placeholder": "e.g., Hematology Analyzer 1",
  "analyzer.form.pluginType": "Plugin Type",
  "analyzer.form.pluginType.helperText": "The analyzer plugin that will handle incoming messages",
  "analyzer.form.pluginType.placeholder": "Select plugin type...",
  "analyzer.form.port": "Port Number",
  "analyzer.form.port.placeholder": "5000",
  "analyzer.form.protocolVersion": "Protocol Version",
  "analyzer.form.save": "Save",
  "analyzer.form.status": "Status",
  "analyzer.form.status.helperText": "Status transitions automatically based on analyzer state. Manual override to INACTIVE, SETUP, or VALIDATION only.",
  "analyzer.form.subtitle": "Configure analyzer connection settings and test units",
  "analyzer.form.success.save": "Analyzer saved successfully",
  "analyzer.form.testConnection": "Test Connection",
  "analyzer.form.testConnection.error": "Connection Failed",
  "analyzer.form.testUnits": "Test Unit Assignment",
  "analyzer.form.testUnits.helper": "Select one or more test units for this analyzer",
  "analyzer.form.testUnits.placeholder": "Select test units...",
  "analyzer.form.type": "Analyzer Type",
  "analyzer.form.type.helperText": "Select the reusable Analyzer Type for this installed connection.",
  "analyzer.form.type.invalidSelection": "That Analyzer Type revision is unavailable or deactivated",
  "analyzer.form.type.loadError": "Analyzer Types could not be loaded",
  "analyzer.form.type.other": "Other",
  "analyzer.form.type.placeholder": "Select analyzer type",
  "analyzer.form.type.revision": "{name}, revision {revision} ({protocol})",
  "analyzer.form.validation.ipAddress.invalid": "Invalid IP address format",
  "analyzer.form.validation.name.required": "Analyzer name is required",
  "analyzer.form.validation.type.required": "Analyzer type is required",
  "analyzer.hl7.insertError": "HL7 insert error",
  "analyzer.hl7.parseError": "HL7 parse error",
  "analyzer.hl7.unknownAnalyzer": "Unable to identify analyzer from HL7 MSH (sending application/facility)",
  "analyzer.list.subtitle": "Manage laboratory analyzers and field mappings",
  "analyzer.list.title": "Analyzers",
  "analyzer.lifecycle.activate.blockedMessage": "Complete these setup requirements before activating. Open Edit setup on this analyzer to verify its mappings and connection.",
  "analyzer.lifecycle.activate.blockedTitle": "Analyzer is not ready",
  "analyzer.lifecycle.activate.cancel": "Cancel activation",
  "analyzer.lifecycle.activate.confirm": "Activate analyzer",
  "analyzer.lifecycle.activate.error": "The analyzer could not be activated.",
  "analyzer.lifecycle.activate.errorTitle": "Activation failed",
  "analyzer.lifecycle.activate.message": "Activate {name}? Its setup will be checked before it can be used.",
  "analyzer.lifecycle.activate.title": "Activate analyzer",
  "analyzer.lifecycle.deactivate.cancel": "Cancel deactivation",
  "analyzer.lifecycle.deactivate.confirm": "Deactivate analyzer",
  "analyzer.lifecycle.deactivate.error": "The analyzer could not be deactivated.",
  "analyzer.lifecycle.deactivate.errorTitle": "Deactivation failed",
  "analyzer.lifecycle.deactivate.message": "Deactivate {name}? New runtime use will stop. Its configuration and history will be retained, and it can be reactivated later.",
  "analyzer.lifecycle.deactivate.title": "Deactivate analyzer",
  "analyzer.lifecycle.delete.cancel": "Keep analyzer",
  "analyzer.lifecycle.delete.confirm": "Delete analyzer",
  "analyzer.lifecycle.delete.error": "The analyzer could not be deleted.",
  "analyzer.lifecycle.delete.errorTitle": "Delete refused",
  "analyzer.lifecycle.delete.message": "Delete {name}? This is for an analyzer that never received a result and was never activated; one that was used is refused, so retire it instead.",
  "analyzer.lifecycle.delete.title": "Delete analyzer",
  "analyzer.lifecycle.error.inUse": "This analyzer has results or history. Retire it instead.",
  "analyzer.lifecycle.error.notRetired": "The analyzer is not retired.",
  "analyzer.lifecycle.error.running": "Deactivate the analyzer before retiring it.",
  "analyzer.lifecycle.reactivate.blockedMessage": "Complete these setup requirements before reactivating. Open Edit setup on this analyzer to verify its mappings and connection.",
  "analyzer.lifecycle.reactivate.blockedTitle": "Analyzer is not ready",
  "analyzer.lifecycle.reactivate.cancel": "Cancel reactivation",
  "analyzer.lifecycle.reactivate.confirm": "Reactivate analyzer",
  "analyzer.lifecycle.reactivate.error": "The analyzer could not be reactivated.",
  "analyzer.lifecycle.reactivate.errorTitle": "Reactivation failed",
  "analyzer.lifecycle.reactivate.message": "Reactivate {name}? Its setup will be checked again before it can be used.",
  "analyzer.lifecycle.reactivate.title": "Reactivate analyzer",
  "analyzer.lifecycle.restore.cancel": "Keep retired",
  "analyzer.lifecycle.restore.confirm": "Restore analyzer",
  "analyzer.lifecycle.restore.error": "The analyzer could not be restored.",
  "analyzer.lifecycle.restore.errorTitle": "Restore failed",
  "analyzer.lifecycle.restore.message": "Restore {name}? It comes back inactive, to be set up and activated again.",
  "analyzer.lifecycle.restore.title": "Restore analyzer",
  "analyzer.lifecycle.retire.cancel": "Keep analyzer",
  "analyzer.lifecycle.retire.confirm": "Retire analyzer",
  "analyzer.lifecycle.retire.error": "The analyzer could not be retired.",
  "analyzer.lifecycle.retire.errorTitle": "Retire failed",
  "analyzer.lifecycle.retire.message": "Retire {name}? Its results and history are kept, and it is hidden from this list unless you show retired analyzers.",
  "analyzer.lifecycle.retire.title": "Retire analyzer",
  "analyzer.connection.choice.select": "Select a value",
  "analyzer.connection.field.apiToken": "API token",
  "analyzer.connection.field.connectionRole": "Connection role",
  "analyzer.connection.field.directory": "Directory",
  "analyzer.connection.field.directory.help": "Directory on the Analyzer Bridge host",
  "analyzer.connection.field.enabled": "Enabled",
  "analyzer.connection.field.filePattern": "File pattern",
  "analyzer.connection.field.filePattern.help": "File name pattern watched by Analyzer Bridge",
  "analyzer.connection.field.host": "Host",
  "analyzer.connection.field.host.help": "The analyzer's IP address. Optional when the analyzer connects to the Analyzer Bridge. Leave it blank if the analyzer reaches the bridge through NAT or a proxy, and use the instrument system name instead.",
  "analyzer.connection.field.numberFormat": "Decimal separator in results",
  "analyzer.connection.numberFormat.comma": "Comma (12,5)",
  "analyzer.connection.numberFormat.point": "Point (12.5)",
  "analyzer.connection.field.port": "Port",
  "analyzer.connection.field.senderId": "Instrument system name",
  "analyzer.connection.field.senderId.help": "The sender field this instrument puts in its messages (ASTM H.5 or HL7 MSH-3), such as CPHL^GeneXpert^6.2. Enter the whole field, or a part followed by * such as CPHL^GeneXpert^*. Needed only when several analyzers share this port and address.",
  "analyzer.connection.field.received": "Received from instruments:",
  "analyzer.connection.field.serialPort": "Serial device",
  "analyzer.connection.field.transport": "Transport",
  "analyzer.connection.field.unavailable": "Connection setting",
  "analyzer.connection.readiness.profileUnavailable": "This connection is pinned to {profileId} revision {revision}, which the Analyzer Bridge no longer has. Reset the analyzer type, then choose an available one to reconnect it. The analyzer keeps its name, lab units, connection and history.",
  "analyzer.connection.readiness.restoreFailed": "The Analyzer Bridge could not restart this connection. Activate it again; if it still fails, check the Bridge log.",
  "analyzer.connection.role.client": "Client",
  "analyzer.connection.role.server": "Server",
  "analyzer.connection.reference.configured": "Bridge connection configured",
  "analyzer.connection.reference.missing": "Connection setup required",
  "analyzer.connection.transport.RS-232": "Serial (RS-232)",
  "analyzer.connection.transport.TCP/IP": "Network (TCP/IP)",
  "analyzer.connection.validation.invalid": "Check this value.",
  "analyzer.connection.validation.required": "This field is required.",
  "analyzer.setup.close": "Close analyzer setup",
  "analyzer.setup.connect.address.required": "Enter the analyzer address",
  "analyzer.activation.blocker.bridgeAcknowledgement": "Analyzer Bridge has not acknowledged this exact setup.",
  "analyzer.activation.blocker.connection": "Connection settings are incomplete or invalid.",
  "analyzer.activation.blocker.dataFlow": "The selected data flow is not supported by this analyzer type.",
  "analyzer.activation.blocker.labUnit": "Assign at least one active lab unit.",
  "analyzer.activation.blocker.mappings": "Analyzer mappings must be verified again.",
  "analyzer.activation.blocker.name": "Enter an analyzer name.",
  "analyzer.activation.blocker.profile": "The selected analyzer type revision is unavailable or no longer matches this analyzer.",
  "analyzer.activation.blocker.retired": "This analyzer is retired. Restore it before activating it.",
  "analyzer.activation.blocker.recognition": "Control recognition must be verified again.",
  "analyzer.activation.blocker.transport": "The selected connection type is not supported by this analyzer type.",
  "analyzer.setup.connect.activation.active": "Analyzer is active",
  "analyzer.setup.connect.activation.activating": "Activating analyzer",
  "analyzer.setup.connect.activation.blockerUnknown": "Analyzer setup is not ready to activate.",
  "analyzer.setup.connect.activation.cancel": "Cancel",
  "analyzer.setup.connect.activation.error": "Analyzer readiness could not be checked.",
  "analyzer.setup.connect.activation.finish": "Finish and activate",
  "analyzer.setup.connect.activation.loading": "Checking analyzer readiness",
  "analyzer.setup.connect.activation.readiness": "Activation readiness",
  "analyzer.setup.connect.activation.ready": "Analyzer is ready to activate",
  "analyzer.setup.connect.activation.saveChanges": "Save changes",
  "analyzer.setup.connect.activation.saveLater": "Save and finish later",
  "analyzer.setup.connect.activation.saving": "Saving analyzer",
  "analyzer.setup.connect.activation.verifyMappings": "Verify mappings",
  "analyzer.setup.connect.analyzerAddress": "Analyzer address",
  "analyzer.setup.connect.check.analyzer.address.missing": "No analyzer address is saved, so the analyzer was not checked. Results arriving from the analyzer prove the connection works.",
  "analyzer.setup.connect.check.analyzer.host.unknown": "The analyzer address {host} could not be resolved, so the analyzer was not checked. Results arriving from the analyzer prove the connection works.",
  "analyzer.setup.connect.check.analyzer.reachable": "The Bridge reached the analyzer at {host}.",
  "analyzer.setup.connect.check.analyzer.unreachable": "The Bridge could not reach the analyzer at {host}. Analyzers that connect to the Bridge often cannot be reached from it (a firewall, NAT, or a hosted server). Results arriving from the analyzer prove the connection works.",
  "analyzer.setup.connect.check.connection.mode.unsupported": "This connection mode is not supported by the Bridge.",
  "analyzer.setup.connect.check.directory.configuration.missing": "Enter the analyzer file directory before testing.",
  "analyzer.setup.connect.check.directory.not.directory": "The configured path is not a directory.",
  "analyzer.setup.connect.check.directory.not.found": "The configured directory was not found.",
  "analyzer.setup.connect.check.directory.not.readable": "The Bridge cannot read the configured directory.",
  "analyzer.setup.connect.check.directory.path.invalid": "The configured directory path is invalid.",
  "analyzer.setup.connect.check.directory.ready": "Directory is ready.",
  "analyzer.setup.connect.check.http.configuration.missing": "Enter the analyzer web address before testing.",
  "analyzer.setup.connect.check.http.connection.error": "The Bridge could not connect to the analyzer web address.",
  "analyzer.setup.connect.check.http.input.verify.with.delivery": "This analyzer sends messages to the Bridge, so this connection must be verified by delivering a result.",
  "analyzer.setup.connect.check.http.interrupted": "The web connection test was interrupted.",
  "analyzer.setup.connect.check.http.ready": "The analyzer web address is reachable.",
  "analyzer.setup.connect.check.http.server.error": "The analyzer web address returned a server error.",
  "analyzer.setup.connect.check.http.timeout": "The analyzer web address did not respond before the timeout.",
  "analyzer.setup.connect.check.http.url.invalid": "The analyzer web address is invalid.",
  "analyzer.setup.connect.check.listener.configuration.missing": "The shared Bridge listener is not configured. Ask the Bridge administrator to check its listener settings.",
  "analyzer.setup.connect.check.listener.endpoint.missing": "The Bridge listener address is not configured.",
  "analyzer.setup.connect.check.listener.not.listening": "The Bridge listener is not accepting connections.",
  "analyzer.setup.connect.check.listener.port.in.use": "The configured Bridge listener port is already in use.",
  "analyzer.setup.connect.check.listener.profile.unsupported": "The pinned profile does not define a compatible Bridge listener.",
  "analyzer.setup.connect.check.listener.ready": "Bridge listener is ready.",
  "analyzer.setup.connect.check.listener.timeout": "The Bridge listener did not respond before the timeout.",
  "analyzer.setup.connect.check.remote.astm.ready": "The analyzer completed the ASTM handshake.",
  "analyzer.setup.connect.check.remote.astm.response.invalid": "The analyzer returned an invalid ASTM handshake response.",
  "analyzer.setup.connect.check.remote.configuration.missing": "Check the analyzer address and outbound destination settings. An optional port override can replace the analyzer type or Bridge default.",
  "analyzer.setup.connect.check.remote.connection.error": "The Bridge could not connect to the analyzer.",
  "analyzer.setup.connect.check.remote.hl7.ready": "The analyzer completed the HL7 handshake.",
  "analyzer.setup.connect.check.remote.hl7.response.invalid": "The analyzer returned an invalid HL7 handshake response.",
  "analyzer.setup.connect.check.remote.host.unknown": "The analyzer address could not be resolved.",
  "analyzer.setup.connect.check.remote.protocol.unsupported": "This analyzer protocol does not support a remote connection test.",
  "analyzer.setup.connect.check.remote.refused": "The analyzer refused the connection.",
  "analyzer.setup.connect.check.remote.timeout": "The analyzer did not respond before the timeout.",
  "analyzer.setup.connect.check.serial.configuration.missing": "Enter the analyzer serial device before testing.",
  "analyzer.setup.connect.check.serial.not.found": "The configured serial device was not found.",
  "analyzer.setup.connect.check.serial.not.readable": "The Bridge cannot read the configured serial device.",
  "analyzer.setup.connect.check.serial.path.invalid": "The configured serial device path is invalid.",
  "analyzer.setup.connect.check.serial.ready": "The analyzer serial device is ready.",
  "analyzer.setup.connect.checkKind.analyzer": "Analyzer (for information)",
  "analyzer.setup.connect.checkKind.directory": "Directory",
  "analyzer.setup.connect.checkKind.http_endpoint": "Web address",
  "analyzer.setup.connect.checkKind.http_input": "Incoming analyzer messages",
  "analyzer.setup.connect.checkKind.listener": "Bridge listener",
  "analyzer.setup.connect.checkKind.other": "Connection check",
  "analyzer.setup.connect.checkKind.remote_protocol": "Analyzer protocol",
  "analyzer.setup.connect.checkKind.serial_device": "Serial device",
  "analyzer.setup.connect.checkStatus.failed": "Connection check failed.",
  "analyzer.setup.connect.checkStatus.missing_configuration": "Connection settings are incomplete.",
  "analyzer.setup.connect.checkStatus.passed": "Connection check passed.",
  "analyzer.setup.connect.checkStatus.skipped": "This check could not be run.",
  "analyzer.setup.connect.checkStatus.timed_out": "Connection check timed out.",
  "analyzer.setup.connect.configureEndpoint": "Configure the analyzer to use",
  "analyzer.setup.connect.dataFlow": "Data flow",
  "analyzer.setup.connect.dataFlow.resultsOnly": "Results only",
  "analyzer.setup.connect.dataFlow.twoWay": "Two-way",
  "analyzer.setup.connect.destination": "Destination: {host}, port {port}",
  "analyzer.setup.connect.destinationRemediation": "Check the analyzer address, destination port, listening service and network access, then test again.",
  "analyzer.setup.connect.listenerPort": "Bridge listener port: {port}",
  "analyzer.setup.connect.portSource": "Port selected from: {source}",
  "analyzer.setup.connect.portSource.override": "Connection override",
  "analyzer.setup.connect.portSource.profile": "Analyzer type default",
  "analyzer.setup.connect.portSource.bridge": "Bridge default",
  "analyzer.setup.connect.directory": "Analyzer file directory",
  "analyzer.setup.connect.directory.required": "Enter the analyzer file directory",
  "analyzer.setup.connect.error": "Connection settings could not be saved or tested.",
  "analyzer.setup.connect.evidence": "Connection evidence",
  "analyzer.setup.connect.loadError": "The saved analyzer connection could not be loaded.",
  "analyzer.setup.connect.loading": "Loading analyzer connection",
  "analyzer.setup.connect.outcome.failure": "Connection failed",
  "analyzer.setup.connect.outcome.missing_configuration": "Connection settings are incomplete",
  "analyzer.setup.connect.outcome.success": "Connection ready",
  "analyzer.setup.connect.outcome.timeout": "Connection timed out",
  "analyzer.setup.connect.port": "Analyzer port",
  "analyzer.setup.connect.port.invalid": "Enter a port from 1 to 65535",
  "analyzer.setup.connect.sourceAddress": "Analyzer source address",
  "analyzer.setup.connect.test": "Test connection",
  "analyzer.setup.connect.testing": "Testing connection",
  "analyzer.setup.connect.title": "Connect",
  "analyzer.setup.connect.useResultsOnly": "Use Results only",
  "analyzer.setup.instrument.continue": "Continue to Assays",
  "analyzer.setup.instrument.labUnits": "Lab units",
  "analyzer.setup.instrument.labUnits.placeholder": "Select lab units",
  "analyzer.setup.instrument.labUnits.required": "Select at least one lab unit",
  "analyzer.setup.instrument.name": "Analyzer name",
  "analyzer.setup.instrument.name.required": "Enter an analyzer name",
  "analyzer.setup.instrument.notListed": "Instrument not listed?",
  "analyzer.setup.instrument.saveError": "The analyzer could not be saved. Try again.",
  "analyzer.setup.instrument.saving": "Saving analyzer",
  "analyzer.setup.instrument.summary": "Saved instrument details",
  "analyzer.setup.step.edit": "Edit {step}",
  "analyzer.setup.instrument.type": "Analyzer type",
  "analyzer.setup.instrument.type.helper": "Choose the listed type for your instrument, even if it will only send results. Whether it sends results only or also receives orders is set later, in Connect.",
  "analyzer.setup.instrument.type.placeholder": "Search analyzer types",
  "analyzer.setup.instrument.type.required": "Select an analyzer type",
  "analyzer.setup.instrument.typeOption": "{name} · {manufacturer} · {protocol} · revision {revision}",
  "analyzer.setup.instrument.title": "Instrument",
  "analyzer.setup.steps": "Analyzer setup steps",
  "analyzer.setup.title": "Set up a new analyzer",
  "analyzer.setup.title.named": "Set up {name}",
  "analyzer.setup.verify.confirm": "Confirm the mappings below to continue.",
  "analyzer.setup.verify.noAssays": "No assay is on for this instrument. Turn on the assays it runs in Assays.",
  "analyzer.setup.verify.unresolved": "{count, plural, one {# record or value} other {# records or values}} of the assays that are on still need mapping. Map them below, or turn the assay off in Assays if this instrument does not run it.",
  "analyzer.setup.verify.continue": "Continue to Connect",
  "analyzer.setup.verify.selecting": "Applying mappings...",
  "analyzer.setup.verify.selectionError": "Could not apply the reviewed mappings. Reload Verify and try again.",
  "analyzer.setup.verify.loading": "Loading mapping verification",
  "analyzer.setup.verify.summary": "Mappings reviewed for this setup",
  "analyzer.setup.verify.summary.stale": "Mappings need to be verified again",
  "analyzer.setup.verify.title": "Verify",
  "analyzer.navigation.analyzerTypes": "Analyzer Types",
  "analyzer.navigation.analyzers": "Analyzers",
  "analyzer.navigation.analyzersList": "Analyzers List",
  "analyzer.navigation.fieldMappings": "Field Mappings",
  "analyzer.navigation.qc": "Quality Control",
  "analyzer.navigation.qcDashboard": "QC Dashboard",
  "analyzer.navigation.qcAlerts": "QC Alerts & Violations",
  "analyzer.navigation.qcCorrectiveActions": "Corrective Actions",
  "analyzerType.action.deactivate": "Deactivate",
  "analyzerType.action.editMappings": "View default mappings",
  "analyzerType.action.history": "View history",
  "analyzerType.action.reactivate": "Reactivate",
  "analyzerType.action.updateShared": "Update shared",
  "analyzerType.adoption.adopted": "Revision {revision} adopted. Confirm the mapping below, then apply it to switch this analyzer.",
  "analyzerType.adoption.blocked.heldResults": "{code} still has held results from revision {revision}. Resolve them before adopting.",
  "analyzerType.adoption.blocked.inactiveTest": "Mapped to a test that is no longer active. Choose another test.",
  "analyzerType.adoption.blocked.reviewHeld": "Review held results",
  "analyzerType.adoption.bucket.blocked": "Blocked",
  "analyzerType.adoption.bucket.blocked.help": "Adoption waits until these are resolved.",
  "analyzerType.adoption.bucket.changed": "Changed",
  "analyzerType.adoption.bucket.changed.help": "The newer revision proposes something else for these. Keep the current choice or use the new default.",
  "analyzerType.adoption.bucket.needs_mapping": "Needs mapping",
  "analyzerType.adoption.bucket.needs_mapping.help": "New in this revision, or no longer carried over. Map them now or leave them for later.",
  "analyzerType.adoption.bucket.retired": "No longer sent",
  "analyzerType.adoption.bucket.retired.help": "Revision {revision} no longer sends these, so their mappings are dropped.",
  "analyzerType.adoption.bucket.unchanged": "Unchanged",
  "analyzerType.adoption.bucket.unchanged.help": "These carry over as they are.",
  "analyzerType.adoption.changed.current": "Current: {name}",
  "analyzerType.adoption.changed.newDefault": "New default: {name}",
  "analyzerType.adoption.error.save": "The adoption could not be saved",
  "analyzerType.adoption.keepCurrent": "Keep current",
  "analyzerType.adoption.notice.subtitle": "This analyzer keeps receiving on revision {from} until you save this, confirm it and apply it.",
  "analyzerType.adoption.notice.title": "Adopting revision {revision}",
  "analyzerType.adoption.save": "Save as revision {revision}",
  "analyzerType.adoption.title": "Adopt revision {revision} of {name}",
  "analyzerType.adoption.useNewDefault": "Use new default",
  "analyzerType.affectedAnalyzers.heading": "{count, plural, one {Analyzer using this type} other {Analyzers using this type}}",
  "analyzerType.affectedAnalyzers.adopt": "Adopt revision {revision}",
  "analyzerType.affectedAnalyzers.verify": "Verify saved mapping",
  "analyzerType.affectedAnalyzers.current": "Confirmed and current",
  "analyzerType.affectedAnalyzers.behind": "Behind",
  "analyzerType.actions.ariaLabel": "Actions for {name}",
  "analyzerType.button.create": "Create Profile",
  "analyzerType.button.cancel": "Cancel",
  "analyzerType.button.duplicate": "Duplicate Profile",
  "analyzerType.button.publish": "Publish Profile",
  "analyzerType.button.startUpdate": "Start update",
  "analyzerType.column.actions": "Actions",
  "analyzerType.column.protocol": "Protocol",
  "analyzerType.column.resultsMapped": "Results for a new analyzer",
  "analyzerType.column.status": "Status",
  "analyzerType.column.testsMapped": "Tests for a new analyzer",
  "analyzerType.column.type": "Analyzer type",
  "analyzerType.column.usedBy": "Used by",
  "analyzerType.dataFlow.resultsOnly": "Results only",
  "analyzerType.dataFlow.twoWay": "Two-way",
  "analyzerType.duplicate.lineage.subtitle": "The new profile starts from {name} revision {revision}. Later changes do not alter the source profile or its analyzers.",
  "analyzerType.duplicate.lineage.title": "New profile with preserved lineage",
  "analyzerType.draft.created.subtitle": "The draft is saved in Analyzer Bridge. It must be completed and validated before it can be published for analyzer setup.",
  "analyzerType.draft.created.title": "Profile draft created",
  "analyzerType.draft.loading": "Loading profile draft",
  "analyzerType.draft.publish.ready.subtitle": "{name} has a unique Bridge-owned identity and preserves its source lineage.",
  "analyzerType.draft.publish.ready.title": "Ready to publish",
  "analyzerType.draft.publish.review.subtitle": "Review and save the control-recognition behavior for {name} before publishing.",
  "analyzerType.draft.publish.review.title": "Complete profile review",
  "analyzerType.draft.update.loading": "Loading profile update draft",
  "analyzerType.draft.update.subtitle": "The shared analyzer type is unchanged until this draft is completed and published. Existing analyzers remain pinned to their current revisions.",
  "analyzerType.draft.update.title": "Profile update draft created",
  "analyzerType.empty.subtitle": "Adjust the search or filters to see other analyzer types.",
  "analyzerType.empty.title": "No analyzer types match",
  "analyzerType.none.subtitle": "Create Profile adds one.",
  "analyzerType.none.title": "No analyzer types yet",
  "analyzerType.bridgeNotPaired.subtitle": "The analyzer types it serves are listed here once it is paired on the Analyzers page.",
  "analyzerType.explainer.subtitle": "Identical analyzers can share one type. Duplicate a type when an analyzer needs different behavior; deactivate types instead of deleting their history.",
  "analyzerType.explainer.title": "Reusable analyzer setup",
  "analyzerType.error.nameUnique": "Profile names must be unique",
  "analyzerType.field.connectionTest": "Supports connection testing",
  "analyzerType.field.dataFlow": "Data flow",
  "analyzerType.field.fileFormat": "File format",
  "analyzerType.field.filePattern": "File name pattern",
  "analyzerType.field.manufacturer": "Manufacturer",
  "analyzerType.field.model": "Model",
  "analyzerType.field.newProfileName": "New profile name",
  "analyzerType.field.profileName": "Profile name",
  "analyzerType.field.protocol": "Protocol",
  "analyzerType.field.resultColumn": "Result column",
  "analyzerType.field.sampleColumn": "Sample ID column",
  "analyzerType.field.sourceProfile.placeholder": "Select an analyzer type",
  "analyzerType.field.sourceProfile": "Source analyzer type",
  "analyzerType.field.testColumn": "Test code column",
  "analyzerType.filter.all": "All",
  "analyzerType.filter.mapping": "Mapping status",
  "analyzerType.filter.protocol": "Protocol",
  "analyzerType.filter.showDeactivated": "Show deactivated",
  "analyzerType.filter.source": "Created",
  "analyzerType.history.action.created": "Created",
  "analyzerType.history.action.deactivated": "Deactivated",
  "analyzerType.history.action.duplicated": "Duplicated",
  "analyzerType.history.action.reactivated": "Reactivated",
  "analyzerType.history.action.shipped": "Shipped",
  "analyzerType.history.action.updated": "Updated",
  "analyzerType.history.actor": "Changed by",
  "analyzerType.history.change": "Change",
  "analyzerType.history.loading": "Loading profile history",
  "analyzerType.history.revisionValue": "Revision {revision}",
  "analyzerType.history.revision": "Revision",
  "analyzerType.history.status": "Status",
  "analyzerType.history.time": "Changed at",
  "analyzerType.lineage": "Derived from {profileId} revision {revision}",
  "analyzerType.loading": "Loading analyzer types",
  "analyzerType.mapping.complete": "Fully mapped",
  "analyzerType.mapping.count": "{mapped} / {total} · {percent}%",
  "analyzerType.mapping.allDecided": "{decided} decided: {mapped} mapped, {excluded} excluded",
  "analyzerType.mapping.countWithExcluded": "{decided} of {total} decided: {mapped} mapped, {excluded} excluded",
  "analyzerType.mapping.incomplete": "Needs mapping",
  "analyzerType.mapping.notApplicable": "Not applicable",
  "analyzerType.mapping.notStarted": "Not mapped",
  "analyzerType.mappingEditor.applyToAnalyzer": "Apply mappings and retry held results",
  "analyzerType.mappingEditor.appliedToAnalyzer": "Current mappings applied to this analyzer. Eligible held results were retried.",
  "analyzerType.mappingEditor.error.applyToAnalyzer": "Could not apply mappings to this analyzer.",
  "analyzerType.mappingEditor.alias": "Alias: {alias}",
  "analyzerType.mappingEditor.confirm": "Confirm mappings",
  "analyzerType.mappingEditor.confirmation.by": "Confirmed by {actor} on {date}",
  "analyzerType.mappingEditor.confirmation.current": "Current confirmation",
  "analyzerType.mappingEditor.confirmation.stale": "Confirmation is stale",
  "analyzerType.mappingEditor.confirmation.summary.current": "Current",
  "analyzerType.mappingEditor.confirmation.summary.stale": "Stale",
  "analyzerType.mappingEditor.confirmation.summary.unconfirmed": "Not confirmed",
  "analyzerType.mappingEditor.confirmation.unconfirmed": "Not confirmed",
  "analyzerType.mappingEditor.confirmation": "Confirmation",
  "analyzerType.mappingEditor.confirmed": "Mappings confirmed",
  "analyzerType.mappingEditor.error.confirm": "Confirmation failed",
  "analyzerType.mappingEditor.error.load": "Analyzer mappings could not be loaded",
  "analyzerType.mappingEditor.error.route": "A valid analyzer or Analyzer Type revision is required",
  "analyzerType.mappingEditor.error.save": "Mappings could not be saved",
  "analyzerType.mappingEditor.excludeResult.short": "Do not receive",
  "analyzerType.mappingEditor.excludeResult": "Do not receive {value}",
  "analyzerType.mappingEditor.callComponentPicker": "Call result for {code} goes to",
  "analyzerType.mappingEditor.componentPicker": "OpenELIS component for {code}",
  "analyzerType.mappingEditor.componentPicker.required": "Choose the component this record lands on.",
  "analyzerType.mappingEditor.componentPicker.placeholder": "Choose a component",
  "analyzerType.mappingEditor.excludeTest": "Do not receive {code}",
  "analyzerType.mappingEditor.partial": "{count} unresolved mappings. You can confirm and connect; affected results will be saved for correction before use.",
  "analyzerType.mappingEditor.incomplete": "Correct unavailable test or result selections before confirmation.",
  "analyzerType.mappingEditor.loading": "Loading analyzer mappings",
  "analyzerType.mappingEditor.observed": "Observed in held results",
  "analyzerType.mappingEditor.recognition.heading": "Control result recognition",
  "analyzerType.mappingEditor.recognition.none": "This Analyzer Type explicitly declares that the interface transports no control results.",
  "analyzerType.mappingEditor.resultPicker.placeholder": "Choose an OpenELIS result",
  "analyzerType.mappingEditor.resultPicker": "OpenELIS result for {value}",
  "analyzerType.mappingEditor.tests.none": "This analyzer type declares no tests, so there is nothing to map. Its author can add tests to a new revision of the type.",
  "analyzerType.mappingEditor.results.empty": "This Test has no active result options",
  "analyzerType.mappingEditor.results.heading": "Results - {name}",
  "analyzerType.mappingEditor.results.loading": "Loading result options",
  "analyzerType.mappingEditor.results.openCatalog": "Add result options in Test Catalog",
  "analyzerType.mappingEditor.results.testFirst": "Choose an OpenELIS Test before mapping its results",
  "analyzerType.mappingEditor.reason.result.ambiguous": "Not mapped: several answers for this test carry this value's code. Choose one.",
  "analyzerType.mappingEditor.reason.result.incompatible": "Not mapped: no answer for this test can hold this value.",
  "analyzerType.mappingEditor.reason.result.no_match": "Not mapped: no answer for this test carries this value's code.",
  "analyzerType.mappingEditor.reason.test.ambiguous": "Not mapped: several tests in this lab's catalog carry its code. Choose one.",
  "analyzerType.mappingEditor.reason.test.incompatible": "Not mapped: a test in this lab's catalog carries its code but cannot hold these results.",
  "analyzerType.mappingEditor.reason.test.no_match": "Not mapped: no test in this lab's catalog carries its code.",
  "analyzerType.mappingEditor.results": "Results mapped",
  "analyzerType.mappingEditor.return": "Back",
  "analyzerType.mappingEditor.save": "Save mapping",
  "analyzerType.mappingEditor.saved": "Mappings saved",
  "analyzerType.mappingEditor.own.title": "This analyzer's own mapping",
  "analyzerType.mappingEditor.own.subtitle": "Changes here apply only to this analyzer. They take effect when you confirm the mapping and apply it.",
  "analyzerType.mappingEditor.defaults.title": "Defaults for new analyzers",
  "analyzerType.mappingEditor.defaults.subtitle": "This is what a new analyzer of this type would start with, matched by the codes the profile and the current catalog share. Nothing here is saved; each analyzer keeps its own mapping.",
  "analyzerType.mappingEditor.origin.override": "Edited",
  "analyzerType.mappingEditor.changes.heading": "Review changes before saving",
  "analyzerType.mappingEditor.changes.save": "Save changes",
  "analyzerType.mappingEditor.changes.none": "Nothing has changed since the last save.",
  "analyzerType.mappingEditor.changes.row": "{from} to {to}",
  "analyzerType.mappingEditor.sourceCode": "Analyzer code",
  "analyzerType.mappingEditor.state.bound": "Mapped",
  "analyzerType.mappingEditor.state.excluded": "Do not receive",
  "analyzerType.mappingEditor.state.unresolved": "Needs mapping",
  "analyzerType.mappingEditor.subtitle": "{protocol} · revision {revision}",
  "analyzerType.mappingEditor.suggestion": "Suggested match: {name}",
  "analyzerType.mappingEditor.summary": "Mapping summary",
  "analyzerType.mappingEditor.testPicker.placeholder": "Search by name, code, or LOINC",
  "analyzerType.mappingEditor.testPicker": "OpenELIS test for {code}",
  "analyzerType.mappingEditor.tests.heading": "Test and result mappings",
  "analyzerType.mappingEditor.tests.help": "Review each analyzer code independently. Map it to an active OpenELIS Test or explicitly exclude it.",
  "analyzerType.mappingEditor.tests": "Tests mapped",
  "analyzerType.mappingEditor.title": "{name} mappings",
  "analyzerType.mappingEditor.unsaved": "Unsaved mapping changes",
  "analyzerType.mappingEditor.useSuggestion": "Use suggested test",
  "analyzerType.modal.deactivate.subtitle": "Existing analyzers and revision history stay linked. This profile will no longer be available for new analyzer setup.",
  "analyzerType.modal.deactivate.title": "Deactivate {name}",
  "analyzerType.modal.history.title": "{name} history",
  "analyzerType.modal.reactivate.subtitle": "This profile will be available for new analyzer setup again. Existing analyzers remain pinned to their selected revisions.",
  "analyzerType.modal.reactivate.title": "Reactivate {name}",
  "analyzerType.modal.update.subtitle": "This starts a new immutable revision from revision {revision}. {count, plural, one {# analyzer remains pinned to its current revision.} other {# analyzers remain pinned to their current revisions.}}",
  "analyzerType.modal.update.title": "Update {name}",
  "analyzerType.notification.action.error.subtitle": "Try the profile action again.",
  "analyzerType.notification.action.error": "Profile action failed",
  "analyzerType.notification.create.success": "Profile created",
  "analyzerType.notification.deactivate.success": "Profile deactivated",
  "analyzerType.notification.duplicate.success": "Profile duplicated",
  "analyzerType.notification.update.success": "Profile updated",
  "analyzerType.notification.loadError.subtitle": "Check the Analyzer Bridge connection, then try again.",
  "analyzerType.notification.catalogIssues": "Some analyzer profiles could not be loaded",
  "analyzerType.notification.catalogIssues.subtitle": "The Analyzer Bridge set these files aside and serves every other profile. Fix or remove each file, then restart the Bridge.",
  "analyzerType.notification.loadError": "Analyzer types could not be loaded",
  "analyzerType.notification.reactivate.success": "Profile reactivated",
  "analyzerType.page.subtitle": "The reusable setups behind your analyzers.",
  "analyzerType.page.title": "Analyzer Types",
  "analyzerType.protocol.file": "Flat file",
  "analyzerType.recognition.none.affirmation": "I confirm this interface does not transmit control results",
  "analyzerType.recognition.none.subtitle": "Publish this profile only when the analyzer interface sends no control results. Profiles that transmit controls require explicit recognition rules.",
  "analyzerType.recognition.none.title": "No automatic control-result recognition",
  "analyzerType.recognition.condition.add": "Add condition",
  "analyzerType.recognition.condition.fieldValue": "{source} value",
  "analyzerType.recognition.condition.new": "New recognition condition",
  "analyzerType.recognition.condition.prefixValue": "Specimen ID prefix",
  "analyzerType.recognition.condition.remove": "Remove condition",
  "analyzerType.recognition.condition.select.placeholder": "Choose a condition",
  "analyzerType.recognition.condition.select": "New condition",
  "analyzerType.recognition.condition.sourceContains": "{source} contains",
  "analyzerType.recognition.condition.sourceEquals": "{source} equals",
  "analyzerType.recognition.condition.specimenPrefix": "Specimen ID starts with",
  "analyzerType.recognition.condition.summary.configuredPattern": "Specimen ID matches a configured pattern",
  "analyzerType.recognition.condition.summary.contains": "{source} contains {value}",
  "analyzerType.recognition.condition.summary.equals": "{source} equals {value}",
  "analyzerType.recognition.condition.summary.startsWith": "{source} starts with {value}",
  "analyzerType.recognition.condition.summary.unknown": "Control-result recognition",
  "analyzerType.recognition.error.load": "Control recognition could not be loaded.",
  "analyzerType.recognition.error.save": "Control recognition could not be saved.",
  "analyzerType.recognition.error.title": "Control recognition needs attention",
  "analyzerType.recognition.heading": "Control result recognition",
  "analyzerType.recognition.loading": "Loading control recognition",
  "analyzerType.recognition.mode.none": "This interface does not transmit control results",
  "analyzerType.recognition.mode.none.short": "No control-result recognition",
  "analyzerType.recognition.mode.rules": "Recognize controls using these conditions",
  "analyzerType.recognition.mode.rules.short": "Rule-based control recognition",
  "analyzerType.recognition.mode.unconfigured.short": "Control recognition not configured",
  "analyzerType.recognition.mode.unconfigured": "No control recognition rules are configured. Control results may not be identified automatically.",
  "analyzerType.recognition.mode": "How does this interface identify control results?",
  "analyzerType.recognition.rules.help": "A result is treated as a control when any condition matches.",
  "analyzerType.recognition.save": "Save control recognition",
  "analyzerType.recognition.saved": "Control recognition saved",
  "analyzerType.recognition.source.specimenId": "Specimen ID",
  "analyzerType.revision": "revision {revision}",
  "analyzerType.search.label": "Search analyzer types",
  "analyzerType.search.placeholder": "Search by name, manufacturer, or model",
  "analyzerType.source.shipped": "Shipped",
  "analyzerType.source.site": "Site-created",
  "analyzerType.status.active": "Active",
  "analyzerType.status.inactive": "Deactivated",
  "analyzerType.summary.ariaLabel": "Analyzer type summary",
  "analyzerType.summary.deactivated": "Deactivated",
  "analyzerType.summary.inUse": "In Use",
  "analyzerType.summary.needsAttention": "Needs Attention",
  "analyzerType.summary.total": "Analyzer Types",
  "analyzerType.usedBy": "{count, plural, =0 {Not in use} one {# analyzer} other {# analyzers}}",
  "analyzer.navigation.qcControlLots": "Control Lots",
  "analyzer.navigation.qcRuleConfig": "Rule Configuration",
  "analyzer.page.addButton": "Add Analyzer",
  "analyzer.page.hierarchy.list": "Analyzer List",
  "analyzer.page.hierarchy.mappings": "Field Mappings",
  "analyzer.page.hierarchy.root": "Analyzers",
  "analyzer.page.title": "Analyzers",
  "analyzer.plugin.missing": "Plugin Missing",
  "analyzer.qc.alerts.message": "Alerts and violations features are coming soon.",
  "analyzer.qc.alerts.title": "QC Alerts & Violations",
  "analyzer.qc.corrective.message": "Corrective actions features are coming soon.",
  "analyzer.qc.corrective.title": "Corrective Actions",
  "analyzer.qc.placeholder.message": "Quality Control features are coming soon.",
  "analyzer.qc.placeholder.title": "Quality Control",
  "analyzer.action.viewResults": "View results",
  "analyzer.results.held.assayNotEnabled": "This assay is off in the analyzer's setup, so its result was held. Turn it on in the setup's Assays step if this instrument runs it; the result is retried when the mapping is applied.",
  "analyzer.results.held.code": "Analyzer code: {code}",
  "analyzer.results.held.enableAssay": "Turn the assay on",
  "analyzer.results.held.instrumentNote": "Instrument note: {note}",
  "analyzer.results.instrumentReported": "Instrument reported",
  "analyzer.results.instrumentReported.assay": "Assay: {assay}",
  "analyzer.results.instrumentReported.assayVersion": "Assay: {assay}, version {version}",
  "analyzer.results.instrumentReported.flag": "Flag: {flag}",
  "analyzer.results.instrumentReported.operator": "Operator: {operator}",
  "analyzer.results.failedRun.dismiss": "Dismiss as failed run",
  "analyzer.results.held.remove": "Remove from review",
  "analyzer.results.held.removed": "The held result is removed from review. The audit trail keeps it.",
  "analyzer.results.held.removeError": "The held result could not be removed",
  "analyzer.results.failedRun.dismissed": "The failed run is recorded on the order and its test stays open for the repeat.",
  "analyzer.results.failedRun.error": "The failed run could not be dismissed",
  "analyzer.results.held.conflictingAnswerMapping": "The received spelling and its canonical answer have conflicting local mappings. Make their mapping decisions consistent, then retry this held result.",
  "analyzer.results.held.qcTargetMissing": "This control reported an answer, but its test and control level have no QC target to judge it against. Set the expected answer, then apply the analyzer's mapping to retry it.",
  "analyzer.results.held.setQcTarget": "Set QC target",
  "analyzer.results.held.reviewMapping": "Review analyzer mapping",
  "analyzer.results.sampleFlags": "Analyzer flags: {flags}",
  "analyzer.results.held.subtitle": "Held results cannot be accepted. Each one says what to do: review this analyzer's mapping, or dismiss a failed run so its test stays open for the repeat.",
  "analyzer.results.held.tag": "Held",
  "analyzer.results.held.title": "{count, plural, one {# analyzer result needs attention} other {# analyzer results need attention}}",
  "analyzer.qualitativeMapping.isDefault": "Default",
  "analyzer.qualitativeMapping.mappings": "Value Mappings",
  "analyzer.qualitativeMapping.noValues": "No analyzer values available for mapping",
  "analyzer.qualitativeMapping.openelisCode.placeholder": "Select OpenELIS code",
  "analyzer.qualitativeMapping.subtitle": "Map qualitative values for {fieldName}",
  "analyzer.qualitativeMapping.title": "Qualitative Value Mapping",
  "analyzer.qualitativeMapping.validation.error": "Validation Error",
  "analyzer.qualitativeMapping.validation.error.subtitle": "Please correct the errors below",
  "analyzer.qualitativeMapping.validation.noDefault": "No Default Value",
  "analyzer.qualitativeMapping.validation.noDefault.subtitle": "At least one mapping should be marked as default",
  "analyzer.qualitativeMapping.validation.openelisCode.required": "OpenELIS code is required",
  "analyzer.query.button": "Query Analyzer",
  "analyzer.query.cancel": "Cancel",
  "analyzer.query.modal.logs": "Connection Logs",
  "analyzer.query.modal.noLogs": "No logs yet.",
  "analyzer.query.modal.progress": "Progress",
  "analyzer.query.modal.state": "State",
  "analyzer.query.modal.subtitle": "Retrieve available fields from analyzer",
  "analyzer.query.modal.title": "Query Analyzer",
  "analyzer.query.progress": "{percent}% complete",
  "analyzer.search.label": "Search",
  "analyzer.search.placeholder": "Search analyzers...",
  "analyzer.attention.review": "Review held results",
  "analyzer.attention.subtitle": "Map unknown tests or result values before using these results clinically.",
  "analyzer.attention.tag": "Needs attention",
  "analyzer.attention.title.many": "{count} analyzers have held results",
  "analyzer.attention.title.one": "{name} has held results",
  "analyzer.stat.active": "Active",
  "analyzer.stat.inactive": "Inactive",
  "analyzer.stat.needsAttention": "Needs attention",
  "analyzer.stat.setup": "In Setup",
  "analyzer.stat.total": "Total Analyzers",
  "analyzer.stats.active": "Active Analyzers",
  "analyzer.stats.inactive": "Inactive Analyzers",
  "analyzer.stats.total": "Total Analyzers",
  "analyzer.status.active": "Active",
  "analyzer.status.deleted": "Deleted",
  "analyzer.status.error_pending": "Error Pending",
  "analyzer.status.inactive": "Inactive",
  "analyzer.status.offline": "Offline",
  "analyzer.status.retired": "Retired",
  "analyzer.status.setup": "Setup",
  "analyzer.status.validation": "Validation",
  "analyzer.success.save": "Analyzer saved successfully",
  "analyzer.table.actions": "Actions",
  "analyzer.table.connection": "Connection",
  "analyzer.table.header.connection": "Connection",
  "analyzer.table.header.lastModified": "Last Modified",
  "analyzer.table.header.name": "Name",
  "analyzer.table.header.status": "Status",
  "analyzer.table.header.testUnits": "Lab Units",
  "analyzer.table.header.type": "Analyzer type",
  "analyzer.table.lastModified": "Last Modified",
  "analyzer.table.name": "Name",
  "analyzer.table.status": "Status",
  "analyzer.table.testUnits": "Test Units",
  "analyzer.table.type": "Type",
  "analyzer.table.type.loading": "Loading analyzer type",
  "analyzer.table.type.unavailable": "Analyzer type unavailable",
  "analyzer.testUnits.count": "{count, plural, one {# unit} other {# units}}",
  "analyzer.testConnection.bridge.healthCheckFailed": "Cannot reach bridge health endpoint at {url}: {detail}",
  "analyzer.testConnection.bridge.httpStatus": "Bridge returned HTTP {status}",
  "analyzer.testConnection.bridge.notConfigured": "Bridge is not configured",
  "analyzer.testConnection.bridge.unparseableResponse": "Bridge returned an unparseable response",
  "analyzer.testConnection.bridge.unreachable": "Cannot reach bridge: {detail}",
  "analyzer.testConnection.close": "Close",
  "analyzer.testConnection.logs": "Connection Logs",
  "analyzer.testConnection.requestBuildFailed": "Failed to build request: {detail}",
  "analyzer.testConnection.success": "Connection Successful",
  "analyzer.testConnection.tcp.bridgeNotConfigured": "Bridge is not configured, so analyzer reachability cannot be tested",
  "analyzer.testConnection.testAgain": "Test Again",
  "analyzer.testConnection.testing": "Testing connection...",
  "analyzer.testConnection.title": "Test Connection",
  "analyzer.testMapping.activeMappings": "{count} active mappings",
  "analyzer.testMapping.analyzerInfo": "Analyzer Information",
  "analyzer.testMapping.analyzerName": "Analyzer Name",
  "analyzer.testMapping.analyzerType": "Analyzer Type",
  "analyzer.testMapping.appliedMappings": "Applied Mappings",
  "analyzer.testMapping.entityPreview": "OpenELIS Entity Preview",
  "analyzer.testMapping.errors": "Errors",
  "analyzer.testMapping.loading": "Processing preview...",
  "analyzer.testMapping.messageInput": "Sample ASTM Message",
  "analyzer.testMapping.messageInput.counter": "{current} / {max} characters",
  "analyzer.testMapping.messageInput.helper": "Enter a sample ASTM message to preview how it will be interpreted",
  "analyzer.testMapping.messageInput.placeholder": "H|\\^&|||PSM^Micro^2.0|...",
  "analyzer.testMapping.messageInput.required": "Sample ASTM Message *",
  "analyzer.testMapping.noResults": "No preview results yet. Enter a sample ASTM message and click Preview Mapping.",
  "analyzer.testMapping.parsedFields": "Parsed Fields",
  "analyzer.testMapping.parsedFields.astmRef": "ASTM Ref",
  "analyzer.testMapping.parsedFields.fieldName": "Field Name",
  "analyzer.testMapping.parsedFields.interpretation": "Interpretation",
  "analyzer.testMapping.parsedFields.mappedTo": "Mapped To",
  "analyzer.testMapping.parsedFields.rawValue": "Raw Value",
  "analyzer.testMapping.pluginConfigSnapshot": "Plugin Config Snapshot",
  "analyzer.testMapping.previewOptions": "Preview Options",
  "analyzer.testMapping.previewOptions.detailedParsing": "Show detailed parsing steps",
  "analyzer.testMapping.previewOptions.validateAll": "Validate all mappings",
  "analyzer.testMapping.results": "Preview Results",
  "analyzer.testMapping.saveTestCase": "Save as Test Case",
  "analyzer.testMapping.submit": "Preview Mapping",
  "analyzer.testMapping.subtitle": "Preview how sample ASTM messages will be interpreted",
  "analyzer.testMapping.testAnother": "Test Another Message",
  "analyzer.testMapping.title": "Test Field Mappings",
  "analyzer.testMapping.validation.invalidFormat": "Invalid ASTM message format",
  "analyzer.testMapping.validation.messageRequired": "ASTM message is required",
  "analyzer.testMapping.validation.messageTooLarge": "ASTM message exceeds maximum size of 10KB",
  "analyzer.testMapping.warnings": "Warnings",
  "analyzer.unitMapping.analyzerUnit": "Source Unit (Analyzer)",
  "analyzer.unitMapping.analyzerUnit.helper": "Unit reported by the analyzer",
  "analyzer.unitMapping.conversionFactor": "Conversion Factor",
  "analyzer.unitMapping.conversionFactor.helper": "Factor to convert from {from} to {to} (e.g., 0.0555 for mg/dL to mmol/L)",
  "analyzer.unitMapping.openelisUnit": "Target Unit (OpenELIS)",
  "analyzer.unitMapping.openelisUnit.helper": "Canonical unit used in OpenELIS",
  "analyzer.unitMapping.openelisUnit.placeholder": "Select target unit",
  "analyzer.unitMapping.rejectIfMismatch": "Reject if Units Don't Match",
  "analyzer.unitMapping.rejectIfMismatch.helper": "Reject messages if units don't match and no conversion factor is provided",
  "analyzer.unitMapping.subtitle": "Configure unit mapping for {fieldName}",
  "analyzer.unitMapping.title": "Unit Mapping",
  "analyzer.unitMapping.validation.analyzerUnit.required": "Source unit is required",
  "analyzer.unitMapping.validation.conversionFactor.invalid": "Conversion factor must be a positive number",
  "analyzer.unitMapping.validation.conversionFactor.required": "Conversion factor is required when units differ",
  "analyzer.unitMapping.validation.error": "Validation Error",
  "analyzer.unitMapping.validation.error.subtitle": "Please correct the errors below",
  "analyzer.unitMapping.validation.openelisUnit.required": "Target unit is required",
  "analyzerTestName.header.analyzerName": "Analyzer - Analyzer Test Name",
  "analyzerTestName.modal.add.heading": "Add Analyzer Test Name",
  "analyzerTestName.modal.update.heading": "Update Analyzer Test Name",
  "assigned.cytopathologist.label": "CytoPathologist Assigned",
  "assigned.pathologist.label": "Pathologist Assigned",
  "assigned.technician.label": "Technician Assigned",
  "audittrail.table.heading.action": "Action",
  "audittrail.table.heading.identifier": "Identifier",
  "audittrail.table.heading.item": "Item",
  "audittrail.table.heading.newvalue": "New Value",
  "audittrail.table.heading.oldvalue": "Old Value",
  "audittrail.table.heading.time": "Time",
  "audittrail.table.heading.user": "User",
  "audittrail.table.title.patientResults": "Patient Results",
  "availabletests.title": "Available Tests",
  "availabletests.none": "Every orderable test of the existing samples is already on this order.",
  "back.action.button": "Back",
  "banner.menu.administration": "Admin",
  "banner.menu.alerts": "Alerts",
  "banner.menu.alerts.tooltip": "Alerts and quality assurance dashboard",
  "banner.menu.aliquot": "Aliquot",
  "banner.menu.aliquot.tooltip": "Sample Aliquot",
  "banner.menu.billing": "Billing",
  "banner.menu.billing.tooltip": "Billing",
  "banner.menu.createDouble": "Double Entry",
  "banner.menu.createInitial": "Initial Entry",
  "banner.menu.eorders": "Incoming Orders",
  "banner.menu.eqa": "EQA",
  "banner.menu.eqa.distribution": "EQA Distributions",
  "banner.menu.eqa.distribution.tooltip": "Create and manage EQA distributions",
  "banner.menu.eqa.management": "EQA Schemes",
  "banner.menu.eqa.management.tooltip": "Create and manage EQA schemes",
  "banner.menu.eqa.mgmt": "EQA Management",
  "banner.menu.eqa.mgmt.distributions": "Distributions",
  "banner.menu.eqa.mgmt.distributions.tooltip": "Create and manage EQA distributions",
  "banner.menu.eqa.mgmt.participants": "Participants",
  "banner.menu.eqa.mgmt.participants.tooltip": "Manage organization enrollment in EQA schemes",
  "banner.menu.eqa.mgmt.programs": "Schemes",
  "banner.menu.eqa.mgmt.programs.tooltip": "Create and manage EQA schemes",
  "banner.menu.eqa.mgmt.results": "Results & Analysis",
  "banner.menu.eqa.mgmt.results.tooltip": "EQA results collection and statistical analysis",
  "banner.menu.eqa.mgmt.tooltip": "Manage EQA schemes, participants, and distributions",
  "banner.menu.eqa.tests": "EQA Tests",
  "banner.menu.eqa.tests.myPrograms": "My EQA Schemes",
  "banner.menu.eqa.tests.myPrograms.tooltip": "Manage self-enrollment in external EQA schemes",
  "banner.menu.eqa.tests.orders": "Orders",
  "banner.menu.eqa.tests.orders.tooltip": "View and manage EQA test orders",
  "banner.menu.eqa.tests.tooltip": "EQA test orders and scheme enrollment",
  "banner.menu.eqa.tooltip": "External Quality Assurance",
  "banner.menu.generic.sample": "Generic Sample",
  "banner.menu.generic.sample.edit": "Edit Order",
  "banner.menu.generic.sample.import": "Import Samples",
  "banner.menu.generic.sample.order": "Create Order",
  "banner.menu.generic.sample.results": "Enter Results",
  "banner.menu.help": "Help",
  "banner.menu.help.about": "Video Tutorials",
  "banner.menu.help.contact": "Release Notes",
  "banner.menu.help.documents": "Process Documentation",
  "banner.menu.help.formDBS": "DBS Form",
  "banner.menu.help.formVL": "VL Form",
  "banner.menu.help.usermanual": "User Manual",
  "banner.menu.home": "Home",
  "banner.menu.inventory": "Inventory",
  "banner.menu.inventory.catalog": "Manage Catalog",
  "banner.menu.inventory.dashboard": "Dashboard",
  "banner.menu.inventory.list": "Inventory Items",
  "banner.menu.inventory.reports": "Reports",
  "banner.menu.nonconformity": "Non-Conform",
  "banner.menu.nonconformity.correctiveActions": "Corrective actions",
  "banner.menu.nonconformity.dashboard": "All NCEs",
  "banner.menu.nonconformity.report": "Report Non-Conforming Event",
  "banner.menu.nonconformity.view": "View New Non-Conforming Events",
  "banner.menu.patient": "Patient",
  "banner.menu.patient.Create": "Study",
  "banner.menu.patient.addOrEdit": "Add/Edit Patient",
  "banner.menu.patient.merge": "Merge Patient",
  "banner.menu.patient.merge.tooltip": "Merge duplicate patient records",
  "banner.menu.patientConsult": "View",
  "banner.menu.patientEdit": "Edit",
  "banner.menu.patienthistory": "Patient History",
  "banner.menu.printBarcode": "Barcode",
  "banner.menu.referredOut": "Referred Out",
  "banner.menu.report.validation.backlog": "Delayed Validation",
  "banner.menu.reports": "Reports",
  "banner.menu.reports.routine": "Routine",
  "banner.menu.reports.study": "Study",
  "banner.menu.results": "Results",
  "banner.menu.results.CobasIntegra400": "Biochemistry: Cobas Integra 400+",
  "banner.menu.results.FacsCalibur": "Immunology: FacsCalibur",
  "banner.menu.results.FacsCantoII": "Immunology: FacsCantoII",
  "banner.menu.results.FacsPrestoanalyzer": "Immunology: FacsPresto",
  "banner.menu.results.Fullyanalyzer": "Biochemestry: Fully analyzer importer",
  "banner.menu.results.GeneXpertAnalyzer": "GeneXpertAnalyzer",
  "banner.menu.results.GeneXpertanalyzer": "GeneXpertFileAnalyzer",
  "banner.menu.results.PocH100iAnalyzer": "PocH100iAnalyze",
  "banner.menu.results.SysmeXT": "Hematology: SysmeXT 2000i",
  "banner.menu.results.SysmexXNLAnalyzer": "SysmexXNLAnalyzer",
  "banner.menu.results.SysmexXNLanalyzer": "SysmexXNL Analyzer",
  "banner.menu.results.SysmexXPAnalyzer": "SysmexXPAnalyzer",
  "banner.menu.results.SysmexXPanalyzer": "SysmexXP Analyzer",
  "banner.menu.results.accession": "By Order",
  "banner.menu.results.analyzer": "Analyzer",
  "banner.menu.results.cobasc111analyzer": "Biochemistry: Cobas C111",
  "banner.menu.results.genexpertanalyzer": "GeneXpert",
  "banner.menu.results.logbook": "By Unit",
  "banner.menu.results.mindrayanalyzer": "Mindray",
  "banner.menu.results.order.programmes": "Order Programs",
  "banner.menu.results.patient": "By Patient",
  "banner.menu.results.quantstudio3analyzer": "QuantStudio 3",
  "banner.menu.results.status": "By Test, Date or Status",
  "banner.menu.results.sysmexanalyzer": "Hematology: Sysmex XT 2000 i",
  "banner.menu.results.sysmexxtanalyzer": "Hematology: Sysmex XT analyzer importer",
  "banner.menu.results.taqman48dbsanalyzer": "Virologie: Cobas TaqMan48 DNA PCR",
  "banner.menu.results.testdate": "By Test Date",
  "banner.menu.results.unified": "Results Entry",
  "banner.menu.results.unified.tooltip": "Unified results entry worklist",
  "banner.menu.results.weber": "Weber 4000",
  "banner.menu.resultvalidation": "Validation",
  "banner.menu.resultvalidation.bacteria": "Bacteria",
  "banner.menu.resultvalidation.bench": "By Bench",
  "banner.menu.resultvalidation.biochemistry": "Biochemistry",
  "banner.menu.resultvalidation.cytobacteriology": "Cytobacteriology",
  "banner.menu.resultvalidation.dnapcr": "DNA PCR",
  "banner.menu.resultvalidation.ecbu": "ECBU",
  "banner.menu.resultvalidation.endocrinologie": "Endocrinology",
  "banner.menu.resultvalidation.genotyping": "Genotyping",
  "banner.menu.resultvalidation.hemato-immunology": "Hemato-Immunology",
  "banner.menu.resultvalidation.hematology": "Hematology",
  "banner.menu.resultvalidation.immunology": "Immunology",
  "banner.menu.resultvalidation.immunology.Haiti": "Immunology-Virology",
  "banner.menu.resultvalidation.immunologyHematology": "Immunology - Hematology",
  "banner.menu.resultvalidation.liquidBio": "Liquid Biology",
  "banner.menu.resultvalidation.malaria": "Malaria",
  "banner.menu.resultvalidation.molecularBio": "Molecular Biology",
  "banner.menu.resultvalidation.mycobacteriology": "Mycobacteriology",
  "banner.menu.resultvalidation.mycology": "Mycology",
  "banner.menu.resultvalidation.parasitology": "Parasitology",
  "banner.menu.resultvalidation.serology": "Serology",
  "banner.menu.resultvalidation.serology-immunology": "Serology-Immunology",
  "banner.menu.resultvalidation.viralload": "Viral Load",
  "banner.menu.resultvalidation.virology": "Virology",
  "banner.menu.resultvalidation_routine": "Routine",
  "banner.menu.resultvalidation_study": "Study",
  "banner.menu.sample": "Order",
  "banner.menu.sample.shipment": "Sample Shipment",
  "banner.menu.sampleAdd": "Add Order",
  "banner.menu.sampleBatchEntry": "Batch Order Entry",
  "banner.menu.sampleConsult": "View",
  "banner.menu.sampleCreate": "Study",
  "banner.menu.sampleEdit": "Edit Order",
  "banner.menu.sampleManagement": "Sample Management",
  "banner.menu.sampleManagement.tooltip": "Sample Management Menu",
  "banner.menu.storage": "Storage",
  "banner.menu.storage.tooltip": "Sample Storage Management",
  "banner.menu.study.eorders": "Electronic Orders",
  "banner.menu.workplan": "Workplan",
  "banner.menu.workplan.batch": "Batch Workplan",
  "banner.menu.workplan.batch.tooltip": "Batch Workplan",
  "banner.menu.workplan.bench": "By Unit",
  "banner.menu.workplan.panel": "By Panel",
  "banner.menu.workplan.priority": "By Priority",
  "banner.menu.workplan.test": "By Test Type",
  "banner.menu.workplan.unit": "By Test Section",
  "barcode.additionalInvalidLevels.message": "The barcode contains levels beyond the valid portion. Only valid levels are pre-filled.",
  "barcode.additionalInvalidLevels.warning": "Additional invalid levels detected",
  "barcode.autoOpenForm": "Opening location form with valid hierarchy",
  "barcode.debounce.warning": "Please wait before scanning another barcode",
  "barcode.error": "Invalid barcode",
  "barcode.firstMissingLevel": "First missing level: {level}",
  "barcode.format": "Barcode Format",
  "barcode.header": "Barcode(s)",
  "barcode.invalidFormat": "Invalid barcode format. Expected: ROOM-DEVICE or ROOM-DEVICE-SHELF-RACK-POSITION",
  "barcode.label.block": "Block label",
  "barcode.label.freezer": "Freezer label",
  "barcode.label.helper.text": "Enter values in: mm",
  "barcode.label.order": "Order label",
  "barcode.label.slide": "Slide label",
  "barcode.label.specimen": "Specimen label",
  "barcode.label.info.blockCaseNumber": "Block Case Number",
  "barcode.label.info.blockId": "Block ID",
  "barcode.label.info.blockNumber": "Block Number",
  "barcode.label.info.boxid": "Box ID",
  "barcode.label.info.caseNumber": "Case Number",
  "barcode.label.info.collectedBy": "Collected By",
  "barcode.label.info.collectionDate": "Collection Date",
  "barcode.label.info.collectionDateTime": "Collection Date and Time",
  "barcode.label.info.created": "Created",
  "barcode.label.info.destination": "Destination",
  "barcode.label.info.expiryDate": "Expiry Date",
  "barcode.label.info.labNumber": "Accession number",
  "barcode.label.info.patientDobFull": "Patient Date of Birth",
  "barcode.label.info.patientId": "Patient ID",
  "barcode.label.info.patientName": "Patient Name",
  "barcode.label.info.patientSexFull": "Patient Sex",
  "barcode.label.info.samplecount": "Samples",
  "barcode.label.info.siteId": "Site ID",
  "barcode.label.info.slideId": "Slide ID",
  "barcode.label.info.slideNumber": "Slide Number",
  "barcode.label.info.specimenType": "Specimen Type",
  "barcode.label.info.stainType": "Stain Type",
  "barcode.label.info.storageLocation": "Storage Location",
  "barcode.label.info.temperature": "Temperature",
  "barcode.label.info.tests": "Tests",
  "barcode.labels.order.row": "Order labels",
  "barcode.labels.running.total": "Running total",
  "barcode.labels.sample.row": "Specimen labels sample {sampleNumber}",
  "barcode.labels.section.title": "Label quantities",
  "barcode.locationNotFound": "Location not found",
  "barcode.notification.save": "BarCode Configurations has been saved.",
  "barcode.partialMatch": "Partial match - some components valid",
  "barcode.print.button": "Print",
  "barcode.print.labels.title": "Labels for this order",
  "barcode.print.all.button": "Print all",
  "barcode.print.all.saved": "Prints every label saved with this order at its saved quantity.",
  "barcode.print.all.legacy": "Prints {orderCount, plural, one {# order label} other {# order labels}} and {specimenCount, plural, one {# label} other {# labels}} per specimen.",
  "barcode.print.col.label": "Label",
  "barcode.print.col.accession": "Accession Number",
  "barcode.print.col.info": "Additional Info",
  "barcode.print.col.quantity": "Number to Print",
  "barcode.print.quantity.for": "Number of labels to print for {label}",
  "barcode.print.size": "{height} × {width} mm",
  "barcode.print.max.hint": "Up to {max}",
  "barcode.print.max.total": "Up to {max} in total, counting earlier prints",
  "barcode.print.row.button": "Print {label}",
  "error.labels.quantity.max": "A quantity above the preset maximum needs the label override.",
  "error.labels.quantity.min": "Print at least one label.",
  "barcode.print.dialog.quantityFor": "Quantity to print for {label}",
  "barcode.print.dialog.title": "Print labels",
  "barcode.print.done": "Done",
  "barcode.print.later": "Skip — Print Later",
  "barcode.print.preprint": "Pre-Print Barcodes",
  "barcode.print.preprint.button": "Pre-Print Labels",
  "barcode.print.preprint.note": "NOTE: If a facility and/or sample and test are added, they will be printed on EVERY label",
  "barcode.print.skip": "Skip",
  "barcode.print.title": "Print Bar Code Labels",
  "barcode.ready": "Ready to scan",
  "barcode.scan": "Scan barcode",
  "barcode.scan.error": "Order not found",
  "barcode.scan.placeholder": "Scan barcode or enter lab number...",
  "barcode.scan.success": "Order loaded successfully",
  "barcode.scanning": "Scanning...",
  "barcode.scanOrType": "Scan barcode or type location",
  "barcode.success": "Location found",
  "barcode.validHierarchyPrefilled": "Valid hierarchy levels pre-filled",
  "barcode.validation.altPrefix": "Input should be alphanumeric and have a maximum length of 4 characters.",
  "barcode.validationFailed": "Barcode validation failed",
  "barcodeconfiguration.browse.title": "Barcode Configuration",
  "breadcrumb.home": "Home",
  "breadcrumb.caseView": "Case View",
  "breadcrums.admin.managment": "Admin Management",
  "calendar.management.title": "Calendar Management",
  "calendar.management.description": "Manage public holidays and weekend configuration for working time TAT calculations",
  "calendar.management.addHoliday": "Add Holiday",
  "calendar.management.editHoliday": "Edit Holiday",
  "calendar.management.deleteConfirm": "Are you sure you want to delete this holiday?",
  "calendar.management.holidayName": "Holiday Name",
  "calendar.management.date": "Date",
  "calendar.management.recurring": "Recurring",
  "calendar.management.annual": "Annual",
  "calendar.management.oneTime": "One-time",
  "calendar.management.active": "Active",
  "calendar.management.inactive": "Inactive",
  "calendar.management.weekend": "Weekend",
  "calendar.management.weekendDays": "Weekend Days (excluded from Working Time)",
  "calendar.management.weekendSaved": "Weekend configuration saved",
  "calendar.management.importCsv": "Import CSV",
  "calendar.management.exportCsv": "Export CSV",
  "calendar.management.importPreview": "Import Preview",
  "calendar.management.year": "Year",
  "calendar.management.noHolidays": "No holidays configured for {year}. Click \"Add Holiday\" to get started.",
  "calendar.management.duplicateDate": "A holiday already exists for this date",
  "calendar.management.imported": "{count} holidays imported",
  "calendar.management.skipped": "{count} holidays skipped",
  "calendar.management.holidayCount": "{count} holidays configured for {year}",
  "calendar.management.saveError": "Error saving holiday",
  "calendar.management.loadError": "Error loading holidays",
  "calendar.management.save": "Save",
  "calendar.management.cancel": "Cancel",
  "calendar.management.actions": "Actions",
  "calendar.management.status": "Status",
  "calendar.management.column.date": "Date",
  "calendar.management.column.holidayName": "Holiday Name",
  "calendar.management.column.recurring": "Recurring",
  "calendar.management.column.status": "Status",
  "calendar.management.column.actions": "Actions",
  "calendar.management.day.sun": "Sun",
  "calendar.management.day.mon": "Mon",
  "calendar.management.day.tue": "Tue",
  "calendar.management.day.wed": "Wed",
  "calendar.management.day.thu": "Thu",
  "calendar.management.day.fri": "Fri",
  "calendar.management.day.sat": "Sat",
  "calendar.management.chooseFile": "Choose CSV file",
  "calendar.management.csvColumns": "Columns: date, name, recurring (true/false)",
  "calendar.management.rowsFound": "{count} rows found",
  "calendar.management.column.csvDate": "Date",
  "calendar.management.column.csvName": "Name",
  "calendar.management.column.csvRecurring": "Recurring",
  "calendar.management.importing": "Importing...",
  "caseView.action.discard": "Discard changes",
  "caseView.action.saveDraft": "Save draft",
  "caseView.action.showDeactivated": "Show deactivated",
  "caseView.banner.unsavedChanges": "This case has unsaved changes. Leave the page and lose them?",
  "caseView.badge.deactivated": "Deactivated",
  "caseView.badge.notApplicable": "N/A",
  "caseView.badge.readOnly": "Read only",
  "caseView.label.assignedStaff": "{role}: {name}",
  "caseView.label.caseProgress": "Case progress",
  "caseView.label.caseSummary": "Case summary",
  "caseView.label.numberedSection": "{number}. {title}",
  "caseView.label.notRecorded": "— not recorded",
  "caseView.label.unsavedChanges": "Unsaved changes",
  "caseView.locked.awaitingStage": "Available once the case reaches {stage}",
  "caseView.locked.prerequisite": "Available once this case's earlier steps are complete",
  "column.qc.accession": "QC Sample",
  "column.qc.detail": "Detail",
  "column.qc.result": "Result",
  "column.qc.test": "Test",
  "column.qc.type": "Type",
  "compliance.dashboard.chart.comparison.title": "Site Comparison — Current Period Compliance %",
  "compliance.dashboard.chart.drilldown.title": "Site Drill-Down — Per-Parameter Trend",
  "compliance.dashboard.chart.trend.title": "Compliance Rate Trend — All Sites",
  "compliance.dashboard.descriptive.excluded": "Descriptive parameters excluded from trend chart",
  "compliance.dashboard.drilldown.placeholder": "Select a site…",
  "compliance.dashboard.empty": "No data matches the selected filters",
  "compliance.dashboard.export.pdf": "Export PDF",
  "compliance.dashboard.filter.allStandards": "All Standards",
  "compliance.dashboard.filter.dateRange": "Date Range",
  "compliance.dashboard.filter.dateRangeEnd": "End date",
  "compliance.dashboard.filter.drilldownSite": "Drill down by site",
  "compliance.dashboard.filter.sites": "Sampling Sites",
  "compliance.dashboard.filter.sites.placeholder": "All sites",
  "compliance.dashboard.filter.standard": "Compliance Standard",
  "compliance.dashboard.kpi.complianceRate": "Compliance Rate",
  "compliance.dashboard.kpi.exceedances": "Total Exceedances",
  "compliance.dashboard.kpi.sitesMonitored": "Sites Monitored",
  "compliance.dashboard.kpi.totalOrders": "Total Orders",
  "compliance.dashboard.loading.comparison": "Loading comparison…",
  "compliance.dashboard.loading.drilldown": "Loading drill-down…",
  "compliance.dashboard.loading.exceedances": "Loading exceedances…",
  "compliance.dashboard.loading.generating": "Generating…",
  "compliance.dashboard.loading.trend": "Loading trend…",
  "compliance.dashboard.lowData": "Low data (< 3 orders)",
  "compliance.dashboard.status.fail": "FAIL",
  "compliance.dashboard.table.col.date": "Date",
  "compliance.dashboard.table.col.labNumber": "Lab #",
  "compliance.dashboard.table.col.parameter": "Parameter",
  "compliance.dashboard.table.col.result": "Result",
  "compliance.dashboard.table.col.site": "Site",
  "compliance.dashboard.table.col.status": "Status",
  "compliance.dashboard.table.col.threshold": "Threshold",
  "compliance.dashboard.table.exceedances.title": "Exceedance Summary",
  "compliance.dashboard.title": "Environmental Compliance Dashboard",
  "error.referOut.emailFormat": "Enter a valid email address (e.g. lab@example.org).",
  "error.referOut.handoffRequiredForDispatch": "Handoff Date/Time is required to dispatch.",
  "error.referOut.maxLength": "Maximum {max} characters.",
  "error.referOut.phoneFormat": "Enter a valid phone number with country code prefix (e.g. +62 812 3456 7890).",
  "error.referOut.referringLabRequired": "Select a reference lab.",
  "error.validation.qc.ackFailed": "Failed to record QC acknowledgment. Please try again.",
  "holding.time.exceeded.message": "The SOP max holding time has been exceeded for: {tests}",
  "holding.time.exceeded.note": "WARNING: Result entered after SOP max holding time was exceeded.",
  "holding.time.exceeded.title": "Holding Time Exceeded",
  "label.button.edit.details": "Edit details",
  "label.expand.poolDetails": "Expand pool details",
  "label.pool.collapse": "Hide individual specimens",
  "label.pool.expand": "Show individual specimens",
  "label.pool.expansion.next": "Next",
  "label.pool.expansion.page": "Page {page} of {total}",
  "label.pool.expansion.prev": "Previous",
  "label.pool.expansion.title": "{animal} specimens ({count})",
  "label.qc.fail": "Fail",
  "label.qc.pass": "Pass",
  "label.referOut.action.dispatch": "Dispatch",
  "label.referOut.action.edit": "Edit",
  "label.referOut.action.referOut": "Refer Out",
  "label.referOut.action.save": "Save Referral",
  "label.referOut.action.view": "View",
  "label.referOut.column.actions": "Actions",
  "label.referOut.column.referringLab": "Reference lab",
  "label.referOut.column.sampleId": "Sample ID",
  "label.referOut.column.sampleType": "Sample Type",
  "label.referOut.column.status": "Subcontract Status",
  "label.referOut.column.tests": "Tests",
  "label.referOut.dispatch.error": "Failed to dispatch referral.",
  "label.referOut.dispatch.notSaved": "Save the referral before dispatching.",
  "label.referOut.dispatch.success": "Referral dispatched.",
  "label.referOut.empty.subtitle": "Samples appear here once they are saved. Save the order first to refer specimens out.",
  "label.referOut.empty.title": "No samples available for referral",
  "label.referOut.field.agreementReference": "Agreement Reference",
  "label.referOut.field.cocContactEmail": "Chain-of-Custody Contact Email",
  "label.referOut.field.cocContactEmail.placeholder": "lab@example.org",
  "label.referOut.field.cocContactName": "Chain-of-Custody Contact Name",
  "label.referOut.field.cocContactPhone": "Chain-of-Custody Contact Phone",
  "label.referOut.field.cocContactPhone.placeholder": "+62 812 3456 7890",
  "label.referOut.field.expectedReturnDate": "Expected Return Date",
  "label.referOut.field.handoffDate": "Handoff Date",
  "label.referOut.field.handoffDatetime": "Handoff Date/Time",
  "label.referOut.field.handoffTime": "Handoff Time",
  "label.referOut.field.handoffTime.placeholder": "HH:mm",
  "label.referOut.field.notes": "Notes",
  "label.referOut.field.referringLab": "Reference lab",
  "label.referOut.field.referringLab.placeholder": "Select a reference lab",
  "label.referOut.save.error": "Failed to save referral.",
  "label.referOut.save.success": "Referral saved.",
  "label.referOut.section.description": "Refer specimens to an external lab. Each sample carries its full chain-of-custody metadata.",
  "label.referOut.section.title": "Refer Out / Subcontract",
  "label.referOut.status.cancelled": "Cancelled",
  "label.referOut.status.closed": "Closed",
  "label.referOut.status.completed": "Completed",
  "label.referOut.status.dispatched": "Dispatched",
  "label.referOut.status.draft": "Draft",
  "label.referOut.status.inProgress": "In progress",
  "label.referOut.status.notReferred": "In-house",
  "label.referOut.status.received": "Received",
  "label.referOut.status.rejected": "Rejected",
  "label.referOut.status.requested": "Requested",
  "label.referOut.status.resultsReturned": "Results Returned",
  "label.referOut.field.reason": "Reason",
  "label.referOut.field.reason.placeholder": "Select a reason (optional)",
  "label.referOut.action.referOutAll": "Refer out all in-house samples",
  "label.referOut.status.pendingSave": "Pending save",
  "label.referOut.staged.success": "Staged for {count} sample(s). The referral is saved with this step's Save.",
  "order.status.referredOut": "Referred out",
  "order.referral.partial": "{referred} of {total} tests referred to {lab}",
  "order.referral.fully": "All {total} tests referred to {lab}",
  "label.sampleKind.blank": "BLANK",
  "label.sampleKind.client": "Client sample",
  "label.sampleKind.control": "CONTROL",
  "label.sampleKind.duplicate": "DUPLICATE",
  "label.sampleKind.qc": "QC",
  "label.validation.qc.ack.checkbox": "I have reviewed the QC failures and assessed their impact on the result release",
  "label.validation.qc.ack.heading": "Required Acknowledgment",
  "label.validation.qc.banner.subtitle": "Review and acknowledge below before releasing results.",
  "label.validation.qc.banner.title": "QC failures detected — {count} QC sample(s) failed acceptance criteria",
  "label.validation.qc.failedSamples": "Failed QC Samples",
  "label.validation.qc.justification": "Justification",
  "label.validation.checkBeforeRelease": "Check before release",
  "label.validation.triage.filterLabel": "Filter by signal",
  "label.validation.filter.all": "All",
  "label.validation.filter.needsReview": "Needs review",
  "label.validation.filter.nce": "NCE",
  "label.validation.filter.qcFail": "QC fail",
  "label.validation.filter.modified": "Modified",
  "label.validation.filter.ackPending": "Ack pending",
  "label.validation.search.box": "Lab number",
  "label.validation.search.rangeHint": "A range: A..B, or A.. for A onwards",
  "label.validation.search.fromDate": "From",
  "label.validation.search.toDate": "To",
  "label.validation.search.loadError": "The validation queue could not be loaded.",
  "label.validation.filter.critical": "Critical",
  "label.validation.filter.abnormal": "Abnormal",
  "label.validation.lane.clear": "Clear",
  "label.validation.lane.needsReview": "Needs review",
  "label.validation.signal.nce": "NCE open",
  "label.validation.signal.qcFail": "QC fail",
  "label.validation.signal.modified": "Modified",
  "label.validation.signal.ackPending": "Ack pending",
  "label.validation.signal.nonconforming": "Nonconforming",
  "label.validation.signal.critical": "Critical",
  "label.validation.review.result": "Result",
  "label.validation.review.units": "Units",
  "label.validation.review.normalRange": "Reference range",
  "label.validation.review.criticalRange": "Critical range",
  "label.validation.review.method": "Method",
  "label.validation.review.analyzer": "Analyzer",
  "label.validation.review.performedAt": "Performed at",
  "label.validation.review.enteredBy": "Entered by",
  "label.validation.review.enteredDate": "Entered on",
  "label.validation.review.collected": "Collected",
  "label.validation.review.qc": "QC",
  "label.validation.review.qc.PASS": "QC passed",
  "label.validation.review.qc.FAIL": "QC failed",
  "label.validation.review.notRecorded": "Not recorded",
  "label.validation.review.beforeRelease": "Before releasing, check:",
  "label.validation.review.components": "Components",
  "label.validation.review.component": "Component",
  "label.validation.review.flag": "Flag",
  "label.validation.review.primary": "Primary",
  "label.validation.review.reference": "Reference",
  "label.validation.review.notes": "Notes",
  "label.validation.review.notes.summary": "{count} notes",
  "label.validation.review.notes.empty": "No notes yet",
  "label.validation.review.notes.add": "Validation note",
  "label.validation.review.notes.placeholder": "Add a validation note…",
  "label.validation.review.notes.visibility": "Visibility",
  "label.validation.review.notes.internal": "Internal",
  "label.validation.review.notes.external": "Send with result",
  "label.validation.review.notes.externalWarning": "This note will appear on the patient report.",
  "label.validation.review.notes.contextHint": "Context: Validation (recorded automatically).",
  "label.validation.review.notes.context.result": "Result note",
  "label.validation.review.modify.reason": "Reason for modification",
  "label.validation.review.modify.reasonRequired": "A reason is required to modify a result.",
  "label.validation.review.modify.newValue": "New result",
  "label.validation.review.modify.notEditable": "This result type is edited on the Results Entry page.",
  "label.validation.review.qcSection": "QC",
  "label.validation.review.reagents.followUp": "Reagent and control lots for this analysis are reviewed on the Results Entry page.",
  "label.validation.review.action.release": "Validate & release",
  "label.validation.review.action.modify": "Modify result",
  "label.validation.review.action.saveModification": "Save modification",
  "label.validation.review.action.cancel": "Cancel",
  "label.validation.review.action.refer": "Refer this test",
  "label.validation.review.release.qcAckFirst": "Acknowledge the failed QC below before releasing.",
  "label.validation.review.error.notAwaitingValidation": "This result changed since the page loaded. Reload and review it again.",
  "label.validation.review.error.qcAcknowledgmentRequired": "Failed QC in this batch must be acknowledged before release.",
  "label.validation.review.error.modificationReasonRequired": "A reason is required to modify a result.",
  "label.validation.review.error.modifyRoleRequired": "Your role does not permit modifying results.",
  "label.validation.review.error.resultRequired": "Enter a result value before saving.",
  "label.validation.review.error.invalidResult": "The result is incomplete; check the qualified value.",
  "label.validation.review.error.generic": "The action could not be completed.",
  "label.validation.review.success.released": "Result validated and released.",
  "label.validation.review.success.accepted": "Component validated. The test is released once its other components are validated.",
  "label.validation.review.success.modified": "Result modified. It stays in the validation queue.",
  "esig.context.validateSingle": "Validate and release {test} for accession {accession}",
  "label.validation.bulk.releaseAllClear": "Release all clear ({count})",
  "label.validation.bulk.heading": "Release all clear results",
  "label.validation.bulk.bodyClear": "{count, plural, one {This # result is} other {These # results are}} in the Clear lane: in range, no recorded QC failure, no non-conformity, not modified, not critical. A result that stops being clear before the release is skipped.",
  "label.validation.bulk.bodyEsig": "Releasing commits one e-signature for the whole set.",
  "label.validation.bulk.disabled": "Bulk release is turned off for this laboratory.",
  "label.validation.emptyState.signals": "{count} results in this queue carry something to check before release.",
  "label.validation.emptyState.signalsDetail": "Most common: {signals}.",
  "label.validation.emptyState.noReference": "{count} results are for tests with no reference value recorded in the test catalogue, so they cannot be judged as normal.",
  "label.validation.emptyState.noReferenceHint": "Record an expected normal value for these tests in the Test Catalogue to let their results clear.",
  "label.validation.emptyState.rangeNotApplied": "{count} results had no reference range applied because patient sex or age is not recorded. Review them one by one, or record the missing value on the patient.",
  "label.validation.emptyState.queueEmpty": "Nothing is waiting for validation.",
  "label.validation.release.scope": "Clearance checks the reference range, result flags, non-conformities, edits after save and critical acknowledgment, and stops any result with a recorded quality-control failure. It does not confirm that quality control was performed.",
  "label.validation.bulk.none": "No clear results to release.",
  "label.validation.bulk.column.accession": "Lab No.",
  "label.validation.bulk.success": "{count} clear result(s) released.",
  "label.validation.bulk.partial": "{released} released; {skipped} skipped because they were no longer clear.",
  "label.validation.bulk.error.bulkReleaseDisabled": "Bulk release is turned off for this laboratory.",
  "label.validation.bulk.error.qcAcknowledgmentRequired": "Failed QC in this batch must be acknowledged before release.",
  "label.validation.bulk.error.nothingReleased": "None of the selected results is still clear; nothing was released.",
  "label.validation.bulk.error.generic": "The bulk release could not be completed.",
  "label.validation.review.action.review": "Review →",
  "esig.context.releaseAllClear": "Release {count} clear result(s) for {accession}",
  "instructions.validation.bulk.release": "When enabled, the Validation page offers \"Release all clear\", which releases only results in the Clear lane (in range, no recorded QC failure, no signals) under one e-signature. Disable to require every result to be released individually after review.",
  "instructions.validation.retest.note": "When enabled, a validator sending a result back for retest must write a note for the bench.",
  "label.validation.review.action.retest": "Send for retest",
  "label.validation.review.action.reject": "Reject (file NCE)",
  "label.validation.review.retest.note": "Note for the bench",
  "label.validation.review.retest.noteRequired": "A note is required to send a result for retest.",
  "label.validation.review.retest.hint": "The result goes back to Results Entry and the pipeline restarts at level 1.",
  "label.validation.review.reject.hint": "Rejecting files a non-conformity event; complete the form to record it.",
  "label.validation.review.reject.disabled": "Result rejection is turned off for this laboratory.",
  "label.validation.review.error.stale": "This result was changed by {who} at {when}. Reloading the queue…",
  "label.validation.review.error.retestNoteRequired": "A note is required to send a result for retest.",
  "label.validation.review.error.rejectionDisabled": "Result rejection is turned off for this laboratory.",
  "label.validation.review.success.retest": "Result sent back for retest.",
  "label.validation.review.success.rejected": "Result rejected; the non-conformity event is recorded.",
  "label.validation.bulk.error.stale": "The queue changed while you were reviewing. Reloading…",
  "label.validation.autoValidated.toggle": "Include auto-validated",
  "label.validation.autoValidated.heading": "Auto-validated results ({count})",
  "label.validation.autoValidated.tag": "Auto-validated",
  "label.validation.autoValidated.empty": "No auto-validated results for this accession.",
  "label.validation.autoValidated.hint": "Released at result entry without a validator; shown for review only.",
  "label.validation.autoValidated.releasedOn": "Released on",
  "label.validation.signal.rangeNotApplied": "Range not applied",
  "result.rangeNotApplied.sexMissing": "Reference range not applied: patient sex not recorded",
  "result.rangeNotApplied.ageMissing": "Reference range not applied: patient age not recorded",
  "result.rangeNotApplied.sexAndAgeMissing": "Reference range not applied: patient sex and age not recorded",
  "laporanHasil.action.generatePdf": "Generate PDF",
  "laporanHasil.action.regeneratePdf": "Re-generate PDF",
  "laporanHasil.col.actions": "Actions",
  "laporanHasil.col.collectionDate": "Collection Date",
  "laporanHasil.col.compliance": "Compliance",
  "laporanHasil.col.labNumber": "Lab Number",
  "laporanHasil.col.lastGenerated": "Last Generated",
  "laporanHasil.col.site": "Site",
  "laporanHasil.col.standard": "Standard",
  "laporanHasil.col.tests": "Tests",
  "laporanHasil.detail.ambientTemp": "Ambient Temp",
  "laporanHasil.detail.collectionDateTime": "Collection Date/Time",
  "laporanHasil.detail.collectionMethod": "Collection Method",
  "laporanHasil.detail.complianceSummary": "Compliance Summary",
  "laporanHasil.detail.conditions": "Collection Conditions",
  "laporanHasil.detail.gps": "GPS",
  "laporanHasil.detail.labAnalyst": "Lab Analyst",
  "laporanHasil.detail.labManager": "Lab Manager",
  "laporanHasil.detail.parameter": "Parameter",
  "laporanHasil.detail.ppNo": "PP No.",
  "laporanHasil.detail.preservation": "Preservation",
  "laporanHasil.detail.result": "Result",
  "laporanHasil.detail.signatures": "Signatures",
  "laporanHasil.detail.site": "Site",
  "laporanHasil.detail.siteInfo": "Site Information",
  "laporanHasil.detail.standard": "Standard",
  "laporanHasil.detail.status": "Status",
  "laporanHasil.detail.threshold": "Threshold",
  "laporanHasil.detail.waterTemp": "Water Temp",
  "laporanHasil.detail.weather": "Weather",
  "laporanHasil.empty": "No orders found for the selected filters.",
  "laporanHasil.error": "Failed to load report. Please try again.",
  "laporanHasil.filter.all": "All",
  "laporanHasil.filter.allSites": "All Sites",
  "laporanHasil.filter.allStandards": "All Standards",
  "laporanHasil.filter.complianceStatus": "Compliance Status",
  "laporanHasil.filter.dateFrom": "Date From",
  "laporanHasil.filter.dateTo": "Date To",
  "laporanHasil.filter.generated": "Generated",
  "laporanHasil.filter.generationStatus": "Generation Status",
  "laporanHasil.filter.notGenerated": "Not Yet Generated",
  "laporanHasil.filter.samplingSite": "Sampling Site",
  "laporanHasil.filter.standard": "Compliance Standard",
  "laporanHasil.loading": "Loading compliance report...",
  "laporanHasil.status.borderline": "Borderline",
  "laporanHasil.status.compliant": "Compliant",
  "laporanHasil.status.ineligible": "No standard linked",
  "laporanHasil.status.nonCompliant": "Non-Compliant",
  "laporanHasil.status.none": "–",
  "laporanHasil.subtitle": "Generate compliance certificates for validated environmental orders",
  "laporanHasil.tile.generated": "Generated",
  "laporanHasil.tile.ineligible": "Ineligible",
  "laporanHasil.tile.ineligible.desc": "Not validated or no standard linked",
  "laporanHasil.tile.notGenerated": "Not Yet Generated",
  "laporanHasil.title": "Compliance Report",
  "lhu.amendment.error.generic": "Failed to reissue the report. Please try again.",
  "lhu.amendment.modal.description": "You are reissuing LHU for lab number {labNumber}. The reissued report will be identified as an amendment to the previously released certificate.",
  "lhu.amendment.modal.heading": "Reissue LHU with Amendment",
  "lhu.amendment.modal.submit": "Reissue & Download PDF",
  "lhu.amendment.reason.helper": "State why the original report is being amended (required for ISO 17025 §7.8.8 compliance).",
  "lhu.amendment.reason.label": "Amendment reason",
  "lhu.amendment.reason.placeholder": "e.g. Incorrect pH result — instrument was not calibrated",
  "lhu.amendment.reason.required": "Amendment reason is required",
  "lhu.amendment.reissue": "Reissue with Amendment",
  "lhu.amendment.submitting": "Reissuing…",
  "nce.close.error": "Failed to close NCE",
  "nce.close.success": "NCE closed successfully",
  "nce.correctiveAction.error": "Failed to advance NCE status",
  "nce.correctiveAction.success": "NCE moved to Corrective Action",
  "notificationtrigger.activetriggers.heading": "Active Triggers",
  "notificationtrigger.activetriggers.subtitle": "Each row controls one notification event type. Toggle On to activate. Channel and recipient settings only apply when the trigger is enabled.",
  "notificationtrigger.channel.email": "Email",
  "notificationtrigger.channel.sms": "SMS",
  "notificationtrigger.channel.whatsapp": "WhatsApp",
  "notificationtrigger.template.disallowed": "This message type cannot include {fields}. Use the merge fields listed under the template.",
  "notificationtrigger.column.channels": "Channels",
  "notificationtrigger.column.enabled": "Enabled",
  "notificationtrigger.column.eventcode": "Event Code",
  "notificationtrigger.column.override": "Per-Lab-Unit Override",
  "notificationtrigger.column.recipients": "Recipients",
  "notificationtrigger.column.trigger": "Trigger",
  "notificationtrigger.config.subtitle": "Enable or disable notification triggers, select delivery channels, and configure recipient types per event.",
  "notificationtrigger.config.title": "Notification Trigger Configuration",
  "notificationtrigger.disabled.hint": "Enable this trigger to configure its channels and recipients.",
  "notificationtrigger.override.comingsoon": "Per-lab-unit override is not available yet.",
  "notificationtrigger.override.configure": "Configure",
  "notificationtrigger.recipient.coccontact": "CoC Contact",
  "notificationtrigger.recipient.orderingprovider": "Ordering Provider",
  "notificationtrigger.recipient.submittinguser": "Submitting User",
  "notificationtrigger.referralout.defaultoff": "Defaults OFF — must be enabled explicitly.",
  "notificationtrigger.referralout.description": "Sent when a sample is referred to an external laboratory.",
  "notificationtrigger.referralout.firesoncenote": "Fires once per saved referral. If one order has referrals to two different labs, two notifications are sent.",
  "notificationtrigger.referralout.name": "Referral Out",
  "notificationtrigger.sentmessages.action.resend": "Resend",
  "notificationtrigger.sentmessages.action.viewlog": "View Log",
  "notificationtrigger.sentmessages.channel.failed": "failed",
  "notificationtrigger.sentmessages.channel.sent": "sent",
  "notificationtrigger.sentmessages.column.actions": "Actions",
  "notificationtrigger.sentmessages.column.channels": "Channels",
  "notificationtrigger.sentmessages.column.datetime": "Date / Time",
  "notificationtrigger.sentmessages.column.recipient": "Recipient",
  "notificationtrigger.sentmessages.column.reference": "Reference",
  "notificationtrigger.sentmessages.column.status": "Status",
  "notificationtrigger.sentmessages.column.type": "Type",
  "notificationtrigger.sentmessages.count": "{count} of {total} messages",
  "notificationtrigger.sentmessages.empty.heading": "No notifications have been sent yet.",
  "notificationtrigger.sentmessages.filter.status.all": "All Statuses",
  "notificationtrigger.sentmessages.filter.status.failed": "Failed",
  "notificationtrigger.sentmessages.filter.status.label": "Status",
  "notificationtrigger.sentmessages.filter.status.sent": "Sent",
  "notificationtrigger.sentmessages.filter.type.all": "All Types",
  "notificationtrigger.sentmessages.filter.type.label": "Type",
  "notificationtrigger.sentmessages.heading": "Sent Messages",
  "notificationtrigger.sentmessages.resend.disclaimer": "Resending replays the original message bytes and recipient address. To send to a different address, edit the patient record and trigger a new event.",
  "notificationtrigger.sentmessages.resend.failure": "Resend failed. See server logs for details.",
  "notificationtrigger.sentmessages.resend.success": "Notification resent.",
  "notificationtrigger.sentmessages.status.failed": "Failed",
  "notificationtrigger.sentmessages.status.sent": "Sent",
  "notificationtrigger.sentmessages.subtitle": "All outbound notifications dispatched by OpenELIS, across all trigger types and channels.",
  "notificationtrigger.sentmessages.viewlog.channels": "Channel Outcomes",
  "notificationtrigger.sentmessages.viewlog.column.attempts": "Attempts",
  "notificationtrigger.sentmessages.viewlog.column.channel": "Channel",
  "notificationtrigger.sentmessages.viewlog.column.error": "Error",
  "notificationtrigger.sentmessages.viewlog.column.status": "Status",
  "notificationtrigger.sentmessages.viewlog.heading": "Notification Log",
  "notificationtrigger.sentmessages.viewlog.message": "Message Body",
  "notificationtrigger.sentmessages.viewlog.subject": "Subject",
  "notificationtrigger.status.new": "NEW",
  "notificationtrigger.subcontractdispatched.description": "Sent when a sample has been physically dispatched to the receiving laboratory.",
  "notificationtrigger.subcontractdispatched.name": "Subcontract Dispatched",
  "notificationtrigger.tabs.sentmessages": "Sent Messages",
  "notificationtrigger.tabs.sentmessages.placeholder": "Sent messages — coming in a future milestone.",
  "notificationtrigger.tabs.templates": "Templates",
  "notificationtrigger.tabs.templates.placeholder": "Template editor — coming in a future milestone.",
  "notificationtrigger.tabs.triggers": "Triggers",
  "notificationtrigger.templates.body.help": "Free text with merge fields. This template is not managed by i18n — edit it directly.",
  "notificationtrigger.templates.body.label": "Message Body",
  "notificationtrigger.templates.button.reset": "Reset to Default",
  "notificationtrigger.templates.button.save": "Save Template",
  "notificationtrigger.templates.channel.help": "Each channel has its own template fields. Switch channels to edit separately.",
  "notificationtrigger.templates.channel.label": "Channel",
  "notificationtrigger.templates.heading": "Notification Template Configuration",
  "notificationtrigger.templates.mergefields.heading": "Available Merge Fields",
  "notificationtrigger.templates.mergefields.help": "Fields below are specific to the {eventCode} event. Click a field to insert it at the cursor position.",
  "notificationtrigger.templates.mergefields.optionalnote": "If [expectedReturn] is not set on the referral, it renders blank — no error.",
  "notificationtrigger.templates.preview.label": "Rendered Preview",
  "notificationtrigger.templates.referralout.description": "Sent to the customer contact (Ordering Provider) and/or internal staff (Submitting User) when a referral is saved.",
  "notificationtrigger.templates.subcontractdispatched.description": "Sent to the receiving lab's CoC contact and the customer when a sample is physically dispatched to the receiving laboratory.",
  "notificationtrigger.templates.subject.label": "Subject",
  "notificationtrigger.templates.subtitle": "Compose message templates for each notification event type. Templates are free text with merge fields.",
  "order.clinicalInfo.helper": "Optional context to guide test selection and reporting — not recorded as a confirmed diagnosis.",
  "order.complete.processing.description": "{labNumber} is now in {status} status and will appear in the V-03 Vector Identification worklist.",
  "order.complete.processing.description.plain": "{labNumber} is now in Processing status and will appear in the V-03 Vector Identification worklist.",
  "order.complete.processing.title": "Order Complete — Processing",
  "order.context.poolOf": "Pool of {count} {animal}",
  "order.paymentStatus.helper": "How payment will be handled for this order.",
  "order.priority.helper": "ROUTINE: standard turnaround. STAT: process immediately.",
  "order.referral.sampleType.ambiguous": "This referred order requested {items}, but the sample type could not be determined automatically. Please select a sample type below and choose the requested test(s).",
  "order.requester.section.helper": "Select the facility that ordered the tests and the responsible provider.",
  "panel.domain.clinical": "Clinical",
  "panel.domain.environmental": "Environmental",
  "panel.domain.eqa": "EQA",
  "panel.domain.vector": "Vector",
  "panel.filter.domain": "Domain",
  "panel.organism.flea": "Flea",
  "panel.organism.fly": "Fly",
  "panel.organism.mosquito": "Mosquito",
  "panel.organism.rodent": "Rodent",
  "panel.organism.selectPlaceholder": "Select Organism Group",
  "panel.organism.tick": "Tick",
  "patient.search.section.helper": "Search by any combination of fields. Names match exactly or by their first letters. 'External Search' queries the Client Registry and requires at minimum a name and date of birth.",
  "placeholder.validation.qc.justification": "Required (max 500 chars)",
  "provider.add.new": "+ Add new provider \"{name}\"",
  "providerTitle.abbreviation": "Abbreviation",
  "providerTitle.add": "Add Title",
  "providerTitle.confirm.activate": "Activate \"{title}\"?",
  "providerTitle.confirm.activate.body": "It will be offered again when choosing a provider's title.",
  "providerTitle.confirm.deactivate": "Deactivate \"{title}\"?",
  "providerTitle.confirm.deactivate.body": "It will no longer be offered for new selections. The {count} provider(s) already carrying it keep it.",
  "providerTitle.duplicate": "\"{value}\" is already in the list",
  "providerTitle.edit": "Edit Title",
  "providerTitle.edit.warning": "Changing a title changes how it displays on every provider using it.",
  "providerTitle.empty": "No provider titles are configured yet.",
  "providerTitle.filter.status": "Status",
  "providerTitle.filter.status.active": "Active",
  "providerTitle.filter.status.all": "All",
  "providerTitle.filter.status.inactive": "Inactive",
  "providerTitle.inUse": "In use",
  "providerTitle.search": "Search titles",
  "providerTitle.sortOrder": "Sort order",
  "providerTitle.summary": "{total} title(s): {active} active, {inactive} inactive.",
  "providerTitle.title": "Title",
  "providerTitle.titles": "Provider Titles",
  "provider.email.field": "Provider Email",
  "provider.fax.field": "Provider Fax",
  "provider.title.field": "Title",
  "provider.title.inName": "That looks like a title. Consider moving it to the Title field so lists sort by surname.",
  "provider.title.filter": "Filter by title",
  "provider.title.filter.all": "All titles",
  "provider.title.placeholder": "Select a title...",
  "provider.firstName.field": "First Name",
  "provider.lastName.field": "Last Name",
  "provider.new.helper": "Will be created as a new provider when this order is saved.",
  "provider.new.tag": "New",
  "provider.no.match": "No matching provider found.",
  "provider.phone.field": "Phone",
  "qc.add.blank": "+ Blank QC",
  "qc.add.control": "+ Control QC",
  "qc.add.duplicate": "+ Duplicate QC",
  "qc.collect.inheritsFromParent": "Collection details inherited from parent sample",
  "qc.expectedValue.placeholder": "e.g. 50.0",
  "qc.samples.label": "QC samples:",
  "qc.samples.numericOnly": "QC is currently supported only for tests with numeric results. The selected tests are coded — pick a numeric test to attach QC.",
  "qc.samples.thresholdsMissing": "Configure QC thresholds for {tests} in Administration → Test Configuration before adding QC samples.",
  "qc.status.current": "Current QC Status",
  "qc.status.failed.warning.message": "Lots that fail QC are excluded from testing and from stock available for use.",
  "qc.status.failed.warning.title": "This lot will not be usable",
  "qc.status.new": "New QC Status",
  "qc.status.notes": "QC Notes",
  "qc.status.notes.placeholder": "Reason for the QC result, test performed, or reference",
  "qc.type.blank": "QC: Blank",
  "qc.type.control": "QC: Control",
  "qc.type.duplicate": "QC: Duplicate",
  "referral.accept.error": "Could not accept the result. Please try again.",
  "referral.action.accept": "Accept",
  "referral.action.acceptToAnalysis": "Accept to Analysis",
  "referral.action.clearFilters": "Clear filters",
  "referral.action.enterResult": "Enter result",
  "referral.action.markLost": "Mark Lost",
  "referral.action.notifyReferenceLab": "Notify reference lab",
  "referral.action.openResultEntry": "Open in Result Entry",
  "referral.action.reject": "Reject",
  "referral.banner.filterToStuck": "Filter to stuck only",
  "referral.banner.stuckReferralsSubtitle": "{count} referral(s) have been at a reference lab for more than {threshold} day(s).",
  "referral.banner.stuckReferralsTitle": "Stuck referrals detected",
  "referral.box.cannotReconcileMessage": "Cannot reconcile box — {count} samples still awaiting result reconciliation. See Reference Lab Results.",
  "referral.box.viewBlockedReferrals": "View in Reference Lab Results",
  "referral.breadcrumb.referenceLabResults": "Reference Lab Results",
  "referral.chip.ariaLabel": "Reference lab results view",
  "referral.chip.history": "History",
  "referral.chip.outstanding": "Outstanding",
  "referral.chip.returned": "Returned — needs action",
  "referral.column.actions": "Actions",
  "referral.column.boxId": "Box ID",
  "referral.column.closedDate": "Closed date",
  "referral.column.daysOutstanding": "Days outstanding",
  "referral.column.daysTotal": "Days total",
  "referral.column.labNumber": "Lab Number",
  "referral.column.outcome": "Outcome",
  "referral.column.patient": "Patient",
  "referral.column.priority": "Priority",
  "referral.column.referenceLab": "Reference Lab",
  "referral.column.requestor": "Original requestor",
  "referral.column.resultSummary": "Result summary",
  "referral.column.returnedDate": "Returned Date",
  "referral.column.sentDate": "Sent Date",
  "referral.column.status": "Status",
  "referral.column.tests": "Test(s)",
  "referral.expand.criticalBadge": "CRITICAL",
  "referral.expand.detail.ageYears": "{years, plural, one {# year} other {# years}}",
  "referral.expand.detail.boxId": "Box ID",
  "referral.expand.detail.boxReceivedDate": "Received at reference lab",
  "referral.expand.detail.collected": "Collected",
  "referral.expand.detail.currentStatus": "Current status",
  "referral.expand.detail.daysOutstanding": "Days outstanding",
  "referral.expand.detail.dispatched": "Dispatched",
  "referral.expand.detail.fhirTask": "FHIR Task",
  "referral.expand.detail.labNumber": "Lab Number",
  "referral.expand.detail.patient": "Patient",
  "referral.expand.detail.priority": "Priority",
  "referral.expand.detail.referenceLab": "Reference Lab",
  "referral.expand.detail.requestor": "Original requestor",
  "referral.expand.detail.sampleType": "Sample type",
  "referral.expand.detail.tests": "Tests",
  "referral.expand.noResultPayload": "No structured result was returned by the reference lab.",
  "referral.expand.originalOrderContext": "Original order context",
  "referral.expand.outcomeDetail": "Outcome detail",
  "referral.expand.receptionAction": "Reception action",
  "referral.expand.receptionHint": "Review the returned result below, then Accept it to post to the patient record, or Reject it if the result cannot be used.",
  "referral.expand.referenceLabTransit": "Reference lab transit",
  "referral.expand.result": "Result",
  "referral.expand.statusDetail": "Status detail",
  "referral.filter.allPriorities": "All priorities",
  "referral.filter.allRefLabs": "All reference labs",
  "referral.filter.dateRange": "Date range",
  "referral.filter.daysOutstandingBucket": "Days outstanding",
  "referral.filter.daysOutstandingBucket.stuck": "Stuck (> {threshold} days)",
  "referral.filter.priority": "Priority",
  "referral.filter.referenceLab": "Reference Lab",
  "referral.markLost.cancelButton": "Cancel",
  "referral.markLost.confirmButton": "Mark as lost",
  "referral.markLost.description": "This marks the referral as lost in transit and removes it from Outstanding. The clinical team will need to re-collect and re-refer the sample.",
  "referral.markLost.modalTitle": "Mark referral as lost",
  "referral.markLost.reasonLabel": "Reason",
  "referral.markLost.reasonPlaceholder": "e.g. Courier confirmed loss. Box never arrived at the reference lab.",
  "referral.markLost.reasonRequired": "Reason is required.",
  "referral.metric.outstanding": "Outstanding",
  "referral.metric.reconciledToday": "Reconciled today",
  "referral.metric.rejectedThisWeek": "Rejected this week",
  "referral.metric.returned": "Returned — needs action",
  "referral.notification.accepted": "Result accepted to the patient record.",
  "referral.notification.rejected": "Result rejected. The clinician has been notified to re-collect.",
  "referral.notify.errorRetry": "Failed to notify reference lab. Try again.",
  "referral.notify.toast": "Reference lab notified.",
  "referral.page.title": "Reference Lab Results",
  "referral.reject.cancelButton": "Cancel",
  "referral.reject.confirmButton": "Reject and notify clinician",
  "referral.reject.description": "Rejecting closes the originating test terminally and notifies the clinician to re-collect and re-refer the sample.",
  "referral.reject.error": "Could not reject the result. Please try again.",
  "referral.reject.modalTitle": "Reject returned result",
  "referral.reject.reason.clotted": "Clotted",
  "referral.reject.reason.damagedContainer": "Damaged container",
  "referral.reject.reason.hemolyzed": "Hemolyzed",
  "referral.reject.reason.insufficientVolume": "Insufficient volume",
  "referral.reject.reason.mislabeled": "Mislabeled",
  "referral.reject.reason.other": "Other",
  "referral.reject.reason.temperatureDeviation": "Temperature deviation",
  "referral.reject.reason.wrongSampleType": "Wrong sample type",
  "referral.reject.reasonLabel": "Reason",
  "referral.reject.reasonTextLabel": "Details",
  "referral.reject.reasonTextPlaceholder": "Describe why this returned result cannot be used.",
  "referral.reject.reasonTextRequired": "Details are required.",
  "referral.reject.warningTitle": "This action cannot be undone",
  "referral.result.interp.Abnormal": "Abnormal",
  "referral.result.interp.Critical": "Critical",
  "referral.result.interp.Normal": "Normal",
  "referral.status.cancelled": "Cancelled",
  "referral.status.completed": "Result returned",
  "referral.status.draft": "Draft",
  "referral.status.inProgress": "In progress at reference lab",
  "referral.status.received": "At reference lab",
  "referral.status.reconciled": "Reconciled",
  "referral.status.rejected": "Rejected by reference lab",
  "referral.status.requested": "Sent — awaiting acceptance",
  "referral.table.count": "{count, plural, =0 {No referrals} one {# referral} other {# referrals}}",
  "referral.table.history.title": "History",
  "referral.table.outstanding.title": "Outstanding referrals",
  "referral.table.returned.title": "Returned — needs action",
  "referral.tag.manuallyEntered": "Manually entered",
  "reports.tat.title": "Turn Around Time Report",
  "reports.tat.description": "Analyze laboratory turnaround times across workflow milestones",
  "reports.tat.generateReport": "Generate Report",
  "reports.tat.clearFilters": "Clear Filters",
  "reports.tat.segment.orderToCollection": "Order to Collection",
  "reports.tat.segment.collectionToReceipt": "Collection to Receipt",
  "reports.tat.segment.receiptToTesting": "Receipt to Testing Started",
  "reports.tat.segment.receiptToResult": "Receipt to Result Entry",
  "reports.tat.segment.receiptToValidation": "Receipt to Validation",
  "reports.tat.segment.resultToValidation": "Result Entry to Validation",
  "reports.tat.segment.overall": "Overall TAT",
  "reports.tat.calendarTime": "Calendar Time",
  "reports.tat.workingTime": "Working Time",
  "reports.tat.workingTimeInfo": "Working Time mode: Excluding {weekendDays} and {holidayCount} public holidays in the selected date range",
  "reports.tat.configuredWeekends": "configured weekends",
  "reports.tat.noHolidaysWarning": "No public holidays configured. Configure holidays in Admin > Calendar Management.",
  "reports.tat.manageCalendar": "Manage Calendar",
  "reports.tat.totalResults": "Total Results",
  "reports.tat.meanTat": "Mean TAT",
  "reports.tat.medianTat": "Median TAT",
  "reports.tat.percentile90": "90th Percentile",
  "reports.tat.minTat": "Min TAT",
  "reports.tat.maxTat": "Max TAT",
  "reports.tat.stdDeviation": "Std Deviation",
  "reports.tat.distribution": "TAT Distribution",
  "reports.tat.breakdownBy": "Breakdown by",
  "reports.tat.clickRowHint": "Click a row to view individual results",
  "reports.tat.summary": "Summary",
  "reports.tat.detailList": "Detail List",
  "reports.tat.trends": "Trends",
  "reports.tat.noResults": "No results found for the selected filters. Try adjusting the date range or filter criteria.",
  "reports.tat.insufficientData": "Insufficient data",
  "reports.tat.loadError": "Error loading report data",
  "reports.tat.dateRange": "Date Range",
  "reports.tat.labUnit": "Lab Unit",
  "reports.tat.testPanel": "Test / Panel",
  "reports.tat.priority.all": "All",
  "reports.tat.priority.routine": "Routine",
  "reports.tat.priority.stat": "STAT",
  "reports.tat.priority.asap": "ASAP",
  "reports.tat.sampleType": "Sample Type",
  "reports.tat.orderingSite": "Ordering Site",
  "reports.tat.priority": "Priority",
  "reports.tat.includeCancelled": "Include cancelled/rejected",
  "reports.tat.export": "Export",
  "reports.tat.exportCsv": "Export CSV",
  "reports.tat.exportPdf": "Export PDF",
  "reports.tat.labNumber": "Lab Number",
  "reports.tat.patient": "Patient",
  "reports.tat.test": "Test",
  "reports.tat.orderCreated": "Order Created",
  "reports.tat.collected": "Collected",
  "reports.tat.received": "Received",
  "reports.tat.testingStarted": "Testing Started",
  "reports.tat.resultEntered": "Result Entered",
  "reports.tat.validated": "Validated",
  "reports.tat.selectedTat": "Selected TAT",
  "reports.tat.overallTat": "Overall TAT",
  "reports.tat.columns": "Columns",
  "reports.tat.rowsPerPage": "Rows per page",
  "reports.tat.showing": "Showing {from}-{to} of {total} results",
  "reports.tat.trend": "Trend",
  "reports.tat.aggregation": "Aggregation",
  "reports.tat.daily": "Daily",
  "reports.tat.weekly": "Weekly",
  "reports.tat.monthly": "Monthly",
  "reports.tat.compareBy": "Compare by",
  "reports.tat.showVolume": "Show order volume",
  "reports.tat.mean": "Mean",
  "reports.tat.median": "Median",
  "reports.tat.notApplicable": "N/A",
  "reports.tat.dateRangeFrom": "Date Range (From)",
  "reports.tat.dateRangeTo": "Date Range (To)",
  "reports.tat.tatSegment": "TAT Segment",
  "reports.tat.metrics": "Metrics",
  "reports.tat.compareNone": "None",
  "reports.tat.comparePriority": "Priority",
  "reports.tat.column.labNumber": "Lab Number",
  "reports.tat.column.test": "Test",
  "reports.tat.column.labUnit": "Lab Unit",
  "reports.tat.column.priority": "Priority",
  "reports.tat.column.ordered": "Ordered",
  "reports.tat.column.collected": "Collected",
  "reports.tat.column.received": "Received",
  "reports.tat.column.started": "Started",
  "reports.tat.column.resulted": "Resulted",
  "reports.tat.column.validated": "Validated",
  "reports.tat.column.selectedTat": "Selected TAT",
  "reports.tat.column.overallTat": "Overall TAT",
  "reports.tat.column.name": "Name",
  "reports.tat.column.count": "Count",
  "reports.tat.column.mean": "Mean",
  "reports.tat.column.median": "Median",
  "reports.tat.column.p90": "90th %ile",
  "reports.tat.column.max": "Max",
  "reports.tat.home": "Home",
  "reports.tat.all": "All",
  "reports.tat.preset.today": "Today",
  "reports.tat.preset.7days": "Last 7 Days",
  "reports.tat.preset.30days": "Last 30 Days",
  "reports.tat.preset.90days": "Last 90 Days",
  "reports.tat.preset.thisMonth": "This Month",
  "reports.tat.preset.lastMonth": "Last Month",
  "reports.tat.preset.thisQuarter": "This Quarter",
  "button.cancel": "Cancel",
  "button.activate": "Activate",
  "button.adjust": "Adjust",
  "button.deactivate": "Deactivate",
  "button.dispose": "Dispose",
  "button.edit": "Edit",
  "button.generate": "Generate",
  "button.label.genarateReport": "Generate Report",
  "button.label.loadnext": "Load Next Bundle",
  "button.label.loadprevious": "Load Previous Bundle",
  "button.label.showHidePram": "Show/Hide Report Parameter",
  "button.record": "Record",
  "button.save": "Save",
  "button.save.draft": "Save Draft",
  "button.save.next": "Save & Next",
  "button.save.stay": "Save",
  "button.send": "Send",
  "button.update": "Update",
  "calculatedTests": "Calculated Tests",
  "catalog.item.activate.success": "Catalog item activated successfully",
  "catalog.item.category": "Category",
  "catalog.item.code": "Code",
  "catalog.item.code.hint": "Stable identifier used by integrations. Leave blank and we'll generate one from the name, like PAR-500MG-001.",
  "catalog.item.code.locked": "Code is locked once saved so integrations and existing references keep working.",
  "catalog.item.code.placeholder": "Leave blank to auto-generate from name",
  "catalog.item.code.preview": "Will be saved as {code}",
  "catalog.item.compatibleAnalyzers": "Compatible Analyzers",
  "catalog.item.deactivate.confirm.button": "Deactivate",
  "catalog.item.deactivate.confirm.message": "Are you sure you want to deactivate {itemName}?",
  "catalog.item.deactivate.confirm.title": "Confirm Deactivation",
  "catalog.item.deactivate.implications.1": "This item will no longer appear in active item lists",
  "catalog.item.deactivate.implications.2": "Existing lots for this item will remain accessible",
  "catalog.item.deactivate.implications.3": "You can reactivate this item later if needed",
  "catalog.item.deactivate.implications.title": "Implications:",
  "catalog.item.deactivate.label": "Deactivate Item",
  "catalog.item.deactivate.success": "Item deactivated successfully",
  "catalog.item.error.saveGeneric": "Error saving catalog item",
  "catalog.item.error.stabilityRequired": "Stability after opening is required for reagents",
  "catalog.item.form.title.add": "Add New Catalog Item",
  "catalog.item.form.title.edit": "Edit Catalog Item",
  "catalog.item.lowStockThreshold": "Low Stock Threshold",
  "catalog.item.manufacturer": "Manufacturer",
  "catalog.item.minimumStock": "Minimum Stock Level",
  "catalog.item.name": "Item Name",
  "catalog.item.reorderLevel": "Reorder Level",
  "catalog.item.reorderQuantity": "Reorder Quantity",
  "catalog.item.save.error": "Error saving catalog item",
  "catalog.item.save.success": "Catalog item saved successfully",
  "catalog.item.stabilityAfterOpening": "Stability After Opening (days)",
  "catalog.item.status": "Status",
  "catalog.item.storageRequirements": "Storage Requirements",
  "catalog.item.testTypes": "Test Types",
  "catalog.item.testsPerCartridge": "Tests Per Cartridge",
  "catalog.item.testsPerKit": "Tests Per Kit",
  "catalog.item.units": "Units",
  "catalog.search.placeholder": "Search by item name or code",
  "choose.availablepanel": "Choose Available panel",
  "coldStorage.action.createSuccess": "Corrective action created successfully",
  "coldStorage.action.retractSuccess": "Corrective action retracted successfully",
  "coldStorage.action.updateSuccess": "Corrective action updated successfully",
  "coldStorage.actions": "Actions",
  "coldStorage.activated": "activated",
  "coldStorage.addDevicesMessage": "Please add devices in Device Management to configure temperature thresholds.",
  "coldStorage.addNewDevice": "Add New Device",
  "coldStorage.alert.acknowledged": "Alert acknowledged successfully",
  "coldStorage.alert.actionFailed": "Unable to {action} alert {alertId}",
  "coldStorage.alert.equipment": "Equipment Failure",
  "coldStorage.alert.equipment.description": "Alerts for equipment malfunctions or connectivity issues",
  "coldStorage.alert.inventory": "Inventory Alerts",
  "coldStorage.alert.inventory.description": "Alerts for low inventory or stock management",
  "coldStorage.alert.resolved": "Alert resolved successfully",
  "coldStorage.alert.saveFailed": "Failed to save notification preferences: ",
  "coldStorage.alert.saveSuccess": "Notification preferences saved successfully. Each alert type will use its configured notification methods.",
  "coldStorage.alert.temperature": "Temperature & Humidity Alerts",
  "coldStorage.alert.temperature.description": "Alerts triggered when a unit's temperature or relative humidity leaves its configured band",
  "coldStorage.alert.type": "Alert Type",
  "coldStorage.alertConfiguration": "Alert Configuration",
  "coldStorage.autoEscalate": "Automatically escalate unresolved alerts",
  "coldStorage.button.delete": "Delete",
  "coldStorage.configuredDevices": "Configured Devices",
  "coldStorage.correctiveAction.column.actionId": "Action ID",
  "coldStorage.correctiveAction.column.created": "Created",
  "coldStorage.correctiveAction.column.lastUpdatedBy": "Last Updated By",
  "coldStorage.correctiveAction.column.performedBy": "Performed By",
  "coldStorage.correctiveAction.edited": "Edited",
  "coldStorage.correctiveAction.status.cancelled": "Cancelled",
  "coldStorage.correctiveAction.status.completed": "Completed",
  "coldStorage.correctiveAction.status.inProgress": "In Progress",
  "coldStorage.correctiveAction.status.pending": "Pending",
  "coldStorage.correctiveAction.status.retracted": "Retracted",
  "coldStorage.correctiveAction.type.calibration": "Calibration",
  "coldStorage.correctiveAction.type.calibration.description": "Calibrating equipment or sensors",
  "coldStorage.correctiveAction.type.equipmentRepair": "Equipment Repair",
  "coldStorage.correctiveAction.type.equipmentRepair.description": "Repairing or replacing equipment",
  "coldStorage.correctiveAction.type.itemReorder": "Item Reorder",
  "coldStorage.correctiveAction.type.itemReorder.description": "Reordering inventory items",
  "coldStorage.correctiveAction.type.maintenance": "Maintenance",
  "coldStorage.correctiveAction.type.maintenance.description": "Performing maintenance tasks",
  "coldStorage.correctiveAction.type.other": "Other",
  "coldStorage.correctiveAction.type.other.description": "Other or custom corrective actions",
  "coldStorage.correctiveAction.type.sampleRelocation": "Sample Relocation",
  "coldStorage.correctiveAction.type.sampleRelocation.description": "Moving samples to another location",
  "coldStorage.correctiveAction.type.temperatureAdjustment": "Temperature Adjustment",
  "coldStorage.correctiveAction.type.temperatureAdjustment.description": "Adjusting temperature settings",
  "coldStorage.criticalThreshold": "Critical Threshold (°C)",
  "coldStorage.dashboard.acknowledge": "Acknowledge",
  "coldStorage.dashboard.activeAlerts": "Active Alerts ({count})",
  "coldStorage.dashboard.column.currentTemp": "Current Temp",
  "coldStorage.dashboard.column.currentTemp2": "Probe 2 Temp",
  "coldStorage.dashboard.column.device": "Device",
  "coldStorage.dashboard.column.duration": "Duration",
  "coldStorage.dashboard.column.humidity": "Humidity",
  "coldStorage.dashboard.column.lastReading": "Last Reading",
  "coldStorage.dashboard.column.location": "Location",
  "coldStorage.dashboard.column.severity": "Severity",
  "coldStorage.dashboard.column.started": "Started",
  "coldStorage.dashboard.column.targetTemp": "Target Temp",
  "coldStorage.dashboard.column.temperature": "Temperature",
  "coldStorage.dashboard.column.unitId": "Unit ID",
  "coldStorage.dashboard.column.unitName": "Unit Name",
  "coldStorage.dashboard.criticalAlertSubtitle": "{count} storage unit(s) experiencing critical temperature excursions",
  "coldStorage.dashboard.criticalAlertTitle": "CRITICAL ALERT",
  "coldStorage.dashboard.deviceTypeFilter": "Device Type",
  "coldStorage.dashboard.kpi.critical": "Critical Alerts",
  "coldStorage.dashboard.kpi.normal": "Normal Status",
  "coldStorage.dashboard.kpi.totalUnits": "Total Storage Units",
  "coldStorage.dashboard.kpi.warnings": "Warnings",
  "coldStorage.dashboard.lastUpdate": "Last update: {time}",
  "coldStorage.dashboard.loadingUnits": "Loading storage units…",
  "coldStorage.dashboard.noActiveAlerts": "No active alerts",
  "coldStorage.dashboard.noUnitsFound": "No storage units found.",
  "coldStorage.dashboard.online": "Online",
  "coldStorage.dashboard.refresh": "Refresh",
  "coldStorage.dashboard.refreshing": "Refreshing",
  "coldStorage.dashboard.refreshingEllipsis": "Refreshing...",
  "coldStorage.dashboard.searchLabel": "Search by Unit ID or Name",
  "coldStorage.dashboard.statusFilter": "Status",
  "coldStorage.dashboard.storageUnitsTitle": "Storage Units",
  "coldStorage.dashboard.subtitle": "Real-time temperature monitoring & compliance",
  "coldStorage.dashboard.systemStatus": "System Status: {status}",
  "coldStorage.dashboard.tab.correctiveActions": "Corrective Actions",
  "coldStorage.dashboard.tab.dashboard": "Dashboard",
  "coldStorage.dashboard.tab.historicalTrends": "Historical Trends",
  "coldStorage.dashboard.tab.reports": "Reports",
  "coldStorage.dashboard.tab.settings": "Settings",
  "coldStorage.dashboard.viewAlertDetails": "View alert details",
  "coldStorage.deactivated": "deactivated",
  "coldStorage.description": "Description",
  "coldStorage.device.activate": "Activate device",
  "coldStorage.device.activateMessage": "Activating this device will enable monitoring and data collection.",
  "coldStorage.device.changeStatus": "Change Device Status",
  "coldStorage.device.changeStatusOf": "Change the status of {name}:",
  "coldStorage.device.created": "Device created successfully",
  "coldStorage.device.createdSuccess": "Device \"{name}\" has been created successfully",
  "coldStorage.device.deactivate": "Deactivate device",
  "coldStorage.device.deactivateMessage": "Deactivating this device will stop monitoring and data collection. Historical data will be preserved.",
  "coldStorage.device.delete": "Delete Device",
  "coldStorage.device.deleteConfirm": "Are you sure you want to delete {name}?",
  "coldStorage.device.deleteWarning": "This will mark the device as inactive and remove it from active monitoring. Historical data will be preserved.",
  "coldStorage.device.deleted": "Device \"{name}\" has been deleted successfully",
  "coldStorage.device.deviceStatus": "Device Status",
  "coldStorage.device.edit": "Edit device",
  "coldStorage.device.id": "Device ID",
  "coldStorage.device.ipAddress": "IP Address",
  "coldStorage.device.port": "Port",
  "coldStorage.device.protocol": "Protocol",
  "coldStorage.device.registerCount": "Registers Per Value",
  "coldStorage.device.registerCount.help": "1 for a 16-bit value, 2 for a 32-bit value spanning two registers",
  "coldStorage.device.roomFacility": "Room/Facility",
  "coldStorage.device.rs485": "RS-485 Half-Duplex (Optional)",
  "coldStorage.device.rs485.delayAfter": "Delay After Transmit (ms)",
  "coldStorage.device.rs485.delayBefore": "Delay Before Transmit (ms)",
  "coldStorage.device.rs485.mode": "Enable RS-485 driver-enable timing",
  "coldStorage.device.rs485.rtsActiveHigh": "RTS active high during transmit",
  "coldStorage.device.rs485.rxDuringTx": "Keep receiver enabled while transmitting",
  "coldStorage.device.rs485.termination": "Bus termination enabled",
  "coldStorage.device.secondProbe": "Second Temperature Probe (Optional)",
  "coldStorage.device.secondProbe.offset": "Base Temperature 2 (°C)",
  "coldStorage.device.secondProbe.offsetHelp": "Base offset for the second probe",
  "coldStorage.device.secondProbe.register": "Temperature Register 2",
  "coldStorage.device.secondProbe.registerHelp": "Modbus register address for a second, independent temperature probe. Its readings are recorded and charted; threshold alerts are raised from the first probe.",
  "coldStorage.device.secondProbe.scale": "Temperature Scale 2",
  "coldStorage.device.secondProbe.scaleHelp": "Scaling factor (e.g., 0.1 to divide by 10)",
  "coldStorage.device.statusChanged": "Device \"{name}\" has been {status} successfully",
  "coldStorage.device.type": "Type",
  "coldStorage.device.updated": "Device updated successfully",
  "coldStorage.device.wordOrder": "Word Order",
  "coldStorage.device.wordOrder.bigEndian": "Big endian (most significant word first)",
  "coldStorage.device.wordOrder.help": "Order of the two registers in a 32-bit value; ignored when reading one register",
  "coldStorage.device.wordOrder.littleEndian": "Little endian (least significant word first)",
  "coldStorage.deviceHistory.averageMetric": "Average {metric}",
  "coldStorage.deviceHistory.column.acknowledgedPerformedBy": "Acknowledged / Performed By",
  "coldStorage.deviceHistory.column.date": "Date",
  "coldStorage.deviceHistory.column.eventId": "Event ID",
  "coldStorage.deviceHistory.column.eventType": "Event Type",
  "coldStorage.deviceHistory.column.summaryTitle": "Summary / Title",
  "coldStorage.deviceHistory.column.time": "Time",
  "coldStorage.deviceHistory.correctiveActions": "Corrective Actions",
  "coldStorage.deviceHistory.dataPoints": "Data Points",
  "coldStorage.deviceHistory.exportCsv": "Export CSV",
  "coldStorage.deviceHistory.loadingEvents": "Loading event history...",
  "coldStorage.deviceHistory.loadingTemperature": "Loading temperature data...",
  "coldStorage.deviceHistory.maxMetric": "Max {metric}",
  "coldStorage.deviceHistory.metric": "Metric:",
  "coldStorage.deviceHistory.minMetric": "Min {metric}",
  "coldStorage.deviceHistory.noEventsFound": "No events found.",
  "coldStorage.deviceHistory.noTemperatureData": "No temperature data available for the selected time range.",
  "coldStorage.deviceHistory.searchEvents": "Search events",
  "coldStorage.deviceHistory.searchPlaceholder": "Search by event ID, summary, or user...",
  "coldStorage.deviceHistory.tab.eventHistory": "Event History",
  "coldStorage.deviceHistory.tab.temperatureTrends": "Temperature Trends",
  "coldStorage.deviceHistory.timeRange": "Time Range:",
  "coldStorage.deviceHistory.title": "Device History - {name} ({id})",
  "coldStorage.deviceHistory.totalAlerts": "Total Alerts",
  "coldStorage.deviceHistory.totalEvents": "Total Events",
  "coldStorage.email": "Email",
  "coldStorage.emailSmsNotifications": "Email Notifications & SMS Notifications",
  "coldStorage.error.createAction": "Failed to create corrective action. Please try again.",
  "coldStorage.error.createDevice": "Failed to create device: ",
  "coldStorage.error.createRoom": "Failed to create room: ",
  "coldStorage.error.deleteDevice": "Failed to delete device: ",
  "coldStorage.error.loadActions": "Failed to load corrective actions. Please try again.",
  "coldStorage.error.loadAuditTrail": "Unable to load audit trail",
  "coldStorage.error.loadAuditTrailDetail": "Unexpected error while loading audit records.",
  "coldStorage.error.loadDevices": "Failed to load devices: ",
  "coldStorage.error.loadExcursions": "Unable to load excursion history",
  "coldStorage.error.loadExcursionsDetail": "Unexpected error while loading excursions.",
  "coldStorage.error.loadFailed": "Unable to load cold storage monitoring data.",
  "coldStorage.error.loadLocations": "Failed to load locations: ",
  "coldStorage.error.loadUsers": "Failed to load user list. Please try again later.",
  "coldStorage.error.noCurrentUser": "Unable to identify the current user. Please sign in again.",
  "coldStorage.error.retractAction": "Failed to retract corrective action. Please try again.",
  "coldStorage.error.saveThreshold": "Failed to save threshold configuration: ",
  "coldStorage.error.toggleStatus": "Failed to toggle device status: ",
  "coldStorage.error.updateAction": "Failed to update corrective action. Please try again.",
  "coldStorage.error.updateDevice": "Failed to update device: ",
  "coldStorage.error.updateFailed": "Unable to update cold storage data",
  "coldStorage.escalationDelay": "Escalation Delay (minutes)",
  "coldStorage.escalationDelayHelper": "Time to wait before escalating an unresolved alert",
  "coldStorage.escalationRules": "Escalation Rules",
  "coldStorage.filter.activeOnly": "Active Only",
  "coldStorage.filter.all": "All Devices",
  "coldStorage.filter.inactiveOnly": "Inactive Only",
  "coldStorage.footer": "Cold Storage Monitoring v2.1.0 | Compliant with CAP, CLIA, FDA, and WHO guidelines | HIPAA Compliant Data Handling",
  "coldStorage.granularNotificationControl": "Granular Notification Control",
  "coldStorage.granularNotificationControlDesc": "Configure email and SMS notifications for each alert type independently. Enable the notification methods you want for each specific alert category.",
  "coldStorage.howNotificationsWork": "How Notifications Work",
  "coldStorage.howNotificationsWorkDesc": "When an alert is triggered (temperature threshold violation, equipment failure, etc.), the system will:",
  "coldStorage.loadingDevices": "Loading devices...",
  "coldStorage.loadingPrefs": "Loading notification preferences...",
  "coldStorage.name": "Name",
  "coldStorage.noConfigFound": "No Configuration Found",
  "coldStorage.noDevicesConfigured": "No Devices Configured",
  "coldStorage.notification.createRecord": "Create an alert record in the system (visible in Dashboard)",
  "coldStorage.notification.logAttempt": "Log the notification attempt for audit trail purposes",
  "coldStorage.notification.sendEmail": "Send EMAIL notifications if enabled (to configured recipients)",
  "coldStorage.notification.sendSms": "Send SMS notifications if enabled (to configured phone numbers)",
  "coldStorage.pollInterval": "Poll Interval (seconds)",
  "coldStorage.reports.column.action": "Action",
  "coldStorage.reports.column.details": "Details",
  "coldStorage.reports.column.excursionId": "Excursion ID",
  "coldStorage.reports.column.freezer": "Freezer",
  "coldStorage.reports.column.freezerId": "Freezer ID",
  "coldStorage.reports.column.startTime": "Start Time",
  "coldStorage.reports.column.temperatureRange": "Temperature Range",
  "coldStorage.reports.column.timestamp": "Timestamp",
  "coldStorage.reports.column.user": "User",
  "coldStorage.reports.downloadReport": "Download {format} Report",
  "coldStorage.reports.endDate": "End date",
  "coldStorage.reports.excursionHistory": "Temperature Excursion History",
  "coldStorage.reports.exportFormat": "Export Format",
  "coldStorage.reports.footer": "Cold Storage Monitoring v2.1.0 | CAP, CLIA, FDA & WHO compliant | HIPAA-ready data handling",
  "coldStorage.reports.freezer": "Freezer",
  "coldStorage.reports.generateReport": "Generate Report",
  "coldStorage.reports.loadingAudit": "Loading audit entries…",
  "coldStorage.reports.loadingExcursions": "Loading excursions…",
  "coldStorage.reports.noAuditActivity": "No audit activity for the selected filters.",
  "coldStorage.reports.noAuditMatch": "No audit entries match your search.",
  "coldStorage.reports.noExcursions": "No excursions available for the selected filters.",
  "coldStorage.reports.regulatoryCompliance": "Regulatory Compliance",
  "coldStorage.reports.regulatoryComplianceDesc": "Reports follow CAP (College of American Pathologists), CLIA (Clinical Laboratory Improvement Amendments), FDA (Food and Drug Administration), and WHO (World Health Organization) guidance for temperature-controlled storage.",
  "coldStorage.reports.reportType": "Report Type",
  "coldStorage.reports.searchAuditTrail": "Search audit trail...",
  "coldStorage.reports.startDate": "Start date",
  "coldStorage.reports.tab.auditTrail": "Audit Trail",
  "coldStorage.reports.tab.excursions": "Temperature Excursions",
  "coldStorage.reports.title": "Regulatory Reports",
  "coldStorage.room.addNew": "Add New Room",
  "coldStorage.room.create": "Create Room",
  "coldStorage.room.created": "Room created successfully",
  "coldStorage.room.description": "Description",
  "coldStorage.room.descriptionPlaceholder": "Enter room description (optional)",
  "coldStorage.room.name": "Room Name",
  "coldStorage.room.namePlaceholder": "Enter room name (e.g., Lab Storage Room A)",
  "coldStorage.saveNotificationPrefs": "Save Notification Preferences",
  "coldStorage.saveThresholdConfig": "Save Threshold Configuration",
  "coldStorage.saving": "Saving...",
  "coldStorage.search.placeholder": "Search by Device ID or Name",
  "coldStorage.selectType": "Select type",
  "coldStorage.sms": "SMS",
  "coldStorage.status": "Status",
  "coldStorage.status.active": "ACTIVE",
  "coldStorage.status.inactive": "INACTIVE",
  "coldStorage.status.noData": "No data",
  "coldStorage.status.offline": "Offline",
  "coldStorage.status.unknown": "Unknown",
  "coldStorage.supervisorEmail": "Supervisor Email",
  "coldStorage.supervisorEmailHelper": "Email address to send escalated alerts",
  "coldStorage.supervisorEmailPlaceholder": "supervisor@lab.com",
  "coldStorage.targetTemperature": "Target Temperature (°C)",
  "coldStorage.threshold.saveSuccess": "Threshold configuration saved successfully",
  "coldStorage.thresholdConfiguration": "Temperature Threshold Configuration",
  "coldStorage.trends.averageMetric": "Average {metric}",
  "coldStorage.trends.axis.humidity": "Humidity (%)",
  "coldStorage.trends.axis.temperature": "Temperature (°C)",
  "coldStorage.trends.axis.temperature2": "Temperature - Probe 2 (°C)",
  "coldStorage.trends.maxMetric": "Max {metric}",
  "coldStorage.trends.metric": "Metric",
  "coldStorage.trends.metric.humidity": "Humidity",
  "coldStorage.trends.metric.temperature": "Temperature",
  "coldStorage.trends.metric.temperature2": "Temperature (Probe 2)",
  "coldStorage.trends.minMetric": "Min {metric}",
  "coldStorage.usingDefaults": "Using default notification settings. Save to create configuration.",
  "coldStorage.validation.error": "Validation Error",
  "coldStorage.validation.retractionReason": "Please provide a reason for retraction",
  "coldStorage.validation.selectActionType": "Please select an action type",
  "coldStorage.validation.selectDevice": "Please select a device",
  "coldStorage.validation.selectRoom": "Please select a room/location for the device",
  "coldStorage.warningThreshold": "Warning Threshold (°C)",
  "collect.addSample.button": "Add Sample",
  "collect.assign.addToSample": "Add to existing sample",
  "collect.assign.button": "Assign Tests",
  "collect.assign.description": "Assign requested tests to sample tubes",
  "collect.assign.newSample": "Create new sample",
  "collect.assign.newSampleHelp": "Select sample type for the new tube",
  "collect.assign.noExisting": "No existing samples available",
  "collect.assign.title": "Test Assignment",
  "collect.multiSampleExample.description": "When multiple sample types are needed",
  "collect.multiSampleExample.result": "Creates separate tubes for each type",
  "collect.multiSampleExample.title": "Multi-Sample Collection Example",
  "collect.noSampleYet": "No samples collected yet",
  "collect.noCompatibleSampleTypes": "No sample type is set up for this test in the test catalog",
  "collect.noTestsOrdered": "No tests have been ordered",
  "collect.noTestsWarning.subtitle": "Add samples with tests in Step 1 before proceeding",
  "collect.noTestsWarning.title": "No tests to collect",
  "collect.requestedTests.info": "Tests requested for this order",
  "collect.requestedTests.title": "Requested Tests",
  "collect.sample.assignedTests": "Assigned Tests",
  "collect.sample.collectionConditions": "Collection Conditions",
  "collect.sample.collectionConditions.placeholder": "Note any special conditions...",
  "collect.sample.collectionDate": "Collection Date",
  "collect.sample.collectionMethod": "Collection Method",
  "collect.addTests.title": "Add Tests or Panels",
  "collect.addTests.helper": "Add a test the clinician asked for after the order was entered, or one that only becomes appropriate with the specimen in hand.",
  "collect.consentRequired.title": "Informed consent is required",
  "collect.consentRequired.subtitle": "This laboratory requires consent to be recorded before a collection can proceed.",
  "sample.holdingLimit": "Holding time: {limit}",
  "sample.holdingLimit.testBy": "test by {deadline}",
  "env.sample.receivedAtLab": "Received at Lab",
  "collect.sample.specimenOrigin": "Specimen Origin",
  "collect.sample.temperature": "Sample Temperature",
  "collect.sample.temperature.placeholder": "e.g. 4 C",
  "collect.sample.collectionDate.helper": "Defaults to today — correct it if the sample was collected earlier",
  "collect.sample.collectionTime": "Collection Time",
  "collect.sample.collector": "Collector",
  "collect.sample.header": "Sample {number}",
  "collect.sample.labPerformedSampling": "Lab performed sampling",
  "collect.sample.nce.link": "Report Non-Conforming Event",
  "collect.sample.noTests": "No tests assigned to this sample",
  "collect.sample.printLabels": "Print Labels",
  "collect.printMoreLabels.helper": "Drew more than expected, or need a different sample type? Use Add Sample, then print its labels from the sample card or the Labels section.",
  "collect.sample.quantity": "Quantity",
  "collect.sample.receivedAtLab": "Received at Lab",
  "collect.sample.receivedAtLab.helper": "Check if sample has been received at the laboratory",
  "collect.sample.receivedDate": "Received Date",
  "collect.sample.receivedTime": "Received Time",
  "collect.sample.remove": "Remove Sample",
  "collect.samples.title": "Samples",
  "collect.table.compatibleTypes": "Compatible Sample Types",
  "collect.table.sampleAssignments": "Sample Assignments",
  "collect.table.testPanel": "Test/Panel",
  "heading.informedConsent.sectionTitle": "Informed Consent",
  "heading.informedConsent.auditRecord": "Consent Audit Record",
  "label.informedConsent.consentGiven": "Patient has provided signed consent",
  "label.informedConsent.formReference": "Consent Form Reference No.",
  "label.informedConsent.recordedBy": "Recorded by",
  "label.informedConsent.recordedAt": "Recorded on",
  "label.informedConsent.statusTag": "Consent Recorded",
  "label.informedConsent.notRecorded": "Not recorded",
  "placeholder.informedConsent.formReference": "e.g. CF-2026-00123",
  "placeholder.informedConsent.recordedBy": "e.g. Dr. Smith",
  "error.informedConsent.formReferenceMaxLength": "Consent form reference must be 100 characters or fewer",
  "error.informedConsent.formReferenceInvalidChars": "Only letters, numbers, hyphens, and spaces are allowed",
  "coldstorage.label.dashboard": "Cold Storage Dashboard",
  "collection.date": "Collection Date",
  "collector": "Collector",
  "collector.label": "Collector",
  "column.actions": "Actions",
  "column.name.accept": "Accept",
  "column.name.analyzerResult": "Analyzer Result",
  "column.name.currentResult": "Current Result",
  "column.name.ignore": "Ignore",
  "column.name.normalRange": "Normal Range",
  "column.name.notes": "Notes",
  "column.name.pastNotes": "Past Notes",
  "column.name.qcDetail": "Detail",
  "column.name.qcStatus": "QC Status",
  "column.name.reject": "Reject",
  "column.name.result": "Result",
  "column.name.retest": "Retest",
  "column.name.sampleInfo": "Sample Info",
  "column.name.sampleKind": "Sample Kind",
  "column.name.save": "Save",
  "column.name.statusPerRegulation": "Status — Per Regulation",
  "column.name.testDate": "Test Date",
  "column.name.testId": "Test Id",
  "column.name.testName": "Test Name",
  "column.name.uncertainty": "U (k=2)",
  "common.codeGenerator.error.invalidCode": "Code must contain at least one letter, digit, or underscore.",
  "common.properties.title": "Common Properties",
  "configuration.batch.test.reassignment": "Batch test reassignment and cancelation",
  "configuration.batch.test.reassignment.search.sampleType": "Type to search sample types",
  "configuration.batch.test.reassignment.search.currentTest": "Type to search tests",
  "configuration.batch.test.reassignment.search.replaceWith": "Type to search tests to add",
  "configuration.method": "Manage Methods",
  "configuration.method.create": "Create New Method",
  "configuration.testCatalog.tests.explain": "Create, edit, rename, activate and set the orderability of tests, with their ranges, result options, methods and labels",
  "configuration.testCatalog.panels.explain": "Create and edit panels, assign their tests and set their display order",
  "configuration.testCatalog.sampleTypes.explain": "Create and edit sample types, assign tests and set their display order",
  "configuration.testCatalog.labUnits.explain": "Create and edit lab units and assign their tests",
  "configuration.testCatalog.import.explain": "Load tests, panels, sample types and lab units from CSV files",
  "configuration.testCatalog.methods.explain": "Add methods; a new method becomes active once a test uses it",
  "configuration.selectList.add": "Add result select list",
  "configuration.selectList.add.alert": "To change spelling of current result list entries use Rename existing result list options",
  "configuration.selectList.add.explain": "use to create result select list for test results",
  "configuration.selectList.rename": "Rename existing result list options",
  "configuration.selectList.rename.explain": "Rename existing result list options",
  "configuration.test.activate": "Activate/Deactivate tests",
  "configuration.test.activate.explain": "Use to activate or deactivate an existing test.",
  "configuration.test.catalog": "View Test Catalog",
  "configuration.test.catalog.explain": "View the current test catalog",
  "configuration.test.orderable": "Enable/disable test orderability",
  "configuration.test.orderable.explain": "Tests that are orderable can be ordered on intake. If they are not orderable then they can only be ordered as a result of a reflex",
  "configuration.testCatalog.uom.explain": "List units of measure and correct their names, codes and UCUM codes",
  "configuration.uom.title": "Units of Measure",
  "configuration.uom.explain": "Units that numeric results are reported in. A unit can also be created while editing a test.",
  "configuration.uom.add": "Add Unit",
  "configuration.uom.edit": "Edit Unit",
  "configuration.uom.empty": "No units of measure match",
  "method.modal.edit.heading": "Edit Method",
  "configuration.method.create.duplicate": "A method with this name already exists. Use a different name.",
  "configuration.panel.assign": "Test Assignment",
  "configuration.panel.assign.explain": "Select tests to re-assign to a different panel by clicking the test name; they are displayed under their currently assigned panel.",
  "configuration.panel.confirmation.explain": "This panel will not be active until at least one test has been assigned to it.",
  "configuration.panel.create": "Create New Panel",
  "configuration.panel.create.duplicate": "An existing panel type with the same name has been found. Please cancel or use a different name.",
  "configuration.panel.order": "Set Panel Order",
  "configuration.panel.order.explain": "Sort panels by clicking a type and dragging it into the proper order.",
  "configuration.panel.order.explain.limits": "Only panels with tests assigned may be ordered. For new panels please assign tests before ordering.",
  "configuration.sampleType.assign.explain": "Select tests to re-assign to a different sample type by clicking the test name; they are displayed under their currently assigned sample type.",
  "configuration.sampleType.assign.new.type": "Assign to sample type",
  "configuration.sampleType.confirmation.explain": "This sample type will not be active until at least one test has been assigned to it.",
  "configuration.sampleType.create": "Create New Sample Type",
  "configuration.sampleType.create.duplicate": "An existing test sample type with the same name has been found.  Please cancel or use a different name.",
  "configuration.sampleType.manage": "Manage Sample Types",
  "configuration.sampleType.manage.explain": "Use to create, set display order or assign tests to sample types",
  "configuration.sampleType.order": "Set Sample Type Order",
  "configuration.sampleType.order.explain": "Sort sample types by clicking a type and dragging it into the proper order.",
  "configuration.sampleType.order.explain.limits": "Only sample types with tests assigned may be ordered.  For new types please assign tests before ordering.",
  "configuration.selectList.assign.description": "The new entry may be assigned to tests or it may be saved without assignment. Select one or more tests for assignment and then adjust the display order. If the new entry should be the normal range value for the selected test check the box labeled `Normal`. If it is desired that the technician should enter text with the result selection to further qualify the results then check the box labeled `Qualifiable`, For instance; if the options are a list of organisms and the last option is `Other` then the user could enter an organism not on the list.",
  "configuration.selectList.assign.header": "Assign new result selection to test",
  "configuration.selectList.assign.new": "New select list option",
  "configuration.selectList.confirmChange": "The normal value will bechanged from %oldvalue% to %newvalue%, are you sure you would like to proceed?",
  "configuration.selectList.description": "Enter both English and French for new selection option. If you don't know the translation then the entered term  will be used for both languages.",
  "configuration.selectList.header": "Create new result selection option",
  "configuration.test.management.ocl": "OCL Concept Import",
  "configuration.test.management.organization": "Test Organization",
  "configuration.test.modify.tab.configuration": "Configuration",
  "configuration.test.modify.tab.compliance": "Compliance Thresholds",
  "configuration.test.modify.filter.instruction": "Select a Sample Type or Test Section to display tests.",
  "configuration.test.modify.filter.noTestsFound": "No tests found matching the selected criteria.",
  "configuration.test.modify.filter.selectToBegin": "Please select a Sample Type or Test Section to begin viewing tests.",
  "configuration.testUnit.assign.new.unit": "Assign to test section",
  "configuration.testUnit.confirmation.explain": "This test unit will not be active until at least one test has been assigned to it.",
  "configuration.testUnit.create": "Create New Test Unit",
  "configuration.testUnit.create.duplicate": "An existing test unit with the same name has been found.  Please cancel or use a different name.",
  "configuration.testUnit.order": "Set Test Unit Order",
  "configuration.testUnit.order.explain": "Sort lab units by clicking a unit and dragging it into the proper order.",
  "configuration.testUnit.order.explain.limits": "Only test sections with tests assigned may be ordered.  For new sections please assign tests before ordering.",
  "heading.sampleType.management": "Sample Type Editor",
  "heading.sampleType.subtitle": "Configure sample types, display order, test associations, and domain classification.",
  "heading.sampleType.editing": "Editing: {name}",
  "label.sampleType.domain": "Sample Domain",
  "label.domain.CLINICAL": "Clinical",
  "label.domain.ENVIRONMENTAL": "Environmental",
  "label.domain.VECTOR": "Vector",
  "label.sampleType.domain.clinical": "Clinical",
  "label.sampleType.domain.environmental": "Environmental",
  "label.sampleType.domain.helper": "Determines which workflow mode (Clinical or Environmental) this sample type appears in.",
  "label.sampleType.domain.helperAllDomains": "Determines which workflow mode (Clinical, Environmental or Vector) this sample type appears in.",
  "label.sampleType.filterDomain": "Filter by domain",
  "label.sampleType.testCount": "Tests",
  "label.sampleType.actions": "Actions",
  "label.sampleType.status": "Status",
  "placeholder.sampleType.search": "Search sample types...",
  "placeholder.sampleType.filter.domain": "All domains",
  "button.sampleType.add": "Add Sample Type",
  "configuration.uom.create": "Create New Units of Measure",
  "configure.labNumber.title": "Lab Number Management",
  "confirmation.rename": "Confirm Changes above you made.",
  "currentests.title": "Current Tests",
  "cytology.label.cellabnomality": "Epithelial Cell Abnomality",
  "cytology.label.confirmSelect": "If you select this option, all current diagnosis information  will be removed",
  "cytology.label.dashboard": "Cytology DashBoard",
  "cytology.label.glandular": "Glandular",
  "cytology.label.negative": "Negative For Intraepithelial Lesion or Malignancy",
  "cytology.label.neoplastic": "Non-neoplastic cellular variations",
  "cytology.label.organisms": "Organisms",
  "cytology.label.other": "Other Malignant Neoplasms",
  "cytology.label.otherResult": " Other Diagnosis Result",
  "cytology.label.reactive": "Reactive cellular changes",
  "cytology.label.review": "Awaiting Cytopathologist Review",
  "cytology.label.specimen": "Specimen Adequacy",
  "cytology.label.squamous": "Squamous",
  "cytology.label.title": "Cytology",
  "cytology.status.completed": "Completed",
  "cytology.status.preparingSlides": "Preparing slides",
  "cytology.status.readyForCytopathologist": "Ready for Cytopathologist",
  "cytology.status.screening": "Screening",
  "dashboard.avg.turn.around.label": "Average Turn Around time",
  "dashboard.avg.turn.around.reception.to.result.label": "Reception To Result Average Time",
  "dashboard.avg.turn.around.reception.to.validation.label": "Reception To Validation Average Time",
  "dashboard.avg.turn.around.result.to.validation.label": "Result To Validation Average Time",
  "dashboard.avg.turn.around.subtitle.label": "Reception to Validation",
  "dashboard.complete.orders.label": "Orders Completed Today",
  "dashboard.in.progress.label": "In Progress",
  "dashboard.in.progress.subtitle.label": "Awaiting Result Entry",
  "dashboard.metrics.loadFailed": "Dashboard counts could not be loaded.",
  "dashboard.partially.completed.label": "Partially Completed Today",
  "dashboard.partially.completed.subtitle.label": "Awaiting Remaining Tests",
  "dashboard.rejected.orders": "Orders Rejected Today",
  "dashboard.turn.around.label": "Delayed Turn Around",
  "dashboard.turn.around.subtitle.label": "More Than 96 hours",
  "dashboard.unprinted.results.label": "Unprinted results",
  "dashboard.user.orders.label": "Orders Entered By Users Today",
  "dashboard.user.orders.today.label": "Orders Entered By User Today",
  "dashboard.user.ordersEntered": "Orders Entered",
  "dashboard.validation.ready.label": "Ready For Validation",
  "dashboard.validation.ready.subtitle.label": "Awaiting Review",
  "dataexport.status.actions": "Actions",
  "dataexport.status.attempt.duration": "Duration",
  "dataexport.status.attempt.endTime": "End Time",
  "dataexport.status.attempt.startTime": "Start Time",
  "dataexport.status.attempt.status": "Status",
  "dataexport.status.duration.ms": "{value} ms",
  "dataexport.status.duration.s": "{value} s",
  "dataexport.status.empty": "No FHIR subscribers are configured. Set org.openelisglobal.fhir.subscriber in common.properties and restart the server to register one.",
  "dataexport.status.endpoint": "Endpoint",
  "dataexport.status.failed24h": "Failed / Total (24h)",
  "dataexport.status.failed24hValue": "{failed} / {total}",
  "dataexport.status.intervalMin": "Retry Interval",
  "dataexport.status.intervalValue": "{value} min",
  "dataexport.status.lastAttempt": "Last Attempt",
  "dataexport.status.lastRefreshed": "Last refreshed",
  "dataexport.status.lastStatus": "Last Status",
  "dataexport.status.lastSuccess": "Last Success",
  "dataexport.status.loadingAttempts": "Loading attempt history…",
  "dataexport.status.never": "Never",
  "dataexport.status.noAttempts": "No attempts yet",
  "dataexport.status.placeholderDash": "—",
  "dataexport.status.refresh": "Refresh",
  "dataexport.status.retry": "Retry now",
  "dataexport.status.retryInFlight": "Triggering…",
  "dataexport.status.title": "FHIR Data Export Status",
  "datasubmission.siteid": "Site Id",
  "database.clean": "Database Cleaning",
  "database.clean.button": "Clean Database",
  "database.clean.confirm.message": "Are you sure you want to clean the database? This will remove all patient and test data.",
  "database.clean.confirm.title": "Confirm Database Cleaning",
  "database.clean.confirm.warning": "This action cannot be undone!",
  "database.clean.error": "Failed to clean the database.",
  "database.clean.not.training": "Database cleaning is only available on training installations.",
  "database.clean.success": "Database cleaned successfully.",
  "database.clean.warning": "This will permanently delete all patient data, sample data, and results from the database.",
  "date.created": "Date Created",
  "datepicker.future.notAllowed": "The date cannot be in the future.",
  "datepicker.past.notAllowed": "The date cannot be in the past.",
  "datepicker.placeholder.dmy": "dd/mm/yyyy",
  "datepicker.placeholder.mdy": "mm/dd/yyyy",
  "delete.error.msg": "Error while Deleting",
  "delete.success.msg": "Successfully Deleted",
  "description.active": "If the test is active it can be ordered on the order form or as part of a test algorithm. If it is not active it cannot be ordered or be part of a test algorithm",
  "description.ageRange": "If the age range (in months) matters for the given values it will be specified here.",
  "description.name": "The name of the test as it will appear within openELIS. Both English and French are shown",
  "description.normalRange": "Any numeric result within this range is what is expected in a healthy person.",
  "description.note": "n/a means not available. The value is not specified.",
  "description.orderable": "If a test is active and orderable then it can be ordered on an order form. If it is active but not orderable then it will only be done if it is reflexed from another test",
  "description.panel": "If this test is part of a test panel then the panel will be named here.",
  "description.referenceValue": "The value of a selection for a healthy person. Only given for select list results.",
  "description.reportName": "The name of the test as it will appear in reports. Both English and French are shown",
  "description.resultLimits": "The limits of normal and valid results for numeric tests. The values can depend on both the age and sex of the patient.",
  "description.resultType": "The kind of result for this test:",
  "description.resultType.alphanumeric": "A - Alphanumeric:",
  "description.resultType.alphanumericDesc": " Accepts either numeric or text in a text box. It will not be evaluated for being normal or valid.",
  "description.resultType.cascadingMultiSelectList": "C - Cascading multi-select list:",
  "description.resultType.cascadingMultiSelectListDesc": " Similar to multi-select but the user will be able to select multiple groups from the dropdown list.",
  "description.resultType.kind": "The kind of result for this test:",
  "description.resultType.multiSelectList": "M - Multi-select list:",
  "description.resultType.multiSelectListDesc": " The user will be able to select one or more values from a dropdown list. No reference value will be specified.",
  "description.resultType.numeric": "N - Numeric:",
  "description.resultType.numericDesc": " Accepts only numeric results in a text box. Results can be evaluated as to being in a normal or a valid range.",
  "description.resultType.selectList": "D - Select list:",
  "description.resultType.selectListDesc": " User will be able to select from a dropdown list. The normal value will be specified as the reference value.",
  "description.resultType.textArea": "R-Free text:",
  "description.resultType.textAreaDesc": " Accepts up to 200 characters in a text area. It will not be evaluated for being normal or valid.",
  "description.sampleType": "The type of sample on which the test can be done. If the intake technician is able to select the type of sample after they have ordered the test it will be marked as user to indicate that the user will select the type",
  "description.selectValues": "Only specified for select, multi-select or cascading multi-select results. These are the available selections shown to the user. If the selection is marked as 'qualifiable' then when the user selects that value they will be able to enter additional information in a text box.",
  "description.sex": "If the sex of the patient matters for the given values it will be specified here.",
  "description.significantDigits": "The number of significant digits for numeric results. Entered results will be rounded or padded to the correct number of digits. The normal range will also be displayed with the correct number of significant digits.",
  "description.testUnit": "Which section of the lab performs the test. This is also known as a test section.",
  "description.uom": "Unit of measure for the test. This usually only applies to numeric or alphanumeric result types.",
  "description.validRange": "Any numeric result not in this range is an indication that the test may not have been done correctly.",
  "dictionary.category.isActive": "Is Active",
  "dictionary.category.label": "Dictionary Category",
  "dictionary.category.localAbbreviation": "Local Abbreviation",
  "dictionary.category.name": "Category",
  "dictionary.dictEntry": "Dictionary Entry",
  "dictionary.error.categoryRequired": "Choose a dictionary category.",
  "dictionary.error.dictEntryRequired": "Enter the dictionary entry.",
  "dictionary.error.localAbbreviationRequired": "Enter a local abbreviation.",
  "dictionary.error.localAbbreviationTooLong": "A local abbreviation has at most 60 characters.",
  "dictionary.label.modify": "Dictionary Menu",
  "dictionary.loincCode": "LOINC Code",
  "dictionary.loincCode.help": "Enter standard LOINC identifier",
  "dictionary.loincCode.helpText": "Standard laboratory observation identifier",
  "dictionary.loincCode.invalid": "Invalid LOINC format (expected: 12345-6 or LP12345-6)",
  "dictionary.loincCode.placeholder": "e.g. 12345-6",
  "dictionary.menu.deactivate.fail": "Dictionary Menu Deactivation Failed",
  "dictionary.menu.deactivate.success": "Dictionary Menu deactivated successfully",
  "dictionary.modal.add.heading": "Add Dictionary",
  "dictionary.modal.edit.heading": "Edit Dictionary",
  "dictionary.number.label": "Dictionary Number",
  "disposal.button": "Dispose Lot",
  "disposal.notes": "Disposal Notes",
  "disposal.notes.placeholder": "Provide details about disposal (disposal method, witness, etc.)",
  "disposal.reason": "Disposal Reason",
  "disposal.reason.select": "Select reason",
  "disposal.success": "Lot disposed successfully",
  "disposal.title": "Dispose Lot",
  "disposal.warning.message": "This action cannot be undone. The lot will be marked as disposed and removed from active inventory.",
  "disposal.warning.title": "Warning",
  "emergencyContactInfo.title": "Emergency Contact Info",
  "english.current": "ENGLISH current",
  "english.label": "English",
  "enterText.label": "Enter text rest",
  "eorder.allInfo": "All Info",
  "eorder.button.editOrder": "Edit Order",
  "eorder.button.enterOrder": "Enter Order",
  "eorder.buttons": " ",
  "eorder.date.end": "End Date",
  "eorder.date.start": "Start Date",
  "eorder.facility.requesting": "Requesting Facility",
  "eorder.header": "Search Incoming Test Requests",
  "eorder.id.national": "National Id",
  "eorder.id.subjectNumber": "Subject Number",
  "eorder.instructions.enter1": "Test Requests Matching Search - In the ",
  "eorder.instructions.enter2": " menu, add a lab number and select ",
  "eorder.instructions.enter3": " to accept the order as is, or select ",
  "eorder.instructions.enter4": " to make changes ",
  "eorder.labNumber": "Lab Number",
  "eorder.labnumber.referring": "Referring Lab Number",
  "eorder.name.first": "First Name",
  "eorder.name.last": "Last Name",
  "eorder.passport.number": "Passport Number",
  "eorder.priority": "Priority",
  "eorder.requestDate": "Request Date",
  "eorder.search.noresults": "No Electronic Orders",
  "eorder.search1.text": "Search by family name, national ID number, lab number from referring lab, or passport number",
  "eorder.search2.text": "Search by Date, and Status Enter the date range for test requests. This will search by the date of the referral, or the order date of the electronic request",
  "eorder.searchValue": "Search Value",
  "eorder.status": "Status",
  "eorder.test.name": "Test Name",
  "eqa.action.deactivate": "Deactivate",
  "eqa.action.edit": "Edit",
  "eqa.action.enterResults": "Enter Results",
  "eqa.action.enterViewResults": "Enter/View Results",
  "eqa.action.reactivate": "Reactivate",
  "eqa.action.viewOrder": "View Order",
  "eqa.action.viewResults": "View Results",
  "eqa.admin.addProgram": "Add Scheme",
  "eqa.admin.col.actions": "Actions",
  "eqa.admin.col.category": "Category",
  "eqa.admin.col.frequency": "Frequency",
  "eqa.admin.col.participants": "Enrolled Participants",
  "eqa.admin.col.programName": "Scheme Name",
  "eqa.admin.col.provider": "Provider",
  "eqa.admin.delete": "Delete",
  "eqa.admin.form.addHeading": "Add New EQA Scheme",
  "eqa.admin.form.category.placeholder": "Select category",
  "eqa.admin.form.description.placeholder": "Scheme description and objectives...",
  "eqa.admin.form.editHeading": "Edit EQA Scheme",
  "eqa.admin.form.frequency.placeholder": "Select frequency",
  "eqa.admin.form.name.placeholder": "e.g., TB Culture & Sensitivity",
  "eqa.admin.form.provider.placeholder": "Name of the organization that runs the scheme",
  "eqa.admin.form.subtitle": "Enroll in a new external quality assessment scheme",
  "eqa.admin.programs.subtitle": "Manage enrolled EQA schemes and providers",
  "eqa.admin.programs.title": "EQA Schemes",
  "eqa.admin.provider.placeholder": "e.g., WHO, CDC, CAP",
  "eqa.admin.subtitle": "Manage EQA schemes",
  "eqa.admin.tab.participants": "Participants",
  "eqa.admin.tab.userManagement": "User Management",
  "eqa.admin.tile.acrossAllPrograms": "Across all schemes",
  "eqa.admin.tile.activePrograms": "Active Schemes",
  "eqa.admin.tile.canManageEqa": "Can manage EQA",
  "eqa.admin.tile.enrolledParticipants": "Enrolled Participants",
  "eqa.admin.tile.systemUsers": "System Users",
  "eqa.admin.tile.totalParticipants": "Total Participants",
  "eqa.admin.tile.totalPrograms": "{count} total schemes",
  "eqa.admin.title": "Scheme Administration",
  "eqa.admin.userManagement.placeholder": "User management coming soon.",
  "eqa.column.actions": "Actions",
  "eqa.deadline.label": "Testing Deadline",
  "eqa.distribution.action.continue": "Continue",
  "eqa.distribution.action.ship": "Ship",
  "eqa.distribution.action.track": "Track",
  "eqa.distribution.action.viewReport": "View Report",
  "eqa.distribution.advance": "Advance Status",
  "eqa.distribution.backToDashboard": "Back to Distributions",
  "eqa.distribution.barcodes": "Generate Barcodes",
  "eqa.distribution.col.actions": "Actions",
  "eqa.distribution.col.deadline": "Deadline",
  "eqa.distribution.col.participants": "Participants",
  "eqa.distribution.col.program": "Program",
  "eqa.distribution.col.responses": "Responses",
  "eqa.distribution.col.round": "Round",
  "eqa.distribution.col.samples": "Samples",
  "eqa.distribution.col.shipmentId": "Shipment ID",
  "eqa.distribution.col.status": "Status",
  "eqa.distribution.create": "Create Distribution",
  "eqa.distribution.createError": "Failed to create distribution.",
  "eqa.distribution.createShipment": "Create New Shipment",
  "eqa.distribution.createSuccess": "Distribution created successfully.",
  "eqa.distribution.dashboard.subtitle": "Distribute EQA samples to participating laboratories",
  "eqa.distribution.dashboard.title": "EQA Distribution",
  "eqa.distribution.deadline": "Submission Deadline",
  "eqa.distribution.detail.title": "Distribution Details",
  "eqa.distribution.empty": "No distributions found",
  "eqa.distribution.filter.allShipments": "All Shipments",
  "eqa.distribution.filter.program": "Filter by Program",
  "eqa.distribution.filter.status": "Filter by Status",
  "eqa.distribution.list.title": "EQA Distributions",
  "eqa.distribution.manageParticipants": "Manage Participants",
  "eqa.distribution.name": "Distribution Name",
  "eqa.distribution.name.placeholder": "e.g., Round 1 - Chemistry 2026",
  "eqa.distribution.network.active": "Active Participants",
  "eqa.distribution.network.active.sub": "Currently enrolled",
  "eqa.distribution.network.responseRate": "Average Response Rate",
  "eqa.distribution.network.responseRate.sub": "Last 4 quarters",
  "eqa.distribution.network.subtitle": "Overview of enrolled participating laboratories",
  "eqa.distribution.network.title": "Participant Network",
  "eqa.distribution.network.total": "Total Participants",
  "eqa.distribution.network.total.sub": "Across all countries",
  "eqa.distribution.participants": "Participant Organizations",
  "eqa.distribution.participants.min": "At least 2 participant organizations are required",
  "eqa.distribution.participants.none": "No laboratory is actively enrolled in this scheme yet.",
  "eqa.distribution.participants.select": "Select organizations",
  "eqa.distribution.program": "EQA Program",
  "eqa.distribution.program.select": "Select a program",
  "eqa.distribution.responseRate": "response rate",
  "eqa.distribution.shipments.subtitle": "Track distributed EQA samples and participant responses",
  "eqa.distribution.shipments.title": "EQA Shipments",
  "eqa.distribution.shipped": "Shipped",
  "eqa.distribution.status.completed": "Completed",
  "eqa.distribution.status.draft": "Draft",
  "eqa.distribution.status.prepared": "Prepared",
  "eqa.distribution.status.shipped": "Shipped",
  "eqa.distribution.step.confirmation": "Confirmation",
  "eqa.distribution.step.details": "Program & Details",
  "eqa.distribution.step.participants": "Participants",
  "eqa.distribution.summary.completed": "Completed",
  "eqa.distribution.summary.completed.sub": "All responses received",
  "eqa.distribution.summary.draft": "Draft Shipments",
  "eqa.distribution.summary.draft.sub": "Being prepared",
  "eqa.distribution.summary.participants": "Participants",
  "eqa.distribution.summary.participants.sub": "Enrolled",
  "eqa.distribution.summary.shipped": "Shipped",
  "eqa.distribution.summary.shipped.sub": "Awaiting responses",
  "eqa.enrollment.allStatuses": "All Statuses",
  "eqa.enrollment.alreadyEnrolled": "Already Enrolled",
  "eqa.enrollment.alreadyEnrolledCount": "{count} organization(s) already enrolled",
  "eqa.enrollment.confirmWithdraw": "Confirm Withdrawal",
  "eqa.enrollment.created.success": "Scheme enrollment created successfully",
  "eqa.enrollment.deactivated": "Program enrollment deactivated",
  "eqa.enrollment.description": "Description",
  "eqa.enrollment.district": "District",
  "eqa.enrollment.editing": "Editing: {name}",
  "eqa.enrollment.empty": "No enrollments found for this scheme",
  "eqa.enrollment.enroll": "Enroll",
  "eqa.enrollment.enrollParticipant": "Enroll Participant",
  "eqa.enrollment.enrollSelected": "Enroll Selected",
  "eqa.enrollment.enrollmentDate": "Enrollment Date",
  "eqa.enrollment.error": "The enrollment was not saved. Try again.",
  "eqa.enrollment.labUnits": "Lab Units",
  "eqa.enrollment.new": "New EQA Scheme Enrollment",
  "eqa.enrollment.organizationCode": "Organization Code",
  "eqa.enrollment.organizationName": "Organization Name",
  "eqa.enrollment.panels": "Test panels",
  "eqa.enrollment.programName": "Scheme Name",
  "eqa.enrollment.programName.placeholder": "Enter scheme name",
  "eqa.enrollment.provider": "Provider",
  "eqa.enrollment.provider.placeholder": "Enter provider name",
  "eqa.enrollment.reactivate": "Reactivate",
  "eqa.enrollment.reactivated": "Program enrollment reactivated",
  "eqa.enrollment.save": "Save Enrollment",
  "eqa.enrollment.saveChanges": "Save Changes",
  "eqa.enrollment.searchOrgs": "Search organizations...",
  "eqa.enrollment.searchPlaceholder": "Search by organization name or code...",
  "eqa.enrollment.selectLabUnits": "Select lab units...",
  "eqa.enrollment.selectOrg": "Select an organization...",
  "eqa.enrollment.selectOrgsPrompt": "Select organizations to enroll",
  "eqa.enrollment.selectPanels": "Select test panels...",
  "eqa.enrollment.selectProgram": "Select scheme",
  "eqa.enrollment.selectProgramPrompt": "Select a scheme to view enrollments",
  "eqa.enrollment.selectTests": "Select tests...",
  "eqa.enrollment.selected": "selected",
  "eqa.enrollment.status": "Status",
  "eqa.enrollment.status.active": "Active",
  "eqa.enrollment.status.suspended": "Suspended",
  "eqa.enrollment.status.withdrawn": "Withdrawn",
  "eqa.enrollment.success": "Enrollment successful",
  "eqa.enrollment.suspend": "Suspend",
  "eqa.enrollment.tests": "Tests",
  "eqa.enrollment.thisLab": "This Lab",
  "eqa.enrollment.updated.success": "Scheme enrollment updated successfully",
  "eqa.enrollment.withdraw": "Withdraw",
  "eqa.enrollment.withdrawReason": "Reason for Withdrawal",
  "eqa.enrollment.withdrawReasonPlaceholder": "Provide a reason for withdrawing this participant...",
  "eqa.filter.allPriorities": "All Priorities",
  "eqa.filter.allPrograms": "All Programs",
  "eqa.filter.allStatuses": "All Statuses",
  "eqa.filter.eqaOnly": "EQA Samples Only",
  "eqa.filter.priority": "Priority",
  "eqa.filter.program": "Program",
  "eqa.filter.status": "Status",
  "eqa.management.action.enterResults": "Enter Results",
  "eqa.management.action.submit": "Submit",
  "eqa.management.bulkUpload": "Bulk Upload Results",
  "eqa.management.col.accession": "Accession #",
  "eqa.management.col.actions": "Actions",
  "eqa.management.col.deadline": "Deadline",
  "eqa.management.col.progress": "Progress",
  "eqa.management.col.provider": "Provider/Program",
  "eqa.management.col.sampleId": "Sample ID",
  "eqa.management.col.status": "Status",
  "eqa.management.daysLeft": "days left",
  "eqa.management.distributions.title": "Distributions",
  "eqa.management.filter.allSamples": "All Samples",
  "eqa.management.overdue": "Overdue",
  "eqa.management.participants.subtitle": "Manage organization enrollment in EQA schemes",
  "eqa.management.participants.title": "Participants",
  "eqa.management.performance.onTime": "On-Time Submission",
  "eqa.management.performance.participation": "Participation Rate",
  "eqa.management.performance.participation.sub": "All programs enrolled",
  "eqa.management.performance.subtitle": "Your laboratory's EQA performance metrics",
  "eqa.management.performance.title": "Performance Summary",
  "eqa.management.performance.zScore": "Average Z-Score",
  "eqa.management.performance.zScore.sub": "Within acceptable range",
  "eqa.management.programs.subtitle": "Manage programs distributed by this laboratory",
  "eqa.management.programs.title": "EQA Schemes",
  "eqa.management.results.title": "Results & Analysis",
  "eqa.management.samples.empty": "No EQA samples found",
  "eqa.management.samples.subtitle": "Manage received EQA samples and submit results",
  "eqa.management.samples.title": "EQA Samples",
  "eqa.management.status.completed": "Completed",
  "eqa.management.status.completed.sub": "Ready to submit",
  "eqa.management.status.inProgress": "In Progress",
  "eqa.management.status.inProgress.sub": "Testing in progress",
  "eqa.management.status.in_progress": "In Progress",
  "eqa.management.status.overdue": "Overdue",
  "eqa.management.status.pending": "Pending",
  "eqa.management.status.pending.sub": "Not started",
  "eqa.management.status.submitted": "Submitted",
  "eqa.management.status.submitted.sub": "Results sent",
  "eqa.management.subtitle": "Receive and manage EQA samples from external providers",
  "eqa.management.title": "EQA Management",
  "eqa.management.viewPerformance": "View Performance",
  "eqa.myProgram.helperText": "Selecting an enrollment pre-populates tests and panels",
  "eqa.myProgram.label": "My Program Enrollment",
  "eqa.myProgram.prePopulated.subtitle": "{tests} tests and {panels} panels pre-selected from enrollment",
  "eqa.myProgram.prePopulated.title": "Tests/panels pre-populated",
  "eqa.myProgram.select": "Select enrollment to pre-populate tests...",
  "eqa.myPrograms.action.deactivate": "Deactivate",
  "eqa.myPrograms.action.edit": "Edit",
  "eqa.myPrograms.action.reactivate": "Reactivate",
  "eqa.myPrograms.description": "Description",
  "eqa.myPrograms.enrollButton": "Enroll in Scheme",
  "eqa.myPrograms.enrollInProgram": "Enroll in Scheme",
  "eqa.myPrograms.labUnits": "Lab Unit(s)",
  "eqa.myPrograms.panels": "Test panels",
  "eqa.myPrograms.programName": "Scheme Name",
  "eqa.myPrograms.provider": "Provider",
  "eqa.myPrograms.search.placeholder": "Search schemes...",
  "eqa.myPrograms.status": "Status",
  "eqa.myPrograms.status.active": "Active",
  "eqa.myPrograms.status.inactive": "Inactive",
  "eqa.myPrograms.subtitle": "Schemes this laboratory participates in",
  "eqa.myPrograms.testMapping": "Test Mapping (Optional)",
  "eqa.myPrograms.testMappingHint": "Select tests and panels to pre-populate Order Entry when this program is selected",
  "eqa.myPrograms.tests": "Tests",
  "eqa.myPrograms.title": "My EQA Schemes",
  "eqa.order.deadline": "Result Deadline",
  "eqa.order.form.title": "EQA Sample Information",
  "eqa.order.participantId": "Participant ID",
  "eqa.order.priority": "EQA Priority",
  "eqa.order.programme": "Scheme",
  "eqa.order.provider": "Provider",
  "eqa.order.providerSampleId": "Provider Sample ID",
  "eqa.orders.completedThisMonth": "Completed This Month",
  "eqa.orders.enterNewTest": "Enter New EQA Test",
  "eqa.orders.inProgress": "In Progress",
  "eqa.orders.overdue": "Overdue",
  "eqa.orders.pending": "Pending",
  "eqa.orders.search.placeholder": "Search by lab number or program...",
  "eqa.participant.id": "Participant ID",
  "eqa.priority.critical": "Critical",
  "eqa.priority.label": "Priority",
  "eqa.priority.standard": "Standard",
  "eqa.priority.urgent": "Urgent",
  "eqa.program.activate": "Activate",
  "eqa.program.active": "Active",
  "eqa.program.addProgram": "Add Program",
  "eqa.program.cancel": "Cancel",
  "eqa.program.create": "Create Program",
  "eqa.program.createTitle": "Create EQA Program",
  "eqa.program.deactivate": "Deactivate",
  "eqa.program.description": "Description",
  "eqa.program.description.placeholder": "Describe the EQA program...",
  "eqa.program.edit": "Edit scheme",
  "eqa.program.editTitle": "Edit EQA Program",
  "eqa.program.empty": "No EQA schemes found",
  "eqa.program.inactive": "Inactive",
  "eqa.program.label": "EQA Program",
  "eqa.program.management.title": "EQA Program Management",
  "eqa.program.name": "Scheme Name",
  "eqa.program.name.placeholder": "e.g., Chemistry Proficiency Testing",
  "eqa.program.name.required": "Scheme name is required",
  "eqa.program.provider.required": "Provider is required",
  "eqa.program.participantCount": "Enrolled Participants",
  "eqa.program.provider": "Provider",
  "eqa.program.required": "EQA Program is required when registering an EQA sample",
  "eqa.program.save": "Save scheme",
  "eqa.program.select": "Select EQA Program",
  "eqa.program.status": "Status",
  "eqa.program.tests": "Assigned Tests",
  "eqa.program.tests.assign": "Assign Tests",
  "eqa.program.tests.select": "Select tests to assign",
  "eqa.provider.label": "EQA Provider Organization",
  "eqa.provider.sampleId": "Provider Sample ID",
  "eqa.provider.select": "Select EQA Provider",
  "eqa.results.acceptable": "Acceptable",
  "eqa.results.batch.import": "Batch Import",
  "eqa.results.col.deadline": "Deadline",
  "eqa.results.col.labNumber": "Lab Number",
  "eqa.results.col.priority": "Priority",
  "eqa.results.col.programme": "Programme",
  "eqa.results.col.provider": "Provider",
  "eqa.results.col.status": "Status",
  "eqa.results.import.confirm": "Confirm Import",
  "eqa.results.import.errors": "{count} rows had errors",
  "eqa.results.import.success": "{count} results imported successfully",
  "eqa.results.import.upload": "Upload CSV File",
  "eqa.results.manual.entry": "Manual Result Entry",
  "eqa.results.mean": "Mean",
  "eqa.results.minimum.participants": "Minimum 5 participants required for statistical analysis",
  "eqa.results.noResults": "No EQA test results found.",
  "eqa.results.organization": "Organization",
  "eqa.results.organization.select": "Select organization",
  "eqa.results.participant.count": "Participant Count",
  "eqa.results.performance": "Performance",
  "eqa.results.questionable": "Questionable",
  "eqa.results.report.downloading": "Downloading report...",
  "eqa.results.report.generate": "Generate Report",
  "eqa.results.search.placeholder": "Search by lab number, programme, or provider...",
  "eqa.results.standardDeviation": "Standard Deviation",
  "eqa.results.statistics": "Statistics",
  "eqa.results.submit": "Submit Result",
  "eqa.results.test": "Test",
  "eqa.results.test.select": "Select test",
  "eqa.results.title": "EQA Results & Analysis",
  "eqa.results.unacceptable": "Unacceptable",
  "eqa.results.value": "Result Value",
  "eqa.results.zscore": "Z-Score",
  "eqa.sample.badge": "EQA",
  "eqa.sample.checkbox": "EQA Sample",
  "eqa.sample.checkbox.helper": "Check if this is an External Quality Assurance sample",
  "eqa.sample.demographics.disabled": "Demographics disabled for EQA samples",
  "eqa.sample.patient.readonly.body": "Patient demographic fields are automatically set for EQA samples and cannot be edited.",
  "eqa.sample.patient.readonly.title": "EQA Sample — Patient Info Locked",
  "eqa.section.title": "EQA Sample Details",
  "eqa.status.active": "Active",
  "eqa.status.completed": "Completed",
  "eqa.status.inProgress": "In Progress",
  "eqa.status.inactive": "Inactive",
  "eqa.status.inprogress": "In Progress",
  "eqa.status.overdue": "Overdue",
  "eqa.status.pending": "Pending",
  "eqa.submission.audit": "Submission Audit Trail",
  "eqa.submission.date": "Submission Date",
  "eqa.submission.error": "Submission failed",
  "eqa.submission.fhir": "Submit via FHIR",
  "eqa.submission.fhir.description": "Submit results to external EQA provider via FHIR R4",
  "eqa.submission.late.approve": "Approve Late Submission",
  "eqa.submission.late.justification": "Justification for Late Submission",
  "eqa.submission.late.justification.placeholder": "Provide reason for late submission...",
  "eqa.submission.late.supervisor": "Supervisor User ID",
  "eqa.submission.late.warning": "Submission deadline has passed. Supervisor approval is required.",
  "eqa.submission.method": "Submission Method",
  "eqa.submission.success": "Results submitted successfully",
  "eqa.submission.title": "Result Submission",
  "eqa.tests.action.enterResults": "Enter Results",
  "eqa.tests.action.viewOrder": "View Order",
  "eqa.tests.action.viewResults": "View Results",
  "eqa.tests.dateEntered": "Date Entered",
  "eqa.tests.deadline": "Deadline",
  "eqa.tests.enterNew": "Enter New EQA Test",
  "eqa.tests.labNumber": "Lab Number",
  "eqa.tests.orders.subtitle": "Proficiency testing orders for this laboratory",
  "eqa.tests.orders.title": "EQA Orders",
  "eqa.tests.priority": "Priority",
  "eqa.tests.program": "EQA scheme",
  "eqa.tests.provider": "Provider",
  "eqa.tests.searchPlaceholder": "Search by accession #, program, or provider...",
  "eqa.tests.status": "Status",
  "eqa.tests.status.completed": "Completed",
  "eqa.tests.status.inProgress": "In Progress",
  "eqa.tests.status.overdue": "Overdue",
  "eqa.tests.status.pending": "Pending",
  "eqa.tests.summary.completedThisMonth": "Completed This Month",
  "eqa.tests.summary.inProgress": "In Progress",
  "eqa.tests.summary.overdue": "Overdue",
  "eqa.tests.summary.pending": "Pending",
  "eqa.validation.deadline.required": "Testing Deadline is required",
  "eqa.validation.program.required": "EQA Program is required",
  "eqa.validation.provider.required": "EQA Provider Organization is required",
  "error.add.edited.msg": "Error while Editing/Adding",
  "error.barcode.dimension.positive": "Label dimension must be a positive number",
  "error.barcode.labelcount.default.lte.max": "Default label count must not exceed maximum for this label type",
  "error.delete.msg": "Error while Deleting",
  "error.duplicate.calculationname": "Duplicate Calculation Name or Error while saving",
  "calculation.error.duplicateName": "A rule named \"{name}\" already exists. Choose another name.",
  "calculation.error.duplicateNameInactive": "A rule named \"{name}\" already exists and is switched off. Switch that rule on, or choose another name.",
  "calculation.error.selfReference": "This rule reads {test}, the result it writes. A rule cannot use its own result.",
  "calculation.error.duplicateDestination": "{test} already gets its value from the active rule \"{other}\". Switch that rule off first.",
  "calculation.error.cycle": "These active rules would feed each other in a loop: {cycle}.",
  "calculation.error.destinationNotComponent": "The chosen result component is not an active component of the resulting test.",
  "calculation.error.destinationNotNumeric": "A calculated value is a number, so it cannot be written to {component}, which does not report a number.",
  "calculation.error.notFound": "This rule no longer exists. Reload the page.",
  "error.fetch.boxDetails": "Failed to fetch box details",
  "error.fetch.boxes": "Failed to fetch shipping boxes",
  "error.fetch.facilities": "Failed to fetch facilities",
  "error.fetch.unassignedSamples": "Failed to fetch unassigned samples",
  "error.field.required": "This field is required",
  "error.import.patient": "Error While Importing Patient into OpenELIS",
  "error.invalid.email": "Invalid Email",
  "error.invalidcredentials": "Username or Password are incorrect",
  "error.locale.format": "Invalid format. Use: en, fr, es, or en-US, fr-CA, etc.",
  "error.no.patient.data": "No Patient Data to Import",
  "error.nonconform.report": "Please Enter Value",
  "error.report.csv.date": "Please select date type.",
  "error.report.csv.study": "Please select study type.",
  "error.report.status": "Error while Generating Report",
  "error.report.linkIncomplete": "The link does not say which {0} to open, so the report cannot be shown. Choose it from the report lists instead.",
  "error.report.linkIncomplete.title": "This report link is incomplete",
  "error.required.destination": "Destination facility is required",
  "error.results.loadFailed": "The results worklist could not be loaded",
  "error.results.loadFailed.detail": "This is not an empty worklist — the request failed, so any pending work here is not shown. Try again, and tell an administrator if it keeps failing.",
  "error.results.staleSave": "This result was updated by {0} at {1} — refresh to see the latest value",
  "error.results.save.noResponse": "The result was not saved because the server did not respond. Check the connection and try again.",
  "error.order.staleSave": "This order was updated by {0} at {1}. Refresh to see the latest version, then make your change again.",
  "error.patient.staleSave": "This patient was updated by {0} at {1}. Refresh to see the latest version, then make your change again.",
  "error.testCatalog.staleSave": "This test was updated by {0} at {1}. Refresh to see the latest version, then make your change again.",
  "error.testCatalog.storage.invalidField": "{field}: this value is not accepted. Choose a listed condition, use zero or more for durations, and keep text within its length.",
  "error.staleSave.section": "Someone else changed this after you opened it. Nothing was saved. Refresh to see the latest version, then make your change again.",
  "error.load.failed": "Could not load this list. Reload to try again.",
  "error.save.failed": "Failed to save",
  "error.save.msg": "Error While saving",
  "error.save.order": "Error while saving order",
  "error.save.patient": "Error While Saving Patient",
  "error.title": "Error",
  "errorBoundary.reload": "Reload",
  "errorBoundary.route.patientResultsViewer.message": "Something went wrong while showing this patient's results. Reload to try again.",
  "errorBoundary.route.patientResultsViewer.title": "Patient results could not be loaded",
  "errorBoundary.route.resultsSearch.message": "Something went wrong on the results page. Reload to try again.",
  "errorBoundary.route.resultsSearch.title": "Results could not be loaded",
  "errorBoundary.route.modifyOrder.message": "Something went wrong on the modify order page. Reload to try again.",
  "errorBoundary.route.modifyOrder.title": "Modify order could not be loaded",
  "errorBoundary.route.orderEntry.message": "Something went wrong on the order entry page. Reload to try again.",
  "errorBoundary.route.orderEntry.title": "Order entry could not be loaded",
  "errorBoundary.route.samplePatientEntry.message": "Something went wrong on the sample entry page. Reload to try again.",
  "errorBoundary.route.samplePatientEntry.title": "Sample entry could not be loaded",
  "errorBoundary.route.storage.message": "Something went wrong on this page. Reload to try again, or use the menu to go elsewhere.",
  "errorBoundary.route.storage.title": "Storage could not be loaded",
  "errorBoundary.route.analyzers.message": "Something went wrong loading this page. Reload to try again.",
  "errorBoundary.route.analyzers.title": "Analyzer module could not be loaded",
  "errorBoundary.route.analyzerResults.message": "Something went wrong loading results. Reload to try again.",
  "errorBoundary.route.analyzerResults.title": "Analyzer results could not be loaded",
  "serverReconnect.title": "Can't reach the server",
  "serverReconnect.retryIn": "Trying again in {seconds} s",
  "serverReconnect.trying": "Trying again now…",
  "serverReconnect.tryNow": "Try now",
  "errors.no.sample": "Select the appropriate sample for each test.",
  "errors.requester.org.or.requestor.required": "Enter at least one of Requesting Organization or Requester contact.",
  "esig.button.certify": "Certify & Continue",
  "esig.button.reject": "Reject",
  "esig.button.saveAndSign": "Save",
  "esig.button.saveModification": "Save",
  "esig.button.sign": "Sign",
  "esig.button.validate": "Validate",
  "esig.certification.acknowledge": "I have read and understand the above statement",
  "esig.certification.intro": "Before you can use electronic signatures, you must certify that your electronic signature is the legally binding equivalent of your handwritten signature.",
  "esig.error.disabled": "Electronic signatures are not enabled",
  "esig.error.generic": "An error occurred",
  "esig.error.invalidCredentials": "Invalid credentials",
  "esig.error.keycloakNotSupported": "Keycloak authentication is not yet supported for electronic signatures",
  "esig.error.loadingStatus": "Failed to load signature status",
  "esig.error.mustAcknowledge": "You must acknowledge the certification statement",
  "esig.error.passwordRequired": "Password is required",
  "esig.error.rejectionReasonRequired": "Rejection reason is required",
  "esig.error.title": "Error",
  "esig.error.usernameRequired": "Username is required",
  "esig.info.fullAuth": "This is your first signature in this session. Please enter your username and password to authenticate.",
  "esig.info.legalBinding": "By entering your credentials, you are creating a legally binding electronic signature per 21 CFR Part 11.",
  "esig.info.passwordOnly": "You have an active signing session. Enter your password to continue.",
  "esig.label.context": "Action:",
  "esig.label.meaning": "Signature Meaning:",
  "esig.label.password": "Password",
  "esig.label.rejectionReason": "Rejection Reason",
  "esig.label.signingAs": "Signing as: {userName}",
  "esig.label.username": "Username",
  "esig.meaning.authored": "Authored",
  "esig.meaning.modified": "Modified",
  "esig.meaning.rejected": "Rejected",
  "esig.meaning.validatedAndReleased": "Validated and Released",
  "esig.placeholder.password": "Enter your password to confirm",
  "esig.placeholder.rejectionReason": "Enter the reason for rejection",
  "esig.placeholder.username": "Enter your username",
  "esig.title.certification": "Electronic Signature Certification",
  "esig.title.signature": "Electronic Signature",
  "example": "Example",
  "external.id": "External ID",
  "external.referrals.report": "External Referrals Report",
  "externalReferredOutTests.title": "External Referrals Report",
  "externalconnections.active": "Active",
  "externalconnections.add.title": "Add External Connection",
  "externalconnections.authtype": "Authentication Type",
  "externalconnections.authtype.basic.password": "Password",
  "externalconnections.authtype.basic.username": "Username",
  "externalconnections.browse.title": "External Connections",
  "externalconnections.deactivate.success": "External connection(s) deactivated successfully.",
  "externalconnections.description": "Description",
  "externalconnections.edit.title": "Edit External Connection",
  "externalconnections.name": "Name",
  "externalconnections.name.placeholder": "Enter connection name",
  "externalconnections.programmedconnection": "Connection Type",
  "externalconnections.save.success": "External connection saved successfully.",
  "externalconnections.search": "Search external connections",
  "externalconnections.search.placeholder": "Search by name or type",
  "externalconnections.select": "Select",
  "externalconnections.uri": "URI",
  "externalconnections.uri.placeholder": "e.g. https://server:port",
  "false.label": "False",
  "field.active": "Active/Not Active",
  "field.ageRange": "Age range",
  "field.dictionaryValues": "Dictionary Values",
  "field.loinc": "Loinc",
  "field.name": "Name",
  "field.normalRange": "Normal range",
  "field.note": "Note",
  "field.orderable": "Orderable/Not orderable",
  "field.panel": "Panel",
  "field.referenceValue": "Reference value",
  "field.reportName": "Report Name",
  "field.resultLimits": "Result limits",
  "field.resultType": "Result type",
  "field.sampleType": "Sample Type",
  "field.select.testSection": "Select Test Section",
  "field.selectValues": "Select values",
  "field.sex": "Sex",
  "field.significantDigits": "Significant digits",
  "field.testSection": "Test Section",
  "field.testUnit": "Test Unit",
  "field.uom": "Unit of measure",
  "field.validRange": "Valid range",
  "file.import.configuration.active": "Active",
  "file.import.configuration.analyzer": "Analyzer",
  "file.import.configuration.analyzer.emptyState": "No file import plugins installed",
  "file.import.configuration.analyzer.placeholder": "Select analyzer",
  "file.import.configuration.cancel": "Cancel",
  "file.import.configuration.columnMappings": "Column Mappings",
  "file.import.configuration.columnMappings.helperText": "JSON mapping of CSV columns to OpenELIS fields (e.g., {\"Sample_ID\": \"sampleId\", \"Result\": \"result\"})",
  "file.import.configuration.delimiter": "Delimiter",
  "file.import.configuration.delimiter.helperText": "CSV delimiter character (default: comma)",
  "file.import.configuration.error.save": "Failed to save file import configuration",
  "file.import.configuration.error.unknown": "An unknown error occurred",
  "file.import.configuration.fileFormat": "File Format",
  "file.import.configuration.fileFormat.placeholder": "Select file format",
  "file.import.configuration.filePattern": "File Pattern",
  "file.import.configuration.filePattern.helperText": "Glob pattern for matching files (e.g., *.csv, results_*.txt)",
  "file.import.configuration.hasHeader": "Has Header Row",
  "file.import.configuration.importDirectory": "Import Directory",
  "file.import.configuration.importDirectory.helperText": "Directory to watch for new files",
  "file.import.configuration.importDirectory.placeholder": "/data/import",
  "file.import.configuration.save": "Save",
  "file.import.configuration.success.created": "File import configuration created successfully",
  "file.import.configuration.success.updated": "File import configuration updated successfully",
  "file.import.configuration.title.add": "Add File Import Configuration",
  "file.import.configuration.title.edit": "Edit File Import Configuration",
  "file.import.configuration.validation.analyzerId.required": "Analyzer is required",
  "file.import.configuration.validation.columnMappings.invalid": "Invalid JSON format for column mappings",
  "file.import.configuration.validation.importDirectory.required": "Import directory is required",
  "fileImport.format.csv": "CSV",
  "fileImport.format.excel": "Excel",
  "fileImport.format.tsv": "TSV",
  "filters.label": "Filters",
  "freezer.alert.detail.acknowledge": "Acknowledge",
  "freezer.alert.detail.acknowledgedAt": "Acknowledged At",
  "freezer.alert.detail.acknowledgedBy": "Acknowledged By",
  "freezer.alert.detail.acknowledgmentNotes": "Acknowledgment Notes",
  "freezer.alert.detail.actions": "Actions Taken",
  "freezer.alert.detail.close": "Close",
  "freezer.alert.detail.correctiveAction": "Corrective Action",
  "freezer.alert.detail.correctiveActionDescription": "Description",
  "freezer.alert.detail.correctiveActionFailed": "Failed to log corrective action",
  "freezer.alert.detail.correctiveActionType": "Action Type",
  "freezer.alert.detail.delete": "Delete Alert",
  "freezer.alert.detail.deleteConfirm": "Delete this alert permanently?",
  "freezer.alert.detail.deleteFailed": "Failed to delete alert",
  "freezer.alert.detail.deletePermanently": "Delete permanently",
  "freezer.alert.detail.deleteWarning": "The start time, severity, acknowledgment and notes are removed with no audit trail and cannot be recovered.",
  "freezer.alert.detail.freezer": "Freezer",
  "freezer.alert.detail.id": "Alert ID",
  "freezer.alert.detail.logCorrectiveAction": "Log corrective action",
  "freezer.alert.detail.message": "Message",
  "freezer.alert.detail.method": "Method",
  "freezer.alert.detail.notes": "Notes",
  "freezer.alert.detail.notesPlaceholder": "Add notes about this alert...",
  "freezer.alert.detail.notifications": "Notifications Sent",
  "freezer.alert.detail.overview": "Alert Overview",
  "freezer.alert.detail.recipient": "Recipient",
  "freezer.alert.detail.resolutionNotes": "Resolution Notes",
  "freezer.alert.detail.resolve": "Resolve",
  "freezer.alert.detail.resolvedAt": "Resolved At",
  "freezer.alert.detail.resolvedBy": "Resolved By",
  "freezer.alert.detail.sentAt": "Sent At",
  "freezer.alert.detail.severity": "Severity",
  "freezer.alert.detail.startTime": "Start Time",
  "freezer.alert.detail.status": "Status",
  "freezer.alert.detail.summary": "Summary",
  "freezer.alert.detail.takenAt": "Taken At",
  "freezer.alert.detail.takenBy": "Taken By",
  "freezer.alert.detail.title": "Alert Details",
  "freezer.alert.severity.critical": "Critical",
  "freezer.alert.severity.warning": "Warning",
  "freezer.alert.status.acknowledged": "Acknowledged",
  "freezer.alert.status.closed": "Closed",
  "freezer.alert.status.escalated": "Escalated",
  "freezer.alert.status.open": "Open",
  "freezer.alert.status.resolved": "Resolved",
  "freezer.nav.corrective": "Corrective Actions",
  "freezer.nav.corrective.tooltip": "Manage corrective actions",
  "freezer.nav.dashboard": "Dashboard",
  "freezer.nav.dashboard.tooltip": "View cold storage monitoring dashboard",
  "freezer.nav.reports": "Reports",
  "freezer.nav.reports.tooltip": "Generate cold storage reports",
  "freezer.nav.settings": "Settings",
  "freezer.nav.settings.tooltip": "Configure cold storage settings",
  "freezer.nav.trends": "Historical Trends",
  "freezer.nav.trends.tooltip": "View temperature trends over time",
  "french.current": "FRENCH current",
  "french.label": "French",
  "from.title": "From",
  "genericSample.edit.success": "Sample updated successfully",
  "genericSample.edit.success.accession": "Accession Number: {accessionNumber}",
  "genericSample.edit.title": "Edit Sample",
  "genericSample.field.by": "By",
  "genericSample.field.count": "#",
  "genericSample.field.date": "Date",
  "genericSample.field.from": "From",
  "genericSample.field.id": "ID",
  "genericSample.field.labPersonReceived": "Lab person received",
  "genericSample.field.project": "Project",
  "genericSample.field.storageLocation": "Storage freezer # & location",
  "genericSample.field.type": "Type",
  "genericSample.notebook.selection.title": "Notebook Selection (Optional)",
  "genericSample.order.error.labNoRequired": "Please generate a Lab Number before saving.",
  "genericSample.order.generateLabNo": "Generate Lab Number",
  "genericSample.order.labNo.placeholder": "Click 'Generate Lab Number' to create",
  "genericSample.order.success.details": "Sample Details",
  "genericSample.order.success.message": "Sample order created successfully with accession number: {accessionNumber}",
  "genericSample.order.title": "Receive Sample",
  "gps.accuracy.display": "±{accuracy}m accuracy",
  "gps.accuracy.warning.message": "GPS accuracy is {accuracy}m, which exceeds the required {required}m threshold. Consider capturing the location again in a better position.",
  "gps.accuracy.warning.title": "GPS Accuracy Warning",
  "gps.button.clear": "Clear",
  "gps.button.getting.location": "Getting Location...",
  "gps.button.location.captured": "Location Captured",
  "gps.button.use.my.location": "Use My Location",
  "gps.collapse": "Collapse GPS section",
  "gps.config.accuracy.helper": "Maximum acceptable GPS accuracy in meters. Set to 0 to disable accuracy checking.",
  "gps.config.accuracy.label": "Required Accuracy (meters)",
  "gps.config.enabled.description": "When enabled, GPS coordinate fields will appear in the Order Entry workflow to capture sample collection locations.",
  "gps.config.enabled.label": "Enable GPS Coordinates",
  "gps.config.error.load": "Failed to load GPS configuration",
  "gps.config.save.error": "Failed to save GPS configuration",
  "gps.config.save.success": "GPS configuration saved successfully",
  "gps.config.saving": "Saving...",
  "gps.config.section.general": "GPS Settings",
  "gps.config.timeout.helper": "Maximum time to wait for GPS location in seconds.",
  "gps.config.timeout.label": "Timeout (seconds)",
  "gps.config.title": "GPS Coordinates Configuration",
  "gps.config.unsaved.changes": "You have unsaved changes. Are you sure you want to leave?",
  "gps.config.unsaved.subtitle": "Remember to save your changes before navigating away.",
  "gps.config.unsaved.title": "Unsaved Changes",
  "gps.config.validation.accuracy.negative": "Required accuracy cannot be negative",
  "gps.config.validation.accuracy.too.high": "Required accuracy cannot exceed 10,000 meters",
  "gps.config.validation.timeout.too.high": "Timeout cannot exceed 120 seconds",
  "gps.config.validation.timeout.too.low": "Timeout must be at least 1 second",
  "gps.coordinates.captured.via": "Captured via {method}",
  "gps.coordinates.current": "Current coordinates",
  "gps.error.not.supported": "GPS is not supported by this browser",
  "gps.error.permission.denied": "GPS access was denied. Please enable location permissions and try again.",
  "gps.error.position.unavailable": "GPS position is unavailable. Please check your device's location settings.",
  "gps.error.timeout": "GPS request timed out. Please try again.",
  "gps.error.title": "GPS Error",
  "gps.error.unknown": "An unknown GPS error occurred. Please try again.",
  "gps.info.description": "GPS coordinates record the geographic location where the sample was collected. This supports epidemiological surveillance and disease mapping.",
  "gps.info.title": "GPS Coordinates",
  "gps.latitude.helper": "Degrees North (+) or South (-), between -90 and 90",
  "gps.latitude.invalid": "Latitude must be between -90 and 90 degrees",
  "gps.latitude.label": "Latitude",
  "gps.latitude.placeholder": "e.g., -1.286389",
  "gps.longitude.helper": "Degrees East (+) or West (-), between -180 and 180",
  "gps.longitude.invalid": "Longitude must be between -180 and 180 degrees",
  "gps.longitude.label": "Longitude",
  "gps.longitude.placeholder": "e.g., 36.817223",
  "gps.manual.entry.off": "Off",
  "gps.manual.entry.on": "On",
  "gps.manual.entry.title": "Enter coordinates manually",
  "gps.manual.entry.toggle": "Manual coordinate entry",
  "gps.not.captured": "Not captured",
  "gps.section.description": "Capture the geographic location where this sample was collected for epidemiological tracking",
  "gps.section.title": "Collection Location (GPS)",
  "gps.status.captured": "Captured",
  "gps.status.optional": "Optional",
  "gps.tile.collapse": "Collapse GPS section",
  "gps.tile.expand": "Expand to add GPS coordinates",
  "gps.warning.partial.coordinates": "Both latitude and longitude should be provided for a valid location.",
  "header.ID": "ID",
  "header.assign": "Assign",
  "header.cancel.test": "Cancel Test",
  "header.formname": "FormName",
  "header.icon.help": "Help",
  "header.icon.lang": "Language",
  "header.icon.menu.close": "Close menu",
  "header.icon.menu.open": "Open menu",
  "header.icon.menu.pin": "Pin menu",
  "header.icon.menu.unpin": "Unpin menu",
  "header.icon.notifications": "Notifications",
  "header.icon.search": "Search",
  "header.icon.user": "User",
  "header.label.ARV": "ARV-initial",
  "header.label.EID": "Diagnostic for children with DBS-PCR",
  "header.label.changeLab": "Select Lab",
  "header.label.followup": "ARV-Follow-up",
  "header.label.intialFollowup": "ARV -->Initial-FollowUp-VL",
  "header.label.logout": "Logout",
  "header.label.nonconformityByDate": "Non-conformity Report By Date",
  "header.label.selectLab": "Select Lab",
  "header.label.selectlocale": "Select Locale",
  "header.label.specialRequest": "Special Request",
  "header.label.study.ciexport": "Export a CSV File by Date",
  "header.label.study.vlloadtrends": "Viral Load Data Export Report",
  "header.label.version": "Version:",
  "header.reject": "Reject",
  "header.rejection.reason": "Reject Reason",
  "header.results.recorded": "Results Recorded",
  "hide.aliquoting": "Hide Aliquoting",
  "holder.choose.availabletest": "Choose Available Test",
  "home.dashboard.title": "Dashboard",
  "home.label": "Home",
  "immunohistochemistry.label.addreport": "Add Report",
  "immunohistochemistry.label.averageChrom": "Average Chromozome 17 Sinals per nucleus",
  "immunohistochemistry.label.averageHer2": "Average HER2 per nucleus",
  "immunohistochemistry.label.cellIntensity": "intensity . Allred score",
  "immunohistochemistry.label.cellPercent": "% of cell show nuclear staining with",
  "immunohistochemistry.label.dashboard": "Immunohistochemistry DashBoard",
  "immunohistochemistry.label.her2Assesment": "HER 2 protein assesment is",
  "immunohistochemistry.label.her2Pattern": "CerbB2/HER 2 staining pattern",
  "immunohistochemistry.label.her2ScoreOf": "with a Score of",
  "immunohistochemistry.label.historicalDiagnosis": "Histological Diagnosis",
  "immunohistochemistry.label.ihcRatio": "Ratio of Her2/neu Signals to Chromozome 17",
  "immunohistochemistry.label.ihcScore": "IHC (Cerb2 Score)",
  "immunohistochemistry.label.mibName": " MiB 1(ki-67) (Proliferative Index): ",
  "immunohistochemistry.label.molecularType": " Molecular SubType",
  "immunohistochemistry.label.numberOfCancer": "Number of Cancer nuclei",
  "immunohistochemistry.label.outOf8": "out of 8",
  "immunohistochemistry.label.report": "Report",
  "immunohistochemistry.label.reports": "Reports",
  "immunohistochemistry.label.review": "Awaiting Immunohistochemistry Review",
  "immunohistochemistry.label.title": "Immunohistochemistry",
  "immunohistochemistry.label.tumorCells": "of tumor cells positive (cut off 20%)",
  "immunohistochemistry.status.completed": "Completed",
  "immunohistochemistry.status.inProgress": "In Progress",
  "immunohistochemistry.status.readyPathologist": "Ready for Pathologist",
  "import.autoGenerated": "Auto-generated",
  "import.created": "Created",
  "import.error.failed": "Import failed",
  "import.error.importFile": "Failed to import file",
  "import.error.selectFile": "Please select a file first",
  "import.error.validateFile": "Failed to validate file",
  "import.error.validateFirst": "Please validate the file first and fix any errors",
  "import.error.validationFailed": "Validation failed. Please check the errors below.",
  "import.failed": "Import Failed",
  "import.failedCount": "Failed",
  "import.header.collectionDate": "Collection Date",
  "import.header.errorMessage": "Error Message",
  "import.header.field": "Field",
  "import.header.from": "From",
  "import.header.labNo": "Lab No",
  "import.header.quantity": "Quantity",
  "import.header.row": "Row",
  "import.header.sampleType": "Sample Type",
  "import.header.samplesToCreate": "Samples to Create",
  "import.importing": "Importing...",
  "import.invalidRows": "Invalid Rows",
  "import.selectFile": "Select file",
  "import.status.invalid": "Invalid",
  "import.status.valid": "Valid",
  "import.success": "Import Successful",
  "import.totalRows": "Total Rows",
  "import.totalSamplesToCreate": "Total Samples to Create",
  "import.uploadFile": "Upload File",
  "import.uploadFileDesc": "Upload CSV or Excel file ({types})",
  "import.validRows": "Valid Rows",
  "import.validating": "Validating...",
  "import.validationStatus": "Validation Status",
  "input.error.same.panel.type": "An existing panel type with the same name has been found.  Please cancel or use a different name.",
  "input.placeholder.labNo": "Enter Lab Number",
  "input.placeholder.patientFirstName": "Enter Patient's First Name",
  "input.placeholder.patientId": "Enter Patient Id",
  "input.placeholder.patientLastName": "Enter Patient's Last Name",
  "input.placeholder.prevLabNumber": "Enter Previous Lab Number",
  "input.placeholder.providerEmail": "Enter Requester's Email",
  "input.placeholder.providerFax": "Enter Requester's Fax Number",
  "input.placeholder.providerWorkPhone": "Enter Requester's Phone Number",
  "input.placeholder.provisionalClinicalDiagnosis": "Enter Provisional Clinical Diagnosis",
  "input.placeholder.requesterFirstName": "Enter Requester's First Name",
  "input.placeholder.requesterLastName": "Enter Requester's Last Name",
  "input.placeholder.searchTestName": "Search testName Here",
  "input.placeholder.selectPanel": "Select Panel Type",
  "input.placeholder.selectPriority": "Select Priority",
  "input.placeholder.selectTest": "Select Test Type",
  "input.placeholder.selectTestSection": "Select Unit Type",
  "instructions.copy.labnum": "Copy Lab Number",
  "instructions.order.entry.eqa.enabled": "When enabled, a checkbox will appear on the Order Entry screen allowing staff to mark a sample as an EQA (External Quality Assurance) sample. Patient demographics will be auto-populated with N/A and locked.",
  "instructions.order.entry.requester": "When enabled, Search Requester and Requester First Name and Requester Last Name become required fields on the Add Order screen. When disabled (default), all three fields are optional.",
  "instructions.test.activation": "Active Tests: a checked box indicates an already active test. To activate a test, check the box; to deactivate, uncheck the box. Any sample types without an existing active test are deactivated and appear at the bottom, under 'Inactive Sample Types'. If one of the tests is activated, the sample type will be activated.",
  "instructions.test.activation.confirm": "Verify that these are the changes you want to make. If correct then save. If not correct use the back button to make the correct changes",
  "instructions.test.activation.sort": "Display Order: Lists of sample types which have newly activated tests. Sort the tests to indicate how they will be displayed in the order entry screen. Sorting can be done by dragging items to the desired position.",
  "instructions.test.order": "Test with checks are orderable, those without checks are not orderable.  Change checks to change status.  For a test to be able to be ordered on intake it must be both active and orderable.  Tests which are active but not orderable may be requested as part of a test reflex.",
  "invalid.json": "JSON is invalid",
  "inventory.add.button": "Add New Lot",
  "inventory.addItem.button": "Add Catalog Item",
  "inventory.consume.error.noLots": "No stock available for {name} ({code})",
  "inventory.consume.error.noLotsAwaitingQc": "No QC-passed stock for {name} ({code}): {count} lot(s) with stock are awaiting QC. Mark QC as passed to use them.",
  "inventory.consume.error.noLotsQcFailed": "No usable stock for {name} ({code}): {count} lot(s) with stock failed QC",
  "inventory.consume.error.noLotsQuarantined": "No usable stock for {name} ({code}): {count} lot(s) with stock are quarantined",
  "inventory.dashboard.title": "Inventory Dashboard",
  "inventory.export.button": "Export",
  "inventory.filter.all": "All",
  "inventory.filter.status": "Filter by Status",
  "inventory.item.error.duplicateCode": "An inventory item with code \"{code}\" already exists.",
  "inventory.item.error.codeGenerationExhausted": "Could not find a free code for prefix \"{prefix}\". Enter a code manually.",
  "inventory.list.title": "Inventory Items",
  "inventory.lot.error.duplicateBarcode": "Barcode \"{barcode}\" is already assigned to lot {lotNumber}",
  "inventory.lot.search.placeholder": "Search by item name, lot number or barcode",
  "inventory.metrics.expired": "Expired",
  "inventory.metrics.expiringSoon": "Expiring Soon",
  "inventory.metrics.lowStock": "Low Stock",
  "inventory.metrics.totalLots": "Total Lots",
  "inventory.tab.catalog": "Catalog",
  "inventory.tab.dashboard": "Dashboard",
  "inventory.tab.reports": "Reports",
  "inventory.title": "Inventory Management",
  "label.action": "Action",
  "labNumber.format.current": "Current Format",
  "labNumber.format.new": "New Format",
  "labNumber.prefix": "Prefix",
  "labNumber.type": "Lab Number Type",
  "labNumber.usePrefix": "Use Prefix",
  "label.actions": "Actions",
  "label.active": "Active",
  "label.actualTestName": "Actual Test Name",
  "label.add": "Add",
  "label.add.notification": "Add pop up notification to user",
  "label.all": "All",
  "label.analysisNotStarted": "Analysis not started",
  "label.any": "Any",
  "label.audittrail": "Lab No",
  "label.audittrail.Reports": "Audit Trail Reports",
  "label.audittrail.labNo.invalidaccessionnumber": "Invalid Accession Number",
  "label.audittrail.labNo.missing": "Lab No is required!",
  "label.audittrailreport.nextvisitdate": "Next Visit Date",
  "label.audittrailreport.priority": "Priority",
  "label.audittrailreport.program": "Program",
  "label.audittrailreport.receiveddate": "Received Date",
  "label.audittrailreport.requestdate": "Request Date",
  "label.audittrailreport.requester": "Requester",
  "label.audittrailreport.requester.firstname": "Requester's First Name",
  "label.audittrailreport.requester.lastname": "Requester's Last Name",
  "label.audittrailreport.sitename": "Site Name",
  "label.autoFilledFromServer": "Auto-filled from server",
  "label.barcode": "Barcode",
  "label.barcode.labelsets": "Number of label sets",
  "label.barcode.orderlabel": "Number of order labels per set",
  "label.barcode.specimenlabel": "Number of specimen labels per set",
  "label.barcode.totallabel": "Total Labels to Print",
  "label.button.action": "Action",
  "label.button.add": "Add",
  "label.button.add.question": "Add new Question",
  "label.button.cancel": "Cancel",
  "label.button.close": "Close",
  "label.button.changepassword": "Change Password",
  "label.button.clear": "Clear",
  "label.button.confirm": "Confirm",
  "label.button.confirmAction": "Confirm Action",
  "label.button.confirmDelete": "Confirm Delete",
  "label.button.confirmTitle": "Are You Sure ?",
  "label.button.delete": "Delete",
  "label.button.descritpion": "Description",
  "label.button.edit": "Edit",
  "label.button.activate": "Activate",
  "label.button.deactivate": "Deactivate",
  "label.button.exit": "Exit",
  "label.button.externalsearch": "External Search",
  "label.button.field": "Field",
  "label.button.finish": "Finish",
  "label.button.finished": "Finished",
  "label.button.generatePrintableVersion": "Generate Printable Version",
  "label.button.import": "Import",
  "label.button.login": "Login",
  "label.button.login.sso": "Single Sign On",
  "label.button.newEntry": "New Entry",
  "label.button.ok": "Ok",
  "label.button.previous": "Previous",
  "label.button.range": "Range",
  "label.button.remove": "Remove",
  "label.button.remove.report": "Remove Report",
  "label.button.remove.slide": "Remove Slide",
  "label.button.reset": "Reset",
  "label.button.sample": "Sample",
  "label.button.save": "Save",
  "label.button.saveconfig": "Save Configuration",
  "label.button.search": "Search",
  "label.button.select": "Select",
  "label.button.select.pathologist": "Select Pathologist",
  "label.button.select.status": "Select Status",
  "label.button.select.technician": "Select Technician",
  "label.button.select.test": "Select Test",
  "label.button.start": "Start",
  "label.button.submit": "Submit",
  "label.button.update": "Update",
  "label.button.uploadfile": "Upload file",
  "label.button.validate": "Validate",
  "label.button.viewReport": "View Report",
  "label.cancel": "Cancel",
  "label.cancel.test.no.replace": "Cancel test for lab numbers selected, do not assign a new test",
  "label.checkedWillBeModified": "Checked lab no. will be modified",
  "label.clear": "Clear Filters",
  "label.content": "Label Content",
  "label.confirm": "Confirm",
  "label.created.samples": "Created Samples",
  "label.critical.range": "Critical range",
  "label.currentTest": "Current test",
  "label.days": "days",
  "label.default.result": "Default result",
  "label.delete": "Delete",
  "label.description": "Description",
  "label.edit": "Edit",
  "label.electronic.orders": "Electronic Orders",
  "label.equals": "equals",
  "label.error": "Error",
  "label.existing.methods": "Existing Methods",
  "label.existing.test.sets": "Existing test sets",
  "label.filters.mycases": "My cases",
  "label.filters.status": "Status",
  "label.field.required": "This field is required",
  "label.status": "Status",
  "label.form.searchby": "Search By",
  "label.id": "ID",
  "label.import.errors": "Import Errors",
  "label.inactive": "Inactive",
  "label.inactive.methods": "Inactive Methods. Assign tests to activate.",
  "label.includeInactiveTests": "Include inactive tests",
  "label.inside.normalrange": "is inside the normal range",
  "label.lastPrinted": "Last printed: {date} {time} by {user}",
  "label.loading": "Loading...",
  "label.required": "required",
  "label.loinc": "LOINC",
  "label.management.title": "Label Management",
  "label.no": "No",
  "label.no.options.available": "No options available",
  "label.none": "None (no filter)",
  "label.notValidated": "Not validated",
  "label.notequals": "does not equal",
  "label.order.labNrPrefix": "Lab Nr",
  "label.order.patientPrefix": "Patient",
  "label.order.scan.text": "Scan OR Enter Manually OR",
  "label.orderable": "Orderable",
  "label.outside.normalrange": "is outside the normal range",
  "label.page.patientHistory": "Patient History",
  "label.preview.data": "Preview Data",
  "label.print": "Print Label",
  "label.print.error": "Error generating label. Please try again.",
  "label.print.error.popupBlocked": "Popup blocked. Please allow popups for this site to print labels.",
  "label.print.openDirectly": "Open the labels in a new tab",
  "label.print.generating": "Generating...",
  "label.print.success": "Label printed successfully",
  "label.print.description": "Print labels for orders and samples",
  "label.print.helper": "Select the type and quantity of labels to print",
  "label.print.success.count": "{count} labels printed successfully",
  "label.print.title": "Print Labels",
  "label.printAll": "Print All Labels",
  "label.printAll.success": "All labels printed successfully",
  "label.printConfirmation.message": "Print label for {name}{code}?",
  "label.printConfirmation.title": "Print Label",
  "label.printHistory": "Print History",
  "label.printHistory.byUser": "By {user}",
  "label.printHistory.count": "{count} labels",
  "label.printHistory.loading": "Loading print history...",
  "label.printHistory.never": "Never printed",
  "label.printHistory.unknownUser": "Unknown",
  "label.printHistory.viewAll": "View History",
  "label.printLabel": "Print Label",
  "label.program": "Program",
  "label.qualifiers": "Qualifiers",
  "label.quantity": "Quantity",
  "label.readonly": "Read Only",
  "label.reference.value": "Reference value",
  "label.refertest.referencelab": "Refer test to a reference lab",
  "label.rejectedByBiologist": "Rejected by biologist",
  "label.rejectedByTechnician": "Rejected by technician",
  "label.remove": "Remove",
  "label.replaceWith": "Replace with",
  "label.report.byNationalId": "By National ID / Unique Health ID number",
  "label.reporting.range": "Reporting range",
  "label.result.order": "Result order",
  "label.resultSelectList": "Result select list",
  "label.results.actions": "Actions",
  "label.results.anotherUser": "another user",
  "label.results.date": "Test date",
  "label.results.domain": "Clinical",
  "label.results.domain.env": "Water Quality",
  "label.results.domain.vector": "Vector Surveillance",
  "label.results.edit": "Edit",
  "label.results.inReviewBy": "In review by {0}",
  "label.results.labUnit": "Lab Unit",
  "label.results.load": "Load results",
  "label.results.loading": "Loading results...",
  "label.results.range": "Reference Range",
  "label.results.range.env": "Regulatory Limit",
  "label.results.range.vector": "Interpretation",
  "label.results.reflexTriggered": "Reflex/calculated tests added for:",
  "label.results.refresh": "Refresh",
  "label.results.result": "Result",
  "label.results.resultFor": "Result for {0}",
  "label.results.retry": "Try again",
  "label.results.save": "Save",
  "label.results.search": "Search by lab number",
  "label.results.searchByPatient": "Search by patient",
  "label.results.selectAnotherPatient": "Select another patient",
  "label.results.selectedPatient": "Selected patient",
  "label.results.selectedPatient.none": "None",
  "label.results.status": "Status",
  "label.results.status.all": "All",
  "label.results.subject": "Sample / Patient",
  "label.results.subject.env": "Sample / Site",
  "label.results.subject.vector": "Sample / Trap",
  "label.results.table.caption": "Results worklist",
  "label.results.test": "Test",
  "label.results.titer.placeholder": "e.g. 1:10",
  "label.results.method": "Method",
  "label.results.analyzer": "Analyzer",
  "label.results.analyzer.none": "Not from an instrument",
  "label.results.fromAnalyzer": "from analyzer",
  "label.results.methodAnalyzerHint": "Method is the analyzer type; Analyzer is the specific instrument.",
  "label.results.expandRow": "Expand row",
  "label.results.collapseRow": "Collapse row",
  "label.results.referredOut": "Referred out",
  "label.results.notes": "Notes",
  "label.results.note.context": "Context",
  "label.results.note.context.entry": "Entry",
  "label.results.note.context.modification": "Modification",
  "label.results.note.context.auto": "Set automatically from what you are doing.",
  "label.results.note.visibility": "Visibility",
  "label.results.note.internal": "In lab only",
  "label.results.note.external": "Send with result",
  "label.results.note.analysisLevel": "Analysis-level",
  "label.results.note.externalWarning": "This note will appear on the patient report.",
  "label.results.note.placeholder": "Add a note…",
  "label.results.dilution.measured": "Measured value",
  "label.results.dilution.factor": "Dilution factor",
  "label.results.dilution.reported": "Reported value: {0}",
  "label.results.saveHint": "Saving records your e-signature. Critical acknowledgment never blocks Save.",
  "label.results.flag.normal": "Normal",
  "label.results.flag.abnormal": "Abnormal",
  "label.results.flag.critical": "Critical",
  "label.results.flag.invalid": "Invalid",
  "label.results.sample": "Sample",
  "label.results.flag": "Flag",
  "label.results.order.clinician": "Ordering clinician",
  "label.results.order.phone": "Phone",
  "label.results.order.site": "Requesting site",
  "label.results.order.priority": "Priority",
  "label.results.order.collection": "Collection",
  "label.results.section.program": "Program info",
  "label.results.program.name": "Program",
  "label.results.program.eqa": "EQA",
  "label.results.program.readonly": "Program fields are read-only here — edit on the originating order.",
  "label.results.section.storage": "Storage & sample disposal",
  "label.results.storage.location": "Location",
  "label.results.storage.position": "Position",
  "label.results.storage.notes": "Notes",
  "label.results.storage.unassigned": "No storage assignment",
  "label.results.storage.assignLocation": "Assign Location",
  "label.results.storage.moveLocation": "Move to Location",
  "label.results.program.capturedData": "Programme data",
  "label.results.sampleStatus.title": "Sample status",
  "label.results.sampleStatus.volume": "Volume: {0} remaining of {1} · status {2}.",
  "label.results.sampleStatus.noVolume": "Status {0}.",
  "label.results.sampleStatus.available": "available",
  "label.results.sampleStatus.usedUp": "used up (exhausted)",
  "label.results.sampleStatus.disposed": "disposed",
  "label.results.sampleStatus.recordUse": "Record amount used",
  "label.results.sampleStatus.markUsedUp": "Mark used up",
  "label.results.sampleStatus.startDisposal": "Start disposal",
  "label.results.sampleStatus.amountUsed": "Amount used this test",
  "label.results.sampleStatus.record": "Record",
  "label.results.sampleStatus.recordHint": "Decrements remaining volume — the sample is not disposed until exhausted or explicitly marked used up.",
  "label.results.sampleStatus.usedUpNote": "The sample is exhausted and queued for the disposal workflow. Disposal records who, when, and method.",
  "label.results.sampleStatus.disposalReason": "Disposal reason",
  "label.results.sampleStatus.disposalMethod": "Disposal method",
  "label.results.sampleStatus.disposalNotes": "Notes",
  "label.results.sampleStatus.confirmDisposal": "Confirm disposal",
  "label.results.sampleStatus.updateFailed": "The sample status was not updated because the server did not respond. Check the connection and try again.",
  "label.results.sampleStatus.reason.expired": "Expired",
  "label.results.sampleStatus.reason.contaminated": "Contaminated",
  "label.results.sampleStatus.reason.patient_request": "Patient Request",
  "label.results.sampleStatus.reason.testing_complete": "Testing Complete",
  "label.results.sampleStatus.reason.other": "Other",
  "label.results.sampleStatus.method.autoclave": "Biohazard Autoclave",
  "label.results.sampleStatus.method.neutralization": "Chemical Neutralization",
  "label.results.sampleStatus.method.incineration": "Incineration",
  "label.results.sampleStatus.method.other": "Other",
  "label.results.sampleStatus.footnote": "Partial use records the amount consumed against the sample item's remaining volume; full exhaustion (or Mark used up) triggers disposal.",
  "label.results.section.reagents": "Reagents, QC & Controls",
  "label.results.reagents.summary.analyzer": "analyzer-reported lot",
  "label.results.reagents.summary.manual": "manual capture",
  "label.results.reagents.mode.analyzer": "capture mode: analyzer-reported",
  "label.results.reagents.mode.manual": "capture mode: manual (optional)",
  "label.results.reagents.analyzerNote": "Reported by {0} in its result payload — read-only.",
  "label.results.reagents.lotsUsed": "Reagent lots used",
  "label.results.reagents.noneLinked": "No reagents linked to this test — links are configured in the Test Catalog.",
  "label.results.reagents.noLots": "No available lots in inventory for this reagent.",
  "label.results.reagents.perTest": "{0} {1} per test",
  "label.results.reagents.fefo": "FEFO Suggested",
  "label.results.reagents.expires": "Exp {0} ·",
  "label.results.reagents.remaining": "{0} {1} remaining",
  "label.results.reagents.quantityUsed": "Quantity used",
  "label.results.reagents.recordUse": "Record use",
  "label.results.reagents.recorded": "Recorded {0} {1} — consumed FEFO across lots.",
  "label.results.reagents.recordFailed": "Could not record reagent use.",
  "label.results.reagents.amountInvalid": "Quantity used must be a positive number.",
  "label.results.reagents.consumeNote": "Recording use decrements inventory (FEFO) and writes a consumption transaction linked to this analysis.",
  "label.results.control.title": "Control result",
  "label.results.control.noneConfigured": "No control lots configured for this test and analyzer.",
  "label.results.control.viewResults": "View control results",
  "label.results.control.capture.controlLine": "Control line",
  "label.results.control.capture.valid": "Valid",
  "label.results.control.capture.invalid": "Invalid",
  "label.results.control.capture.kitLot": "Kit lot",
  "label.results.control.capture.outcome": "Outcome",
  "label.results.control.capture.lot": "Control lot",
  "label.results.control.capture.measured": "Measured value",
  "label.results.control.capture.expected": "Expected value",
  "label.results.control.capture.uncertainty": "Uncertainty (±)",
  "label.results.control.capture.record": "Record control result",
  "label.results.control.capture.recorded": "Control result recorded.",
  "label.results.control.capture.recordedBlocked": "Control result recorded. Reporting is blocked for covered results until a passing repeat is recorded.",
  "label.results.control.capture.blockedHint": "A failing control blocks reporting for covered results — a repeat run is expected.",
  "label.results.control.capture.noBenchLots": "No bench control lot is configured for this test — add one under QC → Control Lots before recording a quantitative control.",
  "label.results.control.capture.incomplete": "Complete the control result fields before recording.",
  "label.results.control.capture.failed": "Recording the control result failed.",
  "label.results.dilution.title": "Dilution",
  "label.results.section.attachments": "Attachments",
  "label.results.attachments.summary": "{0} file(s)",
  "label.results.attachments.none": "none",
  "label.results.attachments.empty": "No attachments on this order yet.",
  "label.results.attachments.add": "Add attachment",
  "label.results.attachments.tooLarge": "File exceeds the 10 MB limit.",
  "label.results.attachments.uploadFailed": "Upload failed — PDF, JPG, PNG, or TIFF up to 10 MB.",
  "label.results.attachments.resultsScope": "Results",
  "label.results.attachments.orderScope": "Order Entry",
  "label.results.attachments.view": "View",
  "label.results.attachments.download": "Download",
  "label.results.section.interpretation": "Interpretation",
  "label.results.interpretation.summary": "enter via rule or free text",
  "label.results.interpretation.ruleFired": "rule fired ({0}) · auto-open",
  "label.results.interpretation.autoOpen": "rule fired · auto-open",
  "label.results.interpretation.ruleBanner": "Rule match (configured on the test): the entered value {0} falls in {1}. Pick a category to apply its interpretation text, then edit as needed.",
  "label.results.interpretation.match": "matches value",
  "label.results.interpretation.freeText": "Interpretation (free text)",
  "label.results.interpretation.footnote": "Interpretation can be set by a rule configured on the test (the categorical buckets, auto-matched to the value) or free text. Rule text is a non-binding suggestion until applied or edited. Saving sends it with the result to the report.",
  "label.results.nce.disposition": "Result disposition",
  "label.results.nce.disposition.hint": "Applied when the NCE is submitted. Refer-out is a separate row action, not a disposition.",
  "label.results.nce.disposition.none": "None",
  "label.results.nce.disposition.none.detail": "File the NCE without changing the result.",
  "label.results.nce.disposition.cancel": "Cancel result",
  "label.results.nce.disposition.cancel.detail": "Voided. No value reported. Common for pre-analytical NCEs.",
  "label.results.nce.disposition.reject": "Reject + reason",
  "label.results.nce.disposition.reject.detail": "Clears the value and records the reason. Applied by your e-signature Save.",
  "label.results.nce.disposition.retest": "Retest",
  "label.results.nce.disposition.retest.detail": "Orders the same test again on this sample; the repeat appears as pending.",
  "label.results.nce.disposition.rejectArmed": "Rejection armed on the row — Save (e-signature) to apply it.",
  "label.results.nce.disposition.cancelled": "Result cancelled.",
  "label.results.nce.disposition.retested": "Retest ordered.",
  "label.results.critical.range": "Critical",
  "label.results.critical.banner.title": "Critical value — physician notification required",
  "label.results.critical.banner.notify": "The responsible clinician must be notified. Record that on the Alerts dashboard and log the call below.",
  "label.results.critical.acknowledge": "I Acknowledge",
  "label.results.critical.acknowledged": "Acknowledged",
  "label.results.critical.comment": "Acknowledgment comment",
  "label.results.critical.comment.placeholder": "e.g. Physician notified by phone",
  "label.results.section.history": "History (this analysis)",
  "label.results.history.summary": "{0} events",
  "label.results.history.summary.unloaded": "revisions · status · retests",
  "label.results.history.when": "When",
  "label.results.history.event": "Event",
  "label.results.history.detail": "Detail",
  "label.results.history.by": "By",
  "label.results.history.event.CREATED": "Created",
  "label.results.history.event.STATUS": "Status",
  "label.results.history.event.RESULT": "Result",
  "label.results.history.event.NOTE": "Note",
  "label.results.history.event.RETEST": "Retest",
  "label.results.history.event.REFLEX": "Reflex",
  "label.results.history.event.OTHER": "Event",
  "label.results.history.empty": "No recorded events yet for this analysis.",
  "label.results.history.footnote": "This analysis only — revisions, status transitions, retests, corrections, notes and audit entries. Patient trends live on the patient record; Westgard rules on the QC dashboard.",
  "label.results.nce.report": "Report Non-Conformity",
  "label.results.reject.result": "Reject result",
  "label.results.reject.reason": "Rejection reason",
  "label.results.reject.hint": "Saving with a rejection clears the value, records the reason, and marks the analysis Technical Rejected.",
  "label.results.referral.refer": "Refer this test",
  "label.results.referral.editing": "Referral pending — edit",
  "label.results.referral.organization": "Reference laboratory",
  "label.results.referral.reason": "Referral reason",
  "label.results.referral.date": "Referral date",
  "label.results.referral.reportDate": "Reference lab report date",
  "label.results.referral.hint": "The referral is recorded when you Save this row and hands off to the Referrals dashboard.",
  "label.results.referral.cancel": "Discard",
  "label.results.referral.incomplete": "Choose the reference laboratory and the referral reason, or discard the referral, before saving this row.",
  "label.results.section.aliquots": "Aliquots",
  "label.results.aliquots.summary": "{0} aliquots",
  "label.results.aliquots.summary.unloaded": "list · create",
  "label.results.aliquots.labNo": "Lab No",
  "label.results.aliquots.quantity": "Quantity",
  "label.results.aliquots.createdDate": "Created",
  "label.results.aliquots.empty": "No aliquots yet for this sample item.",
  "label.results.aliquots.count": "Number of aliquots",
  "label.results.aliquots.totalQuantity": "Total quantity to transfer",
  "label.results.aliquots.notes": "Notes",
  "label.results.aliquots.create": "Create aliquots",
  "label.results.aliquots.created": "Aliquots created.",
  "label.results.aliquots.failed": "Could not create aliquots.",
  "label.results.aliquots.remaining": "Parent remaining quantity",
  "label.results.history.event.REFERRAL": "Referred",
  "label.results.history.event.NCE": "Non-conformity",
  "label.results.history.event.CRITICAL_ACK": "Critical acknowledged",
  "label.results.history.event.INVALID_CONFIRMED": "Outside valid range confirmed",
  "label.results.alert.critical.title": "Critical result",
  "label.results.alert.critical.defaultMessage": "This is a critical result. Notify the responsible clinician according to your laboratory procedure.",
  "label.results.alert.invalid.title": "Value outside the valid range",
  "label.results.alert.invalid.body": "This value is outside the valid range for this test ({low} to {high}). Check it before saving.",
  "label.results.alert.correct": "Correct the value",
  "label.results.alert.keepValue": "Keep this value",
  "label.results.alert.confirmAndSave": "Confirm and save",
  "label.results.alert.acknowledgeAndSave": "Acknowledge and save",
  "label.results.callback.logged": "Callback logged",
  "label.results.referenceZone": "Reference & context",
  "label.results.layoutRemembered": "Layout remembered",
  "label.results.resetLayout": "Reset layout",
  "label.results.section.orderInfo": "Order info",
  "label.results.sampleType": "Sample type",
  "label.results.testDate": "Test date",
  "label.results.receivedDate": "Received",
  "label.results.technician": "Technician",
  "label.routine.Reports": "Routine Reports",
  "label.sample.types.activate": "The following sample types will be activated:",
  "label.sample.types.deactivate": "The following sample types will be deactivated because they have no tests:",
  "label.save": "Save",
  "label.saving": "Saving...",
  "label.search.available.targetest": "Search Available Tests",
  "label.search.availablepanel": "Search Available panel",
  "label.search.labno.family": "Search by LabNo or Family Name",
  "label.search.patient": "Search Patient",
  "label.select": "Select",
  "label.select.dateRange": "Select the Date Range you want the Report For",
  "label.select.list.options": "Select list options",
  "label.selectTestSectionCatalog": "Select test section to view catalog for that section",
  "label.sex.dependent": "Sex dependent",
  "label.shortCode": "Short Code",
  "label.shortCode.error.invalidChars": "Short code can only contain letters, numbers, hyphens, and underscores",
  "label.shortCode.error.maxLength": "Short code must be 10 characters or less",
  "label.shortCode.error.network": "Could not verify uniqueness. Please check manually.",
  "label.shortCode.error.save": "Error saving short code: {error}",
  "label.shortCode.error.startChar": "Short code must start with a letter or number",
  "label.shortCode.helper": "Max 10 characters, alphanumeric, hyphen, underscore",
  "label.shortCode.optional.helper": "Optional (code will be used if ≤10 chars). Max 10 characters, alphanumeric with hyphens/underscores",
  "label.shortCode.required.helper": "Required when code > 10 characters. Max 10 characters, alphanumeric with hyphens/underscores",
  "label.shortCode.update.success": "Short code updated successfully",
  "label.shortCodeRequired": "Short code is required for label printing. Please set short code in Edit form first.",
  "label.shortCodeWarning": "Changing short code will invalidate existing labels",
  "label.showChildren": "Show Child Elements",
  "label.study.Reports": "Study Reports",
  "label.test.name": "Test Name",
  "label.test.activate": "The following tests will be activated:",
  "label.test.add": "Add test to order",
  "label.test.batch.cancel.finish": "This is non-reversible.",
  "label.test.batch.cancel.start": "You have selected to cancel the test",
  "label.test.batch.no.change.finish": "tests will not be changed.",
  "label.test.batch.replace.start": "The following",
  "label.test.batch.replace.with": "You have selected to replace the test {current} with {replacements}.",
  "label.test.deactivate": "The following tests will be deactivated:",
  "label.test.display.order": "Test display order",
  "label.test.order.confirm": "Verify: Enable/disable test orderability",
  "label.test.activation.confirm": "Verify: Activate/deactivate tests",
  "label.test.orderable": "The following tests will be orderable from the order form.",
  "label.test.results": "Test Results",
  "label.test.resultsData": "Test results data",
  "label.test.unorderable": "The following tests will not be orderable on order form.  They will only be orderable as a reflexed test.",
  "label.testActivate": "Test Activation",
  "label.testName": "Test names",
  "label.text.generate": "generate",
  "label.total.tests": "Total Tests",
  "label.type": "Label Type",
  "label.type.order": "Order Label",
  "label.type.pool": "Pool of {count} {animal}",
  "label.type.sample": "Sample Label",
  "label.unit": "Unit",
  "label.user.notestsection": "Current User has no Assined Lab Unit . Please Contact admin",
  "label.validation.errors": "Validation Errors",
  "label.validation.results": "Validation Results",
  "label.view": "View",
  "label.viewtestCatalog": "Test Catalog",
  "label.warning": "Warning",
  "label.yes": "Yes",
  "labno.alt.prefix.instruction": "Prefix for pre-printed barcode labels (4 characters) :",
  "labno.alt.prefix.note": "NOTE: If this prefix has already been used, the numbering will continue from the last number generated.",
  "labno.alt.prefix.use": "Use the same accession number format and pool of available numbers as Order Entry Generation.",
  "language.select.label": "English",
  "legend.search.availabletests": "Search through the available tests",
  "loading": "Loading...",
  "loading.boxes": "Loading boxes...",
  "loading.description": "Loading...",
  "location.collection.title": "Collection Location",
  "location.environmentalConditions": "Environmental Conditions",
  "location.environmentalConditions.placeholder": "e.g. 25°C, clear weather",
  "location.gps.error": "Unable to get location",
  "location.gps.getCurrent": "Get Current Location",
  "location.gps.getting": "Getting location...",
  "location.gps.latitude": "GPS Latitude",
  "location.gps.longitude": "GPS Longitude",
  "location.gps.notSupported": "Geolocation is not supported by your browser",
  "location.gps.permissionDenied": "Location permission denied",
  "location.gps.timeout": "Location request timed out",
  "location.gps.unavailable": "Location information unavailable",
  "location.helper": "Location hierarchy (Region / District / Town-Village) uses the existing system of Location structure. Environmental workflow profiles allow some rows to be unlabeled to provide simpler or shorter row sets for setup as required.",
  "location.requesterReference": "Requester Reference",
  "location.requesterReference.placeholder": "e.g. EPA Method 524.2",
  "location.select.placeholder": "Select {levelName}...",
  "location.siteDescription": "Collection Site Description",
  "location.siteDescription.placeholder": "e.g. Municipal water supply intake point",
  "locale.active": "Active",
  "locale.add": "Add Language",
  "locale.add.title": "Add Language",
  "locale.code": "Locale Code",
  "locale.code.helper": "e.g., en, fr, es, pt",
  "locale.create.success": "Language created successfully",
  "locale.delete.confirm.message": "Are you sure you want to delete this language? This action cannot be undone.",
  "locale.delete.confirm.title": "Delete Language",
  "locale.delete.error": "Failed to delete language",
  "locale.delete.fallback.error": "Cannot delete the fallback language. Set another language as fallback first.",
  "locale.delete.success": "Language deleted successfully",
  "locale.displayName": "Display Name",
  "locale.displayName.helper": "e.g., English, Français, Español",
  "locale.edit.title": "Edit Language",
  "locale.fallback": "Fallback",
  "locale.fallback.error": "Failed to set fallback language",
  "locale.fallback.success": "Fallback language updated",
  "locale.management.description": "Manage supported languages for metadata translations.",
  "locale.management.title": "Language Management",
  "locale.setFallback": "Set as Fallback",
  "locale.sortOrder": "Sort Order",
  "locale.status": "Status",
  "locale.update.success": "Language updated successfully",
  "log.submitting.aliquot.data": "Submitting aliquot data:",
  "log.submitting.aliquot.data2": "Submitting aliquot data (JSON):",
  "logging.management.apply": "Apply Log Level",
  "logging.management.description": "Change the backend logging level at runtime. This is useful for debugging issues without restarting the server. Changes take effect immediately but do not persist across server restarts.",
  "logging.management.label": "Logging Configuration",
  "logging.management.level": "Log Level",
  "logging.management.logger": "Logger Name",
  "logging.management.logger.helper": "e.g., org.openelisglobal, root",
  "logging.management.success": "Log level set to {level} for {logger}",
  "login.account.disabled": "Account Disabled",
  "login.account.locked": "Account Locked",
  "login.complexity.message": "Password must : ",
  "login.complexity.message.1": "Must Be at least 7 characters",
  "login.complexity.message.2": "May contain upper and lower case letters or numbers",
  "login.complexity.message.3": "Must contain at least one of the following characters: *, $, #, !",
  "login.complexity.message.4": "Must not contain any other characters",
  "login.complexity.new.message": "New Password must : ",
  "login.complexity.new.message.1": "Must not be the same as the current password",
  "login.error.account.disable": "Your account has been disabled. Please contact system administrator.",
  "login.error.password.current.incorrect": "The current password you entered is incorrect. Please try again.",
  "login.error.password.expired": "Your password has expired. Please contact system administrator.",
  "login.error.update.message": "Update password failed. Please try again.",
  "login.login.": "Repeat Password",
  "login.login.current.password": "Current Password",
  "login.login.first": "First Name",
  "login.login.last": "Last Name",
  "login.login.name": "Login Name",
  "login.login.new.password": "New Password",
  "login.login.password": "Password",
  "login.login.repeat.password": "Repeat Password",
  "login.msg.password": "Password",
  "login.msg.password.missing": "A password is required",
  "login.msg.username": "Username",
  "login.msg.username.missing": "A username is required",
  "login.notice.message": "Notice: Access to this service is for authorized personnel only. If you do not have the expressed authorization of the administrator, you must exit now. This organization prohibits unauthorized access, disclosure, duplication, modification, diversion, destruction, loss, misuse, or theft of its information.",
  "login.password.expired.date": "Password Expiration Date",
  "login.password.expired.date.placeholder": "(dd/mm/yyyy)",
  "login.redirecting.sso": "Redirecting to single sign-on...",
  "login.subtitle": "Login",
  "login.timeout": "User Time Out (minutes)",
  "login.timeout.placeholder": "Enter in ms",
  "login.title": "Login",
  "lot.barcode": "Barcode",
  "lot.barcode.assign": "This lot has no barcode yet. Enter one now; it is locked once saved.",
  "lot.barcode.hint": "Leave blank to generate one from the item code and lot number.",
  "lot.barcode.locked": "Barcode is locked once saved so printed labels keep working.",
  "lot.barcode.placeholder": "Leave blank to auto-generate",
  "lot.barcode.placeholder.assign": "Enter a barcode",
  "lot.calculatedExpiry": "Calculated Expiry",
  "lot.currentQuantity": "Current Quantity",
  "lot.dateOpened": "Date Opened",
  "lot.details.no.movements": "No movements recorded for this lot",
  "lot.details.no.transactions": "No transactions recorded for this lot",
  "lot.details.no.usage": "No usage history for this lot",
  "lot.details.section.basic": "Basic Information",
  "lot.details.section.dates": "Important Dates",
  "lot.details.section.movements": "Movement History",
  "lot.details.section.quantities": "Quantities",
  "lot.details.section.storage": "Storage Location",
  "lot.details.section.transactions": "Transaction History",
  "lot.details.section.usage": "Usage History",
  "lot.details.tab.info": "Information",
  "lot.details.tab.transactions": "Transactions",
  "lot.details.tab.usage": "Usage History",
  "lot.details.title": "Lot Details",
  "lot.details.view": "View Details",
  "lot.expirationDate": "Expiration Date",
  "lot.form.title.add": "Receive New Inventory Lot",
  "lot.form.title.edit": "Edit Inventory Lot",
  "lot.initialQuantity": "Initial Quantity",
  "lot.label.print": "Print label",
  "lot.label.print.failed": "Could not generate the label. Please try again.",
  "lot.number": "Lot Number",
  "lot.number.hint": "Stable identifier for this lot. Leave blank and we'll generate one from the item code and today's date.",
  "lot.number.placeholder": "Leave blank to auto-generate",
  "lot.qcStatus.FAILED": "Failed",
  "lot.qcStatus.PASSED": "Passed",
  "lot.qcStatus.PENDING": "Pending",
  "lot.qcStatus.QUARANTINED": "Quarantined",
  "lot.qcStatus.hint": "Lots stay unusable for testing until QC is marked Passed.",
  "lot.qcStatus": "QC Status",
  "lot.receiptDate": "Receipt Date",
  "lot.save.error": "Error saving lot",
  "lot.save.error.locationAfterCreate": "The lot was created, but assigning its storage location failed. Press Save again to retry the assignment only, so the lot is not received twice. {reason}",
  "lot.save.success": "Lot saved successfully",
  "lot.selectItem": "Select Catalog Item",
  "lot.selectLocation": "Select Storage Location",
  "lot.status": "Status",
  "lot.status.ACTIVE": "Active",
  "lot.status.CONSUMED": "Consumed",
  "lot.status.DISPOSED": "Disposed",
  "lot.status.EXPIRED": "Expired",
  "lot.status.IN_USE": "In Use",
  "lot.status.QUARANTINED": "Quarantined",
  "lot.storageLocation": "Storage Location",
  "manage.testing.algorithms.add.reflex.tests": "Manage Testing Algorithms and Reflex tests",
  "master.lists.page": "Master Lists Page",
  "master.lists.page.analyzer": "Analyzer TestName Menu",
  "master.lists.page.barcode": "Barcode Configuration",
  "master.lists.page.batchtest": "Batch test reassignment and cancelation",
  "master.lists.page.external.connections": "External Connections Menu",
  "master.lists.page.field": "Field Validation Configuration ",
  "master.lists.page.list": "List Plugins",
  "master.lists.page.menu": "Menu Configuration",
  "master.lists.page.notification": "Test Notification Configuration",
  "master.lists.page.order.entry": "Order Entry Configuration",
  "master.lists.page.org": "Organization Menu",
  "master.lists.page.patient": "Patient Entry Configuration",
  "master.lists.page.printed": "Printed Reports Configuration",
  "master.lists.page.provider": "Provider",
  "master.lists.page.report.result": "Result Reporting Configuration",
  "master.lists.page.result": "Result Entry Configuration",
  "master.lists.page.site": "Site Information",
  "master.lists.page.test.management": "Test Management",
  "master.lists.page.user": "User Management",
  "master.lists.page.work.plan": "Workplan Configuration ",
  "menu.accession.validation": "By Order",
  "menu.accession.validation.range": "By Range of Order Numbers",
  "menu.billing.active": "Billing Menu Active",
  "menu.billing.address": "Billing URL",
  "menu.billing.title": "Billing Menu Management",
  "menu.genericSample": "Generic Sample",
  "menu.genericSample.edit": "Edit Order",
  "menu.genericSample.import": "Import",
  "menu.genericSample.order": "Order",
  "menu.global.title": "Global Menu Management",
  "menu.label.filter": "Filters : ",
  "menu.label.filter.active": "Only Active",
  "menu.label.filter.admin": "Only Administrator",
  "menu.label.filter.role": "By Lab Unit Roles",
  "menu.nonconform.active": "Non-Conformity Menu Active",
  "menu.nonconform.title": "Non-Conformity Menu Management",
  "menu.patient.active": "Patient Menu Active",
  "menu.patient.title": "Patient Menu Management",
  "menu.results.range": "By Range of Order numbers",
  "menu.sidenav.active": "Side Nav Active",
  "menu.study.active": "Study Menu Active",
  "menu.study.title": "Study Menu Configuration",
  "menu.validation.date": "By Date",
  "message.method.activation": "This method unit will not be active until at least one test has been assigned to it.",
  "message.propertiesupdate.success": "Properties updated successfully",
  "method.browse.title": "Method Section",
  "method.methodName": "Method Name",
  "method.modal.add.heading": "Add New Method",
  "modal.add.method": "Add New Method",
  "move.back": "Move Back",
  "move.to.aliquot": "Move to Aliquot",
  "new.patient.label": "New Patient",
  "next.action.button": "Next",
  "nextLabel.action.button": "Next Label",
  "no.aliquots": "No aliquots available",
  "no.analysis.found": "No analyses found",
  "no.data.found": "No Data Found",
  "no.option": "No",
  "noTestsFound.matching": "No test found matching",
  "nonconform.add.new.date": "Add new date",
  "nonconform.corrective.action": "Planned or recommended corrective action:",
  "nonconform.corrective.actionType": "Action Type",
  "nonconform.corrective.comment": "Comments",
  "nonconform.corrective.control": "Planned or recommended corrective preventive action or concurrent controls:",
  "nonconform.corrective.title": "Nonconforming Events Corrective Action",
  "nonconform.date.completed": "Date Completed",
  "nonconform.date.discussion.nce": "Date of discussion with NCE Staff",
  "nonconform.date.event": "Date of Event",
  "nonconform.description.nce": "Description of NCE",
  "nonconform.field.date": "NCE Date",
  "nonconform.field.reporting.data": "Reporting Date",
  "nonconform.goToNceForm": "Go to NCE Reporting Form",
  "nonconform.lab.componenet.nce": "Laboratory Component where NCE took place",
  "nonconform.label.highseverity": "9 = very high severity-- immediate action is required",
  "nonconform.label.lowseverity": "1 = very low severity-- no immediate action is required",
  "nonconform.label.prescibernamesite": "Prescriber Name and Site",
  "nonconform.label.proposed.action": "Proposed Action",
  "nonconform.label.reportingunit": "Reporting Unit",
  "nonconform.label.suspected.cause.nce": "Suspected Cause of NCE",
  "nonconform.nce.concurrent.control.action": "concurrent control action",
  "nonconform.nce.number": "NCE Number",
  "nonconform.nce.preventive.action": "preventive action",
  "nonconform.nce.resolution": "NCE Resolution",
  "nonconform.nce.resolution.description": "Were the corrective actions and preventive/concurrentcontrols effective in solving the nonconforming event and preventing it from recurring?",
  "nonconform.nce.turnaround.time": "Turnaround Time",
  "nonconform.order.save.fail": "Save failed",
  "nonconform.order.save.failBecause": "Save failed: {reason}",
  "nonconform.search.nceNumber": "NCE Number",
  "nonconform.column.date": "Date",
  "nonconform.column.labSection": "Lab Section/Unit",
  "nonconform.search.lastName": "Last Name",
  "nonconform.search.firstName": "First Name",
  "nonconform.search.patientCode": "Patient Identification Code",
  "nonconform.search.labNumber": "Lab Number",
  "nonconform.search.specimenType": "Specimen type",
  "nonconform.order.save.success": "Save was successful",
  "nonconform.person.reporting.different": "Name of person reporting NCE (if different)",
  "nonconform.person.responsible": "Person responsible",
  "nonconform.report": "Report Non-Conforming Event (NCE)",
  "nonconform.report.field.date": "Report Date",
  "nonconform.severity.score": "Severity Score",
  "nonconform.view.comments": "Comments",
  "nonconform.view.corrective.action.description": "Description of corrective action to take",
  "nonconform.view.event.date": "Date of Event",
  "nonconform.view.event.description": "Description of Event",
  "nonconform.view.lab.component": "Laboratory Component",
  "nonconform.view.nce.category": "NCE Category",
  "nonconform.view.nce.likely.occur": "How likely is the NCE to recur?",
  "nonconform.view.nce.severity": "Severity",
  "nonconform.view.nce.type": "NCE Type",
  "nonconform.view.preventive.description": "If applicable, description of preventive or concurrent control action",
  "nonconform.view.report": "View New Non Conform Event",
  "nonconform.view.reporting.person": "Reporting Person",
  "nonconform.view.severe.consequences": "How severe are the consequences or impact of the NCE?",
  "nonconform.view.specimen": "Specimen(s)",
  "nce.attachment.dropzone": "Drag and drop files here or click to upload",
  "nce.attachment.error.maxFiles": "Maximum {maxFiles} files allowed",
  "nce.attachment.error.size": "File size exceeds maximum of {maxSize}",
  "nce.attachment.error.type": "File type not allowed. Accepted types: {types}",
  "nce.attachment.error.upload": "Error uploading file",
  "nce.attachment.files": "files",
  "nce.attachment.hint": "(Optional - max {maxFiles} files, 10MB each)",
  "nce.attachment.uploading": "Uploading...",
  "nce.category.administrative": "Administrative",
  "nce.category.analytical": "Analytical",
  "nce.category.postanalytical": "Post-analytical",
  "nce.category.preanalytical": "Pre-analytical",
  "nce.field.attachments": "Attachments",
  "nce.field.notes": "Notes",
  "nce.field.description.placeholder": "Describe what happened, when it was detected, and any relevant context...",
  "nce.field.immediateAction": "Immediate Action Taken",
  "nce.field.immediateAction.placeholder": "What corrective steps were taken immediately...",
  "nce.field.linkedItems": "Linked Samples/Results",
  "nce.field.severity": "Severity",
  "nce.field.title": "Title",
  "nce.field.title.placeholder": "Brief description of the event...",
  "nce.severity.critical": "Critical",
  "nce.severity.critical.description": "Patient safety risk, regulatory violation",
  "nce.severity.major": "Major",
  "nce.severity.major.description": "Significant quality or operational impact",
  "nce.severity.minor": "Minor",
  "nce.severity.minor.description": "Limited impact, easily corrected",
  "nce.severity.low": "Low",
  "nce.severity.low.description": "Minimal impact, no corrective action required",
  "nce.status.open": "Open",
  "nce.status.underInvestigation": "Under Investigation",
  "nce.tree.empty": "No orders found. Search for a lab number to begin.",
  "nce.tree.loading": "Loading orders...",
  "nce.tree.order": "Order",
  "nce.tree.search": "Filter by test or sample...",
  "nce.tree.selected": "{sampleCount} samples, {resultCount} results selected",
  "nce.trigger.order_cancellation": "Order cancellation may require NCE documentation",
  "nce.trigger.partial_sample_rejection": "Partial sample rejection requires NCE documentation",
  "nce.trigger.pathology_rejection": "Pathology case rejection may require NCE documentation",
  "nce.trigger.premature_disposal": "Premature disposal may require NCE documentation",
  "nce.trigger.qc_invalidation": "QC invalidation requires NCE documentation",
  "nce.trigger.referral_rejection": "Referral rejection requires NCE documentation",
  "nce.trigger.result_rejection_no_retest": "Result rejection without retest requires NCE documentation",
  "nce.trigger.result_rejection_retest": "Result rejection with retest may require NCE documentation",
  "nce.trigger.sample_rejection": "Sample rejection requires NCE documentation",
  "nce.trigger.test_cancel_no_results": "Test cancellation may require NCE documentation",
  "nce.trigger.test_cancel_with_results": "Test cancellation with results requires NCE documentation",
  "nce.type.calibration_failure": "Calibration failure",
  "nce.type.communication_failure": "Communication failure",
  "nce.type.contamination": "Contamination",
  "nce.type.documentation_error": "Documentation error",
  "nce.type.equipment_malfunction": "Equipment malfunction",
  "nce.type.labeling_error": "Labeling error",
  "nce.type.patient_id_mismatch": "Patient ID mismatch",
  "nce.type.policy_violation": "Policy violation",
  "nce.type.procedure_deviation": "Procedure deviation",
  "nce.type.qc_failure": "QC failure",
  "nce.type.reagent_issue": "Reagent issue",
  "nce.type.report_delay": "Report delay",
  "nce.type.report_distribution_error": "Report distribution error",
  "nce.type.requisition_incomplete": "Requisition incomplete",
  "nce.type.resource_shortage": "Resource shortage",
  "nce.type.result_interpretation_error": "Result interpretation error",
  "nce.type.sample_collection_error": "Sample collection error",
  "nce.type.staff_competency_issue": "Staff competency issue",
  "nce.type.storage_error": "Storage error",
  "nce.type.system_error": "System error",
  "nce.type.training_gap": "Training gap",
  "nce.type.transcription_error": "Transcription error",
  "nce.type.transport_issue": "Transport issue",
  "nce.type.request_form_error": "Request form error",
  "nce.type.equipment_failure": "Equipment failure",
  "nce.type.procedure_error": "Procedure error",
  "nce.type.calibration_error": "Calibration error",
  "nce.type.cross_contamination": "Cross-contamination",
  "nce.type.result_transcription_error": "Result transcription error",
  "nce.type.report_delivery_error": "Report delivery error",
  "nce.type.critical_value_not_reported": "Critical value not reported",
  "nce.type.delayed_result": "Delayed result",
  "nce.type.result_amendment": "Result amendment",
  "nce.type.training_issue": "Training issue",
  "nce.category.analysis": "Analysis",
  "nce.category.general": "General",
  "nce.category.order": "Order",
  "nce.category.sample": "Sample",
  "nce.type.barcodeIssue": "Barcode Issue",
  "nce.type.brokenTubeContainer": "Broken Tube/Container",
  "nce.type.calibrationIssue": "Calibration Issue",
  "nce.type.coagulatedSample": "Coagulated Sample",
  "nce.type.contaminationClient": "Contamination - client",
  "nce.type.contaminationInternal": "Contamination - internal",
  "nce.type.demographicError": "Demographic error",
  "nce.type.employeeConcern": "Employee concern",
  "nce.type.expiredReagentMaterial": "Expired Reagent/Material",
  "nce.type.formIncorrect": "Form incorrect",
  "nce.type.formMissing": "Form missing",
  "nce.type.haemolyticSample": "Hemolytic sample",
  "nce.type.improperSpecimenCollection": "Improper Specimen Collection",
  "nce.type.inadequateSampling": "Inadequate Sampling",
  "nce.type.incorrectMeasurement": "Incorrect measurement of sample or reagent",
  "nce.type.instrumentDowntime": "Instrument Downtime",
  "nce.type.insufficientAmount": "Insufficient Amount",
  "nce.type.inventoryStorage": "Inventory Storage",
  "nce.type.leakage": "Leakage",
  "nce.type.lostSpecimenIrreplacable": "Lost Specimen - Irreplaceable",
  "nce.type.lostSpecimenRedraw": "Lost Specimen - Redraw",
  "nce.type.lotNumberIssue": "Lot Number Issue",
  "nce.type.mislabeledUnlabeled": "Mislabeled/unlabeled specimen",
  "nce.type.missingSample": "Missing Sample",
  "nce.type.otherDescribe": "Other, please describe",
  "nce.type.rerunEquipmentFailure": "Rerun - Equipment Failure",
  "nce.type.rerunInconsistentResults": "Rerun - Inconsistent Results",
  "nce.type.rerunQCFailure": "Rerun- QC Failure",
  "nce.type.resultReported": "Result reported when quality control sample tested out of range",
  "nce.type.sopDeviation": "SOP Deviation (please describe)",
  "nce.type.specimenReceiptDelay": "Specimen Receipt Delay",
  "nce.type.spill": "Spill",
  "nce.type.technologyIssue": "Technology/Computer issue",
  "nce.type.transmissionDelay": "Transmission Delay",
  "nce.type.wrongSpecimen": "Wrong specimen",
  "nce.type.wrongTemperature": "Wrong temperature",
  "nce.type.wrongTestKit": "Wrong Test Kit",
  "nce.button.createNce": "Create NCE",
  "nce.button.skip": "Skip",
  "nce.creating": "Creating NCE...",
  "nce.description.placeholder": "Describe the non-conforming event...",
  "nce.error.create.failed": "Failed to create NCE",
  "nce.error.severity.required": "Severity is required",
  "nce.trigger.mandatory.message": "You must create an NCE before proceeding with this action.",
  "nce.trigger.mandatory.title": "NCE Required",
  "nce.trigger.order_cancellation.message": "Order cancellation may require documentation of a non-conforming event.",
  "nce.trigger.order_cancellation.title": "Order Cancellation - NCE",
  "nce.trigger.partial_sample_rejection.message": "Partial sample rejection requires documentation of a non-conforming event.",
  "nce.trigger.partial_sample_rejection.title": "Partial Sample Rejection - NCE Required",
  "nce.trigger.pathology_rejection.message": "Pathology case rejection may require documentation of a non-conforming event.",
  "nce.trigger.pathology_rejection.title": "Pathology Rejection - NCE",
  "nce.trigger.premature_disposal.message": "Premature disposal may require documentation of a non-conforming event.",
  "nce.trigger.premature_disposal.title": "Premature Disposal - NCE",
  "nce.trigger.qc_invalidation.message": "QC invalidation requires documentation of a non-conforming event.",
  "nce.trigger.qc_invalidation.title": "QC Invalidation - NCE Required",
  "nce.trigger.referral_rejection.message": "Referral rejection requires documentation of a non-conforming event.",
  "nce.trigger.referral_rejection.title": "Referral Rejection - NCE Required",
  "nce.trigger.result_rejection_no_retest.message": "Result rejection without retest requires documentation of a non-conforming event.",
  "nce.trigger.result_rejection_no_retest.title": "Result Rejection - NCE Required",
  "nce.trigger.result_rejection_retest.message": "Result rejection with retest may require documentation of a non-conforming event.",
  "nce.trigger.result_rejection_retest.title": "Result Rejection - NCE",
  "nce.trigger.sample_rejection.message": "Sample rejection requires documentation of a non-conforming event.",
  "nce.trigger.sample_rejection.title": "Sample Rejection - NCE Required",
  "nce.trigger.test_cancel_no_results.message": "Test cancellation may require documentation of a non-conforming event.",
  "nce.trigger.test_cancel_no_results.title": "Test Cancellation - NCE",
  "nce.trigger.test_cancel_with_results.message": "Test cancellation with existing results requires documentation of a non-conforming event.",
  "nce.trigger.test_cancel_with_results.title": "Test Cancellation - NCE Required",
  "nce.admin.trigger.config.title": "NCE Trigger Configuration",
  "nce.admin.trigger.config.description": "Configure when Non-Conforming Events are automatically created or prompted.",
  "nce.admin.trigger.behaviors.title": "Trigger Behaviors",
  "nce.admin.rejection.mappings.title": "Rejection Reason Mappings",
  "nce.admin.rejection.mappings.description": "Map rejection reasons to NCE categories for automatic population.",
  "nce.trigger.behavior.mandatory": "Mandatory",
  "nce.trigger.behavior.prompted": "Prompted",
  "nce.trigger.behavior.disabled": "Disabled",
  "nce.trigger.column.type": "Trigger Type",
  "nce.trigger.column.description": "Description",
  "nce.trigger.column.behavior": "Behavior",
  "nce.trigger.column.active": "Active",
  "nce.trigger.type.sampleRejection": "Sample Rejection",
  "nce.trigger.type.resultRejection": "Result Rejection",
  "nce.trigger.type.qaEvent": "QA Event",
  "nce.trigger.type.manual": "Manual",
  "nce.trigger.update.success": "Trigger configuration updated",
  "nce.trigger.update.error": "Failed to update trigger configuration",
  "nce.mapping.add": "Add Mapping",
  "nce.mapping.edit": "Edit Mapping",
  "nce.mapping.column.rejectionReason": "Rejection Reason",
  "nce.mapping.column.category": "NCE Category",
  "nce.mapping.column.type": "NCE Type",
  "nce.mapping.column.severity": "Default Severity",
  "nce.mapping.column.active": "Active",
  "nce.mapping.noData": "No rejection mappings configured",
  "nce.mapping.validation.error": "Rejection reason and category are required",
  "nce.mapping.save.success": "Mapping saved successfully",
  "nce.mapping.active": "Active",
  "nce.field.category": "Category",
  "nce.field.type": "Type",
  "nce.select.category": "Select a category",
  "nce.select.type": "Select a type",
  "nce.error.dateOfEvent.required": "Date of event is required",
  "nce.error.reportingUnit.required": "Reporting unit is required",
  "nce.error.description.required": "Description is required",
  "nce.error.suspectedCauses.required": "Suspected causes are required",
  "nce.error.proposedAction.required": "Proposed action is required",
  "nce.error.category.required": "Category is required",
  "nce.attachment.saveFirst": "Save the NCE event to enable file attachments",
  "nce.attachment.error.noEvent": "Please save the NCE event first before uploading attachments",
  "nce.attachment.download": "Download",
  "nce.attachment.delete": "Delete",
  "requester.add.new.restricted": "Adding a new organization has been disabled by your administrator.",
  "requester.add.new.restricted.organization.contact": "Entering contact info for a new organization has been disabled by your administrator. Search for an existing organization above.",
  "requester.add.new.restricted.provider": "Adding a new provider has been disabled by your administrator.",
  "requester.add.new.restricted.provider.contact": "Entering contact info for a new provider has been disabled by your administrator. Search for an existing provider above.",
  "requester.add.new.restricted.requestor": "Adding a new requestor has been disabled by your administrator. Search for an existing requestor above.",
  "requester.contact.search": "Requestor Search",
  "requester.contact.search.helper": "Search for the contact person requesting these tests, or enter a new one below. At least one of Requesting Organization or Requestor is required.",
  "requester.organization.add.new": "+ Add new organization \"{name}\"",
  "requester.organization.email": "Organization Email",
  "requester.organization.fax": "Organization Fax",
  "requester.organization.new.helper": "Will be created as a new organization when this order is saved.",
  "requester.organization.new.tag": "New",
  "requester.organization.no.match": "No matching organization found.",
  "requester.organization.phone": "Organization Phone",
  "requester.organization.search": "Requesting Organization Search",
  "requestor.add.new": "+ Add new requestor \"{name}\"",
  "requestor.add.new.restricted": "Adding a new requestor has been disabled by your administrator.",
  "requestor.department": "Department",
  "requestor.email": "Email",
  "requestor.fax": "Fax",
  "requestor.firstName": "First Name",
  "requestor.lastName": "Last Name",
  "requestor.name": "Requestor Name",
  "requestor.name.placeholder": "Enter requestor name",
  "requestor.new.helper": "Will be created as a new requestor when this order is saved.",
  "requestor.new.tag": "New",
  "requestor.no.match": "No matching requestor found.",
  "requestor.phone": "Phone",
  "requestor.search.helper": "Type at least 2 characters to auto-search.",
  "result.compliance.fail": "FAIL",
  "result.compliance.pass": "PASS",
  "result.pool.filter.allLots": "All lots",
  "result.pool.filter.allPools": "All pools",
  "result.pool.filter.clear": "Clear filter",
  "result.pool.filter.count": "Showing {shown} of {total} results",
  "result.pool.filter.lot": "Filter by lot",
  "result.pool.filter.pool": "Filter by pool",
  "result.pool.intake": "Intake pool",
  "result.pool.subpool": "Sub-pool {n}",
  "result.vectorPool.label": "Pool of {count} {animal}",
  "results.uncertainty.column.label": "U (k=2)",
  "results.uncertainty.validation.negative": "Uncertainty must be a non-negative number.",
  "results.uncertainty.value.prefix": "±",
  "sample.fallback.name": "Sample",
  "sample.priority.ASAP": "ASAP",
  "sample.priority.FUTURE_STAT": "Future STAT",
  "sample.priority.ROUTINE": "Routine",
  "sample.priority.STAT": "STAT (Urgent)",
  "sample.priority.TIMED": "Timed",
  "sample.referToReferenceLab.helper": "Mark if this sample requires testing at an external reference laboratory.",
  "sampleAcceptance.action.moveDown": "Move down",
  "sampleAcceptance.action.moveUp": "Move up",
  "sampleAcceptance.banner.resampledFrom": "This is a replacement created by a resample of sample #{id}.",
  "sampleAcceptance.banner.resampledFrom.title": "Replacement sample",
  "sampleAcceptance.banner.resampledTo": "This sample was rejected and resampled. Replacement order: {accession}.",
  "sampleAcceptance.banner.resampledTo.title": "Resampled",
  "sampleAcceptance.button.addItem": "Add item",
  "sampleAcceptance.col.active": "Active",
  "sampleAcceptance.col.label": "Label",
  "sampleAcceptance.col.order": "Order",
  "sampleAcceptance.col.statusForDomain": "Status for this domain",
  "sampleAcceptance.domain.all": "All domains",
  "sampleAcceptance.domain.clinical": "Clinical",
  "sampleAcceptance.domain.environmental": "Environmental",
  "sampleAcceptance.domain.vector": "Vector",
  "sampleAcceptance.enforcement.help": "Enforcement is set per domain, not per lab unit — a reception clerk spans many lab units.",
  "sampleAcceptance.enforcement.label": "Checklist enforcement — {domain}",
  "sampleAcceptance.enforcement.mandatory": "Mandatory — block Step 3 until complete",
  "sampleAcceptance.enforcement.off": "Off — hide the checklist",
  "sampleAcceptance.enforcement.optional": "Optional — record but don't block",
  "sampleAcceptance.gate.blocked": "Intake acceptance is mandatory for this domain — accept every specimen (or report an NCE / resample) before this order can proceed.",
  "sampleAcceptance.labWide.heading": "Lab-wide items (apply unless a domain overrides)",
  "sampleAcceptance.labWide.inherited": "Lab-wide items — inherited (active fallback)",
  "sampleAcceptance.labWide.superseded": "Lab-wide items — superseded here (edit from “All domains”)",
  "sampleAcceptance.notify.enforcementSaved": "Enforcement updated",
  "sampleAcceptance.notify.itemAdded": "Checklist item added",
  "sampleAcceptance.notify.itemSaved": "Checklist item saved",
  "sampleAcceptance.notify.recordFailed": "Failed to record acceptance",
  "sampleAcceptance.notify.rejectFailed": "Failed to reject",
  "sampleAcceptance.notify.resampleFailed": "Failed to resample",
  "sampleAcceptance.ownItems.empty": "No items yet — this domain falls back to the lab-wide list below.",
  "sampleAcceptance.ownItems.heading": "{domain} items",
  "sampleAcceptance.qa.accepted.success": "Acceptance recorded",
  "sampleAcceptance.qa.answer.fail": "Fail",
  "sampleAcceptance.qa.answer.na": "N/A",
  "sampleAcceptance.qa.answer.pass": "Pass",
  "sampleAcceptance.qa.button.accept": "Accept sample",
  "sampleAcceptance.qa.button.reject": "Reject",
  "sampleAcceptance.qa.button.resample": "Resample",
  "sampleAcceptance.qa.context.collected": "Collected",
  "sampleAcceptance.qa.context.longTransit": "long transit — your call",
  "sampleAcceptance.qa.context.note": "Transit is shown for reference only — it does not auto-grade anything. Active list: {domain}.",
  "sampleAcceptance.qa.context.received": "Received",
  "sampleAcceptance.qa.context.transit": "Transit time",
  "sampleAcceptance.qa.empty": "No acceptance checklist is configured for this domain.",
  "sampleAcceptance.qa.failHint": "This sample has failed checks — report an NCE or resample instead of accepting.",
  "sampleAcceptance.qa.failHint.reject": "This sample has failed checks. Report an NCE or reject it instead of accepting.",
  "sampleAcceptance.qa.noSample": "Save collection to run intake acceptance for this specimen.",
  "sampleAcceptance.qa.note.label": "Note (optional)",
  "sampleAcceptance.qa.note.placeholder": "Optional — note any observed condition",
  "sampleAcceptance.qa.status.accepted": "Accepted",
  "sampleAcceptance.qa.status.pending": "Pending",
  "sampleAcceptance.qa.status.rejected": "Rejected",
  "sampleAcceptance.qa.status.review": "Review",
  "sampleAcceptance.qa.subtitle": "Complete the acceptance checklist for this sample",
  "sampleAcceptance.qa.subtitle.rejected": "This specimen was rejected and resampled — read-only.",
  "sampleAcceptance.qa.subtitle.rejectedEqa": "This sample was rejected — read-only.",
  "sampleAcceptance.qa.subtitle.rejectedVector": "This catch was rejected — read-only.",
  "sampleAcceptance.qa.title": "Intake acceptance",
  "sampleAcceptance.reject.commit": "Commit reject",
  "sampleAcceptance.reject.comment.label": "Comment (optional)",
  "sampleAcceptance.reject.info": "Reject this catch as unusable. This cannot be re-collected, so no replacement order is created.",
  "sampleAcceptance.reject.info.eqa": "Reject this proficiency-testing sample. PT material cannot be recollected, so no replacement order is created.",
  "sampleAcceptance.reject.reason.label": "Reason (pre-filled from failed items — editable)",
  "sampleAcceptance.reject.reason.required": "A reason is required",
  "sampleAcceptance.reject.success": "Sample rejected.",
  "sampleAcceptance.reject.title": "Reject — {labNumber}",
  "sampleAcceptance.resample.commit": "Commit resample",
  "sampleAcceptance.resample.info": "Reject this sample and create a new collection order for re-collection. The requester will be notified.",
  "sampleAcceptance.resample.reason.label": "Reason (pre-filled from failed items — editable)",
  "sampleAcceptance.resample.reason.required": "Enter a resample reason.",
  "sampleAcceptance.resample.success": "Resample created — new order {accession}. Requester notified.",
  "sampleAcceptance.resample.title": "Resample — {labNumber}",
  "sampleAcceptance.review.col.eligibility": "Eligibility",
  "sampleAcceptance.review.col.labNo": "Lab #",
  "sampleAcceptance.review.col.sampleType": "Sample type",
  "sampleAcceptance.review.col.transit": "Transit",
  "sampleAcceptance.review.noSamples": "No collected specimens to review yet.",
  "sampleAcceptance.review.subtitle": "Select a sample to complete its acceptance checklist",
  "sampleAcceptance.review.title": "Intake Acceptance",
  "sampleAcceptance.status.active": "Active",
  "sampleAcceptance.status.inactive": "Inactive",
  "sampleAcceptance.status.inheritedActive": "Active (inherited)",
  "sampleAcceptance.status.superseded": "Superseded",
  "sampleAcceptance.title": "Sample Acceptance Checklist",
  "sidenav.label.admin.nceTriggerConfig": "Trigger Configuration",
  "sidenav.label.admin.nceCategoryType": "Categories & Types",
  "sidenav.label.admin.nceConfig": "NCE Configuration",
  "nce.admin.categorytype.title": "NCE Categories & Types Configuration",
  "nce.admin.categorytype.description": "Manage the categories and types available for Non-Conforming Events.",
  "nce.admin.tab.categories": "Categories",
  "nce.admin.tab.types": "Types",
  "nce.admin.category.add": "Add Category",
  "nce.admin.category.edit": "Edit Category",
  "nce.admin.category.name.required": "Category name is required",
  "nce.admin.category.save.success": "Category saved successfully",
  "nce.admin.category.save.error": "Failed to save category",
  "nce.admin.type.add": "Add Type",
  "nce.admin.type.edit": "Edit Type",
  "nce.admin.type.validation.error": "Type name and category are required",
  "nce.admin.type.save.success": "Type saved successfully",
  "nce.admin.type.save.error": "Failed to save type",
  "nce.admin.column.name": "Name",
  "nce.admin.column.displayKey": "Display Key",
  "nce.admin.column.typesCount": "Types Count",
  "nce.admin.column.category": "Category",
  "nce.admin.column.actions": "Actions",
  "nce.admin.field.name": "Name",
  "nce.admin.field.displayKey": "Display Key (for i18n)",
  "nce.admin.field.displayKey.helper": "Optional. Used for translations.",
  "nce.admin.field.category": "Category",
  "nce.admin.delete.confirm.title": "Confirm Delete",
  "nce.admin.delete.confirm.message": "Are you sure you want to delete \"{name}\"? This action cannot be undone.",
  "nce.admin.delete.success": "Deleted successfully",
  "nce.inline.title": "Report Non-Conformity Event",
  "nce.inline.context": "CONTEXT (Auto-populated)",
  "nce.dashboard.breadcrumb": "NCE > All NCEs",
  "nce.dashboard.title": "All NCEs",
  "nce.dashboard.subtitle": "All open NCEs across the laboratory",
  "nce.dashboard.daysSince": "{count} days",
  "nce.button.reportNce": "Report NCE",
  "nce.search.placeholder": "Search NCEs...",
  "nce.filter.allStatus": "All Status",
  "nce.filter.allCategories": "All Categories",
  "nce.filter.allSeverities": "All Severities",
  "nce.filter.clearAll": "Clear All",
  "nce.summary.critical": "Critical",
  "nce.summary.major": "Major",
  "nce.summary.minor": "Minor",
  "nce.summary.overdue": "Overdue",
  "nce.tag.overdue": "Overdue",
  "nce.tab.eventDetails": "Event Details",
  "nce.tab.investigation": "Investigation",
  "nce.tab.capa": "CAPA",
  "nce.tab.history": "History",
  "nce.field.suspectedCauses": "Suspected Causes",
  "nce.field.proposedAction": "Proposed Action",
  "nce.field.trigger": "Trigger",
  "nce.capReason.time_24h": "{count} samples linked — capped at 24h window",
  "nce.capReason.count_50": "{count} samples linked — capped at 50 most recent",
  "nce.capa.noItems": "No corrective/preventive actions recorded yet.",
  "nce.capa.dueDate": "Due Date",
  "nce.history.noItems": "No history available.",
  "nce.history.system": "System",
  "nce.action.acknowledge": "Acknowledge",
  "nce.action.assignTo": "Assign To",
  "nce.action.addNote": "Add Note",
  "nce.action.close": "Close NCE",
  "nce.action.startCorrectiveAction": "Start Corrective Action",
  "nce.link.duplicate.warning": "These specimens are already linked to this NCE",
  "nce.list.empty": "No NCEs found matching your criteria.",
  "nce.modal.addNote": "Add Note",
  "nce.modal.addNoteDescription": "Add a note to NCE {nceNumber}",
  "nce.modal.notePlaceholder": "Enter your note...",
  "nce.modal.assign": "Assign NCE",
  "nce.modal.assignDescription": "Assign NCE {nceNumber} to a user",
  "nce.modal.selectUser": "Select User",
  "nce.modal.searchUser": "Search for a user...",
  "nce.assign.selectUser": "Please select a user to assign",
  "nce.assign.success": "NCE assigned successfully",
  "nce.assign.error": "Failed to assign NCE",
  "nce.acknowledge.success": "NCE acknowledged successfully",
  "nce.acknowledge.error": "Failed to acknowledge NCE",
  "nce.note.empty": "Please enter a note",
  "nce.note.success": "Note added successfully",
  "nce.note.error": "Failed to add note",
  "nce.attachment.downloadError": "Failed to download attachment",
  "nce.attachment.viewError": "Failed to view attachment",
  "not.available": "Not available",
  "not.specified": "Not specified",
  "notAuthenticated": "Not Authenticated",
  "notebook.attachments.title": "Attachments",
  "notebook.attachments.uploadPrompt": "click to upload files",
  "notebook.auditTrail.action.archived": "Archived",
  "notebook.auditTrail.action.created": "Created",
  "notebook.auditTrail.action.finalized": "Finalized",
  "notebook.auditTrail.action.locked": "Locked",
  "notebook.auditTrail.action.submitted": "Submitted",
  "notebook.auditTrail.action.updated": "Updated",
  "notebook.auditTrail.comingSoon": "Audit trail functionality will be available soon.",
  "notebook.auditTrail.none.subtitle": "No audit trail entries found for this notebook.",
  "notebook.auditTrail.none.title": "No Audit Trail Available",
  "notebook.auditTrail.title": "Audit Trail",
  "notebook.button.edit": "Edit",
  "notebook.button.editResults": "Edit Results",
  "notebook.button.enterResults": "Enter Results",
  "notebook.button.newLabNotebook": "Project",
  "notebook.button.view": "View",
  "notebook.comments.add.button": "Add Comment",
  "notebook.comments.add.label": "Add a comment",
  "notebook.comments.none.subtitle": "No comments have been added yet.",
  "notebook.comments.none.title": "No Comments",
  "notebook.comments.title": "Comments",
  "notebook.error.notAssigned": "You are not assigned to this project",
  "notebook.heading.allEntries": "All Entries",
  "notebook.heading.notebooks": "Projects",
  "notebook.icon.edit": "Edit",
  "notebook.instruments.title": "Instruments",
  "notebook.label.addpage": "Add Page",
  "notebook.label.author": "Author",
  "notebook.label.basicinfo": "Basic Information",
  "notebook.label.content": "Main Content",
  "notebook.label.dashboard": "Notebook Dashboard",
  "notebook.label.drafts": "Drafts",
  "notebook.label.entry": "Notebook Entry",
  "notebook.label.entryFiles": "Entry Files",
  "notebook.label.instanceEntry": "Notebook Instance Entry",
  "notebook.label.entryTags": "Entry Tags",
  "notebook.label.experimentDoc": "Experiment Documentation",
  "notebook.label.experimentType": "Experiment Type",
  "notebook.label.filter.types": "Experiment Types",
  "notebook.label.finalized": "Finalized This Week",
  "notebook.label.formEntry": "NoteBook Form Entry",
  "notebook.label.objective": "Objective",
  "notebook.label.pages": "WorkFlow Pages",
  "notebook.label.pending": "Pending Review",
  "notebook.label.project": "Project",
  "notebook.label.project.title": "Project Title",
  "notebook.label.projectFiles": "Project Files",
  "notebook.label.projectTags": "Project Tags",
  "notebook.label.protocol": "Protocol ID",
  "notebook.label.questionnaire": "Questionnaire",
  "notebook.label.sampleManagement": "Sample Management",
  "notebook.label.status": "Status",
  "notebook.label.technician": "Technician",
  "notebook.label.title": "Entry Title",
  "notebook.label.total": "Total Entries",
  "notebook.page.completed": "Completed",
  "notebook.page.content": "Content:",
  "notebook.page.instructions": "Instructions:",
  "notebook.page.markComplete": "Mark as Complete",
  "notebook.page.modal.add.errorRequired": "Title and Content are required.",
  "notebook.page.modal.add.title": "Add New Page",
  "notebook.page.modal.content.label": "Content",
  "notebook.page.modal.edit.title": "Edit Page",
  "notebook.page.modal.instructions.label": "Instructions",
  "notebook.page.modal.title.label": "Title",
  "notebook.page.title": "Notebook",
  "notebook.pages.none.subtitle": "Click to add Pages",
  "notebook.pages.none.title": "No Pages Added",
  "notebook.project.definition.form.title": "Project Definition Form",
  "notebook.project.entry.form.title": "Project Entry Form",
  "notebook.results.modal.title": "Results for {accession}",
  "notebook.results.noAccession": "No accession number available for this sample",
  "notebook.results.none.subtitle": "No results found for the provided accession number.",
  "notebook.results.none.title": "No Results Found",
  "notebook.results.title": "Results",
  "notebook.sample.result.dateCreated": "Date Created",
  "notebook.samples.available": "Available Samples",
  "notebook.samples.none.subtitle": "Search Samples By Patient or Accession Number",
  "notebook.samples.none.subtitle.selected": "Click to add samples",
  "notebook.samples.none.title": "No samples Available",
  "notebook.samples.none.title.selected": "No Samples Selected",
  "notebook.samples.resultsRecorded": "Results Recorded:",
  "notebook.samples.selected": "Selected Samples",
  "notebook.search.byAccession": "Search By Accession",
  "notebook.search.byPatient": "Search By Patient",
  "notebook.select.label": "Select Notebook",
  "notebook.select.none": "None - default fields only",
  "notebook.select.optional": "Select a notebook (optional)",
  "notebook.status.archived": "Archive Entry",
  "notebook.status.assignment.title": "Status and Assignment",
  "notebook.status.draft": "Save Draft",
  "notebook.status.finalized": "Finalize Entry",
  "notebook.status.locked": "Lock Entry",
  "notebook.status.metadata.title": "Status & Metadata",
  "notebook.status.submitted": "Submit for Review",
  "notebook.tab.attachments": "Attachments",
  "notebook.tab.auditTrail": "Audit Trail",
  "notebook.tab.comments": "Comments",
  "notebook.tab.content": "Content",
  "notebook.tab.entryDetails": "Entry Details",
  "notebook.tab.metadata": "MetaData",
  "notebook.tab.results": "Results",
  "notebook.tab.samples": "Samples",
  "notebook.tab.workflow": "Workflow",
  "notebook.table.header.entries": "Entries",
  "notebook.tag.placeholder": "Enter Tags",
  "notebook.tags.add": "Add Tag",
  "notebook.tags.modal.add.errorRequired": "Tag is required.",
  "notebook.tags.modal.add.label": "Tag",
  "notebook.tags.modal.add.title": "Add New Tag",
  "notebook.tags.title": "Tags",
  "notebook.validation.content.required": "Main Content is required.",
  "notebook.validation.objective.required": "Objective is required.",
  "notebook.validation.project.required": "Project is required.",
  "notebook.validation.protocol.required": "Protocol ID is required.",
  "notebook.validation.title.required": "Title is required.",
  "notebook.validation.type.required": "Experiment Type is required.",
  "notification.error": "Error",
  "notification.info": "Information",
  "notification.invalid.confirm.password": "Your entered password is not same as above password.",
  "user.notFound": "This user could not be found. The link may be out of date; open the user from User Management.",
  "notification.invalid.loginName": "Login name may only contain letters and the characters . _ @ - (no digits).",
  "notification.invalid.name": "Please enter Alphanumeric values only.",
  "notification.invalid.password": "Please enter password according to instructions.",
  "notification.login.generic.error": "Error while attempting login",
  "notification.login.syntax.error": "Error while attempting login - Could not parse response to JSON",
  "notification.organization.post.delete.success": "Organization Deactivated Successfully.",
  "notification.organization.post.internetAddress": "Enter a valid Organization Url.",
  "notification.organization.post.save.success": "Organization Information Added Successfully.",
  "notification.organization.post.success": "Organization Information Updated Successfully.",
  "notification.password.change.fail": "Password change failed",
  "notification.password.change.success": "Password changed successfully",
  "notification.response.syntax.error": "Error - Could not parse response to JSON",
  "notification.resultSelectList.post.save.success": "Result select list saved successfully.",
  "notification.resultSelectList.post.update.success": "Result select list updated successfully.",
  "notification.slideover.button.hideread": "Hide read",
  "notification.slideover.button.markallasread": "Mark all as Read",
  "notification.slideover.button.markasread": "Mark as Read",
  "notification.slideover.button.reload": "Reload",
  "notification.slideover.button.showread": "Show read",
  "notification.slideover.button.subscribe": "Subscribe on this Device",
  "notification.slideover.button.subscribe.fail": "Subscribe failed",
  "notification.slideover.button.subscribe.success": "Subscribed successfully",
  "notification.slideover.button.unsubscribe": "Unsubscribe",
  "notification.slideover.button.unsubscribe.fail": "Unsubscribe failed",
  "notification.slideover.button.unsubscribe.success": "Unsubscribed successfully",
  "notification.slideover.empty.header": "You're all caught up",
  "notification.sliderover.empty.message": "You don't have any notifications at this time.",
  "notification.success": "Success",
  "notification.title": "Notification Message",
  "notification.user.add.success": "User information added successfully.",
  "notification.user.post.delete.success": "User Deactivated Successfully.",
  "notification.user.post.save.success": "User Information Added Successfully.",
  "notification.user.update.success": "User information updated successfully.",
  "notify.error": "User and Message are required",
  "notify.main.title": "Notify User",
  "notify.message": "Message",
  "notify.user.by": "User to be notified",
  "notify.user.success.notification": "Notification sent successfully",
  "of": "of",
  "openreports.activity.title": "Activity Reports",
  "openreports.aggregate.title": "Aggregate Reports",
  "openreports.all.test.summary.title": "Test Report Summary",
  "openreports.all.tests.aggregate": "Summary of All Tests",
  "openreports.hiv.aggregate": "HIV Test Summary",
  "openreports.management.title": "Management Reports",
  "openreports.mgt.nonconformity.date": "Non ConformityReport by Date",
  "openreports.mgt.nonconformity.section": "Non Conformity Report by Unit and Reason",
  "openreports.mgt.rejection": "Rejection Report",
  "openreports.patient.EID.version1": "EID Version 1",
  "openreports.patient.EID.version2": "EID Version 2",
  "openreports.patient.VL.version1": "VL Version Nationale",
  "openreports.patientTestStatus": "Patient Status Report",
  "openreports.patientreports.title": "Patient Status Report",
  "openreports.stat.aggregate": "Statistics Report",
  "order.accept": "Accept",
  "order.accept.error": "Failed to accept order",
  "order.additionalInfo": "Additional Information",
  "order.additionalInfo.helper": "Optional notes about this order",
  "order.clinicalInfo": "Clinical Information",
  "order.continue": "Continue",
  "order.current.time": "Current Time (hh:mm)",
  "order.dashboard.empty": "No orders found",
  "order.dashboard.title": "Order Dashboard",
  "order.department.label": "ward/dept/unit:",
  "order.diagnosis.helper": "Working diagnosis — guides test selection. Not recorded as a confirmed diagnosis.",
  "order.diagnosis.placeholder": "Enter diagnosis or clinical notes",
  "order.entry.setup": "Batch Order Entry Setup",
  "order.external": "External",
  "order.facility": "Facility",
  "order.filter.priority": "Filter by Priority",
  "order.filter.status": "Filter by Status",
  "order.fixIssue": "Fix Issue",
  "order.form.label": "Form:",
  "order.form.select": "Select Form",
  "order.generate.barcode": "Generate Barcode and Save",
  "order.generate.barcode.history": "Previously used Accession Number",
  "order.if.other.label": "if Other specify:",
  "order.invalid.requester.name.label": "invalid requester name",
  "order.invalid.site.name": "Invalid Site name",
  "order.labNumber": "Lab Number",
  "order.labNumber.generate": "Generate Lab Number",
  "order.labNumber.helper": "Unique identifier for this order",
  "order.attachment.action.delete": "Delete attachment",
  "order.attachment.action.download": "Download attachment",
  "order.attachment.action.view": "View attachment",
  "order.attachment.column.actions": "Actions",
  "order.attachment.column.fileName": "File name",
  "order.attachment.column.fileSize": "Size",
  "order.attachment.column.fileType": "Type",
  "order.attachment.column.uploadedAt": "Uploaded at",
  "order.attachment.delete.confirm.body": "Are you sure you want to delete \"{fileName}\"? This cannot be undone.",
  "order.attachment.delete.confirm.title": "Delete attachment",
  "order.attachment.delete.failed": "Could not delete the attachment. Please try again.",
  "order.attachment.dropzone": "Drag and drop files here, or click to browse",
  "order.attachment.empty": "No attachments yet.",
  "order.attachment.saveFirst": "Save the order to add attachments.",
  "order.attachment.error.maxFiles": "You can attach at most {maxFiles} files.",
  "order.attachment.error.size": "Each file must be {maxSize} or smaller.",
  "order.attachment.error.type": "Allowed file types: {types}",
  "order.attachment.heading": "Attachments",
  "order.attachment.hint": "Optional. Up to {maxFiles} files, 10MB each. Allowed: PDF, JPG, PNG, TIFF.",
  "order.attachment.upload.failed": "One or more attachments could not be uploaded.",
  "order.labNumber.placeholder": "Enter or generate lab number",
  "order.label.add": "Add Order",
  "order.label.modify": "Modify Order",
  "order.legend.EDTATube": "EDTA Tube",
  "order.legend.commonFields": "Common Fields",
  "order.legend.configureBarcode": "Configure Barcode Entry",
  "order.legend.dryBloodSpot": "Dry Blood Spot",
  "order.legend.dryTube": "Dry Tube",
  "order.legend.facility": "Facility",
  "order.legend.onDemand": "On Demand",
  "order.legend.optionalFields": "Optional Fields",
  "order.legend.patient": "Patient Info",
  "order.legend.preDemand": "Pre-Printed",
  "order.legend.sample": "Sample",
  "order.legend.selectMethod": "Select Method",
  "order.legend.siteName": "Site Name",
  "order.legend.specimen.collected": "Specimen Collected",
  "order.legend.tests": "Tests",
  "order.legend.viralLoadTest": "Viral Load Test",
  "order.lastUpdated": "Last Updated",
  "order.load.error": "Failed to load order",
  "order.location": "Location",
  "order.new": "New Order",
  "order.payment.status.label": "Patient payment status:",
  "order.paymentStatus": "Payment Status",
  "order.previousLabNumber": "Previous Lab Number",
  "order.previousLabNumber.placeholder": "Enter previous lab number if applicable",
  "order.printLabels": "Print Labels",
  "order.printLabels.info": "Print barcodes for this order",
  "order.priority": "Priority",
  "order.progress": "Progress",
  "order.provisionalDiagnosis": "Provisional Diagnosis",
  "order.received.time": "Received Time (hh:mm)",
  "order.reception.time": "Reception Time (hh:mm) :",
  "order.remember.site.and.requester.label": "Remember site and requester",
  "order.readonly.message": "This order is in read-only mode",
  "order.requester": "Requester",
  "order.requester.email.label": "Requester's Email:",
  "order.requester.fax.label": "Requester's Fax Number:",
  "order.requester.firstName.label": "Requester's FirstName:",
  "order.requester.lastName.label": "Requester's LastName:",
  "order.requester.phone.label": "Requester Phone:",
  "order.requester.provisionalDiagnosis.label": "Provisional Clinical Diagnosis:",
  "order.result.reporting.heading": "RESULT REPORTING",
  "order.sampleCategory": "Sample Category",
  "order.sampleCategory.helper": "Select the category of sample to collect",
  "order.sampling.performed.label": "Sampling performed for analysis:",
  "order.search.requester.label": "Search Requester",
  "order.saveStatus.error": "Save failed",
  "order.saveStatus.saved": "Saved",
  "order.saveStatus.saving": "Saving...",
  "order.saveStatus.unsaved": "Unsaved changes",
  "order.save.blocked": "The order was not saved",
  "order.save.notPersisted": "The server accepted the order but stored no samples for it. Check the order before continuing.",
  "order.save.incomplete": "Please add a patient (or sampling site) and at least one sample type before saving.",
  "order.save.incomplete.fields": "Add {fields} before saving.",
  "order.save.incomplete.and": "and",
  "order.save.requirements.title": "Required before saving",
  "order.save.requirement.labNumber": "a lab number",
  "order.save.requirement.patient": "a patient",
  "order.save.requirement.samplingSite": "a sampling site",
  "order.save.requirement.collectionSite": "a collection site",
  "order.save.requirement.requesterOrRequestor": "a requesting organisation or requestor",
  "order.sample.missingTests": "Sample {sampleNumber} has a sample type but no test. Add a test or remove the sample before saving.",
  "order.sample.missingTests.named": "Sample {sampleNumber}: {sampleType} has no test. Add a test or remove the sample before saving.",
  "order.save.requirement.sampleType": "at least one sample type",
  "order.save.requirement.site": "a requesting site",
  "order.save.requirement.patientSex": "the patient sex",
  "order.save.requirement.patientBirthDate": "the patient date of birth",
  "order.save.requirement.nationalId": "the patient national ID",
  "order.save.requirement.validEmail": "a valid email address",
  "order.requestDate": "Order Date",
  "order.nextVisitDate": "Next Visit Date",
  "order.sampleHandling": "Sample Handling",
  "sampleAcceptance.qa.button.continueWithTesting": "Continue with testing",
  "sampleAcceptance.qa.continueWithTesting.reason": "Why is this sample being tested despite the failed check?",
  "sampleAcceptance.qa.continueWithTesting.record": "Record and continue",
  "order.eqaSample": "External quality assessment (EQA) sample",
  "order.noPatient": "This order has no patient",
  "order.noPatient.reason": "Reason for ordering without a patient",
  "order.noPatient.reason.eqa": "External quality assessment sample",
  "order.noPatient.warning.title": "Results will not be evaluated against a reference range",
  "order.noPatient.warning.subtitle": "Without a patient there is no age or sex to select a reference range from, so results on this order will not be flagged normal or abnormal.",
  "order.noPatient.butPatientChosen": "A patient is attached to this order, so the no-patient decision will not be recorded.",
  "order.rangeNotApplied.warning.title": "Some results will not be checked against a reference range",
  "order.rangeNotApplied.warning.subtitle": "Patient sex or age is not recorded, and these tests have ranges that depend on it: {tests}. Their results will need review before release.",
  "order.rangeNotApplied.warning.reportNce": "Report NCE",
  "order.eqa.program": "EQA Scheme",
  "order.eqa.providerSampleId": "Provider Sample ID",
  "order.eqa.deadline": "Submission Deadline",
  "order.eqa.priority": "EQA Priority",
  "order.rememberSiteAndRequester": "Remember this site and requester for my next order",
  "order.testLocationCode": "Sampling Performed At",
  "order.testLocationCode.other": "Other",
  "order.testLocationCode.otherLabel": "If other, specify",
  "provider.fax.invalid": "Enter a valid fax number, digits and + ( ) - only.",
  "provider.email.invalid": "Enter a valid email address, for example lab@example.org.",
  "order.save.requirement.provider": "a requesting provider",
  "order.save.requirement.testsPerSample": "at least one test or panel on every sample",
  "order.saved.draft": "Draft saved",
  "order.saved.title": "Order {labNumber} saved",
  "order.saved.next": "Next: {step}",
  "order.search.placeholder": "Search orders...",
  "order.search.site.name": "Search Site Name",
  "order.send.toAnalyzer": "Send to analyzer",
  "order.send.modal.title": "Send order to analyzer",
  "order.send.modal.confirm": "Send",
  "order.send.modal.cancel": "Cancel",
  "order.send.modal.analyzerLabel": "Target analyzer",
  "order.send.modal.accession": "Order accession: {accession}",
  "order.send.modal.noAnalyzers": "No analyzers are configured for LIS-initiated dispatch.",
  "order.send.success": "Order dispatched",
  "order.send.error": "Failed to dispatch order",
  "order.send.unknownError": "Unknown bridge error",
  "order.send.missingAccession": "Order has no accession number to correlate the result.",
  "order.site.name": "Site Name:",
  "order.step.collect": "Collect",
  "order.step.complete": "Complete",
  "order.step.enter": "Enter Order",
  "order.step.label": "Label & Store",
  "order.step.patient.info": "Patient Info",
  "order.step.program.selection": "Program Selection",
  "order.step.qa": "QA Review",
  "order.step.prepare": "Prepare Samples",
  "order.step.sampleCheck": "Sample check",
  "order.step.notStarted": "Not started",
  "order.step.done": "Done",
  "order.step.doneAt": "Done {time}",
  "order.step.toDo": "{count} to do",
  "order.step.ready": "Ready",
  "order.nav.saveExit": "Save and exit",
  "order.nav.saveNext": "Save and next",
  "order.nav.saveFinish": "Save and finish",
  "order.nav.discard.title": "Discard unsaved changes?",
  "order.nav.discard.body": "Unsaved changes on this page will be lost ({samples} samples, {tests} tests).",
  "order.nav.discard.order": "Discard order",
  "order.nav.discard.changes": "Discard changes",
  "order.continue.heading": "To continue to {step}",
  "order.continue.count": "{count} items needed to continue",
  "order.continue.countOne": "1 item needed to continue",
  "order.continue.item.patient": "Select or create the patient",
  "order.continue.item.labNumber": "Add a lab number",
  "order.continue.item.nationalId": "Enter the patient's National ID",
  "order.continue.item.patientSex": "Choose the patient's sex",
  "order.continue.item.birthDate": "Enter the patient's date of birth",
  "order.continue.item.sampleType": "Add at least one sample type",
  "order.continue.item.provider": "Add the requesting provider",
  "order.continue.item.noTests": "Sample {number}: choose at least one test",
  "order.continue.item.noTestsOnSample": "{sample} has no tests. Add them on Enter Order or remove the sample",
  "errors.samples.with.no.tests": "A sample has no tests. Add tests on Enter Order or remove the sample.",
  "order.continue.item.collectionTime": "Collection date and time for {sample}",
  "order.continue.item.consent": "Record consent",
  "order.continue.item.acceptance": "Answer the sample acceptance checklist",
  "order.status.entered": "Entered",
  "order.status.samplesPrepared": "Samples prepared",
  "order.status.readyForTesting": "Ready for testing",
  "order.status.cancelled": "Cancelled",
  "order.status.complete": "Complete",
  "order.cancelled.notice": "This order was cancelled: {reason}",
  "order.cancelled": "This order is already cancelled",
  "order.notFound": "Order not found",
  "order.cancel.reasonRequired": "A reason for cancelling is required",
  "order.cancel.complete": "Order entry is finished; this order can no longer be cancelled here",
  "order.cancel.inProgress": "Testing has started on this order; it can no longer be cancelled here",
  "order.release.prepareIncomplete": "Prepare Samples is not complete",
  "order.release.reasonRequired": "Reason for releasing before every sample is accepted",
  "order.finish.title": "Order {labNo} complete",
  "order.finish.subtitle": "Order entry is finished. Results can be entered as they arrive.",
  "order.finish.backToOrders": "Back to orders",
  "order.finish.awaiting": "Still awaiting a sample: {tests}",
  "order.sampleCheck.release": "Release for testing",
  "order.sampleCheck.return": "Return to Prepare Samples",
  "order.sampleCheck.proceedReason": "Reason for releasing before every sample is accepted",
  "order.sampleCheck.notAcceptedYet": "Not accepted yet: {samples}. Answers count once you press Accept sample.",
  "order.sampleCheck.released": "Order {labNo} released for testing",
  "order.sampleCheck.disabled.incomplete": "Prepare Samples is not complete. Open it and finish the samples first.",
  "order.dashboard.cancelOrder": "Cancel order",
  "order.dashboard.cancel.reason": "Reason for cancelling",
  "order.dashboard.cancel.reasonOther": "Describe the reason",
  "order.dashboard.cancel.other": "Other",
  "order.dashboard.cancel.confirm": "Cancel order {labNo}?",
  "order.dashboard.cancel.body": "Its tests are cancelled and its samples are voided. Nothing is deleted.",
  "order.dashboard.cancelled": "Order {labNo} cancelled",
  "order.dashboard.filter.cancelled": "Cancelled",
  "order.dashboard.open": "Open",
  "order.samples.printLabels": "Print labels",
  "order.samples.notStored": "Not stored",
  "storage.noSamples": "Add a sample above to store it.",
  "common.discard": "Discard",
  "common.stay": "Stay",
  "order.start.new": "Start New Order",
  "order.submit.labNumber": "Submit with Lab Number",
  "order.submit.success": "Order submitted successfully",
  "order.submit.success.labNumber": "Lab Number: {labNumber}",
  "order.submitted.success.msg": "Order has been submitted successfully",
  "order.summary.accessionNumber": "Accession Number",
  "order.summary.collectionDate": "Collection Date",
  "order.dashboard.status.all": "All Statuses",
  "order.dashboard.status.inProgress": "In Progress",
  "order.dashboard.status.pendingQa": "Awaiting sample check",
  "order.dashboard.status.completed": "Completed",
  "order.dashboard.status.hasReferred": "Has referred tests",
  "order.dashboard.status.referredOut": "Referred Out",
  "order.dashboard.priority.all": "All Priorities",
  "order.dashboard.priority.stat": "STAT",
  "order.dashboard.priority.asap": "ASAP",
  "order.dashboard.priority.timed": "Timed",
  "order.dashboard.priority.routine": "Routine",
  "order.summary.patientName": "Patient Name",
  "order.summary.sampleType": "Sample Type",
  "order.summary.title": "Order Summary",
  "order.test.request.heading": "Test Request",
  "order.title": "ORDER",
  "ordertests.title": "Order Tests",
  "organization.add.placeholder": "AlphaNumeric Values",
  "organization.add.placeholder.active": "Y or N",
  "organization.add.placeholder.internetAddress": "https://orgname.com",
  "organization.add.placeholder.parent": "Parent Organization",
  "organization.add.title": "Add Organization",
  "organization.city": "City",
  "organization.clia.number": "CLIA Number",
  "organization.edit.title": "Edit Organization",
  "organization.internetaddress": "Internet Address",
  "organization.isActive": "Is Active",
  "organization.main.title": "Organization Management",
  "organization.next": "Next Page",
  "organization.organizationName": "Org Name",
  "organization.parent": "Parent Org",
  "organization.previous": "Previous Page",
  "organization.search.byorgname": "Search By Org Name",
  "organization.search.parent.name": "Parent Organization Names",
  "organization.search.placeHolder": "Search By Org Name...",
  "organization.select": "Select",
  "organization.short.CI": "Org prefix",
  "organization.streetAddress": "Street Address",
  "organization.type.CI": "Type of Activity",
  "organization.type.CI.description": "Type of Activity : Description",
  "organization.type.CI.name": "Type of Activity : Name",
  "organization.type.CI.select": "Type of Activity : Select",
  "otherMalignant.placeholder": "Other Malignant",
  "page.breadcrumb.separator": " > ",
  "page.title.back": "Back",
  "pagination.backward": "Previous Page",
  "pagination.forward": "Next Page",
  "pagination.item": "{min}-{max}",
  "pagination.item-range": "{min}-{max} of {total} items",
  "pagination.items-on-page": "{count} {count, plural, one {item} other {items}} on this page",
  "pagination.items-per-page": "Items per page",
  "pagination.itemsPerPage": "Items per page:",
  "pagination.nextPage": "Next page",
  "pagination.page": "page {page}",
  "pagination.page-number": "Page Number",
  "pagination.page-range": "of {total} {total, plural, one {page} other {pages}}",
  "pagination.previousPage": "Previous page",
  "panel.existing": "Existing Panels",
  "panel.existing.inactive": "Inactive Panels (Assign tests to activate)",
  "panel.new": "New Panel",
  "panel.panelName": "Panel Name",
  "pathology.action.addCassette": "Add cassette",
  "pathology.action.addSlide": "Add slide",
  "pathology.action.deactivateBlock": "Deactivate block {designation}",
  "pathology.action.deactivateCassette": "Deactivate cassette {designation}",
  "pathology.action.deactivateSlide": "Deactivate slide {barcode}",
  "pathology.action.embed": "Embed",
  "pathology.action.embedCassette": "Embed cassette {designation}",
  "pathology.action.printCassetteLabels": "Print all cassette labels",
  "pathology.action.printSlideLabels": "Print all slide labels",
  "pathology.badge.cassetteCount": "{count, plural, one {# cassette} other {# cassettes}}",
  "pathology.badge.embeddedOf": "{embedded} of {total} embedded",
  "pathology.badge.openRequestCount": "{count} open",
  "pathology.badge.openRequests": "Open requests: {names}",
  "pathology.badge.openRequestsMore": "Open requests: {names} and {count} more",
  "pathology.badge.outstanding": "{designations} outstanding",
  "pathology.badge.outstandingMore": "{designations} and {count} more outstanding",
  "pathology.badge.slideCount": "{count, plural, one {# slide} other {# slides}}",
  "pathology.banner.transitionsLater": "Stage transitions arrive in a later release. Set the stage here for now.",
  "pathology.empty.noCassettes": "No cassettes have been cut yet. They are cut at grossing.",
  "pathology.empty.noReports": "No reports yet. Complete the findings and conclusion to generate one.",
  "pathology.empty.noTissueTypes": "No tissue types are configured. An administrator adds them under Dictionary.",
  "pathology.empty.stageNotRecorded": "OpenELIS does not record work at this stage yet. The case can still be moved through it.",
  "pathology.error.designationConflict": "Another save changed this case at the same moment. Reload the case and try again.",
  "pathology.error.reloadCase": "Something on this screen is out of date: a cassette, slide or tissue type changed elsewhere after the case was loaded. Reload the case and try again.",
  "pathology.label.addslide": "Add Slide(s)",
  "pathology.label.block": "Block",
  "pathology.label.block.number": "Block number",
  "pathology.label.blocks": "Blocks",
  "pathology.label.case": "Pathology Case",
  "pathology.label.caseTitle": "Pathology Case {labNumber}",
  "pathology.label.casesInProgress": "Cases in Progress",
  "pathology.label.cassette": "Cassette",
  "pathology.label.cassettes": "Cassettes",
  "pathology.label.complete": "Complete",
  "pathology.label.conclusion": "Conclusion",
  "pathology.label.dashboard": "Pathology DashBoard",
  "pathology.label.deactivating": "Deactivating",
  "pathology.label.decalcificationRequired": "Decalcification required",
  "pathology.label.designationPending": "Assigned on save",
  "pathology.label.grossExam": "Macroscopic description",
  "pathology.label.location": "Location",
  "pathology.label.microscopyExam": "Microscopic description",
  "pathology.label.newCassette": "New cassette {position}",
  "pathology.label.newSlide": "New slide {position}",
  "pathology.label.parentBlock": "Cut from block",
  "pathology.label.printlabel": "Print Label",
  "pathology.label.refer": "Refer to ImmunoHistoChemistry",
  "pathology.label.release": "Ready For release",
  "pathology.label.report": "Pathology Report",
  "pathology.label.request": "Requests",
  "pathology.label.requests": "Additional Pathology Requests",
  "pathology.label.review": "Awaiting Pathology Review",
  "pathology.label.slide": "Slide",
  "pathology.label.slide.add.number": "Number of Slides to add",
  "pathology.label.slide.number": "Slide number",
  "pathology.label.slides": "Slides",
  "pathology.label.stage": "Stage",
  "pathology.label.storageLocationInterim": "Free text for now. A picker over the laboratory's storage locations arrives with the shared storage model.",
  "pathology.label.techniques": "Techniques Used",
  "pathology.label.textconclusion": "Text Conclusion",
  "pathology.label.tissueType": "Tissue type",
  "pathology.label.title": "Pathology",
  "pathology.label.view": "View File",
  "pathology.locked.decalcNotRequired": "Not required for this specimen",
  "pathology.locked.decalcificationPassed": "No longer editable: the case has passed decalcification.",
  "pathology.locked.nothingToPrint": "No saved labels to print yet",
  "pathology.locked.reasonRequired": "Give a reason before deactivating",
  "pathology.locked.releaseNoPathologist": "A pathologist must be assigned before the case can be released",
  "pathology.locked.releaseNoTechnician": "A technician must be assigned before the case can be released",
  "pathology.locked.saveBeforeDeactivate": "Save or discard your changes before deactivating",
  "pathology.locked.saveBeforeEmbed": "Save or discard your changes before embedding",
  "pathology.locked.slideNeedsBlock": "Pick the block this slide was cut from",
  "pathology.locked.slideNeedsSavedBlock": "Save a cassette before adding a slide",
  "pathology.locked.stageDisabled": "Not tracked at this laboratory",
  "pathology.modal.deactivateBlockHeading": "Deactivate block {designation}?",
  "pathology.modal.deactivateBody": "The record is kept and stays available under Show deactivated. Cassettes, blocks and slides are never deleted.",
  "pathology.modal.deactivateCassetteHeading": "Deactivate cassette {designation}?",
  "pathology.modal.deactivateFailed": "The deactivation was refused. Reload the case and try again.",
  "pathology.modal.deactivateSlideHeading": "Deactivate slide {barcode}?",
  "pathology.section.caseInfo": "Case Information",
  "pathology.section.findings": "Findings & Conclusion",
  "pathology.section.review": "Pathologist Review",
  "pathology.stage.accessioned": "Accessioned",
  "pathology.stage.completed": "Completed",
  "pathology.stage.coverslipping": "Coverslipping & QC",
  "pathology.stage.decalcification": "Decalcification",
  "pathology.stage.embedding": "Embedding",
  "pathology.stage.grossing": "Grossing",
  "pathology.stage.microtomy": "Microtomy",
  "pathology.stage.processing": "Processing",
  "pathology.stage.readyPathologist": "Ready for Pathologist",
  "pathology.stage.staining": "Staining",
  "pathology.stage.underReview": "Under Pathologist Review",
  "pathology.toast.blockDeactivated": "Block {designation} deactivated",
  "pathology.toast.cassetteDeactivated": "Cassette {designation} deactivated",
  "pathology.toast.embedFailed": "Cassette {designation} could not be embedded. Try again; if you have unsaved changes, save them first.",
  "pathology.toast.embedded": "Cassette {designation} embedded",
  "pathology.toast.slideDeactivated": "Slide {barcode} deactivated",
  "patient.address.camp": "Camp/Commune",
  "patient.address.fokontany": "Fokontany",
  "patient.address.hamletOrLot": "Hamlet / Lot",
  "patient.address.healthdistrict": "District",
  "patient.address.healthregion": "Region",
  "patient.address.province": "Province",
  "patient.address.street": "Street",
  "patient.address.town": "Town",
  "patient.age.days": "Days",
  "patient.age.months": "Months",
  "patient.age.years": "Age/Years",
  "patient.alias": "Alias",
  "patient.dataSourceName": "Data Source Name",
  "patient.dob": "Date of Birth",
  "patient.dob.future": "Date of birth cannot be in the future.",
  "patient.validation.contactEmailInvalid": "Enter a valid email address for the contact.",
  "patient.validation.dobInvalid": "Enter a valid date of birth.",
  "patient.validation.dobOrAgeRequired": "Enter a date of birth or an age in years, months or days.",
  "patient.validation.emailInvalid": "Enter a valid email address.",
  "patient.validation.nationalIdRequired": "Enter the national ID.",
  "patient.validation.sexRequired": "Select the patient's sex.",
  "patient.eduction": "Education",
  "patient.emergency.additional.camp": "Enter Camp/Commune",
  "patient.emergency.additional.district": "Enter District",
  "patient.emergency.additional.education": "Enter Education",
  "patient.emergency.additional.maritalstatus": "Enter Martial Status",
  "patient.emergency.additional.nationnality": "Enter Nationality",
  "patient.emergency.additional.othernationality": "Enter Other Nationality",
  "patient.emergency.additional.region": "Enter Region",
  "patient.emergency.additional.street": "Enter Street",
  "patient.emergency.additional.town": "Enter Town",
  "patient.emergency.email": "Enter Emergency Contact Email",
  "patient.emergency.firstname": "Enter Emergency Contact First Name",
  "patient.emergency.lastname": "Enter Emergency Contact Last Name",
  "patient.emergency.phone": "Enter Emergency Contact Phone Number",
  "patient.externalId": "National ID",
  "patient.female": "Female",
  "patient.first.name": "First Name",
  "patient.gender": "Sex",
  "patient.gps.latitude": "GPS Latitude",
  "patient.gps.latitude.placeholder": "e.g., -18.879190 (range -90 to 90)",
  "patient.gps.longitude": "GPS Longitude",
  "patient.gps.longitude.placeholder": "e.g., 47.507905 (range -180 to 180)",
  "patient.id": "Patient Id",
  "patient.information.age": "Enter Age",
  "patient.information.days": "Enter Days",
  "patient.information.email": "Enter Patient Email",
  "patient.information.firstname": "Enter Patient First Name",
  "patient.information.healthid": "Enter Unique Health Identifier",
  "patient.information.lastname": "Enter Patient Last Name",
  "patient.information.months": "Enter Months",
  "patient.information.nationalid": "Enter Nationality Identifier",
  "patient.information.primaryphone": "Enter Patient Primary Number",
  "patient.label": "Patient",
  "patient.label.additionalInfo": "Additional Information",
  "patient.label.age": "Age",
  "patient.label.customNotes": "Custom Notes",
  "patient.label.diseaseProgramme": "Target Disease Programme",
  "patient.label.occupation": "Occupation",
  "patient.label.contactphone": "Contact Phone:{PHONE_FORMAT}",
  "patient.label.email": "Email",
  "patient.label.info": "Patient Information",
  "patient.label.modify": "Add Or Modify Patient",
  "patient.label.name": "Name",
  "patient.label.nopatientid": "No Patient Information Available",
  "patient.label.primaryphone": "Primary phone:{PHONE_FORMAT}",
  "patient.label.sex": "Sex",
  "patient.last.name": "Last Name",
  "phone.format.international.label": "International",
  "phone.format.local.label": "Local",
  "patient.male": "Male",
  "patient.maritalstatus": "Marital Status",
  "patient.merge.activeOrders": "Active Orders",
  "patient.merge.address": "Address",
  "patient.merge.addressesDiffer": "Address differs: {primary} vs {secondary}",
  "patient.merge.auditEntries": "Audit Entries (will retain original patient)",
  "patient.merge.back": "Back",
  "patient.merge.cancelButton": "Cancel",
  "patient.merge.clinicalSummary": "Clinical Summary",
  "patient.merge.confirmButton": "Confirm Merge",
  "patient.merge.confirmCheckbox": "I understand this action cannot be undone and have verified the correct patients are being merged",
  "patient.merge.confirmMerge": "Confirm Patient Merge",
  "patient.merge.conflictNote": "(Primary patient demographics will be used)",
  "patient.merge.conflictingInfo": "Conflicting Information Detected",
  "patient.merge.contactInfo": "Contact Information",
  "patient.merge.county": "County/State",
  "patient.merge.dataToConsolidate": "Data to be Consolidated",
  "patient.merge.demographics": "Demographics",
  "patient.merge.dob": "DOB",
  "patient.merge.email": "Email",
  "patient.merge.emailsDiffer": "Email differs: {primary} vs {secondary}",
  "patient.merge.error.alreadyMerged": "Patient has already been merged",
  "patient.merge.error.executionFailed": "Merge execution failed",
  "patient.merge.error.noPermission": "Only Global Administrators can merge patients",
  "patient.merge.error.patientNotFound": "Patient not found",
  "patient.merge.error.samePatient": "Cannot merge a patient with itself",
  "patient.merge.error.selectBoth": "Please select both patients to continue",
  "patient.merge.error.selectPrimary": "Please select which patient should be the primary record",
  "patient.merge.error.validationFailed": "Merge validation failed",
  "patient.merge.externalIds": "External IDs",
  "patient.merge.gender": "Sex",
  "patient.merge.identifiers": "Identifiers",
  "patient.merge.identifiersToPreserve": "Identifiers to Preserve (both patients)",
  "patient.merge.mergeSummary": "Merge Summary",
  "patient.merge.mergingFrom": "Merging From",
  "patient.merge.mergingLabel": "Merging",
  "patient.merge.name": "Name",
  "patient.merge.nationalId": "National ID",
  "patient.merge.nationalIds": "National IDs",
  "patient.merge.nextStep": "Next Step",
  "patient.merge.noIdentifiers": "No identifiers recorded",
  "patient.merge.noPatientSelected": "No patient selected",
  "patient.merge.notRecorded": "Not recorded",
  "patient.merge.orders": "Orders",
  "patient.merge.ordersCount": "{count} ({active} active)",
  "patient.merge.patientId": "Patient ID",
  "patient.merge.patientIds": "Patient IDs",
  "patient.merge.patientResults": "Patient Results",
  "patient.merge.phone": "Phone",
  "patient.merge.phonesDiffer": "Phone Numbers differ: {primary} vs {secondary}",
  "patient.merge.postalCode": "Postal Code",
  "patient.merge.primaryLabel": "Primary",
  "patient.merge.primaryPatient": "Primary Patient",
  "patient.merge.reason": "Reason for Merge (required)",
  "patient.merge.reasonPlaceholder": "Enter reason for merging these patient records...",
  "patient.merge.recordsReassigned": "{count} records reassigned",
  "patient.merge.samples": "Samples",
  "patient.merge.searchDifferent": "Search for different patient",
  "patient.merge.selectFirstPatient": "Select First Patient",
  "patient.merge.selectPrimaryDescription": "Which patient should become the primary record?",
  "patient.merge.selectPrimaryRecord": "Select Primary Patient Record",
  "patient.merge.selectSecondPatient": "Select Second Patient",
  "patient.merge.step.compare": "Select Primary",
  "patient.merge.step.confirm": "Confirm Merge",
  "patient.merge.step.select": "Select Patients",
  "patient.merge.streetAddress": "Street Address",
  "patient.merge.success": "Patient merge completed successfully",
  "patient.merge.successMessage": "Patient {mergedId} has been merged into patient {primaryId}. Audit ID: {auditId}",
  "patient.merge.testResults": "Test Results",
  "patient.merge.title": "Merge Patient Records",
  "patient.merge.totalContacts": "Contacts",
  "patient.merge.totalRelations": "Relations",
  "patient.merge.totalResults": "Total Results",
  "patient.merge.totalSamples": "Samples",
  "patient.merge.town": "Town/City",
  "patient.merge.tryDifferentSearch": "Try adjusting your search criteria or using different patient identifiers.",
  "patient.merge.warning.dataLink": "All future data will be linked to the primary patient. The non-selected patient will be marked as merged and inactive.",
  "patient.merge.warning.irreversible": "This action CANNOT be undone. All data will be permanently consolidated.",
  "patient.merge.warning.samePatient": "Same patient selected",
  "patient.merge.warning.samePatientDescription": "You have selected the same patient for both records. Please select two different patients to merge.",
  "patient.natioanalid": "National ID",
  "patient.nationalid": "National ID",
  "patient.nationality": "Nationality",
  "patient.nationality.other": "Specify Other nationality",
  "patient.photo.active.camera": "Click to activate camera",
  "patient.photo.add": "Add Photo",
  "patient.photo.browse": "Click to browse files",
  "patient.photo.camera.permission.denied": "Camera permission denied. Please check your browser settings.",
  "patient.photo.cancel": "Cancel",
  "patient.photo.capture": "Capture Photo",
  "patient.photo.captured": "Captured Photo:",
  "patient.photo.change": "Change Image",
  "patient.photo.confirm": "Confirm",
  "patient.photo.dragndrop": "Drag and drop an image here",
  "patient.photo.error.fileTooLarge": "Image is too large. Maximum size is 2MB.",
  "patient.photo.formats": "Formats: JPG, PNG (max 2MB)",
  "patient.photo.import": "Import",
  "patient.photo.label": "Patient Photo",
  "patient.photo.modal.heading": "Select Patient Photo",
  "patient.photo.modal.options": "Image Selection Options",
  "patient.photo.preview": "Preview:",
  "patient.photo.preview.alt": "Patient photo preview",
  "patient.photo.preview.captured.alt": "Captured patient photo",
  "patient.photo.retake": "Retake",
  "patient.photo.start.camera": "Start Camera",
  "patient.photo.take": "Take Photo",
  "patient.photo.view": "View Photo",
  "patient.idDoc.title": "Identification Documents",
  "patient.idDoc.addDocument": "Add Document",
  "patient.idDoc.selectImage": "Select Image",
  "patient.idDoc.documentType": "Document Type",
  "patient.idDoc.description": "Description",
  "patient.idDoc.description.placeholder": "Enter document description",
  "patient.idDoc.category.nationalId": "National ID",
  "patient.idDoc.category.insuranceCard": "Insurance Card",
  "patient.idDoc.category.other": "Other",
  "patient.idDoc.view": "View",
  "patient.idDoc.edit": "Edit",
  "patient.idDoc.delete": "Delete",
  "patient.idDoc.remove": "Remove",
  "patient.idDoc.pending": "Unsaved",
  "patient.idDoc.empty": "No identification documents uploaded",
  "patient.idDoc.viewDocument": "View Document",
  "patient.idDoc.editDocument": "Edit Document",
  "patient.idDoc.confirmDelete": "Delete Document",
  "patient.idDoc.deleteWarning": "Are you sure you want to delete this document? This action cannot be undone.",
  "patient.idDoc.upload": "Upload",
  "patient.idDoc.dragndrop": "Drag and drop a file here",
  "patient.idDoc.browse": "or click to browse files",
  "patient.idDoc.formats": "Formats: JPEG, PNG, PDF (max 10MB)",
  "patient.idDoc.useCamera": "Use Camera",
  "patient.idDoc.pdfSelected": "PDF document selected",
  "patient.idDoc.error.invalidFormat": "Invalid file format. Accepted formats: JPEG, PNG, PDF.",
  "patient.idDoc.error.fileTooLarge": "File is too large. Maximum size is 10MB.",
  "patient.prev.lab.no": "Previous Lab Number",
  "patient.report.associated.name": "Associated Patient Report",
  "patient.report.collection.name": "Collected ARV Patient Report",
  "patient.search.nopatient": "No patients found matching search terms",
  "patient.st.number": "ST Number",
  "patient.subject.number": "Unique Health ID number",
  "patient.yrs": "yrs",
  "patientcontact.person.email": "Contact Email",
  "patientcontact.person.firstname": "Contact first name",
  "patientcontact.person.lastname": "Contact last name",
  "placeholder.accession.number": "Enter Accession No.",
  "print.barcode": "Print Barcode",
  "process.testAdd.pressNext.ageRangeSelectiong": "Press Next button Age Range Selection step is not required !",
  "process.testAdd.pressNext.selectGroupDictionary": "Press Next button Selecting Group Dictionary List step is not required !",
  "program.name.label": "Program Name",
  "project.ARVFollowupStudy.name": "Follow-up ARV",
  "project.ARVStudies.name": "ARV",
  "project.ARVStudy.name": "Initial ARV",
  "project.EIDStudy.name": "EID",
  "project.IndeterminateStudy.name": "Indeterminate",
  "project.RTNStudy.name": "RTN",
  "project.Recency.name": "Recency Testing",
  "project.SequencingStudy.name": "Sequencing",
  "project.SpecialRequestStudy.name": "Special Request",
  "project.VLStudy.name": "VL",
  "project.add.subtitle": "Add Project",
  "project.add.title": "Add Project",
  "project.browse.title": "Project",
  "project.completedDate": "Completed Date",
  "project.desc.short": "Project Descr.",
  "project.description": "Project Description",
  "project.edit.subtitle": "Edit Project",
  "project.edit.title": "Edit Project",
  "project.external.reference": "External Reference",
  "provider.browse.title": "Provider Management",
  "provider.email": "Email",
  "provider.fax": "Fax",
  "provider.isActive": "Is Active",
  "provider.modal.add.heading": "Add Provider",
  "provider.modal.update.heading": "Update Provider",
  "provider.providerFirstName": "Provider Firstname",
  "provider.providerLastName": "Provider Lastname",
  "provider.search": "Provider Search",
  "provider.search.placeholder": "Search Provider Name...",
  "provider.select": "Select Provider",
  "provider.telephone": "Telephone",
  "qa.checklist.incomplete": "QA checklist is incomplete",
  "qa.checklist.instructions": "Complete all required checks before submitting",
  "qa.checklist.samplingSiteCorrect": "Sampling site information is correct",
  "qa.checklist.title": "QA Checklist",
  "qa.summary.noSamples": "No samples to review",
  "qa.summary.noTests": "No tests selected",
  "qa.summary.order": "Order Details",
  "qa.summary.panel": "Panel",
  "qa.summary.patient": "Patient Information",
  "qa.summary.poolOf": "Pool of {count} {animal}",
  "qa.summary.samples": "Sample Summary",
  "qa.summary.samplingSite": "Sampling Site",
  "qa.summary.siteCode": "Site Code",
  "qa.summary.siteName": "Site Name",
  "qc.comments.add": "Add Comment",
  "qc.comments.empty": "No comments yet",
  "qc.comments.placeholder": "Enter QC comment...",
  "qc.comments.title": "QC Comments",
  "qc.expectedValue": "Expected Value",
  "qc.frequency.compliance": "Compliance Metrics",
  "qc.frequency.config": "QC Frequency Configuration",
  "qc.frequency.daily": "Daily Startup",
  "qc.frequency.everyHours": "Every N Hours",
  "qc.frequency.everySamples": "Every N Samples",
  "qc.frequency.manual": "Manual Trigger Only",
  "qc.frequency.notConfigured": "Not configured",
  "qc.frequency.perShift": "Per Shift",
  "qc.frequency.save": "Save Configuration",
  "qc.frequency.type": "Frequency Type",
  "qc.frequency.value": "Frequency Value",
  "qc.leveyJennings.mean": "Mean",
  "qc.leveyJennings.minus2SD": "-2 SD",
  "qc.leveyJennings.minus3SD": "-3 SD",
  "qc.leveyJennings.noData": "No QC data available",
  "qc.leveyJennings.plus2SD": "+2 SD",
  "qc.leveyJennings.plus3SD": "+3 SD",
  "qc.leveyJennings.title": "Levey-Jennings Control Chart",
  "qc.notes": "QC Notes",
  "qc.notes.placeholder": "Enter QC notes and observations",
  "qc.parentSample": "Parent Sample",
  "qc.signature.comment": "Comment (optional)",
  "qc.signature.comment.placeholder": "Add a comment...",
  "qc.signature.ipAddress": "IP Address",
  "qc.signature.noSignatures": "No signatures yet",
  "qc.signature.sign": "Sign Report",
  "qc.signature.signedAt": "Signed At",
  "qc.signature.success": "Report signed successfully",
  "qc.signature.title": "Electronic Signatures",
  "qc.signature.userId": "User ID",
  "qc.status": "QC Status",
  "qc.status.failed": "Failed",
  "qc.status.notRequired": "Not Required",
  "qc.status.passed": "Passed",
  "qc.status.pending": "Pending QC",
  "qc.status.select": "Select QC status",
  "qc.status.update.button": "Update QC Status",
  "qc.status.update.success": "QC status updated successfully",
  "qc.status.update.title": "Update QC Status",
  "qc.status.warning.message": "Marking this lot as 'Failed' will prevent it from being used until QC status is updated.",
  "qc.status.warning.title": "QC Failure Warning",
  "qc.westgard.noViolations": "No violations detected",
  "qc.westgard.rule.disabled": "Disabled",
  "qc.westgard.rule.enabled": "Enabled",
  "qc.westgard.rules": "Westgard Rules",
  "qc.westgard.rules.description": "Configure Westgard multi-rule QC evaluation",
  "qc.westgard.violations": "Violations",
  "quantity": "Quantity",
  "quantity.balanced": "Quantity balanced",
  "quantity.not.balanced": "Quantity not balanced",
  "quick.entry.accession.number": "Accession Number",
  "referTest.referralLabel": "Refer test to a reference lab",
  "referral.button.labSearch": "Search Referrals By Lab Number",
  "referral.button.patientSearch": "Search Patient",
  "referral.button.unitTestSearch": "Search Referrals By Unit(s) & Test(s)",
  "referral.date.end": "End Date (dd/mm/yyyy)",
  "referral.date.start": "Start Date (dd/mm/yyyy)",
  "referral.emptyState": "No referrals found for the selected filters.",
  "referral.error": "No Referrals matching criteria",
  "referral.input": "Scan OR Enter Manually",
  "referral.label.institute": "Institute",
  "referral.label.reason": "Referral Reason",
  "referral.label.referredOutTests": "ReferredOutTests",
  "referral.label.sentdate": "Sent Date",
  "referral.label.testmethod": "Methods",
  "referral.label.testtoperform": "Test to Perform",
  "referral.main.button": "Search Referrals By Patient",
  "referral.matching.search": "Referred Tests Matching Search",
  "referral.out.head": "Referrals",
  "referral.out.note": "Note if searching by result date, only tests with results will appear.",
  "referral.out.request": "Results By Date / Test / Unit Date Type :",
  "referral.print.selected.patient.reports": "Print Selected Patient Reports",
  "referral.print.selected.patient.reports.selectall.button": "Select All",
  "referral.print.selected.patient.reports.selectnone.button": "Select None",
  "referral.result.labNumber": "Results By Lab Number",
  "referral.result.referenceRange": "Reference range",
  "referral.search": "Search",
  "referral.search.column.analysisId": "AnalysisId",
  "referral.search.column.referenceLab": "Reference Lab",
  "referral.search.column.resultDate": "Result Date",
  "referral.search.column.sentDate": "Sent Date",
  "referral.test": "Test(s)",
  "referral.testresult.pastnote": "Past Notes",
  "referral.units": "Unit(s)",
  "referrer.label": "referrer",
  "reflexTests": "Reflex Tests",
  "reject.action.button": "Reject",
  "reject.order.sample.notification": "You are rejecting a sample. This sample will be rejected and not appear in workplans once saved,no results can be entered for this order.",
  "remaining.quantity": "Remaining Quantity:",
  "remove.aliquot": "Remove Aliquot",
  "report.enter.labNumber.headline": "Generate a report or range of reports by Order Number / Lab Number",
  "report.enter.patient.headline": "Generate All Reports for a Client",
  "report.enter.patient.headline.description": "Search for the patient via previous lab number, Patient ID (which can be either Unique Health ID number or national ID) or other fields.",
  "report.enter.site.headline": "Generate Reports By Site",
  "report.labe.byLabNumber": "Report By Lab Number",
  "report.labe.byPatient": "Report By Patient",
  "report.labe.date": "Report By Date",
  "report.labe.site": "Report By Site",
  "report.label.site.dateType": "Date Type",
  "report.label.site.onlyResults": "Only Reports with results",
  "report.patient.site.description": "Generate reports by result date or by order date. Result date will show only reports with results.If you select only resports with results, all reports where all tests are in progress will not be generated.",
  "report.patient.title.final": "Results: final report",
  "report.patient.title.partial": "Results: partial report",
  "report.patient.labDirector": "Lab director",
  "report.patient.block.order": "Order",
  "report.patient.block.dates": "Dates",
  "report.patient.siteWard": "Site / ward",
  "report.patient.completed": "Completed",
  "report.patient.completed.pending": "Not yet complete",
  "report.patient.contactTracing.indexName": "Contact tracing index name",
  "report.patient.contactTracing.indexRecordNumber": "Contact tracing index record number",
  "report.patient.samples": "Samples",
  "report.patient.sample.number": "#",
  "report.patient.sample.condition": "Condition",
  "report.patient.sample.rejected": "Rejected: {0}",
  "report.patient.sample.notRecorded": "Not recorded",
  "report.patient.strip.collected": "Collected {0}",
  "report.patient.strip.collectedFirst": "Collected {0} (first of {1} samples)",
  "report.patient.result.sampleRejected": "Sample rejected",
  "report.patient.result.rejected": "Rejected",
  "report.patient.col.sample": "Smp",
  "report.patient.col.completed": "Completed",
  "report.patient.flag.low": "L",
  "report.patient.flag.high": "H",
  "report.patient.flag.criticalLow": "LL",
  "report.patient.flag.criticalHigh": "HH",
  "report.patient.flag.abnormal": "*",
  "report.patient.flag.referred": "R",
  "report.patient.flag.confirm": "C",
  "report.patient.legend": "Legend",
  "report.patient.legend.high": "above normal",
  "report.patient.legend.low": "below normal",
  "report.patient.legend.critical": "critical",
  "report.patient.legend.referred": "referred, result pending",
  "report.patient.legend.confirm": "confirmation test",
  "report.patient.notAccredited": "Not within the laboratory's accredited scope",
  "report.patient.awaitingValidation": "Awaiting validation",
  "report.patient.performedBy": "Performed by {0}",
  "report.patient.accred.notesLine": "Tests on this report are accredited by: {0}.",
  "report.patient.callback.line": "Callback: {0}, {1}, by {2}. {3}.",
  "report.patient.callback.more": "(+{0} earlier attempts)",
  "report.patient.callback.confirmed": "Read back confirmed",
  "report.patient.callback.noReadback": "Reached, no read-back",
  "report.patient.callback.unreachable": "Unable to reach",
  "report.patient.corrected.line": "Corrected report. Replaces the report issued {0}. Change: {1}.",
  "report.patient.corrected.seeReplaced": "See the replaced report",
  "report.patient.version": "Version {0}.",
  "report.patient.footer.version": "Version {0}",
  "report.patient.comments": "General comments",
  "report.patient.releasedBy": "Validated and released by",
  "report.patient.endOfReport": "End of report",
  "report.patient.issued": "Issued",
  "report.patient.page": "Page",
  "report.select.site": "Select Site",
  "report.select.studttype": "Select Study Type",
  "reporting.label.testName": "Reporting Test Name",
  "reports.auditTrail": "Audit Trail",
  "reports.systemAuditTrail": "System Audit Trail",
  "reports.button": "Generate Report",
  "reports.dateRange": "Date Range",
  "reports.endDate": "End Date",
  "reports.error.dateRangeRequired": "Date range is required for this report type",
  "reports.error.generationFailed": "Failed to generate report. Please try again.",
  "reports.error.invalidDate": "Invalid date",
  "reports.error.invalidDateRange": "End date must be after start date",
  "reports.error.unknownExportFormat": "Unknown export format",
  "reports.error.unknownReportType": "Unknown report type",
  "reports.export": "Export",
  "reports.export.byDate": "Export By Date",
  "reports.export.byDate_routine": "Routine CSV Report",
  "reports.export.general": "General export",
  "reports.export.specific": "Viral Load Data Export",
  "reports.export.valid": "Valid",
  "reports.export.whonet": "WHONET Report",
  "reports.followupRequired.byLocation": "Follow-up Required",
  "reports.format": "Export Format",
  "reports.format.select": "Select format",
  "reports.generate.title": "Generate Inventory Report",
  "reports.generating": "Generating...",
  "reports.generation.success": "Report generated and downloaded successfully",
  "reports.groupByLocation": "Group by storage location",
  "reports.groupByType": "Group by item type",
  "reports.grouping": "Grouping Options",
  "reports.help.description": "Use these reports to analyze your inventory data:",
  "reports.help.tip1": "Use date ranges for trend analysis",
  "reports.help.tip2": "Filter by tag to report on one group of items",
  "reports.help.tip3": "Export to Excel for further analysis",
  "reports.help.title": "Report Tips",
  "reports.includeExpired": "Include expired lots",
  "reports.includeInactive": "Include inactive items",
  "reports.info.message": "Select report type and options below. Reports may take a few moments to generate.",
  "reports.info.title": "Report Generation",
  "reports.label.cistudyexport": "General Report",
  "reports.label.indicator": "Indicator",
  "reports.label.indicator.performance": "Section Performance",
  "reports.label.referred.out": "Referred Out Tests Report",
  "reports.label.trends": "Trends",
  "reports.menu.covid": "Covid Report",
  "reports.nonConformity.byDate.report": "By Date",
  "reports.nonConformity.byLabno.report": "By Labno",
  "reports.nonConformity.bySectionReason.report": "By Unit and Reason",
  "reports.nonConformity.bySectionReason.title": "Non Conformity Report by Unit and Reason",
  "reports.nonConformity.menu": "Non Conformity Reports",
  "reports.nonConformity.notification.report": "Non-conformity notification",
  "reports.nonConformity.notification.report.instructions": "If a service is selected then any non-conformity notifications which have not yet been printed will be printed. If there are no services listed then all notifications have already been printed. Entering a laboratory number will print a notification even if it has already been printed. A service does not have to be chosen.",
  "reports.options": "Filter Options",
  "reports.patient.ARV.version1": "ARV-Version",
  "reports.patient.ARV.version1 ": "ARV-Version 1",
  "reports.patient.ARVFollowup.version1": "ARV Follow-up Version 1",
  "reports.patient.ARVFollowup.version2": "ARV Follow-up Version 2",
  "reports.patient.ARVInitial.version1": "ARV Initial Version 1",
  "reports.patient.ARVInitial.version2": "ARV Initial Version 2",
  "reports.patient.Indeterminate.location": "Indeterminate by Service",
  "reports.patient.Indeterminate.version1": "Indeterminate Version 1",
  "reports.patient.Indeterminate.version2": "Indeterminate Version 2",
  "reports.startDate": "Start Date",
  "reports.type": "Report Type",
  "reports.type.expirationForecast": "Expiration Forecast",
  "reports.type.expirationForecast.description": "Items expiring within specified date range",
  "reports.type.lotTraceability": "Lot Traceability",
  "reports.type.lotTraceability.description": "Complete traceability of lot movements and usage",
  "reports.type.lowStock": "Low Stock Alert",
  "reports.type.lowStock.description": "Items currently below minimum stock level",
  "reports.type.select": "Select report type",
  "reports.type.stockLevels": "Stock Levels Report",
  "reports.type.stockLevels.description": "Current stock levels for all inventory items",
  "reports.type.transactionHistory": "Transaction History",
  "reports.type.transactionHistory.description": "All transactions within date range",
  "reports.type.usageTrends": "Usage Trends",
  "reports.type.usageTrends.description": "Usage patterns and consumption trends over time",
  "request.samesite.order": "Place same site order",
  "requester.label": "Requester",
  "required.invalidtext": "This field is required",
  "result.acceptasis.warning": "Checking this box will indicate that you accept the results unconditionally.\nExpected uses:\n1. The test has been redone and the result is the same.\n2. There is no result for the test but you do not want to cancel it.\n3. The result was changed and the technician wants to give the biologist the option to add a note during the validation step explaining the reason of the change.\nIn  either case, leave a note explaining why you are taking this action.\n",
  "result.acceptasis.trigger": "Accept",
  "result.acceptasis.reason.label": "Reason for unconditional acceptance",
  "result.acceptasis.reason.placeholder": "Required — e.g. retested twice with same result, or no result available",
  "result.acceptasis.confirm": "Confirm acceptance",
  "result.acceptasis.cancel": "Cancel",
  "result.acceptasis.committed": "Accepted",
  "result.acceptasis.undo": "Undo",
  "result.entry.error.accessionRequired": "Please enter an accession number",
  "result.entry.error.title": "Error",
  "result.entry.info.title": "Information",
  "result.entry.label": "Result Entry",
  "result.entry.noResults": "No sample found for accession number {accessionNumber}",
  "result.entry.noTestsFound": "No tests with pending results found for accession number {accessionNumber}",
  "result.entry.results.accessionNumber": "Accession Number",
  "result.entry.results.sampleCount": "Samples",
  "result.entry.results.testCount": "Tests",
  "result.entry.results.title": "Tests Pending Results",
  "result.entry.saveSuccess": "Result saved for {testName}",
  "result.entry.search.accessionLabel": "Accession Number",
  "result.entry.search.accessionPlaceholder": "Enter accession number...",
  "result.entry.search.button": "Search",
  "result.entry.search.searching": "Searching...",
  "result.entry.search.title": "Search by Accession Number",
  "result.entry.success.title": "Success",
  "result.entry.table.action": "Action",
  "result.entry.table.header.sampleId": "Sample ID",
  "result.entry.table.header.sampleType": "Sample Type",
  "result.entry.table.header.testCount": "Tests",
  "result.entry.table.noSamples": "No samples with tests found",
  "result.entry.table.noTests": "No tests for this sample",
  "result.entry.table.result": "Result",
  "result.entry.table.resultPlaceholder": "Enter result",
  "result.entry.table.save": "Save",
  "result.entry.table.saving": "Saving...",
  "result.entry.table.status": "Status",
  "result.entry.table.testName": "Test Name",
  "result.entry.table.testsTitle": "Tests ({count})",
  "result.entry.title": "Result Entry",
  "result.noTestsFound": "No appropriate tests were found.",
  "result.nonconforming.item": "Sample or order is nonconforming OR test has been rejected",
  "result.outOfValidRange.msg": "The value you entered (red field) is outside the range of allowable values for that record. Please check the value",
  "result.notNumeric.msg": "{test}: \"{value}\" is not a number. Enter a plain decimal or scientific notation such as 1.5e5 or 1.5 x 10^5, then save again.",
  "result.reject.warning": "Rejecting the result will permanently delete test results \nThe results will no longer be available.",
  "result.report.queue.size": "Queue Size :",
  "result.search.noresult": "No results found",
  "resultreporting.browse.title": "Result Reporting Configuration",
  "resultreporting.config.url": "URL for site to which the results will be sent. For example http://192.168.56.101/someSite",
  "resultreporting.config.url.placeholder": "https://orgname.com/someSite",
  "results.label.refer": "Refer test to a reference lab",
  "routine.reports": "Routine Reports",
  "rulebuilder.error.invalidNumeric": "Invalid Numeric Value",
  "rulebuilder.error.invalidTest": "Invalid Test",
  "rulebuilder.label.add.externaltrigger": "Add External `triggered by` message",
  "rulebuilder.label.add.internaltrigger": "Add Internal `triggered by` message",
  "rulebuilder.label.addAction": "Add Action",
  "rulebuilder.label.addCondition": "Add Condition",
  "rulebuilder.label.addExternalNote": "Add External Note",
  "rulebuilder.label.addInternalNote": "Add Internal Note",
  "rulebuilder.label.addPopup": "Add Pop Up",
  "rulebuilder.label.addRule": "Add Rule",
  "rulebuilder.label.addRuleConditions": "Add Reflex Rule Conditions",
  "rulebuilder.label.confirmDelete": "Are you sure you want to deactivate this Rule?",
  "rulebuilder.label.dictValue": "Dictionaly Value",
  "rulebuilder.label.noSuggestions": "No suggestions available",
  "rulebuilder.label.numericValue": "Numeric value",
  "rulebuilder.label.numericValue2": "Numeric value 2",
  "rulebuilder.label.overallOptions": "Over All Option",
  "rulebuilder.label.perfomActions": "Perform the following actions",
  "rulebuilder.label.relation": "Relation",
  "rulebuilder.label.removeAction": "Remove Action",
  "rulebuilder.label.removeCondition": "Remove Condition",
  "rulebuilder.label.removeRule": "Deactivate Rule",
  "rulebuilder.label.rule": "Rule",
  "rulebuilder.label.ruleDetails": "View Rule",
  "rulebuilder.label.ruleName": "Rule Name",
  "rulebuilder.label.searchTest": "Search Test",
  "rulebuilder.label.selectSample": "Select Sample",
  "rulebuilder.label.textValue": "Text value",
  "rulebuilder.label.toggleRule": "Activate / Deactivate",
  "sample.accession.number": "Sample Accession",
  "sample.add.action": "Add Sample",
  "sample.collection.date": "Collection Date",
  "sample.collection.method": "Collection Method",
  "sample.collection.method.placeholder": "e.g., venipuncture, capillary, tubing",
  "sample.collection.time": "Collection Time",
  "sample.currentDate": "Current Date",
  "sample.requiredBy": "Required By",
  "sample.specimen.origin": "Specimen Origin (referent lab)",
  "sample.specimen.origin.placeholder": "Referring laboratory name",
  "sample.temperature": "Sample Temperature",
  "sample.temperature.placeholder": "e.g., room temp, iced, refrigerated",
  "sample.entry.available.tests": "Available Tests",
  "sample.entry.nextVisit.date": "Date of next visit",
  "sample.entry.panels": "Panels",
  "sample.entry.project.patient.and.testName": "Name/Code of patient {br} Test Name",
  "sample.entry.project.testName": "Test Name",
  "sample.entry.search.barcode": "Print Barcodes for Existing Orders",
  "sample.id": "Sample ID",
  "sample.item.info": "Sample Information",
  "sample.items.for.accession": "Sample items for accession number:",
  "sample.label.accessionNumber": "Accession Number",
  "sample.label.collectionDate": "Collection Date",
  "sample.label.dept": "Ward/Dept/Unit",
  "sample.label.facility": "Referring Facility",
  "sample.label.labnumber": "Lab Number",
  "sample.label.labnumber.generate": "Generate",
  "sample.label.labnumber.new": "New Lab Number",
  "sample.labnumber.reassign.button": "Reassign Lab Number",
  "sample.labnumber.reassign.confirm": "Reassign",
  "sample.labnumber.reassign.current": "Current Lab Number",
  "sample.labnumber.reassign.heading": "Reassign Lab Number",
  "sample.labnumber.reassign.pending": "This specimen will be reassigned to {number} when you save.",
  "sample.labnumber.reassign.pending.title": "Pending Lab Number reassignment",
  "sample.labnumber.reassign.undo": "Undo",
  "sample.labnumber.reassign.warning": "Reassigning permanently changes this specimen's Lab Number. Existing labels, reports, and references to the current number will no longer match it. Do this only to correct a mislabelled specimen.",
  "sample.label.noorder": "Order Doesn't Exist",
  "sample.label.orderdate": "Order Date",
  "sample.label.orderpanel": "Order Panels",
  "sample.label.requester": "Requester",
  "sample.label.search.Order": "Search Order",
  "sample.label.search.labnumber": "Search By Accession Number",
  "sample.label.search.patient": "Search By Patient",
  "sample.label.typeOfSample": "Sample Type",
  "sample.label.types": "Sample Types",
  "sample.management.action.clearSelection": "Clear Selection",
  "sample.management.action.createAliquot": "Create Aliquot",
  "sample.management.action.selectAllAliquots": "Select All Aliquots",
  "sample.management.action.selectAllParents": "Select All Parents",
  "sample.management.addTests.button": "Add Tests",
  "sample.management.addTests.error.addFailed": "Failed to add tests. Please try again.",
  "sample.management.addTests.error.loadSampleTypes": "Error loading sample types",
  "sample.management.addTests.error.loadTests": "Error loading available tests",
  "sample.management.addTests.error.noEligibleSamples": "Cannot add tests: all selected samples have been fully dispensed",
  "sample.management.addTests.error.noTests": "Please select at least one test",
  "sample.management.addTests.modal.add": "Add Tests",
  "sample.management.addTests.modal.addCount": "Add {count} Test(s)",
  "sample.management.addTests.modal.adding": "Adding...",
  "sample.management.addTests.modal.aliquotsIncluded": "aliquot(s) included",
  "sample.management.addTests.modal.bulkAliquotNote": "Tests will be added to all selected samples including aliquots.",
  "sample.management.addTests.modal.cancel": "Cancel",
  "sample.management.addTests.modal.noEligibleSamples": "No Eligible Samples",
  "sample.management.addTests.modal.noTestsAvailable": "No tests available for this sample type.",
  "sample.management.addTests.modal.noTestsSelected": "No tests selected",
  "sample.management.addTests.modal.panels": "Panels",
  "sample.management.addTests.modal.searchTestsPlaceholder": "Search tests...",
  "sample.management.addTests.modal.selectSampleType": "Sample Type",
  "sample.management.addTests.modal.selectSampleTypeFirst": "Please select a sample type to view available panels and tests.",
  "sample.management.addTests.modal.selectSampleTypePlaceholder": "Select a sample type...",
  "sample.management.addTests.modal.selectTests": "Select Tests",
  "sample.management.addTests.modal.selectTestsPlaceholder": "Search and select tests...",
  "sample.management.addTests.modal.selectedTests": "Selected Tests",
  "sample.management.addTests.modal.subtitle": "Add tests to {count} selected sample(s)",
  "sample.management.addTests.modal.tests": "Tests",
  "sample.management.addTests.modal.title": "Add Tests to Sample",
  "sample.management.addTests.resultItem": "{sampleId}: {added} added",
  "sample.management.addTests.resultItem.withSkipped": "{sampleId}: {added} added, {skipped} skipped",
  "sample.management.addTests.success": "{count} test(s) added successfully",
  "sample.management.addTests.successDetailed": "{count} test(s) added to {samples} sample(s): {details}",
  "sample.management.addTests.successDetailedWithSkipped": "{added} test(s) added to {samples} sample(s), {skipped} skipped: {details}",
  "sample.management.addTests.successWithSkipped": "{added} test(s) added, {skipped} skipped (already ordered)",
  "sample.management.addTests.title": "Add Tests",
  "sample.management.addTests.warning.dispensedSamples": "{count} sample(s) have no remaining volume and will be skipped. Tests will be added to {eligible} eligible sample(s).",
  "sample.management.addTests.warning.dispensedSamples.title": "Dispensed Samples Excluded",
  "sample.management.aliquot.error.createFailed": "Failed to create aliquot. Please try again.",
  "sample.management.aliquot.error.numberOfAliquotsInvalid": "Number of aliquots must be between 1 and 100",
  "sample.management.aliquot.error.quantityExceedsRemaining": "Requested quantity ({requested}) exceeds remaining quantity ({remaining})",
  "sample.management.aliquot.error.quantityPerAliquotTooSmall": "Quantity per aliquot ({quantityPerAliquot}) would be less than minimum (0.001)",
  "sample.management.aliquot.error.quantityPositive": "Quantity must be greater than 0",
  "sample.management.aliquot.error.quantityRequired": "Quantity is required",
  "sample.management.aliquot.error.title": "Error",
  "sample.management.aliquot.modal.cancel": "Cancel",
  "sample.management.aliquot.modal.create": "Create Aliquot",
  "sample.management.aliquot.modal.createMultiple": "Create {count} Aliquots",
  "sample.management.aliquot.modal.creating": "Creating...",
  "sample.management.aliquot.modal.notesLabel": "Notes (Optional)",
  "sample.management.aliquot.modal.notesPlaceholder": "Add any notes about this aliquot...",
  "sample.management.aliquot.modal.numberOfAliquotsHelper": "Enter how many equal-volume aliquots to create (1-100)",
  "sample.management.aliquot.modal.numberOfAliquotsLabel": "Number of Aliquots",
  "sample.management.aliquot.modal.parentInfo": "Parent Sample Information",
  "sample.management.aliquot.modal.preview": "Preview",
  "sample.management.aliquot.modal.previewText": "Creating {count} aliquots with {quantityEach} {unit} each",
  "sample.management.aliquot.modal.quantityHelper": "Enter the quantity to transfer in {unit}",
  "sample.management.aliquot.modal.quantityLabel": "Quantity to Transfer",
  "sample.management.aliquot.modal.quantityPlaceholder": "Enter quantity",
  "sample.management.aliquot.modal.subtitle": "Create aliquot from sample {externalId}",
  "sample.management.aliquot.modal.title": "Create Aliquot",
  "sample.management.aliquot.modal.totalQuantityHelper": "Enter the total quantity to divide among all aliquots in {unit}",
  "sample.management.aliquot.modal.totalQuantityLabel": "Total Quantity to Transfer",
  "sample.management.aliquot.success": "Aliquot {externalId} created successfully. Please search again to see the updated results.",
  "sample.management.aliquot.successMultiple": "{count} aliquots created successfully ({externalIds}). Please search again to see the updated results.",
  "sample.management.breadcrumb.title": "Sample Management",
  "sample.management.cancelTest.error": "Failed to cancel test. Please try again.",
  "sample.management.cancelTest.success": "Test \"{testName}\" cancelled successfully",
  "sample.management.description": "Search and manage sample items, create aliquots, and add tests",
  "sample.management.error.title": "Error",
  "sample.management.hierarchy.aliquotOf": "Aliquot of {parent}",
  "sample.management.hierarchy.aliquots": "aliquots",
  "sample.management.noResults.subtitle": "No sample items found for accession number: {accessionNumber}",
  "sample.management.noResults.title": "No Results Found",
  "sample.management.results.accessionNumber": "Accession Number",
  "sample.management.results.aliquots": "aliquots",
  "sample.management.results.aliquotsSelected": "aliquots",
  "sample.management.results.item": "item",
  "sample.management.results.items": "items",
  "sample.management.results.selected": "Selected",
  "sample.management.results.title": "Sample Items",
  "sample.management.results.totalCount": "Total Samples",
  "sample.management.search.error.general": "Error loading sample results. Please try again.",
  "sample.management.search.label": "Search Samples",
  "sample.management.search.loading": "Searching...",
  "sample.management.search.placeholder": "Enter accession number to search...",
  "sample.management.search.title": "Search Samples",
  "sample.management.status.allVolumeDispensed": "All Volume Dispensed",
  "sample.management.status.available": "Available",
  "sample.management.status.consumed": "Consumed",
  "sample.management.status.inUse": "In Use",
  "sample.management.status.unknown": "Unknown",
  "sample.management.success.title": "Success",
  "sample.management.table.cancelTest": "Cancel Test",
  "sample.management.table.cancelling": "Cancelling...",
  "sample.management.table.header.externalId": "Sample ID",
  "sample.management.table.header.hierarchy": "Hierarchy",
  "sample.management.table.header.originalQuantity": "Original Quantity",
  "sample.management.table.header.quantity": "Original Quantity",
  "sample.management.table.header.remainingQuantity": "Remaining Quantity",
  "sample.management.table.header.sampleType": "Sample Type",
  "sample.management.table.header.status": "Status",
  "sample.management.table.header.tests": "Tests",
  "sample.management.table.noResults": "No sample items to display. Use the search above to find samples.",
  "sample.management.table.noTests": "No tests ordered for this sample",
  "sample.management.table.orderedDate": "Ordered",
  "sample.management.table.orderedTests": "Ordered Tests ({count})",
  "sample.management.title": "Sample Management",
  "sample.panel.label.text": "Search Available panel",
  "sample.panel.placeholder": "Choose Available panel",
  "sample.panel.search.error.msg": "No panel found matching",
  "sample.quantity.label": "Quantity",
  "sample.receivedDate": "Received Date",
  "sample.reject.label": "Reject Sample",
  "sample.reject.reason.choose": "Choose a rejection reason",
  "sample.reject.reason.label": "Rejection reason",
  "sample.reject.reasonRequired": "Choose a rejection reason.",
  "sample.remove.action": "Remove Sample",
  "sample.requestDate": "Request Date",
  "sample.search.nosample": "No sample found for the provided accession number.",
  "sample.search.panel.legend.text": "Search through the available panels",
  "sample.search.scanner.instructions": "Scan or Enter Manually. For a single report, leave the box at the right empty",
  "sample.search.scanner.instructions.highaccession": "For a single report, leave the box at the right empty",
  "sample.search.scanner.instructions2": "Scan or Enter Manually.",
  "sample.search.title": "Search Sample",
  "sample.select.type": "Select sample type",
  "sample.type": "Sample Type",
  "searchableList.noMatch": "Nothing matches \"{query}\".",
  "searchableList.remove": "Remove {name}",
  "searchableList.search.panels": "Search panels",
  "searchableList.search.tests": "Search tests",
  "sample.type.and.test.sort.order": "Sample type and test sort order",
  "sample.type.helper": "Select a specimen type — available panels and tests update after selection.",
  "sample.uom.label": "Sample Unit Of Measure",
  "sample.uom.search": "Type to search units",
  "sample.voided.title": "Sample is voided",
  "sampleManagement.actions": "Actions",
  "sampleManagement.addTests.button": "Add Tests",
  "sampleManagement.addTests.cancel": "Cancel",
  "sampleManagement.addTests.duplicate": "Test already ordered for {sampleId}",
  "sampleManagement.addTests.error": "Error adding tests",
  "sampleManagement.addTests.incompatible": "Test not compatible with sample type ({sampleType})",
  "sampleManagement.addTests.selectSamples": "Select sample(s) to add tests",
  "sampleManagement.addTests.selectTests": "Select test(s) to add",
  "sampleManagement.addTests.skipped": "Skipped {count} duplicate(s)",
  "sampleManagement.addTests.submit": "Add Tests",
  "sampleManagement.addTests.success": "{count} test(s) added successfully",
  "sampleManagement.addTests.title": "Add Tests to Samples",
  "sampleManagement.aliquot.button": "Create Aliquot",
  "sampleManagement.aliquot.cancel": "Cancel",
  "sampleManagement.aliquot.error": "Error creating aliquot",
  "sampleManagement.aliquot.error.concurrentModification": "Another user modified this sample. Please refresh and try again.",
  "sampleManagement.aliquot.error.insufficientQuantity": "Cannot aliquot: requested {requested} exceeds remaining {remaining}",
  "sampleManagement.aliquot.error.noRemainingQuantity": "All volume dispensed: no remaining quantity available for aliquoting",
  "sampleManagement.aliquot.notes": "Notes (optional)",
  "sampleManagement.aliquot.notesPlaceholder": "Add notes about this aliquot...",
  "sampleManagement.aliquot.parentExternalId": "Parent External ID",
  "sampleManagement.aliquot.parentLabel": "Parent Sample",
  "sampleManagement.aliquot.quantityPlaceholder": "Enter quantity...",
  "sampleManagement.aliquot.quantityToTransfer": "Quantity to Transfer",
  "sampleManagement.aliquot.remainingQuantity": "Remaining Quantity",
  "sampleManagement.aliquot.submit": "Create Aliquot",
  "sampleManagement.aliquot.success": "Aliquot {externalId} created successfully",
  "sampleManagement.aliquot.title": "Create Aliquot",
  "sampleManagement.aliquot.unit": "Unit",
  "sampleManagement.aliquot.validation.exceeds": "Quantity exceeds remaining quantity",
  "sampleManagement.aliquot.validation.min": "Quantity must be at least 0.001",
  "sampleManagement.aliquot.validation.required": "Quantity to transfer is required",
  "sampleManagement.clearSelection": "Clear selection",
  "sampleManagement.hierarchy.children": "Aliquots:",
  "sampleManagement.hierarchy.collapse": "Collapse hierarchy",
  "sampleManagement.hierarchy.expand": "Expand hierarchy",
  "sampleManagement.hierarchy.level": "Level {level}",
  "sampleManagement.hierarchy.parent": "Parent:",
  "sampleManagement.notification.refreshResults": "Results have been refreshed",
  "sampleManagement.results.children": "Aliquots",
  "sampleManagement.results.collectionDate": "Collection Date",
  "sampleManagement.results.count": "{count} sample(s) found",
  "sampleManagement.results.externalId": "External ID",
  "sampleManagement.results.originalQuantity": "Original Quantity",
  "sampleManagement.results.parent": "Parent",
  "sampleManagement.results.remainingQuantity": "Remaining Quantity",
  "sampleManagement.results.sampleType": "Sample Type",
  "sampleManagement.results.status": "Status",
  "sampleManagement.results.tests": "Tests",
  "sampleManagement.results.title": "Search Results",
  "sampleManagement.search.button": "Search",
  "sampleManagement.search.error": "Error searching for samples",
  "sampleManagement.search.label": "Search by Accession Number",
  "sampleManagement.search.loading": "Searching...",
  "sampleManagement.search.noResults": "No samples found with this accession number",
  "sampleManagement.search.placeholder": "Enter accession number...",
  "sampleManagement.selectSamples": "Select sample(s)",
  "sampleManagement.selectedCount": "{count} selected",
  "sampleManagement.test.name": "Test Name",
  "sampleManagement.test.orderedDate": "Ordered Date",
  "sampleManagement.test.status": "Status",
  "sampleManagement.test.status.CANCELLED": "Cancelled",
  "sampleManagement.test.status.COMPLETED": "Completed",
  "sampleManagement.test.status.IN_PROGRESS": "In Progress",
  "sampleManagement.test.status.ORDERED": "Ordered",
  "sampleManagement.title": "Sample Management",
  "sampleManagement.validation.accessionNumberRequired": "Accession number is required",
  "sampleManagement.validation.parentSampleRequired": "Parent sample item is required",
  "sampleManagement.validation.samplesRequired": "At least one sample must be selected",
  "sampleManagement.validation.testsRequired": "At least one test must be selected",
  "sampleType.existing": "Existing Sample Types",
  "sampleType.existing.inactive": "Inactive Sample Types.  Assign tests to activate.",
  "sampleType.new": "New Sample Type",
  "sampleType.typeName": "Sample Type Name",
  "save.aliquot.changes": "Save Aliquot Changes",
  "save.config.success.msg": "Configuration Updated Successfully",
  "save.order.success.msg": "Sample Order Entry has been saved successfully",
  "save.success": "Successfully saved",
  "saving": "Saving...",
  "search.by.dictionary.entry": "Search By Dictionary Entry",
  "search.label": "Search",
  "search.label.accession": "Enter Accession Number",
  "search.label.analysis": "Select Analysis Status",
  "search.label.collectiondate": "Enter Collection Date",
  "search.label.fromaccession": "From Accession Number",
  "search.label.loadnext": "Load Next 99 Records Starting at Lab Number",
  "search.label.receiveddate": "Enter Received Date",
  "search.label.sample": "Select Sample Status",
  "search.label.test": "Select Test Name",
  "search.label.testdate": "Enter Test Date",
  "search.label.testunit": "Select Test Unit",
  "search.label.toaccession": "To Accession Number",
  "search.patient.label": "Search for Patient",
  "search.placeholder": "Search...",
  "searchTests.label": "Search Available Test",
  "searchTests.legend": "Search through the available tests",
  "searchindexmanagement.description": "The search index updates automatically when data is added or modified. If you need to manually update the search index, click the Start Reindexing button. This may take some time.",
  "searchindexmanagement.label": "Search Index Management",
  "searchindexmanagement.reindex": "Start Reindexing",
  "searchindexmanagement.reindex.error": "Reindexing failed",
  "searchindexmanagement.reindex.success": "Reindexing completed successfully",
  "select.aliquot": "Select Aliquot",
  "select.datarange.label": "Date range is for when the referrals were made",
  "select.dateRange": "Select the Date Range for the Test Report Summary",
  "select.default.option.label": "Choose an option",
  "select.end.date.referredTests": "End Date (dd/mm/yyyy)",
  "select.labUnits": "Select the lab unit(s) you would like to create the test for, you may select as many as you would like",
  "select.label.analyser": "Select Analyzer",
  "select.priority.tests": "Select the priority of the tests you would like to show",
  "select.program": "Program",
  "select.referral.centre": "Referral Center or Laboratory",
  "select.referral.centre.is.required": " Referral center or labratory is required",
  "select.referral.centre.search": "Type to search referral laboratories",
  "select.referral.centre.choose": "Choose the referral center or laboratory to report on.",
  "select.start.date.referredTests": "Start Date (dd/mm/yyyy)",
  "select.timeFrame": "Select time frames you would like to generate the reports for",
  "select.timeFrame.Note": "NOTE: all dates and times are based on reception time. EG: a test received on Jan 31 at 11:59 pm and resulted Feb 1 at 9:30am would show as out of normal hours in January",
  "select.year.report": "Select the year you would like to generate the reports for",
  "selectListRenameEntry.selectList": "Select List Rename Entry",
  "selectListRenameEntry.selectListEdit": "Select List Rename Entry Edit",
  "selectReportValues.title": "Select Report Values",
  "selectResult.title": "Select Result",
  "serial.config.active.label": "Active",
  "serial.config.baudRate.label": "Baud Rate",
  "serial.config.connect.button": "Connect",
  "serial.config.connect.error": "Error connecting serial port",
  "serial.config.connect.success": "Serial port connected successfully",
  "serial.config.create.title": "Create Serial Port Configuration",
  "serial.config.dataBits.label": "Data Bits",
  "serial.config.disconnect.button": "Disconnect",
  "serial.config.disconnect.error": "Error disconnecting serial port",
  "serial.config.disconnect.success": "Serial port disconnected successfully",
  "serial.config.edit.title": "Edit Serial Port Configuration",
  "serial.config.flowControl.label": "Flow Control",
  "serial.config.flowControl.none": "None",
  "serial.config.form.legend": "Serial Port Settings",
  "serial.config.parity.even": "Even",
  "serial.config.parity.label": "Parity",
  "serial.config.parity.mark": "Mark",
  "serial.config.parity.none": "None",
  "serial.config.parity.odd": "Odd",
  "serial.config.parity.space": "Space",
  "serial.config.portName.label": "Port Name",
  "serial.config.save.error": "Error saving serial port configuration",
  "serial.config.save.success": "Serial port configuration saved successfully",
  "serial.config.status.label": "Connection Status",
  "serial.config.stopBits.label": "Stop Bits",
  "serial.config.validation.analyzerId.required": "Analyzer ID is required",
  "serial.config.validation.baudRate.invalid": "Baud rate must be between 9600 and 115200",
  "serial.config.validation.dataBits.invalid": "Data bits must be 7 or 8",
  "serial.config.validation.portName.required": "Port name is required",
  "server.error.msg": "Oops, Server error please contact administrator",
  "common.retry": "Retry",
  "show.aliquoting": "Show Aliquoting",
  "showing": "Showing",
  "breadcrumb.label.addOrder": "Add Order",
  "sidenav.label.admin": "Admin",
  "sidenav.label.admin.backToMainMenu": "Back to main menu",
  "sidenav.label.admin.barcodeconfiguration": "Barcode Configuration",
  "sidenav.label.admin.labelPresets": "Label Presets",
  "sidenav.label.admin.commonproperties": "Application Properties",
  "sidenav.label.admin.eqaProgram": "EQA Program Management",
  "sidenav.label.admin.formEntry.menustatementconfig": "MenuStatement Configuration",
  "sidenav.label.admin.formEntry.nonconformityconfig": "NonConformity Configuration",
  "sidenav.label.admin.formEntry.patientconfig": "Patient Entry Configuration",
  "sidenav.label.admin.formEntry.PrintedReportsconfig": "Printed Report Configuration",
  "sidenav.label.admin.formEntry.resultConfig": "Result Entry Configuration",
  "sidenav.label.admin.formEntry.sampleEntryconfig": "Order Entry Configuration",
  "sidenav.label.admin.formEntry.siteBranding": "Site Branding",
  "sidenav.label.admin.formEntry.siteInfoconfig": "Site Information",
  "sidenav.label.admin.formEntry.validationconfig": "Validation Configuration",
  "sidenav.label.admin.formEntry.Workplanconfig": "WorkPlan Configuration",
  "sidenav.label.admin.labNumber": "Lab Number Management",
  "sidenav.label.admin.localization": "Localization",
  "sidenav.label.admin.menu": "Menu Configuration",
  "sidenav.label.admin.menu.billing": "Billing Menu Configuration",
  "sidenav.label.admin.menu.global": "Global Menu Configuration",
  "sidenav.label.admin.menu.nonconform": "Non-Conform Menu Configuration",
  "sidenav.label.admin.menu.patient": "Patient Menu Configuration",
  "sidenav.label.admin.menu.study": "Study Menu Configuration",
  "sidenav.label.admin.organizationmgt": "Organization Management",
  "sidenav.label.admin.testmgt": "Reflex Tests Configuration",
  "sidenav.label.admin.testmgt.calculated": "Calculated Value Tests Management",
  "sidenav.label.admin.testmgt.testCatalogEditor": "Test Catalogue Editor",
  "sidenav.label.admin.testCatalog": "Test Catalogue Management",
  "sidenav.label.admin.testCatalog.backToList": "← All Tests",
  "sidenav.label.admin.testCatalog.sectionsHelper": "Click a test to edit its sections",
  "sidenav.label.admin.testCatalog.editing": "Editing: {name}",
  "sidenav.label.admin.testCatalog.editingGeneric": "Editing test",
  "label.testCatalog.editor": "Test Catalogue Editor",
  "label.testCatalog.editor.empty": "Click a test to edit its sections",
  "label.testCatalog.editor.empty.helper": "Open a test from the Test Catalogue list to edit it.",
  "label.testCatalog.editor.loadError": "Unable to load this test. Please try again.",
  "label.testCatalog.editor.saveAsNew": "Save as new test…",
  "label.testCatalog.editor.save.pending": "Saving is available once the section editors ship.",
  "label.testCatalog.editor.clone.pending": "Save as new test is available once the editor sections ship.",
  "label.testCatalog.section.pending": "This section's editor ships in a later milestone.",
  "label.testCatalog.section.basic-info": "Basic Info",
  "label.testCatalog.section.sample-results": "Sample & Results",
  "label.testCatalog.section.methods": "Methods",
  "label.testCatalog.section.ranges": "Ranges",
  "label.testCatalog.section.qc-targets": "QC Targets",
  "label.testCatalog.section.storage": "Sample Storage",
  "label.testCatalog.section.panels": "Panels",
  "label.testCatalog.entity.panels": "Panel Editor",
  "note.panel.domainUpgrade": "A panel's domain is set on the panel itself, not worked out from the sample types its tests use.",
  "note.panel.domainLaterPhase": "A panel whose tests reach sample types from another domain is marked Mixed domain.",
  "label.panel.list.description": "Ordered bundles of tests; sample types derive from the member tests",
  "label.panel.list.empty": "No panels match the current filters.",
  "label.panel.search": "Search by name or LOINC",
  "button.panel.add": "Add Panel",
  "label.panel.col.name": "Panel Name",
  "label.panel.col.tests": "Tests",
  "label.panel.col.domain": "Domain",
  "label.panel.list.mixedDomain": "Mixed domain",
  "label.panel.list.mixedDomain.detail": "Sample types outside this panel's domain: {sampleTypes}",
  "label.panel.col.sampleTypes": "Sample Types (derived)",
  "label.panel.col.status": "Status",
  "label.panel.backToList": "Back to list",
  "label.panel.notFound": "This panel does not exist or could not be loaded. Go back to the list to choose another.",
  "title.panel.new": "New panel",
  "label.panel.name": "Panel name",
  "placeholder.panel.name": "e.g. Anemia Workup",
  "label.panel.domain": "Domain",
  "helper.panel.domainGuard": "Only {domain}-domain tests can be added to this panel.",
  "helper.panel.loincIsIdentifier": "The panel's LOINC serves as its identifier.",
  "note.panel.sampleTypesDerived": "Sample types are derived from the tests in this panel.",
  "label.panel.description": "Description",
  "label.panel.active": "Active",
  "helper.panel.needsTest": "Add at least one test before this panel can be activated.",
  "error.panel.save": "The panel could not be saved. Check the fields and try again.",
  "error.panel.nameRequired": "A panel name is required.",
  "error.panel.nameTooLong": "A panel name has at most 20 characters.",
  "error.panel.descriptionTooLong": "A description has at most 60 characters.",
  "error.panel.nameDuplicate": "Another panel already uses this name. Enter a different name.",
  "error.panel.domainConflict": "This panel cannot be filed under {domain}: {count, plural, one {# of its tests belongs} other {# of its tests belong}} to another domain ({tests}).",
  "helper.panel.domainConflict.remedy": "Change the domain of those tests in the Test Catalog, or remove them from this panel, then save again.",
  "error.panel.tests.domainConflict": "Not saved: {tests} {count, plural, one {is} other {are}} not in this panel's domain ({domain}). Only {domain}-domain tests can be added.",
  "error.panel.tests.activeNeedsTest": "Not saved: an active panel needs at least one test. Keep a test, or deactivate the panel in Basic Info first.",
  "error.panel.tests.inactive": "Not saved: {tests} {count, plural, one {is} other {are}} inactive. Only active tests can be added to a panel.",
  "error.panel.tests.loadFailed": "The panel's tests could not be loaded, so nothing can be saved yet. Retry to load them again.",
  "error.testCatalog.panels.domainConflict": "This test cannot join {panelName}: the panel is filed under {panelDomain} and the test under {testDomain}.",
  "error.testCatalog.panels.activateFailed": "Panel \"{name}\" was created and this test added, but it could not be switched on. Activate it in the Panel Editor.",
  "error.testCatalog.panels.activeNeedsTest": "Not saved: {panels} would be left with no tests while active. Deactivate {count, plural, one {that panel} other {those panels}} first, or keep this test in {count, plural, one {it} other {them}}.",
  "success.panel.created": "Panel created. It stays inactive until at least one test is assigned to it.",
  "error.panel.create.invalid": "The panel could not be created. Fill in every required field, including a LOINC code.",
  "label.panel.section.basic-info": "Basic Info",
  "label.panel.section.tests": "Tests",
  "label.panel.section.terminology": "Terminology",
  "label.panel.section.localization": "Localization",
  "label.panel.localization.intro": "Edit per-language translations for this panel's name. Untranslated fields fall back to English. Manage all translations from the Translation Management admin page.",
  "label.panel.localization.empty": "This panel has no localizable name fields.",
  "label.panel.localization.loadError": "Unable to load translations for this panel.",
  "label.panel.localization.field.name": "Panel Name",
  "sidenav.label.admin.panel.editing": "Editing panel: {name}",
  "sidenav.label.admin.panel.sectionsHelper": "Click a panel to edit its sections",
  "sidenav.label.admin.panel.addingNew": "Adding a new panel",
  "label.panel.testsCount": "tests",
  "label.panel.addTest": "Add a test",
  "label.panel.tests.filterBySampleType": "Filter by sample type",
  "label.panel.tests.filterBySampleType.all": "All sample types",
  "placeholder.panel.addTest": "Search by name or code…",
  "helper.panel.membershipSync": "Membership writes keep order entry's panel list in sync.",
  "label.panel.col.order": "Order",
  "label.panel.col.testName": "Test Name",
  "label.panel.col.code": "Code",
  "label.panel.moveUp": "Move up",
  "label.panel.moveDown": "Move down",
  "empty.panel.tests": "No tests yet — search above to add the first one.",
  "helper.panel.loincRouting": "It is also a live routing key — FHIR e-orders match panels by this code at intake. The primary LOINC stays on the panel for list display and order entry.",
  "label.panel.terminology.primary": "Primary",
  "label.panel.terminology.empty": "No terminology mappings yet. The LOINC mapping is the panel's identifier.",
  "label.panel.terminology.saved": "Terminology mappings saved.",
  "label.panel.terminology.saveInvalid": "Some mappings are invalid. Check source, code, and duplicates.",
  "label.panel.terminology.codeTooLong": "Not saved: the code {code} is longer than {max} characters.",
  "label.panel.terminology.loincTooLong": "Not saved: {code} is not a LOINC code. A LOINC code has at most 10 characters.",
  "label.panel.terminology.saveError": "Could not save terminology mappings.",
  "note.panel.positionShared": "Position writes panel_item.sort_order — the same field the test-side Panels section edits.",
  "label.testCatalog.section.labels": "Labels",
  "label.testCatalog.section.terminology": "Terminology",
  "label.testCatalog.labels.col.preset": "Preset",
  "label.testCatalog.labels.col.defaultQty": "Default Qty",
  "label.testCatalog.labels.col.maxQty": "Max Qty",
  "label.testCatalog.labels.col.allowOverride": "Allow Override",
  "label.testCatalog.labels.col.actions": "Actions",
  "label.testCatalog.labels.addLabelType": "Add Label Type",
  "label.testCatalog.labels.addLabelType.placeholder": "Select a label preset…",
  "label.testCatalog.labels.empty": "No label types configured. Add label presets to automatically suggest labels when this test is ordered.",
  "label.testCatalog.labels.loadError": "Unable to load label configuration for this test.",
  "label.testCatalog.labels.saved": "Label configuration saved",
  "label.testCatalog.labels.saveError": "Could not save label configuration.",
  "label.testCatalog.labels.unsaved": "You have unsaved label changes. Click Save to apply them.",
  "label.testCatalog.labels.maxLtDefault": "Max Qty must be greater than or equal to Default Qty.",
  "label.testCatalog.labels.allowOverride.label": "Allow override at order entry",
  "label.testCatalog.labels.generationSettings": "Label Generation Settings",
  "label.testCatalog.labels.remove.action": "Remove",
  "label.testCatalog.labels.remove.title": "Remove Label Type",
  "label.testCatalog.labels.remove.confirm": "Remove",
  "label.testCatalog.labels.remove.body": "Remove {name} from this test's label configuration?",
  "label.testCatalog.section.reagents": "Reagents",
  "label.testCatalog.section.analyzers": "Analyzers",
  "label.testCatalog.section.alerts": "Alerts",
  "label.testCatalog.section.accreditation": "Accreditation",
  "label.testCatalog.accreditation.add": "Add accreditation",
  "label.testCatalog.accreditation.added": "Accreditation added",
  "label.testCatalog.accreditation.removed": "Accreditation removed",
  "label.testCatalog.accreditation.empty": "This test is not accredited by any body.",
  "label.testCatalog.accreditation.selectBody": "Choose an accrediting body",
  "label.testCatalog.accreditation.remove": "Remove accreditation",
  "label.testCatalog.accreditation.remove.body": "Remove this test from {body}? Its logo will stop appearing on reports that contain only this test.",
  "label.testCatalog.accreditation.manageLink": "Manage accrediting bodies and expiry dates",
  "label.testCatalog.accreditation.loadError": "Accreditation could not be loaded.",
  "label.testCatalog.accreditation.saveError": "The accreditation could not be added.",
  "label.testCatalog.accreditation.deleteError": "The accreditation could not be removed.",
  "label.testCatalog.section.reflex-calc": "Reflex & Calc",
  "label.testCatalog.section.localization": "Localization",
  "label.testCatalog.section.display-order": "Display Order",
  "label.sampleType.section.basic-info": "Basic Info",
  "label.sampleType.section.associated-tests": "Associated Tests",
  "label.sampleType.section.terminology": "Terminology",
  "label.sampleType.section.localization": "Localization",
  "label.sampleType.localization.intro": "Edit per-language translations for this sample type's name. Untranslated fields fall back to English. Manage all translations from the Translation Management admin page.",
  "label.sampleType.localization.empty": "This sample type has no localizable name fields.",
  "label.sampleType.localization.loadError": "Unable to load translations for this sample type.",
  "label.sampleType.localization.field.name": "Sample Type Name",
  "label.sampleType.terminology.intro": "Map this sample type to standard terminology codes for interoperability.",
  "label.sampleType.terminology.empty": "No terminology mappings yet.",
  "label.sampleType.terminology.saved": "Terminology mappings saved.",
  "label.sampleType.terminology.saveError": "Could not save terminology mappings.",
  "label.sampleType.terminology.saveInvalid": "Some mappings are invalid. Check source, code, and duplicates.",
  "label.sampleType.terminology.addHint": "Save this sample type first, then add terminology mappings.",
  "label.sampleType.localization.addHint": "Save this sample type first, then edit its translations.",
  "label.sampleType.name": "Name",
  "label.sampleType.section.display-order": "Display Order",
  "label.sampleType.section.disposal": "Disposal",
  "label.sampleType.displayOrder": "Position in the Sample Type menu",
  "label.sampleType.displayOrder.intro": "Positions this sample type in the order-entry Sample Type menu. Type a position or use the arrows, then save — every sample type is renumbered.",
  "label.sampleType.displayOrder.current": "This sample type",
  "label.sampleType.displayOrder.loading": "Loading sample types...",
  "label.sampleType.displayOrder.saved": "Display order updated.",
  "label.sampleType.displayOrder.saveError": "Could not update display order.",
  "label.sampleType.displayOrder.addHint": "Save this sample type first, then set its menu position.",
  "label.sampleType.disposalInstructions": "Disposal instructions",
  "label.sampleType.disposal.intro": "Free-text reference guidance for disposing of this specimen type. The authoritative, structured handling stays on each test's Storage section and the specimen disposal workflow.",
  "label.sampleType.disposal.placeholder": "e.g. Autoclave before disposal via biohazard waste",
  "label.sampleType.disposal.loading": "Loading disposal instructions...",
  "label.sampleType.disposal.saved": "Disposal instructions saved.",
  "label.sampleType.disposal.saveError": "Could not save disposal instructions.",
  "label.sampleType.disposal.addHint": "Save this sample type first, then add disposal instructions.",
  "label.sampleType.tests.manageIntro": "Tests linked to this sample type. Search the catalog to add more, or remove existing links. The same link can also be managed from a test's Basic Info in the Test Catalog.",
  "label.sampleType.tests.search": "Search tests",
  "label.sampleType.tests.searchPlaceholder": "Search by test name...",
  "label.sampleType.tests.filterBySampleType": "Filter by sample type",
  "label.sampleType.tests.filterBySampleType.all": "Any sample type",
  "label.sampleType.tests.pick": "Test to add",
  "label.sampleType.tests.pickPlaceholder": "Select a test...",
  "label.sampleType.tests.add": "Add test",
  "label.sampleType.tests.addError": "Could not link the test to this sample type.",
  "label.sampleType.tests.domainMismatch": "This test belongs to another domain than this sample type, so it cannot use it.",
  "label.sampleType.tests.remove": "Remove test",
  "helper.sampleType.name": "Enter a unique name for this sample type (e.g., \"Serum\", \"Whole Blood\")",
  "helper.sampleType.description": "Provide a description of this sample type for lab staff reference",
  "label.sampleType.active": "Active",
  "label.sampleType.description": "Description",
  "label.sampleType.tests.removeError": "Could not unlink the test.",
  "label.sampleType.tests.removeLastOfActive": "Not unlinked: this is the only sample type of an active test, which could then not be ordered. Give the test another sample type or deactivate it first.",
  "label.sampleType.tests.loading": "Loading associated tests...",
  "label.sampleType.tests.none": "No tests are associated with this sample type.",
  "message.sampleType.add.success": "Sample type saved successfully.",
  "message.sampleType.edit.success": "Sample type updated successfully.",
  "heading.sampleType.add": "Add New Sample Type",
  "button.sampleType.create": "Create Sample Type",
  "button.sampleType.creating": "Creating...",
  "heading.sampleType.filtered": "Showing {filtered} of {total} sample types",
  "heading.sampleType.total": "Total: {total} sample types",
  "label.sampleType.tests.addHint": "Save this sample type first, then associate tests from the test configuration.",
  "message.sampleType.noResults": "No sample types found matching your criteria",
  "error.sampleType.create.invalidName": "This name contains characters that are not allowed, such as HTML tags. Remove them and try again.",
  "error.sampleType.create.invalid": "The sample type was not created. Check the fields and try again.",
  "error.sampleType.create.duplicateName": "A sample type with this name already exists.",
  "error.sampleType.create.duplicateDescription": "Another sample type in this domain already has this description.",
  "error.sampleType.update.description.409": "Another sample type in this domain already has this description.",
  "error.sampleType.update.abbreviation.409": "Another sample type in this domain already uses this abbreviation.",
  "error.sampleType.update.abbreviation.400": "The abbreviation has at most 10 characters.",
  "error.sampleType.update.whonetCode.400": "The WHONET code has at most 5 characters.",
  "error.sampleType.update.description.400": "The description has at most 40 characters.",
  "error.sampleType.nameTooLong": "A new sample type name has at most 40 characters.",
  "label.sampleType.loading": "Loading sample type...",
  "label.sampleType.notFound": "This sample type does not exist. Go back to the list to choose another.",
  "label.sampleType.editorLoadError": "The sample types could not be loaded. Refresh the page to try again.",
  "stock.status.pendingQc": "Pending QC",
  "stock.status.qcFailed": "Failed QC",
  "stock.status.quarantined": "Quarantined",
  "label.sampleType.whonetCode": "WHONET specimen code",
  "helper.sampleType.whonetCode": "Code written to the WHONET SPECIMEN_TYPE field (maximum 5 characters).",
  "label.sampleType.whonetReturn": "Return to WHONET preview",
  "warning.sampleType.deactivateInUse": "{count} active tests use this type; they won't be orderable while it's inactive.",
  "note.sampleType.associatedTests.viewOnly": "View only — a test's specimen is part of its identity. To run a test on this sample type, create a specimen variant in the Test Catalog.",
  "sidenav.label.admin.sampleType.backToList": "← All Sample Types",
  "sidenav.label.admin.sampleType.editing": "Editing: {name}",
  "sidenav.label.admin.sampleType.editingGeneric": "Editing sample type",
  "sidenav.label.admin.sampleType.sectionsHelper": "Click a sample type to edit its sections",
  "sidenav.label.admin.sampleType.addingNew": "Adding new sample type",
  "label.testCatalog.localization.locale": "Locale",
  "label.testCatalog.localization.intro": "Edit per-language translations for this test's name and reporting name. Untranslated fields fall back to English. Manage all translations from the Translation Management admin page.",
  "label.testCatalog.localization.unsaved": "You have unsaved translation changes. Click Save to apply them.",
  "label.testCatalog.localization.loadError": "Unable to load translations for this test.",
  "label.testCatalog.localization.empty": "This test has no localizable name fields.",
  "label.testCatalog.localization.saved": "Translation saved",
  "label.testCatalog.localization.saveError": "Could not save the translation.",
  "label.testCatalog.localization.fallbackRequired": "The English value is what every screen shows when no translation exists, so it cannot be blank.",
  "label.testCatalog.localization.field.name": "Test Name",
  "label.testCatalog.localization.field.reportingName": "Reporting Name",
  "label.testCatalog.localization.fallback.en": "Fallback (en)",
  "label.testCatalog.localization.fallback.tooltip": "Showing the English value because no translation is configured for {locale}.",
  "label.testCatalog.reflexCalc.loadError": "Unable to load reflex and calculation cross-links for this test.",
  "label.testCatalog.reflexCalc.reflex.heading": "Reflex Tests",
  "label.testCatalog.reflexCalc.reflex.helper": "Rules that automatically order additional tests based on this test's results. Manage in Master Lists → Reflex Rules.",
  "label.testCatalog.reflexCalc.reflex.col.rule": "Rule Name",
  "label.testCatalog.reflexCalc.reflex.col.trigger": "Trigger Condition",
  "label.testCatalog.reflexCalc.reflex.col.reflexTests": "Reflex Test(s) Ordered",
  "label.testCatalog.reflexCalc.reflex.empty": "No reflex rules configured. Reflex rules are managed in Master Lists → Reflex Rules.",
  "label.testCatalog.reflexCalc.reflex.manage": "Manage Reflex Rules",
  "label.testCatalog.reflexCalc.calc.heading": "Calculated Results",
  "label.testCatalog.reflexCalc.calc.helper": "Formulas that use this test's results or that produce this test as output. Manage in Master Lists → Calculated Results.",
  "label.testCatalog.reflexCalc.calc.feedsInto": "This test feeds into",
  "label.testCatalog.reflexCalc.calc.calculatedBy": "This test is calculated by",
  "label.testCatalog.reflexCalc.calc.col.name": "Formula Name",
  "label.testCatalog.reflexCalc.calc.col.formula": "Formula",
  "label.testCatalog.reflexCalc.calc.col.output": "Output Test",
  "label.testCatalog.reflexCalc.calc.empty": "None",
  "label.testCatalog.reflexCalc.calc.feedsInto.empty": "This test does not feed into any calculated result. Calculations are managed in Master Lists → Calculated Values.",
  "label.testCatalog.reflexCalc.calc.calculatedBy.empty": "This test is not calculated from other tests. Calculations are managed in Master Lists → Calculated Values.",
  "label.testCatalog.reflexCalc.calc.manage": "Manage Calculated Results",
  "label.testCatalog.alerts.addRule": "Add Rule",
  "label.testCatalog.alerts.empty": "No alert rules configured. Add a rule to notify recipients when results match a condition.",
  "label.testCatalog.alerts.loadError": "Unable to load alert rules for this test.",
  "label.testCatalog.alerts.saved": "Alert rule saved",
  "label.testCatalog.alerts.saveError": "Could not save the alert rule.",
  "label.testCatalog.alerts.saveRefused": "The alert rule was refused. The name, value and custom email hold at most 100 characters, the custom phone 20, and the role must be one that can be notified.",
  "label.testCatalog.alerts.deleted": "Alert rule deleted",
  "label.testCatalog.alerts.deleteError": "Could not delete the alert rule.",
  "label.testCatalog.alerts.nameRequired": "Rule name is required.",
  "label.testCatalog.alerts.valueRequired": "A specific value is required for the Specific Value trigger.",
  "label.testCatalog.alerts.col.name": "Name",
  "label.testCatalog.alerts.col.trigger": "Trigger",
  "label.testCatalog.alerts.col.channels": "Channels",
  "label.testCatalog.alerts.col.ack": "Ack Required",
  "label.testCatalog.alerts.col.enabled": "Enabled",
  "label.testCatalog.alerts.col.actions": "Actions",
  "label.testCatalog.alerts.trigger.ALL": "All Results",
  "label.testCatalog.alerts.trigger.ABNORMAL": "Abnormal",
  "label.testCatalog.alerts.trigger.CRITICAL": "Critical",
  "label.testCatalog.alerts.trigger.SPECIFIC_VALUE": "Specific Value",
  "label.testCatalog.alerts.trigger.COMPLIANCE_BREACH": "Compliance Breach",
  "label.testCatalog.alerts.edit.action": "Edit",
  "label.testCatalog.alerts.delete.action": "Delete",
  "label.testCatalog.alerts.delete.title": "Delete Alert Rule",
  "label.testCatalog.alerts.delete.confirm": "Delete",
  "label.testCatalog.alerts.delete.body": "Delete alert rule {name}?",
  "label.testCatalog.alerts.modal.addTitle": "Add Alert Rule",
  "label.testCatalog.alerts.modal.editTitle": "Edit Alert Rule",
  "label.testCatalog.alerts.field.name": "Rule Name",
  "label.testCatalog.alerts.field.trigger": "Alert when result is:",
  "label.testCatalog.alerts.field.specificValue": "Specific value",
  "label.testCatalog.alerts.field.channels": "Notification channels",
  "label.testCatalog.alerts.field.recipients": "Recipients",
  "label.testCatalog.alerts.field.ackRequired": "Require acknowledgment",
  "label.testCatalog.alerts.channel.sms": "SMS",
  "label.testCatalog.alerts.channel.email": "Email",
  "label.testCatalog.alerts.recipient.physician": "Ordering Physician",
  "label.testCatalog.alerts.recipient.patient": "Patient",
  "label.testCatalog.alerts.recipient.facility": "Referring Facility",
  "label.testCatalog.alerts.recipient.customPhone": "Custom phone",
  "label.testCatalog.alerts.recipient.customEmail": "Custom email",
  "label.testCatalog.alerts.recipient.roleId": "Notify users with role",
  "label.testCatalog.alerts.recipient.rolePlaceholder": "Select a role",
  "label.testCatalog.reagents.col.name": "Reagent Name",
  "label.testCatalog.reagents.col.usage": "Usage Type",
  "label.testCatalog.reagents.col.qty": "Quantity per Test",
  "label.testCatalog.reagents.col.stock": "Stock Level",
  "label.testCatalog.reagents.col.actions": "Actions",
  "label.testCatalog.reagents.empty": "No reagents linked. Link reagents from inventory to track consumption per test.",
  "label.testCatalog.reagents.loadError": "Unable to load reagents for this test.",
  "label.testCatalog.reagents.linkButton": "Link Reagent",
  "label.testCatalog.reagents.linkError": "Unable to link one or more reagents. Please try again.",
  "label.testCatalog.reagents.modal.title": "Link Reagents",
  "label.testCatalog.reagents.modal.linkSelected": "Link Selected",
  "label.testCatalog.reagents.modal.select.label": "Reagents",
  "label.testCatalog.reagents.modal.select.placeholder": "Select reagents to link",
  "label.testCatalog.reagents.modal.allLinked": "All available reagents are already linked to this test.",
  "label.testCatalog.reagents.unitPlaceholder": "Unit",
  "label.testCatalog.reagents.updated": "Reagent updated",
  "label.testCatalog.reagents.saveError": "Could not save changes.",
  "label.testCatalog.reagents.unitTooLong": "A unit can have at most 50 characters.",
  "label.testCatalog.reagents.unsaved": "You have unsaved reagent changes. Click Save to apply them.",
  "label.testCatalog.reagents.retry": "Retry",
  "label.testCatalog.reagents.unlink.action": "Unlink",
  "label.testCatalog.reagents.unlink.title": "Unlink Reagent",
  "label.testCatalog.reagents.unlink.confirm": "Unlink",
  "label.testCatalog.reagents.unlink.body": "Unlink {name} from this test? Existing results linked to this reagent are unaffected.",
  "label.testCatalog.reagents.unlinked": "Reagent unlinked",
  "label.testCatalog.reagents.unlinkError": "Could not unlink the reagent. Please try again.",
  "label.testCatalog.basicInfo.name": "Name",
  "label.testCatalog.basicInfo.name.helper": "The display name is translated — edit it in the Localization section.",
  "label.testCatalog.basicInfo.reportingName": "Reporting name",
  "label.testCatalog.basicInfo.labUnit": "Lab Unit",
  "label.testCatalog.basicInfo.labUnit.inactive": "{name} (inactive)",
  "label.testCatalog.basicInfo.labUnit.inactiveHelp": "This lab unit is inactive, so the test cannot be ordered. Saving keeps it inactive; reactivate it in Lab Unit Management.",
  "label.testCatalog.basicInfo.createInactiveHint": "The test is created Inactive. Configure its sections, then activate it to make it orderable.",
  "sidenav.label.environmental.compliance.tooltip": "Environmental Compliance Dashboard",
  "site.search.helper": "Type at least 2 characters to auto-search. Required for routing results back to the requesting site.",
  "storage.skipped.title": "Storage skipped for {count} sample(s)",
  "test.qc.blankThreshold": "Blank Threshold",
  "test.qc.recoveryWindowPct": "Recovery Window (%)",
  "test.qc.rpdThreshold": "RPD Threshold (%)",
  "test.qc.thresholds.description": "Optional thresholds for environmental/vector QC evaluation. Leave blank if not applicable.",
  "test.qc.thresholds.heading": "QC Acceptance Thresholds",
  "title.testCatalog.createTest": "Create new test",
  "label.testCatalog.testName": "Test name",
  "label.testCatalog.testCode": "Test code",
  "label.testCatalog.domain": "Domain",
  "label.testCatalog.specimenType": "Sample type",
  "label.testCatalog.basicInfo.sampleTypes": "Sample types",
  "helper.testCatalog.basicInfo.sampleTypesMulti": "Select every specimen this test runs on. Configuration is shared across them.",
  "error.testCatalog.basicInfo.sampleTypeRequired": "Select at least one sample type.",
  "error.testCatalog.basicInfo.sampleTypeDomain": "This sample type's domain doesn't match the test's domain.",
  "label.testCatalog.list.sampleTypesSummary": "{first} +{n}",
  "label.testCatalog.override.col.sampleType": "Specimen",
  "label.testCatalog.override.shared": "All specimens (shared)",
  "notice.testCatalog.intake.awaitingSpecimen": "Awaiting specimen — this test runs on several specimens; resolve at collection.",
  "tag.testCatalog.finding.noSampleTypeLink": "No sample-type link",
  "error.testCatalog.codeExists": "A test with this code already exists.",
  "error.testCatalog.description.inUse": "Another test already uses this description. Descriptions must be unique — change it and save again.",
  "notification.testCatalog.testCreated": "Test {name} created. Complete its configuration in the sections at left.",
  "label.testCatalog.basicInfo.code": "Code",
  "label.testCatalog.basicInfo.description": "Description",
  "label.testCatalog.basicInfo.domain": "Domain",
  "label.testCatalog.basicInfo.domain.CLINICAL": "Clinical",
  "label.testCatalog.basicInfo.domain.ENVIRONMENTAL": "Environmental",
  "label.testCatalog.basicInfo.domain.VECTOR": "Vector",
  "label.testCatalog.basicInfo.domainModal.title": "Change test domain?",
  "label.testCatalog.basicInfo.domainModal.body": "Change this test's domain to {domain}? This affects how the test is categorized in the catalog.",
  "label.testCatalog.basicInfo.amr": "AMR surveillance test",
  "label.testCatalog.basicInfo.active": "Active",
  "label.testCatalog.basicInfo.status": "Status",
  "label.testCatalog.basicInfo.orderable": "Orderable",
  "label.testCatalog.basicInfo.saved": "Basic info saved.",
  "error.testCatalog.basicInfo.labUnitInactive": "That lab unit is inactive. Choose an active unit, or reactivate it in Lab Unit Management first.",
  "error.testCatalog.create.refused": "The test was not created: a sample type or the lab unit cannot be used. Check them and try again.",
  "error.testCatalog.basicInfo.invalidValue": "Basic info was not saved: one of the values cannot be stored. Correct the highlighted field.",
  "error.testCatalog.basicInfo.timeHolding": "Enter a whole number of minutes, or leave blank.",
  "error.testCatalog.basicInfo.qcThreshold": "Enter a number of 0 or more (up to 5 decimal places), or leave blank.",
  "label.testCatalog.sampleResults.saved": "Sample & results saved.",
  "label.testCatalog.sampleResults.empty": "No result components yet. Add one to define how this test's results are captured.",
  "label.testCatalog.sampleResults.newComponent": "(new component)",
  "label.testCatalog.sampleResults.code": "Component code",
  "label.testCatalog.sampleResults.isPrimary": "Primary component",
  "label.testCatalog.sampleResults.showOnReport": "Show on patient report",
  "label.testCatalog.sampleResults.label": "Component label",
  "label.testCatalog.sampleResults.resultType": "Result type",
  "label.testCatalog.sampleResults.resultType.N": "Numeric",
  "label.testCatalog.sampleResults.resultType.none": "No result type selected",
  "label.testCatalog.sampleResults.preview.noType": "Select a result type above to see how technicians will enter this result.",
  "label.testCatalog.sampleResults.resultType.D": "Single-select list (dictionary)",
  "label.testCatalog.sampleResults.resultType.R": "Free text",
  "label.testCatalog.sampleResults.resultType.M": "Multi-select list",
  "label.testCatalog.sampleResults.resultType.C": "Cascading multi-select",
  "label.testCatalog.sampleResults.resultType.T": "Titer",
  "label.testCatalog.sampleResults.resultType.A": "Alpha (validated text)",
  "label.testCatalog.sampleResults.resultType.group.primary": "Common",
  "label.testCatalog.sampleResults.resultType.group.advanced": "Advanced / legacy types",
  "label.testCatalog.sampleResults.resultType.showAdvanced": "Advanced / legacy types",
  "label.testCatalog.sampleResults.resultType.hideAdvanced": "Hide advanced / legacy types",
  "label.testCatalog.sampleResults.resultTypeDesc.N": "A measured number with a unit (e.g. 12.3 g/dL).",
  "label.testCatalog.sampleResults.resultTypeDesc.D": "One value chosen from a fixed set (e.g. Detected / Not detected).",
  "label.testCatalog.sampleResults.resultTypeDesc.R": "A typed comment or description.",
  "label.testCatalog.sampleResults.resultTypeDesc.M": "One or more values from a list; no single reference value.",
  "label.testCatalog.sampleResults.resultTypeDesc.C": "Grouped options; select multiple groups.",
  "label.testCatalog.sampleResults.resultTypeDesc.T": "A dilution ratio such as 1:10 or 1:20 (common in serology).",
  "label.testCatalog.sampleResults.resultTypeDesc.A": "Validated alphanumeric text (a code or short coded value).",
  "label.testCatalog.sampleResults.preview": "Result entry preview",
  "label.testCatalog.sampleResults.previewHelper": "This is what a technician will see when entering this result.",
  "label.testCatalog.sampleResults.purpose": "Define what a technician records for this test and how results are interpreted.",
  "label.testCatalog.sampleResults.labelRequired": "Each result component needs a label before it can be saved.",
  "label.testCatalog.sampleResults.resultTypeRequired": "Select a result type for \"{component}\" before saving.",
  "label.testCatalog.sampleResults.mostTestsOneResult": "Most tests record one result. Add a component only if this test produces several values (e.g. a differential).",
  "label.testCatalog.sampleResults.displayOrder": "Display order",
  "label.testCatalog.sampleResults.uom": "Unit of measure",
  "label.testCatalog.sampleResults.uom.none": "(none)",
  "label.testCatalog.sampleResults.uom.addNew": "＋ Add new unit…",
  "label.testCatalog.sampleResults.uom.newName": "Display name",
  "label.testCatalog.sampleResults.uom.newCode": "Code",
  "label.testCatalog.sampleResults.uom.newUcum": "UCUM code",
  "label.testCatalog.sampleResults.uom.newDescription": "Description",
  "label.testCatalog.sampleResults.uom.saveNew": "Create unit",
  "label.testCatalog.sampleResults.significantDigits": "Significant digits",
  "label.testCatalog.sampleResults.significantDigits.helper": "Number of digits to keep after the decimal point when a numeric result is entered. Leave blank for no rounding.",
  "admin.testCatalog.sampleResults.lod.label": "LOD",
  "admin.testCatalog.sampleResults.loq.label": "LOQ",
  "admin.testCatalog.sampleResults.lod.helper": "Limit of detection (optional)",
  "admin.testCatalog.sampleResults.loq.helper": "Limit of quantification (optional)",
  "error.testCatalog.sampleResults.valueTooLong": "{component}: a value is longer than its field allows (label 255, code 50, default result and option value 80; interpretation text 255, match 80, severity and color 20 characters).",
  "error.testCatalog.sampleResults.unitUnknown": "{component}: that unit of measure does not exist.",
  "error.testCatalog.sampleResults.activeNeedsComponent": "Not saved: an active test needs at least one result component. Keep a component, or deactivate the test in Basic Info first.",
  "error.testCatalog.sampleResults.lodGtLoq": "LOD cannot be greater than LOQ.",
  "error.testCatalog.sampleResults.detectionLimitNegative": "Detection limits must be zero or more.",
  "admin.testCatalog.qcTargets.section.label": "QC Targets",
  "admin.testCatalog.qcTargets.intro": "The control targets Results Entry judges each QC run against. Enter them once here so technicians only enter the measured value.",
  "admin.testCatalog.qcTargets.column.level": "Control level",
  "admin.testCatalog.qcTargets.column.expected": "Expected value",
  "admin.testCatalog.qcTargets.column.uncertainty": "Uncertainty (±)",
  "admin.testCatalog.qcTargets.column.unit": "Unit",
  "admin.testCatalog.qcTargets.column.overrides": "Lot overrides",
  "admin.testCatalog.qcTargets.column.status": "Status",
  "admin.testCatalog.qcTargets.column.actions": "Actions",
  "admin.testCatalog.qcTargets.level.low": "Low",
  "admin.testCatalog.qcTargets.level.normal": "Normal",
  "admin.testCatalog.qcTargets.level.high": "High",
  "admin.testCatalog.qcTargets.expectedOutcome.label": "Expected outcome",
  "admin.testCatalog.qcTargets.expectedOutcome.placeholder": "Choose the expected outcome",
  "admin.testCatalog.qcTargets.addTarget": "Add target",
  "admin.testCatalog.qcTargets.addOverride": "Add lot override",
  "admin.testCatalog.qcTargets.lot.label": "Control lot",
  "admin.testCatalog.qcTargets.lot.placeholder": "Search control lots…",
  "admin.testCatalog.qcTargets.lot.emptyLink": "No lots found — manage lots in QC Lot Management",
  "admin.testCatalog.qcTargets.overrides.none": "No lot overrides",
  "admin.testCatalog.qcTargets.overrides.count": "{count, plural, one {# lot override} other {# lot overrides}}",
  "admin.testCatalog.qcTargets.empty.level": "No target configured — techs enter values at capture",
  "admin.testCatalog.qcTargets.helper.precedence": "At results entry, the control form prefills from the lot override if one exists, otherwise the level default.",
  "admin.testCatalog.qcTargets.showDeactivated": "Show deactivated",
  "admin.testCatalog.qcTargets.deactivate": "Deactivate",
  "admin.testCatalog.qcTargets.reactivate": "Reactivate",
  "admin.testCatalog.qcTargets.edit": "Edit target",
  "admin.testCatalog.qcTargets.done": "Done",
  "admin.testCatalog.qcTargets.saved": "QC targets saved.",
  "admin.testCatalog.qcTargets.loadError": "The QC targets could not be loaded.",
  "error.testCatalog.qcTargets.uncertaintyNegative": "Uncertainty must be a non-negative number.",
  "error.testCatalog.qcTargets.required": "Every active target needs an expected value and an uncertainty, or an expected outcome.",
  "label.testCatalog.sampleResults.defaultResult": "Default result",
  "label.testCatalog.sampleResults.defaultResult.none": "No default",
  "label.testCatalog.sampleResults.allowMultiple": "Allow multiple readings",
  "label.testCatalog.sampleResults.options": "Select-list options",
  "label.testCatalog.sampleResults.options.empty": "No options defined yet. Add at least one option so this result can be entered.",
  "label.testCatalog.sampleResults.option.value": "Value",
  "label.testCatalog.sampleResults.option.sortOrder": "Sort order",
  "label.testCatalog.sampleResults.option.sortOrder.helper": "Options are shown to technicians in ascending sort order — lower numbers appear first.",
  "label.testCatalog.sampleResults.option.normal": "Normal",
  "label.testCatalog.sampleResults.option.qualifiable": "Qualifiable",
  "error.testCatalog.sampleResults.duplicateOption": "{component} lists {options} more than once. Remove the extra row so result entry offers each option once.",
  "label.testCatalog.sampleResults.addOption": "Add option",
  "label.testCatalog.sampleResults.addCustomOption": "Add custom option",
  "label.testCatalog.sampleResults.searchDictionary": "Search dictionary values…",
  "label.testCatalog.sampleResults.removeOption": "Remove option",
  "label.testCatalog.sampleResults.interpretations": "Interpretations",
  "label.testCatalog.sampleResults.interpretations.empty": "No interpretations defined. Add one to attach guidance or a severity flag to a result.",
  "label.testCatalog.sampleResults.interp.valueMatch": "Value match",
  "label.testCatalog.sampleResults.interp.selectValue": "Choose a value…",
  "label.testCatalog.sampleResults.interp.numericHint": "e.g. >140, 90-140, =0",
  "label.testCatalog.sampleResults.interp.text": "Interpretation",
  "label.testCatalog.sampleResults.interp.severity": "Severity",
  "label.testCatalog.sampleResults.addInterpretation": "Add interpretation",
  "label.testCatalog.sampleResults.removeInterpretation": "Remove interpretation",
  "label.testCatalog.sampleResults.severity.NORMAL": "Normal",
  "label.testCatalog.sampleResults.severity.ABNORMAL": "Abnormal",
  "label.testCatalog.sampleResults.severity.CRITICAL": "Critical",
  "label.testCatalog.sampleResults.actions": "Actions",
  "label.testCatalog.sampleResults.addComponent": "Add component",
  "label.testCatalog.sampleResults.removeComponent": "Remove component",
  "label.testCatalog.sampleResults.moveUp": "Move component up",
  "label.testCatalog.sampleResults.moveDown": "Move component down",
  "label.testCatalog.sampleResults.copyFrom": "Copy configuration from test",
  "label.testCatalog.sampleResults.copyFrom.placeholder": "Select a test…",
  "label.testCatalog.sampleResults.copyFromButton": "Copy from test",
  "label.testCatalog.sampleResults.copyConfirm.title": "Replace this test's result configuration?",
  "label.testCatalog.sampleResults.copyConfirm.body": "Every result component, select-list option and interpretation of this test will be replaced with those of {source}. Nothing changes until you click Save. Once saved, the replacement cannot be undone.",
  "label.testCatalog.sampleResults.copyConfirm.confirm": "Replace configuration",
  "label.testCatalog.sampleResults.copyStaged": "Configuration copied from {source}, not saved yet",
  "label.testCatalog.sampleResults.copyStaged.helper": "Click Save to replace this test's configuration with it, or discard it to keep the current one.",
  "label.testCatalog.sampleResults.copyDiscard": "Discard copied configuration",
  "label.testCatalog.sampleResults.copyEmpty": "{source} has no result configuration to copy.",
  "label.testCatalog.sampleResults.copyLoadError": "The configuration of {source} could not be loaded.",
  "label.testCatalog.sampleResults.copied": "Configuration copied.",
  "label.testCatalog.ranges.activated": "Test activated.",
  "label.testCatalog.ranges.ackModal.title": "Activate with coverage gaps?",
  "label.testCatalog.ranges.ackModal.confirm": "Acknowledge and activate",
  "label.testCatalog.ranges.ackModal.warning": "This test has reference-range coverage gaps.",
  "label.testCatalog.ranges.ackModal.body": "The following age windows have no reference range — results there cannot be flagged against a range. Acknowledge to activate anyway.",
  "label.testCatalog.ranges.male": "Male",
  "label.testCatalog.ranges.female": "Female",
  "label.testCatalog.ranges.gapRange": "{from} – {to}",
  "label.testCatalog.ranges.days": "days",
  "label.testCatalog.ranges.months": "months",
  "label.testCatalog.ranges.years": "years",
  "label.testCatalog.ranges.noUpperLimit": "no upper limit",
  "label.testCatalog.ranges.noLowerLimit": "no lower limit",
  "label.testCatalog.ranges.both": "Both",
  "label.testCatalog.ranges.add": "Add range",
  "label.testCatalog.ranges.empty": "No reference ranges defined yet.",
  "label.testCatalog.ranges.saved": "Reference ranges saved.",
  "label.testCatalog.ranges.loadError": "Could not load reference ranges.",
  "label.testCatalog.ranges.col.component": "Component",
  "label.testCatalog.ranges.allComponents": "All components",
  "label.testCatalog.ranges.col.sex": "Sex",
  "label.testCatalog.ranges.col.age": "Age range",
  "label.testCatalog.ranges.col.normal": "Normal",
  "label.testCatalog.ranges.col.critical": "Critical",
  "label.testCatalog.ranges.col.valid": "Valid",
  "label.testCatalog.ranges.col.actions": "Actions",
  "label.testCatalog.ranges.anyAge": "Any age",
  "label.testCatalog.ranges.coverage.title": "Coverage validation",
  "label.testCatalog.ranges.coverage.gapsHeading": "Uncovered age windows:",
  "label.testCatalog.ranges.coverage.gapWithComponent": "{range} — {component}",
  "label.testCatalog.ranges.coverage.status.COMPLETE": "Fully covered",
  "label.testCatalog.ranges.coverage.status.GAP": "Has gaps",
  "label.testCatalog.ranges.coverage.status.OVERLAP": "Has overlaps",
  "label.testCatalog.ranges.coverage.status.EMPTY": "No ranges",
  "label.testCatalog.ranges.modal.titleAdd": "Add reference range",
  "label.testCatalog.ranges.modal.titleEdit": "Edit reference range",
  "label.testCatalog.ranges.modal.sex": "Applies to",
  "label.testCatalog.ranges.modal.component": "Result component",
  "label.testCatalog.ranges.modal.component.all": "All components",
  "label.testCatalog.ranges.modal.ageUnit": "Age unit",
  "label.testCatalog.ranges.modal.minAge": "From age",
  "label.testCatalog.ranges.modal.maxAge": "To age (blank = no upper bound)",
  "label.testCatalog.ranges.modal.lowNormal": "Normal low",
  "label.testCatalog.ranges.modal.highNormal": "Normal high",
  "label.testCatalog.ranges.modal.lowCritical": "Critical low",
  "label.testCatalog.ranges.modal.highCritical": "Critical high",
  "label.testCatalog.ranges.modal.lowValid": "Valid low",
  "label.testCatalog.ranges.modal.highValid": "Valid high",
  "label.testCatalog.ranges.modal.lowReporting": "Reporting low",
  "label.testCatalog.ranges.modal.highReporting": "Reporting high",
  "error.testCatalog.ranges.reportingInverted": "Reporting low must not be above reporting high.",
  "label.testCatalog.ranges.modal.ageError": "“To age” must be greater than “From age”.",
  "label.testCatalog.ranges.modal.boundsError": "Bounds must nest outward: valid low ≤ critical low ≤ normal low ≤ normal high ≤ critical high ≤ valid high.",
  "label.testCatalog.storage.saved": "Sample storage saved.",
  "label.testCatalog.storage.loadError": "Could not load sample storage settings.",
  "label.testCatalog.storage.history.view": "View change history",
  "label.testCatalog.storage.history.title": "Sample Storage — Change History",
  "label.testCatalog.storage.history.loadError": "Unable to load change history.",
  "label.testCatalog.storage.history.empty": "No changes recorded.",
  "label.testCatalog.storage.history.filter": "Filter by field",
  "label.testCatalog.storage.history.col.changedAt": "Changed At",
  "label.testCatalog.storage.history.col.changedBy": "Changed By",
  "label.testCatalog.storage.history.col.field": "Field",
  "label.testCatalog.storage.history.col.old": "Old Value",
  "label.testCatalog.storage.history.col.new": "New Value",
  "label.testCatalog.storage.storageHeading": "Storage",
  "label.testCatalog.storage.disposalHeading": "Disposal",
  "label.testCatalog.storage.handlingHeading": "Special handling",
  "label.testCatalog.storage.condition": "Storage condition",
  "label.testCatalog.storage.conditionCustom": "Custom condition",
  "label.testCatalog.storage.duration": "Maximum storage duration",
  "label.testCatalog.storage.durationUnit": "Duration unit",
  "label.testCatalog.storage.stabilityNotes": "Stability notes",
  "label.testCatalog.storage.protectFromLight": "Protect from light",
  "label.testCatalog.storage.doNotFreeze": "Do not freeze",
  "label.testCatalog.storage.doNotRefrigerate": "Do not refrigerate",
  "label.testCatalog.storage.disposalMethod": "Disposal method",
  "label.testCatalog.storage.disposalTimeframe": "Disposal timeframe",
  "label.testCatalog.storage.disposalUnit": "Timeframe unit",
  "label.testCatalog.storage.specialInstructions": "Special instructions",
  "label.testCatalog.storage.overrideRestricted": "Restrict storage-duration override",
  "label.testCatalog.storage.none": "— none —",
  "label.testCatalog.storage.condition.AMBIENT": "Ambient / room temperature",
  "label.testCatalog.storage.condition.CONTROLLED_ROOM_TEMPERATURE": "Controlled room temperature (20–25°C)",
  "label.testCatalog.storage.condition.COOL_ROOM": "Cool room (8–15°C)",
  "label.testCatalog.storage.condition.COLD_ROOM": "Cold room (2–8°C)",
  "label.testCatalog.storage.condition.REFRIGERATED": "Refrigerated (2–8°C)",
  "label.testCatalog.storage.condition.FROZEN": "Frozen (−20°C)",
  "label.testCatalog.storage.condition.DEEP_FROZEN": "Deep frozen (−70°C)",
  "label.testCatalog.storage.condition.ULTRA_LOW_FREEZER": "Ultra-low freezer (−80°C)",
  "label.testCatalog.storage.condition.WARM_INCUBATOR": "Warm incubator (35–37°C)",
  "label.testCatalog.storage.disposal.INCINERATION": "Incineration",
  "label.testCatalog.storage.disposal.AUTOCLAVE": "Autoclave",
  "label.testCatalog.storage.disposal.CHEMICAL_DISINFECTION": "Chemical disinfection",
  "label.testCatalog.storage.disposal.BIOHAZARD": "Biohazard waste",
  "label.testCatalog.storage.disposal.SHARPS_CONTAINER": "Sharps container",
  "label.testCatalog.storage.disposal.SEWER": "Sewer / drain disposal",
  "label.testCatalog.storage.disposal.RETURN_TO_SENDER": "Return to sender",
  "label.testCatalog.storage.disposal.ARCHIVE": "Long-term archive",
  "label.testCatalog.storage.disposal.STANDARD": "Standard waste",
  "label.testCatalog.storage.unit.hours": "hours",
  "label.testCatalog.storage.unit.days": "days",
  "label.testCatalog.storage.unit.weeks": "weeks",
  "label.testCatalog.storage.unit.months": "months",
  "label.testCatalog.analyzers.infoCard": "Analyzers are linked to this test on the analyzer configuration screen. This list is read-only.",
  "label.testCatalog.analyzers.empty": "No analyzers are mapped to this test yet.",
  "label.testCatalog.analyzers.loadError": "Could not load analyzers for this test.",
  "label.testCatalog.analyzers.col.analyzer": "Analyzer",
  "label.testCatalog.analyzers.col.testName": "Analyzer test name",
  "label.testCatalog.displayOrder.pickSampleType": "Sample type",
  "label.testCatalog.displayOrder.intro": "Reorder how tests appear within a sample type. Order is saved automatically.",
  "label.testCatalog.displayOrder.empty": "No tests are assigned to this sample type.",
  "label.testCatalog.displayOrder.loadError": "Could not load the display order.",
  "label.testCatalog.displayOrder.saved": "Display order saved.",
  "label.testCatalog.displayOrder.currentTest": "This test",
  "label.testCatalog.displayOrder.moveUp": "Move up",
  "label.testCatalog.displayOrder.moveDown": "Move down",
  "label.testCatalog.displayOrder.col.position": "Position",
  "label.testCatalog.displayOrder.col.test": "Test",
  "label.testCatalog.displayOrder.dragHandle": "Drag to reorder",
  "label.testCatalog.terminology.intro": "Map this test to standard terminology codes for interoperability.",
  "vector.collectedVolume.helper": "Number of organisms in this pool, e.g., number of mosquitoes.",
  "vector.complete.animal": "Animal",
  "vector.complete.cancel": "Cancel",
  "vector.complete.details.collectionDate": "Collection Date",
  "vector.complete.details.collectionSite": "Collection Site",
  "vector.complete.details.collector": "Collector",
  "vector.complete.details.lifecycleStage": "Lifecycle Stage",
  "vector.complete.details.tests": "Tests",
  "vector.complete.details.title": "Order Details",
  "vector.complete.details.trapType": "Trap Type",
  "vector.complete.labNumber": "Lab Number",
  "vector.complete.newOrder": "New Vector Order",
  "vector.complete.quantity": "Quantity",
  "vector.complete.quantity.value": "{count} organisms",
  "vector.complete.status": "Status",
  "vector.complete.status.processing": "Processing",
  "vector.lifecycleStage.helper": "Developmental stage of the collected organism.",
  "vector.order.collectionContext.helper": "Optional — records ecological conditions at time of collection (bionomics).",
  "vector.order.collectionDate.heading": "Collection Date",
  "vector.order.collectionDate.helper": "Date the lot was physically collected from the field. Applies to every sample on this order.",
  "vector.order.site.add.new": "+ Add new site \"{name}\"",
  "vector.order.site.add.new.restricted": "Adding a new sampling site has been disabled by your administrator.",
  "vector.order.site.new.helper": "Will be created as a new sampling site when this order is saved.",
  "vector.order.site.new.tag": "New",
  "vector.order.site.no.match": "No matching site found.",
  "vector.pool.noTests": "No tests recorded",
  "vector.pool.summary": "Pool of {count} {animal}",
  "vector.trapCount.helper": "Number of traps deployed — used with nights to compute density per trap-night.",
  "vector.trapNights.helper": "Number of nights the traps were active. Leave blank if effort was not recorded.",
  "vector.trapType.helper": "Capture method or device used — select a sample type first.",
  "vectorDec.actionBar.assigned": "{assigned}/{total} assigned · {pools} pools",
  "vectorDec.button.back": "Back",
  "vectorDec.button.discard": "Discard",
  "vectorDec.button.previewGrouping": "Preview Grouping",
  "vectorDec.button.savePools": "Save Pools",
  "vectorDec.button.splitIndividuals": "Split to individuals →",
  "vectorDec.button.splitIndividuals.tooltip": "Quick set: one specimen per pool",
  "vectorDec.button.view": "View",
  "vectorDec.col.children": "Child Specimens",
  "vectorDec.col.positiveTest": "Positive Test",
  "vectorDec.col.results": "Results",
  "vectorDec.col.status": "Status",
  "vectorDec.empty": "No deconvolution tasks.",
  "vectorDec.error.initiateFailed": "Could not initiate deconvolution.",
  "vectorDec.error.loadWorklist": "Could not load deconvolution worklist.",
  "vectorDec.error.minPoolCount": "Number of pools must be at least 2.",
  "vectorDec.error.noAssignedSpecimens": "Drag at least one specimen into a pool before saving.",
  "vectorDec.error.noParent": "No parent SampleItem available to split.",
  "vectorDec.error.poolFloorByType": "Lot has {types} sample types ({names}) — minimum {types} pools required for Random distribution.",
  "vectorDec.error.unassignedSpecimens": "{count} specimens are still unassigned. Assign all specimens before saving.",
  "vectorDec.field.howManyPools": "How many pools?",
  "vectorDec.field.notes": "Notes",
  "vectorDec.field.organismsPerPool": "Organisms per pool",
  "vectorDec.field.poolCount": "Number of pools",
  "vectorDec.field.strategy": "Assignment method",
  "vectorDec.filter.all": "All",
  "vectorDec.filter.status": "Filter by status",
  "vectorDec.heading.preview": "Proposed Pool Grouping",
  "vectorDec.heading.split": "Split into Sub-pools",
  "vectorDec.heading.worklist": "Pool Deconvolution",
  "vectorDec.individualMode.badge": "Individual mode",
  "vectorDec.locationOverride.help": "Override the inherited intake collection site for individual sub-pools. Use this when a single lot was collected from multiple sites.",
  "vectorDec.locationOverride.inherit": "Inherit from lot (default)",
  "vectorDec.locationOverride.notes": "Aliquot notes",
  "vectorDec.locationOverride.site": "Collection site",
  "vectorDec.locationOverride.title": "Per sub-pool collection location (optional)",
  "vectorDec.message.success": "{count} sub-pools created ({labRange}), {orders} test orders queued. Status → Deconvolution In Progress.",
  "vectorDec.message.successIndividual": "{count} individual aliquots created ({labRange}), {orders} test orders queued. Status → Deconvolution In Progress. VR-07 Sporozoite Confirmation will fire on confirmed positives.",
  "vectorDec.parent.label": "Parent",
  "vectorDec.parent.quantity": "Quantity: {qty}",
  "vectorDec.preview.body": "{count} pools using {strategy}. Drag specimens between pools to adjust before saving.",
  "vectorDec.preview.empty": "No specimens",
  "vectorDec.preview.organisms": "organisms",
  "vectorDec.preview.poolN": "Pool {n}",
  "vectorDec.preview.poolWithSpecies": "Pool {n} — {species}",
  "vectorDec.preview.specimenCount": "{count, plural, one {# specimen} other {# specimens}}",
  "vectorDec.preview.title": "Proposed grouping",
  "vectorDec.preview.unassigned": "{count, plural, =0 {All specimens assigned} one {# unassigned} other {# unassigned}}",
  "vectorDec.preview.unassignedHint": "{count} unassigned — these stay in the original pool.",
  "vectorDec.reflexPreview.copiedTag": "COPIED",
  "vectorDec.reflexPreview.eagerTag": "EAGER",
  "vectorDec.reflexPreview.heading": "↪ Reflex rules will fire on save",
  "vectorDec.reflexPreview.parentTests": "Parent test orders ({test}) — re-run on each child",
  "vectorDec.reflexPreview.screeningPanel": "screening panel",
  "vectorDec.reflexPreview.tipSplitIndividuals": "Tip: Split to individual specimens to also fire {rules} — these rules only apply to pools with a single organism.",
  "vectorDec.results.positive": "({count} +)",
  "vectorDec.setup.distribution": "{specimens} specimens → ~{perPool} per pool{remainder, plural, =0 {} other {, remainder +1 to first {remainder}}}",
  "vectorDec.status.complete": "Decon Complete",
  "vectorDec.status.confirmed": "Confirmed",
  "vectorDec.status.inProgress": "In Progress",
  "vectorDec.status.pending": "Review Needed",
  "vectorDec.strategy.manual": "Assign manually — drag and drop specimens into pools",
  "vectorDec.strategy.manual.hint": "Drag and drop specimens into pools yourself",
  "vectorDec.strategy.manual.title": "Assign manually",
  "vectorDec.strategy.random": "Assign randomly — distribute specimens evenly across pools",
  "vectorDec.strategy.random.hint": "Evenly distribute specimens across pools",
  "vectorDec.strategy.random.title": "Assign randomly",
  "vectorDec.strategy.species": "Auto sub-pool by species — group matching specimens together",
  "vectorDec.strategy.species.hint": "Group specimens by species — requires species ID on specimens",
  "vectorDec.strategy.species.title": "Auto sub-pool by species",
  "vectorDec.totalOrganisms": "Total organisms",
  "vectorDec.warning.exceedsParent.body": "{total} organisms requested across child pools, but parent has {parent}. The system will still create {total} children.",
  "vectorDec.warning.exceedsParent.title": "Total exceeds parent quantity",
  "vectorId.batch.selectedCount": "{count, plural, one {# specimen selected} other {# specimens selected}}",
  "vectorId.bloodMeal.add": "Add Panel to Order",
  "vectorId.bloodMeal.added": "Blood-Meal Identification Panel added to specimen test orders.",
  "vectorId.bloodMeal.addedSub": "Provenance: manual (lab tech accepted suggestion). Per BR-V03-014.",
  "vectorId.bloodMeal.alreadyAttached": "Blood-meal panel already attached ({skipped} tests).",
  "vectorId.bloodMeal.body": "Order the Mosquito Blood-Meal Identification Panel to identify the host species this specimen fed on.",
  "vectorId.bloodMeal.bulkAdd": "Add Panel to All ({count})",
  "vectorId.bloodMeal.bulkAddedSub": "Blood-meal panel processed for {count} specimens.",
  "vectorId.bloodMeal.bulkBody": "Add the Mosquito Blood-Meal Identification Panel to every selected specimen so the lab can identify which vertebrate host the mosquitoes fed on.",
  "vectorId.bloodMeal.bulkSummary": "Blood-meal panel: {added} added, {skipped} already attached, {rejected} rejected.",
  "vectorId.bloodMeal.bulkTitle": "Blood-fed females detected ({count} specimens)",
  "vectorId.bloodMeal.dismiss": "Dismiss",
  "vectorId.bloodMeal.error.add": "Could not add the Mosquito Blood-Meal Identification Panel.",
  "vectorId.bloodMeal.error.dismiss": "Could not record the dismissal.",
  "vectorId.bloodMeal.title": "Blood-fed female detected",
  "vectorId.bulk.applyToCount": "Apply to {count} specimens",
  "vectorId.bulk.heading": "Bulk Apply Species ID",
  "vectorId.bulk.notice.body": "Molecular detail fields (target gene, assay, accession) are not bulk-copied — record those per specimen.",
  "vectorId.bulk.notice.title": "Specimen-specific fields not copied",
  "vectorId.button.bulkApply": "🔖 Bulk Apply ({count})",
  "vectorId.button.cancel": "Cancel",
  "vectorId.button.close": "▲ Close",
  "vectorId.button.confirm": "Confirm",
  "vectorId.button.confirmAll": "✓ Confirm for all vectors",
  "vectorId.button.confirmResult": "✓ Confirm: {test}",
  "vectorId.button.hideResults": "Hide results",
  "vectorId.button.identify": "▼ Identify",
  "vectorId.button.reviewResults": "Review results ({n})",
  "vectorId.button.save": "Save Identification",
  "vectorId.button.splitPool": "↗ Split",
  "vectorId.col.collectionDate": "Collection Date",
  "vectorId.col.decon": "Decon",
  "vectorId.col.decon.help": "Deconvolution status — whether pool results have been entered and sub-pools are awaiting review.",
  "vectorId.col.idStatus": "ID Status",
  "vectorId.col.lotId": "Lot ID",
  "vectorId.col.organismGroup": "Group",
  "vectorId.col.progress": "Progress",
  "vectorId.col.site": "Sampling Site",
  "vectorId.completion.body": "{positive} of {total} sub-pools confirmed ({pct}%)",
  "vectorId.completion.body.confirmed": "{total} vectors confirmed",
  "vectorId.completion.body.partial": "Confirmed for all vectors in this pool:",
  "vectorId.completion.heading": "Deconvolution Complete",
  "vectorId.completion.heading.confirmed": "Result Confirmed",
  "vectorId.completion.heading.partial": "Results Partially Confirmed",
  "vectorId.completion.tag": "Decon Complete",
  "vectorId.completion.tag.confirmed": "Confirmed",
  "vectorId.completion.tag.partial": "Partially Confirmed",
  "vectorId.confidence.confirmed": "Confirmed",
  "vectorId.confidence.presumptive": "Presumptive",
  "vectorId.distribution.confirmed": "{count} Confirmed",
  "vectorId.distribution.heading": "Species Distribution",
  "vectorId.distribution.notIdentified": "{count} Not Identified",
  "vectorId.distribution.notYet": "Not yet identified",
  "vectorId.distribution.presumptive": "{count} Presumptive",
  "vectorId.empty": "No lots in this queue.",
  "vectorId.error.accessionFormat": "GenBank accession format: 1–2 letters followed by 5–8 digits (e.g. MW123456).",
  "vectorId.error.confidenceRequired": "Confidence is required.",
  "vectorId.error.loadSpecimens": "Could not load specimens for this lot.",
  "vectorId.error.loadWorklist": "Could not load worklist.",
  "vectorId.error.methodRequired": "Identification method is required.",
  "vectorId.error.notesTooLong": "Notes must be 500 characters or less.",
  "vectorId.error.requiredFields": "Species, method, and confidence are required.",
  "vectorId.error.saveFailed": "Could not save identification.",
  "vectorId.error.speciesRequired": "Species is required.",
  "vectorId.filter.complete": "Complete",
  "vectorId.filter.complete.sub": "All specimens identified.",
  "vectorId.filter.decon": "Deconvolution",
  "vectorId.filter.decon.sub": "Pool results entered, awaiting technician decision to split or confirm.",
  "vectorId.filter.label": "Status",
  "vectorId.filter.notstarted": "Not Started",
  "vectorId.filter.notstarted.sub": "Received, 0 specimens identified.",
  "vectorId.filter.partialid": "Partial ID",
  "vectorId.filter.partialid.sub": "Identification in progress.",
  "vectorId.filter.pending": "Pending",
  "vectorId.filter.pending.sub": "All not-complete lots, including pools with results awaiting technician review.",
  "vectorId.form.assayName": "Assay Name",
  "vectorId.form.assayName.placeholder": "Multiplex RT-PCR",
  "vectorId.form.confidence": "Confidence",
  "vectorId.form.genbankAccession": "GenBank Accession",
  "vectorId.form.genbankAccession.placeholder": "MW123456",
  "vectorId.form.lifecycleStage": "Lifecycle Stage",
  "vectorId.form.linkedResult": "Link to Pathogen Result",
  "vectorId.form.linkedResultPlaceholder": "Select a result on this lot…",
  "vectorId.form.method": "Method",
  "vectorId.form.molecularDetails": "🔬 Molecular Details",
  "vectorId.form.notes": "Notes",
  "vectorId.form.physState": "Physiological State",
  "vectorId.form.select": "Select…",
  "vectorId.form.species": "Species",
  "vectorId.form.speciesPlaceholder": "Search genus or species…",
  "vectorId.form.targetGene": "Target Gene",
  "vectorId.form.targetGene.placeholder": "COI, ITS2, 28S rDNA",
  "vectorId.heading.worklist": "Vector Identification Worklist",
  "vectorId.loading": "Loading…",
  "vectorId.message.bulkSuccess": "Identification applied to {count} specimens.",
  "vectorId.message.saveSuccess": "Identification saved.",
  "vectorId.method.both": "Morphological + Molecular",
  "vectorId.method.molecular": "Molecular",
  "vectorId.method.morphological": "Morphological",
  "vectorId.notif.confirmAll.error": "Could not confirm result. Please try again.",
  "vectorId.notif.confirmAll.success": "Result confirmed for all vectors in this pool.",
  "vectorId.notif.deconNeeded.body": "A result has been entered for this pool. Split into sub-pools for further testing, or confirm the result applies to all vectors.",
  "vectorId.notif.deconNeeded.bodyWithTest": "One of the tests has a result. Split into sub-pools for further testing, or confirm the result applies to all vectors.",
  "vectorId.notif.deconNeeded.title": "Pool Result Awaiting Review",
  "vectorId.physState.blood_fed": "Blood-fed",
  "vectorId.physState.gravid": "Gravid",
  "vectorId.physState.half_gravid": "Half-gravid",
  "vectorId.physState.unfed": "Unfed",
  "vectorId.physState.unknown": "Unknown / not assessed",
  "vectorId.resplit.heading": "Split: {label}",
  "vectorId.search.placeholder": "Search lots…",
  "vectorId.specimen.col.confidence": "Confidence",
  "vectorId.specimen.col.idStatus": "ID Status",
  "vectorId.specimen.col.label": "Specimen",
  "vectorId.specimen.col.labNo": "Lab Number",
  "vectorId.specimen.col.poolOrSpecimen": "Pool / Specimen",
  "vectorId.specimen.col.species": "Species",
  "vectorId.specimen.confirmed": "Confirmed",
  "vectorId.specimen.count": "specimens",
  "vectorId.specimen.empty": "No specimens for this lot.",
  "vectorId.specimen.label": "Specimen #{n}",
  "vectorId.specimen.notIdentified": "Not Identified",
  "vectorId.specimen.presumptive": "Presumptive",
  "vectorId.status.complete": "Complete",
  "vectorId.status.inProgress": "In Progress",
  "vectorId.status.notStarted": "Not Started",
  "vectorId.tag.deconComplete": "Complete",
  "vectorId.tag.deconInProgress": "Decon in progress",
  "vectorId.tag.deconNeeded": "⚠ Review Result",
  "vectorId.tag.subPoolPending": "{count} sub-pool with results",
  "vectorId.tree.organisms": "{count, plural, one {# organism} other {# organisms}}",
  "vectorReport.density.bySite": "Density by site and period",
  "vectorReport.density.effortNotRecorded": "Effort not recorded",
  "vectorReport.density.period": "Period",
  "vectorReport.density.perTrapNight": "Density (per trap-night)",
  "vectorReport.density.pools": "Pools",
  "vectorReport.density.site": "Site",
  "vectorReport.density.specimens": "Specimens",
  "vectorReport.density.title": "Specimen counts by site",
  "vectorReport.density.trapNights": "Trap-nights",
  "vectorReport.description": "Surveillance indices computed from recorded vector collections, species identifications, and pathogen results",
  "vectorReport.empty": "No data for the selected scope.",
  "vectorReport.exportPdf": "Export PDF",
  "vectorReport.fieldMap.description": "Reorder, hide, relabel, or portal-tag the metrics shown in the Manual Entry Helper.",
  "vectorReport.fieldMap.hidden": "Hidden",
  "vectorReport.fieldMap.label": "Label",
  "vectorReport.fieldMap.metric": "Metric",
  "vectorReport.fieldMap.order": "Order",
  "vectorReport.fieldMap.portalTag": "Portal tag",
  "vectorReport.fieldMap.title": "Manual Entry Field Map",
  "vectorReport.fieldMap.visibility": "Visibility",
  "vectorReport.fieldMap.visible": "Visible",
  "vectorReport.fieldMap.visibleLabel": "Visible in the Manual Entry Helper",
  "vectorReport.filter.allSites": "All sites",
  "vectorReport.filter.apply": "Apply",
  "vectorReport.filter.dateRange": "Date range",
  "vectorReport.filter.from": "From",
  "vectorReport.filter.site": "Sampling site",
  "vectorReport.filter.to": "To",
  "vectorReport.freshness": "Data freshness",
  "vectorReport.freshness.as": "Figures as of {time}",
  "vectorReport.freshness.unknown": "unknown",
  "vectorReport.generated": "Generated:",
  "vectorReport.home": "Home",
  "vectorReport.loadError": "Failed to load surveillance indices. Please try again.",
  "vectorReport.manualEntry.confirmBody": "Record an audit snapshot of this week's figures ({periodStart} – {periodEnd})? Re-submitting a week is recorded as a separate entry.",
  "vectorReport.manualEntry.confirmSubmit": "Confirm",
  "vectorReport.manualEntry.copied": "Copied to clipboard",
  "vectorReport.manualEntry.copy": "Copy value",
  "vectorReport.manualEntry.empty": "No metrics configured for this period",
  "vectorReport.manualEntry.loading": "Loading week's numbers...",
  "vectorReport.manualEntry.lowConfidence": "Confidence reduced (pool deconvolution below 95%)",
  "vectorReport.manualEntry.markSubmitted": "Mark week submitted",
  "vectorReport.manualEntry.submitError": "Could not record submission",
  "vectorReport.manualEntry.submitted": "Week marked submitted",
  "vectorReport.manualEntry.title": "Manual Entry Helper",
  "vectorReport.manualEntry.week": "Reporting week",
  "vectorReport.mir.classic": "MIR (classical)",
  "vectorReport.mir.observed": "Infection rate (observed)",
  "vectorReport.mir.pathogen": "Pathogen",
  "vectorReport.mir.positivePools": "Positive pools",
  "vectorReport.mir.resolution": "Positive resolution",
  "vectorReport.mir.species": "Species",
  "vectorReport.mir.sporozoite": "Sporozoite rate",
  "vectorReport.mir.sporozoiteNote": "Confidence is reduced when pool deconvolution resolution is below 95%.",
  "vectorReport.mir.title": "Minimum Infection Rate by species",
  "vectorReport.mir.totalSpecimens": "Total specimens",
  "vectorReport.mir.withheld": "Withheld",
  "vectorReport.positivity.notConfigured": "Positivity classification is not configured for this deployment, so infection-rate, positivity, and sporozoite figures are unavailable. Configure result significance in the test catalog to enable them.",
  "vectorReport.positivity.pathogen": "Pathogen",
  "vectorReport.positivity.pct": "Positivity",
  "vectorReport.positivity.poolsPositive": "Pools positive",
  "vectorReport.positivity.poolsTested": "Pools tested",
  "vectorReport.positivity.title": "Pathogen positivity",
  "vectorReport.positivity.unrecognized": "Some results carry a significance value that is not a recognized classification (POSITIVE, NEGATIVE, or INDETERMINATE) and are excluded from positivity counts. Review the test catalog so these results can be counted.",
  "vectorReport.prompt": "Select a date range and site, then choose Apply to view surveillance indices.",
  "vectorReport.qc.detail": "{passed} of {total} analyses passed",
  "vectorReport.qc.passed": "Analyses passed",
  "vectorReport.qc.passRate": "Pass rate",
  "vectorReport.qc.title": "QC pass-rate",
  "vectorReport.qc.total": "Analyses total",
  "vectorReport.species.genus": "Genus",
  "vectorReport.species.pct": "Share",
  "vectorReport.species.species": "Species",
  "vectorReport.species.specimens": "Specimens",
  "vectorReport.species.title": "Species distribution",
  "vectorReport.sporozoite.title": "Sporozoite rate (Anopheles)",
  "vectorReport.title": "Vector Surveillance",
  "vfs.abj": "ABJ (Larva-Free Rate)",
  "vfs.abj.target.below": "✗ ABJ below the 95% Kemenkes target",
  "vfs.abj.target.met": "✓ ABJ meets the 95% Kemenkes target",
  "vfs.bi": "Breteau Index (per 100 houses)",
  "vfs.ci": "Container Index (CI)",
  "vfs.containersExamined": "Containers examined",
  "vfs.containersPositive": "Containers positive",
  "vfs.err.containersExceeded": "Cannot exceed containers examined.",
  "vfs.err.examinedMin": "Must be ≥ 1 when larval data is entered.",
  "vfs.err.housesExceeded": "Cannot exceed houses examined.",
  "vfs.err.negative": "Cannot be negative.",
  "vfs.err.populationMin": "Must be ≥ 1 when pupal data is entered.",
  "vfs.hi": "House Index (HI)",
  "vfs.housesExamined": "Houses examined",
  "vfs.housesPositive": "Houses positive",
  "vfs.indices.title": "Computed indices (preview)",
  "vfs.larval.title": "Larval Survey — Mode C",
  "vfs.populationAtRisk": "Population at risk",
  "vfs.ppi": "Pupae Per Person (PPI)",
  "vfs.pupaeCount": "Pupae count",
  "vfs.pupal.title": "Pupal Survey — Mode D",
  "vfs.surveyMethod": "Survey method",
  "vfs.surveyMethod.placeholder": "Choose an option",
  "warning.results.precision": "This test reports to {0} decimal place(s). The value is saved as entered and reported rounded to that precision.",
  "warning.testCatalog.noLoinc": "This test has no LOINC. Analyzer and electronic-order results cannot be imported to it.",
  "warning.testCatalog.duplicateLoinc": "LOINC {code} is also used by {testName}. Incoming results for this code route to only one test (first match) — results may be sent to the wrong test.",
  "label.testCatalog.terminology.col.source": "Source",
  "label.testCatalog.terminology.col.code": "Code",
  "label.testCatalog.terminology.col.displayName": "Display name",
  "label.testCatalog.terminology.displayName.placeholder": "e.g. Glucose [Mass/volume] in Serum or Plasma",
  "label.testCatalog.terminology.col.relationship": "Relationship",
  "label.testCatalog.terminology.col.appliesTo": "Applies to",
  "label.testCatalog.terminology.appliesTo.test": "Whole test",
  "label.testCatalog.terminology.col.actions": "Actions",
  "label.testCatalog.terminology.source": "Terminology source",
  "label.testCatalog.terminology.sourceTooLong": "A source is at most {max} characters",
  "label.testCatalog.terminology.code": "Code",
  "label.testCatalog.terminology.relationship": "Relationship",
  "label.testCatalog.terminology.addMapping": "Add mapping",
  "label.testCatalog.terminology.remove": "Remove mapping",
  "label.testCatalog.terminology.empty": "No terminology mappings yet.",
  "label.testCatalog.terminology.loadError": "Could not load terminology mappings.",
  "label.testCatalog.terminology.saved": "Terminology mappings saved.",
  "error.testCatalog.terminology.duplicate": "Duplicate {source} code {code} — this mapping already exists for this test.",
  "error.testCatalog.terminology.invalid": "The mappings could not be saved — check for a duplicate code, an unknown source, or an invalid relationship.",
  "error.testCatalog.terminology.tooLong": "A code holds at most 80 characters and a display name 255.",
  "label.testCatalog.terminology.rel.none": "— none —",
  "label.testCatalog.terminology.rel.SAME_AS": "Same as",
  "label.testCatalog.terminology.rel.BROADER_THAN": "Broader than",
  "label.testCatalog.terminology.rel.NARROWER_THAN": "Narrower than",
  "label.testCatalog.panels.intro": "Manage which panels this test belongs to, and its position within each.",
  "label.testCatalog.panels.addToPanel": "Add to panel",
  "label.testCatalog.panels.col.panel": "Panel",
  "label.testCatalog.panels.col.position": "Position",
  "label.testCatalog.panels.col.actions": "Actions",
  "label.testCatalog.panels.position": "Position",
  "label.testCatalog.panels.remove": "Remove from panel",
  "label.testCatalog.panels.remove.confirm.heading": "Remove test from panel?",
  "label.testCatalog.panels.remove.confirm.body": "This test will be removed from {panel}. It stays in the catalog and any other panels. You can re-add it later.",
  "label.testCatalog.panels.moveUp": "Move earlier",
  "label.testCatalog.panels.moveDown": "Move later",
  "label.testCatalog.panels.viewOrder": "View this panel's test order",
  "label.testCatalog.panels.orderContext": "Tests in this panel (in order):",
  "label.testCatalog.panels.empty": "This test is not in any panel yet.",
  "label.testCatalog.panels.loadError": "Could not load panel memberships.",
  "label.testCatalog.panels.saved": "Panel memberships saved.",
  "label.testCatalog.panels.createPanel": "Create new panel",
  "label.testCatalog.panels.createPanelHint": "Enter a name to create a panel and add this test to it. Its sample type, ordering modules and other settings are configured later in the Panel Editor.",
  "notification.testCatalog.panels.created": "Panel \"{name}\" created and this test added. Configure it further in the Panel Editor.",
  "label.search": "Search",
  "label.testCatalog.list": "Test Catalog",
  "label.testCatalog.list.search": "Search by test name",
  "label.testCatalog.list.col.status": "Status",
  "label.testCatalog.list.filter.allDomains": "All domains",
  "label.testCatalog.list.filter.allStatus": "All statuses",
  "label.testCatalog.list.filter.inactive": "Inactive",
  "label.testCatalog.list.coverageIncomplete": "Coverage incomplete",
  "label.testCatalog.list.filter.amr": "AMR",
  "label.testCatalog.list.filter.anyAmr": "Any",
  "label.testCatalog.list.filter.amrOnly": "AMR only",
  "label.testCatalog.list.filter.nonAmr": "Non-AMR",
  "label.testCatalog.list.filter.sampleType": "Sample Type",
  "label.testCatalog.list.filter.allSampleTypes": "All sample types",
  "label.testCatalog.list.filter.allLabUnits": "All lab units",
  "label.testCatalog.list.amrTag": "AMR",
  "label.testCatalog.list.noLoinc": "No LOINC",
  "label.testCatalog.list.filter.issuesOnly": "Only tests with issues",
  "label.testCatalog.list.health.banner": "{count} tests have configuration issues ({errors} errors · {warnings} warnings)",
  "label.testCatalog.list.health.show": "Show",
  "label.testCatalog.activation.incomplete.heading": "Test cannot be activated yet",
  "label.testCatalog.activation.incomplete.body": "Resolve the following before this test can be activated:",
  "label.testCatalog.list.col.sampleType": "Sample Type",
  "button.testCatalog.newTest": "New test",
  "button.testCatalog.editRelated": "Edit related tests together",
  "button.testCatalog.editRelatedFromEditor": "Edit related tests…",
  "label.testCatalog.editor.noRelated": "No related tests share this test's name.",
  "label.testCatalog.editor.createSaveFirst.title": "Save the test first",
  "label.testCatalog.editor.createSaveFirst": "Complete Basic Info and save. This section becomes available once the test is created.",
  "label.testCatalog.editingNTests": "Editing {count} tests",
  "label.testCatalog.perTestIdentity": "Identity & LOINC (per test)",
  "state.testCatalog.differsAcrossTests": "Differs across tests",
  "button.testCatalog.setAllTo": "Set all to these values",
  "label.testCatalog.group.rangesSaved": "Reference ranges saved to {count} tests.",
  "label.testCatalog.group.storageIntro": "Edit storage & handling once; saving applies the fields you change to every selected test and leaves the other fields as they are on each test.",
  "label.testCatalog.group.storageDiffer": "These fields are not the same on every selected test: {fields}. The form shows the first test's values; a field you leave unchanged keeps each test's own value.",
  "button.testCatalog.removeFromSet": "Remove from this set",
  "label.testCatalog.group.rangesIntro": "Edit the reference ranges once; saving applies them to every selected test. Identity and LOINC stay per test.",
  "label.testCatalog.group.rangesDiffer": "The selected tests' current ranges are not identical. Saving will set all of them to the values below.",
  "label.testCatalog.group.rangesLoadError": "The current ranges of {tests} could not be loaded, so nothing can be applied yet. Retry to load them again.",
  "label.testCatalog.ranges.table.sex": "Applies to",
  "label.testCatalog.ranges.table.age": "Age range",
  "label.testCatalog.ranges.table.normal": "Normal (low / high)",
  "label.testCatalog.list.filters": "Filters",
  "label.testCatalog.list.filters.count": "Filters ({count})",
  "label.testCatalog.list.error": "Couldn't load the test catalog. Adjust the filters or reload to try again.",
  "label.testCatalog.list.empty": "No tests match the current filters.",
  "sidenav.label.admin.testmgt.ManageMethod": "Manage Method",
  "sidenav.label.admin.testmgt.reflex": "Reflex Tests  Management",
  "sidenav.label.admin.usermgt": "User Management",
  "sideNav.label.arvfollowup1": "ARV Follow-up Version 1",
  "sideNav.label.arvfollowup2": "ARV Follow-up Version 2",
  "sideNav.label.arvreports1": "ARV Initial Version 1",
  "sideNav.label.arvreports2": "ARV Initial Version 2",
  "sideNav.label.arvversion1": "ARV-Version 1",
  "sideNav.label.associatedpatientreport": "Associated Patient Report",
  "sideNav.label.audittrail": "Audit Trail",
  "sidenav.label.barcode": "Barcode",
  "sidenav.label.batchorder": "Batch Order Entry",
  "sideNav.label.bypaneltype": "By Panel Type",
  "sideNav.label.bytesttype": "By Test Type",
  "sideNav.label.byunit": "By Unit",
  "sideNav.label.collectedarvpatientreports": "Collected ARV patient Report",
  "sidenav.label.cytology": "Cytology",
  "sidenav.label.cytology.dashboard": "Dashboard",
  "sideNav.label.delayedvalidation": "Delayed Validation",
  "sidenav.label.editorder": "Edit Order",
  "sideNav.label.eidreports1": "EID Version 1",
  "sideNav.label.eidreports2": "EID Version 2",
  "sideNav.label.exportcsvfile": "Export Routine CSV file",
  "sideNav.label.followuprequired": "Follow-up Required",
  "sideNav.label.generalreport": "General Report",
  "sideNav.label.hivtestsummary": "HIV Test Summary",
  "sidenav.label.immunochem": "Immunohistochemistry",
  "sidenav.label.immunochem.dashboard": "Dashboard",
  "sidenav.label.incomingorder": "Electronic Orders",
  "sideNav.label.intermediatebyservice": "Intermediate By Service",
  "sideNav.label.intermediatereport1": "Intermediate Version 1",
  "sideNav.label.intermediatereport2": "Intermediate Version 2",
  "sidenav.label.inventory": "Inventory",
  "sidenav.label.inventory.management": "Inventory Management",
  "sidenav.label.inventory.management.tooltip": "Manage inventory items, lots, and stock levels",
  "sidenav.label.inventory.tooltip": "Inventory management for reagents, kits, and supplies",
  "sideNav.label.laporanHasil": "Compliance Report",
  "sideNav.label.noncomformitynotification": "Non-conformity Notification",
  "sideNav.label.noncomformityreportsbydate": "By Date",
  "sideNav.label.noncomformityreportsbylabno": "By Lab No",
  "sideNav.label.noncomformityreportsbyunit": "By Unit and Reason",
  "sidenav.label.notebook": "NoteBook",
  "sidenav.label.add.order": "Add Order",
  "sidenav.label.clinical.order": "Add Clinical Order",
  "sidenav.label.environmental.compliance": "Compliance Dashboard",
  "sidenav.label.environmental.order": "Add Environmental Order",
  "sidenav.label.vector.order": "Add Vector Order",
  "sidenav.label.order": "Order",
  "sidenav.label.order.collect": "Collect Sample",
  "sidenav.label.order.dashboard": "Dashboard",
  "sidenav.label.order.enter": "Enter Order",
  "sidenav.label.order.label": "Label & Store",
  "sidenav.label.order.qa": "QA Review",
  "sidenav.label.order.prepare": "Prepare Samples",
  "sidenav.label.order.sampleCheck": "Sample check",
  "sidenav.label.pathology": "Pathology",
  "sidenav.label.pathology.dashboard": "Dashboard",
  "sideNav.label.referredtestreport": "Referred Out Tests Report",
  "sideNav.label.rejectionreport": "Rejection Report",
  "sidenav.label.reports": "Reports",
  "sidenav.label.reports.routine": "Routine",
  "sidenav.label.reports.study": "Study",
  "sidenav.label.results": "Results",
  "sidenav.label.results.byrange": "By Range of Lab numbers",
  "sidenav.label.results.order": "By Order",
  "sidenav.label.results.patient": "By Patient",
  "sidenav.label.results.testdate": "By Test Date",
  "sidenav.label.results.unit": "By Unit",
  "sideNav.label.sectionperformance": "Section Performance",
  "sideNav.label.specialrequest": "Special Request ",
  "sidenav.label.statisticsreport": "Statistics Report",
  "sidenav.label.statusreport": "Patient Status Report",
  "sidenav.label.storage.coldstorage": "Cold Storage Monitoring",
  "sidenav.label.storage.coldstorage.tooltip": "Monitor temperature and humidity of freezers and refrigerators",
  "sidenav.label.storage.management": "Storage Management",
  "sidenav.label.storage.management.tooltip": "Manage storage locations and devices",
  "sidenav.label.testsummary": "Summary of All Tests",
  "sidenav.label.validation": "Validation",
  "sidenav.label.validation.order": "Search By Order",
  "sidenav.label.validation.routine": "Routine",
  "sidenav.label.validation.study": "Study",
  "sidenav.label.validation.testdate": "Search By Test Date",
  "sideNav.label.viralloaddataexport": "Viral Load Data Export",
  "sideNav.label.vlversionnational": "VL version Nationale",
  "sidenav.label.workplan": "Workplan",
  "sidenav.label.workplan.panel": "By Panel Type",
  "sidenav.label.workplan.priority": "By Priority",
  "sidenav.label.workplan.test": "By Test Type",
  "sidenav.label.workplan.unit": "By Unit",
  "sideNav.title.activityreport": "Activity Report",
  "sidenav.title.aggregatereport": "Aggregate Reports",
  "sideNav.title.arvreports": "ARV Reports",
  "sideNav.title.associatedpatientreport": "Associated Patient Report",
  "sideNav.title.audittrail": "Audit Trail",
  "sideNav.title.collectedarvpatientreports": "Collected ARV patient Report",
  "sideNav.title.delayedvalidation": "Delayed Validation",
  "sideNav.title.eidreports": "EID Reports",
  "sideNav.title.environmentalReports": "Environmental Reports",
  "sideNav.title.exportbydate": "Export By Date",
  "sideNav.title.exportcsvfile": "Export Routine CSV file",
  "sideNav.title.indicator": "Indicator",
  "sideNav.title.intermediatereport": "Intermediate Report",
  "sideNav.title.noncomformityreports": "Non conformity Reports",
  "sideNav.title.referredtestreport": "Referred Out Tests Report",
  "sideNav.title.rejectionreport": "Rejection Report",
  "sideNav.title.specialrequest": "Special Request ",
  "sideNav.title.tatreport": "Turn Around Time",
  "sideNav.title.vectorIdentification": "Vector Identification",
  "sideNav.title.vlreport": "VL Report",
  "sideNav.label.audittrail.orderEvents": "Order Events",
  "sideNav.label.audittrail.systemEvents": "System Events",
  "sidenav.label.addorder": "Add Generic Order",
  "sidenav.label.admin.sampleTypeManagement": "Sample Type Editor",
  "sideNav.label.qa": "Quality Assurance",
  "sideNav.label.qa.overview": "QA Overview",
  "sideNav.label.qa.qc": "Statistical QC",
  "sideNav.label.qa.qc.dashboard": "QC Dashboard",
  "sideNav.label.qa.qc.alerts": "QC Alerts",
  "sideNav.label.qa.qc.controlLots": "QC Lot Management",
  "sideNav.label.qa.qc.ruleConfig": "Rule Configuration",
  "sideNav.label.qa.qc.reagentQc": "Reagent QC",
  "sideNav.label.qa.qc.manualQc": "Analyzer Manual QC",
  "sideNav.label.qa.qi": "Quality Indicators",
  "sideNav.label.qa.qi.dashboard": "QI Dashboard",
  "sideNav.label.qa.qi.config": "QI Configuration",
  "qa.qiConfig.subtitle": "Set per-indicator target and action thresholds, enable or disable indicators, and override thresholds for specific test sections.",
  "qa.qiConfig.column.overrides": "Overrides",
  "qa.qiConfig.field.enabled": "Track this indicator",
  "qa.qiConfig.field.target": "Target",
  "qa.qiConfig.field.action": "Action threshold",
  "qa.qiConfig.field.category": "Test section",
  "qa.qiConfig.editor.title": "Edit {indicator}",
  "qa.qiConfig.editor.defaults": "Default thresholds",
  "qa.qiConfig.editor.overrides": "Per-section overrides",
  "qa.qiConfig.editor.usesDefault": "Test sections without an override use the indicator default.",
  "qa.qiConfig.editor.noOverrides": "No overrides — every test section uses the default.",
  "qa.qiConfig.editor.addOverride": "Add section override",
  "qa.qiConfig.editor.autoNce": "When the month-to-date value breaches the action threshold, a non-conforming event is created automatically (one per indicator per month).",
  "qa.qiConfig.indicator.tat": "Average Turnaround Time",
  "qa.qiConfig.indicator.rejection": "Rejection Rate",
  "qa.qiConfig.indicator.amendment": "Amendment Rate",
  "qa.qiConfig.indicator.nce": "NCE Pulse",
  "qa.qiConfig.indicator.callback": "Critical Callback Compliance",
  "qa.qiConfig.validation.required": "Both target and action thresholds are required.",
  "qa.qiConfig.validation.range": "Thresholds must be between 0 and 100.",
  "qa.qiConfig.validation.direction": "Target and action threshold are in the wrong order for this indicator.",
  "qa.qiConfig.validation.category": "Choose a test section for each override.",
  "qa.qiConfig.validation.duplicateCategory": "A test section can only be overridden once.",
  "qa.qiConfig.confirmDisableTitle": "Disable this indicator?",
  "qa.qiConfig.confirmDisableBody": "This will hide the dashboard tile, suppress new alerts, and stop auto-generated NCEs for this indicator. Historical data is preserved. Continue?",
  "qa.qiConfig.saveFailed": "Could not save QI configuration.",
  "sideNav.label.qa.qms": "QMS & Improvement",
  "sideNav.label.qa.qms.esigLog": "Electronic Signature Log",
  "sideNav.label.qa.qms.capaRegister": "CAPA Register",
  "sideNav.label.qa.qms.accreditation": "Accreditation",
  "qa.qms.capaRegister.subtitle": "Every corrective and preventive action across all non-conforming events, with due dates and status.",
  "qa.qms.capaRegister.tile.dueThisWeek": "Due This Week",
  "qa.qms.capaRegister.tile.completed": "Completed (90d)",
  "qa.qms.capaRegister.filter.assignee": "Assignee",
  "qa.qms.capaRegister.filter.from": "Due Date (From)",
  "qa.qms.capaRegister.filter.to": "Due Date (To)",
  "qa.qms.capaRegister.column.correctiveAction": "Corrective / Preventive Action",
  "qa.qms.capaRegister.column.assignee": "Person Responsible",
  "qa.qms.capaRegister.status.open": "Open",
  "qa.qms.capaRegister.status.overdue": "Overdue",
  "qa.qms.capaRegister.status.completed": "Completed",
  "qa.qms.capaRegister.error": "The CAPA register could not be loaded.",
  "qa.qms.accreditation.title": "Test Accreditation",
  "qa.qms.accreditation.subtitle": "Accrediting bodies and per-test enrollment. Drives the accreditation logos on patient reports and the inspector-readiness answer.",
  "qa.qms.accreditation.error": "Accreditation data could not be loaded.",
  "qa.qms.accreditation.actionError": "The change could not be saved.",
  "qa.qms.accreditation.tile.total": "Bodies",
  "qa.qms.accreditation.inForce": "In force: {names}",
  "qa.qms.accreditation.bodies.title": "Accrediting Bodies",
  "qa.qms.accreditation.bodies.add": "Add body",
  "qa.qms.accreditation.body.column.logo": "Logo",
  "qa.qms.accreditation.body.column.expiresOn": "Expires",
  "qa.qms.accreditation.status.ACTIVE": "Active",
  "qa.qms.accreditation.status.EXPIRING": "Expiring soon",
  "qa.qms.accreditation.status.EXPIRED": "Expired",
  "qa.qms.accreditation.status.INACTIVE": "Inactive",
  "qa.qms.accreditation.body.modal.addTitle": "Add Accrediting Body",
  "qa.qms.accreditation.body.modal.editTitle": "Edit Accrediting Body",
  "qa.qms.accreditation.body.edit": "Edit body",
  "qa.qms.accreditation.body.delete": "Delete body",
  "qa.qms.accreditation.body.field.codeHelper": "2–16 characters: capitals, digits and hyphens. Cannot be changed later.",
  "qa.qms.accreditation.body.field.expiresOn": "Accreditation expires",
  "qa.qms.accreditation.body.field.visibilityMode": "Show the logo on a report when",
  "qa.qms.accreditation.visibility.ANY_ACCREDITED_TEST": "Any accredited test is on the report",
  "qa.qms.accreditation.visibility.PERCENTAGE": "A percentage of the report's tests are accredited",
  "qa.qms.accreditation.body.field.thresholdPct": "Threshold (%)",
  "qa.qms.accreditation.body.field.logo": "Logo (PNG or JPEG, at least 64×64 pixels, up to 500 KB)",
  "qa.qms.accreditation.body.logo.remove": "Remove logo",
  "qa.qms.accreditation.body.required": "Code, name and expiry date are required.",
  "qa.qms.accreditation.body.saveError": "The accrediting body could not be saved.",
  "qa.qms.accreditation.body.logoError": "The logo could not be uploaded. Use a PNG or JPEG of at least 64×64 pixels and no more than 500 KB.",
  "qa.qms.accreditation.body.delete.title": "Delete Accrediting Body",
  "qa.qms.accreditation.body.delete.body": "Delete {name}? This cannot be undone.",
  "qa.qms.accreditation.body.delete.blocked": "Cannot delete — {count} test accreditations reference this body. Remove them first.",
  "qa.qms.accreditation.enrollments.title": "Enrolled Tests",
  "qa.qms.accreditation.enrollments.add": "Enroll tests",
  "qa.qms.accreditation.enrollment.column.body": "Accrediting Body",
  "qa.qms.accreditation.enrollment.column.effectiveFrom": "Effective From",
  "qa.qms.accreditation.enrollment.column.expires": "Body Expires",
  "qa.qms.accreditation.enrollment.remove": "Remove enrollment",
  "qa.qms.accreditation.eqa.title": "EQA Coverage of Accredited Scope",
  "qa.qms.accreditation.eqa.subtitle": "ISO 15189 §7.7 asks whether every test you claim as accredited takes part in external quality assessment. This compares accredited scope against active EQA enrollments.",
  "qa.qms.accreditation.eqa.column.scope": "Tests in Scope",
  "qa.qms.accreditation.eqa.column.covered": "Covered by EQA",
  "qa.qms.accreditation.eqa.column.gaps": "Gaps",
  "qa.qms.accreditation.eqa.noGaps": "Full coverage",
  "qa.qms.accreditation.eqa.gapsMore": "{names} and {count} more",
  "qa.qms.accreditation.eqa.error": "EQA coverage could not be loaded.",
  "qa.qms.accreditation.filter.body": "Accrediting body",
  "qa.qms.accreditation.filter.test": "Test: {name}",
  "qa.qms.accreditation.enroll.modal.title": "Enroll Tests",
  "qa.qms.accreditation.enroll.field.effectiveFrom": "Effective from (optional)",
  "qa.qms.accreditation.enroll.required": "Select an accrediting body and at least one test.",
  "qa.qms.accreditation.enroll.failed": "The enrollment was rejected.",
  "qa.qms.accreditation.enrollment.delete.title": "Remove Enrollment",
  "qa.qms.accreditation.enrollment.delete.body": "Remove {test} from {body}?",
  "qa.qms.esigLog.search": "Search the log",
  "qa.qms.esigLog.subtitle": "Every electronic signature recorded in the system — who signed what, when, and why.",
  "qa.qms.esigLog.column.signer": "Signer",
  "qa.qms.esigLog.column.subject": "Subject",
  "qa.qms.esigLog.filter.subjectType": "Subject Type",
  "qa.qms.esigLog.filter.apply": "Apply Filters",
  "qa.qms.esigLog.export.confirm.title": "Export without filters?",
  "qa.qms.esigLog.export.confirm.body": "No filters are applied, so this exports every signature in the selected date range (up to 10,000 rows).",
  "qa.qms.esigLog.meaning.AUTHORED": "Authored",
  "qa.qms.esigLog.meaning.VALIDATED_AND_RELEASED": "Validated & Released",
  "qa.qms.esigLog.meaning.REJECTED": "Rejected",
  "qa.qms.esigLog.error": "Unable to load the signature log. Please try again.",
  "qa.qi.dashboard.subtitle": "Five quality indicators including the optional Critical Callback Compliance opt-in.",
  "qa.qi.dashboard.window.label": "Reporting window",
  "qa.qi.dashboard.window.7d": "Rolling 7 days",
  "qa.qi.dashboard.window.30d": "Rolling 30 days",
  "qa.qi.dashboard.window.90d": "Rolling 90 days",
  "qa.qi.dashboard.window.ytd": "Year to date",
  "qa.qi.dashboard.lastRecomputed": "Last recomputed: {time}",
  "qa.qi.dashboard.viewDetail": "View detail",
  "qa.qi.dashboard.tileInfo": "What does this tile measure?",
  "qa.qi.disabled.toast.title": "Indicator disabled",
  "qa.qi.disabled.toast.message": "This quality indicator is disabled in QI Configuration; its detail page is unavailable.",
  "qa.qi.dashboard.tile.tat.label": "Average TAT",
  "qa.qi.dashboard.tile.tat.tooltip": "Average turnaround time from sample receipt to result validation, across all completed test orders in the reporting window.",
  "qa.qi.dashboard.tile.tat.vsPriorDays": "vs prior {days} days",
  "qa.qi.dashboard.tile.tat.vsPriorPeriod": "vs prior period",
  "qa.qi.dashboard.tile.tat.secondary": "Across {count, plural, one {# lab unit} other {# lab units}} · Slowest: {unit} ({tat})",
  "qa.qi.dashboard.tile.tat.empty": "No completed test orders in this window.",
  "qa.qi.dashboard.tile.tat.error": "Turnaround data is unavailable.",
  "qa.qi.dashboard.tile.rejection.label": "Rejection Rate",
  "qa.qi.dashboard.tile.amendment.label": "Amendment Rate",
  "qa.qi.dashboard.tile.ncePulse.label": "NCE Pulse",
  "qa.qi.dashboard.tile.ncePulse.tooltip": "Critical non-conforming events not yet acknowledged, as of now. A current count, not a trend.",
  "qa.qi.dashboard.tile.ncePulse.criticalPending": "critical pending",
  "qa.qi.dashboard.tile.ncePulse.inCorrectiveAction": "{count} in corrective action",
  "qa.qi.dashboard.tile.ncePulse.error": "NCE data is unavailable.",
  "qa.qi.dashboard.tile.amendment.tooltip": "Results corrected after their patient report went out, as a share of results released in the reporting window.",
  "qa.qi.dashboard.tile.amendment.vsPriorDays": "vs prior {days} days",
  "qa.qi.dashboard.tile.amendment.vsPriorPeriod": "vs prior period",
  "qa.qi.dashboard.tile.amendment.secondary": "{amended} amended of {released} released",
  "qa.qi.dashboard.tile.amendment.empty": "No results released in this window.",
  "qa.qi.dashboard.tile.amendment.error": "Amendment data is unavailable.",
  "qa.qi.dashboard.tile.rejection.tooltip": "Tests rejected at results entry or validation, as a share of tests started in the reporting window.",
  "qa.qi.dashboard.tile.rejection.vsPriorDays": "vs prior {days} days",
  "qa.qi.dashboard.tile.rejection.vsPriorPeriod": "vs prior period",
  "qa.qi.dashboard.tile.rejection.secondary": "{rejected} rejected of {total} started",
  "qa.qi.dashboard.tile.rejection.empty": "No tests started in this window.",
  "qa.qi.dashboard.tile.rejection.error": "Rejection data is unavailable.",
  "qa.qi.dashboard.tile.thresholds": "Target {target} · action {action}",
  "qa.qi.amendment.title": "Amendment Rate — Detail",
  "qa.qi.amendment.subtitle": "Results corrected after their patient report went out.",
  "qa.qi.amendment.column.amendedAt": "Amended at",
  "qa.qi.amendment.column.priorValue": "Prior value",
  "qa.qi.amendment.column.currentValue": "Current value",
  "qa.qi.amendment.column.amendedBy": "Amended by",
  "qa.qi.amendment.column.releasedAt": "Released at",
  "qa.qi.amendment.column.timeToAmend": "Time to amend",
  "qa.qi.amendment.rate.label": "Amendment rate",
  "qa.qi.amendment.trend.empty": "No trend data in this window.",
  "qa.qi.amendment.breakdown.title": "By test",
  "qa.qi.amendment.breakdown.column.rate": "Rate",
  "qa.qi.rejection.title": "Rejection Rate — Detail",
  "qa.qi.rejection.subtitle": "Tests rejected at results entry, with the recorded rejection reason.",
  "qa.qi.rejection.column.rejectedAt": "Rejected at",
  "qa.qi.rejection.column.rejectedBy": "Rejected by",
  "qa.qi.rejection.heatmap.title": "Heatmap: ordering location × test section",
  "qa.qi.rejection.heatmap.section": "Test section",
  "qa.qi.rejection.heatmap.unknown": "Unknown location",
  "qa.qi.rejection.heatmap.unknownSection": "Unknown section",
  "qa.qi.rejection.heatmap.legend": "Cells colored by rate against the lab's thresholds: green ≤ {target}%, amber in between, red ≥ {action}%. Hover a cell for rejected / started counts.",
  "qa.qi.rejection.rate.label": "Rejection rate",
  "qa.qi.rejection.reasons.title": "By reason (Pareto)",
  "qa.qi.rejection.reasons.column.percent": "% of rejections",
  "qa.qi.rejection.reasons.column.cumulative": "Cumulative %",
  "qa.qi.rejection.reasons.donut.label": "Rejections",
  "qa.qi.rejection.reasons.insight": "Top {count} of {total} reasons account for {percent}% of rejections — addressing {reason} first has the biggest impact.",
  "qa.qi.rejection.breakdown.other": "Other ({count} tests)",
  "qa.qi.rejection.list.title": "Individual rejections",
  "qa.qi.amendment.list.title": "Individual amendments",
  "qa.qi.callback.button": "Log callback",
  "qa.qi.callback.banner.title": "Critical results need a clinician callback",
  "qa.qi.callback.banner.subtitle": "{count, plural, one {# saved critical result on this page has no callback logged — read-back required (TJC NPSG.02.03.01).} other {# saved critical results on this page have no callback logged — read-back required (TJC NPSG.02.03.01).}}",
  "qa.qi.callback.modal.title": "Log critical callback",
  "qa.qi.callback.field.recipientName": "Person notified",
  "qa.qi.callback.field.recipientName.placeholder": "Name of clinician or ward contacted",
  "qa.qi.callback.field.status": "Callback outcome",
  "qa.qi.callback.status.CONFIRMED": "Confirmed with read-back",
  "qa.qi.callback.status.REACHED_NO_READBACK": "Reached, no read-back",
  "qa.qi.callback.status.UNABLE_TO_REACH": "Unable to reach",
  "qa.qi.callback.save.success": "Callback logged",
  "qa.qi.callback.save.fail": "Failed to log callback",
  "qa.qi.callback.title": "Critical Callback Compliance — Detail",
  "qa.qi.callback.subtitle": "Released critical results and whether each was phoned to a clinician with read-back inside the callback target window.",
  "qa.qi.callback.distribution.title": "Time-to-acknowledge distribution",
  "qa.qi.callback.distribution.0-5": "0–5 min",
  "qa.qi.callback.distribution.5-15": "5–15 min",
  "qa.qi.callback.distribution.15-30": "15–30 min",
  "qa.qi.callback.distribution.30-60": "30–60 min",
  "qa.qi.callback.distribution.over60": "60+ min",
  "qa.qi.callback.distribution.noAck": "No ack",
  "qa.qi.callback.failures.title": "Failures ({count}) by reason",
  "qa.qi.callback.failures.overTarget": "Over target",
  "qa.qi.callback.failures.unableToReach": "Unable to reach",
  "qa.qi.callback.failures.noReadback": "No read-back recorded",
  "qa.qi.callback.failures.noCallback": "No callback recorded",
  "qa.qi.callback.list.title": "Critical results in window",
  "qa.qi.callback.rate.label": "Callback compliance (read-back within {minutes} min)",
  "qa.qi.callback.status.notLogged": "Not logged",
  "qa.qi.callback.column.status": "Callback status",
  "qa.qi.callback.column.timeToCallback": "Time to callback",
  "qa.qi.callback.column.loggedBy": "Logged by",
  "qa.qi.dashboard.tile.callback.label": "Critical Callback Compliance",
  "qa.qi.dashboard.tile.callback.tooltip": "Released critical results with a confirmed read-back callback within the lab's callback target window. Opt-in — enable in QI Configuration. Compliance is recomputed from current critical ranges.",
  "qa.qi.dashboard.tile.callback.secondary": "{confirmed} of {critical} critical results acknowledged within target",
  "qa.qi.dashboard.tile.callback.vsPriorDays": "vs prior {days} days",
  "qa.qi.dashboard.tile.callback.vsPriorPeriod": "vs prior period",
  "qa.qi.dashboard.tile.callback.empty": "No critical results in this window.",
  "qa.qi.dashboard.tile.callback.error": "Callback data is unavailable.",
  "qa.qi.dashboard.tile.callback.disabled": "Not enabled — turn on in QI Configuration.",
  "qa.empty.callback.title": "No critical results in this window",
  "qa.empty.callback.subhead": "Released critical results appear here with their callback documentation status.",
  "qa.overview.rejection.caption": "rejected at results entry (30d)",
  "qa.overview.rejection.ofStarted": "{rejected} of {total} started",
  "qa.overview.callback.caption": "critical read-back compliance (30d)",
  "qa.overview.callback.ofCritical": "{confirmed} of {critical} confirmed",
  "qa.overview.callback.none": "no critical results in window",
  "qa.overview.week.confirmedCount": "{count} confirmed",
  "qa.overview.amendment.caption": "amended after report (30d)",
  "qa.overview.amendment.ofReleased": "{amended} of {released} released",
  "qa.future.subtitle": "Future feature — design exists; build not yet scheduled.",
  "qa.future.questionLabel": "The question this feature answers",
  "qa.future.whyLabel": "Why it matters",
  "qa.future.readDesignDoc": "Read design doc on GitHub",
  "qa.future.reagentQc.question": "Has this reagent lot been verified before we use it on patients?",
  "qa.future.reagentQc.summary": "Per-lot QC frequency tracking. Before a new reagent lot is used clinically, the system requires documented verification samples comparing the new lot against the old lot or a peer-comparison reference.",
  "qa.future.reagentQc.why": "Without lot verification, a bad reagent lot can ruin a week of patient results before anyone notices. Most labs do this informally today; shipping it as a system feature catches the cases where the informal process fails.",
  "qa.future.manualQc.question": "Did the technician run a daily control on this instrument today, and did it pass?",
  "qa.future.manualQc.summary": "Daily PASS/FAIL log per instrument. Different instruments have different daily checks; the system holds them all to one shape: a daily PASS/FAIL log with a signer, a timestamp, and a block on instrument use if FAIL.",
  "qa.future.manualQc.why": "The first thing an inspector asks when they walk into a lab is 'show me your daily QC log for this instrument.' A signed log per instrument per day, every day. Forgetting it is what fails inspections.",
  "qa.overview.subtitle": "Daily snapshot for the QA Officer",
  "qa.overview.comingSoon": "Coming soon",
  "qa.overview.section.attention": "Attention Required",
  "qa.overview.section.thisWeek": "This Week",
  "qa.overview.section.pillars": "Pillar Status",
  "qa.overview.section.activity": "Recent Activity",
  "qa.overview.section.inspector": "Inspector readiness — five ISO 15189 quality questions",
  "qa.overview.attention.criticalNce": "Critical NCEs pending acknowledgment",
  "qa.overview.attention.criticalResults": "Critical results in last 24 hours",
  "qa.overview.attention.overdueCapas": "Overdue CAPAs",
  "qa.overview.attention.qcViolations": "QC violations in last 24 hours",
  "qa.overview.attention.effectivenessReview": "CAPA effectiveness reviews due",
  "qa.overview.attention.eqaDue": "EQA submissions due in next 14 days",
  "qa.overview.attention.nceSla": "NCEs nearing acknowledgment SLA",
  "qa.overview.tile.criticalCallback": "Critical Callback",
  "qa.overview.week.newNces": "New NCEs",
  "qa.overview.week.ncesResolved": "NCEs resolved",
  "qa.overview.week.capasCompleted": "CAPAs completed",
  "qa.overview.week.qcViolations": "QC violations",
  "qa.overview.week.criticalResults": "Critical results",
  "qa.overview.week.eqaSubmissions": "EQA submissions",
  "qa.overview.week.auditEntries": "Audit log entries",
  "qa.overview.week.signatureEvents": "Signature events",
  "qa.overview.inspector.q1": "Are runs in control?",
  "qa.overview.inspector.q2": "How did EQA perform last cycle?",
  "qa.overview.inspector.q3": "Are QIs on target?",
  "qa.overview.inspector.q4": "Open critical NCEs?",
  "qa.overview.inspector.q5": "Accreditation status?",
  "qa.overview.inspector.q1.answer": "{inControl} of {total} instruments in control (30d)",
  "qa.overview.inspector.q3.answer": "Avg TAT {tat} vs prior 30d",
  "qa.overview.inspector.q4.answer": "{count} critical NCEs pending acknowledgment",
  "qa.overview.inspector.q5.answer": "{active} of {total} in force, {expiring} expiring, {expired} expired",
  "qa.overview.inspector.q5.noData": "No accrediting bodies configured",
  "qa.overview.week.severityBreakdown": "{critical} critical · {major} major · {minor} minor",
  "qa.overview.week.overdueCount": "{count} overdue",
  "qa.overview.week.currentlyOpen": "currently open",
  "qa.overview.pillar.qc.text": "{inControl} of {total} instruments in control",
  "qa.overview.pillar.qc.noData": "No QC data yet",
  "qa.overview.pillar.qi.text": "Avg TAT {tat}",
  "qa.overview.pillar.qi.noData": "No TAT data yet",
  "qa.overview.pillar.qi.disabled": "Not currently tracked",
  "qa.overview.pillar.qms.text": "{critical} critical pending · {capa} in corrective action",
  "qa.overview.activity.viewAudit": "View full audit trail",
  "qa.overview.activity.empty": "No activity in the last 24 hours",
  "qa.empty.activity.subhead": "Attested actions across all pillars appear here as they happen.",
  "qa.empty.attention.title": "Nothing needs attention right now",
  "qa.empty.attention.subhead": "Critical NCEs, overdue CAPAs, and QC violations surface here when they occur.",
  "qa.empty.amendment.title": "No amendments in this window",
  "qa.empty.amendment.subhead": "Amendments appear here when a released result is corrected.",
  "qa.empty.rejection.title": "No rejections in this window",
  "qa.empty.rejection.subhead": "Rejections appear here when a test is rejected at results entry or validation.",
  "qa.empty.capaRegister.title": "No CAPAs match these filters",
  "qa.empty.capaRegister.subhead": "Corrective and preventive actions appear here as they are recorded against non-conforming events.",
  "qa.empty.accreditation.bodies.title": "No accrediting bodies yet",
  "qa.empty.accreditation.bodies.subhead": "Add the bodies that accredit this laboratory to start tracking per-test accreditation.",
  "qa.empty.accreditation.enrollments.title": "No enrollments match these filters",
  "qa.empty.accreditation.enrollments.subhead": "Enroll tests under an accrediting body to show its logo on patient reports.",
  "qa.empty.accreditation.eqa.title": "Nothing to compare yet",
  "qa.empty.accreditation.eqa.subhead": "Once tests are enrolled under an accrediting body, their EQA coverage is compared here.",
  "qa.empty.esigLog.title": "No signatures in this window",
  "qa.empty.esigLog.subhead": "Signatures appear here as results are authored and validated. Try a wider date range or fewer filters.",
  "qa.empty.tat.title": "No results in this window",
  "qa.empty.tat.subhead": "Turnaround times appear here as test orders are completed and validated. Try a different date range.",
  "qa.empty.sparse.labUnits": "{count, plural, one {# lab unit} other {# lab units}} this period",
  "qa.overview.activity.yesterday": "Yesterday {time}",
  "qa.overview.activity.esig": "{actor} {meaning} {record}",
  "qa.overview.activity.meaning.AUTHORED": "authored results for",
  "qa.overview.activity.meaning.VALIDATED_AND_RELEASED": "validated & released",
  "qa.overview.activity.meaning.REJECTED": "rejected",
  "qa.overview.activity.qc": "QC alert: {rule} ({severity}) on {instrument}",
  "qa.overview.activity.nce.CREATED": "{actor} reported {nce}",
  "qa.overview.activity.nce.ACKNOWLEDGED": "{actor} acknowledged {nce}",
  "qa.overview.activity.nce.ASSIGNED": "{actor} assigned {nce}",
  "qa.overview.activity.nce.NOTE_ADDED": "{actor} added a note to {nce}",
  "qa.overview.activity.nce.STATUS_CHANGED": "{actor} updated the status of {nce}",
  "qa.overview.activity.nce.CORRECTIVE_ACTION": "{actor} updated corrective action on {nce}",
  "qa.overview.activity.nce.RESOLVED": "{actor} resolved {nce}",
  "qa.overview.activity.nce.UPDATED": "{actor} updated {nce}",
  "sidenav.title.statusreport": "Patient Status Report",
  "systemAudit.filter.startDate": "Start Date",
  "systemAudit.filter.endDate": "End Date",
  "systemAudit.filter.entityType": "Entity Type",
  "systemAudit.filter.action": "Action",
  "systemAudit.filter.search": "Search",
  "systemAudit.filter.export": "Export CSV",
  "systemAudit.table.heading.time": "Time",
  "systemAudit.table.heading.entityType": "Entity Type",
  "systemAudit.table.heading.entityId": "Entity ID",
  "systemAudit.table.heading.action": "Action",
  "systemAudit.table.heading.user": "User",
  "systemAudit.table.heading.changes": "Changes",
  "systemAudit.noResults": "No system events found for the given filters.",
  "systemAudit.filter.all": "All",
  "systemAudit.filter.user": "User",
  "systemAudit.filter.searchText": "Search",
  "systemAudit.filter.searchText.placeholder": "Search by entity ID...",
  "systemAudit.filter.exportPdf": "Export PDF",
  "systemAudit.filter.selectedPatient": "Selected Patient",
  "systemAudit.filter.selectedPatient.none": "None",
  "systemAudit.filter.selectPatient": "Select Patient",
  "systemAudit.filter.selectAnotherPatient": "Select Another Patient",
  "systemAudit.action.insert": "Insert",
  "systemAudit.action.update": "Update",
  "systemAudit.action.delete": "Delete",
  "site.branding.cancel": "Cancel",
  "site.branding.color.format.error": "Invalid color format. Please use a valid CSS color (e.g., #0f62fe)",
  "site.branding.color.hex.label": "Hex Color Code",
  "site.branding.colorPicker.helperText": "Enter any CSS color (e.g., #0f62fe, blue, rgb(15, 98, 254))",
  "site.branding.colorPicker.placeholder": "#0f62fe or blue",
  "site.branding.confirm.remove": "Remove Logo",
  "site.branding.confirm.remove.message": "Are you sure you want to remove this logo and revert to the default OpenELIS logo?",
  "site.branding.current.logo": "Current Logo",
  "site.branding.description": "Customize your organization's visual branding including logos and colors",
  "site.branding.error.remove": "Error removing logo file.",
  "site.branding.favicon": "Favicon",
  "site.branding.favicon.description": "Icon displayed in browser tabs and bookmarks",
  "site.branding.file.format.error": "Unsupported file format. Please use PNG, SVG, or JPG/JPEG",
  "site.branding.file.pending": "File selected - click Save Changes to upload",
  "site.branding.file.size.error": "File size exceeds 2MB limit",
  "site.branding.formats": "Formats: PNG, SVG, JPG (max 2MB)",
  "site.branding.header.color": "Header Color",
  "site.branding.header.color.description": "Background color for the application header bar",
  "site.branding.header.logo": "Header Logo",
  "site.branding.header.logo.description": "Logo displayed in the top-left of the application header",
  "site.branding.login.logo": "Login Page Logo",
  "site.branding.login.logo.description": "Logo displayed on the login page",
  "site.branding.login.using.header.logo": "Using header logo for login page",
  "site.branding.logo.upload.success": "Logo uploaded successfully",
  "site.branding.no.logo": "No custom logo (using default)",
  "site.branding.preview": "Preview",
  "site.branding.primary.color": "Primary Color",
  "site.branding.primary.color.description": "Color for primary buttons, active menu items, and links",
  "site.branding.remove.favicon": "Remove Favicon",
  "site.branding.remove.header.logo": "Remove Header Logo",
  "site.branding.remove.login.logo": "Remove Login Logo",
  "site.branding.remove.logo": "Remove Logo",
  "site.branding.reset.confirmation": "Are you sure you want to reset all branding to OpenELIS defaults? This will remove all custom logos and colors.",
  "site.branding.reset.error": "Error resetting branding to defaults.",
  "site.branding.reset.success": "Branding reset to default values successfully.",
  "site.branding.reset.to.defaults": "Reset to Default Branding",
  "site.branding.save": "Save Changes",
  "site.branding.save.error": "Error saving branding configuration",
  "site.branding.save.success": "Branding configuration saved successfully",
  "site.branding.secondary.color": "Secondary Color",
  "site.branding.secondary.color.description": "Color for secondary buttons, borders, and inactive states",
  "site.branding.section.colors": "Colors",
  "site.branding.section.logos": "Logos",
  "site.branding.title": "Site Branding",
  "site.branding.unsaved.changes": "You have unsaved changes. Do you want to save, discard, or cancel?",
  "site.branding.unsaved.changes.warning": "You have unsaved changes. Click Save to apply them.",
  "site.branding.upload.favicon": "Upload Favicon",
  "site.branding.upload.header.logo": "Upload Header Logo",
  "site.branding.upload.login.logo": "Upload Login Logo",
  "site.branding.upload.logo": "Upload Logo",
  "site.branding.use.header.logo.for.login": "Use same logo as header",
  "siteInfo.description.default.barcode": "Indicate the default number of bar code labels which should be printed with every order and specimen.",
  "siteInfo.description.dimensions": "Indicate the dimensions that bar code labels should conform to when printing.",
  "siteInfo.description.elements": "Check the box next to the optional elements that should appear on theorder and sample bar code labels.",
  "siteInfo.description.max.barcode": "Indicate the maximum number of bar code labels that can be printed for each order or specimen. Once the maximum has been reached, a user will be unable to print additional labels.",
  "siteInfo.elements.mandatory": "Mandatory Elements",
  "siteInfo.elements.optional": "Optional Elements",
  "siteInfo.section.altAccession": "Preprinted Bar Code Accession number",
  "siteInfo.section.elements": "Bar Code Label Elements",
  "siteInfo.section.number": "Number Bar Code Label",
  "siteInfo.section.size": "Dimensions Bar Code Label",
  "siteInfo.title.default.barcode": "Default Bar Code Labels",
  "siteInfo.title.default.barcode.block": "Block",
  "siteInfo.title.default.barcode.height": "Height",
  "siteInfo.title.default.barcode.order": "Order",
  "siteInfo.title.default.barcode.order.none": "None",
  "siteInfo.title.default.barcode.slide": "Slide",
  "siteInfo.title.default.barcode.specimen": "Specimen",
  "siteInfo.title.default.barcode.freezer": "Freezer",
  "siteInfo.title.default.barcode.width": "Width",
  "siteInfo.title.max.barcode": "Maximum Bar Code Labels",
  "started.date": "Started Date",
  "status": "Status",
  "status.in.progress": "In Progress",
  "status.unknown": "Unknown",
  "stillThere.message": "User session is about to time out. Click anywhere to stay logged in.",
  "stillThere.title": "Still There?",
  "stock.available": "Available",
  "stock.level": "Stock Level",
  "stock.status": "Stock Status",
  "stock.status.expired": "Expired",
  "stock.status.expiring": "Expiring",
  "stock.status.expiringIn": "Expiring ({days}d)",
  "stock.status.inStock": "In Stock",
  "stock.status.lowStock": "Low Stock",
  "stock.status.outOfStock": "Out of Stock",
  "storage.active": "Active",
  "storage.add.device": "Add Device",
  "storage.add.location": "Location",
  "storage.add.location.option": "Add Location...",
  "storage.add.new.device": "Add new device",
  "storage.add.rack": "Add Rack",
  "storage.add.box": "Add Box",
  "storage.add.room": "Add Room",
  "storage.add.shelf": "Add Shelf",
  "storage.allAssigned.title": "All Samples Assigned",
  "storage.assign.button": "Assign Location",
  "storage.assign.title": "Assign Storage Location",
  "storage.assigned": "Assigned",
  "storage.assigned.by": "Assigned By",
  "storage.assigned.date": "Assigned Date",
  "storage.barcode.scan.placeholder": "Scan barcode or enter manually",
  "storage.bulk.move.auto.assigned": "Auto-assigned positions (editable)",
  "storage.bulk.move.preview": "Bulk Move Preview",
  "storage.cannotDelete.hasAssignments": "Cannot delete {entityType} \"{name}\": has {count} assigned sample(s)",
  "storage.cannotDelete.hasChildren": "Cannot delete {entityType} \"{name}\": contains {count} {childType}(s)",
  "storage.capacity.calculated": "Calculated",
  "storage.capacity.manual": "Manual Limit",
  "storage.capacity.undetermined.tooltip": "Capacity cannot be calculated: some child locations lack defined capacities",
  "storage.capacity.warning": "{location} is {percentage}% full. Consider using alternative storage.",
  "storage.code.change.acknowledge": "I understand and want to proceed with the code change",
  "storage.code.change.warning": "Warning",
  "storage.code.change.warning.message": "Changing the code will invalidate any previously printed labels for this location.",
  "storage.confirm.add.device": "Do you want to create a new device \"{name}\"?",
  "storage.conditionNotes": "Condition Notes",
  "storage.conditionNotes.placeholder": "Enter any notes about storage conditions...",
  "storage.confirm.delete": "Confirm Delete",
  "storage.create.room.error": "Failed to create room: {error}",
  "storage.create.room.success": "Room \"{name}\" created successfully",
  "storage.current.location": "Current Location",
  "storage.currentLocation": "Current Location",
  "storage.delete.admin.only": "Only Global Administrators can delete locations",
  "storage.delete.are.you.sure": "Are you sure you want to delete",
  "storage.delete.cannot.be.undone": "This action cannot be undone.",
  "storage.delete.cascade.confirm": "Confirm Cascade Delete",
  "storage.delete.cascade.confirmation.checkbox": "I confirm that I want to delete this location and all its child locations. All samples will be unassigned. This action cannot be undone.",
  "storage.delete.cascade.summary": "This will delete {childCount} {childType}(s) and unassign {sampleCount} sample(s). Are you sure you want to proceed?",
  "storage.delete.cascade.warning": "Cascade Delete Warning",
  "storage.delete.checking": "Checking constraints...",
  "storage.delete.confirmation.checkbox": "I confirm that I want to delete this location. This action cannot be undone.",
  "storage.delete.constraints.title": "Cannot Delete",
  "storage.delete.device": "Delete Device",
  "storage.delete.error": "Failed to delete location",
  "storage.delete.location": "Delete Location",
  "storage.delete.rack": "Delete Rack",
  "storage.delete.room": "Delete Room",
  "storage.delete.shelf": "Delete Shelf",
  "storage.device.code": "Code",
  "storage.device.communicationProtocol": "Communication Protocol",
  "storage.device.communicationProtocol.helper": "Protocol used for device communication (e.g., BACnet)",
  "storage.device.ipAddress": "IP Address",
  "storage.device.ipAddress.helper": "IPv4 or IPv6 address for network-connected equipment",
  "storage.device.label": "Device",
  "storage.device.name": "Name",
  "storage.device.placeholder": "Select or type to create device...",
  "storage.device.port": "Port",
  "storage.device.port.helper": "Port number (1-65535) for communication",
  "storage.device.room": "Room",
  "storage.device.type": "Type",
  "storage.edit.device": "Edit Device",
  "storage.edit.error.loadLocation": "Failed to load location",
  "storage.edit.error.saveFailed": "Save failed",
  "storage.edit.error.saveHttp": "Save failed (HTTP {status})",
  "storage.edit.rack": "Edit Rack",
  "storage.edit.room": "Edit Room",
  "storage.edit.shelf": "Edit Shelf",
  "storage.edit.selectParent": "Select {parent}",
  "storage.editbox.error.loadBox": "Failed to load box",
  "storage.editbox.selectRack": "Select rack",
  "storage.box.capacity": "Capacity",
  "storage.box.gridSize": "Grid size",
  "storage.box.rows": "Rows",
  "storage.box.columns": "Columns",
  "storage.box.preset": "Dimension preset",
  "storage.box.preset.select": "Select dimensions",
  "storage.error.location.inactive": "Cannot assign to inactive location",
  "storage.error.name.duplicate": "A {entityType} with this name already exists in the selected parent location",
  "storage.error.position.occupied": "Position is already occupied",
  "storage.expanded.capacityLimit": "Capacity Limit",
  "storage.expanded.createdBy": "Created By",
  "storage.expanded.createdDate": "Created Date",
  "storage.expanded.description": "Description",
  "storage.expanded.lastModifiedBy": "Last Modified By",
  "storage.expanded.lastModifiedDate": "Last Modified Date",
  "storage.expanded.notAvailable": "N/A",
  "storage.expanded.positionSchemaHint": "Position Schema Hint",
  "storage.expanded.temperatureSetting": "Temperature Setting",
  "storage.filter.by.locations": "Filter by locations",
  "storage.filter.by.locations.placeholder": "Filter by locations...",
  "storage.filter.device": "Filter by Device",
  "storage.filter.room": "Filter by Room",
  "storage.filter.status": "Filter by Status",
  "storage.hierarchical.path": "Location Path",
  "storage.inline.add.device": "Add New Device",
  "storage.inline.add.rack": "Add New Rack",
  "storage.inline.add.room": "Add New Room",
  "storage.inline.add.shelf": "Add New Shelf",
  "storage.location": "Location",
  "storage.location.active": "Active",
  "storage.location.add.button": "Add Location",
  "storage.location.add.title": "Add Storage Location",
  "storage.location.current": "Storage location",
  "storage.location.code": "Code",
  "storage.location.code.helper": "Max 10 characters, alphanumeric with hyphens/underscores",
  "storage.location.description": "Description",
  "storage.location.label": "Storage Location",
  "storage.location.name": "Location Name",
  "storage.location.skipped": "Storage Skipped",
  "storage.location.tempMax": "Max Temperature",
  "storage.location.tempMin": "Min Temperature",
  "storage.location.type": "Location Type",
  "storage.location.unassigned": "Unassigned",
  "storage.location.notAssigned": "Not assigned",
  "storage.location.move": "Move storage location",
  "storage.location.assign": "Assign storage location",
  "storage.manageLocation.error.saveFailed": "Save failed",
  "storage.manageLocation.error.selectTarget": "Select a device, shelf, rack, or box before saving",
  "storage.nav.box": "Box",
  "storage.nav.device": "Device",
  "storage.nav.room": "Room",
  "storage.nav.shelf": "Shelf",
  "storage.picker.currentLocation": "Current location",
  "storage.picker.heading.assignLocation": "Assign Storage Location",
  "storage.picker.heading.move": "Move Item",
  "storage.picker.newLocation": "New location",
  "storage.picker.notes": "Notes",
  "storage.picker.orBrowse": "Or pick level by level",
  "storage.picker.position.optional": "Position (optional)",
  "storage.picker.select": "Select {level}",
  "storage.picker.selectDeviceType": "Select device type",
  "storage.picker.addNewLevel": "Add new {level}",
  "storage.picker.inlineCreate.heading": "Create new {level}",
  "storage.picker.inlineCreate.error.title": "Could not create location",
  "storage.picker.inlineCreate.error": "Failed to create location",
  "storage.picker.occupant.identifier": "Identifier",
  "storage.picker.occupant.heading": "Item",
  "storage.picker.occupant.status": "Status",
  "storage.picker.occupant.type": "Type",
  "storage.picker.storageLocation": "Storage location",
  "storage.metrics.active": "Active",
  "storage.metrics.disposed": "Disposed",
  "storage.metrics.total.samples": "Total Sample Items",
  "storage.mode.autocomplete": "Type-Ahead Search",
  "storage.mode.barcode": "Barcode Scan",
  "storage.mode.cascading": "Cascading Dropdowns",
  "storage.move.button": "Move Sample",
  "storage.move.reason.label": "Reason for Move",
  "storage.nav.boxes": "Boxes",
  "storage.nav.boxes.tooltip": "Manage storage boxes",
  "storage.nav.dashboard": "Storage Dashboard",
  "storage.nav.devices": "Devices",
  "storage.nav.devices.tooltip": "Manage storage devices",
  "storage.nav.locations": "Locations",
  "storage.nav.locations.tooltip": "Manage storage locations",
  "storage.nav.racks": "Racks",
  "storage.nav.racks.tooltip": "Manage storage racks",
  "storage.nav.rooms": "Rooms",
  "storage.nav.rooms.tooltip": "Manage storage rooms",
  "storage.nav.sample.items": "Sample Items",
  "storage.nav.sample.items.tooltip": "View and manage stored samples",
  "storage.nav.samples": "Sample Items",
  "storage.nav.samples.tooltip": "View and manage stored samples",
  "storage.nav.shelves": "Shelves",
  "storage.nav.shelves.tooltip": "Manage storage shelves",
  "storage.no.data": "No data available",
  "storage.occupancy": "Occupancy",
  "storage.position.label": "Position",
  "storage.rack.device": "Device",
  "storage.rack.dimensions": "Dimensions",
  "storage.rack.label": "Rack",
  "storage.rack.placeholder": "Select or type to create rack...",
  "storage.rack.room": "Room",
  "storage.rack.shelf": "Shelf",
  "storage.room.code": "Code",
  "storage.room.devices": "Devices",
  "storage.room.label": "Room",
  "storage.room.name": "Name",
  "storage.room.placeholder": "Select or type to create room...",
  "storage.room.samples": "Samples",
  "storage.sampleitem.id": "SampleItem ID",
  "storage.search.boxes.placeholder": "Search boxes by label or code...",
  "storage.search.devices.placeholder": "Search by device name or code...",
  "storage.search.location.minLength": "Keep typing, at least 2 characters",
  "storage.search.location.searching": "Searching...",
  "storage.search.location.error": "Could not search locations. Please try again.",
  "storage.search.location.noResults": "No storage locations match \"{query}\"",
  "storage.search.placeholder": "Search by sample ID or location...",
  "storage.search.racks.placeholder": "Search by rack label...",
  "storage.search.rooms.placeholder": "Search by room name or code...",
  "storage.search.lots.placeholder": "Search by lot number, barcode, item or location...",
  "storage.search.samples.placeholder": "Search by sample ID or location...",
  "storage.search.shelves.placeholder": "Search by shelf label...",
  "storage.select.location": "Select Location",
  "storage.selectSample": "Select Sample",
  "storage.shelf.device": "Device",
  "storage.shelf.label": "Shelf",
  "storage.shelf.placeholder": "Select or type to create shelf...",
  "storage.shelf.room": "Room",
  "storage.status": "Status",
  "storage.status.disposed": "Disposed",
  "storage.success.assigned": "Sample assigned to storage location successfully",
  "storage.success.moved": "Sample moved to new location successfully",
  "storage.tab.ariaLabel": "Storage management tabs",
  "storage.tab.dashboard": "Dashboard",
  "storage.tab.inventoryLots": "Inventory Lots",
  "storage.tab.samples": "Sample Items",
  "storage.target.location": "Target Location",
  "storage.unassigned.title": "Unassigned Samples",
  "storage.skipAssignment": "No storage required - samples will be processed immediately",
  "success.add.edited.msg": "Successfully Added/Edited",
  "success.delete.msg": "Successfully Deleted",
  "success.import.patient": "Patient Successfully Imported",
  "success.report.status": "Successfully Generated Report",
  "success.save.msg": "Successfully saved",
  "success.save.patient": "Patient Saved Successfully",
  "systemuser.firstName": "System User First Name",
  "systemuser.isActive": "Is Active",
  "systemuser.lastName": "System User Last Name",
  "systemuser.loginName": "System User Login Name",
  "systemuser.role": "Roles",
  "systemuserrole.apply": "Apply",
  "systemuserrole.allLabUnits.confirm.body": "Switching this row to All Lab Units removes these lab unit permissions. The All Lab Units row starts with no permissions ticked.",
  "systemuserrole.allLabUnits.confirm.noPermissions": "no permissions ticked",
  "systemuserrole.allLabUnits.confirm.primary": "Replace permissions",
  "systemuserrole.allLabUnits.confirm.title": "Replace lab unit permissions?",
  "systemuserrole.allLabUnits.exclusive.error": "All Lab Units cannot be combined with individual lab units. Nothing was saved.",
  "systemuserrole.allLabUnits.exclusive.info": "All Lab Units cannot be combined with individual lab units: selecting it replaces every lab-unit-specific permission.",
  "systemuserrole.copypermissions": "Copy Permisions From User",
  "systemuserrole.copypermissions.placeholder": "Copy Users Permisions",
  "systemuserrole.instruction.1": "There are two types of Roles. Global Roles which are set for the entire application and Lab Unit Roles which can be set for all Lab Units or specific Lab Units.",
  "systemuserrole.instruction.2": "The available Global Roles are: GLobal Administrator (Acces to all Admin Functions) ,Audit Trail (Access to all Audit Trail), User Account Administrator (has acces to all the user account administration features ,but not any other admin functions).",
  "systemuserrole.instruction.3": "The Lab Unit Roles are: Reception (Access to the Order, Patient, and Non-Conformity Tabs) ,Results (Access to the Work Plan, Non-Conformity, and Results Tabs) ,Validation (Access to the Validation and Non-Conformity Tabs), Reports (Acces to Reports Tab except CSV export only Availbale for Global Administrators).",
  "systemuserrole.instruction.4": "To assign Lab Unit Roles ,select all lab units or the specific lab unit from the drop down and select any roles you would like to set.",
  "systemuserrole.instruction.5": "You can also use the Copy Permisions Feature to copy the permisions of an existing user.Ensure that you have filled all the information above and enter the user name whose permissions you want to copy into the box and click apply.",
  "systemuserrole.newpermissions": "Add New Permission",
  "systemuserrole.rmpermissions": "Remove Permission",
  "systemuserrole.roles.global": "Global Roles",
  "systemuserrole.roles.labunit": "Lab Unit Roles",
  "test.add.copy.name": "Copy from Test Name",
  "test.antimicrobialResistance": "Antimicrobial Resistance",
  "test.description.active": "If the test is active it can be ordered on the order form or as part of a test algorithm.If it is not active it can not be ordered or be part of a test algorithm",
  "test.description.name": "The name of the test as it will appear within openELIS. Both English and French are required",
  "test.description.orderable": "If a test is active and orderable then it can be ordered on an order form. If it is active but not orderable then it will only be done if it is reflexed from another test",
  "test.description.panel": "If this test is part of a test panel then the panel can be added here.It is possible, but not usual, for a test to be in more then one panel",
  "test.description.reportName": "The name of the test as it will appear in reports. Both English and French are required.If the Name and reporting name are the same click on the button to copy the name",
  "test.description.testSection": "The test section in which the test will be done",
  "test.description.uom": "Unit of measure for the test. This usually only applies to numeric or alphanumeric result types",
  "test.field.active": "Active",
  "test.field.orderable": "Orderable",
  "test.inLabOnly": "In Lab Only",
  "test.modify.en": "en",
  "test.modify.fr": "fr",
  "test.modify.header.modify": "Please Select Test to Modify!",
  "test.modify.header.test": "Test",
  "test.name": "Test Name",
  "test.notifyResults": "Notify Patient Of Results",
  "test.section": "Test Section",
  "test.section.label": "Test Section",
  "test.show.guide": "Show Guide",
  "testcalculation.label.calculation": "Calculation",
  "testcalculation.label.finalresult": "Final Result",
  "testcalculation.label.insertOperation": "Insert Operation",
  "testcalculation.label.integer": "Integer",
  "testcalculation.label.mathFucntion": "Mathematical Function",
  "testcalculation.label.name": "Calculation Name",
  "testcalculation.label.patientAttribute": "Patient Attribute",
  "testcalculation.label.searchNumericTest": "Search Numeric Test",
  "testcalculation.label.selectDictionaryValue": "Select Dictionary Value",
  "testcalculation.label.testResult": "Test Result",
  "testcalculation.label.textValue": "Text Value",
  "testCatalog.header.ageRange": "Age Range",
  "testCatalog.header.criticalRange": "Critical Range",
  "testCatalog.header.field": "Field",
  "testCatalog.header.gender": "Sex",
  "testCatalog.header.normalRange": "Normal Range",
  "testCatalog.header.reportingRange": "Reporting Range",
  "testCatalog.header.validRange": "Valid Range",
  "testCatalog.header.value": "Value",
  "admin.testCatalog.methods.title": "Methods",
  "admin.testCatalog.methods.column.name": "Method Name",
  "admin.testCatalog.methods.column.code": "Code",
  "admin.testCatalog.methods.column.default": "Default",
  "admin.testCatalog.methods.column.effectiveDate": "Effective Date",
  "admin.testCatalog.methods.column.actions": "Actions",
  "admin.testCatalog.methods.action.edit": "Edit",
  "admin.testCatalog.methods.action.remove": "Remove",
  "admin.testCatalog.methods.btn.linkMethod": "+ Link Method",
  "admin.testCatalog.methods.btn.createMethod": "+ Create New Method",
  "admin.testCatalog.methods.btn.copyFromTest": "Copy from Test",
  "admin.testCatalog.methods.modal.link.title": "Link Method",
  "admin.testCatalog.methods.modal.link.selectPlaceholder": "Select a method to link",
  "admin.testCatalog.methods.modal.link.noAvailable": "All active methods are already linked",
  "admin.testCatalog.methods.inline.nameEnglish": "Method Name (English)",
  "admin.testCatalog.methods.inline.nameFrench": "Method Name (French)",
  "admin.testCatalog.methods.inline.code": "Shortcode",
  "admin.testCatalog.methods.inline.codeHint": "3–10 uppercase alphanumeric characters, no spaces",
  "admin.testCatalog.methods.inline.createAndLink": "Create & Link",
  "admin.testCatalog.methods.copyFromTest.label": "Copy methods from test",
  "admin.testCatalog.methods.copyFromTest.placeholder": "Select source test",
  "admin.testCatalog.methods.effectiveDate.label": "Effective Date",
  "admin.testCatalog.methods.default.label": "Set as default",
  "admin.testCatalog.methods.error.duplicateLink": "This method is already linked to the test",
  "admin.testCatalog.methods.error.codeFormat": "Code must be 3–10 uppercase alphanumeric characters with no spaces",
  "admin.testCatalog.methods.error.effectiveDateRequired": "Effective date is required",
  "admin.testCatalog.methods.error.duplicateCode": "A method with this code already exists. Enter a different code.",
  "admin.testCatalog.methods.error.duplicateName": "A method with this name already exists. Use a different name, or link the existing method.",
  "admin.testCatalog.methods.error.invalidRequest": "The request was refused. Check the fields and try again.",
  "admin.testCatalog.methods.error.server": "The server could not complete the request. Try again.",
  "admin.testCatalog.methods.error.removeFailed": "The method could not be removed. It is still linked; try again.",
  "admin.testCatalog.methods.linked": "Method linked.",
  "admin.testCatalog.methods.created": "Method created and linked.",
  "admin.testCatalog.methods.copied": "From {source}: {count, plural, one {# method} other {# methods}} copied.",
  "admin.testCatalog.methods.copyNothing": "No methods copied: {source} has no methods that are not already linked to this test.",
  "admin.testCatalog.methods.empty": "No methods linked. Use '+ Link Method' or '+ Create New Method' to add one.",
  "testnotification.bcc": "BCC",
  "testnotification.instructionis.variables.body": "[testName] : Name of the test this is for",
  "testnotification.instructionis.variables.body.0": "[testResult] : Result of the test",
  "testnotification.instructionis.variables.header": "List of variables:",
  "testnotification.instructions.body": "When a notification is created, it will first check if a message template is defined for the recipient/message type.",
  "testnotification.instructions.body.0": "If none exists, it will use the test default message.",
  "testnotification.instructions.body.1": "If that does not exist, it will use the system default message.",
  "testnotification.instructions.body.2": "Variables will be replaced by their corresponding values in the message body and the subject.",
  "testnotification.instructions.body.3": "Variables should always include the square brackets and should have no whitespace.",
  "testnotification.instructions.header": "Instructions:",
  "testnotification.messagetemplate": "Message",
  "testnotification.options": "Individiual Messages",
  "testnotification.patient.email": "Patient Email",
  "testnotification.patient.sms": "Patient SMS",
  "testnotification.patiententry.header": "Result Reporting",
  "testnotification.patiententry.info": "If OpenELIS is not able to connect to the recipient of the transmitted results it will queue them up. A large and growing queue is a sign that troubleshooting should be done including contacting the receiving party.",
  "testnotification.provider.email": "Provider Email",
  "testnotification.provider.sms": "Provider SMS",
  "testnotification.subjecttemplate": "Subject",
  "testnotification.systemdefault.template": "System Default Message",
  "testnotification.testdefault.editIcon": "Edit Test Notification",
  "testnotification.testdefault.template": "Default Message for Test",
  "testnotificationconfig.browse.title": "Test Notification Configuration",
  "tests.not.assigned": "Tests not assigned",
  "testsection.testSectionName": "Test Section Name",
  "testUnit.existing": "Existing Test Units",
  "testUnit.existing.inactive": "Inactive Test Units.  Assign tests to activate.",
  "testUnit.new": "New Unit Test",
  "text.length.max": "Text length Should not be greater than 200",
  "title.notestfoundmatching": "No test Found Matching",
  "to.title": "To",
  "tooltip.banner.menu.generic.sample.results": "Enter test results for generic samples",
  "tooltip.banner.menu.workplan.batch": "Batch Workplan",
  "total.quantity": "Total Quantity",
  "transaction.date": "Date",
  "transaction.quantity": "Quantity",
  "transaction.type": "Type",
  "transaction.user": "User",
  "true.label": "True",
  "unifiedSystemUser.add.user": "Add User",
  "unifiedSystemUser.browser.button.add": "Add New user",
  "unifiedSystemUser.browser.search": "Search By User Names",
  "unifiedSystemUser.browser.search.placeholder": "Search By User Names...",
  "unifiedSystemUser.browser.title": "User Management",
  "unifiedSystemUser.edit.user": "Modify User",
  "unifiedSystemUser.select": "Select",
  "unknown.section": "Unknown Section",
  "unknown.test": "Unknown Test",
  "uom.browse.title": "Unit Of Measure",
  "uom.create.heading.confirmation": "Confirmation",
  "uom.existing": "Current Unit of Measure",
  "uom.existing.inactive": "Inactive Unit of Measure. Assign tests to this Unit of Measure to activate it.",
  "uom.new": "Create a new Unit of Measure",
  "uom.new.added": "New Unit of Measure will get added",
  "uom.notification.duplicate": "Unit of Measure already exists",
  "uom.notification.save": "New Unit Of Measure has been saved.",
  "uom.uomName": "Unit Of Measure Name",
  "training.installation.message": "Training Installation",
  "translation.edit.title": "Edit Translations",
  "translation.export": "Export CSV",
  "translation.export.success": "Translations exported successfully",
  "translation.fallback": "Fallback (English)",
  "translation.management.description": "View and edit translations for metadata.",
  "translation.management.title": "Translation Management",
  "translation.missing": "Missing",
  "translation.search": "Search translations...",
  "translation.selectLocale": "Select Language",
  "translation.showMissing": "Show Missing Only",
  "translation.stats.title": "Translation Progress",
  "translation.stats.total": "Total entries: {count}",
  "translation.update.error": "Failed to update translation",
  "translation.update.success": "Translation updated successfully",
  "translation.value": "Translation",
  "translation.origin": "Origin",
  "translation.origin.shipped": "Shipped",
  "translation.origin.siteOverride": "Site override",
  "translation.origin.siteValue": "Site value",
  "translation.shippedLabel": "Shipped translation: {label}",
  "translation.reset": "Reset to shipped translation",
  "translation.reset.confirm": "Replace the lab's label with the shipped translation \"{label}\"?",
  "translation.reset.confirmButton": "Reset",
  "translation.reset.success": "The label is back to the shipped translation.",
  "translation.reset.error": "The label could not be reset.",
  "localization.error.overrideBlank": "A label for a value OpenELIS ships cannot be blank. To drop the lab's label, use Reset to shipped translation.",
  "localization.error.notShipped": "Only a value OpenELIS ships has a shipped translation to return to.",
  "usage.analysisId": "Analysis ID",
  "usage.date": "Date Used",
  "usage.error.quantityPositive": "Quantity must be greater than 0",
  "usage.fefo.note": "The quantity is deducted from this item's earliest-expiring QC-passed lot (FEFO), which may not be the lot you opened this from.",
  "usage.item": "Item",
  "usage.notes": "Notes",
  "usage.notes.placeholder": "Add any notes about this usage",
  "usage.quantityUsed": "Quantity Used",
  "usage.quantityUsed.helper": "Enter the number of units consumed",
  "usage.record.button": "Record Usage",
  "usage.record.error": "Error recording usage",
  "usage.record.success": "Usage recorded successfully",
  "usage.record.title": "Record Inventory Usage",
  "usage.testResultId": "Test Result ID (Optional)",
  "usage.testResultId.placeholder": "Link to test result for traceability",
  "user.select.instruction": "Select a User to Modify or to Deactivate . You can set a Filter ,Search for users, or Add a User along with the controls at the top.",
  "validation.accept.all": "Save All Results",
  "validation.accept.normal": "Save All Normal",
  "validation.field.required": "This field is required",
  "validation.ignore.all": "Ignore All Results",
  "validation.label.nonconform": "= Sample or Order is nonconforming or Test has been rejected",
  "validation.legend.qcHold": "= A quality control covering this result failed; the non-conformity is still open",
  "validation.qcHold.tooltip": "A control run for this test in this lab unit failed. Review the non-conformity before releasing this result.",
  "validation.password.match": "Passwords must match",
  "validation.password.minLength": "Password must be at least 7 characters",
  "validation.password.notSameAsOld": "New password must not be the same as the old password",
  "validation.password.specialChar": "Password must contain at least one special character (*, $, #, !) and only letters, numbers or those characters",
  "validation.no.records.display": "There are no records to display",
  "validation.reject.all": "Retest All Tests",
  "validation.save.error": "Unable to save analyzer results",
  "validation.save.success": "Results have been validated successfully",
  "validation.search.noresult": "No Results found to be validated",
  "validation.search.noresult.analyser": "No Results found from : ",
  "vl.arvRegimen": "ARV Regimen",
  "vl.durationOnARV": "Duration on ARV (months)",
  "vl.durationOnARV.placeholder": "Enter months on treatment",
  "vl.indication": "Indication for VL Test",
  "vl.lastVLDate": "Date of Last VL Result",
  "vl.lastVLResult": "Last VL Result (copies/mL)",
  "vl.lastVLResult.placeholder": "e.g., 150",
  "vl.pregnancyStatus": "Pregnancy / Breastfeeding Status",
  "workplan.batch.action.archive": "Archive",
  "workplan.batch.action.complete": "Complete",
  "workplan.batch.batches.empty": "No batches found",
  "workplan.batch.column.sampleType": "Sample type",
  "workplan.batch.column.status": "Status",
  "workplan.batch.column.test": "Test",
  "workplan.batch.column.unit": "Unit",
  "workplan.batch.create": "Create batch ({count})",
  "workplan.batch.create.error": "Batch could not be created",
  "workplan.batch.pending.empty": "No pending tests found",
  "workplan.batch.pendingTests": "Pending Tests",
  "workplan.batch.refresh": "Refresh",
  "workplan.batch.selectPage": "Select page",
  "workplan.batch.selectTest": "Select {accessionNumber}",
  "workplan.batch.status.ACTIVE": "Active",
  "workplan.batch.status.ARCHIVED": "Archived",
  "workplan.batch.status.COMPLETED": "Completed",
  "workplan.batch.status.DRAFT": "Draft",
  "workplan.batch.status.error": "Batch status could not be updated",
  "workplan.batch.status.success": "Batch status updated",
  "workplan.batch.tabs": "Batch workplan tabs",
  "workplan.batch.title": "Batch Workplan",
  "workplan.batch.action.edit": "Edit",
  "workplan.batch.actions": "Batch actions",
  "workplan.batch.addTo": "Add to batch ({count})",
  "workplan.batch.addTo.label": "Add to an existing draft batch",
  "workplan.batch.addTo.select": "Select a draft batch",
  "workplan.batch.addTo.success": "Tests added to batch \"{name}\".",
  "workplan.batch.archived": "Batch \"{name}\" archived.",
  "workplan.batch.batches.count": "Batches ({count})",
  "workplan.batch.clear.failed": "The batches could not be cleared.",
  "workplan.batch.clearAll": "Clear all batches",
  "workplan.batch.clearAll.body": "All of your batches will be archived and their tests returned to Pending Tests. Archived batches are kept for audit but leave this view.",
  "workplan.batch.clearAll.confirm": "Clear all",
  "workplan.batch.cleared": "All batches cleared.",
  "workplan.batch.collapse": "Collapse batch",
  "workplan.batch.column.labNumber": "Lab Number",
  "workplan.batch.column.orderDate": "Order date",
  "workplan.batch.column.panel": "Panel",
  "workplan.batch.column.patient": "Patient",
  "workplan.batch.column.priority": "Priority",
  "workplan.batch.create.success.named": "Batch \"{name}\" created. Assign a reagent and lot to set it up.",
  "workplan.batch.edit.success": "Batch \"{name}\" returned to draft for editing.",
  "workplan.batch.expand": "Expand batch",
  "workplan.batch.filter.any": "Any",
  "workplan.batch.filter.clear": "Clear filters",
  "workplan.batch.filter.from": "Order date from",
  "workplan.batch.filter.panel": "Panel",
  "workplan.batch.filter.priority": "Priority",
  "workplan.batch.filter.test": "Test",
  "workplan.batch.filter.to": "Order date to",
  "workplan.batch.filter.unit": "Lab Unit",
  "workplan.batch.generate": "Generate workplan",
  "workplan.batch.generate.blocked": "No current control lot covers this batch, so it cannot be released. Contact your QC officer.",
  "workplan.batch.generate.failed": "The workplan could not be generated.",
  "workplan.batch.generate.needsReagent": "Assign a reagent and lot before generating a workplan.",
  "workplan.batch.generate.saveFirst": "Save the reagent and lot before generating a workplan.",
  "workplan.batch.generated": "Workplan generated for batch \"{name}\".",
  "workplan.batch.generated.nce": "Workplan generated for batch \"{name}\". Non-conforming event {nce} was created for the QC deviation.",
  "workplan.batch.instrument": "Instrument",
  "workplan.batch.instrument.bench": "Bench (no analyzer)",
  "workplan.batch.name": "Batch name (optional)",
  "workplan.batch.name.placeholder": "e.g., Chemistry AM run",
  "workplan.batch.name.oneUnit": "A batch holds the tests of one lab unit.",
  "workplan.batch.name.tooLong": "Batch name cannot exceed {max} characters.",
  "workplan.batch.nceTag": "NCE: {nce}",
  "workplan.batch.needsSetup": "Needs setup",
  "workplan.batch.override.body.ESTABLISHMENT": "The control lot for {test} on {instrument} is still in its establishment phase, so Westgard rules are not evaluated yet. Proceeding will create a non-conforming event (NCE).",
  "workplan.batch.override.body.FAILED": "The most recent QC result for {test} on {instrument} was rejected. Proceeding will create a non-conforming event (NCE) linked to the rejected result.",
  "workplan.batch.override.body.LOT_EXPIRED": "The control lot for {test} on {instrument} is expired. A new control lot must be set up before this batch can be released.",
  "workplan.batch.override.body.NOT_RUN": "No QC has been recorded for the active control lot of {test} on {instrument}. Proceeding will create a non-conforming event (NCE).",
  "workplan.batch.override.body.NO_CONTROL_LOT": "No active QC control lot is configured for {test} on {instrument}. A control lot must be set up before this batch can be released.",
  "workplan.batch.override.body.OVERDUE": "The control lot for {test} on {instrument} has not passed QC within the required time. Last passing QC: {lastPass}. Proceeding will create a non-conforming event (NCE).",
  "workplan.batch.override.body.VIOLATION": "An unresolved Westgard violation ({rules}) exists for the control lot of {test} on {instrument}. Proceeding will create a non-conforming event (NCE) linked to the violation.",
  "workplan.batch.override.goBack": "Go back",
  "workplan.batch.override.noPermission": "You do not have permission to override QC. Contact your lab manager.",
  "workplan.batch.override.proceed": "Proceed and create NCE",
  "workplan.batch.override.title.ESTABLISHMENT": "Control lot in establishment",
  "workplan.batch.override.title.FAILED": "Most recent QC failed",
  "workplan.batch.override.title.LOT_EXPIRED": "Control lot expired",
  "workplan.batch.override.title.NOT_RUN": "No QC recorded",
  "workplan.batch.override.title.NO_CONTROL_LOT": "No control lot configured",
  "workplan.batch.override.title.OVERDUE": "QC not current for batch",
  "workplan.batch.override.title.VIOLATION": "Active Westgard violation",
  "workplan.batch.override.traceability": "The NCE is linked to this batch, and to the Westgard violation when there is one, for follow-up.",
  "workplan.batch.print": "Print workplan",
  "workplan.batch.print.date": "Generated",
  "workplan.batch.print.generatedBy": "Generated by",
  "workplan.batch.print.nce": "Non-conforming event",
  "workplan.batch.print.notFound": "This batch could not be found.",
  "workplan.batch.print.notReleased": "This batch has not been released; generate its workplan first.",
  "workplan.batch.print.overridden": "released by QC override",
  "workplan.batch.print.qc": "QC at release",
  "workplan.batch.print.result": "Result",
  "workplan.batch.print.title": "Workplan",
  "workplan.batch.qc.analyzerFed": "QC for {instrument} is recorded from the analyzer. Run the controls on the instrument.",
  "workplan.batch.qc.controlLot": "Control lot",
  "workplan.batch.qc.date": "QC date",
  "workplan.batch.qc.entry.dateRequired": "Enter the date the QC was run.",
  "workplan.batch.qc.entry.failed": "The QC result could not be saved.",
  "workplan.batch.qc.entry.future": "QC date cannot be in the future.",
  "workplan.batch.qc.entry.lot": "{test}: control lot {lot} ({level})",
  "workplan.batch.qc.entry.resultRequired": "Select Pass or Fail.",
  "workplan.batch.qc.entry.save": "Save QC result",
  "workplan.batch.qc.entry.timeInvalid": "Enter the time as HH:mm.",
  "workplan.batch.qc.entry.title": "Record QC result",
  "workplan.batch.qc.entry.valueRequired": "A numeric QC value is required.",
  "workplan.batch.qc.evaluating": "Evaluating QC...",
  "workplan.batch.qc.evaluationPending": "QC evaluation pending. Refresh to update.",
  "workplan.batch.qc.evaluated": "QC evaluation complete: {status}.",
  "workplan.batch.qc.fail": "Fail",
  "workplan.batch.qc.frequency.CUSTOM_HOURS": "Required every {hours} hours",
  "workplan.batch.qc.frequency.DAILY": "Required daily",
  "workplan.batch.qc.frequency.PER_RUN": "Required before each run",
  "workplan.batch.qc.frequency.PER_SHIFT": "Required each shift ({hours} hours)",
  "workplan.batch.qc.history": "QC history",
  "workplan.batch.qc.lastDate": "Last QC",
  "workplan.batch.qc.lastRun": "Last QC run",
  "workplan.batch.qc.message.ESTABLISHMENT": "The control lot for {test} on {instrument} is in its establishment phase; Westgard rules are not active yet.",
  "workplan.batch.qc.message.FAILED": "QC failed for {test} on {instrument} (rules {rules}). Consider re-running QC, troubleshooting, or selecting a different instrument.",
  "workplan.batch.qc.message.LOT_EXPIRED": "The control lot for {test} on {instrument} is expired. A new control lot is required.",
  "workplan.batch.qc.message.NOT_RUN": "No QC has been recorded for {test} on {instrument}.",
  "workplan.batch.qc.message.NO_CONTROL_LOT": "No active QC control lot is configured for {test} on {instrument}. A control lot must be set up before this batch can be released. Contact your QC officer.",
  "workplan.batch.qc.message.OVERDUE": "QC has not been performed within the required time for {test} on {instrument}. Last passing QC: {lastPass}.",
  "workplan.batch.qc.message.VIOLATION": "An unresolved {rules} violation exists for {test} on {instrument}.",
  "workplan.batch.qc.never": "Never",
  "workplan.batch.qc.nextDue": "Next QC due",
  "workplan.batch.qc.dueNow": "Due now",
  "workplan.batch.override.reason.label": "Reason for releasing without passing QC",
  "workplan.batch.override.reason.placeholder": "For example: control rerun booked, patient care cannot wait",
  "workplan.batch.override.reason.required": "Give the reason before releasing the batch.",
  "workplan.batch.overrideReason": "Override reason: {reason}",
  "workplan.batch.print.overrideReason": "Override reason",
  "workplan.batch.qc.noControlLot": "No active QC control lot is configured for {test} on {instrument}. Contact your QC officer.",
  "workplan.batch.qc.noHistory": "No QC runs recorded for this control lot.",
  "workplan.batch.qc.notes": "Notes (optional)",
  "workplan.batch.qc.pass": "Pass",
  "workplan.batch.qc.performedBy": "Performed by",
  "workplan.batch.qc.result": "Result",
  "workplan.batch.qc.resultStatus.ACCEPTED": "Accepted",
  "workplan.batch.qc.resultStatus.PENDING": "Evaluation pending",
  "workplan.batch.qc.resultStatus.REJECTED": "Rejected",
  "workplan.batch.qc.runQc": "Run QC",
  "workplan.batch.qc.saved": "QC result saved. Evaluating...",
  "workplan.batch.qc.status.ESTABLISHMENT": "Lot in establishment",
  "workplan.batch.qc.status.FAILED": "QC failed",
  "workplan.batch.qc.status.LOT_EXPIRED": "Lot expired",
  "workplan.batch.qc.status.NOT_RUN": "QC not run",
  "workplan.batch.qc.status.NO_CONTROL_LOT": "No control lot",
  "workplan.batch.qc.status.OVERDUE": "QC overdue",
  "workplan.batch.qc.status.PASS": "QC pass",
  "workplan.batch.qc.status.VIOLATION": "QC violation",
  "workplan.batch.qc.statusColumn": "QC status",
  "workplan.batch.qc.time": "QC time",
  "workplan.batch.qc.value": "Value",
  "workplan.batch.qc.value.placeholder": "Measured value",
  "workplan.batch.qc.viewChart": "View full Levey-Jennings chart",
  "workplan.batch.qc.viewInstrument": "Open the instrument's QC",
  "workplan.batch.qc.viewViolation": "View violation details",
  "workplan.batch.qc.zScore": "Z-score",
  "workplan.batch.reagent": "Reagent",
  "workplan.batch.reagent.noLots": "This reagent has no usable lot: none is in stock, QC-passed and unexpired.",
  "workplan.batch.reagent.noneLinked": "No reagent is linked to the tests in this batch. Link reagents to the tests in the Test Catalog.",
  "workplan.batch.reagent.noneLinked.title": "No reagents",
  "workplan.batch.reagent.notAssigned": "Reagent not assigned",
  "workplan.batch.reagent.save": "Save reagent and lot",
  "workplan.batch.reagent.saveFailed": "The reagent and lot could not be saved.",
  "workplan.batch.reagent.saved": "Reagent and lot saved.",
  "workplan.batch.reagent.select": "Select reagent",
  "workplan.batch.reagent.summary": "Reagent {reagent}, lot {lot}, on {instrument}",
  "workplan.batch.reagentLot": "Reagent lot",
  "workplan.batch.reagentLot.detail": "Exp {expires} · {remaining} {units} remaining",
  "workplan.batch.removeTest": "Remove {labNumber} from the batch",
  "workplan.batch.search": "Search",
  "workplan.batch.search.placeholder": "Search tests...",
  "workplan.batch.step.generate": "Generate",
  "workplan.batch.step.reagent": "Reagent and QC",
  "workplan.batch.step.tests": "Tests",
  "workplan.batch.testCount": "{count, plural, one {# test} other {# tests}}",
  "workplan.batch.tests.updateFailed": "The batch's tests could not be updated.",
  "workplan.batch.tests.updated": "Batch tests updated.",
  "workplan.batch.testsInBatch": "Tests in this batch ({count})",
  "workplan.page.title": "Workplan {0}",
  "workplan.panel.selection.error.msg": "This is an invalid error message.",
  "workplan.panel.title": "Workplan By Panel",
  "workplan.panel.types": "Panel Type",
  "workplan.print": "Print Workplan",
  "workplan.priority.list": "Priority",
  "workplan.priority.title": "Workplan By Priority",
  "workplan.run": "Get Workplan",
  "workplan.test.title": "Workplan By Test",
  "workplan.test.types": "Test Type",
  "workplan.title": "Workplan",
  "workplan.unit.title": "Workplan By Unit",
  "workplan.unit.types": "Unit Type",
  "yes.option": "Yes",
  "shipment.module.title": "Shipment Management",
  "shipment.breadcrumb": "Sample Shipment",
  "shipment.nav.dashboard": "Dashboard",
  "shipment.nav.createBox": "Create Box",
  "shipment.nav.receiveBox": "Receive Box",
  "shipment.dashboard.title": "Shipment Dashboard",
  "shipment.dashboard.description": "Manage shipment boxes and track referred samples",
  "shipment.dashboard.tabs.shipments": "Shipments",
  "shipment.dashboard.tabs.unassigned": "Unassigned Tests",
  "shipment.tab.boxes": "Shipment Boxes",
  "shipment.tab.unassignedSamples": "Unassigned Samples",
  "shipment.label.boxId": "Box ID",
  "shipment.label.createdDate": "Created Date",
  "shipment.label.daysUnassigned": "Days Unassigned",
  "shipment.label.destination": "Destination",
  "shipment.label.priority": "Priority",
  "shipment.label.referralTest": "Referral Test",
  "shipment.label.sampleCount": "Sample Count",
  "shipment.label.state": "State",
  "shipment.label.tests": "Tests",
  "shipment.filter.state": "Filter by State",
  "shipment.filter.facility": "Filter by Facility",
  "shipment.action.addSelected": "Add selected",
  "shipment.action.addToBox": "Add to Box",
  "shipment.action.cancelReferral": "Cancel Referral",
  "shipment.action.confirmRejection": "Confirm Rejection",
  "shipment.action.createBox": "Create New Box",
  "shipment.action.markAsLost": "Mark as Lost",
  "shipment.action.printManifest": "Print Manifest",
  "shipment.action.rejectSample": "Reject Sample",
  "shipment.action.saveAndMarkReady": "Save & Mark Ready to Send",
  "shipment.action.saveBox": "Save Box",
  "shipment.action.saveDraft": "Save as Draft",
  "shipment.action.scanSample": "Scan Sample",
  "shipment.box.addSample": "Add Sample",
  "shipment.box.addSampleDescription": "Select samples to add to this shipping box",
  "shipment.box.addSamples": "Add Samples",
  "shipment.box.details": "Box Details",
  "shipment.box.autoGenerate": "Auto-generate",
  "shipment.box.capacity": "Capacity",
  "shipment.box.capacityValue": "{capacity} samples",
  "shipment.box.create": "Create Box",
  "shipment.box.createDescription": "Create a new shipping box for referred samples",
  "shipment.box.created": "Created Date: ",
  "shipment.box.createdBy": "Created By :",
  "shipment.box.createdDate": "Created Date",
  "shipment.box.destination": "Destination",
  "shipment.box.downloadLabel": "Download Label",
  "shipment.box.downloadManifest": "Download Manifest",
  "shipment.box.generateLabel": "Generate Label",
  "shipment.box.generateManifest": "Generate Manifest",
  "shipment.box.id": "Box ID: ",
  "shipment.box.labelDownloaded": "Label downloaded successfully",
  "shipment.box.labelPrefix": "Label Prefix",
  "shipment.box.labelPrefixHelper": "Configured by administrator in Site Settings",
  "shipment.box.manifest": "Manifest",
  "shipment.box.manifestDownloaded": "Manifest downloaded successfully",
  "shipment.box.noSamples": "This box does not contain any samples yet",
  "shipment.box.noUnassignedSamples": "No unassigned samples found for this facility",
  "shipment.box.notes": "Notes",
  "shipment.box.notesPlaceholder": "Enter any special handling instructions or notes...",
  "shipment.box.number": "Box Number",
  "shipment.box.readyConfirmation": "Are you sure you want to mark this box as ready to send?",
  "shipment.box.readySampleCount": "This box contains {count} sample(s)",
  "shipment.box.readyToSend": "Mark Ready to Send",
  "shipment.box.reconcile": "Reconcile",
  "shipment.box.removeSample": "Remove Sample",
  "shipment.box.removeSampleConfirmation": "Are you sure you want to remove this sample from the box?",
  "shipment.box.resendManifest": "Resend Manifest",
  "shipment.box.sampleCount": "Sample Count",
  "shipment.box.sampleProgress": "{added} / {capacity} ({remaining} remaining)",
  "shipment.box.samplesAdded": "Samples Added",
  "shipment.box.samplesSelected": "{count} sample(s) selected",
  "shipment.box.scanExisting": "Scan existing",
  "shipment.box.scanExistingId": "Scan or enter existing Box ID",
  "shipment.box.scanExistingIdPlaceholder": "Scan barcode or type box ID",
  "shipment.box.sendBox": "Send Box",
  "shipment.box.sendConfirmation": "Are you sure you want to send this box?",
  "shipment.box.sendSampleCount": "This box contains {count} sample(s) that will be marked as sent",
  "shipment.box.state": "State",
  "shipment.box.summary": "Summary",
  "shipment.box.temperature": "Temperature Requirement",
  "shipment.box.title": "Box {boxId}",
  "shipment.box.useExistingId": "Box ID Mode",
  "shipment.dashboard.boxNotFound": "No box found with ID \"{boxId}\". Try filtering the list instead.",
  "shipment.dashboard.scanBoxPlaceholder": "Search or scan Box ID (press Enter to navigate)",
  "shipment.error.addSample": "Failed to add sample to box",
  "shipment.error.assignToBox": "Failed to assign sample to box",
  "shipment.error.boxFull": "Box is full. Cannot add more samples.",
  "shipment.error.boxNotEmpty": "Box must have at least one sample",
  "shipment.error.boxNotFound": "Box not found",
  "shipment.error.cancelReferral": "Failed to cancel referral",
  "shipment.error.confirmReception": "Failed to confirm reception",
  "shipment.error.createBox": "Failed to create shipping box",
  "shipment.error.exceedsCapacity": "Cannot add {requested} sample(s). Only {available} slot(s) available.",
  "shipment.error.fetchBox": "Failed to fetch box information",
  "shipment.error.fetchBoxes": "Failed to fetch available boxes",
  "shipment.error.fetchUnassignedSamples": "Failed to fetch the unassigned samples",
  "shipment.error.generateLabel": "Error generating shipping label",
  "shipment.error.generateManifest": "Error generating manifest",
  "shipment.error.invalidState": "Invalid box state for this operation",
  "shipment.error.linkDestinationNotLoaded": "The destination in this link could not be loaded.",
  "shipment.error.linkSampleNotLoaded": "The sample in this link could not be loaded.",
  "shipment.error.markAsLost": "Failed to mark sample as lost",
  "shipment.error.markReady": "Failed to mark box as ready to send",
  "shipment.error.noDestinationFacility": "No destination facility specified for this sample",
  "shipment.error.noReferralId": "No referral ID available for this sample",
  "shipment.error.noSampleSelected": "Please select at least one sample",
  "shipment.error.partialReception": "Some sample status updates failed. Please try again.",
  "shipment.error.partialSampleAdd": "Only {added} of {total} samples were added to the box. It was left as a draft so you can add the rest.",
  "shipment.error.reasonRequired": "Please provide a reason",
  "shipment.error.reconcile": "Error reconciling box",
  "shipment.error.removeSample": "Failed to remove sample from box",
  "shipment.error.sampleAlreadyAssigned": "This sample is already assigned to a box",
  "shipment.error.sampleAlreadyInBox": "Sample already in box",
  "shipment.error.sampleNotFound": "Sample not found",
  "shipment.error.saveFailed": "Failed to save",
  "shipment.error.searchFailed": "Failed to search for sample. Please try again.",
  "shipment.error.selectBox": "Please select a box",
  "shipment.error.sendBox": "Failed to send box",
  "shipment.filter.clear": "Clear Filters",
  "shipment.filter.dateFrom": "From Date",
  "shipment.filter.dateTo": "To Date",
  "shipment.filter.referenceLab": "Reference Lab",
  "shipment.label.addedDate": "Added Date",
  "shipment.label.position": "Position",
  "shipment.label.samples": "Samples",
  "shipment.label.shippingLabel": "SHIPPING LABEL",
  "shipment.manifest.generated": "Generated:",
  "shipment.manifest.number": "#",
  "shipment.manifest.recallExpired": "Manifest recall is no longer available (7-day limit exceeded since send)",
  "shipment.manifest.regenerationExpired": "Manifest regeneration is no longer available (24-hour limit exceeded since send)",
  "shipment.manifest.serviceLocation": "Service Location:",
  "shipment.manifest.specimenBarcodes": "Specimen Barcodes",
  "shipment.manifest.title": "Shipping Manifest",
  "shipment.manifest.totalSamples": "Total Samples:",
  "shipment.modal.addToBox.existingBox": "Add to existing box",
  "shipment.modal.addToBox.mode": "Select an option",
  "shipment.modal.addToBox.newBox": "Create new box",
  "shipment.modal.addToBox.newBoxInfo.message": "You will be redirected to create a new box for this sample",
  "shipment.modal.addToBox.newBoxInfo.title": "Create New Box",
  "shipment.modal.addToBox.noDraftBoxes.message": "No draft boxes found for this destination. A new box will be created.",
  "shipment.modal.addToBox.noDraftBoxes.title": "No Draft Boxes Available",
  "shipment.modal.addToBox.selectBox": "Select Box",
  "shipment.modal.addToBox.title": "Add Sample to Box",
  "shipment.modal.cancelReferral.reason": "Reason for cancellation",
  "shipment.modal.cancelReferral.reasonPlaceholder": "Please explain why this referral is being cancelled...",
  "shipment.modal.cancelReferral.title": "Cancel Referral",
  "shipment.modal.cancelReferral.warning.message": "This action will permanently cancel the referral and cannot be undone.",
  "shipment.modal.cancelReferral.warning.title": "Warning",
  "shipment.modal.createBox.cancel": "Cancel",
  "shipment.modal.createBox.submit": "Create",
  "shipment.modal.createBox.title": "Create New Box",
  "shipment.modal.markAsLost.reason": "Reason for marking as lost",
  "shipment.modal.markAsLost.reasonPlaceholder": "Please explain why this sample is being marked as lost...",
  "shipment.modal.markAsLost.title": "Mark Sample as Lost",
  "shipment.modal.markAsLost.warning.message": "This action will permanently mark the sample as lost and cannot be undone.",
  "shipment.modal.markAsLost.warning.title": "Warning",
  "shipment.modal.rejectSample": "Reject Sample",
  "shipment.modal.rejectSampleMessage": "Are you sure you want to reject sample {accession}?",
  "shipment.nav.referenceLabResults": "Reference Lab Results",
  "shipment.nav.reports": "Reports",
  "shipment.nav.settings": "Settings",
  "shipment.notification.boxCreated": "Box created successfully",
  "shipment.notification.boxReadyToSend": "Box marked as Ready to Send",
  "shipment.notification.boxReconciled": "Box has been reconciled successfully",
  "shipment.notification.boxSent": "Box sent successfully",
  "shipment.notification.error": "An error occurred: {message}",
  "shipment.notification.partialSamplesAdded": "Only {added} of {total} samples added. Box capacity reached ({notAdded} not added).",
  "shipment.notification.receptionComplete": "Shipment received successfully",
  "shipment.notification.referralCancelled": "Referral cancelled successfully",
  "shipment.notification.sampleAdded": "Sample {accessionNumber} added with {testCount, plural, one {# test} other {# tests}}",
  "shipment.notification.sampleAssignedToBox": "Sample assigned to box successfully",
  "shipment.notification.sampleMarkedAsLost": "Sample marked as lost",
  "shipment.notification.sampleRejected": "Sample {accession} rejected: {reason}",
  "shipment.notification.sampleRemoved": "Sample removed from box",
  "shipment.notification.samplesAdded": "{count, plural, one {# sample added to box} other {# samples added to box}}",
  "shipment.notification.samplesRemovedDueToCapacity": "{removed} sample(s) removed due to capacity reduction.",
  "shipment.reception.acceptSample": "Accept Sample",
  "shipment.reception.applyToAll": "Apply status to all...",
  "shipment.reception.awaitingAcceptance": "Awaiting acceptance",
  "shipment.reception.confirmMessage": "Confirm reception of {count} sample(s)?",
  "shipment.reception.confirmReception": "Confirm Reception",
  "shipment.reception.damaged": "Damaged",
  "shipment.reception.description": "Scan box barcode to receive and verify samples",
  "shipment.reception.enterBoxId": "Please enter a box ID",
  "shipment.reception.generalNotes": "General Notes",
  "shipment.reception.generalNotesPlaceholder": "Enter general reception notes",
  "shipment.reception.importError": "Error importing shipments from remote server",
  "shipment.reception.importFromFhir": "Import from FHIR",
  "shipment.reception.importResult": "{count, plural, =0 {No new shipments found} one {1 shipment imported} other {{count} shipments imported}}",
  "shipment.reception.incomingBoxes": "Incoming Shipments",
  "shipment.reception.leaked": "Leaked",
  "shipment.reception.markAllMissing": "Mark All Missing",
  "shipment.reception.markAllReceived": "Mark All Received",
  "shipment.reception.missing": "Missing",
  "shipment.reception.noIncomingBoxes": "No incoming shipments. Click 'Import from FHIR' to check for new shipments.",
  "shipment.reception.notes": "Notes",
  "shipment.reception.notesPlaceholder": "Enter notes if needed",
  "shipment.reception.notesRequired": "Notes are required for samples not received in good condition",
  "shipment.reception.notesRequiredPlaceholder": "Required: describe the issue",
  "shipment.reception.openBox": "Open",
  "shipment.reception.originFacility": "From",
  "shipment.reception.pending": "Pending",
  "shipment.reception.pendingAcceptance": "Specimens Awaiting Acceptance",
  "shipment.reception.received": "Received",
  "shipment.reception.referralOrder": "Referral Order",
  "shipment.reception.rejected": "Rejected",
  "shipment.reception.sampleCountSummary": "{accepted} accepted / {expected} expected",
  "shipment.reception.sampleNotFound": "Sample {accessionNumber} not found in this box",
  "shipment.reception.sampleScanned": "Sample {accessionNumber} checked in as received",
  "shipment.reception.sampleVerification": "Sample Verification",
  "shipment.reception.scanBox": "Box ID / Barcode",
  "shipment.reception.scanBoxPlaceholder": "Scan or enter box barcode",
  "shipment.reception.scanButton": "Scan Box",
  "shipment.reception.scanSample": "Scan Sample ID",
  "shipment.reception.scanSampleButton": "Check In Sample",
  "shipment.reception.scanSamplePlaceholder": "Scan or type sample accession number",
  "shipment.reception.shipped": "Shipped",
  "shipment.reception.specimen": "Specimen",
  "shipment.reception.status": "Reception Status",
  "shipment.reception.title": "Receive Shipment",
  "shipment.reception.unresolved": "No matching order",
  "shipment.rejection.damaged": "Damaged",
  "shipment.rejection.expired": "Expired",
  "shipment.rejection.insufficientVolume": "Insufficient Volume",
  "shipment.rejection.other": "Other",
  "shipment.rejection.reason": "Rejection Reason",
  "shipment.rejection.wrongType": "Wrong Sample Type",
  "shipment.report.contents": "Contents",
  "shipment.report.description": "Generate and export shipment reports by box, date, destination, or reference lab",
  "shipment.report.export.excel": "Export Excel",
  "shipment.report.export.pdf": "Export PDF",
  "shipment.report.generate": "Generate Report",
  "shipment.report.noResults": "No shipment records found for the selected filters",
  "shipment.report.receivedDate": "Received Date",
  "shipment.report.receivedStatus": "Received Status",
  "shipment.report.receiver": "Receiver",
  "shipment.report.receivingUser": "Receiving User",
  "shipment.report.sender": "Sender",
  "shipment.report.sentDate": "Sent Date",
  "shipment.report.title": "Shipment Reports",
  "shipment.report.totalBoxes": "Total Boxes",
  "shipment.report.totalSamples": "Total Samples",
  "shipment.sample.accessionNumber": "Accession Number",
  "shipment.sample.multipleMatches": "Multiple samples match — select which to add",
  "shipment.sample.remove": "Remove",
  "shipment.sample.search": "Search sample by accession number",
  "shipment.sample.searchPlaceholder": "Scan or enter accession number",
  "shipment.sample.status": "Status",
  "shipment.sample.type": "Sample Type",
  "shipment.settings.administration": "Administration",
  "shipment.settings.boxLabelSection": "Box Label Configuration",
  "shipment.settings.description": "Configure shipment module settings",
  "shipment.settings.fhirConfig": "FHIR Mapping Options",
  "shipment.settings.fhirConfigDesc": "Configure SupplyDelivery mapping and specimen container types for FHIR interoperability",
  "shipment.settings.fhirConfigNote": "FHIR mapping is configured via application properties. Contact your system administrator for changes.",
  "shipment.settings.fhirConfigSaveError": "Error saving FHIR mapping configuration",
  "shipment.settings.fhirConfigSaved": "FHIR mapping configuration saved",
  "shipment.settings.fhirContainerType": "Specimen Container Type (SNOMED CT)",
  "shipment.settings.fhirDisplayName": "Display Name",
  "shipment.settings.fhirNonConformity": "Non-Conformity Codes (SNOMED CT)",
  "shipment.settings.fhirSnomedCode": "SNOMED CT Code",
  "shipment.settings.manageFacilities": "Manage Facility Registry",
  "shipment.settings.manageFacilitiesDesc": "Add, edit, or remove reference laboratory destinations",
  "shipment.settings.manageUsers": "Manage Users",
  "shipment.settings.manageUsersDesc": "Configure user accounts and roles for the shipment module",
  "shipment.settings.prefixHelperText": "Prefix used when generating new box IDs (e.g. BOX, SHIP, LAB)",
  "shipment.settings.prefixPlaceholder": "BOX",
  "shipment.settings.prefixPreview": "Preview: {preview}",
  "shipment.settings.prefixRequired": "Box label prefix is required",
  "shipment.settings.prefixSaveError": "Error saving box label prefix",
  "shipment.settings.prefixSaved": "Box label prefix saved successfully",
  "shipment.settings.siteOrgDescription": "Select the organization that represents this laboratory. Only shipments destined for this organization will be imported from remote FHIR servers.",
  "shipment.settings.siteOrgLabel": "This Laboratory",
  "shipment.settings.siteOrgSaveError": "Error saving site organization",
  "workflow.clinical": "Clinical",
  "workflow.environmental": "Environmental / Other",
  "provider.name": "Provider Name",
  "provider.name.placeholder": "Enter provider name",
  "provider.phone": "Provider Phone",
  "provider.search.helper": "Enter provider name or phone number and press Search.",
  "site.search": "Site Search",
  "site.name": "Site Name",
  "site.name.placeholder": "Enter site name",
  "site.location": "Location",
  "site.type": "Type",
  "site.department": "Department / Ward / Unit",
  "site.department.selectFirst": "Select facility first...",
  "site.department.choose": "Select a department...",
  "site.department.none": "No subunits available",
  "sample.filterByLabUnit": "Filter by Lab Unit",
  "sample.allLabUnits": "All Lab Units",
  "sample.orderPanels": "Order Panels",
  "sample.orderTests": "Order Tests",
  "sample.referToReferenceLab": "Refer test to a reference lab",
  "sample.optional.info": "Tests can wait: Save and exit keeps the order without them. Save and next needs at least one test on every sample.",
  "panel.search.placeholder": "Choose Available panel",
  "test.search.placeholder": "Choose Available Test",
  "test.timeHolding": "SOP Max Holding Time (minutes)",
  "select.regimen": "Select Regimen...",
  "select": "Select...",
  "generating": "Generating...",
  "label.order": "Order Label",
  "label.sample": "Sample Label",
  "label.slide": "Slide Label",
  "label.block": "Block Label",
  "label.freezer": "Freezer Label",
  "environmental.coming.soon": "Environmental workflow",
  "environmental.location.info": "Location hierarchy fields (Region/District/Town-Village) and GPS capture will be available here.",
  "env.collectionConditions.title": "Default Collection Conditions",
  "env.collectionConditions.subtitle": "Defaults applied to all samples in this batch.",
  "env.collectionMethod": "Collection Method",
  "env.waterTemp": "Water Temp (°C)",
  "env.ambientTemp": "Ambient Temp (°C)",
  "env.weather": "Weather",
  "env.preservationMethod": "Preservation Method",
  "env.preservationMethod.placeholder": "e.g., HNO3 acidification, 4°C cooler",
  "env.fieldNotes": "Field Notes",
  "env.fieldNotes.placeholder": "Enter field observations...",
  "env.sample.manifest.title": "Per-Sample Manifest",
  "env.sample.manifest.subtitle": "one row = one physical sample",
  "env.sample.container": "Container",
  "env.sample.gpsLat": "GPS Lat",
  "env.sample.gpsLat.placeholder": "e.g. -6.2088",
  "env.sample.gpsLng": "GPS Lng",
  "env.sample.gpsLng.placeholder": "e.g. 106.8456",
  "env.sample.samplingSite": "Sampling site",
  "env.sample.useOrderSite": "Use order site {site}",
  "order.microPreview.site": "Site: {site}",
  "env.sample.locationDetails": "Location Details",
  "env.sample.locationDetails.placeholder": "e.g., Inlet, Bank...",
  "env.sample.collected": "Collected",
  "env.sample.duplicate": "Duplicate sample",
  "env.sample.addRow": "+ Add sample row",
  "env.sample.total": "Total: {count} {count, plural, one {sample} other {samples}} in this batch",
  "env.sample.testsAndPanels": "Tests & Panels",
  "env.sample.tests.required": "required",
  "env.complianceStandards.title": "Applicable Compliance Standards",
  "env.complianceStandards.subtitle": "Select the regulatory standards that apply to this order.",
  "env.complianceStandards.label": "Compliance Standards",
  "env.complianceStandards.placeholder": "Select standards...",
  "env.complianceStandards.empty": "No active compliance standards configured. Add them in Administration → Compliance Standards.",
  "order.dashboard.samplingSite": "Sampling Site",
  "order.search.placeholder.env": "Search by site name or lab number...",
  "order.filter.dateFrom": "From",
  "order.filter.dateTo": "To",
  "program.placeholder": "Type to filter or select from the list",
  "program.helper": "Type to filter or select from the list. Selecting a program displays its specific Additional Order Information fields below.",
  "patient.externalSearch": "External Search",
  "patient.results": "Patient Results",
  "patient.id.helper": "Enter subject number, national ID, or ST number.",
  "patient.id.placeholder": "Enter Patient Id",
  "patient.lastName.placeholder": "Enter Patient's Last Name",
  "patient.firstName.placeholder": "Enter Patient's First Name",
  "patient.natId": "Unique Health ID",
  "patient.dataSource": "Data Source",
  "patient.noResults": "0-0 of 0 items",
  "patient.new.info": "Enter new patient information below. The patient will be created when the order is saved.",
  "pagination.showing": "Showing {start}-{end} of {total} tests",
  "results.found.for": "results found for \"{term}\"",
  "selected": "Selected",
  "shipment.settings.siteOrgSaved": "Site organization saved (FHIR UUID: {uuid})",
  "shipment.settings.siteOrgSection": "Site Organization (FHIR)",
  "shipment.settings.title": "Shipment Settings",
  "shipment.state.cancelled": "Cancelled",
  "shipment.state.draft": "Draft",
  "shipment.state.inTransit": "In Transit",
  "shipment.state.lostInTransit": "Lost in Transit",
  "shipment.state.partiallyReceived": "Partially Received",
  "shipment.state.readyToSend": "Ready to Send",
  "shipment.state.received": "Received",
  "shipment.state.reconciled": "Reconciled",
  "shipment.state.sent": "Sent",
  "shipment.stats.delivered": "Delivered",
  "shipment.stats.inTransit": "In Transit",
  "shipment.stats.reconciled": "Reconciled",
  "shipment.stats.totalSamples": "Total Samples",
  "shipment.temperature.ambient": "Ambient (Room Temperature)",
  "shipment.temperature.deepFrozen": "Deep Frozen (-80°C)",
  "shipment.temperature.dryIce": "Dry Ice",
  "shipment.temperature.frozen": "Frozen (-20°C)",
  "shipment.temperature.refrigerated": "Refrigerated (2-8°C)",
  "shipment.validation.addSample": "Add at least one sample",
  "shipment.validation.selectDestination": "Select a destination facility",
  "qc.dashboard.title": "Quality Control Dashboard",
  "qc.dashboard.lastUpdate": "Last Updated",
  "qc.dashboard.complianceStatus": "Compliance Status",
  "qc.dashboard.compliant": "Compliant",
  "qc.dashboard.warning": "Warning",
  "qc.dashboard.nonCompliant": "Non-Compliant",
  "qc.dashboard.violationsCount": "{count} violations",
  "qc.dashboard.lastResult": "Last Result",
  "qc.dashboard.noInstruments": "No instruments configured",
  "qc.dashboard.subtitle": "Monitor instrument QC status and alerts",
  "qc.dashboard.loading": "Loading dashboard data...",
  "qc.dashboard.refresh": "Refresh",
  "qc.dashboard.lastUpdated": "Last Updated",
  "qc.dashboard.export.title": "Export QC Data",
  "qc.dashboard.export.selectInstrument": "Select an instrument",
  "qc.dashboard.export.dateError": "End date must be on or after the start date.",
  "qc.dashboard.error.title": "Error",
  "qc.dashboard.error.loadFailed": "Failed to load dashboard data. Please try again.",
  "qc.dashboard.tab.instruments": "Instruments",
  "qc.dashboard.tab.alerts": "Alerts",
  "qc.dashboard.summary.inControl": "Instruments In Control",
  "qc.dashboard.summary.warningStatus": "Warning Status",
  "qc.dashboard.summary.outOfControl": "Out of Control",
  "qc.dashboard.summary.passRate": "% Instruments In Control",
  "qc.dashboard.summary.ofTotal": "{percentage}% of total instruments",
  "qc.dashboard.instruments.title": "Instrument Quality Control Status",
  "qc.dashboard.instruments.subtitle": "Monitor compliance status and QC performance for all laboratory instruments",
  "qc.dashboard.instruments.search": "Search instruments...",
  "qc.dashboard.instruments.col.id": "Instrument ID",
  "qc.dashboard.instruments.col.name": "Instrument Name",
  "qc.dashboard.instruments.col.type": "Type",
  "qc.dashboard.instruments.col.location": "Location",
  "qc.dashboard.instruments.col.status": "Status",
  "qc.dashboard.instruments.col.analytes": "Analytes",
  "qc.dashboard.instruments.col.violations": "Recent Violations",
  "qc.dashboard.instruments.col.lastUpdate": "Last Update",
  "qc.dashboard.instruments.col.actions": "Actions",
  "qc.dashboard.instruments.view": "View",
  "qc.dashboard.instruments.status.green": "In Control",
  "qc.dashboard.instruments.status.yellow": "Warning",
  "qc.dashboard.instruments.status.red": "Out of Control",
  "qc.dashboard.instruments.status.notConfigured": "Not configured",
  "qc.dashboard.instruments.status.unknown": "Unknown",
  "qc.dashboard.instruments.noViolations": "No violations",
  "qc.dashboard.instruments.empty": "No instruments found",
  "qc.dashboard.alerts.title": "QC Violations & Alerts",
  "qc.dashboard.alerts.subtitle": "Showing violations from last {period}",
  "qc.dashboard.alerts.timePeriod": "Time Period",
  "qc.dashboard.alerts.timePeriod.24h": "Last 24 Hours",
  "qc.dashboard.alerts.timePeriod.72h": "Last 72 Hours",
  "qc.dashboard.alerts.timePeriod.7d": "Last 7 Days",
  "qc.dashboard.alerts.timePeriod.30d": "Last 30 Days",
  "qc.dashboard.alerts.timePeriod.all": "All Time",
  "qc.dashboard.alerts.active": "Active QC Violations",
  "qc.dashboard.alerts.active.count": "{count} unacknowledged violation(s) requiring attention",
  "qc.dashboard.alerts.active.empty": "No active violations",
  "qc.dashboard.alerts.acknowledge": "Acknowledge",
  "qc.dashboard.alerts.acknowledged": "Acknowledged Violations",
  "qc.dashboard.alerts.acknowledged.count": "{count} violation(s) have been acknowledged",
  "qc.dashboard.alerts.acknowledged.empty": "No acknowledged violations",
  "qc.dashboard.alerts.col.severity": "Severity",
  "qc.dashboard.alerts.col.time": "Time",
  "qc.dashboard.alerts.col.instrument": "Instrument",
  "qc.dashboard.alerts.col.analyte": "Analyte",
  "qc.dashboard.alerts.col.rule": "Rule",
  "qc.dashboard.alerts.col.acknowledgedBy": "Acknowledged By",
  "qc.dashboard.alerts.col.acknowledgedDate": "Acknowledged Date",
  "qc.dashboard.banner.title": "{count} active QC violation(s) require attention",
  "qc.dashboard.banner.viewAll": "View all alerts",
  "qc.violations.error.acknowledgeFailed": "Failed to acknowledge violation",
  "qc.chart.axis.date": "Date/Time",
  "qc.chart.axis.run": "Run",
  "qc.chart.axis.value": "Standard Deviations (σ)",
  "qc.instrument.notFound": "Instrument not found",
  "qc.chart.stats.sd": "SD",
  "qc.chart.stats.cv": "CV",
  "qc.chart.stats.sigma": "Sigma performance",
  "qc.chart.sigma.notCalculable": "Not calculable — TEa not configured",
  "qc.chart.sigma.bias": "Bias not applied (no peer data)",
  "qc.chart.sigma.WORLD_CLASS": "World-class",
  "qc.chart.sigma.ACCEPTABLE": "Acceptable",
  "qc.chart.sigma.MARGINAL": "Marginal",
  "qc.chart.sigma.POOR": "Poor",
  "qc.chart.title": "Quality Control Chart",
  "qc.chart.loading": "Loading control chart…",
  "qc.chart.error.title": "Unable to load control chart",
  "qc.chart.tabs.label": "Control chart levels",
  "qc.chart.filter.allLevels": "All levels",
  "qc.chart.filter.selectLot": "Select lot",
  "qc.chart.action.zoomIn": "Zoom in",
  "qc.chart.action.zoomOut": "Zoom out",
  "qc.chart.action.zoomReset": "Reset zoom",
  "qc.chart.legend.normal": "Normal",
  "qc.chart.legend.violation": "Violation",
  "qc.chart.mean": "Mean",
  "qc.chart.noData": "No QC data available",
  "qc.chart.tooltip.date": "Date",
  "qc.chart.tooltip.value": "Value",
  "qc.chart.tooltip.violations": "Violations",
  "qc.chart.tooltip.zScore": "Z-Score",
  "qc.charts.title": "Control Charts",
  "qc.charts.leveyJennings": "Levey-Jennings Chart",
  "qc.charts.dateRange": "Date Range",
  "qc.charts.controlLevel": "Control Level",
  "qc.charts.export": "Export Chart",
  "qc.charts.noData": "No QC data available",
  "qc.violations.title": "QC Violations",
  "qc.violations.severity": "Severity",
  "qc.violations.rule": "Rule",
  "qc.violations.date": "Date",
  "qc.violations.status": "Status",
  "qc.violations.unresolved": "Unresolved",
  "qc.violations.resolved": "Resolved",
  "qc.violations.acknowledged": "Acknowledged",
  "qc.correctiveActions.title": "Corrective Actions",
  "qc.correctiveActions.create": "Create Corrective Action",
  "qc.correctiveActions.type": "Action Type",
  "qc.correctiveActions.description": "Description",
  "qc.correctiveActions.assignedTo": "Assigned To",
  "qc.correctiveActions.status": "Status",
  "qc.correctiveActions.pending": "Pending",
  "qc.correctiveActions.inProgress": "In Progress",
  "qc.correctiveActions.completed": "Completed",
  "qc.correctiveActions.resolutionNotes": "Resolution Notes",
  "qc.alerts.title": "QC Alerts",
  "qc.alerts.markAsRead": "Mark as Read",
  "qc.alerts.viewDetails": "View Details",
  "qc.rules.title": "Westgard Rules Configuration",
  "qc.rules.enable": "Enable",
  "qc.rules.disable": "Disable",
  "qc.rules.preset": "Preset Configuration",
  "qc.rules.basic": "Basic",
  "qc.rules.standard": "Standard",
  "qc.rules.comprehensive": "Comprehensive",
  "qc.rules.1₂ₛ.description": "One control exceeds ±2SD",
  "qc.rules.1₃ₛ.description": "One control exceeds ±3SD",
  "qc.rules.2₂ₛ.description": "Two consecutive controls exceed ±2SD in same direction",
  "qc.rules.R₄ₛ.description": "Range between two controls exceeds 4SD",
  "qc.rules.4₁ₛ.description": "Four consecutive controls exceed ±1SD in same direction",
  "qc.rules.10ₓ.description": "Ten consecutive controls on same side of mean",
  "qc.rules.3₁ₛ.description": "Three consecutive controls exceed ±1SD in same direction",
  "qc.rules.7ₜ.description": "Seven consecutive controls trending in same direction",
  "qc.ruleConfig.title": "Rule Configuration",
  "qc.ruleConfig.subtitle": "Configure Westgard rules per analyzer and test combination",
  "qc.ruleConfig.field.analyzer": "Analyzer",
  "qc.ruleConfig.field.selectAnalyzer": "Select an analyzer",
  "qc.ruleConfig.field.test": "Test",
  "qc.ruleConfig.field.selectTest": "Select a test",
  "qc.ruleConfig.field.severity": "Severity",
  "qc.ruleConfig.severity.warning": "Warning",
  "qc.ruleConfig.severity.rejection": "Rejection",
  "qc.ruleConfig.category.rejection": "Rejection Rules",
  "qc.ruleConfig.category.warning": "Warning Rules",
  "qc.ruleConfig.action.reset": "Reset to Defaults",
  "qc.ruleConfig.loading": "Loading rule configuration...",
  "qc.ruleConfig.prompt.selectAnalyzerTest": "Select an analyzer and test to configure Westgard rules.",
  "qc.ruleConfig.error.title": "Error",
  "qc.ruleConfig.error.selectAnalyzerTest": "Please select both an analyzer and a test.",
  "qc.ruleConfig.error.saveFailed": "Failed to save rule configuration.",
  "qc.ruleConfig.success.title": "Success",
  "qc.ruleConfig.success.saved": "Rule configuration saved successfully.",
  "qc.ruleConfig.table.title": "Configured Rule Sets",
  "qc.ruleConfig.table.empty": "No rule configurations found.",
  "qc.ruleConfig.field.enabledRules": "Enabled Rules",
  "qc.ruleConfig.unconfigured.title": "Unconfigured Control Mappings",
  "qc.ruleConfig.unconfigured.subtitle": "Control lots without Westgard rule configurations",
  "qc.ruleConfig.unconfigured.configure": "Configure",
  "qc.ruleConfig.unconfigured.activeLots": "Active Lots",
  "qc.ruleConfig.modal.title.edit": "Edit Rule Configuration",
  "qc.ruleConfig.modal.title.create": "Create Rule Configuration",
  "button.saving": "Saving...",
  "qc.controlLots.title": "Control Lots",
  "qc.controlLots.create": "Create Control Lot",
  "qc.controlLots.productName": "Product Name",
  "qc.controlLots.lotNumber": "Lot Number",
  "qc.controlLots.level": "Control Level",
  "qc.controlLots.statisticsMethod": "Statistics Calculation Method",
  "qc.controlLots.initialRuns": "Initial Runs",
  "qc.controlLots.rolling": "Rolling Window",
  "qc.controlLots.manufacturerFixed": "Manufacturer Fixed",
  "qc.controlLots.activationDate": "Activation Date",
  "qc.controlLots.expirationDate": "Expiration Date",
  "qc.controlLots.status.active": "Active",
  "qc.controlLots.status.establishment": "Establishment",
  "qc.controlLots.status.expired": "Expired",
  "qc.controlLots.subtitle": "Manage QC control lots for Westgard rule evaluation",
  "qc.controlLots.empty": "No control lots found",
  "qc.controlLot.filter.allStatuses": "All Statuses",
  "qc.controlLot.status.establishment": "Establishment",
  "qc.controlLot.status.active": "Active",
  "qc.controlLot.status.expired": "Expired",
  "qc.controlLot.field.lotNumber": "Lot Number",
  "qc.controlLot.field.lotNumberPlaceholder": "Enter lot number",
  "qc.controlLot.field.material": "Control Material",
  "qc.controlLot.field.materialPlaceholder": "Enter material name",
  "qc.controlLot.field.manufacturer": "Manufacturer",
  "qc.controlLot.field.level": "Control Level",
  "qc.controlLot.field.selectLevel": "Select level",
  "qc.controlLot.field.expiration": "Expiration Date",
  "qc.controlLot.field.analyzer": "Analyzer",
  "qc.controlLot.field.selectAnalyzer": "Select analyzer",
  "qc.controlLot.field.analyzerHelper": "Optional. Choose \"Bench / no analyzer\" for a manual method run at the bench without an instrument.",
  "qc.controlLot.analyzer.bench": "Bench / no analyzer (manual method)",
  "qc.controlLot.field.test": "Test",
  "qc.controlLot.field.selectTest": "Select test",
  "qc.controlLot.field.isActive": "Status",
  "qc.controlLot.field.frequency": "QC frequency",
  "qc.controlLot.field.frequencyHelper": "How often this lot must pass QC before a batch workplan using it is released.",
  "qc.controlLot.field.frequencyHours": "QC required every (hours)",
  "qc.controlLot.field.qcRequired": "QC required before release",
  "qc.controlLot.field.qcRequired.off": "Not enforced",
  "qc.controlLot.field.qcRequired.on": "Enforced",
  "qc.controlLot.field.shiftHours": "Shift length (hours)",
  "qc.controlLot.frequency.CUSTOM_HOURS": "Every N hours",
  "qc.controlLot.frequency.DAILY": "Daily",
  "qc.controlLot.frequency.PER_RUN": "Before each run",
  "qc.controlLot.frequency.PER_SHIFT": "Each shift",
  "qc.controlLot.validation.frequencyHoursRequired": "Enter a whole number of hours greater than zero.",
  "qc.controlLot.validation.shiftHoursRequired": "Enter a shift length in whole hours greater than zero.",
  "qc.controlLot.field.inactive": "Inactive",
  "qc.controlLot.field.active": "Active",
  "qc.controlLot.field.status": "Status",
  "qc.controlLot.loading": "Loading...",
  "qc.controlLot.error.title": "Error",
  "qc.controlLot.error.saveFailed": "Failed to save control lot",
  "qc.controlLot.error.statsRequired": "Manufacturer-fixed lots need a mean and standard deviation. Click \"Configure\" to enter them before saving.",
  "qc.controlLot.error.benchNeedsFixedStats": "A bench lot has no analyzer accumulating runs, so it must use manufacturer-fixed statistics. Click \"Configure\" to enter a mean and standard deviation, or select an analyzer for this lot.",
  "qc.controlLot.new.title": "New Control Lot",
  "qc.controlLot.viewChart": "View chart",
  "qc.controlLot.new.subtitle": "Create a new QC control lot",
  "qc.controlLot.edit.title": "Edit Control Lot",
  "qc.controlLot.edit.subtitle": "Update control lot configuration",
  "qc.controlLot.validation.lotNumberRequired": "Lot number is required",
  "qc.controlLot.validation.materialRequired": "Material is required",
  "qc.controlLot.validation.levelRequired": "Control level is required",
  "qc.controlLot.validation.expirationRequired": "Expiration date is required",
  "qc.controlLot.validation.analyzerRequired": "Analyzer is required",
  "qc.controlLot.validation.testRequired": "Test is required",
  "qc.controlLot.level.low": "Low",
  "qc.controlLot.level.normal": "Normal",
  "qc.controlLot.level.high": "High",
  "qc.controlLot.statistics.title": "Statistics Configuration",
  "qc.controlLot.statistics.configure": "Configure",
  "qc.controlLot.statistics.method": "Calculation Method",
  "qc.controlLot.statistics.mean": "Mean",
  "qc.controlLot.statistics.sd": "Standard Deviation",
  "qc.controlLot.statistics.config.title": "Statistics Configuration",
  "qc.controlLot.statistics.config.label": "Configure statistics method",
  "qc.controlLot.statistics.method.manufacturer_fixed": "Manufacturer Fixed",
  "qc.controlLot.statistics.method.manufacturer_fixed.description": "Use manufacturer-provided mean and SD values",
  "qc.controlLot.statistics.method.rolling": "Rolling Window",
  "qc.controlLot.statistics.method.rolling.description": "Recalculate from the most recent N results",
  "qc.controlLot.statistics.method.initial_runs": "Initial Runs",
  "qc.controlLot.statistics.method.initial_runs.description": "Calculate once from the first N establishment runs",
  "qc.controlLot.statistics.manufacturerValues": "Manufacturer Values",
  "qc.controlLot.statistics.rollingConfig": "Rolling Configuration",
  "qc.controlLot.statistics.windowSize": "Window Size",
  "qc.controlLot.statistics.windowSize.helper": "Number of recent results to include in calculation",
  "qc.controlLot.statistics.initialRunsConfig": "Initial Runs Configuration",
  "qc.controlLot.statistics.initialRunsRequired": "Runs Required",
  "qc.controlLot.statistics.initialRunsRequired.helper": "Number of establishment runs before statistics are calculated",
  "qc.instrumentDetail.analytesMonitored": "Analytes Monitored",
  "qc.instrumentDetail.analyte.cv": "CV: {value}%",
  "qc.instrumentDetail.analyte.violations": "{count, plural, one {# violation} other {# violations}}",
  "qc.instrumentDetail.tab.activityTimeline": "Activity Timeline",
  "qc.instrumentDetail.tab.controlChart": "Control Chart",
  "qc.instrumentDetail.timeline.empty": "No alerts or corrective actions recorded for the selected time period",
  "qc.instrumentDetail.timeline.violation": "Violation",
  "qc.instrumentDetail.timeline.correctiveAction": "Corrective Action",
  "qc.instrumentDetail.timeline.loading": "Loading activity timeline...",
  "qc.instrumentDetail.chart.selectAnalyte": "Select Analyte",
  "qc.instrumentDetail.chart.loading": "Loading control chart...",
  "qc.instrumentDetail.chart.noData": "No QC data available for this analyte",
  "qc.instrumentDetail.chart.activeRules": "Active QC Rules",
  "qc.instrumentDetail.chart.noRules": "No active rules configured",
  "qc.instrumentDetail.chart.stats.cv": "CV%",
  "qc.instrumentDetail.chart.stats.mean": "Mean (x̄)",
  "qc.instrumentDetail.chart.stats.n": "N",
  "qc.instrumentDetail.chart.stats.sd": "Std Dev (s)",
  "qc.instrumentDetail.error.loadFailed": "Failed to load instrument details",
  "qc.instrumentDetail.notConfigured.title": "Operational QC not configured",
  "qc.instrumentDetail.notConfigured.description": "No active control lots or QC results are linked to this analyzer.",
  "question.text.required": "Question text is required",
  "compliance.legend.limitTypes": "LIMIT TYPES:",
  "compliance.limitType.borderlineShort": "Borderline ⚑",
  "compliance.limitType.descriptiveShort": "Qualitative",
  "compliance.limitType.MAXIMUM": "High Limit ≤",
  "compliance.limitType.MINIMUM": "Low Limit ≥",
  "compliance.limitType.RANGE": "Normal Range",
  "compliance.limitType.BORDERLINE": "Borderline 🚩",
  "compliance.limitType.DESCRIPTIVE": "Qualitative",
  "compliance.limitType.EXACT": "Exact",
  "compliance.limitType.SELECT_MAP": "Value Mapping",
  "compliance.status.ACTIVE": "Active",
  "compliance.status.DRAFT": "Draft",
  "compliance.status.SUPERSEDED": "Superseded",
  "compliance.status.ARCHIVED": "Archived",
  "compliance.standard.placeholder.name": "e.g., PP No. 22/2021 — Water Quality",
  "compliance.standard.placeholder.issuingBody": "e.g., Government of Indonesia",
  "compliance.standard.placeholder.regulationNumber": "e.g., PP 22/2021",
  "compliance.standard.placeholder.version": "e.g., 2021",
  "compliance.standard.placeholder.countryRegion": "e.g., Indonesia",
  "compliance.standard.placeholder.description": "Optional. Full description of the standard's scope.",
  "compliance.standard.placeholder.date": "yyyy-mm-dd",
  "compliance.threshold.placeholder.lower": "Lower / Min",
  "compliance.threshold.placeholder.upper": "Upper / Max",
  "compliance.threshold.placeholder.unit": "Unit",
  "compliance.standard.archive": "Archive",
  "compliance.standard.archiveHeading": "Archive Compliance Standard",
  "compliance.standard.archivePrompt": "Archive this standard? Existing evaluated results stay linked to it for audit, but the standard will be hidden from active selection lists. This action can be reverted by editing the standard's status back to Active.",
  "compliance.standard.archived": "Compliance standard archived.",
  "compliance.standard.archiveError": "Could not archive this standard.",
  "button.complianceStandard.copy": "Copy Standard",
  "compliance.standard.copied": "Compliance standard copied as a new Draft.",
  "compliance.standard.copyError": "Could not copy this standard.",
  "compliance.standard.viewLinkedTests": "View Linked Tests",
  "compliance.testEditor.groupBy": "Group by",
  "compliance.testEditor.section.configuration": "Configuration",
  "compliance.testEditor.section.organization": "Organization",
  "compliance.testEditor.section.resources": "Resources",
  "compliance.testEditor.section.automation": "Automation",
  "compliance.testEditor.section.compliance": "Compliance",
  "compliance.testEditor.tab.compliance": "Compliance",
  "compliance.testEditor.tabPlaceholder": "Coming with the Test Editor surface — manage this from the Modify Test page for now.",
  "compliance.parameterGroup.editBtn": "Edit",
  "compliance.parameterGroup.moveUp": "Move up",
  "compliance.parameterGroup.moveDown": "Move down",
  "compliance.parameterGroup.updateError": "Could not update parameter group.",
  "compliance.testEditor.standardInactiveBanner": "This test has thresholds linked to {name} which is now {status}. Results will no longer be evaluated against this standard.",
  "compliance.standard.viewLinkedTests.heading": "Linked Tests — {name}",
  "compliance.standard.viewLinkedTests.empty": "No tests are currently linked to this standard.",
  "compliance.filter.status": "Status",
  "compliance.filter.region": "Region",
  "compliance.filter.allStatuses": "All Statuses",
  "compliance.filter.allRegions": "All Regions",
  "compliance.filter.sampleType": "Sample Type",
  "compliance.filter.allSampleTypes": "All Sample Types",
  "compliance.sampleTypes.addLabel": "Add sample type",
  "compliance.sampleTypes.noneConfigured": "None configured",
  "compliance.sampleTypes.noneTitle": "No sample types configured yet.",
  "compliance.sampleTypes.noneSubtitle": "Add at least one sample type before linking tests.",
  "compliance.sampleTypes.counter": "{count, plural, one {# sample type configured} other {# sample types configured}}",
  "compliance.standard.default": "Default",
  "compliance.standard.groups": "Groups",
  "compliance.standard.tests": "Tests",
  "compliance.standard.expiryDate": "Expiry Date",
  "compliance.parameterGroups.heading": "Parameter Groups & Linked Tests",
  "compliance.parameterGroups.requireSampleTypes": "Configure the standard's fields and sample types first, then link tests.",
  "compliance.button.save": "Save",
  "compliance.button.saving": "Saving…",
  "compliance.parameterGroup.createError": "Could not add parameter group.",
  "compliance.parameterGroup.deleteHeading": "Delete Parameter Group",
  "compliance.parameterGroup.deletePrompt": "Delete the parameter group {name} and all of its thresholds? This cannot be undone.",
  "compliance.parameterGroup.deleteWarning": "{count, plural, one {# test is} other {# tests are}} currently linked. All linked thresholds will be removed.",
  "compliance.threshold.saveError": "Could not save this row.",
  "compliance.threshold.deleteError": "Could not remove this row.",
  "compliance.validation.required": "This field is required.",
  "compliance.validation.expiryAfterEffective": "Expiry date must be on or after the effective date.",
  "compliance.validation.missingUpper": "Upper limit is required.",
  "compliance.validation.missingLower": "Lower limit is required.",
  "compliance.validation.missingBounds": "Both lower and upper bounds are required.",
  "compliance.validation.lowerGtUpper": "Lower bound must be less than or equal to upper bound.",
  "compliance.validation.missingDescriptive": "Qualitative value is required.",
  "compliance.linkTest.selectNoOptions": "This test is select-list but has no options configured in the test catalog. Add result options in test management before linking it to a compliance standard.",
  "compliance.linkTest.resultTypeLegend": "Result type",
  "compliance.linkTest.resultType.numeric": "Numeric (use limit values)",
  "compliance.linkTest.resultType.select": "Select list (map options to status)",
  "compliance.linkTest.optionsHint": "Add the result options for this test (e.g. 'Absent', 'Present'). The next step lets you map each one to a compliance status.",
  "compliance.linkTest.optionLabel": "Option value",
  "compliance.linkTest.optionPlaceholder": "e.g. Absent",
  "compliance.linkTest.optionsRequired": "Add at least one option above before mapping statuses.",
  "compliance.admin.title": "Compliance Standards Administration",
  "compliance.admin.tile.explain": "Manage compliance standards, parameter groups, and per-test thresholds (e.g. PP 22/2021, WHO Drinking Water).",
  "compliance.tabs.standardsAdmin": "Compliance Standards List",
  "compliance.tabs.testThresholds": "Compliance Tab (Test Editor)",
  "compliance.testEditor.back": "Back",
  "compliance.testEditor.editTest": "Edit Test:",
  "compliance.testEditor.loinc": "LOINC:",
  "compliance.testEditor.sampleType": "Sample Type:",
  "compliance.testEditor.resultType": "Result Type:",
  "compliance.testEditor.saveTest": "Save Test",
  "compliance.testEditor.saveDisabledHint": "Other test-editor tabs are not yet wired in this iteration.",
  "compliance.testEditor.thresholdsHeading": "Compliance Thresholds for",
  "compliance.testEditor.addThreshold": "Add Threshold",
  "compliance.testEditor.addThresholdHeading": "Link {name} to a compliance standard",
  "compliance.testEditor.pickStandard": "Compliance standard",
  "compliance.testEditor.pickStandardPlaceholder": "-- Select a standard --",
  "compliance.testEditor.pickGroup": "Parameter group",
  "compliance.testEditor.pickGroupPlaceholder": "-- Select a parameter group --",
  "compliance.testEditor.pickGroupHint": "Pick a standard and parameter group above to configure the threshold.",
  "compliance.testEditor.unlink": "Unlink",
  "compliance.testEditor.unlinkHeading": "Unlink Threshold",
  "compliance.testEditor.unlinkPrompt": "Remove this threshold from {test}? The threshold itself stays on the standard's parameter group; only the link to this specific test is removed.",
  "compliance.testEditor.linkedBanner": "This test is linked to {count, plural, one {# compliance standard} other {# compliance standards}}. Thresholds are evaluated at validation time.",
  "compliance.testEditor.expandRow": "Expand row",
  "compliance.testEditor.col.standard": "Standard",
  "compliance.testEditor.col.parameterGroup": "Parameter Group",
  "compliance.testEditor.col.limitType": "Limit Type",
  "compliance.testEditor.col.thresholdRange": "Threshold / Range",
  "compliance.testEditor.col.unit": "Unit",
  "compliance.testEditor.col.effective": "Effective",
  "compliance.testEditor.col.status": "Status",
  "compliance.testThresholds.selectHint": "Select a test to view its compliance thresholds linked across standards.",
  "compliance.testThresholds.overviewHeading": "Tests linked to compliance standards",
  "compliance.testThresholds.overviewCount": "{filtered} of {total} test{total, plural, one {} other {s}}",
  "compliance.testThresholds.overviewEmpty": "No tests are linked to compliance standards yet.",
  "compliance.testThresholds.overviewEmptyHint": "CSV-seeded thresholds at parameter-group level appear in Tab 1 (Compliance Standards Admin), not here. Search above to pick a test from the catalog and link it to a standard.",
  "compliance.testThresholds.noLinkedMatches": "No linked tests match \"{q}\".",
  "compliance.testThresholds.addSection": "Add a test to compliance",
  "compliance.testThresholds.col.test": "Test",
  "compliance.testThresholds.col.code": "Code",
  "compliance.testThresholds.col.loinc": "LOINC",
  "compliance.testThresholds.col.sampleTypes": "Sample Types",
  "compliance.testThresholds.col.thresholdCount": "# Thresholds",
  "compliance.testThresholds.col.standardCount": "# Standards",
  "compliance.testThresholds.openEditor": "Open",
  "compliance.testThresholds.title": "Test Compliance Thresholds",
  "compliance.testThresholds.tile.explain": "View compliance thresholds linked to a specific test, grouped by standard and parameter group.",
  "compliance.testThresholds.searchLabel": "Search test",
  "compliance.testThresholds.searchPlaceholder": "Filter test list…",
  "compliance.testThresholds.test": "Test",
  "compliance.testThresholds.selectPlaceholder": "-- Select a test --",
  "compliance.testThresholds.empty": "No compliance thresholds are linked to this test yet. Click + Add Threshold above to link it to a compliance standard's parameter group.",
  "compliance.testThresholds.parameter": "Parameter",
  "compliance.testThresholds.type": "Limit Type",
  "compliance.testThresholds.value": "Value",
  "compliance.testThresholds.note": "Note",
  "compliance.testThresholds.unknownStandard": "Unknown standard",
  "compliance.button.openAdmin": "Open Compliance Standards Admin",
  "compliance.button.addStandard": "Add Standard",
  "compliance.button.saveStandard": "Save Standard",
  "compliance.button.linkTest": "Link Test to Group",
  "compliance.button.saveLimits": "Save Limits",
  "compliance.button.saveMapping": "Save Mapping",
  "compliance.search": "Search standards",
  "compliance.search.placeholder": "Search by name, issuing body, regulation, country…",
  "compliance.list.empty": "No compliance standards yet.",
  "compliance.standard.name": "Standard Name",
  "compliance.standard.issuingBody": "Issuing Body",
  "compliance.standard.regulationNumber": "Regulation Number",
  "compliance.standard.version": "Version",
  "compliance.standard.countryRegion": "Country / Region",
  "compliance.standard.status": "Status",
  "compliance.standard.effectiveDate": "Effective Date",
  "compliance.standard.description": "Description",
  "compliance.standard.addNew": "Add New Compliance Standard",
  "compliance.standard.edit": "Edit Compliance Standard",
  "compliance.standard.preSeeded": "Pre-seeded",
  "compliance.standard.saved": "Compliance standard saved.",
  "compliance.standard.saveError": "Could not save standard.",
  "compliance.standard.saveBeforeGroups": "Save the standard before adding parameter groups.",
  "compliance.standard.deleted": "Compliance standard deleted.",
  "compliance.standard.deleteError": "Could not delete standard (it may be pre-seeded or have linked thresholds).",
  "compliance.standard.deleteHeading": "Delete Compliance Standard",
  "compliance.standard.deletePrompt": "Are you sure you want to delete this standard? Pre-seeded standards and standards with linked thresholds cannot be deleted.",
  "compliance.sampleTypes.heading": "Applicable Sample Types",
  "compliance.sampleTypes.explicitHint": "Declare which sample type categories this standard applies to. These selections drive the test filter when linking tests.",
  "compliance.sampleTypes.empty": "No sample types declared yet.",
  "compliance.sampleTypes.selectPlaceholder": "Select sample type...",
  "compliance.sampleTypes.addBtn": "Add Sample Type",
  "compliance.sampleTypes.remove": "Remove",
  "compliance.parameterGroups": "Parameter Groups",
  "compliance.parameterGroups.empty": "No parameter groups defined yet.",
  "compliance.parameterGroups.add": "Add Parameter Group",
  "compliance.parameterGroup.name": "Group name",
  "compliance.parameterGroup.description": "Description",
  "compliance.parameterGroup.deleteBtn": "Delete",
  "compliance.label.tests": "tests",
  "compliance.linkedTest.name": "Test",
  "compliance.linkedTest.sampleTypes": "Sample Types",
  "compliance.linkedTest.limits": "Limits Configured",
  "compliance.linkedTest.editLimits": "Edit limits",
  "compliance.linkedTest.unlink": "Remove from group",
  "compliance.linkedTest.unlinkHeading": "Remove Test from Group",
  "compliance.linkedTest.unlinkConfirm": "Remove",
  "compliance.linkedTest.unlinkPrompt": "Remove this test from the group? All threshold definitions for this test in this group will be deleted.",
  "compliance.group.noTests": "No tests linked to this group yet. Link tests to define compliance thresholds for evaluation.",
  "compliance.linkTest.heading": "Link Test to Group",
  "compliance.linkTest.step1": "Step 1 — Filter by Sample Type",
  "compliance.linkTest.step2": "Step 2 — Search & Select Test",
  "compliance.linkTest.step3Numeric": "Step 3 — Configure Limits",
  "compliance.linkTest.step3Select": "Step 3 — Compliance Value Mapping",
  "compliance.linkTest.filterByST": "Filter by sample type:",
  "compliance.linkTest.searchTest": "Search test catalog",
  "compliance.linkTest.searchPlaceholder": "Type to search by name or code...",
  "compliance.linkTest.noResults": "No matching tests found.",
  "compliance.linkTest.selectListBadge": "Select List",
  "compliance.linkTest.clearSelection": "Clear selection",
  "compliance.multiLimit.editHeading": "Configure Limits",
  "compliance.multiLimit.hint": "Enable one or more limit types for this test. At least one limit type must be enabled.",
  "compliance.multiLimit.type": "Limit Type",
  "compliance.multiLimit.lower": "Lower",
  "compliance.multiLimit.upper": "Upper",
  "compliance.multiLimit.unit": "Unit",
  "compliance.multiLimit.note": "Note / Advisory",
  "compliance.multiLimit.descriptive.placeholder": "e.g., No odor, Absent, Clear",
  "compliance.multiLimit.note.placeholder": "Optional note",
  "compliance.limitType.high": "High Limit ≤",
  "compliance.limitType.high.hint": "Non-compliant if result exceeds upper limit",
  "compliance.limitType.low": "Low Limit ≥",
  "compliance.limitType.low.hint": "Non-compliant if result is below lower limit",
  "compliance.limitType.range": "Normal Range",
  "compliance.limitType.range.hint": "Compliant within lower–upper range",
  "compliance.limitType.borderline": "Borderline (Advisory)",
  "compliance.limitType.borderline.hint": "Advisory zone — triggers review flag, not fail",
  "compliance.limitType.descriptive": "Qualitative / Descriptive",
  "compliance.limitType.descriptive.hint": "Text value evaluated by analyst",
  "compliance.selectMap.editHeading": "Compliance Mapping",
  "compliance.selectMap.hint": "Map each result option to its compliance status. Options come from the test catalog.",
  "compliance.selectMap.option": "Result Option",
  "compliance.selectMap.status": "Compliance Status",
  "compliance.selectMap.preview": "Preview",
  "compliance.selectMap.badge": "Value Mapping",
  "compliance.selectMap.optionsLabel": "options mapped",
  "compliance.selectMap.statusForOption": "Compliance status for {option}",
  "compliance.status.compliant": "Compliant",
  "compliance.status.borderline": "Borderline",
  "compliance.status.nonCompliant": "Non-Compliant",
  "compliance.status.compliantWithIcon": "Compliant ✓",
  "compliance.status.borderlineWithIcon": "Borderline ⚑",
  "compliance.status.nonCompliantWithIcon": "Non-Compliant ✗",
  "compliance.linkedTest.noLimits": "No limits configured",
  "compliance.threshold.savedThresholds": "Compliance thresholds linked to the test.",
  "compliance.threshold.savedValueMap": "Value-mapping threshold saved.",
  "compliance.threshold.savedPartialError": "Some thresholds could not be saved. Review the highlighted rows.",
  "compliance.threshold.unlinked": "Threshold unlinked from the test.",
  "compliance.threshold.unlinkError": "Could not unlink this threshold.",
  "notification.title.success": "Success",
  "notification.title.error": "Error",
  "sidenav.label.admin.vectorSurveillance": "Vector Surveillance",
  "vector.admin.title": "Vector Surveillance Setup",
  "vector.admin.groups": "Organism Groups",
  "vector.admin.group.code": "Code",
  "vector.admin.group.label": "Label",
  "vector.admin.group.colorTag": "Color Tag",
  "vector.admin.group.description": "Description",
  "vector.admin.active": "Active",
  "vector.admin.system": "System",
  "vector.admin.trapTypes": "Trap Types",
  "vector.admin.trapType.name": "Name",
  "vector.admin.trapType.description": "Description",
  "vector.admin.species": "Species",
  "vector.admin.selectGroup": "Select a group on the left to manage its trap types and species.",
  "vector.admin.newGroup": "New group (unsaved)",
  "vector.admin.newTrapType": "New trap type",
  "vector.admin.newSpecies": "New species",
  "vector.admin.saveGroup": "Save group",
  "vector.admin.saveTrap": "Save trap",
  "vector.admin.saveSpecies": "Save species",
  "vector.admin.addGroup": "+ Add group",
  "vector.admin.addTrapType": "+ Add trap type",
  "vector.admin.addSpecies": "+ Add species",
  "vector.admin.locked": "locked",
  "vector.admin.systemGroup": "System-protected group",
  "vector.admin.systemGroup.desc": "The code is locked because this group is referenced by core reports and seed data. You may still edit the label, color, and description.",
  "vector.admin.usedBy": "Used by",
  "vector.admin.status": "Status",
  "vector.admin.status.active": "Active",
  "vector.admin.status.inactive": "Inactive",
  "vector.admin.group": "Organism group",
  "vector.admin.trapType.group": "Target organism group",
  "vector.admin.trapType.groups": "Organism groups",
  "vector.admin.trapType.sampleTypes": "Sample types",
  "vector.admin.sampleType": "Sample type",
  "vector.admin.search.groups": "Search by code or label...",
  "vector.admin.search.traps": "Search trap name or description...",
  "vector.admin.search.species": "Search genus or species...",
  "vector.admin.samplingSites": "Sampling Sites",
  "vector.admin.samplingSite.newSite": "New site",
  "vector.admin.samplingSite.allSites": "All Sites",
  "vector.admin.samplingSite.code": "Code",
  "vector.admin.samplingSite.name": "Site Name",
  "vector.admin.samplingSite.type": "Site Type",
  "vector.admin.samplingSite.region": "Region",
  "vector.admin.samplingSite.district": "District",
  "vector.admin.samplingSite.contactName": "Contact Person",
  "vector.admin.samplingSite.contactPhone": "Contact Phone",
  "vector.admin.samplingSite.gpsLatitude": "GPS Latitude",
  "vector.admin.samplingSite.gpsLongitude": "GPS Longitude",
  "vector.admin.samplingSite.environmentalZone": "Environmental Zone",
  "vector.admin.samplingSite.address": "Address",
  "vector.admin.samplingSite.description": "Description",
  "vector.admin.samplingSite.source": "Source",
  "vector.admin.samplingSite.source.local": "LOCAL",
  "vector.admin.samplingSite.source.hub": "HUB",
  "vector.admin.samplingSite.lastCollection": "Last Collection",
  "vector.admin.samplingSite.search": "Search by code, name, region...",
  "vector.admin.samplingSite.saveSite": "Save site",
  "vector.admin.samplingSites.registry": "Sampling Site Registry",
  "vector.admin.samplingSite.deactivate": "Deactivate",
  "vector.admin.samplingSite.activate": "Activate",
  "vector.admin.samplingSite.location": "Location",
  "vector.admin.samplingSite.allTypes": "All types",
  "vector.admin.samplingSite.subtype": "Subtype",
  "vector.admin.samplingSite.subtype.placeholder": "e.g. River, Well, BG-Sentinel, Fixed Station",
  "vector.admin.samplingSite.city": "City",
  "vector.admin.samplingSite.addressLocation": "Address Location",
  "vector.admin.samplingSite.addressSearch.placeholder": "Search location to auto-fill dropdowns...",
  "vector.admin.samplingSite.gpsCoordinates": "GPS Coordinates",
  "vector.admin.samplingSite.lastModified": "Last Modified",
  "label.noResults": "No results found",
  "vector.admin.addSite": "+ New Site",
  "vector.order.title": "New Vector Order",
  "vector.order.subtitle": "Lab unit: Vector Surveillance Lab — Vector domain active.",
  "vector.order.samplingSite": "Sampling Site",
  "vector.order.site.code": "Site Code",
  "vector.order.site.helper": "Only active surveillance sites appear in results. GPS coordinates are pre-filled from the site record.",
  "vector.order.site.name": "Site Name",
  "vector.order.site.placeholder": "Search by site name or code...",
  "vector.order.site.type": "Site Type",
  "vector.order.specimen": "Specimen",
  "vector.order.organism": "Animal / Organism",
  "vector.order.organism.hint": "Common name — e.g., Mosquito, Tick, Rodent, Sandfly.",
  "vector.order.organism.placeholder": "Search organism or species...",
  "vector.order.quantity": "Quantity",
  "vector.order.quantity.hint": "Number of organisms in this pool.",
  "vector.order.requester.section": "Requester / Ordering Programme",
  "vector.order.requester": "Requester",
  "vector.order.requester.placeholder": "Search by organisation name or code...",
  "vector.order.panels": "Order Panels",
  "vector.order.panels.search": "Choose available panel",
  "vector.order.tests": "Order Tests",
  "vector.order.tests.search": "Choose available test",
  "vector.order.collectionContext": "Collection Context (optional — bionomics capture)",
  "vector.order.timeOfDay": "Time of Day",
  "vector.order.timeOfDay.dawn": "Dawn",
  "vector.order.timeOfDay.day": "Day",
  "vector.order.timeOfDay.dusk": "Dusk",
  "vector.order.timeOfDay.night": "Night",
  "vector.order.restingContext": "Resting Context",
  "vector.order.restingContext.outdoor": "Outdoor (exophilic)",
  "vector.order.restingContext.indoor": "Indoor (endophilic)",
  "vector.order.restingContext.peridomestic": "Peridomestic",
  "vector.order.humanBitingCatch": "Human-Biting Catch",
  "vector.order.humanBitingCatch.hint": "specimen came from a human-landing collection",
  "vector.order.collectionNotes": "Collection Notes",
  "vector.order.collectionNotes.placeholder": "Weather, trap conditions, anomalies...",
  "vector.admin.group.code.placeholder": "e.g., SANDFLY",
  "vector.admin.group.label.placeholder": "e.g., Sandfly",
  "vector.species.genus.placeholder": "e.g., Mansonia",
  "vector.species.species.placeholder": "e.g., uniformis",
  "vector.species.subspecies.placeholder": "e.g., diardii",
  "vector.species.genus": "Genus",
  "vector.species.species": "Species",
  "vector.species.subspecies": "Subspecies",
  "vector.species.pathogensOfInterest": "Pathogens of Interest",
  "vector.species.lifecycleStages": "Lifecycle Stages",
  "vector.species.pathogenCategory": "Pathogen category",
  "vector.species.lifecycleCategory": "Lifecycle category",
  "workflow.vector": "Vector Surveillance",
  "vector.sampleType": "Sample Type",
  "vector.organismGroup": "Organism Group",
  "vector.species": "Species",
  "vector.animalOrganism": "Animal/Organism",
  "vector.animalOrganism.add": "Add Animal/Organism",
  "vector.animalOrganism.remove": "Remove Animal/Organism",
  "vector.collectedVolume": "Quantity in Pool",
  "vector.lifecycleStage": "Lifecycle Stage",
  "vector.trapCount": "Traps Deployed",
  "vector.trapNights": "Nights Deployed",
  "vector.trapType": "Trap Type",
  "vector.poolingMethod": "Pooling Method",
  "vector.poolCount": "Number of Pools",
  "vector.samplesPerPool": "Specimens per Pool",
  "vector.totalSpecimens": "Total Specimens",
  "vector.pathogensOfInterest": "Pathogens of Interest",
  "vector.homogeneous": "Homogeneous",
  "vector.random": "Random",
  "vector.collectionSite": "Collection Site",
  "vector.collectionSiteName": "Collection Site Name",
  "vector.gpsLatitude": "GPS Latitude",
  "vector.gpsLongitude": "GPS Longitude",
  "patient.search.merged.tag": "Merged",
  "patient.merged.banner.title": "This patient record was merged",
  "patient.merged.banner.subtitle": "Active records are kept on Patient {target}.",
  "patient.merged.banner.subtitle.noTarget": "This record has been merged into another patient.",
  "admin.testCatalog.tabs.ariaLabel": "Test details tabs",
  "admin.testCatalog.tabs.details": "Details",
  "admin.testCatalog.tabs.labels": "Labels",
  "admin.testCatalog.labels.masterOverride.label": "Allow Order Entry Override",
  "admin.testCatalog.labels.masterOverride.on": "On",
  "admin.testCatalog.labels.masterOverride.off": "Off",
  "admin.testCatalog.labels.linkedPresets.title": "Linked Label Presets",
  "admin.testCatalog.labels.linkedPresets.empty": "No label presets linked. Use the dropdown below to add one.",
  "admin.testCatalog.labels.col.presetName": "Preset Name",
  "admin.testCatalog.labels.col.defaultQty": "Default Qty",
  "admin.testCatalog.labels.col.maxQty": "Max Qty",
  "admin.testCatalog.labels.col.allowOverride": "Allow Override",
  "admin.testCatalog.labels.col.actions": "Actions",
  "admin.testCatalog.labels.action.remove": "Remove preset link",
  "admin.testCatalog.labels.addPreset.label": "Add Label Type",
  "admin.testCatalog.labels.addPreset.placeholder": "Select a label preset",
  "admin.testCatalog.labels.preview.title": "Order Entry Preview",
  "admin.testCatalog.labels.preview.col.locked": "Locked",
  "admin.testCatalog.labels.preview.locked": "Locked",
  "admin.testCatalog.labels.preview.unlocked": "Editable",
  "admin.testCatalog.labels.save.success": "Label configuration saved.",
  "admin.testCatalog.labels.save.error": "Failed to save label configuration.",
  "orderEntry.labels.orderTable.title": "Order Labels",
  "orderEntry.labels.sampleTable.title": "Sample Labels",
  "orderEntry.labels.col.row": "Row",
  "orderEntry.labels.col.sample": "Sample",
  "orderEntry.labels.col.quantity": "Quantity",
  "orderEntry.labels.orderRow.header": "Order",
  "orderEntry.labels.sampleRow.header": "Sample {number}",
  "orderEntry.labels.input.sample": "Sample {number} {column} quantity",
  "orderEntry.labels.input.sampleNamed": "{sample} {column} quantity",
  "orderEntry.labels.source.test": "From test",
  "orderEntry.labels.source.presetDefault": "Preset default",
  "orderEntry.labels.source.saved": "Saved",
  "orderEntry.labels.locked.tooltipFor": "{label} is locked by the test configuration and cannot be changed.",
  "orderEntry.labels.total": "Total labels: {total}",
  "orderEntry.labels.heading": "LABELS",
  "orderEntry.labels.title": "Labels",
  "orderEntry.labels.printRow": "Print labels for {label}",
  "orderEntry.labels.printColumn": "Print all {label} labels",
  "orderEntry.labels.printAll": "Print all labels",
  "orderEntry.labels.pendingSave": "Prints after save",
  "orderEntry.labels.empty": "Add a sample above to see its labels.",
  "orderEntry.labels.loadFailed": "The label quantities could not be loaded from the presets.",
  "orderEntry.labels.printFailed": "The labels could not be generated.",
  "orderEntry.labels.printFailed.detail": "The server answered {status}.",
  "orderEntry.labels.printFailed.unreachable": "The server could not be reached.",
  "orderEntry.labels.nothingToPrint": "No labels are configured for this selection.",
  "orderEntry.labels.downloaded": "The print window was blocked, so the labels were downloaded instead.",
  "orderEntry.labels.retry": "Retry",
  "label.patientHistory.filterByCategory": "Filter by test category",
  "label.patientHistory.testCategories": "Test categories",
  "label.patientHistory.tree": "Tree",
  "label.patientHistory.showTree": "Show tree",
  "label.patientHistory.resetTree": "Reset tree",
  "label.patientHistory.viewResults": "View {count} results",
  "label.patientHistory.emptyState": "There are no {displayText} to display for this patient",
  "label.patientHistory.record": "Record {displayText}",
  "label.patientHistory.dataLoadError": "Data Load Error",
  "label.patientHistory.errorCopy": "Sorry, there was a problem displaying this information. You can try to reload this page, or contact the site administrator and quote the error code above.",
  "label.patientHistory.backToTimeline": "Back to timeline",
  "label.patientHistory.returnToTimeline": "Return to timeline",
  "label.patientHistory.timeOfTest": "Time of Test",
  "label.patientHistory.observations": "observations",
  "label.patientHistory.range.oneDay": "1 day",
  "label.patientHistory.range.fiveDays": "5 days",
  "label.patientHistory.range.oneMonth": "1 month",
  "label.patientHistory.range.sixMonths": "6 months",
  "label.patientHistory.range.oneYear": "1 year",
  "label.patientHistory.range.fiveYears": "5 years",
  "label.patientHistory.range.all": "All",
  "label.patientHistory.date": "Date",
  "address.search.no.results": "No addresses found for \"{term}\"",
  "address.search.placeholder": "Search for address (type at least 2 characters)...",
  "address.search.results.count": "{count} results found",
  "alert.error": "Error",
  "alert.warning": "Warning",
  "analyzer.errorDetails.noLogsAvailable": "No logs available",
  "analyzer.fieldSelector.placeholder": "Search and select field...",
  "analyzer.fieldSelector.title": "Select OpenELIS Field",
  "analyzer.form.columnMappings": "Column Mappings (JSON)",
  "analyzer.form.columnMappings.helperText": "Maps file column names to internal field names",
  "analyzer.form.delimiter": "Delimiter",
  "analyzer.form.fileFormat": "File Format",
  "analyzer.form.fileImport.title": "File Import Settings",
  "analyzer.form.filePattern": "File Pattern",
  "analyzer.form.filePattern.helperText": "Glob pattern to match result files",
  "analyzer.form.hasHeader": "File has header row",
  "analyzer.form.importDirectory": "Import Directory",
  "analyzer.form.importDirectory.helperText": "Directory the bridge watches for incoming result files",
  "analyzer.form.importDirectory.placeholder": "/data/analyzer-imports/my-analyzer/incoming",
  "analyzer.form.validation.columnMappings.invalid": "Column mappings must be valid JSON",
  "analyzer.form.validation.importDirectory.required": "Import directory is required for file-based analyzers",
  "analyzer.form.validation.port.invalid": "Port must be a number between 1 and 65535",
  "analyzer.qc.batch.failure.subtitle": "QC controls in this batch have failures. Review QC results below before accepting patient results.",
  "analyzer.qc.batch.failure.title": "QC Controls Failed",
  "analyzer.qc.controls.hidden": "QC controls hidden from patient view",
  "analyzer.qc.controls.section.title": "QC Controls ({count})",
  "audittrail.table.heading": "Order Information",
  "barcode.label.info.labnumber": "Accession number",
  "button.close": "Close",
  "button.collapse": "Collapse",
  "button.expand": "Expand",
  "button.home": "Home",
  "button.new.search": "New Search",
  "column.name.labNo": "Lab #",
  "env.collectionConditions.helper": "Search for an existing sampling site or create a new one. Sites are reusable across orders — like patients in clinical workflows.",
  "env.collectionMethod.placeholder": "e.g., Grab sample, Composite 24h",
  "env.conditions": "Environmental Conditions",
  "env.conditions.placeholder": "e.g., 20°C, clear weather, dry season",
  "env.regulatoryReference": "Regulatory Reference",
  "env.regulatoryReference.placeholder": "e.g., PP No. 22/2021 Batu Mutu Air",
  "env.samplingSite.title": "Subject — Sampling Site",
  "env.site.address": "Address",
  "env.site.addressSearch.placeholder": "Search for location to auto-fill dropdowns below...",
  "env.site.code": "Site Code",
  "env.site.code.placeholder": "Auto-generated (or enter manually)",
  "env.site.contactPerson": "Contact Person",
  "env.site.contactPerson.placeholder": "Name of site custodian or contact",
  "env.site.contactPhone": "Contact Phone",
  "env.site.description": "Site Description",
  "env.site.description.placeholder": "e.g., Downstream monitoring point near floodgate",
  "env.site.helperText": "Register a new sampling site. The site will be saved to the Site Registry and can be reused for future orders.",
  "env.site.name": "Site Name",
  "env.site.name.placeholder": "e.g., Sungai Ciliwung — Manggarai",
  "env.site.newTab": "New Site",
  "env.site.saveAndSelect": "Save & Select Site",
  "env.site.searchLabel": "Site Name",
  "env.site.searchPlaceholder": "e.g., Sungai Ciliwung - Manggarai",
  "env.site.searchTab": "Search for Site",
  "env.site.streetAddress": "Address",
  "env.site.streetAddress.placeholder": "Street address or location reference",
  "env.site.subtype": "Subtype",
  "env.site.subtype.placeholder": "e.g., River, Well, BG-Sentinel, Fixed Station",
  "env.site.type": "Site Type",
  "env.site.type.select": "Select Type...",
  "env.site.zone": "Environmental Zone",
  "env.site.zone.select": "Select Zone...",
  "error.dateRange.start": "Please select Start and end date.",
  "error.loading.metrics": "Error loading metrics",
  "error.nonconform.report.data.found": "No data found",
  "error.report.csv.dateType": "Please select date type.",
  "error.required.fields": "Please fill in all required fields",
  "error.save.sample": "Error saving sample",
  "error.validation.failed": "Validation failed",
  "error.value": "Please select a value.",
  "esig.context.saveResults": "Save {count} result(s) for accession {accession}",
  "esig.context.saveResultsMulti": "Save {count} result(s) across {accessionCount} accessions",
  "esig.context.validateResults": "Validate {count} result(s) for accession {accession}",
  "esig.context.validateResultsMulti": "Validate {count} result(s) across {accessionCount} accessions",
  "fhir.questionnaire.title": "Additional Information",
  "genericSample.default.fields.title": "Sample Information",
  "genericSample.import.success": "Import successful",
  "genericSample.notebook.label": "Select Notebook",
  "genericSample.order.newOrder": "Create Another Sample",
  "genericSample.search.title": "Search by Accession Number",
  "http.success": "Success!",
  "label.button.assign": "Assign",
  "label.button.create": "Create",
  "label.button.saving": "Saving...",
  "label.button.view": "View Report",
  "label.code": "Code",
  "label.editing": "Editing",
  "label.label": "Label",
  "label.name": "Name",
  "label.panel": "Panel",
  "label.tests": "tests",
  "loading.label": "Loading...",
  "loading.metrics": "Loading metrics...",
  "locale.save.error": "Failed to save language",
  "logging.management.tail.clear": "Clear",
  "logging.management.tail.disconnected": "Stream disconnected. Toggle off and on to reconnect.",
  "logging.management.tail.label": "Live application log",
  "logging.management.tail.off": "Off",
  "logging.management.tail.on": "On",
  "logging.management.tail.stream": "Live stream",
  "nationalID.title": "National ID",
  "nce.button.linkSelected": "Link Selected Samples",
  "nce.button.submit": "Submit NCE",
  "nce.error.numberGeneration": "Failed to generate NCE number. Please try again.",
  "nce.error.unknownOrder": "No order has the lab number {0}.",
  "nce.field.dateOfEvent": "Date of Event",
  "nce.field.description": "Description",
  "nce.field.nceNumber": "NCE Number",
  "nce.field.proposedAction.helper": "Separate from CAPA actions assigned during corrective action workflow",
  "nce.field.proposedAction.placeholder": "Recommended next steps...",
  "nce.field.reporterName": "Reporter Name",
  "nce.field.reportingUnit": "Reporting Unit",
  "nce.field.subcategory": "Subcategory",
  "nce.field.suspectedCauses.helper": "Initial assessment only - formal root cause determined during investigation",
  "nce.field.suspectedCauses.placeholder": "Reporter",
  "nce.form.subtitle": "Document a quality event and link to affected samples and results",
  "nce.form.title": "Report Non-Conformity Event",
  "nce.linkSamples.helper": "Search for orders above to link samples to this NCE. This step is optional.",
  "nce.section.attachments": "Attachments",
  "nce.section.classification": "Classification",
  "nce.section.details": "Details",
  "nce.section.linkSamples": "Link to Samples / Results (Optional)",
  "nce.section.reporterContext": "Reporter & Event Context",
  "nce.select.subcategory": "Select subcategory...",
  "nce.severity.critical.desc": "Patient safety risk, regulatory violation",
  "nce.severity.major.desc": "Significant quality or operational impact",
  "nce.severity.minor.desc": "Limited impact, easily corrected",
  "nonconform.corrective.requiredFields": "Fill all corrective-action fields (action, person responsible, date completed, and at least one action type), or leave the row entirely empty.",
  "nonconform.view.requiredFields": "Lab component, NCE category, NCE type, severity consequence and recurrence are all required.",
  "notebook.sample.create": "Create",
  "notebook.sample.create.title": "Create New Sample",
  "notebook.sample.edit": "Edit",
  "notebook.sample.edit.title": "Edit Sample",
  "notebook.sample.import": "Import",
  "notebook.sample.import.title": "Import Samples",
  "notebook.sample.order.info": "This sample will be associated with the current notebook.",
  "notebook.sample.order.title": "Create Sample for Notebook",
  "notification.warning": "Warning",
  "order.entry.setup.batch": "Batch Order Entry",
  "order.legend.patient1": "Patient Info",
  "pagination.next": "Next page",
  "pagination.previous": "Previous page",
  "patient.fetch.error": "Could not load patient. The id may be invalid or the server is unreachable.",
  "patient.firstName": "First Name",
  "patient.lastName": "Last Name",
  "print.barcode.all": "Print All Barcodes ({count})",
  "sample.item.id": "Sample Item ID",
  "sample.label": "Sample",
  "sample.noPanels": "No panels available for this sample type",
  "sample.noTests": "No tests available for this sample type",
  "sample.testsLoadFailed": "The tests for this sample type could not be loaded.",
  "sample.noTestsMatchSearch": "No tests match your search",
  "sample.noPanelsMatchSearch": "No panels match your search",
  "sample.selectType.first": "Select a sample type above to see available panels and tests",
  "sample.testsCount": "{count} tests available",
  "sample.types": "Samples",
  "sample.referral.listsFailed": "The referral reasons or laboratories could not be loaded. Everything you entered is kept; press Retry to refer a test.",
  "sample.tests.loadFailed": "Tests for {sampleType} could not be loaded.",
  "sample.tests.loadFailed.hint": "Everything you entered is kept. Check the connection or sign in again, then press Retry.",
  "sample.tests.loading": "Loading tests…",
  "save.error.msg": "Error saving",
  "saving.label": "Saving...",
  "select.label.analyzer": "Select Analyzer",
  "site.code": "Code",
  "steps.complete": "steps",
  "storage.audit.empty": "No movements recorded for this sample yet.",
  "storage.audit.empty.title": "No movements",
  "storage.audit.fetch.error": "Could not load audit trail.",
  "storage.audit.fetch.error.title": "Error",
  "storage.audit.from": "From",
  "storage.audit.movedBy": "Moved By",
  "storage.audit.movementDate": "Movement Date",
  "storage.audit.reason": "Reason",
  "storage.audit.to": "To",
  "storage.box.code.helper": "Up to 10 characters",
  "storage.confirm.disposal": "Confirm Disposal",
  "storage.dashboard.title": "Storage",
  "storage.disposal.method": "Disposal Method",
  "storage.disposal.method.placeholder": "Select method...",
  "storage.disposal.notes": "Additional Notes (optional)",
  "storage.disposal.notes.placeholder": "Enter any additional notes...",
  "storage.disposal.reason": "Disposal Reason",
  "storage.disposal.reason.placeholder": "Select reason...",
  "storage.dispose.confirmation": "I confirm that I want to permanently dispose of this sample. This action cannot be undone.",
  "storage.dispose.error": "Disposal failed",
  "storage.dispose.instructions.subtitle": "Please ensure proper disposal procedures are followed according to laboratory safety protocols.",
  "storage.dispose.instructions.title": "Disposal Instructions",
  "storage.dispose.location.note": "Sample will be removed from this location upon disposal",
  "storage.dispose.sample": "Dispose Sample",
  "storage.dispose.sample.subtitle": "Permanently dispose of sample {sampleId}",
  "storage.dispose.warning.subtitle": "The sample will be marked as disposed and removed from storage.",
  "storage.dispose.warning.title": "This action cannot be undone",
  "storage.edit.heading": "Edit {type}",
  "storage.edit.title": "Edit",
  "storage.editbox.heading": "Edit Box",
  "storage.error": "Error",
  "storage.error.save": "Failed to save location",
  "storage.filter.select.location": "Select location...",
  "storage.filter.selected": "Selected:",
  "storage.location.assigned.error": "Failed to assign location",
  "storage.location.assigned.success": "Location assigned successfully",
  "storage.location.created": "{level} created",
  "storage.location.deleted": "{level} deleted",
  "storage.location.no.results": "No locations found",
  "storage.location.type.devices": "devices",
  "storage.location.type.racks": "racks",
  "storage.location.type.rooms": "rooms",
  "storage.location.type.shelves": "shelves",
  "storage.location.updated": "{level} updated",
  "storage.manage.location": "Manage Location",
  "storage.nav.rack": "Rack",
  "storage.sample.actions": "Sample actions",
  "storage.sampleitem.accession": "Sample Accession",
  "storage.sampleitem.location": "Storage location",
  "storage.sampleitem.status": "Status",
  "storage.sampleitem.type": "Type",
  "storage.search.location.label": "Search for a storage location",
  "storage.search.location.placeholder": "Type 2+ characters to search…",
  "storage.skipRemaining": "Skip storage for unassigned samples ({count}) - will be processed immediately",
  "storage.view.audit": "View Audit",
  "storage.view.audit.subtitle": "Movement history for sample {sampleId}",
  "storage.view.audit.title": "Storage Audit Trail",
  "systemDefaultPayloadTemplate.messageTemplate": "Message template",
  "systemDefaultPayloadTemplate.subjectTemplate": "Subject template",
  "tests.count": "{count, plural, one {test} other {tests}}",
  "validation.invalid.ip": "Invalid IP address format (IPv4 or IPv6)",
  "validation.invalid.port": "Port must be between 1 and 65535",
  "validation.required": "This field is required",
  "common.accept": "Accept",
  "common.accessionNumber": "Accession Number",
  "common.action": "Action",
  "common.actions": "Actions",
  "common.active": "Active",
  "common.addTests": "Add Tests",
  "common.aliquots": "aliquots",
  "common.all": "All",
  "common.allStatuses": "All Statuses",
  "common.analyzer": "Analyzer",
  "common.analyzers": "Analyzers",
  "common.auditTrail": "Audit Trail",
  "common.back": "Back",
  "common.boxId": "Box ID",
  "common.byUnit": "By Unit",
  "common.cancel": "Cancel",
  "common.category": "Category",
  "common.clinical": "Clinical",
  "common.code": "Code",
  "common.collected": "Collected",
  "common.collectionDate": "Collection Date",
  "common.complete": "Complete",
  "common.completed": "Completed",
  "common.confirm": "Confirm",
  "common.correctiveActions": "Corrective Actions",
  "common.createAliquot": "Create Aliquot",
  "common.critical": "Critical",
  "common.dashboard": "Dashboard",
  "common.date": "Date",
  "common.dateRange": "Date Range",
  "common.deactivate": "Deactivate",
  "common.delete": "Delete",
  "common.description": "Description",
  "common.draft": "Draft",
  "common.edit": "Edit",
  "common.editOrder": "Edit Order",
  "common.email": "Email",
  "common.enterResults": "Enter Results",
  "common.error": "Error",
  "common.expired": "Expired",
  "common.exportPdf": "Export PDF",
  "common.failed": "Failed",
  "common.filterByStatus": "Filter by Status",
  "common.firstName": "First Name",
  "common.from": "From",
  "common.generateReport": "Generate Report",
  "common.home": "Home",
  "common.inProgress": "In Progress",
  "common.inactive": "Inactive",
  "common.labNumber": "Lab Number",
  "common.lastName": "Last Name",
  "common.loading": "Loading...",
  "common.location": "Location",
  "common.mean": "Mean",
  "common.name": "Name",
  "common.nationalId": "National ID",
  "common.new": "New",
  "common.none": "None",
  "common.normal": "Normal",
  "common.normalRange": "Normal Range",
  "common.notCompleted": "Not Completed",
  "common.notes": "Notes",
  "common.order": "Order",
  "common.overdue": "Overdue",
  "common.panels": "Panels",
  "common.participants": "Participants",
  "common.patient": "Patient",
  "common.pending": "Pending",
  "common.position": "Position",
  "common.printLabel": "Print Label",
  "common.priority": "Priority",
  "common.program": "Program",
  "common.programName": "Program Name",
  "common.provider": "Provider",
  "common.quantity": "Quantity",
  "common.reason": "Reason",
  "common.received": "Received",
  "common.referenceLab": "Reference Lab",
  "common.reject": "Reject",
  "common.remove": "Remove",
  "common.removeSelection": "Remove {name}",
  "common.reports": "Reports",
  "common.requester": "Requester",
  "common.result": "Result",
  "common.results": "Results",
  "common.room": "Room",
  "common.routine": "Routine",
  "common.sample": "Sample",
  "common.sampleId": "Sample ID",
  "common.sampleManagement": "Sample Management",
  "common.sampleType": "Sample Type",
  "common.samples": "Samples",
  "common.samplingSite": "Sampling Site",
  "common.save": "Save",
  "common.saveFailed": "Save failed",
  "common.saving": "Saving...",
  "common.search": "Search",
  "common.select": "Select",
  "common.severity": "Severity",
  "common.siteName": "Site Name",
  "common.species": "Species",
  "common.standard": "Standard",
  "common.status": "Status",
  "common.storageLocation": "Storage Location",
  "common.study": "Study",
  "common.test": "Test",
  "common.testName": "Test Name",
  "common.tests": "Tests",
  "common.type": "Type",
  "common.unit": "Unit",
  "common.user": "User",
  "common.value": "Value",
  "common.view": "View",
  "common.warning": "Warning",
  "label.testCatalog.alerts.field.component": "Result component",
  "label.testCatalog.alerts.field.componentHelp": "Which result this alert watches. Leave unset to watch every component of this test.",
  "label.testCatalog.alerts.field.sampleType": "Sample type",
  "label.testCatalog.alerts.field.sampleTypeHelp": "Which specimen this alert watches. Leave unset to watch every sample type this test runs on.",
  "label.testCatalog.alerts.scope.anyComponent": "Any component",
  "label.testCatalog.alerts.scope.anySampleType": "Any sample type",
  "label.testCatalog.alerts.col.scope": "Applies to",
  "label.testCatalog.alerts.scope.wholeTest": "Whole test",
  "microbiology.ast.breakpointStandard": "Breakpoint standard",
  "microbiology.ast.hint": "Record MIC or zone readings, review interpretations, and document overrides inline.",
  "microbiology.ast.noOverride": "No override",
  "microbiology.ast.reading": "AST reading",
  "microbiology.case.isolates.hint": "Add and identify clinically significant growth before AST.",
  "microbiology.isolate.contaminant": "Contaminant",
  "microbiology.isolate.edit": "Edit isolate",
  "microbiology.isolate.identificationStatus": "Identification status",
  "microbiology.isolate.normalFlora": "Normal flora",
  "microbiology.isolate.organism": "Organism",
  "microbiology.isolate.organism.freeText": "Enter organism as free text",
  "microbiology.isolate.significant": "Clinically significant",
  "microbiology.isolate.unknown": "Unknown",
  "microbiology.isolate.update": "Save identification",
  "microbiology.enum.AST_REVIEW_REQUIRED": "AST Review Required",
  "microbiology.enum.AWAITING_RESULTS": "Awaiting Results",
  "microbiology.enum.ANTIBIOTIC_MAPPING_REQUIRED": "Antibiotic Mapping Required",
  "microbiology.enum.CASE_FINALIZATION_REQUIRED": "Case Finalization Required",
  "microbiology.enum.AMENDED": "Amended",
  "microbiology.enum.AMENDMENT_ACTION_FAILED": "Amendment Action Failed",
  "microbiology.enum.CULTURE_PROTOCOL_CHANGED": "Culture Protocol Changed",
  "microbiology.enum.AMENDMENT_ALREADY_OPEN": "Amendment Already Open",
  "microbiology.enum.AMENDMENT_HISTORY_LOAD_FAILED": "Amendment History Load Failed",
  "microbiology.enum.AMENDMENT_IN_PROGRESS": "Amendment In Progress",
  "microbiology.enum.AMENDMENT_NEW_AST_RUN_REQUIRED": "New AST Run Required for Amendment",
  "microbiology.enum.AMENDMENT_NOT_OPEN": "Amendment Not Open",
  "microbiology.enum.AMENDMENT_REASON_REQUIRED": "Amendment Reason Required",
  "microbiology.enum.AMENDMENT_REQUIRES_FINAL_RELEASE": "Amendment Requires Final Release",
  "microbiology.enum.ACKNOWLEDGED": "Acknowledged",
  "microbiology.enum.AMENDMENT_CANCELLED": "Amendment Cancelled",
  "microbiology.enum.AMENDMENT_OPENED": "Amendment Opened",
  "microbiology.enum.AMENDMENT_RELEASED": "Amendment Released",
  "microbiology.enum.AST_AMENDMENT_SOURCE_MUST_BE_REPORTABLE": "Amendment Source AST Must Be Reportable",
  "microbiology.enum.AST_ANALYZER_FLAGS_ACKNOWLEDGED": "Analyzer Flags Acknowledged",
  "microbiology.enum.AST_ANALYZER_QC_FAILED": "Analyzer QC Failed",
  "microbiology.enum.AST_ANALYZER_RESULTS_RECEIVED": "Analyzer Results Received",
  "microbiology.enum.AST_ATTEMPT_REASON_REQUIRED": "AST Attempt Reason Required",
  "microbiology.enum.AST_ENTRY": "AST Entry",
  "microbiology.enum.AST_IN_PROGRESS": "AST In Progress",
  "microbiology.enum.AST_READY": "AST Ready",
  "microbiology.enum.AST_REPEAT_OR_RETEST_REQUIRED": "Repeat or Retest Required",
  "microbiology.enum.AST_REVIEW": "AST Review",
  "microbiology.enum.AST_REVIEWED": "AST Reviewed",
  "microbiology.enum.AST_READING_OVERRIDDEN": "AST Reading Overridden",
  "microbiology.enum.AST_READING_RECORDED": "AST Reading Recorded",
  "microbiology.enum.AST_REPORTABLE_SELECTED": "Reportable AST Selected",
  "microbiology.enum.AST_RUN_CREATED": "AST Run Created",
  "microbiology.enum.AST_RUN_INVALIDATED": "AST Run Invalidated",
  "microbiology.enum.AST_RUN_METHOD_MISMATCH": "AST Run Method Mismatch",
  "microbiology.enum.AST_QC_OVERRIDDEN": "AST QC Overridden",
  "microbiology.enum.AST_SETUP_UNAVAILABLE": "AST Setup Unavailable",
  "microbiology.enum.AST_SOURCE_RUN_REVIEW_REQUIRED": "AST Source Run Review Required",
  "microbiology.enum.ANALYZER": "Analyzer",
  "microbiology.enum.BROTH_MICRODILUTION": "Broth Microdilution",
  "microbiology.enum.CASE": "Case",
  "microbiology.enum.CASE_CREATED": "Case Created",
  "microbiology.enum.CASE_REVIEW": "Case Review",
  "microbiology.enum.CANCELLED": "Cancelled",
  "microbiology.enum.CLINICALLY_SIGNIFICANT": "Clinically significant",
  "microbiology.enum.CLOSED": "Closed",
  "microbiology.enum.CONFIRMED": "Confirmed",
  "microbiology.enum.CONTAMINANT": "Contaminant",
  "microbiology.enum.CRITICAL_COMMUNICATION_ACKNOWLEDGED": "Critical Communication Acknowledged",
  "microbiology.enum.CRITICAL_COMMUNICATION_CLOSED": "Critical Communication Closed",
  "microbiology.enum.CRITICAL_COMMUNICATION_LOGGED": "Critical Communication Logged",
  "microbiology.enum.CRITICAL_FOLLOW_UP_REQUIRED": "Critical Follow-Up Required",
  "microbiology.enum.DISK_DIFFUSION": "Disk Diffusion",
  "microbiology.enum.EMAIL": "Email",
  "microbiology.enum.EMERGENCY": "Emergency",
  "microbiology.enum.ETEST": "Etest",
  "microbiology.enum.FAILED": "Failed",
  "microbiology.enum.FINAL": "Final",
  "microbiology.enum.FINAL_REPORT_RELEASED": "Final Report Released",
  "microbiology.enum.GROWTH_DETECTED": "Growth Detected",
  "microbiology.enum.HIGH": "High",
  "microbiology.enum.IDENTIFICATION": "Identification",
  "microbiology.enum.ICU": "ICU",
  "microbiology.enum.INCUBATING": "Incubating",
  "microbiology.enum.INPATIENT": "Inpatient",
  "microbiology.enum.IN_PROGRESS": "In Progress",
  "microbiology.enum.MALDI_TOF": "MALDI-TOF",
  "microbiology.enum.IN_PERSON": "In Person",
  "microbiology.enum.INOCULATION_RECORDED": "Inoculation Recorded",
  "microbiology.enum.ISOLATE": "Isolate",
  "microbiology.enum.ISOLATE_CREATED": "Isolate Created",
  "microbiology.enum.ISOLATE_ID": "Isolate ID",
  "microbiology.enum.ISOLATE_REQUIRED": "Isolate Required",
  "microbiology.enum.ISOLATE_UPDATED": "Isolate Updated",
  "microbiology.enum.LEGACY_UNSPECIFIED_MIC": "Unspecified MIC Technique",
  "microbiology.enum.LEGACY_UNSPECIFIED_ZONE": "Unspecified Zone Technique",
  "microbiology.enum.MANUAL_NOTE": "Manual Note",
  "microbiology.enum.MANUAL_ENTRY": "Manual Entry",
  "microbiology.enum.MIC": "MIC",
  "microbiology.enum.MICROBIOLOGY_INOCULATION_AUDIT_SERIALIZATION_FAILED": "Inoculation Audit Could Not Be Recorded",
  "microbiology.enum.MICROBIOLOGY_PROTOCOL_AUDIT_SERIALIZATION_FAILED": "Protocol Audit Could Not Be Recorded",
  "microbiology.enum.MICROBIOLOGY_PROTOCOL_UNCHANGED": "Select a Different Protocol",
  "microbiology.enum.MICROBIOLOGY_PROTOCOL_WORKFLOW_REQUIRED": "Assign a Workflow Before Selecting a Protocol",
  "microbiology.enum.MICROBIOLOGY_SUBCULTURE_SOURCE_CASE_MISMATCH": "Subculture Source Must Belong to This Case",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_AUDIT_SERIALIZATION_FAILED": "Workflow Audit Could Not Be Recorded",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_CHANGE_CONFIRMATION_REQUIRED": "Confirm Preservation of Existing Work",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_CLASSIFICATION_REQUIRED": "Workflow Classification Required",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_METHOD_INCOMPATIBLE": "Culture Method Is Not Compatible with the Workflow",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_NOT_SUPPORTED": "Workflow Is Not Supported",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_SIBLING_EXISTS": "A Case Already Exists for This Workflow",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_UNCHANGED": "Select a Different Workflow",
  "microbiology.enum.NO_GROWTH_READY": "No Growth Ready",
  "microbiology.enum.NORMAL_FLORA": "Normal flora",
  "microbiology.enum.NEEDS_WORKFLOW": "Needs Workflow",
  "microbiology.enum.NOT_READY": "Not Ready",
  "microbiology.enum.NONCONFORMANCE_REPORTED": "Nonconformance Reported",
  "microbiology.enum.NONE": "None",
  "microbiology.enum.OPEN": "Open",
  "microbiology.enum.ORGANISM_MAPPING_REQUIRED": "Organism Mapping Required",
  "microbiology.enum.ORGANISM": "Organism",
  "microbiology.enum.ORIGINAL": "Original",
  "microbiology.enum.OTHER": "Other",
  "microbiology.enum.OUTPATIENT": "Outpatient",
  "microbiology.enum.PENDING": "Pending",
  "microbiology.enum.PASSED": "Passed",
  "microbiology.enum.PHOENIX": "Phoenix",
  "microbiology.enum.PHONE": "Phone",
  "microbiology.enum.POSITIVE_SIGNAL": "Positive Signal",
  "microbiology.enum.PRELIM_RELEASED": "Preliminary Released",
  "microbiology.enum.PRELIMINARY": "Preliminary",
  "microbiology.enum.PRELIMINARY_RELEASED": "Preliminary Released",
  "microbiology.enum.PRELIMINARY_REPORT_RELEASED": "Preliminary Report Released",
  "microbiology.enum.QC_FAILED": "QC Failed",
  "microbiology.enum.RECEIVED": "Received",
  "microbiology.enum.RELEASED": "Released",
  "microbiology.enum.REPEAT": "Repeat",
  "microbiology.enum.REPORTABLE_AST_RUN_REQUIRED": "Reportable AST Run Required",
  "microbiology.enum.REPORTABLE_AST_RUN_MUST_BE_REVIEWED": "Reportable AST Run Must Be Reviewed",
  "microbiology.enum.RESULT": "Result",
  "microbiology.enum.RESULTS_IN": "Results In",
  "microbiology.enum.RETEST": "Retest",
  "microbiology.enum.REVIEW_READY": "Review Ready",
  "microbiology.enum.REVIEWED": "Reviewed",
  "microbiology.enum.INTERMEDIATE": "Intermediate",
  "microbiology.enum.LOST_SPECIMEN": "Lost Specimen",
  "microbiology.enum.LOST_SPECIMEN_POSITIVE": "Lost Specimen - Positive Culture",
  "microbiology.enum.NO_BREAKPOINT": "No breakpoint",
  "microbiology.enum.RESISTANT": "Resistant",
  "microbiology.enum.ROUTINE": "Routine",
  "microbiology.enum.SAMPLE_ITEM": "Sample Item",
  "microbiology.enum.SETUP": "Setup",
  "microbiology.enum.SETUP_RECORDED": "Setup Recorded",
  "microbiology.enum.SMS": "SMS",
  "microbiology.enum.SPECIMEN_LOST": "Specimen Lost",
  "microbiology.enum.STAGE_CHANGED": "Stage Changed",
  "microbiology.enum.SUBCULTURE_RECORDED": "Subculture Recorded",
  "microbiology.enum.UNASSIGNED": "Unassigned",
  "microbiology.enum.UNKNOWN_ERROR": "Unknown Error",
  "microbiology.enum.VITEK_2": "VITEK 2",
  "microbiology.enum.WORKFLOW_CHANGED": "Workflow Changed",
  "microbiology.enum.ZONE": "Zone",
  "microbiology.enum.FINAL_RELEASED": "Final Released",
  "microbiology.enum.SUSCEPTIBLE": "Susceptible",
  "microbiology.enum.UNKNOWN": "Unknown",
  "rulebuilder.label.selectComponent": "Select Component",
  "testcalculation.label.selectComponent": "Select Component",
  "testcalculation.label.finalComponent": "Result Component",
  "qc.dashboard.tab.bench": "Bench QC",
  "qc.bench.source.all": "All bench sources",
  "qc.bench.source.manual": "Manual quantitative",
  "qc.bench.source.rdt": "Rapid test (RDT)",
  "qc.bench.column.runs": "Controls run",
  "qc.bench.column.lastRun": "Last run",
  "qc.bench.empty": "No manual or rapid-test controls were recorded in this period.",
  "microbiology.case.activityNote": "Activity note",
  "microbiology.case.accessionNumber": "Accession number",
  "microbiology.case.actionError": "Culture action could not be completed",
  "microbiology.case.action.markNoGrowth": "Mark no growth ready",
  "microbiology.case.action.recordGrowth": "Record growth detected",
  "microbiology.case.action.rejectCase": "Reject case",
  "microbiology.case.action.setIncubating": "Set incubating",
  "microbiology.case.action.startInoculation": "Start inoculation",
  "microbiology.case.createIsolate": "Create isolate",
  "microbiology.case.cultureAction": "Culture action",
  "microbiology.case.atmosphere": "Atmosphere",
  "microbiology.case.eyebrow": "Microbiology case workbench",
  "microbiology.case.sectionExpanded": "{section} expanded",
  "microbiology.case.sectionStatus": "Section status",
  "microbiology.case.error": "Microbiology case error",
  "microbiology.case.isolateLabel": "Isolate label",
  "microbiology.case.isolates": "Isolates",
  "microbiology.case.isolates.empty": "No isolates recorded",
  "microbiology.case.loadError": "Unable to load microbiology case",
  "microbiology.case.lastActivityBy": "Last activity by",
  "microbiology.case.incubation": "Incubation",
  "microbiology.case.media": "Media or bottle",
  "microbiology.case.nextStage": "Next stage",
  "microbiology.case.patient": "Patient",
  "microbiology.case.nonconformanceCount": "{count, plural, one {# NCE} other {# NCEs}}",
  "microbiology.case.relatedWorkflows": "Related specimen workflows",
  "microbiology.case.requestingLocation": "Requesting location",
  "microbiology.case.preliminaryOrganism": "Preliminary organism",
  "microbiology.case.recordActivity": "Record activity",
  "microbiology.case.sampleItem": "Sample item",
  "microbiology.case.setup": "Inoculation",
  "microbiology.case.setup.hint": "Record the initial setup, media, or incubation step for this culture case.",
  "microbiology.case.significance": "Significance",
  "microbiology.case.specimenType": "Specimen type",
  "microbiology.case.timeline": "Case timeline",
  "microbiology.case.timeline.addNote": "Add note",
  "microbiology.case.timeline.auto": "Auto",
  "microbiology.case.timeline.culturePurposeChange": "{from} to {to}",
  "microbiology.case.timeline.culturePurposeChanged": "Culture purpose changed",
  "microbiology.case.timeline.empty": "No case activity recorded",
  "microbiology.case.timeline.hint": "Recorded case activity is shown chronologically.",
  "microbiology.case.timeline.manual": "Manual",
  "microbiology.case.timeline.note": "Note or observation",
  "microbiology.case.timeline.noteExpanded": "Note form expanded",
  "microbiology.case.timeline.performedBy": "Performed by {actor}",
  "microbiology.case.timeline.saveNote": "Save note",
  "microbiology.case.timeline.showAll": "Show all {count} events",
  "microbiology.case.timeline.showRecent": "Show recent {count} events",
  "microbiology.case.events": "events",
  "microbiology.case.finalLocked.message": "Isolate and AST changes are disabled after final release.",
  "microbiology.case.finalLocked.title": "Final case is read-only",
  "microbiology.case.title": "Microbiology case",
  "microbiology.inoculation.addSubculture": "Add subculture",
  "microbiology.inoculation.empty": "No media recorded yet. Start inoculation to begin.",
  "microbiology.inoculation.hint": "Record each bottle or plate and retain its culture lineage.",
  "microbiology.inoculation.identifier": "Bottle or plate ID",
  "microbiology.inoculation.identifierHint": "Scan or type the identifier.",
  "microbiology.inoculation.parent": "Parent media",
  "microbiology.inoculation.parentPlaceholder": "Choose the source bottle or plate",
  "microbiology.inoculation.primaryExpanded": "Inoculation form expanded",
  "microbiology.inoculation.primary": "Primary",
  "microbiology.inoculation.recorded": "Recorded media",
  "microbiology.inoculation.save": "Save media",
  "microbiology.inoculation.source": "Source",
  "microbiology.inoculation.start": "Start inoculation",
  "microbiology.inoculation.subcultureExpanded": "Subculture form expanded",
  "microbiology.inoculation.subculture": "Subculture",
  "microbiology.amendment.actionError": "Amendment action could not be completed",
  "microbiology.amendment.cancel": "Cancel amendment",
  "microbiology.amendment.cancelReason": "Cancellation reason",
  "microbiology.amendment.cancelled": "Amendment cancelled; the final case is locked again",
  "microbiology.amendment.correctsVersion": "Corrects version {number}",
  "microbiology.amendment.hint": "Correct a final report without replacing its released history.",
  "microbiology.amendment.history": "Amendment history",
  "microbiology.amendment.inProgress.message": "Record the correction and release or cancel this amendment to lock the case again.",
  "microbiology.amendment.inProgress.title": "Amendment in progress",
  "microbiology.amendment.noReportVersions": "No final report versions recorded",
  "microbiology.amendment.none": "No amendments recorded",
  "microbiology.amendment.number": "Amendment",
  "microbiology.amendment.numberValue": "Amendment {number}",
  "microbiology.amendment.open": "Open amendment",
  "microbiology.amendment.opened": "Amendment opened; clinical corrections are now enabled",
  "microbiology.amendment.reason": "Amendment reason",
  "microbiology.amendment.release": "Release amended report",
  "microbiology.amendment.released": "Amended report released; the case is locked again",
  "microbiology.amendment.reportVersions": "Released report versions",
  "microbiology.amendment.status": "Status",
  "microbiology.amendment.status.closed": "No open amendment",
  "microbiology.amendment.status.open": "Open amendment",
  "microbiology.amendment.title": "Amendments",
  "microbiology.amendment.version": "Version {number}",
  "microbiology.ast.antibiotic": "Antibiotic",
  "microbiology.ast.acceptResults": "Accept results",
  "microbiology.ast.acknowledgeFlags": "Acknowledge reviewed flags",
  "microbiology.ast.analyzer": "Analyzer",
  "microbiology.ast.analyzerOrganism": "Analyzer organism: {organism} ({confidence}%)",
  "microbiology.ast.analyzerProvenance": "Card or panel {card} · software {version}",
  "microbiology.ast.analyzerResolutionReason": "Reason and corrective action",
  "microbiology.ast.actionError": "AST action could not be completed",
  "microbiology.ast.adjustPanel": "Adjust panel",
  "microbiology.ast.orderedAntibiotics": "Antibiotics to test",
  "microbiology.ast.actions": "Actions",
  "microbiology.ast.applyOverride": "Apply override",
  "microbiology.ast.attempt": "Attempt",
  "microbiology.ast.attemptMethod": "Attempt method",
  "microbiology.ast.attemptNumber": "Attempt {number}",
  "microbiology.ast.attemptReason": "Reason",
  "microbiology.ast.attemptScope": "Repeat scope",
  "microbiology.ast.attempts": "AST attempts",
  "microbiology.ast.attemptType": "Attempt type",
  "microbiology.ast.awaitingAnalyzerResults": "Awaiting analyzer results",
  "microbiology.ast.awaitingAnalyzerResultsDetail": "Results will appear automatically when the connected analyzer sends them. Unmatched events are retained in Analyzer Import Issues.",
  "microbiology.ast.awaitingSetupCount": "{count} awaiting setup",
  "microbiology.ast.cardId": "Card or panel ID",
  "microbiology.ast.entryMode": "Result entry",
  "microbiology.ast.entryMode.analyzer": "Connected analyzer",
  "microbiology.ast.entryMode.manual": "Manual entry",
  "microbiology.ast.expertFlags": "Analyzer expert flags require review",
  "microbiology.ast.hideOriginal": "Hide history",
  "microbiology.ast.historyTo": "to",
  "microbiology.ast.interpretation": "Interpretation",
  "microbiology.ast.instrumentInterpretation": "Analyzer: {interpretation}",
  "microbiology.ast.invalidateAndRepeat": "Invalidate and start new run",
  "microbiology.ast.includedInReport": "Included in report",
  "microbiology.ast.initialAttemptReason": "Initial attempt",
  "microbiology.ast.isolate": "Isolate",
  "microbiology.ast.method": "Method",
  "microbiology.ast.matchedBy": "Matched breakpoint",
  "microbiology.ast.measurement.mic": "MIC (ug/mL)",
  "microbiology.ast.measurement.zone": "Zone diameter (mm)",
  "microbiology.ast.noBreakpointGuidance": "No standard breakpoint. Interpret this reading according to the local SOP.",
  "microbiology.ast.noBreakpointTitle": "Local interpretation required",
  "microbiology.ast.noIsolate": "Create an isolate before recording AST",
  "microbiology.ast.noSourceAttempt": "Original attempt",
  "microbiology.ast.notIncludedInReport": "Not included",
  "microbiology.ast.newAttempt": "New repeat or retest",
  "microbiology.ast.noRunsYet": "No runs yet",
  "microbiology.ast.antibioticToRepeat": "Antibiotic to repeat",
  "microbiology.ast.override": "Override interpretation",
  "microbiology.ast.overrideHistory": "Override history",
  "microbiology.ast.optionsExpanded": "{section} options expanded.",
  "microbiology.ast.overrideReason": "Override reason",
  "microbiology.ast.orderedPanel": "Ordered AST panel",
  "microbiology.ast.organismMismatch": "Analyzer organism differs from the case isolate",
  "microbiology.ast.organismMismatchDetail": "The analyzer identity is informational. Review the discrepancy; the confirmed case isolate remains authoritative.",
  "microbiology.ast.overrideQc": "Override QC flag",
  "microbiology.ast.panel": "AST panel",
  "microbiology.ast.panelAdjustmentReason": "Reason for panel adjustment",
  "microbiology.ast.panelProvenance.organismDefault": "Ordered from the identified organism's configured default",
  "microbiology.ast.rawValue": "Result value",
  "microbiology.ast.qcFailed": "Analyzer QC failed",
  "microbiology.ast.qcFailedDetail": "QC reference {reference}. Result acceptance is blocked until this run is invalidated or a supervisor documents an override.",
  "microbiology.ast.replacementCardId": "New card or panel ID",
  "microbiology.ast.resultsReady": "Analyzer results ready for review",
  "microbiology.ast.resultsReadyDetail": "Review discrepancies, missing breakpoints, and expert flags before accepting these results.",
  "microbiology.ast.runsComplete": "{complete} / {total} runs complete",
  "microbiology.ast.pendingIdentificationCount": "{count} pending identification",
  "microbiology.ast.reasonForAttempt": "Reason for repeat or retest",
  "microbiology.ast.recordReading": "Record AST reading",
  "microbiology.ast.reviewRun": "Review AST run",
  "microbiology.ast.repeat": "Repeat",
  "microbiology.ast.revertOverride": "Revert to original",
  "microbiology.ast.revertReason": "Reason for reverting override",
  "microbiology.ast.reporting": "Reporting",
  "microbiology.ast.retest": "Retest",
  "microbiology.ast.selectAntibiotic": "Select antibiotic",
  "microbiology.ast.singleAntibiotic": "Single antibiotic",
  "microbiology.ast.wholePanel": "Whole panel",
  "microbiology.ast.runStatus": "AST run status",
  "microbiology.ast.startRun": "Start AST run",
  "microbiology.ast.startAttempt": "Start {type} attempt",
  "microbiology.ast.sourceAttempt": "Source",
  "microbiology.ast.source": "Reading source",
  "microbiology.ast.showOriginal": "Show original",
  "microbiology.ast.title": "Manual AST",
  "microbiology.ast.useAttemptForReporting": "Use attempt {number} for reporting",
  "microbiology.ast.useForReporting": "Use for reporting",
  "microbiology.ast.view": "View",
  "microbiology.ast.viewAttempt": "View attempt {number}",
  "microbiology.ast.viewing": "Viewing",
  "microbiology.ast.viewingAttempt": "Viewing attempt {number}",
  "microbiology.critical.acknowledge": "Acknowledge",
  "microbiology.critical.followUp": "Follow-up needed",
  "microbiology.critical.hint": "Log critical-result callbacks and acknowledge them inline.",
  "microbiology.critical.log": "Log communication",
  "microbiology.critical.logForIsolate": "Log critical notification for {isolate}",
  "microbiology.critical.logNotification": "Log critical notification",
  "microbiology.critical.method": "Communication method",
  "microbiology.critical.message": "Message",
  "microbiology.critical.messageRequired": "Message is required",
  "microbiology.critical.none": "No critical communications logged",
  "microbiology.critical.recipient": "Recipient",
  "microbiology.critical.recipientContact": "Recipient contact",
  "microbiology.critical.required": "Choose a target and provide the recipient and message.",
  "microbiology.critical.resolution": "Resolution note",
  "microbiology.critical.resolutionRequired": "A resolution note is required before closing communication.",
  "microbiology.critical.close": "Close communication",
  "microbiology.critical.target": "Critical result target",
  "microbiology.critical.targetId": "Target record",
  "microbiology.critical.title": "Critical communication",
  "microbiology.caseInfo.no": "No",
  "microbiology.caseInfo.notProvided": "Not provided",
  "microbiology.caseInfo.summary": "Case information summary",
  "microbiology.caseInfo.yes": "Yes",
  "microbiology.currentStep.open": "Open {step}",
  "microbiology.currentStep.title": "Current step",
  "microbiology.cultureAction.error": "The culture state could not be updated.",
  "microbiology.cultureAction.noGrowth.confirm": "Confirm no growth",
  "microbiology.cultureAction.noGrowth.detail": "Confirm that the required incubation period is complete and no growth was detected.",
  "microbiology.cultureAction.noGrowth.title": "Mark culture as no growth",
  "microbiology.cultureAction.positive.confirm": "Confirm positive signal",
  "microbiology.cultureAction.positive.detail": "Confirm the positive signal. The next action is to subculture and record the Gram stain.",
  "microbiology.cultureAction.positive.title": "Mark culture positive",
  "microbiology.nce.category": "Category",
  "microbiology.nce.configurationBlockerTitle": "Configuration required",
  "microbiology.nce.configurationLoadError": "NCE categories and reporting units could not be loaded.",
  "microbiology.nce.critical": "Critical",
  "microbiology.nce.description": "Description",
  "microbiology.nce.disposition": "Disposition",
  "microbiology.nce.errorTitle": "Nonconformance could not be reported",
  "microbiology.nce.flagOnly": "Flag only",
  "microbiology.nce.immediateAction": "Immediate action",
  "microbiology.nce.lostTypeMissing": "The active NCE configuration does not include a Specimen lost type.",
  "microbiology.nce.major": "Major",
  "microbiology.nce.markLost": "Mark lost",
  "microbiology.nce.markLostHint": "Record the physical specimen as lost and reject affected open tests.",
  "microbiology.nce.markLostTitle": "Mark specimen lost",
  "microbiology.nce.minor": "Minor",
  "microbiology.nce.rejectTests": "Reject affected tests",
  "microbiology.nce.retest": "Retest AST",
  "microbiology.nce.retestLoadError": "Reviewed AST runs could not be loaded. Try again before selecting Retest AST.",
  "microbiology.nce.sourceAstRun": "AST run to retest",
  "microbiology.nce.report": "Report NCE",
  "microbiology.nce.reportHint": "Record a nonconformance against this specimen and choose its disposition.",
  "microbiology.nce.reportingUnit": "Reporting unit",
  "microbiology.nce.reportTitle": "Report nonconformance",
  "microbiology.nce.required": "Choose a category, reporting unit, and severity, and provide a description.",
  "microbiology.nce.sectionTitle": "Nonconformance",
  "microbiology.nce.severity": "Severity",
  "microbiology.nce.submitError": "The nonconformance could not be saved.",
  "microbiology.nce.title": "Title",
  "microbiology.nce.type": "Type",
  "microbiology.isolate.identify": "Identify organism",
  "microbiology.isolate.reidentify": "Reidentify",
  "microbiology.isolate.identified": "Identified",
  "microbiology.isolate.pending": "Identification pending",
  "microbiology.isolate.gramStain": "Gram stain",
  "microbiology.isolate.colonyMorphology": "Colony morphology",
  "microbiology.isolate.identification": "Identification",
  "microbiology.isolate.identificationMethod": "ID method",
  "microbiology.isolate.identificationConfidence": "ID confidence (%)",
  "microbiology.isolate.identificationChange": "{previous} to {next}: {reason}",
  "microbiology.isolate.identificationHistory": "Identification history",
  "microbiology.isolate.identificationReason": "Re-identification reason",
  "microbiology.isolate.organism.select": "Select an organism",
  "microbiology.isolate.unidentified": "Unidentified",
  "microbiology.ast.identificationRequired": "Identify the isolate before setting up AST.",
  "microbiology.next.createIsolate": "Inoculation recorded. Add significant growth or mark the case ready for no-growth handling.",
  "microbiology.next.completeAmendment": "Amendment open. Record the correction, review the report, then release the amended version.",
  "microbiology.next.finalReleased": "Final report released. Review surveillance readiness before export.",
  "microbiology.next.incubating": "Incubating. Mark the case positive when growth is signaled, or mark no growth when the required incubation period is complete.",
  "microbiology.next.subculturePositive": "Positive signal recorded. Subculture the bottle and record the Gram stain.",
  "microbiology.next.recordSetup": "Case received. Record initial setup to begin incubation.",
  "microbiology.next.release": "AST reviewed. Confirm report readiness and release the final report.",
  "microbiology.next.noGrowthRelease": "No growth recorded. Review and release the final negative report.",
  "microbiology.next.reviewAst": "Isolate recorded. Complete and review AST before release.",
  "microbiology.next.title": "Next step",
  "microbiology.navigation.backToWorklist": "Back to microbiology worklist",
  "microbiology.navigation.menu": "Microbiology",
  "microbiology.navigation.worklist": "Microbiology worklist",
  "order.context.workflowProgress": "Order workflow progress",
  "microbiology.culturePurpose.clinical": "Clinical diagnosis or treatment",
  "microbiology.culturePurpose.label": "Culture purpose",
  "microbiology.culturePurpose.screening": "Active screening or carriage",
  "microbiology.culturePurpose.unspecified": "Unspecified",
  "microbiology.orderDetail.antibioticExposure": "Patient has recent antibiotic exposure (within 2 weeks)",
  "microbiology.orderDetail.admissionDate": "Date of admission",
  "microbiology.orderDetail.admissionDateFuture": "Date of admission cannot be in the future.",
  "microbiology.orderDetail.admissionDateHelper": "Date admitted as an inpatient. Leave blank when it is not known.",
  "microbiology.orderDetail.admissionDateOutpatient": "Outpatients are not admitted - recorded as community-origin.",
  "microbiology.orderDetail.collectionDateContext": "Collection date: {date}",
  "microbiology.orderDetail.collectionTimingHospital": "Collected {days} days after admission - hospital-origin for surveillance.",
  "microbiology.orderDetail.collectionTimingCommunity": "Collected {days} days after admission - community-origin for surveillance.",
  "microbiology.orderDetail.clinicalHistory": "Clinical history",
  "microbiology.orderDetail.cultureMethod": "Culture Protocol",
  "microbiology.orderDetail.hint": "Capture the order context the lab needs for culture setup and critical-result follow-up.",
  "microbiology.orderDetail.numberOfSets": "Number of sets",
  "microbiology.orderDetail.numberOfSets.helper": "Collection groups, such as two blood-culture sets drawn from different sites. Not the specimen count or volume.",
  "microbiology.orderDetail.patientOrigin": "Patient origin",
  "microbiology.orderDetail.protocolDerived": "Derived",
  "microbiology.orderDetail.protocolHelper": "From the ordered test. Change it at the bench if the workup differs.",
  "microbiology.orderDetail.protocolUnset": "Not set - the bench will select a protocol",
  "microbiology.orderDetail.protocolUnsetTitle": "Protocol not set",
  "microbiology.orderDetail.save": "Save order detail",
  "microbiology.orderDetail.title": "Order detail",
  "microbiology.patientOrigin.emergency": "Emergency department",
  "microbiology.patientOrigin.icu": "Intensive care unit",
  "microbiology.patientOrigin.inpatient": "Inpatient ward",
  "microbiology.patientOrigin.other": "Other",
  "microbiology.patientOrigin.outpatient": "Outpatient clinic",
  "microbiology.progress.ast": "AST results",
  "microbiology.progress.caseInfo": "Case info",
  "microbiology.progress.inoculation": "Inoculation",
  "microbiology.progress.isolates": "Isolates",
  "microbiology.progress.reports": "Reports",
  "microbiology.progress.review": "Expert review",
  "microbiology.progress.timeline": "Timeline",
  "microbiology.progress.title": "Case progress",
  "microbiology.protocol.noneTitle": "No protocol set",
  "microbiology.case.timeline.protocolChanged": "Culture protocol changed from {from} to {to}: {reason}",
  "microbiology.readiness.blocked": "Final release blocked",
  "microbiology.readiness.ready": "Final release ready",
  "microbiology.reagentLots.blocked": "Blocked: {reason}",
  "microbiology.reagentLots.context": "Bench context",
  "microbiology.reagentLots.context.AST_SETUP": "AST setup",
  "microbiology.reagentLots.context.CULTURE_SETUP": "Culture setup",
  "microbiology.reagentLots.empty": "No reagents are linked to this test.",
  "microbiology.reagentLots.fefo": "FEFO - use first",
  "microbiology.reagentLots.fifo.tooltip": "Lots are ordered by earliest expiry, then by receipt date when expiry is unavailable.",
  "microbiology.reagentLots.hint": "Select the exact lot used for each linked reagent or consumable.",
  "microbiology.reagentLots.history": "Recorded lot usage",
  "microbiology.reagentLots.legend": "Available lots for {reagent}",
  "microbiology.reagentLots.lot": "Lot",
  "microbiology.reagentLots.noExpiry": "No expiry recorded",
  "microbiology.reagentLots.noLots": "No inventory lots are available for this reagent.",
  "microbiology.reagentLots.option": "{lot}, {quantity} {unit} available, expires {expiration}",
  "microbiology.reagentLots.quantity": "{quantity} {unit}",
  "microbiology.reagentLots.quantityPerTest": "Quantity per test: {quantity} {unit}",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_EXPIRED": "{reagent} lot {lot} expired; pick another lot.",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_INSUFFICIENT_QUANTITY": "{reagent} lot {lot} no longer has enough quantity; pick another lot.",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_QC_FAILED": "{reagent} lot {lot} failed QC; pick a QC-passed lot.",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_QC_NOT_PASSED": "{reagent} lot {lot} has not passed QC; pick a QC-passed lot.",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_UNAVAILABLE": "{reagent} lot {lot} is no longer available; refresh and pick another lot.",
  "microbiology.reagentLots.qc.FAILED": "QC failed",
  "microbiology.reagentLots.qc.PASSED": "QC passed",
  "microbiology.reagentLots.qc.PENDING": "QC pending",
  "microbiology.reagentLots.qc.QUARANTINED": "QC quarantined",
  "microbiology.reagentLots.reason.INVENTORY_LOT_CONSUMED": "Consumed",
  "microbiology.reagentLots.reason.INVENTORY_LOT_EXPIRED": "Expired",
  "microbiology.reagentLots.reason.INVENTORY_LOT_INACTIVE": "Inactive",
  "microbiology.reagentLots.reason.INVENTORY_LOT_INSUFFICIENT_QUANTITY": "Insufficient quantity",
  "microbiology.reagentLots.reason.INVENTORY_LOT_QC_FAILED": "QC failed",
  "microbiology.reagentLots.reason.INVENTORY_LOT_QC_NOT_PASSED": "QC not passed",
  "microbiology.reagentLots.reagent": "Reagent or consumable",
  "microbiology.reagentLots.recorded": "Recorded",
  "microbiology.reagentLots.role.PRIMARY": "Primary",
  "microbiology.reagentLots.role.SECONDARY": "Secondary",
  "microbiology.reagentLots.scan.ambiguous": "That lot number matches more than one linked reagent. Select the lot in its reagent list.",
  "microbiology.reagentLots.scan.label": "Scan or enter lot number",
  "microbiology.reagentLots.scan.notFound": "No linked lot matches that lot number.",
  "microbiology.reagentLots.scan.placeholder": "Scan or enter the exact lot number",
  "microbiology.reagentLots.scan.selected": "Selected lot {lot}.",
  "microbiology.reagentLots.status": "Current lot status",
  "microbiology.reagentLots.status.ACTIVE": "Active",
  "microbiology.reagentLots.status.CONSUMED": "Consumed",
  "microbiology.reagentLots.status.IN_USE": "In use",
  "microbiology.reagentLots.title": "Reagent and lot traceability",
  "microbiology.reagentLots.used": "Quantity used",
  "microbiology.release.failed": "The report could not be released. Review the requirements and try again.",
  "microbiology.release.final": "Release final report",
  "microbiology.release.finalReleased": "Final report released",
  "microbiology.release.hint": "Release reports only when readiness checks pass.",
  "microbiology.release.mappingConfigured": "Patient-report mapping configured",
  "microbiology.release.mappingRequired": "Patient-report mapping required for final release",
  "microbiology.release.noReportableContent": "No reportable microbiology content is ready.",
  "microbiology.release.notEvaluated": "Readiness has not been evaluated yet",
  "microbiology.release.patientReport": "Patient report preview",
  "microbiology.release.preliminary": "Release preliminary report",
  "microbiology.release.readinessChecks": "Final release readiness",
  "microbiology.release.title": "Report readiness",
  "microbiology.release.viewPatientResults": "View patient results",
  "microbiology.release.useAmendment": "Release the corrected version from Amendments",
  "microbiology.release.whonetChecks": "WHONET readiness",
  "microbiology.whonet.blocked": "WHONET export blocked",
  "microbiology.whonet.ready": "WHONET export ready",
  "microbiology.worklist.clearFilters": "Clear filters",
  "microbiology.worklist.column.action": "Action",
  "microbiology.worklist.column.context": "Context",
  "microbiology.worklist.column.due": "Due action",
  "microbiology.worklist.column.flags": "Flags",
  "microbiology.worklist.column.isolate": "Isolate",
  "microbiology.worklist.column.labNumber": "Lab #",
  "microbiology.worklist.column.lastActivity": "Last activity by",
  "microbiology.worklist.column.organism": "Organism",
  "microbiology.worklist.column.panel": "Panel",
  "microbiology.worklist.column.patient": "Patient",
  "microbiology.worklist.column.priority": "Priority",
  "microbiology.worklist.column.sample": "Sample item",
  "microbiology.worklist.column.specimen": "Specimen",
  "microbiology.worklist.column.stage": "Stage",
  "microbiology.worklist.column.started": "Started",
  "microbiology.worklist.column.status": "Status",
  "microbiology.worklist.column.urgency": "Urgency",
  "microbiology.worklist.critical": "Critical communication",
  "microbiology.worklist.dueDetail.ast_entry": "Set up AST for the identified isolate.",
  "microbiology.worklist.dueDetail.ast_review": "Review reported susceptibility results.",
  "microbiology.worklist.dueDetail.case_review": "Review report readiness and release.",
  "microbiology.worklist.dueDetail.isolate_id": "Record growth and identify an isolate.",
  "microbiology.worklist.dueDetail.incubating": "Day {day} of {max}",
  "microbiology.worklist.dueDetail.setup": "Record initial culture setup.",
  "microbiology.worklist.dueDetail.subculture_gram_stain": "Subculture and record the Gram stain.",
  "microbiology.worklist.empty.ast": "No AST runs match. Clear the search or choose a different status.",
  "microbiology.worklist.empty.cultures": "No cultures match. Clear the search or choose a different status.",
  "microbiology.worklist.expertRulesUnavailable": "OpenELIS expert-rule flags are available in Phase 1B. Analyzer-reported flags are shown when present.",
  "microbiology.worklist.filters": "Worklist filters",
  "microbiology.worklist.filter.allActions": "All actions",
  "microbiology.worklist.filter.allStages": "All stages",
  "microbiology.worklist.filter.allUrgencies": "All urgency levels",
  "microbiology.worklist.filter.activeAst": "Active work",
  "microbiology.worklist.filter.astStatus": "AST status",
  "microbiology.worklist.filter.dueAction": "Due action",
  "microbiology.worklist.filter.reviewed": "Reviewed",
  "microbiology.worklist.filter.stage": "Stage",
  "microbiology.worklist.filter.urgency": "Urgency",
  "microbiology.worklist.flagsUnavailable": "Expert rules (Phase 1B)",
  "microbiology.worklist.loadError.subtitle": "The queue could not be loaded. Try refreshing the page.",
  "microbiology.worklist.loadError.title": "Unable to load microbiology worklist",
  "microbiology.worklist.editAst": "Edit AST",
  "microbiology.worklist.grain.ast": "AST runs",
  "microbiology.worklist.grain.cultures": "Cultures",
  "microbiology.worklist.notSet": "Not set",
  "microbiology.worklist.notStarted": "Not started",
  "microbiology.worklist.markLost": "Mark lost",
  "microbiology.worklist.markNoGrowth": "Mark no growth",
  "microbiology.worklist.markPositive": "Mark positive",
  "microbiology.worklist.openCase": "Open case",
  "microbiology.worklist.newAstAttempt": "Set up new AST run",
  "microbiology.worklist.newPositive": "New positive",
  "microbiology.worklist.phase1b": "Available in Phase 1B",
  "microbiology.worklist.print": "Print list",
  "microbiology.worklist.qcDashboard": "QC dashboard",
  "microbiology.worklist.queueStatus": "Shared queue",
  "microbiology.worklist.refresh": "Refresh now",
  "microbiology.worklist.rowActions": "Row actions",
  "microbiology.worklist.recentActivity.empty": "No recent microbiology activity.",
  "microbiology.worklist.recentActivity.title": "Recent activity ({count})",
  "microbiology.worklist.resistance.hint": "Analyzer-reported flags completed today; OpenELIS expert-rule detection remains Phase 1B.",
  "microbiology.worklist.resistance.title": "Today's resistance hits",
  "microbiology.worklist.search.ast": "Search lab number, patient, isolate, organism, or panel",
  "microbiology.worklist.search.cultures": "Search lab number, patient, or specimen",
  "microbiology.worklist.sharedQueue": "Shared laboratory queue",
  "microbiology.worklist.setupAst": "Set up AST",
  "microbiology.worklist.sort": "Sort",
  "microbiology.worklist.sort.newest": "Newest activity",
  "microbiology.worklist.sort.priority": "Priority",
  "microbiology.worklist.sort.workflow": "Workflow",
  "microbiology.worklist.subtitle": "Prioritize culture cases by workflow stage, urgency, and required laboratory action.",
  "microbiology.worklist.summary.astReview": "AST review",
  "microbiology.worklist.summary.astInProgress": "In progress",
  "microbiology.worklist.summary.astInQueue": "In queue",
  "microbiology.worklist.summary.astPendingSetup": "Pending setup",
  "microbiology.worklist.summary.astResultsIn": "Results in - review",
  "microbiology.worklist.summary.caseReview": "Ready for case review",
  "microbiology.worklist.summary.critical": "Open critical follow-ups",
  "microbiology.worklist.summary.growthDetected": "Growth detected",
  "microbiology.worklist.summary.hint": "Select a queue to update the case list.",
  "microbiology.worklist.summary.identification": "Identification in progress",
  "microbiology.worklist.summary.incubating": "Incubating",
  "microbiology.worklist.summary.positive": "Positive",
  "microbiology.worklist.summary.expertFlags": "Expert flags (1B)",
  "microbiology.worklist.summary.title": "Work needing action",
  "microbiology.worklist.summary.totalPending": "Total pending",
  "microbiology.worklist.table.hint": "Cases are ordered by urgency and the next required action.",
  "microbiology.worklist.table.astTitle": "AST runs",
  "microbiology.worklist.table.title": "Open microbiology cases",
  "microbiology.worklist.viewAudit": "View audit",
  "microbiology.worklist.viewReviewedAst": "View reviewed AST",
  "microbiology.worklist.whonetExport": "Export to WHONET",
  "microbiology.worklist.surveillance.title": "Surveillance scope",
  "microbiology.worklist.surveillance.description": "Narrow the AST rows by reporting period and structured surveillance fields. Operational queue filters do not change the export population.",
  "microbiology.worklist.ast.automaticResults": "Analyzer results arrive automatically",
  "microbiology.worklist.ast.automaticResultsDetail": "Connected instruments send results directly to the case. Failed or unmatched events are retained in Analyzer Import Issues.",
  "microbiology.worklist.ast.awaitingResults": "Awaiting analyzer results",
  "microbiology.worklist.ast.pendingIdentification": "Identification pending",
  "microbiology.worklist.ast.resultsInBadge": "Results in",
  "microbiology.worklist.title": "Microbiology worklist",
  "microbiology.worklist.updated": "Updated {seconds}s ago · auto-refresh 30s",
  "microbiology.admin.action.deactivate": "Deactivate",
  "microbiology.admin.action.moveDown": "Move down",
  "microbiology.admin.action.moveUp": "Move up",
  "microbiology.admin.action.reactivate": "Reactivate",
  "microbiology.admin.actions": "Row actions",
  "microbiology.admin.antibiotics.add": "Add antibiotic",
  "microbiology.admin.antibiotics.description": "Antimicrobial vocabulary used by AST panels and breakpoint rules.",
  "microbiology.admin.antibiotics.edit": "Antibiotic",
  "microbiology.admin.antibiotics.title": "Antibiotics",
  "microbiology.admin.astPanels.add": "Add AST panel",
  "microbiology.admin.astPanels.antibiotic": "Antibiotic",
  "microbiology.admin.astPanels.behavior.always": "Always",
  "microbiology.admin.astPanels.behavior.cascade": "Cascade",
  "microbiology.admin.astPanels.behavior.resistant": "Only when resistant",
  "microbiology.admin.astPanels.current": "Current",
  "microbiology.admin.astPanels.confirmDeactivate": "Publish version {version} as unavailable for new work? Existing AST runs will retain their original panel version.",
  "microbiology.admin.astPanels.confirmPublish": "Publish version {version}? Existing AST runs will retain their original panel version.",
  "microbiology.admin.astPanels.confirmTitle": "Confirm panel publication",
  "microbiology.admin.astPanels.historical": "Historical",
  "microbiology.admin.astPanels.loadingEditor": "AST panel administration is loading.",
  "microbiology.admin.astPanels.publishVersion": "Publish new version",
  "microbiology.admin.astPanels.readOnly": "This historical version is read-only. Open the current version to publish a change.",
  "microbiology.admin.astPanels.reportBehavior": "Report behavior",
  "microbiology.admin.astPanels.tier": "Tier",
  "microbiology.admin.astPanels.title": "AST panels",
  "microbiology.admin.astPanels.version": "Version",
  "microbiology.admin.astPanels.versionNotice": "Saving creates a new panel version; existing AST runs keep their original version.",
  "microbiology.admin.astPanels.viewVersion": "View version",
  "microbiology.admin.breakpoints.activate": "Activate standard",
  "microbiology.admin.breakpoints.applyValid": "Apply valid rows",
  "microbiology.admin.breakpoints.archive": "Archive standard",
  "microbiology.admin.breakpoints.archiveConfirm": "This standard will remain available to historical AST runs but cannot be selected for new work.",
  "microbiology.admin.breakpoints.back": "Back to standards",
  "microbiology.admin.breakpoints.breakpointType": "Breakpoint type",
  "microbiology.admin.breakpoints.chooseFile": "Choose CSV file",
  "microbiology.admin.breakpoints.correction.add": "Add local correction",
  "microbiology.admin.breakpoints.correction.edit": "Edit local correction",
  "microbiology.admin.breakpoints.count.imported": "{count} imported",
  "microbiology.admin.breakpoints.count.skipped": "{count} skipped",
  "microbiology.admin.breakpoints.count.unchanged": "{count} unchanged",
  "microbiology.admin.breakpoints.count.valid": "{count} valid",
  "microbiology.admin.breakpoints.csv": "Breakpoint CSV",
  "microbiology.admin.breakpoints.description": "Loaded breakpoint standards and the version active for new AST runs.",
  "microbiology.admin.breakpoints.detail": "Breakpoint rules",
  "microbiology.admin.breakpoints.downloadRejected": "Download rejected rows",
  "microbiology.admin.breakpoints.effectiveDate": "Effective date",
  "microbiology.admin.breakpoints.import": "Import CSV",
  "microbiology.admin.breakpoints.intermediate": "Intermediate",
  "microbiology.admin.breakpoints.intermediateLower": "Intermediate lower",
  "microbiology.admin.breakpoints.intermediateUpper": "Intermediate upper",
  "microbiology.admin.breakpoints.groupOption": "Group: {name}",
  "microbiology.admin.breakpoints.method.all": "All methods",
  "microbiology.admin.breakpoints.method.zone": "Zone",
  "microbiology.admin.breakpoints.organism": "Organism or group",
  "microbiology.admin.breakpoints.organismGroup": "Organism group",
  "microbiology.admin.breakpoints.publisher": "Publisher",
  "microbiology.admin.breakpoints.resistant": "Resistant",
  "microbiology.admin.breakpoints.rowError": "Row {row}",
  "microbiology.admin.breakpoints.rules": "Rules",
  "microbiology.admin.breakpoints.source": "Source",
  "microbiology.admin.breakpoints.source.imported": "Imported",
  "microbiology.admin.breakpoints.source.local": "Local correction",
  "microbiology.admin.breakpoints.source.manual": "Manual",
  "microbiology.admin.breakpoints.specimen": "Specimen context",
  "microbiology.admin.breakpoints.specimen.any": "Any specimen",
  "microbiology.admin.breakpoints.status.active": "Active",
  "microbiology.admin.breakpoints.status.archived": "Archived",
  "microbiology.admin.breakpoints.status.loaded": "Loaded",
  "microbiology.admin.breakpoints.susceptible": "Susceptible",
  "microbiology.admin.breakpoints.title": "Breakpoint standards",
  "microbiology.admin.breakpoints.units": "Units",
  "microbiology.admin.breakpoints.view": "View rules",
  "microbiology.admin.filter.all": "All",
  "microbiology.admin.sort": "Sort",
  "microbiology.admin.sort.nameAsc": "Name A-Z",
  "microbiology.admin.sort.nameDesc": "Name Z-A",
  "microbiology.admin.deactivate.impact": "{name} is used by {count, plural, one {# existing workflow record} other {# existing workflow records}}. Deactivation prevents new selection but preserves those historical references.",
  "microbiology.admin.deactivate.title": "Review deactivation impact",
  "microbiology.admin.deactivated": "Reference deactivated",
  "microbiology.admin.empty": "No matching reference records",
  "microbiology.admin.error.save": "The reference record could not be saved.",
  "microbiology.admin.error.title": "Unable to complete request",
  "microbiology.admin.field.active": "Available for new work",
  "microbiology.admin.field.atmosphere": "Atmosphere defaults",
  "microbiology.admin.field.class": "Class",
  "microbiology.admin.field.code": "Code",
  "microbiology.admin.field.defaultPanel": "Default AST panel",
  "microbiology.admin.field.defaultPanelId": "Default AST panel ID",
  "microbiology.admin.field.gramStain": "Gram stain",
  "microbiology.admin.field.group": "Organism group",
  "microbiology.admin.field.incubation": "Incubation defaults",
  "microbiology.admin.field.incubationHours": "Routine read interval (hours)",
  "microbiology.admin.field.subcultureAtHours": "Subculture at (hours)",
  "microbiology.admin.field.maxIncubationDays": "Maximum incubation (days)",
  "microbiology.admin.field.media": "Media defaults",
  "microbiology.admin.field.method": "Method",
  "microbiology.admin.field.methodId": "Method ID",
  "microbiology.admin.field.name": "Name",
  "microbiology.admin.field.notes": "Notes",
  "microbiology.admin.field.oclCode": "OCL code",
  "microbiology.admin.field.reportableAnalyteId": "Reportable analyte ID",
  "microbiology.admin.field.route": "Route",
  "microbiology.admin.field.shortName": "Short name",
  "microbiology.admin.field.significance": "Initial significance",
  "microbiology.admin.field.whonetCode": "WHONET code",
  "microbiology.admin.organisms.add": "Add organism",
  "microbiology.admin.organisms.description": "Organism vocabulary used by culture identification and AST.",
  "microbiology.admin.organisms.edit": "Organism",
  "microbiology.admin.organisms.title": "Organisms",
  "microbiology.admin.patientOrigins.description": "Configured patient origin choices used during microbiology order entry and WHONET export.",
  "microbiology.admin.patientOrigins.title": "Patient origins",
  "microbiology.admin.reactivated": "Reference reactivated",
  "microbiology.admin.route.both": "Oral and IV",
  "microbiology.admin.route.iv": "IV",
  "microbiology.admin.route.oral": "Oral",
  "microbiology.admin.route.topical": "Topical",
  "microbiology.admin.saved": "Reference saved",
  "microbiology.admin.search": "Search reference data",
  "microbiology.admin.sections": "Microbiology reference sections",
  "microbiology.admin.significance.possible": "Possible pathogen",
  "microbiology.admin.significance.rare": "Rare pathogen",
  "microbiology.admin.significance.usually": "Usually significant",
  "microbiology.admin.status": "Status",
  "microbiology.admin.status.active": "Active",
  "microbiology.admin.status.all": "All statuses",
  "microbiology.admin.status.inactive": "Inactive",
  "microbiology.admin.title": "Microbiology reference data",
  "button.add": "Add",
  "button.remove": "Remove",
  "sidenav.label.microbiology": "Microbiology",
  "sidenav.label.microbiology.worklist": "Microbiology worklist",
  "sidenav.label.microbiology.whonet": "WHONET export",
  "microbiology.whonet.title": "WHONET export",
  "microbiology.whonet.eyebrow": "Routine bacteriology surveillance",
  "microbiology.whonet.subtitle": "Review finalized culture and AST data before generating the current OpenELIS surveillance CSV for WHONET validation.",
  "microbiology.whonet.progress": "WHONET export progress",
  "microbiology.whonet.step.configure": "Configure",
  "microbiology.whonet.step.preview": "Preview",
  "microbiology.whonet.step.generate": "Generate",
  "microbiology.whonet.configure.title": "Configure export",
  "microbiology.whonet.configure.description": "Choose the reporting period and the isolates to include.",
  "microbiology.whonet.from": "From",
  "microbiology.whonet.to": "To",
  "microbiology.whonet.date.placeholder": "yyyy-mm-dd",
  "microbiology.whonet.period.invalid": "The end date must be on or after the start date.",
  "microbiology.whonet.period.preset": "Reporting period",
  "microbiology.whonet.period.thisMonth": "This Month",
  "microbiology.whonet.period.lastMonth": "Last Month",
  "microbiology.whonet.period.thisQuarter": "This Quarter",
  "microbiology.whonet.period.custom": "Custom",
  "microbiology.whonet.source.worklist.title": "Scope provided by the AST worklist",
  "microbiology.whonet.source.worklist.description": "The reporting period and structured surveillance filters came from the AST worklist. They remain editable here.",
  "microbiology.whonet.source.worklist.clear": "Clear worklist scope",
  "microbiology.whonet.significance": "Inclusion",
  "microbiology.whonet.significance.clinical": "Clinically significant isolates",
  "microbiology.whonet.significance.all": "All isolates",
  "microbiology.whonet.significance.CLINICALLY_SIGNIFICANT": "Clinically significant",
  "microbiology.whonet.significance.CONTAMINANT": "Contaminant",
  "microbiology.whonet.significance.NORMAL_FLORA": "Normal flora",
  "microbiology.whonet.significance.UNKNOWN": "Not classified",
  "microbiology.whonet.culturePurpose.description": "Clinical cultures are included by default. Add other populations explicitly when the surveillance question requires them.",
  "microbiology.whonet.culturePurpose.includeScreening": "Include active screening or carriage cultures",
  "microbiology.whonet.culturePurpose.includeUnspecified": "Include historical cultures with unspecified purpose",
  "microbiology.whonet.culturePurpose.title": "Culture purpose",
  "microbiology.whonet.filter.specimen": "Specimen types",
  "microbiology.whonet.filter.organism": "Organisms",
  "microbiology.whonet.filter.origin": "Patient origins",
  "microbiology.whonet.filter.any": "Any",
  "microbiology.whonet.filter.choose": "Choose values",
  "microbiology.whonet.dedup": "De-duplication",
  "microbiology.whonet.dedup.apply": "Apply first-isolate selection",
  "microbiology.whonet.dedup.apply.help": "Collapse repeat isolates for the same patient and organism within the selected window.",
  "microbiology.whonet.dedup.advanced": "Adjust first-isolate policy",
  "microbiology.whonet.dedup.window": "Window length",
  "microbiology.whonet.dedup.window.help": "Repeats at the exact selected-day boundary begin a new window.",
  "microbiology.whonet.dedup.sevenDay": "7 days",
  "microbiology.whonet.dedup.fourteenDay": "14 days",
  "microbiology.whonet.dedup.thirtyDay": "30 days",
  "microbiology.whonet.dedup.basis": "Window date",
  "microbiology.whonet.dedup.basis.collection": "Specimen collection date",
  "microbiology.whonet.dedup.basis.release": "Final result-release date",
  "microbiology.whonet.dedup.basis.help": "Choose whether the window follows specimen collection or final result release. The reporting period always follows collection date.",
  "microbiology.whonet.dedup.scope": "Specimen-source scope",
  "microbiology.whonet.dedup.scope.any": "Any specimen source",
  "microbiology.whonet.dedup.scope.same": "Same specimen source only",
  "microbiology.whonet.dedup.scope.help": "Any source compares the patient and organism across specimen types; same source compares within each specimen type.",
  "microbiology.whonet.dedup.contaminants": "Exclude probable contaminants before selection",
  "microbiology.whonet.dedup.contaminants.help": "Remove probable contaminants before choosing the first representative isolate.",
  "microbiology.whonet.dedup.profile": "Susceptibility profile",
  "microbiology.whonet.dedup.profile.insensitive": "Ignore changed S/I/R",
  "microbiology.whonet.dedup.profile.sensitive": "Treat changed S/I/R as new",
  "microbiology.whonet.dedup.profile.help": "Profile-sensitive selection counts a different reviewed antibiotic S/I/R pattern as a new isolate within the window.",
  "microbiology.whonet.dedup.none": "No de-duplication",
  "microbiology.whonet.preview.action": "Preview export",
  "microbiology.whonet.preview.title": "Preview",
  "microbiology.whonet.preview.description": "These counts and rows will be used when the CSV is generated.",
  "microbiology.whonet.generate.action": "Generate CSV",
  "microbiology.whonet.count.cases": "Finalized cases",
  "microbiology.whonet.count.clinicalPurpose": "Clinical cultures",
  "microbiology.whonet.count.screeningPurpose": "Screening cultures",
  "microbiology.whonet.count.unspecifiedPurpose": "Unspecified cultures",
  "microbiology.whonet.count.purposeIncluded": "After culture-purpose selection",
  "microbiology.whonet.count.isolates": "Isolates found",
  "microbiology.whonet.count.specimen": "After specimen filter",
  "microbiology.whonet.count.organism": "After organism filter",
  "microbiology.whonet.count.origin": "After origin filter",
  "microbiology.whonet.count.included": "Isolates included",
  "microbiology.whonet.count.deduplicated": "After de-duplication",
  "microbiology.whonet.count.mappable": "Mappable isolates",
  "microbiology.whonet.count.rows": "Eligible rows",
  "microbiology.whonet.count.excluded": "Rows excluded",
  "microbiology.whonet.mapping.title": "Mapping readiness",
  "microbiology.whonet.mapping.excluded": "{count, plural, one {# row excluded} other {# rows excluded}} from this export.",
  "microbiology.whonet.mapping.fixOrganism": "Fix organism mapping",
  "microbiology.whonet.mapping.fixAntibiotic": "Fix antibiotic mapping",
  "microbiology.whonet.mapping.fixSpecimen": "Fix specimen mapping",
  "microbiology.whonet.table.title": "Eligible AST rows",
  "microbiology.whonet.table.description": "Reviewed, reportable AST readings with the mappings required by this export.",
  "microbiology.whonet.table.accession": "Lab number",
  "microbiology.whonet.table.specimen": "Specimen",
  "microbiology.whonet.table.organism": "Organism",
  "microbiology.whonet.table.antibiotic": "Antibiotic",
  "microbiology.whonet.table.interpretation": "S / I / R",
  "microbiology.whonet.table.method": "Method",
  "microbiology.whonet.error.title": "WHONET export could not be completed",
  "microbiology.whonet.error.invalidRequest": "Review the reporting period and export options, then try again.",
  "microbiology.whonet.error.blocked": "No valid rows remain. Resolve the listed readiness issues before generating the CSV.",
  "microbiology.whonet.error.network": "The export service could not be reached. Try again when the connection is available.",
  "microbiology.whonet.error.generic": "The export request could not be completed.",
  "microbiology.whonet.preview.loading": "Preparing the export preview.",
  "microbiology.whonet.preview.announced": "Preview ready with {count, plural, one {# eligible row} other {# eligible rows}}.",
  "microbiology.whonet.generated.title": "CSV generated",
  "microbiology.whonet.generated.subtitle": "The validated export was downloaded and its audit summary was recorded.",
  "catalog.import.title": "Import Catalog (CSV)",
  "catalog.import.description": "Load test catalog files without editing tests one at a time. Preview checks each file against the catalog as it stands and keeps nothing, so a row that needs a lab unit, specimen or test another file in the same upload creates is listed as skipped until you apply. Apply loads the files in order and saves them with the configuration, so the next restart loads exactly what you applied.",
  "catalog.import.dropzone": "Add CSV files",
  "catalog.import.preview": "Preview",
  "catalog.import.apply": "Apply",
  "catalog.import.remove": "Remove",
  "catalog.import.plan.title": "What these files would do",
  "catalog.import.result.title": "What was loaded",
  "catalog.import.column.file": "File",
  "catalog.import.column.domain": "Catalog area",
  "catalog.import.column.created": "Created",
  "catalog.import.column.updated": "Updated",
  "catalog.import.column.skipped": "Skipped",
  "catalog.import.column.name": "Name in the file",
  "catalog.import.column.where": "Where it appeared",
  "catalog.import.column.use": "Use this record",
  "catalog.import.file.error": "This file could not be read",
  "catalog.import.applied": "The catalog files were applied.",
  "catalog.import.applied.partial": "Some catalog files were not loaded. The table says which, and why.",
  "catalog.import.apply.failed": "The catalog files were not applied.",
  "catalog.import.apply.hint": "Preview the files first. Apply opens once the preview shows no file errors.",
  "catalog.import.failed": "The catalog files could not be sent.",
  "catalog.import.unresolved.title": "Needs your decision",
  "catalog.import.unresolved.description": "Names the import could not match to a record. Point each one at the record it means, or skip it. Remembering a name resolves it by itself next time.",
  "catalog.import.unresolved.empty": "Nothing is waiting for a decision.",
  "catalog.import.remember": "Remember this name",
  "catalog.import.resolve": "Use",
  "catalog.import.skip": "Skip",
  "sidenav.label.admin.catalogImport": "Import Catalog (CSV)",
  "reporting.design.subtitle": "Create a CSV for a new question or rerun a familiar report for a new period.",
  "reporting.design.overview": "Export overview",
  "reporting.design.newTitle": "Create a new export",
  "reporting.design.newHelp": "Choose the kind of report, the fields you need, and a reporting period. Your work remains available if you visit the queue or return later.",
  "reporting.design.savedTitle": "Use a saved report",
  "reporting.design.savedHelp": "Reuse saved fields and filters, then choose a fresh reporting period.",
  "reporting.design.start": "Start a new export",
  "reporting.design.continue": "Continue current export",
  "reporting.design.newExport": "New export",
  "reporting.design.useReport": "Use report",
  "reporting.design.savedFields": "{count} saved fields · reporting period is never saved",
  "reporting.design.steps": "Export steps",
  "reporting.design.chooseColumns": "Choose columns",
  "reporting.design.setFilters": "Set Filters",
  "reporting.design.reviewSubmit": "Review & Submit",
  "reporting.design.typeQuestion": "What kind of information do you need?",
  "reporting.design.typeHelp": "Choose one report type so every CSV row has a clear meaning. You can change the type until you select fields.",
  "reporting.design.type.SAMPLE_TESTING": "Sample & Testing",
  "reporting.design.type.REFERRALS": "Referrals",
  "reporting.design.type.NON_CONFORMANCE": "Non-Conformance",
  "reporting.design.typeHelp.SAMPLE_TESTING": "Orders, results, patients & turnaround times",
  "reporting.design.typeHelp.REFERRALS": "Tests referred to other labs · preserves returned results and pending referrals",
  "reporting.design.typeHelp.NON_CONFORMANCE": "Rejected samples & non-conforming events · preserves linked specimens and separate occurrences",
  "reporting.design.pending": "Not yet connected",
  "reporting.design.building": "You’re building a {type} report.",
  "reporting.design.changeType": "Change type and clear fields",
  "reporting.design.chooseType": "Choose a report type to see its fields.",
  "reporting.design.configuredReports": "Configured reports",
  "reporting.design.chooseConfigured": "Choose a configured report",
  "reporting.design.available": "Available fields",
  "reporting.design.findField": "Find a field",
  "reporting.design.searchPlaceholder": "Search all fields and groups…",
  "reporting.design.clearSearch": "Clear search",
  "reporting.design.fieldCount": "{count} fields across {groups} groups",
  "reporting.design.matchCount": "{count} matching fields across {groups} groups",
  "reporting.design.expansion": "Expand or collapse field groups",
  "reporting.design.expandAll": "Expand all",
  "reporting.design.collapseAll": "Collapse all",
  "reporting.design.groupCount": "{added} / {total} added",
  "reporting.design.scrollCatalog": "Scrollable field catalog",
  "reporting.design.addShown": "Add all shown",
  "reporting.design.removeShown": "Remove shown",
  "reporting.design.addShownGroup": "Add all shown {group} fields",
  "reporting.design.removeShownGroup": "Remove all shown {group} fields",
  "reporting.design.addField": "Add {field}",
  "reporting.design.addedField": "Added {field}",
  "reporting.design.add": "+ Add",
  "reporting.design.added": "Added",
  "reporting.design.noFields": "No fields match your search.",
  "reporting.design.selectedCount": "Your CSV columns ({count})",
  "reporting.design.orderHelp": "Drag a handle to change column order, or use the arrows. Arrow keys move the focused handle; Home and End move it to the first or last position.",
  "reporting.design.columnOrder": "CSV columns in order",
  "reporting.design.drag": "Drag {field} to reorder",
  "reporting.design.move": "Move {field}",
  "reporting.design.emptyColumns": "Add fields to build your CSV.",
  "reporting.design.addedMessage": "{field} added. {count} columns.",
  "reporting.design.removedMessage": "{field} removed. {count} columns.",
  "reporting.design.columnViews": "Column builder views",
  "reporting.design.yourColumns": "Your columns ({count})",
  "reporting.design.csvPreview": "CSV preview",
  "reporting.design.previewHelp": "Column layout in the order it will appear in your downloaded CSV.",
  "reporting.design.scrollPreview": "Scrollable CSV preview",
  "reporting.design.nextFilters": "Next: Set Filters",
  "reporting.design.nextReview": "Next: Review & Submit",
  "reporting.design.scopeFilters": "Scope Filters (Optional)",
  "reporting.design.periodDays": "{count, plural, one {# day} other {# days}}",
  "reporting.design.moreFilters": "Show more filters",
  "reporting.design.hideFilters": "Hide more filters",
  "reporting.design.sampleStatus": "Sample Status",
  "reporting.design.referringSite": "Referring Site",
  "reporting.design.reviewConfiguration": "Review Configuration",
  "reporting.design.dateFilters": "Date Range and filters",
  "reporting.design.testStatus": "Test and status",
  "reporting.design.change": "Change",
  "reporting.design.deliveryHelp": "Your CSV will be generated in the background. Download it here when ready, or return to My Report Queue.",
  "reporting.design.fileName": "File name",
  "reporting.design.customFileName": "Custom file name",
  "reporting.design.fileNamePending": "A file name is generated automatically. Custom names are not yet connected.",
  "reporting.design.saveLater": "Save these report settings for later",
  "reporting.design.saveSettings": "Save report settings",
  "reporting.design.queueHelp": "View and download your queued CSV exports.",
  "reporting.design.queue.jobName": "Job Name",
  "reporting.design.queue.report": "Report",
  "reporting.design.queue.size": "Rows / File Size",
  "reporting.design.queue.submitted": "Submitted At",
  "reporting.design.queuePending": "Active jobs refresh automatically. Retry failed exports, cancel queued work or rerun expired reports with fresh dates. Job deletion is not yet connected.",
  "reporting.design.details": "Details",
  "reporting.design.expires": "Available until {date}",
  "reporting.design.jobsShown": "Showing {count} jobs",
  "reporting.design.jobAction.EXPIRED": "Re-run",
  "reporting.design.labScope": "Lab Scope",
  "reporting.design.reviewFields": "Selected Fields ({count})",
  "reporting.recovery.cancelTitle": "Cancel export",
  "reporting.recovery.keepQueued": "Keep queued",
  "reporting.recovery.cancelHelp": "Cancel this queued export? If processing has already started, it will continue and you can return to its result.",
  "reporting.job.cannotCancel": "This export has already started or finished and cannot be cancelled.",
  "reporting.job.cannotRetry": "Only a failed export can be retried. Use the current job or start a new export.",
  "reporting.job.interrupted": "Processing was interrupted. Retry this export to generate a new file.",
  "reporting.job.claimLost": "This export is no longer assigned to the current worker. Return to the queue for its status.",
  "sidenav.section.main": "Main Menu",
  "sidenav.section.patientOrders": "Patient & Orders",
  "sidenav.section.administration": "Administration",
  "sidenav.workflow.orderTest": "Order Test",
  "sidenav.workflow.resultsValidation": "Results Validation",
  "sidenav.workflow.patientManagement": "Patient Management",
  "sidenav.moreTools": "More tools",
  "reporting.menu.otherReports": "Other reports",
  "reporting.menu.patientPrintQueue": "Patient Report Print Queue",
  "common.icon": "Icon",
  "menu.presentation.style": "Display as",
  "menu.presentation.item": "Menu item",
  "menu.presentation.section": "Section heading",
  "menu.configuration.description": "Update menu visibility, section headings and icons. A change made here stays when the menu configuration file is applied again at the next start.",
  "menu.configuration.export": "Export menu file",
  "menu.configuration.loadError": "Menu settings could not be loaded.",
  "menu.configuration.saved": "Menu settings saved.",
  "menu.presentation.sectionHint": "Section headings group their child menu items without a link.",
  "menu.presentation.sectionIconHint": "Icons are shown on menu items, not section headings.",
  "analyzer.action.copyMappings": "Copy Mappings",
  "analyzer.action.delete": "Delete",
  "analyzer.action.edit": "Edit",
  "analyzer.action.fieldMappings": "Field Mappings",
  "analyzer.action.qcRules": "QC Rules",
  "analyzer.action.testConnection": "Test Connection",
  "analyzer.copyMappings.confirmation.message": "Are you sure you want to copy {count} mappings? Existing mappings will be overwritten.",
  "analyzer.copyMappings.confirmation.title": "Confirm Copy Mappings",
  "analyzer.copyMappings.copy": "Copy Mappings",
  "analyzer.copyMappings.error": "Error copying mappings",
  "analyzer.copyMappings.error.noSourceMappings": "Source analyzer has no active mappings to copy",
  "analyzer.copyMappings.loading": "Copying mappings...",
  "analyzer.copyMappings.source": "Source Analyzer",
  "analyzer.copyMappings.source.name": "Name",
  "analyzer.copyMappings.source.type": "Type",
  "analyzer.copyMappings.subtitle": "Copy field mappings from {source} to {target}",
  "analyzer.copyMappings.success": "Successfully copied {count} mappings",
  "analyzer.copyMappings.success.viewTarget": "View Target Analyzer",
  "analyzer.copyMappings.summary": "Mapping Summary",
  "analyzer.copyMappings.summary.breakdown": "Field mappings: {fieldCount}, Unit conversions: {unitCount}, Qualitative mappings: {qualCount}",
  "analyzer.copyMappings.summary.count": "{count} mappings will be copied",
  "analyzer.copyMappings.target": "Target Analyzer",
  "analyzer.copyMappings.target.placeholder": "Select target analyzer",
  "analyzer.copyMappings.target.required": "Target Analyzer *",
  "analyzer.copyMappings.title": "Copy Field Mappings",
  "analyzer.copyMappings.warning": "This will copy all field mappings including unit conversions and qualitative value mappings. Existing mappings will be overwritten.",
  "analyzer.delete.cancel": "Cancel",
  "analyzer.delete.delete": "Delete",
  "analyzer.delete.error": "Error",
  "analyzer.delete.error.noId": "Analyzer ID is required",
  "analyzer.delete.error.unknown": "An unknown error occurred while deleting the analyzer",
  "analyzer.delete.message": "Are you sure you want to delete \"{name}\"? This action cannot be undone and will remove all associated field mappings.",
  "analyzer.delete.success": "Analyzer deleted",
  "analyzer.delete.title": "Delete Analyzer",
  "analyzer.delete.unknown": "Unknown Analyzer",
  "analyzer.errorDashboard.acknowledgeAll": "Acknowledge All",
  "analyzer.errorDashboard.action.acknowledge": "Acknowledge",
  "analyzer.errorDashboard.action.menu": "Error actions",
  "analyzer.errorDashboard.action.viewDetails": "View Details",
  "analyzer.errorDashboard.errorType.connection": "Connection",
  "analyzer.errorDashboard.errorType.mapping": "Mapping",
  "analyzer.errorDashboard.errorType.protocol": "Protocol",
  "analyzer.errorDashboard.errorType.timeout": "Timeout",
  "analyzer.errorDashboard.errorType.validation": "Validation",
  "analyzer.errorDashboard.filter.analyzer": "Analyzer",
  "analyzer.errorDashboard.filter.analyzer.all": "All",
  "analyzer.errorDashboard.filter.search": "Search errors...",
  "analyzer.errorDashboard.filter.severity": "Severity",
  "analyzer.errorDashboard.filter.severity.all": "All Severities",
  "analyzer.errorDashboard.filter.type": "Error Type",
  "analyzer.errorDashboard.filter.type.all": "All Types",
  "analyzer.errorDashboard.severity.critical": "Critical",
  "analyzer.errorDashboard.severity.error": "Error",
  "analyzer.errorDashboard.severity.warning": "Warning",
  "analyzer.errorDashboard.stats.critical": "Critical",
  "analyzer.errorDashboard.stats.last24Hours": "Last 24 Hours",
  "analyzer.errorDashboard.stats.total": "Total Errors",
  "analyzer.errorDashboard.stats.unacknowledged": "Unacknowledged",
  "analyzer.errorDashboard.status.acknowledged": "Acknowledged",
  "analyzer.errorDashboard.status.unacknowledged": "Unacknowledged",
  "analyzer.errorDashboard.subtitle": "View and manage analyzer errors and alerts",
  "analyzer.errorDashboard.table.analyzer": "Analyzer",
  "analyzer.errorDashboard.table.message": "Message",
  "analyzer.errorDashboard.table.severity": "Severity",
  "analyzer.errorDashboard.table.status": "Status",
  "analyzer.errorDashboard.table.timestamp": "Timestamp",
  "analyzer.errorDashboard.table.type": "Type",
  "analyzer.errorDashboard.title": "Error Dashboard",
  "analyzer.errorDetails.acknowledged": "Acknowledged",
  "analyzer.errorDetails.acknowledgedBy": "By {user} on {date}",
  "analyzer.errorDetails.analyzer": "Analyzer",
  "analyzer.errorDetails.analyzerId": "Analyzer ID",
  "analyzer.errorDetails.close": "Close",
  "analyzer.errorDetails.copy": "Copy",
  "analyzer.errorDetails.createMapping": "Create Mapping",
  "analyzer.errorDetails.download": "Download",
  "analyzer.errorDetails.errorId": "Error ID",
  "analyzer.errorDetails.errorMessage": "Error Message",
  "analyzer.errorDetails.errorType": "Error Type",
  "analyzer.errorDetails.logs": "Analyzer Logs ({count} entries)",
  "analyzer.errorDetails.recommendedActions": "Recommended Actions",
  "analyzer.errorDetails.recommendedActions.checkConfiguration": "Check IP address and port configuration in analyzer settings",
  "analyzer.errorDetails.recommendedActions.createMapping": "Create a mapping for the unmapped field to resolve this error",
  "analyzer.errorDetails.recommendedActions.testConnection": "Test connection using the 'Test Connection' feature",
  "analyzer.errorDetails.recommendedActions.verifyConnection": "Verify analyzer is powered on and network cable is connected",
  "analyzer.errorDetails.severity": "Severity",
  "analyzer.errorDetails.subtitle": "Detailed information and analyzer logs for error {id}",
  "analyzer.errorDetails.timestamp": "Timestamp",
  "analyzer.errorDetails.title": "Error Details",
  "analyzer.fieldMapping.activationModal.activate": "Activate Changes",
  "analyzer.fieldMapping.activationModal.cancel": "Cancel",
  "analyzer.fieldMapping.activationModal.confirmCheckbox": "I understand these changes will apply to new messages only",
  "analyzer.fieldMapping.activationModal.errorConcurrentEdit": "Mapping changes detected. Another user has modified mappings for this analyzer. Please reload the page to see latest changes.",
  "analyzer.fieldMapping.activationModal.errorMissingRequired": "Cannot activate: Required mappings missing",
  "analyzer.fieldMapping.activationModal.errorMissingRequired.detail": "Missing required fields: {fields}",
  "analyzer.fieldMapping.activationModal.reloadPage": "Reload Page",
  "analyzer.fieldMapping.activationModal.subtitle": "Confirm activation of mapping changes for analyzer \"{name}\"",
  "analyzer.fieldMapping.activationModal.title": "Activate Mapping Changes",
  "analyzer.fieldMapping.activationModal.viewPendingMessages": "View Pending Messages",
  "analyzer.fieldMapping.activationModal.warning": "You are about to activate mapping changes for analyzer \"{name}\". These changes will apply to all new messages received after activation. Existing results will not be affected.",
  "analyzer.fieldMapping.activationModal.warningActive": "This analyzer is currently active. Activating changes may affect incoming results.",
  "analyzer.fieldMapping.activationModal.warningPendingMessages": "This analyzer has {count} pending messages in the error queue. Activating mapping changes may affect how these messages are reprocessed. Consider resolving errors first.",
  "analyzer.fieldMapping.back": "Back",
  "analyzer.fieldMapping.fieldType.controlTest": "Control Test",
  "analyzer.fieldMapping.fieldType.custom": "Custom",
  "analyzer.fieldMapping.fieldType.dateTime": "Date/Time",
  "analyzer.fieldMapping.fieldType.meltingPoint": "Melting Point",
  "analyzer.fieldMapping.fieldType.numeric": "Numeric",
  "analyzer.fieldMapping.fieldType.qualitative": "Qualitative",
  "analyzer.fieldMapping.fieldType.text": "Text",
  "analyzer.fieldMapping.page.subtitle": "Configure field mappings between analyzer and OpenELIS",
  "analyzer.fieldMapping.page.title": "Field Mappings",
  "analyzer.fieldMapping.panel.mapping.active": "Active",
  "analyzer.fieldMapping.panel.mapping.retired": "Retired",
  "analyzer.fieldMapping.panel.retire": "Retire Mapping",
  "analyzer.fieldMapping.panel.retire.disabled.tooltip": "Cannot retire: {reason}",
  "analyzer.fieldMapping.panel.source.fieldsAvailable": "{count} fields available",
  "analyzer.fieldMapping.panel.source.search": "Search fields...",
  "analyzer.fieldMapping.panel.source.title": "Analyzer Fields ({type})",
  "analyzer.fieldMapping.panel.status.mapped": "Mapped",
  "analyzer.fieldMapping.panel.status.unmapped": "Unmapped",
  "analyzer.fieldMapping.panel.statusFilter.active": "Active Only",
  "analyzer.fieldMapping.panel.statusFilter.all": "All Fields",
  "analyzer.fieldMapping.panel.statusFilter.draft": "Draft Only",
  "analyzer.fieldMapping.panel.statusFilter.label": "Filter by Status",
  "analyzer.fieldMapping.panel.statusFilter.mapped": "Mapped Only",
  "analyzer.fieldMapping.panel.statusFilter.unmapped": "Unmapped Only",
  "analyzer.fieldMapping.panel.target.cancel": "Cancel",
  "analyzer.fieldMapping.panel.target.edit": "Edit",
  "analyzer.fieldMapping.panel.target.remove": "Remove",
  "analyzer.fieldMapping.panel.target.saveActivate": "Save and Activate",
  "analyzer.fieldMapping.panel.target.saveDraft": "Save as Draft",
  "analyzer.fieldMapping.panel.target.selectField": "Select a field from the left panel to view or create mappings.",
  "analyzer.fieldMapping.panel.target.summary": "Mappings Summary",
  "analyzer.fieldMapping.panel.unmappedField.tooltip": "Unmapped Field - This field has no mapping configured",
  "analyzer.fieldMapping.pendingCodes.actions": "Actions",
  "analyzer.fieldMapping.pendingCodes.code": "Analyzer Code",
  "analyzer.fieldMapping.pendingCodes.empty": "No pending unmapped analyzer codes.",
  "analyzer.fieldMapping.pendingCodes.ignore": "Ignore",
  "analyzer.fieldMapping.pendingCodes.markMapped": "Mark Mapped",
  "analyzer.fieldMapping.pendingCodes.seenCount": "Seen",
  "analyzer.fieldMapping.pendingCodes.status": "Status",
  "analyzer.fieldMapping.pendingCodes.subtitle": "Review and resolve unmapped analyzer test codes.",
  "analyzer.fieldMapping.pendingCodes.title": "Pending Unmapped Codes",
  "analyzer.fieldMapping.pluginConfig.title": "Plugin Configuration Snapshot",
  "analyzer.fieldMapping.queryAnalyzer": "Query Analyzer",
  "analyzer.fieldMapping.retirementModal.cancel": "Cancel",
  "analyzer.fieldMapping.retirementModal.confirmation": "Are you sure you want to retire this mapping? Historical messages will still reference it for audit purposes.",
  "analyzer.fieldMapping.retirementModal.errorPendingMessages": "Cannot retire: {count} pending messages use this mapping",
  "analyzer.fieldMapping.retirementModal.reasonLabel": "Retirement Reason (Optional)",
  "analyzer.fieldMapping.retirementModal.reasonPlaceholder": "Optional: Reason for retiring this mapping",
  "analyzer.fieldMapping.retirementModal.retire": "Retire Mapping",
  "analyzer.fieldMapping.retirementModal.subtitle": "Confirm retirement of field mapping",
  "analyzer.fieldMapping.retirementModal.title": "Retire Mapping",
  "analyzer.fieldMapping.save": "Save Mappings",
  "analyzer.fieldMapping.stats.pendingCodes": "Pending Codes",
  "analyzer.fieldMapping.stats.required": "Required Mappings",
  "analyzer.fieldMapping.stats.total": "Total Mappings",
  "analyzer.fieldMapping.stats.unmapped": "Unmapped Fields",
  "analyzer.fieldMapping.status.active": "Active",
  "analyzer.fieldMapping.status.draft": "Draft",
  "analyzer.fieldMapping.status.retired": "Retired",
  "analyzer.fieldMapping.status.unmapped": "Unmapped",
  "analyzer.fieldMapping.testMapping": "Test Mapping",
  "analyzer.fieldMapping.warning.missingRequired": "Required mappings are missing",
  "analyzer.fieldMapping.warning.missingRequired.detail": "Some required fields are not mapped. Please map all required fields before activating.",
  "analyzer.navigation.errorDashboard": "Error Dashboard",
  "analyzerType.column.name": "Name",
  "analyzerType.column.description": "Description",
  "analyzerType.column.pluginClass": "Plugin Class",
  "analyzerType.column.genericPlugin": "Generic Plugin",
  "analyzerType.column.identifierPattern": "Identifier Pattern",
  "analyzerType.column.pluginLoaded": "Plugin Loaded",
  "analyzerType.column.instances": "Instances",
  "analyzerType.button.creating": "Creating...",
  "analyzerType.modal.createTitle": "Create New Analyzer Type",
  "analyzerType.field.name": "Name",
  "analyzerType.field.description": "Description",
  "analyzerType.field.selectProtocol": "Select protocol",
  "analyzerType.field.pluginClassName": "Plugin Class Name",
  "analyzerType.field.identifierPattern": "Identifier Pattern",
  "analyzerType.field.identifierPatternHelper": "Regex pattern for matching sample identifiers (e.g. ^[A-Z]{2}\\d{6}$)",
  "analyzerType.field.isGenericPlugin": "Generic Plugin",
  "analyzerType.field.isActive": "Active",
  "analyzerType.error.nameRequired": "Name is required",
  "analyzerType.notification.createSuccess": "Analyzer type created successfully",
  "analyzerType.notification.createError": "Failed to create analyzer type",
  "analyzer.stat.pluginWarnings": "Plugin Warnings",
  "analyzer.status.pending_registration": "Pending Registration",
  "analyzer.qcRules.modal.title": "QC Sample Identification Rules — {analyzerName}",
  "analyzer.qcRules.breadcrumb": "QC Sample Identification Rules",
  "analyzer.qcRules.orSemantics": "Rules use OR semantics: a sample is flagged as QC if ANY active rule matches.",
  "analyzer.qcRules.addRule": "Add Rule",
  "analyzer.qcRules.deleteRule": "Delete Rule",
  "analyzer.qcRules.noRules": "No QC rules configured. Add at least one rule before activating this analyzer.",
  "analyzer.qcRules.ruleType": "Rule Type",
  "analyzer.qcRules.targetField": "Field Reference",
  "analyzer.qcRules.targetField.placeholder": "e.g., O.12, QC_TASK",
  "analyzer.qcRules.operand": "Match Value",
  "analyzer.qcRules.operand.placeholder": "e.g., Q, CNEG, ^(CNEG|CPOS).*",
  "analyzer.qcRules.error.loadFailed": "Failed to load QC rules",
  "analyzer.qcRules.error.saveFailed": "Failed to save QC rule",
  "analyzer.qcRules.error.deleteFailed": "Failed to delete QC rule",
  "analyzer.placement.instrumentSpecimen": "Instrument sent: {id}",
  "analyzer.placement.state.RESOLVED": "Matched",
  "analyzer.placement.state.RETEST_CHOICE": "Already has a result",
  "analyzer.placement.state.MULTI_TUBE": "Several matches",
  "analyzer.placement.state.UNORDERED_ONE_FITS": "Test not ordered",
  "analyzer.placement.state.UNORDERED_MANY_FIT": "Test not ordered",
  "analyzer.placement.state.UNORDERED_NONE_FIT": "Test not ordered",
  "analyzer.placement.state.NEW_SAMPLE": "New sample",
  "analyzer.placement.reason.RESOLVED": "One analysis on {tube} is waiting for this result.",
  "analyzer.placement.reason.RETEST_CHOICE": "The analysis on {tube} already holds a result. Saving replaces it and marks it corrected.",
  "analyzer.placement.reason.MULTI_TUBE": "More than one analysis matches this ID. Choose the one this result belongs to.",
  "analyzer.placement.reason.MULTI_TUBE_NO_ANALYSIS": "More than one tube carries this ID. Correct the duplicate tube labels, then review again.",
  "analyzer.placement.reason.UNORDERED_ONE_FITS": "This test is not ordered. Saving adds it to {tube}.",
  "analyzer.placement.reason.UNORDERED_MANY_FIT": "This test is not ordered and more than one tube could hold it. Choose the sample type below.",
  "analyzer.placement.reason.UNORDERED_NONE_FIT": "This test is not ordered and no tube on the order can hold it. Saving adds a new tube of the test's sample type.",
  "analyzer.placement.reason.NEW_SAMPLE": "No order or tube carries this ID. Saving creates a new sample for it.",
  "analyzer.placement.chooseAnalysis": "Analysis this result belongs to",
  "analyzer.placement.chooseAnalysis.none": "Choose an analysis",
  "analyzer.placement.option": "{tube}, {status}",
  "analyzer.placement.option.awaiting": "waiting for a result",
  "analyzer.placement.option.hasResult": "has a result",
  "analyzer.placement.tubeUnlabelled": "tube {id}",
  "analyzer.placement.viewBundle": "View bundle",
  "analyzer.placement.bundleTitle": "Delivery bundle",
  "analyzer.placement.bundleLoading": "Loading the delivery bundle",
  "analyzer.placement.bundleFailed": "The delivery bundle could not be loaded.",
  "analyzer.placement.redirect.open": "Place on another order",
  "analyzer.placement.redirect.accession": "Order (lab number)",
  "analyzer.placement.redirect.reason": "Why this belongs to that order",
  "analyzer.placement.redirect.help": "Use this when the instrument misread the specimen ID. The reason is saved with the result.",
  "analyzer.placement.redirect.reasonRequired": "Enter the reason before saving.",
  "analyzer.placement.patient.match": "Instrument patient {instrument} matches the order's patient.",
  "analyzer.placement.patient.mismatch.tag": "Patient mismatch",
  "analyzer.placement.patient.mismatch": "The instrument reported patient {instrument}, but the order's patient is {order}. Add a note saying why before saving.",
  "analyzer.placement.patient.noOrderPatient": "The instrument reported patient {instrument}. The order has no patient identifier to compare it with.",
  "instructions.qc.fail.blocks.validation": "When enabled, results covered by an open quality-control failure cannot be accepted in Validation until the non-conformity is closed; they can still be rejected. When disabled, the failure is shown on the row as a warning only.",
  "coldStorage.bacnetUdpPort": "BACnet UDP Port",
  "coldStorage.config.saveSuccess": "System configuration saved successfully",
  "coldStorage.configMoved": "Configuration Moved to Admin Panel",
  "coldStorage.configMovedDesc": "System-wide settings should be managed in the Admin UI where all global configurations are centralized. This page is read-only and will be removed in a future release.",
  "coldStorage.databaseVersion": "Database Version",
  "coldStorage.error.loadConfig": "Failed to load system configuration: ",
  "coldStorage.error.saveConfig": "Failed to save system configuration: ",
  "coldStorage.lastUpdate": "Last Update",
  "coldStorage.loadingConfig": "Loading system configuration...",
  "coldStorage.modbusTcpPort": "Modbus TCP Port",
  "coldStorage.protocolConfiguration": "Protocol Configuration",
  "coldStorage.readOnlyMode": "Read-Only Mode",
  "coldStorage.readOnlyModeDesc": "To modify these settings, please navigate to Admin → System Configuration",
  "coldStorage.securitySettings": "Security Settings",
  "coldStorage.sessionTimeout": "Session Timeout",
  "coldStorage.systemConfiguration": "System Configuration",
  "coldStorage.systemInformation": "System Information",
  "coldStorage.systemVersion": "System Version",
  "coldStorage.twoFactorAuth": "Two-Factor Authentication",
  "coldStorage.uptime": "Uptime",
  "customFieldType.page.hierarchy.management": "Custom Field Types",
  "customFieldType.page.hierarchy.root": "System Administration",
  "eqa.program.tests.helper": "Result intake for this scheme offers exactly these tests, on the results grid and in its CSV import.",
  "eqa.program.tests.saveFailed": "The scheme was saved but its tests were not. Reopen it and set them again.",
  "inventory.search.placeholder": "Search by item name, lot number or barcode",
  "label.results.control.capture.pass": "Pass",
  "label.results.control.capture.fail": "Fail",
  "message.noPluginFound": "No plugins Found",
  "nce.status.capa": "CAPA",
  "nce.status.completed": "Completed",
  "nce.capa.add": "Add",
  "plugin.files": "Plugin Files",
  "plugin.name": "Plugin Name",
  "sidenav.label.admin.analyzerTest": "Analyzer Test Name",
  "sidenav.label.admin.Listplugin": "List Plugins",
  "sidenav.label.admin.pluginFile": "Plugin Files",
  "label.testCatalog.accreditation.col.body": "Accrediting Body",
  "label.testCatalog.accreditation.col.expires": "Body Expires",
  "label.testCatalog.accreditation.col.status": "Status",
  "label.testCatalog.accreditation.col.actions": "Actions",
  "label.testCatalog.accreditation.remove.confirm": "Remove",
  "qa.qiConfig.title": "QI Configuration",
  "qa.qiConfig.error": "Unable to load QI configuration.",
  "qa.qiConfig.column.indicator": "Indicator",
  "qa.qiConfig.column.enabled": "Enabled",
  "qa.qiConfig.column.target": "Target",
  "qa.qiConfig.column.action": "Action threshold",
  "qa.qiConfig.column.actions": "Actions",
  "qa.qms.capaRegister.title": "CAPA Register",
  "qa.qms.capaRegister.tile.open": "Open",
  "qa.qms.capaRegister.tile.overdue": "Overdue",
  "qa.qms.capaRegister.filter.status": "Status",
  "qa.qms.capaRegister.filter.status.all": "All",
  "qa.qms.capaRegister.column.nceNumber": "NCE Number",
  "qa.qms.capaRegister.column.actionType": "Type",
  "qa.qms.capaRegister.column.dueDate": "Due Date",
  "qa.qms.capaRegister.column.completed": "Completed",
  "qa.qms.capaRegister.column.status": "Status",
  "qa.qms.accreditation.tile.active": "Active",
  "qa.qms.accreditation.tile.expiring": "Expiring Soon",
  "qa.qms.accreditation.tile.expired": "Expired",
  "qa.qms.accreditation.body.column.code": "Code",
  "qa.qms.accreditation.body.column.name": "Name",
  "qa.qms.accreditation.body.column.enrolled": "Enrolled Tests",
  "qa.qms.accreditation.body.column.status": "Status",
  "qa.qms.accreditation.body.column.actions": "Actions",
  "qa.qms.accreditation.body.field.code": "Code",
  "qa.qms.accreditation.body.field.name": "Name",
  "qa.qms.accreditation.body.field.displayOrder": "Display order",
  "qa.qms.accreditation.body.field.active": "Active",
  "qa.qms.accreditation.body.delete.confirm": "Delete",
  "qa.qms.accreditation.enrollment.column.test": "Test",
  "qa.qms.accreditation.enrollment.column.status": "Status",
  "qa.qms.accreditation.enrollment.column.actions": "Actions",
  "qa.qms.accreditation.eqa.column.body": "Accrediting Body",
  "qa.qms.accreditation.filter.status": "Status",
  "qa.qms.accreditation.filter.all": "All",
  "qa.qms.accreditation.filter.search": "Search tests",
  "qa.qms.accreditation.enroll.field.body": "Accrediting body",
  "qa.qms.accreditation.enroll.field.tests": "Tests",
  "qa.qms.accreditation.enrollment.delete.confirm": "Remove",
  "qa.qms.esigLog.title": "Electronic Signature Log",
  "qa.qms.esigLog.column.signedAt": "Signed At",
  "qa.qms.esigLog.column.action": "Action",
  "qa.qms.esigLog.column.reason": "Reason",
  "qa.qms.esigLog.filter.from": "Date Range (From)",
  "qa.qms.esigLog.filter.to": "Date Range (To)",
  "qa.qms.esigLog.filter.action": "Action",
  "qa.qms.esigLog.filter.user": "User",
  "qa.qms.esigLog.filter.all": "All",
  "qa.qms.esigLog.filter.clear": "Clear Filters",
  "qa.qms.esigLog.export.csv": "Export CSV",
  "qa.qms.esigLog.export.pdf": "Export PDF",
  "qa.qms.esigLog.export.confirm.confirm": "Export",
  "qa.qms.esigLog.export.confirm.cancel": "Cancel",
  "qa.qi.dashboard.title": "QI Dashboard",
  "qa.qi.dashboard.refresh": "Refresh",
  "qa.qi.dashboard.comingSoon": "Coming soon — {ticket}",
  "qa.qi.amendment.filter.from": "From",
  "qa.qi.amendment.filter.to": "To",
  "qa.qi.amendment.column.labNumber": "Lab number",
  "qa.qi.amendment.column.test": "Test",
  "qa.qi.amendment.empty": "No amendments in this window.",
  "qa.qi.amendment.error": "Amendment data is unavailable.",
  "qa.qi.amendment.trend.title": "Trend",
  "qa.qi.amendment.trend.series": "Amendment rate",
  "qa.qi.amendment.trend.interval": "Aggregation",
  "qa.qi.amendment.threshold.target": "Target",
  "qa.qi.amendment.threshold.action": "Action",
  "qa.qi.amendment.breakdown.column.test": "Test",
  "qa.qi.amendment.breakdown.column.amended": "Amended",
  "qa.qi.amendment.breakdown.column.released": "Released",
  "qa.qi.rejection.filter.from": "From",
  "qa.qi.rejection.filter.to": "To",
  "qa.qi.rejection.column.labNumber": "Lab number",
  "qa.qi.rejection.column.test": "Test",
  "qa.qi.rejection.column.reason": "Reason",
  "qa.qi.rejection.column.location": "Location",
  "qa.qi.rejection.column.nce": "NCE",
  "qa.qi.rejection.error": "Rejection data is unavailable.",
  "qa.qi.rejection.trend.title": "Trend",
  "qa.qi.rejection.trend.series": "Rejection rate",
  "qa.qi.rejection.trend.interval": "Aggregation",
  "qa.qi.rejection.trend.empty": "No trend data in this window.",
  "qa.qi.rejection.threshold.target": "Target",
  "qa.qi.rejection.threshold.action": "Action",
  "qa.qi.rejection.reasons.column.reason": "Reason",
  "qa.qi.rejection.reasons.column.count": "Count",
  "qa.qi.rejection.breakdown.title": "By test",
  "qa.qi.rejection.breakdown.column.test": "Test",
  "qa.qi.rejection.breakdown.column.rejected": "Rejected",
  "qa.qi.rejection.breakdown.column.total": "Started",
  "qa.qi.rejection.breakdown.column.rate": "Rate",
  "qa.qi.callback.failures.column.reason": "Reason",
  "qa.qi.callback.failures.column.count": "Count",
  "qa.qi.callback.error": "Callback data is unavailable.",
  "qa.qi.callback.column.releasedAt": "Released",
  "qa.qi.callback.column.labNumber": "Lab number",
  "qa.qi.callback.column.test": "Test",
  "qa.qi.callback.column.resultValue": "Result",
  "qa.qi.callback.column.criticalRange": "Critical range",
  "qa.qi.callback.column.recipient": "Person notified",
  "qa.comingSoon.subtitle": "This page is planned but not yet built.",
  "qa.overview.section.today": "Today",
  "qa.overview.tile.tat": "Average TAT",
  "qa.overview.tile.rejectionRate": "Rejection Rate",
  "qa.overview.tile.amendmentRate": "Amendment Rate",
  "qa.overview.tile.ncePulse": "NCE Pulse",
  "qa.overview.ncePulse.criticalPending": "critical pending",
  "qa.overview.ncePulse.inCorrectiveAction": "{count} in corrective action",
  "qa.overview.activity.system": "System",
  "storage.picker.backToSearch": "Back to search",
  "storage.picker.createNewLocation": "Create new location",
  "storage.picker.heading.moveSample": "Move Sample",
  "storage.picker.sample.accession": "Accession",
  "storage.picker.sample.heading": "Sample",
  "storage.picker.sample.status": "Status",
  "storage.picker.sample.type": "Type",
  "storage.metrics.storage.locations": "Storage Locations",
  "storage.tab.devices": "Devices",
  "storage.tab.racks": "Racks",
  "storage.tab.rooms": "Rooms",
  "storage.tab.shelves": "Shelves",
  "validation.label.qcHold": "QC failed",
  "validation.qcHold.blocked": "Some results were not released because a quality control covering them failed. Close the non-conformity, or reject the affected results.",
  "validation.qcHold.withheld": "{count, plural, one {1 result was not released ({accessions}). A QC failure covering it is still open. Review the non-conformity, or reject the result.} other {# results were not released ({accessions}). A QC failure covering them is still open. Review the non-conformity, or reject the result.}}",
  "qc.dashboard.export.button": "Export",
  "qc.dashboard.export.instrument": "Instrument",
  "qc.dashboard.export.level": "Control Level",
  "qc.dashboard.export.startDate": "Start Date",
  "qc.dashboard.export.endDate": "End Date",
  "qc.dashboard.export.csv": "Export CSV",
  "qc.dashboard.export.pdf": "Export PDF",
  "qc.dashboard.export.cancel": "Cancel",
  "qc.instrument.tab.timeline": "Activity Timeline",
  "qc.instrument.tab.chart": "Control Chart",
  "qc.chart.stats.mean": "Mean",
  "qc.chart.stats.n": "N",
  "qc.chart.subtitle": "Levey-Jennings control chart",
  "qc.chart.filter.startDate": "Start date",
  "qc.chart.filter.endDate": "End date",
  "qc.chart.filter.controlLevel": "Control level",
  "qc.chart.filter.selectLevel": "Select level",
  "qc.chart.filter.levelLow": "Low",
  "qc.chart.filter.levelNormal": "Normal",
  "qc.chart.filter.levelHigh": "High",
  "qc.chart.filter.controlLot": "Control lot",
  "qc.chart.filter.allLots": "All lots",
  "qc.chart.action.export": "Export",
  "qc.bench.source.label": "Source",
  "qc.bench.column.labUnit": "Lab unit",
  "qc.bench.column.test": "Test",
  "qc.bench.column.source": "Source",
  "qc.bench.column.failed": "Failed",
  "eqa.distribution.updateSuccess": "Draft distribution updated.",
  "banner.menu.eqa.myCycles": "My Cycles",
  "banner.menu.eqa.labPerformance": "Lab Performance",
  "banner.menu.eqa.followUpQueue": "This Lab's Follow-Up",
  "banner.menu.eqa.analystCompetency": "Analyst Competency",
  "banner.menu.eqa.provider": "EQA Provider",
  "eqa.participant.myCycles.title": "My EQA Cycles",
  "eqa.participant.myCycles.subtitle": "Cycles your lab is participating in. Result entry and validation happen in the standard OpenELIS result pipeline — this page tracks progress and routes you there.",
  "eqa.participant.infoTitle": "EQA results flow through standard validation.",
  "eqa.participant.infoBody": "Click a Lab No to open standard result entry for that sample. Once validation completes, the cycle advances to Submitted (or Ready to submit if the scheme requires cycle-level review).",
  "eqa.kpi.active": "Active cycles",
  "eqa.kpi.active.hint": "in flight",
  "eqa.kpi.readyToSubmit": "Ready to submit",
  "eqa.kpi.readyToSubmit.hint": "with review flag on",
  "eqa.kpi.awaiting": "Awaiting scores",
  "eqa.kpi.awaiting.hint": "submitted to provider",
  "eqa.kpi.openNce": "Open EQA-linked NCE",
  "eqa.kpi.openNce.attention": "needs attention",
  "eqa.kpi.openNce.none": "none open",
  "eqa.bucket.label": "Status",
  "eqa.bucket.active": "Active",
  "eqa.bucket.awaiting": "Awaiting scores",
  "eqa.bucket.completed": "Completed",
  "eqa.bucket.all": "All",
  "eqa.bucket.active.hint": "Work in flight — upcoming, testing, or ready to submit",
  "eqa.bucket.awaiting.hint": "Submitted to provider; waiting for scoring",
  "eqa.bucket.completed.hint": "Scored or closed",
  "eqa.bucket.all.hint": "Every cycle this lab has ever touched",
  "eqa.filter.schemeType": "Scheme type",
  "eqa.schemeType.all": "All types",
  "eqa.schemeType.international_pt": "International PT",
  "eqa.schemeType.regional_pt": "Regional PT",
  "eqa.schemeType.inter_lab_split": "Inter-lab split",
  "eqa.schemeType.in_house": "In-house",
  "eqa.filter.searchCycles": "Search scheme, provider, or cycle",
  "eqa.filter.showing": "Showing {shown} of {total} cycles",
  "eqa.filter.clear": "Clear filters",
  "eqa.col.scheme": "Scheme",
  "eqa.col.type": "Type",
  "eqa.col.cycle": "Cycle",
  "eqa.col.status": "Status",
  "eqa.col.deadline": "Deadline",
  "eqa.col.progress": "Progress",
  "eqa.cycle.status.planned": "Planned",
  "eqa.cycle.status.panel_received": "Panel received",
  "eqa.cycle.status.testing": "Testing",
  "eqa.cycle.status.ready_to_submit": "Ready to submit",
  "eqa.cycle.status.submitted": "Submitted",
  "eqa.cycle.status.scored": "Scored",
  "eqa.cycle.status.closed": "Closed",
  "eqa.cycle.toggleDetails": "Toggle cycle details",
  "eqa.cycle.emptyFiltered": "No cycles match these filters.",
  "eqa.cycle.nceBanner": "Unacceptable score on {scheme}. Follow up in the NCE register.",
  "eqa.cycle.perAnalyst.title": "Per-analyst required",
  "eqa.cycle.perAnalyst.body": "Analysts are mapped at scheme enrollment. The per-analyst column is visible on the standard result entry page.",
  "eqa.cycle.review.title": "Optional cycle-level review enabled for this scheme.",
  "eqa.cycle.review.body": "All {total} analytes validated in the standard pipeline. Submit is a single click — validation is the authoritative gate, no re-authentication.",
  "eqa.btn.reviewSubmit": "Review & submit",
  "eqa.cycle.submitted.success": "Cycle submitted to provider — awaiting scores.",
  "eqa.cycle.submitted.error": "Submit failed — the cycle was not advanced. Check that all results are validated and try again.",
  "eqa.progress.title": "Sample progress",
  "eqa.sample.labNo": "Lab No",
  "eqa.sample.providerId": "Provider sample ID",
  "eqa.sample.analytes": "Analytes",
  "eqa.sample.analyst": "Assigned analyst",
  "eqa.sample.entryStatus": "Entry status",
  "eqa.labNo.tooltip": "Open results entry for this lab number",
  "eqa.entry.entered": "Entered",
  "eqa.entry.in_progress": "In progress",
  "eqa.entry.empty": "Not entered",
  "eqa.cycle.scoredCopy": "Scoring complete. Scored results appear under Lab Performance.",
  "eqa.cycle.submittedCopy": "Submitted to provider — awaiting scores.",
  "eqa.cycle.closedCopy": "Cycle closed.",
  "eqa.cycle.panelReceivedCopy": "Panel received. Proceed to standard result entry to begin testing.",
  "eqa.cycle.plannedCopy": "Panel has not yet been received at this lab. Open Add Order with the EQA box checked to record the receipt.",
  "eqa.btn.receivePanel": "Receive panel — open Add Order",
  "eqa.uncycled.title": "Uncycled EQA orders",
  "eqa.uncycled.subtitle": "EQA orders not linked to any cycle. They stay visible here so nothing is lost.",
  "eqa.review.title": "Pre-submission summary",
  "eqa.review.subtitle": "Read-only summary of every validated result, grouped by sample. This is what will be submitted to the provider.",
  "eqa.review.auditFootnote": "Every value above was validated in the standard pipeline, which captured the validating user in the audit trail. Submitting records the acknowledgement only — no separate sign-off.",
  "eqa.sample.analyte": "Analyte",
  "eqa.sample.reportedValue": "Reported value",
  "eqa.sample.validatedAt": "Validated",
  "eqa.order.cycle": "EQA Cycle",
  "eqa.order.receipt.title": "Panel Receipt",
  "eqa.order.receipt.tempC": "Temperature on arrival (°C)",
  "eqa.order.receipt.integrityOk": "Panel arrived intact",
  "eqa.order.receipt.notes": "Integrity notes",
  "eqa.order.receipt.recorded": "Panel receipt already recorded on {date}.",
  "eqa.cycle.status.prep_in_progress": "Prep in progress",
  "eqa.cycle.status.ready_to_ship": "Ready to ship",
  "eqa.cycle.status.shipped": "Shipped",
  "eqa.cycle.status.delivered": "Delivered",
  "eqa.cycle.status.submissions_open": "Submissions open",
  "eqa.cycle.status.submissions_closed": "Submissions closed",
  "eqa.cycle.status.scoring": "Scoring",
  "eqa.provider.workbench.cycle": "Cycle workbench",
  "eqa.provider.workbench.forCycle": "Prep & shipping — {name}",
  "eqa.provider.workbench.tabs": "Workbenches",
  "eqa.provider.workbench.stateHint": "Prep must clear the inventory and QC gate before any panel can be dispatched.",
  "eqa.prep.tab": "Prep",
  "eqa.prep.participants": "Participants",
  "eqa.prep.panels": "Panels",
  "eqa.prep.gate": "Ready-to-ship gate",
  "eqa.prep.gate.clear": "All prep requirements met",
  "eqa.prep.noPanel.title": "No panel prepared",
  "eqa.prep.noPanel.body": "Create the cycle's panel and its samples before recording prep progress.",
  "eqa.prep.needExplained": "Aliquots needed: {samples, plural, one {# sample} other {# samples}} x {participants, plural, one {# participant} other {# participants}} + {reserved} held in reserve = {needed, plural, one {# aliquot} other {# aliquots}}; {shipped, plural, one {# aliquot} other {# aliquots}} dispatched so far.",
  "eqa.prep.produced": "Aliquots produced",
  "eqa.prep.reserved": "Aliquots reserved",
  "eqa.prep.shortfall": "{n} short",
  "eqa.prep.homogeneity": "Homogeneity QC passed",
  "eqa.prep.homogeneityNotes": "QC notes",
  "eqa.prep.save": "Save prep record",
  "eqa.prep.saved": "Prep record updated.",
  "eqa.prep.saveFailed": "Prep record was not saved.",
  "eqa.prep.readyToShip": "Mark cycle ready to ship",
  "eqa.prep.readyToShip.success": "Cycle cleared to ship — record courier details on the Shipments tab.",
  "eqa.prep.readyToShip.refused": "The cycle was not cleared to ship. Resolve the outstanding prep items and try again.",
  "eqa.shipment.tab": "Shipments",
  "eqa.shipment.participant": "Participant",
  "eqa.shipment.box": "Box",
  "eqa.shipment.courier": "Courier",
  "eqa.shipment.courierFor": "Courier for {name}",
  "eqa.shipment.tracking": "Tracking number",
  "eqa.shipment.trackingFor": "Tracking number for {name}",
  "eqa.shipment.expected": "Expected delivery",
  "eqa.shipment.expectedFor": "Expected delivery for {name}",
  "eqa.shipment.selectAll": "Select all pending",
  "eqa.shipment.selectRow": "Select {name} for dispatch",
  "eqa.shipment.markShipped": "Mark {n} shipped",
  "eqa.shipment.firstShipHint": "The first dispatch moves the cycle to shipped.",
  "eqa.shipment.saved": "Shipment details saved.",
  "eqa.shipment.saveFailed": "Shipment details were not saved.",
  "eqa.shipment.shipped": "{n} participant shipments dispatched.",
  "eqa.shipment.shipFailed": "Nothing was dispatched.",
  "eqa.shipment.shippedOn": "Shipped {date}",
  "eqa.shipment.packList": "Pack list",
  "eqa.shipment.packList.noPanel": "This cycle has no panel, so there is nothing to pack.",
  "eqa.shipment.packList.unavailable": "The panel samples could not be read, so no pack list was produced. Reload and try again.",
  "eqa.shipment.packList.notes": "EQA panel material — do not open before the testing window.",
  "eqa.shipment.label": "Label",
  "eqa.shipment.noParticipants.title": "No participants",
  "eqa.shipment.noParticipants.body": "Enrol participant laboratories in this cycle before shipping panels.",
  "eqa.report.download": "Download performance report",
  "banner.menu.eqa.inHouse": "In-House Blinding",
  "eqa.inhouse.wizard.title": "Create in-house blinded panel",
  "eqa.inhouse.step1": "Scheme & cycle",
  "eqa.inhouse.step2": "Samples & prep",
  "eqa.inhouse.step3": "Analysts",
  "eqa.inhouse.step4": "Confirm & seal",
  "eqa.inhouse.scheme": "In-house scheme",
  "eqa.inhouse.cycleName": "Cycle name",
  "eqa.inhouse.plannedStart": "Planned start date",
  "eqa.inhouse.unblindDate": "Unblind date (submission deadline)",
  "eqa.inhouse.sample": "Sample",
  "eqa.inhouse.samples": "Samples",
  "eqa.inhouse.test": "Test",
  "eqa.inhouse.target": "Target value",
  "eqa.inhouse.unit": "Unit",
  "eqa.inhouse.rangeLow": "Range low",
  "eqa.inhouse.rangeHigh": "Range high",
  "eqa.inhouse.addSample": "Add sample",
  "eqa.inhouse.analyst": "Analyst",
  "eqa.inhouse.roster": "Scheme analysts",
  "eqa.inhouse.roster.pick": "Select analysts",
  "eqa.inhouse.roster.saveError": "Could not save the analyst roster",
  "eqa.inhouse.assign.manual": "Assign analysts manually (otherwise round-robin)",
  "eqa.inhouse.assign.mode": "Assignment mode",
  "eqa.inhouse.assign.ROUND_ROBIN": "Round-robin — one analyst per sample, dealt in rotation",
  "eqa.inhouse.assign.IDENTICAL": "Identical set — every analyst tests the same samples",
  "eqa.inhouse.assign.MANUAL": "Manual per-sample assignment",
  "eqa.inhouse.assign.identicalNote": "Every analyst runs every sample: {materials, plural, one {# sample} other {# samples}} × {analysts, plural, one {# analyst} other {# analysts}} = {aliquots, plural, one {# blinded aliquot} other {# blinded aliquots}}, each with its own blind code.",
  "eqa.inhouse.assign.footnote": "Each assignment is recorded on the blinded order it creates, and follows that order through result entry.",
  "eqa.inhouse.gate.identicalNeedsAnalysts": "An identical set needs at least one analyst on the scheme roster",
  "eqa.inhouse.samplesLeadIn": "{count, plural, one {# sample} other {# samples}} defined. Target values are sealed when the wizard finishes; they are never stored in clear text.",
  "eqa.inhouse.confirm.aliquotRows": "Blinded aliquots",
  "eqa.inhouse.confirm.sealWarning": "Sealing encrypts the target values",
  "eqa.inhouse.confirm.sealWarningBody": "After sealing, revealing a target takes the unblind privilege and is recorded in the audit trail. The panel cannot be edited afterwards.",
  "eqa.inhouse.confirm.afterSeal": "Sealing creates one blinded order per aliquot. They appear in result entry and the Workplan under their blind codes, like any other order.",
  "eqa.inhouse.prep.sourceType": "Source",
  "eqa.inhouse.prep.lotNumber": "Lot number",
  "eqa.inhouse.prep.aliquots": "Aliquots produced",
  "eqa.inhouse.prep.storageTemp": "Storage temperature",
  "eqa.inhouse.prep.expiration": "Expiration date",
  "eqa.inhouse.prep.homogeneity": "Homogeneity QC passed",
  "eqa.inhouse.prep.homogeneityNotes": "Homogeneity QC notes",
  "eqa.inhouse.gate.noSamples": "Add at least one sample before continuing",
  "eqa.inhouse.gate.aliquots": "Aliquots produced must cover every blinded sample",
  "eqa.inhouse.gate.homogeneity": "Homogeneity QC has not passed, so distributing requires a written justification",
  "eqa.inhouse.gate.targets": "Every sample needs a test and a target value",
  "eqa.inhouse.confirm.samples": "Samples",
  "eqa.inhouse.confirm.labelNote": "Label sheets carry the blind code, cycle and analyte only — never a target value.",
  "eqa.inhouse.seal": "Seal panel & distribute",
  "eqa.inhouse.seal.error": "Could not seal the panel",
  "eqa.inhouse.seal.cycleError": "Could not create the cycle",
  "eqa.inhouse.seal.panelError": "Could not create the panel",
  "eqa.inhouse.sealed.title": "Panel sealed and distributed",
  "eqa.inhouse.sealed.help": "The blinded orders now carry these blind codes as their sample IDs, in result entry and in the Workplan.",
  "eqa.inhouse.sealed.done": "Back to in-house panels",
  "eqa.inhouse.panel": "EQA material panel",
  "eqa.inhouse.panel.defaultName": "In-house panel",
  "eqa.inhouse.cycle": "Cycle",
  "eqa.inhouse.status": "Status",
  "eqa.inhouse.actions": "Actions",
  "eqa.inhouse.launchWizard": "Launch blinding wizard",
  "eqa.inhouse.noSchemes": "No in-house scheme exists yet. Create one under EQA scheme management first.",
  "eqa.inhouse.labels.print": "Print label sheet",
  "eqa.inhouse.labels.error": "Could not generate the label sheet",
  "eqa.inhouse.unblind.now": "Unblind now",
  "eqa.inhouse.unblind.done": "Panel unblinded and scored",
  "eqa.inhouse.unblind.error": "Could not unblind this panel",
  "eqa.inhouse.targetValues": "Target values",
  "eqa.inhouse.seal.sealed": "Sealed",
  "eqa.inhouse.seal.unsealed": "Unsealed",
  "eqa.inhouse.kpi.awaitingDistribution": "Sealed, awaiting distribution",
  "eqa.inhouse.kpi.inTesting": "In testing",
  "eqa.inhouse.kpi.unblindingSoon": "Unblinding within 7 days",
  "eqa.inhouse.kpi.closed": "Scored or closed",
  "eqa.inhouse.prep.title": "Prep & aliquoting details",
  "eqa.inhouse.prep.subtitle": "Record the same panel inventory details that a provider records.",
  "eqa.inhouse.prep.required": "Required: {samples, plural, one {# sample} other {# samples}} = {samples, plural, one {# aliquot} other {# aliquots}} minimum",
  "eqa.inhouse.back": "Back",
  "eqa.inhouse.next": "Next",
  "eqa.inhouse.cancel": "Cancel",
  "eqa.enrollment.testAnalytes": "Reporting analyte per test",
  "eqa.enrollment.testAnalytes.help": "Set which analyte each test reports for this scheme. Results are submitted to the provider under this analyte; a test left unset is not submitted automatically.",
  "eqa.enrollment.selectAnalyte": "Choose an analyte",
  "eqa.provider.schemes.title": "EQA schemes we provide",
  "eqa.provider.schemes.hint": "Expand a scheme to see its cycles, or start a new cycle to define its panel and participants.",
  "eqa.provider.schemes.none.title": "No schemes to provide yet",
  "eqa.provider.schemes.none.body": "A scheme appears here once another laboratory is actively enrolled in it.",
  "eqa.provider.schemes.provider": "Provider",
  "eqa.provider.schemes.enrolled": "Enrolled labs",
  "eqa.provider.schemes.cycles": "Cycles",
  "eqa.provider.schemes.expand": "Show cycles",
  "eqa.provider.schemes.newCycle": "New cycle",
  "eqa.provider.schemes.noCycles": "No cycles yet. Start one to define its panel and participants.",
  "eqa.scheme.type.international_pt": "International PT",
  "eqa.scheme.type.regional_pt": "Regional PT",
  "eqa.scheme.type.inter_lab_split": "Inter-lab split",
  "eqa.scheme.type.in_house": "In-house",
  "eqa.panel.source.in_house_aliquoted": "Patient-sample pool, aliquoted in-house",
  "eqa.panel.source.vendor_sourced": "Vendor-supplied material",
  "eqa.panel.source.mixed": "Mixed sources",
  "eqa.panel.storage.ambient": "Room temperature",
  "eqa.panel.storage.refrigerated_2_8c": "Refrigerated, 2–8°C",
  "eqa.panel.storage.frozen_minus_20c": "Frozen, −20°C",
  "eqa.panel.storage.ultra_frozen_minus_80c": "Ultra-frozen, −80°C",
  "eqa.panel.storage.dry_ice": "Dry ice",
  "eqa.provider.wizard.title": "New cycle",
  "eqa.provider.wizard.forScheme": "New cycle — {name}",
  "eqa.provider.wizard.step.cycle": "Cycle",
  "eqa.provider.wizard.step.panel": "Panel",
  "eqa.provider.wizard.step.distribution": "Distribution",
  "eqa.provider.wizard.cycleName": "Cycle name",
  "eqa.provider.wizard.cycleNumber": "Cycle number",
  "eqa.provider.wizard.cycleNumber.hint": "Left blank, the next unused number for this scheme is used.",
  "eqa.provider.wizard.panelName": "Panel name",
  "eqa.provider.wizard.source": "Material source",
  "eqa.provider.wizard.lot": "Lot number",
  "eqa.provider.wizard.vendor": "Vendor name",
  "eqa.provider.wizard.vendorLot": "Vendor lot",
  "eqa.provider.wizard.vendorCertificate": "Vendor certificate reference",
  "eqa.provider.wizard.sampleCode": "Sample code",
  "eqa.provider.wizard.target": "Target value",
  "eqa.provider.wizard.target.hint": "A target value is sealed and encrypted at rest; leave it blank when the target is only known at scoring time.",
  "eqa.provider.wizard.unit": "Unit",
  "eqa.provider.wizard.rangeLow": "Acceptance low",
  "eqa.provider.wizard.rangeHigh": "Acceptance high",
  "eqa.provider.wizard.addSample": "Add sample",
  "eqa.provider.wizard.removeSample": "Remove",
  "eqa.provider.wizard.sampleCount": "Panel samples",
  "eqa.provider.wizard.test": "Test",
  "eqa.provider.wizard.test.select": "Select a test",
  "eqa.provider.wizard.participants": "Participating laboratories",
  "eqa.provider.wizard.participants.hint": "Only labs actively enrolled in this scheme can take part, and only those chosen here are counted by the prep gate.",
  "eqa.provider.wizard.storageTemp": "Storage temperature",
  "eqa.provider.wizard.storageTemp.hint": "Becomes each shipping box's temperature requirement.",
  "eqa.provider.wizard.storageTemp.select": "Select a temperature",
  "eqa.provider.wizard.expiration": "Material expiry",
  "eqa.provider.wizard.reserve.hint": "Aliquots held back for repeat testing are recorded on the prep workbench, once the material exists.",
  "eqa.provider.wizard.confirm.hint": "Creating the cycle moves it straight into prep, where aliquot counts and homogeneity QC are recorded.",
  "eqa.provider.wizard.create": "Create cycle and begin prep",
  "eqa.provider.wizard.failed": "The cycle was not created.",
  "eqa.cycle.distributionMethod": "Distribution method",
  "eqa.cycle.distributionMethod.fhir": "FHIR",
  "eqa.cycle.distributionMethod.csv": "CSV export",
  "eqa.cycle.distributionMethod.mixed": "Mixed",
  "eqa.cycle.distributionMethod.hint": "Wired FHIR, exported files, or both where participants differ. The panel's cold chain is recorded with its source in step 2.",
  "eqa.cycle.history": "Cycle history",
  "eqa.cycle.history.empty": "No state changes recorded for this cycle yet.",
  "eqa.cycle.history.when": "When",
  "eqa.cycle.history.state": "State",
  "eqa.cycle.history.trigger": "Trigger",
  "eqa.cycle.history.reason": "Reason",
  "eqa.cycle.history.manual": "Manual",
  "eqa.report.comments.tab": "Report comments",
  "eqa.report.comments.hint": "Only pre-approved comments can be printed. Edit the wording under Administration → Dictionary Management.",
  "eqa.report.comments.picker": "Approved comments",
  "eqa.report.comments.pickerLabel": "Select comments",
  "eqa.report.comments.add": "Add to report",
  "eqa.report.comments.added": "{count} comment(s) added to the report",
  "eqa.report.comments.comment": "Comment",
  "eqa.report.comments.attribution": "Added by",
  "eqa.report.comments.none": "No comments on this cycle's report yet.",
  "eqa.report.comments.remove": "Remove",
  "eqa.report.comments.emptyLibrary.title": "No approved comments configured",
  "eqa.report.comments.emptyLibrary.body": "Add entries to the EQA Report Comment dictionary category to make them selectable here.",
  "eqa.report.comments.addFailed": "The comment could not be added to the report.",
  "eqa.report.comments.removeFailed": "The comment could not be removed from the report.",
  "eqa.performance.ACCEPTABLE": "Acceptable",
  "eqa.performance.QUESTIONABLE": "Questionable",
  "eqa.performance.UNACCEPTABLE": "Unacceptable",
  "eqa.oversight.followUpQueue": "This Lab's Follow-Up",
  "eqa.oversight.queueSubtitle": "This lab's questionable EQA scores awaiting corrective review, from external providers and this lab's own in-house schemes. Correspondence with the laboratories that take part in the schemes this lab provides is a different register:",
  "eqa.queue.policyTitle": "Auto-NCE policy active.",
  "eqa.queue.policyBody": "Unacceptable scores on any external scheme this lab participates in open an NCE automatically. This queue holds the questionable range (2 < |Z| ≤ 3) and in-house failures, which need human triage.",
  "eqa.queue.kpi.queued": "Items queued",
  "eqa.queue.kpi.questionable": "Questionable",
  "eqa.queue.kpi.questionable.hint": "2 < |Z| ≤ 3",
  "eqa.queue.kpi.inHouse": "In-house failures",
  "eqa.queue.kpi.oldest": "Oldest",
  "eqa.queue.kpi.days": "{days} days",
  "eqa.queue.count": "Queue · {count, plural, one {# item} other {# items}}",
  "eqa.queue.exportCsv": "Export CSV",
  "eqa.queue.empty": "Nothing awaiting triage. Questionable scores and in-house failures land here as cycles are scored.",
  "eqa.queue.cycle": "Cycle",
  "eqa.queue.cycleNumber": "Cycle {number}",
  "eqa.queue.analyte": "Analyte",
  "eqa.queue.analytePlus": "{first} +{more} more",
  "eqa.queue.zScore": "Z-score",
  "eqa.queue.reason": "Reason",
  "eqa.queue.enqueued": "Enqueued",
  "eqa.queue.source": "Source",
  "eqa.queue.source.external": "External provider",
  "eqa.queue.source.in_house": "In-house",
  "eqa.queue.source.inter_lab_split": "Inter-lab split",
  "eqa.queue.reason.questionable": "Questionable",
  "eqa.queue.reason.inHouseFailure": "In-house fail",
  "eqa.queue.triage": "Triage",
  "eqa.queue.triageTitle": "Triage this item",
  "eqa.queue.triageHelp": "Escalate if you suspect a real non-conformity. Dismiss with a reason if this is noise — a transcription error, or equipment trouble already documented. Dismissed entries stay linked to the cycle for accreditation trace.",
  "eqa.queue.reported": "Reported",
  "eqa.queue.target": "Target",
  "eqa.queue.verdict": "Verdict",
  "eqa.queue.escalate": "Escalate to NCE",
  "eqa.queue.dismiss": "Dismiss with reason",
  "eqa.queue.viewCycle": "View cycle",
  "eqa.queue.escalated": "Escalated — NCE {nce} raised for this cycle.",
  "eqa.queue.escalateFailed": "The escalation was refused.",
  "eqa.queue.dismissed": "Dismissed. The competency event for this category is recorded.",
  "eqa.queue.dismissFailed": "The dismissal was refused.",
  "eqa.queue.dismissHeading": "Dismiss with reason",
  "eqa.queue.dismissConfirm": "Dismiss",
  "eqa.queue.dismissHelp": "The category decides which competency event is written against every result this entry covers, so pick the one that describes what happened.",
  "eqa.queue.cancel": "Cancel",
  "eqa.queue.category": "Category",
  "eqa.queue.category.TRANSCRIPTION_ERROR": "Transcription error",
  "eqa.queue.category.KNOWN_EQUIPMENT_ISSUE": "Known equipment issue",
  "eqa.queue.category.PENDING_RE_TEST": "Pending re-test",
  "eqa.queue.category.ACCEPTABLE_ON_REVIEW": "Acceptable on review",
  "eqa.queue.category.OTHER": "Other",
  "eqa.queue.notes": "Notes",
  "eqa.labperf.title": "Lab Performance",
  "eqa.labperf.coverage.title": "Lab EQA Performance — Coverage",
  "eqa.labperf.coverage.subtitle": "Accreditation snapshot: lab-wide KPIs, then EQA coverage by section across each scheme's last four cycles. Sections with no active PT are candidates for ISO 15189 §7.7.2 alternative assessment.",
  "eqa.labperf.recent.title": "Lab EQA Performance — Recent Cycles",
  "eqa.labperf.recent.subtitle": "Cycles this lab reported in the last 12 months, with scoring status and verdict.",
  "eqa.labperf.tab.coverage": "Coverage",
  "eqa.labperf.tab.recent": "Recent Cycles",
  "eqa.labperf.kpi.acceptance": "Acceptance rate (12 mo)",
  "eqa.labperf.kpi.delta": "{delta} vs. prior year",
  "eqa.labperf.kpi.noPriorYear": "no prior year to compare",
  "eqa.labperf.kpi.onTime": "On-time submission rate",
  "eqa.labperf.kpi.late": "{late} late of {total}",
  "eqa.labperf.kpi.nce": "EQA-triggered NCEs (12 mo)",
  "eqa.labperf.kpi.nceOpen": "{open} open → NCE register",
  "eqa.labperf.kpi.uncovered": "Accredited tests without EQA",
  "eqa.labperf.kpi.uncovered.hint": "§7.7.2 candidates",
  "eqa.labperf.openNceRegister": "Open the NCE register filtered to EQA-triggered events",
  "eqa.labperf.legendIntro": "Each scheme's last four cycles, by section.",
  "eqa.labperf.legend.acceptable": "Acceptable",
  "eqa.labperf.legend.questionable": "Questionable",
  "eqa.labperf.legend.unacceptable": "Unacceptable",
  "eqa.labperf.legend.missing": "Not enrolled / missed",
  "eqa.labperf.section": "Section",
  "eqa.labperf.unassignedSection": "Unassigned section",
  "eqa.labperf.scheme": "Scheme",
  "eqa.labperf.cycle": "Cycle",
  "eqa.labperf.cycleOffset": "Cycle −{n}",
  "eqa.labperf.mostRecent": "Most recent",
  "eqa.labperf.acceptanceRate": "Acceptance rate",
  "eqa.labperf.coverage.empty": "No scored EQA results yet. Coverage appears once a cycle this lab took part in has been scored.",
  "eqa.labperf.gapTitle": "Accredited without EQA cover:",
  "eqa.labperf.gapBody": "{tests} — no active EQA enrollment, so ISO 15189 §7.7.2 alternative assessment is required.",
  "eqa.labperf.filterScheme": "Filter scheme",
  "eqa.labperf.status": "Status",
  "eqa.labperf.score": "Score",
  "eqa.labperf.scoreOf": "{acceptable} of {scored}",
  "eqa.labperf.performance": "Performance",
  "eqa.labperf.submitted": "Submitted",
  "eqa.labperf.pending": "pending",
  "eqa.labperf.verdict.acceptable": "Acceptable",
  "eqa.labperf.verdict.questionable": "Questionable",
  "eqa.labperf.verdict.unacceptable": "Unacceptable",
  "eqa.labperf.recent.empty": "No cycles reported in the last 12 months.",
  "nce.filter.source": "Source",
  "nce.filter.source.all": "All sources",
  "nce.filter.source.eqa": "EQA-triggered",
  "eqa.receipt.tab": "Receipts & scoring",
  "eqa.receipt.hint": "Submissions open on their own once every participant holds its panel. Overdue means two business days past the expected delivery.",
  "eqa.receipt.noParticipants.body": "Receipts appear here once panels have been dispatched to enrolled participant laboratories.",
  "eqa.receipt.condition": "Condition",
  "eqa.receipt.damaged": "Damaged: {notes}",
  "eqa.receipt.tempOnArrival": "{temp} °C",
  "eqa.receipt.isRepeat": "Repeat shipment",
  "eqa.receipt.markReceived": "Mark received",
  "eqa.receipt.delivered": "Delivery recorded.",
  "eqa.receipt.deliveredFailed": "The delivery could not be recorded.",
  "eqa.receipt.sendRepeat": "Send repeat",
  "eqa.receipt.repeatHeading": "Send a repeat panel",
  "eqa.receipt.repeatHelp": "The repeat comes out of the panel's reserve. If the reserve cannot cover it, a written justification is required before unreserved material is used.",
  "eqa.receipt.overrideNote": "Override note",
  "eqa.receipt.repeatSent": "Repeat panel dispatched.",
  "eqa.receipt.repeatFailed": "The repeat was refused.",
  "eqa.receipt.status.NOT_SHIPPED": "Not shipped",
  "eqa.receipt.status.IN_TRANSIT": "In transit",
  "eqa.receipt.status.EXCEPTION": "Arrived damaged",
  "eqa.score.scoreCycle": "Score cycle",
  "eqa.score.scored": "Cycle scored. Unacceptable participants are in the follow-up register.",
  "eqa.score.scoreFailed": "The cycle could not be scored.",
  "eqa.score.verdicts": "Scores",
  "eqa.score.counts": "{unacceptable} unacceptable of {total}",
  "eqa.score.sendScores": "Send scores",
  "eqa.score.distributed": "Scores placed in the FHIR store for the participant to collect.",
  "eqa.score.distributeFailed": "The scores could not be returned.",
  "eqa.score.downloadCsv": "Scores CSV",
  "eqa.provider.followups.title": "Participant follow-up",
  "eqa.provider.followups.subtitle": "Laboratories participating in the schemes this lab provides that returned unacceptable results. Follow-up here is correspondence with another lab — it never opens a non-conformity in this lab's own register.",
  "eqa.provider.followups.open": "Follow-up register",
  "eqa.provider.followups.empty": "No participant follow-ups. Entries appear here as provider cycles are scored.",
  "eqa.provider.followups.unknownOrg": "Unknown lab",
  "eqa.provider.followups.persistent": "Persistent failure",
  "eqa.provider.followups.response": "Response",
  "eqa.provider.followups.notify": "Notify lab",
  "eqa.provider.followups.emailed": "Notification emailed to {to}.",
  "eqa.provider.followups.csvFallback": "No contact email on file — the notification was downloaded as CSV to send by hand.",
  "eqa.provider.followups.flagRepeat": "Flag for repeat",
  "eqa.provider.followups.repeatSent": "Repeat panel dispatched to {name}.",
  "eqa.provider.followups.moved": "Follow-up moved to {status}.",
  "eqa.provider.followups.failed": "The action was refused.",
  "eqa.provider.followups.notesHelp": "What was agreed with the laboratory. Recorded against the register entry for accreditation trace.",
  "eqa.provider.followups.status.NOTIFIED": "Notified",
  "eqa.provider.followups.status.RESPONSE_RECEIVED": "Response received",
  "eqa.provider.followups.status.UNDER_INVESTIGATION": "Under investigation",
  "eqa.provider.followups.status.ESCALATED": "Escalated",
  "eqa.provider.followups.status.REMOVED_FROM_PROGRAM": "Removed from scheme",
  "eqa.provider.followups.action.RESPONSE_RECEIVED": "Record response",
  "eqa.provider.followups.action.UNDER_INVESTIGATION": "Investigate",
  "eqa.provider.followups.action.RESOLVED": "Resolve",
  "eqa.provider.followups.action.REMOVED_FROM_PROGRAM": "Remove from scheme",
  "eqa.competency.subtitle": "Every analyst assigned to proficiency testing in the last twelve months, banded per analyte. An analyst is competent only where the evidence says so — fewer than four assessable samples reads as under review, not as a pass.",
  "eqa.competency.band.competent": "Competent",
  "eqa.competency.band.underReview": "Under review",
  "eqa.competency.band.notCompetent": "Not competent",
  "eqa.competency.outcome.acceptable": "Acceptable",
  "eqa.competency.outcome.questionable": "Questionable",
  "eqa.competency.outcome.unacceptable": "Unacceptable",
  "eqa.competency.outcome.missed": "Missed deadline",
  "eqa.competency.outcome.dismissed": "Dismissed on triage",
  "eqa.competency.event.scored": "Scored result",
  "eqa.competency.event.UNACCEPTABLE_SCORE": "Unacceptable score",
  "eqa.competency.event.QUESTIONABLE_SCORE": "Questionable score",
  "eqa.competency.event.EXTERNAL_MISSED_DEADLINE": "Missed provider deadline",
  "eqa.competency.event.IN_HOUSE_MISSED_DEADLINE": "Missed in-house deadline",
  "eqa.competency.event.ESCALATED_TO_NCE": "Escalated to non-conformity",
  "eqa.competency.event.DISMISSED_EQUIPMENT": "Dismissed — equipment",
  "eqa.competency.event.DISMISSED_TRANSCRIPTION": "Dismissed — transcription",
  "eqa.competency.event.DISMISSED_ACCEPTABLE_ON_REVIEW": "Dismissed — acceptable on review",
  "eqa.competency.event.DISMISSED_OTHER": "Dismissed — other",
  "eqa.competency.kpi.analysts": "Analysts assessed",
  "eqa.competency.kpi.samples": "{count} PT samples",
  "eqa.competency.kpi.notCompetent.hint": "Open escalated NCE",
  "eqa.competency.search": "Filter analysts",
  "eqa.competency.export": "Export CSV",
  "eqa.competency.analyst": "Analyst",
  "eqa.competency.samples": "PT samples (12 mo)",
  "eqa.competency.recent": "Most recent performance",
  "eqa.competency.status": "Competency",
  "eqa.competency.history": "History",
  "eqa.competency.viewHistory": "View history",
  "eqa.competency.empty": "No analyst has been recorded on an EQA result in the last twelve months. Analysts appear here once results carry an assigned analyst.",
  "eqa.competency.analyteCount": "{count} analytes assessed",
  "eqa.competency.thisYear": "{count} this year · {failures} failed",
  "eqa.competency.byAnalyte": "Competency by analyte",
  "eqa.competency.analyte": "Analyte",
  "eqa.competency.evaluable": "Evaluable",
  "eqa.competency.failures": "Failures",
  "eqa.competency.latest": "Latest",
  "eqa.competency.unnamedAnalyte": "Unnamed analyte",
  "eqa.competency.evidence": "Evidence · every event in the window",
  "eqa.competency.date": "Date",
  "eqa.competency.scheme": "Scheme",
  "eqa.competency.event": "Event",
  "eqa.competency.outcome": "Outcome",
  "eqa.competency.counted": "Counts against",
  "eqa.competency.countsFail": "Failure",
  "eqa.competency.countsPass": "Assessed",
  "eqa.competency.countsExcused": "Excused",
  "eqa.result.analyst": "Analyst (EQA)",
  "eqa.result.analystChoose": "Choose analyst",
  "eqa.result.analystRequired": "This EQA scheme records who ran each sample. Choose an analyst before saving.",
  "eqa.program.perAnalyst": "Record the analyst on every result",
  "eqa.program.perAnalyst.on": "Analyst recorded",
  "eqa.program.perAnalyst.off": "Not recorded",
  "eqa.result.analyst.tooltip": "Shown because this run includes an EQA sample whose scheme records who ran each sample. Choose the OpenELIS user who ran the sample, from the scheme's analyst roster — that is a separate record from whoever enters this result and whoever validates it. Non-EQA rows take no input.",
  "shipment.settings.siteOrgUnsetTitle": "Site organization not set",
  "shipment.settings.siteOrgUnsetSubtitle": "Incoming consignments are not filtered to this site and outgoing boxes carry no sender. Select the organization that represents this laboratory.",
  "shipment.settings.siteOrgUnmatchedTitle": "Set to an organization this instance does not hold",
  "shipment.settings.siteOrgUnmatchedSubtitle": "The UUID below is the one a partner addresses this laboratory by, and it matches no organization here. Filtering works; leave it unless the partner changes it.",
  "eqa.receipt.openSubmissions": "Open submissions",
  "eqa.receipt.openSubmissionsHeading": "Open submissions with undelivered panels",
  "eqa.receipt.openSubmissionsHelp": "Participants that have not received their panel stay on the roster as late. This is a recorded manual override — give the reason.",
  "eqa.receipt.openSubmissionsReason": "Reason",
  "eqa.receipt.submissionsOpened": "Submissions are open.",
  "eqa.receipt.submissionsOpenFailed": "Could not open submissions.",
  "eqa.provider.schemes.lastDistribution": "Last distribution",
  "eqa.provider.wizard.distributionDate": "Distribution date",
  "eqa.provider.wizard.submissionDeadline": "Submission deadline",
  "eqa.provider.kpi.activeSchemes": "Active schemes",
  "eqa.provider.kpi.openCycles": "Open cycles",
  "eqa.provider.kpi.enrolled": "Enrolled participants",
  "eqa.provider.kpi.followupsOpen": "Follow-ups open",
  "eqa.provider.schemes.discipline": "Discipline",
  "eqa.cycle.history.actor": "Actor",
  "eqa.cycle.history.systemActor": "System",
  "eqa.prep.reserved.recommend": "{n} recommended: max(10% of participants, 5)",
  "eqa.provider.schemes.participantOnly.title": "Participant view only",
  "eqa.provider.schemes.participantOnly.body": "Provider scheme administration needs the provider grant. Your lab's participation lives on the pages below.",
  "eqa.provider.schemes.link.myPrograms": "My enrollments — schemes this lab takes part in",
  "eqa.provider.schemes.link.myCycles": "My Cycles — panels, results and deadlines",
  "eqa.btn.newCycle": "New cycle",
  "eqa.cycle.new.heading": "New EQA cycle",
  "eqa.cycle.new.help": "For a provider that does not send consignments to this OpenELIS: record the cycle the panel belongs to so it appears here with \"Receive panel\". Consignments from an OpenELIS provider open their cycle on import.",
  "eqa.cycle.new.scheme": "Scheme (from My EQA Schemes)",
  "eqa.cycle.new.name": "Cycle name",
  "eqa.cycle.new.distributionDate": "Distribution date",
  "eqa.cycle.new.deadline": "Submission deadline",
  "eqa.cycle.new.create": "Create cycle",
  "eqa.cycle.new.created": "Cycle created. It is listed as Planned; use \"Receive panel\" when the panel arrives.",
  "eqa.cycle.new.error": "Could not create the cycle",
  "eqa.cycle.new.noPrograms": "Enroll in a scheme under My EQA Schemes first.",
  "eqa.order.receipt.consignment": "Inbound consignment",
  "eqa.order.receipt.consignment.none": "None — received outside the shipment module",
  "eqa.order.receipt.consignment.thisCycle": "this cycle",
  "eqa.order.receipt.consignment.help": "Choosing the consignment takes delivery of it and tells the provider the panel arrived.",
  "eqa.order.receipt.reference": "Shipment reference",
  "eqa.order.receipt.referenceRecorded": "Consignment {code} received.",
  "eqa.intake.enterResults": "Enter results",
  "eqa.intake.heading": "Results from {lab}",
  "eqa.intake.help": "Key the values as the participant reported them — numbers, or words such as Reactive. Saving overwrites what is on file for that test.",
  "eqa.intake.test": "Test",
  "eqa.intake.value": "Reported value",
  "eqa.intake.save": "Save results",
  "eqa.intake.saved": "Results recorded for {lab}.",
  "eqa.intake.failed": "Could not record the results",
  "eqa.intake.csv": "Or paste the participant's export bundle (CSV)",
  "eqa.intake.import": "Import CSV",
  "eqa.intake.imported": "{count, plural, one {# value imported.} other {# values imported.}}",
  "eqa.intake.noTests": "This scheme has no tests assigned yet.",
  "eqa.cycle.importScores": "Import scores (CSV)",
  "eqa.cycle.importScores.heading": "Import the provider's scores",
  "eqa.cycle.importScores.help": "Paste the scores CSV the provider sent (analyte_name and performance_status columns). Scores from a provider OpenELIS arrive on their own through the FHIR store.",
  "eqa.cycle.importScores.csv": "Scores CSV",
  "eqa.cycle.importScores.import": "Import scores",
  "eqa.cycle.importScores.imported": "{count} scores recorded.",
  "eqa.cycle.importScores.unmapped": "Not recognised here: {names}",
  "eqa.cycle.importScores.failed": "Could not import the scores",
  "eqa.program.schemeType": "Scheme type",
  "eqa.program.schemeType.helper": "In-house schemes are run by this laboratory and need no provider; every other type does.",
  "eqa.order.receipt.notes.required": "Say what was wrong with the material. A receipt marked not intact needs the note that explains it.",
  "eqa.provider.wizard.cycleName.required": "A cycle needs a name.",
  "eqa.provider.wizard.dates.required": "A cycle needs both a distribution date and a submission deadline; the deadline is what its reminders are sent against.",
  "eqa.enrollment.scheme": "Scheme",
  "eqa.enrollment.scheme.helper": "Pick a scheme this instance carries, or choose Not listed and type the name.",
  "eqa.enrollment.scheme.frozen": "This enrollment has cycles against it, so its scheme and provider cannot be changed.",
  "eqa.enrollment.scheme.other": "Not listed - type the name",
  "eqa.action.forbidden": "This action needs the {grant} permission, which your account does not have. Ask an administrator for it.",
  "eqa.receipt.readOnly.title": "Read-only view of receipts and scores",
  "eqa.receipt.readOnly.body": "Recording a delivery, dispatching a repeat, entering results and returning scores all need the provider grant; scoring the cycle needs the manage grant. The table below is the whole cycle either way.",
  "eqa.inhouse.readOnly.title": "Read-only view of in-house panels",
  "eqa.inhouse.readOnly.body": "Designing and sealing a blinded panel needs the manage grant. The panels below are the whole picture either way.",
  "eqa.score.downloadReport": "Report PDF",
  "eqa.labperf.exportCsv": "Export CSV",
  "eqa.labperf.kpi.submitted": "Submitted cycles",
  "eqa.labperf.acceptableOf": "Acceptable of scored",
  "eqa.labperf.kpi.lateCount": "Late submissions",
  "eqa.labperf.kpi.nceOpenCount": "Of those, still open",
  "eqa.queue.source.all": "Every source",
  "eqa.queue.countFiltered": "Queue · {count} of {total, plural, one {# item} other {# items}}",
  "eqa.queue.emptyForSource": "Nothing from this source is awaiting triage. The queue holds {total, plural, one {# item} other {# items}} from other sources.",
  "eqa.program.requiresCycleReview": "Hold each cycle for review before submitting",
  "eqa.program.requiresCycleReview.off": "Submit automatically",
  "eqa.program.requiresCycleReview.on": "Hold for review",
  "eqa.cycle.submitManual": "Submit by hand",
  "eqa.cycle.submitManual.heading": "Record a submission made by hand",
  "eqa.cycle.submitManual.help": "Use this once the results have reached the provider some other way. The reference they gave you is what makes this a record rather than a claim, so it is required.",
  "eqa.cycle.submitManual.reference": "Provider's reference",
  "eqa.cycle.submitManual.success": "Recorded as submitted by hand, with the provider's reference.",
  "eqa.cycle.retriesSpent.title": "Automatic submission has stopped for this cycle.",
  "eqa.cycle.retriesSpent.body": "It failed {attempts} times and will not be retried. Send the results to the provider yourself - the export bundle is on the scheme's page - and record their reference here.",
  "eqa.provider.wizard.sampleCode.duplicate": "Every sample code on a panel must be different.",
  "eqa.provider.wizard.rangeHigh.backwards": "The high end of an acceptance range cannot be below the low end.",
  "eqa.shipment.packList.panelColumn": "Panel",
  "eqa.provider.schemes.performance": "Performance",
  "eqa.performance.title": "Participant performance",
  "eqa.performance.subtitle": "Each laboratory’s pass rate over its last four scored cycles in this scheme. Expand a row for the cycles behind the rate.",
  "eqa.performance.laboratory": "Laboratory",
  "eqa.performance.region": "Region",
  "eqa.performance.enrollment": "Enrollment",
  "eqa.performance.passRate": "Pass rate (last 4)",
  "eqa.performance.mostRecent": "Most recent",
  "eqa.performance.openFollowups": "Open follow-ups",
  "eqa.performance.expand": "Cycle history",
  "eqa.performance.ofJudged": "{accepted} of {judged}",
  "eqa.performance.noRate": "No scored cycle yet",
  "eqa.performance.noCycles": "This laboratory has not reported into a scored cycle yet.",
  "eqa.performance.empty": "No laboratory is enrolled in this scheme yet.",
  "eqa.performance.loadFailed": "Could not load participant performance",
  "eqa.myPrograms.group.active": "Active enrolments ({count})",
  "eqa.order.coverage.title": "Outside this laboratory's enrolment",
  "eqa.order.coverage.subtitle": "The enrolment for this scheme does not cover: {tests}. You can still save the order.",
  "eqa.myPrograms.group.suspended": "Suspended enrolments ({count})",
  "eqa.myPrograms.group.withdrawn": "Withdrawn enrolments ({count})",
  "eqa.enrollment.resume": "Resume",
  "eqa.enrollment.statusReason": "Reason",
  "eqa.enrollment.statusReasonPlaceholder": "Why is this enrolment changing status?",
  "eqa.enrollment.statusEffectiveDate": "Effective from",
  "eqa.enrollment.withdrawIsFinal": "Withdrawing is final. To take part again, this laboratory enrols in the scheme afresh.",
  "eqa.enrollment.statusChanged": "This enrolment is now {status}",
  "eqa.enrollment.statusChangeFailed": "Could not change this enrolment's status",
  "eqa.enrollment.panels.help": "Standard test bundles from the catalogue. This is what your laboratory reports on, not the EQA material a provider ships you.",
  "eqa.myPrograms.panels.help": "Test panels from the catalogue that this enrolment covers.",
  "eqa.score.scoredWithUnjudged": "Cycle scored, but {count} result(s) got no verdict, on {tests}. Those analytes carry no sealed target and the cycle has too few peers to place them against.",
  "eqa.cycle.close": "Close cycle",
  "eqa.cycle.closeHeading": "Close this cycle",
  "eqa.cycle.closeHelp": "A closed cycle is final: participants see it as closed and no further verdicts are recorded against it. Closing is refused while a follow-up is open or a missed-deadline result is still waiting on an answer.",
  "eqa.cycle.closeFailed": "Could not close this cycle",
  "eqa.prep.ofTotal": "{n} of {total}",
  "eqa.prep.tile.participants": "Enrolled laboratories selected for this cycle",
  "eqa.prep.tile.panels": "Material panels prepared",
  "eqa.prep.dispatched": "Participant shipments dispatched",
  "eqa.prep.readyToShip.blockedByGate": "Prep is incomplete. The ready-to-ship gate above lists what is still outstanding.",
  "eqa.prep.readyToShip.notInPrep": "Cycle state: {status}. Clearing to ship is only offered while the cycle is in prep.",
  "eqa.prep.goToShipments": "Open the Shipments tab",
  "eqa.competency.rule.meetsEvidence": "Evidence met",
  "eqa.competency.rule.repeatedFailure": "Repeated failure",
  "eqa.competency.rule.insufficientEvidence": "Insufficient evidence",
  "eqa.competency.rule.openEscalation": "Open non-conformity",
  "eqa.competency.reason.meetsEvidence": "{evaluable} assessable samples with {failures} failures between {from} and {to}, at or above the evidence floor of {floor}. Nothing to action.",
  "eqa.competency.reason.repeatedFailure": "{failures} failures in {evaluable} assessable samples between {from} and {to}. This is a performance concern: review the failed results and raise a non-conformity, or dismiss them on triage.",
  "eqa.competency.reason.insufficientEvidence": "{evaluable} assessable samples between {from} and {to}, short of the evidence floor of {floor}. This is not a performance concern: assign this analyst more proficiency testing samples.",
  "eqa.competency.reason.openEscalation": "An escalated non-conformity raised between {from} and {to} is still open, over {evaluable} assessable samples with {failures} failures. Close the non-conformity to clear the band.",
  "eqa.competency.whatIsAnAnalyst": "An analyst is an OpenELIS user account on the scheme's analyst roster, recorded against the sample they ran. That is a separate record from whoever entered the result and whoever validated it.",
  "eqa.inhouse.roster.help": "Analysts are OpenELIS user accounts. Everyone selected here joins this scheme's roster and can be assigned samples to run; the roster is separate from who enters and who validates a result.",
  "banner.menu.eqa.providerFollowups": "Participant Follow-Up",
  "eqa.oversight.queueSubtitle.link": "Participant follow-up",
  "eqa.inhouse.sealed.deadline": "Unblind date, and the deadline for the analysts to submit: {date}",
  "eqa.inhouse.sealed.analysts": "Assigned analysts: {names}",
  "eqa.inhouse.sealed.noAnalysts": "No analyst is assigned to any sample on this panel.",
  "eqa.inhouse.sealed.toMyCycles": "Open My Cycles",
  "eqa.inhouse.sealed.toWorkplan": "Open the Workplan",
  "analyzerType.editor.heading": "Profile settings",
  "analyzerType.editor.choose": "Choose…",
  "analyzerType.editor.version": "Profile version",
  "analyzerType.editor.confidence": "Evidence confidence",
  "analyzerType.editor.category": "Laboratory discipline",
  "analyzerType.editor.inboundResults": "Receives analyzer results",
  "analyzerType.editor.outboundOrders": "Sends orders to the analyzer",
  "analyzerType.editor.connectionTest": "Supports a connection test",
  "analyzerType.editor.fileHeading": "File parsing",
  "analyzerType.editor.fileFormat": "Profile file format",
  "analyzerType.editor.defaultFileFormat": "Default file format",
  "analyzerType.editor.filePattern": "Filename pattern",
  "analyzerType.editor.hasHeader": "First row contains column names",
  "analyzerType.editor.delimiter": "Column delimiter",
  "analyzerType.editor.encoding": "Text encoding",
  "analyzerType.editor.sheetIndex": "Sheet number (starting at zero)",
  "analyzerType.editor.skipRows": "Rows to skip",
  "analyzerType.editor.extensions": "Supported file extensions",
  "analyzerType.editor.columns": "File columns",
  "analyzerType.editor.columnsHelp": "Match the column names in the exported file to the result fields below. Preserve spelling and punctuation.",
  "analyzerType.editor.columnNumber": "File column {number}",
  "analyzerType.editor.columnName": "Column name in the file",
  "analyzerType.editor.columnField": "Meaning of the column",
  "analyzerType.editor.removeColumn": "Remove column",
  "analyzerType.editor.columnsInvalid": "Each column needs a unique name and a selected meaning.",
  "analyzerType.editor.addColumn": "Add column",
  "analyzerType.editor.resultOrder": "Result value preference (first available value wins)",
  "analyzerType.editor.communicationHeading": "Communication defaults",
  "analyzerType.editor.analyzerName": "Instrument name in messages",
  "analyzerType.editor.identifierPattern": "Analyzer identifier pattern",
  "analyzerType.editor.protocolVersion": "Protocol version",
  "analyzerType.editor.lowerLayerVersion": "ASTM framing version",
  "analyzerType.editor.msh3Pattern": "Sending application pattern",
  "analyzerType.editor.communicationMode": "Who starts communication",
  "analyzerType.editor.lisInitiated": "Allows the laboratory system to start communication",
  "analyzerType.editor.connectionRole": "Default connection role",
  "analyzerType.editor.transport": "Default transport",
  "analyzerType.editor.port": "Default outbound port (optional)",
  "analyzerType.editor.aggregationMode": "Result grouping",
  "analyzerType.editor.aggregationWindowSeconds": "Result grouping window in seconds",
  "analyzerType.editor.connectionFields": "Fields shown when setting up a connection",
  "analyzerType.editor.connectionFieldsHelp": "These fields describe the settings a lab supplies for each connection. A FILE connection needs a directory field for its watched folder on Bridge. Labels use the application’s translation keys. Choices preserve their value types; visibility conditions refer to another setting.",
  "analyzerType.editor.connectionFieldNumber": "Connection field {number}",
  "analyzerType.editor.fieldKey": "Setting name",
  "analyzerType.editor.fieldLabel": "Label translation key",
  "analyzerType.editor.inputKind": "Input type",
  "analyzerType.editor.required": "Required during connection setup",
  "analyzerType.editor.addField": "Add connection field",
  "analyzerType.editor.removeField": "Remove connection field",
  "analyzerType.editor.save": "Save and validate profile settings",
  "analyzerType.editor.saved": "Profile settings saved",
  "analyzerType.editor.saveBeforeRecognition": "Save profile settings before editing control recognition or publishing.",
  "analyzerType.editor.loadError": "Could not reload the draft. Your unsaved edits are still here.",
  "analyzerType.editor.saveError": "Could not save the draft. Your edits are still here; try saving again.",
  "analyzerType.editor.conflict": "The draft changed since it was opened. Your edits have not been sent. Reload the saved draft before making further changes.",
  "analyzerType.editor.error": "Profile could not be saved",
  "analyzerType.editor.reload": "Reload saved draft and discard local edits",
  "analyzerType.editor.validation": "Profile needs attention",
  "analyzerType.editor.add": "Add value",
  "analyzerType.editor.remove": "Remove value",
  "analyzerType.editor.semantic.sampleId": "Specimen identifier",
  "analyzerType.editor.semantic.testCode": "Analyzer test code",
  "analyzerType.editor.semantic.qcTask": "Control task",
  "analyzerType.editor.semantic.ctValue": "Cycle threshold",
  "analyzerType.editor.inputKind.TEXT": "Text",
  "analyzerType.editor.inputKind.NUMBER": "Number",
  "analyzerType.editor.inputKind.SELECT": "Choice list",
  "analyzerType.editor.inputKind.BOOLEAN": "Yes or no",
  "analyzerType.editor.inputKind.SECRET": "Secret",
  "analyzerType.editor.inputKind.FILE_PATH": "Folder or file path",
  "analyzerType.editor.testDefinitions": "Analyzer test definitions",
  "analyzerType.editor.testDefinitionsHelp": "List the test codes and result values reported by the instrument. These definitions supply suggestions for matching to the laboratory catalog; they do not create or change laboratory tests.",
  "analyzerType.editor.testNumber": "Analyzer test {number}",
  "analyzerType.editor.testCode": "Analyzer test code",
  "analyzerType.editor.testName": "Suggested test name",
  "analyzerType.editor.loinc": "LOINC code",
  "analyzerType.editor.testUnit": "Reported units",
  "analyzerType.editor.resultType": "Reported value type",
  "analyzerType.editor.resultType.quantitative": "Numeric measurement",
  "analyzerType.editor.resultType.qualitative": "Named result",
  "analyzerType.editor.resultType.text": "Free text result",
  "analyzerType.editor.testAliases": "Other codes for this same test",
  "analyzerType.editor.testValues": "Result values reported by this test",
  "analyzerType.editor.removeTest": "Remove analyzer test",
  "analyzerType.editor.addTest": "Add analyzer test",
  "analyzerType.editor.choices": "Connection choices",
  "analyzerType.editor.choiceNumber": "Choice {number}",
  "analyzerType.editor.choiceValue": "Choice value",
  "analyzerType.editor.addChoice": "Add choice",
  "analyzerType.editor.removeChoice": "Remove choice",
  "analyzerType.editor.visibility": "Show this connection field when",
  "analyzerType.editor.controllingField": "Controlling setting",
  "analyzerType.editor.comparison": "Comparison",
  "analyzerType.editor.comparisonValue": "Comparison value",
  "analyzerType.editor.comparison.EQUALS": "Equals",
  "analyzerType.editor.comparison.NOT_EQUALS": "Does not equal",
  "analyzerType.editor.comparison.IN": "Is one of",
  "analyzerType.editor.comparison.NOT_IN": "Is not one of",
  "analyzerType.editor.addCondition": "Add visibility condition",
  "analyzerType.editor.removeCondition": "Remove visibility condition",
  "analyzerType.editor.valueType": "Value type",
  "analyzerType.editor.valueType.string": "Text value",
  "analyzerType.editor.valueType.boolean": "Boolean value",
  "analyzerType.editor.valueType.array": "List value",
  "analyzerType.editor.valueType.object": "Object value",
  "analyzerType.editor.valueType.null": "Null value",
  "analyzerType.editor.nullValue": "This choice has a null value.",
  "analyzerType.editor.invalidTypedValue": "Enter a valid value of the selected type.",
  "analyzerType.editor.structuredValueHelp": "Enter a JSON list or object matching the selected type. Use a list for “is one of” comparisons.",
  "analyzerType.editor.newProtocolHelp": "Choose FILE, ASTM, or HL7 and enter the settings supported by the instrument. The protocol is fixed after the first save.",
  "analyzerType.editor.switchProtocol": "Switch protocol and clear its settings",
  "analyzerType.editor.switchProtocolHelp": "Switch to {protocol}? This clears unsaved communication, parsing, connection-field, and control-recognition settings. Profile identity, test definitions, and descriptive information are retained.",
  "analyzerType.editor.keepProtocol": "Keep the current protocol",
  "analyzerType.editor.supportedTransports": "Supported transports",
  "analyzerType.editor.supportTransport": "Support {transport}",
  "analyzerType.editor.transportSettings": "{transport} settings",
  "analyzerType.editor.transportPortHelp": "Optional outbound destination port for this transport. Leave blank to use the Bridge fallback; incoming messages use the shared listener.",
  "analyzerType.editor.serialSettings": "Serial communication settings",
  "analyzerType.editor.readTimeout": "Serial read timeout (milliseconds)",
  "analyzerType.editor.messageTimeout": "Serial message timeout (milliseconds)",
  "analyzerType.editor.reconnectInterval": "Serial reconnect interval (milliseconds)",
  "analyzerType.editor.maxReconnectAttempts": "Maximum serial reconnect attempts",
  "analyzerType.editor.rtsEnabled": "Enable RTS",
  "analyzerType.editor.dtrEnabled": "Enable DTR",
  "analyzerType.editor.resultRecords": "Result records to parse",
  "analyzerType.editor.resultRecords.ALL": "All result records",
  "analyzerType.editor.resultRecords.FIELD_NON_BLANK": "Records with a populated field",
  "analyzerType.editor.resultRecordField": "Required ASTM field (record.field.component)",
  "analyzerType.editor.specimenPosition": "HL7 specimen position relative to results",
  "analyzerType.editor.dataFlow": "Default direction of data transfer",
  "analyzerType.editor.outboundPortMode": "Default outbound port selection",
  "analyzerType.editor.clientProfilePort": "Client connection port stored in this profile (optional)",
  "eqa.intake.sample": "Sample {code}",
  "eqa.competency.countsFoldedTriage": "Decided by triage",
  "eqa.competency.countsFoldedScore": "Counted with the score",
  "eqa.provider.followups.responseText": "What the laboratory said",
  "eqa.provider.followups.responseHelp": "The root cause the laboratory found and the corrective action it took. Kept with the follow-up.",
  "eqa.provider.followups.responseShown": "Laboratory's response: {text}",
  "notification.organization.post.error": "The organization was not saved. Check the fields and try again.",
  "organization.email": "Contact Email",
  "eqa.provider.followups.sendFailed": "Could not email {to}. The notification was downloaded as CSV to send by hand.",
  "label.validation.review.error.qcHold": "Release blocked: a failed QC control holds this result until its non-conformity is closed.",
  "sidenav.label.admin.locations": "Locations & Organizations",
  "sidenav.label.admin.locations.organizations": "Organizations",
  "sidenav.label.admin.locations.sites": "Sampling Sites",
  "sidenav.label.admin.locations.areas": "Geographic Areas",
  "sidenav.label.admin.locations.import": "Import / Export",
  "help.locations.page.organizations": "Organizations are the health facilities and laboratories your lab works with: the hospitals, clinics and health centres that send you patient samples, and the laboratories you refer samples to. Wards and departments inside an organization are listed under it. Organizations appear in order entry as the requesting site and in referrals as the destination lab.",
  "help.locations.page.sites": "Sampling sites are fixed places in the environment where samples are collected that do not come from a patient: a water source, a mosquito trap, an air monitor, a soil plot. A site does not order tests. It records where a sample was taken, so results can be compared over time at the same spot. Each site sits in a geographic area and can have its own GPS point and contact person.",
  "help.locations.page.areas": "Geographic areas are the administrative divisions of the country, for example Region, Province, District and LLG. They are used for patient addresses and to say where each organization and sampling site is. Most deployments load them once from the national list, then add or correct areas here. To add an area inside another one, use the + button on the parent row: \"+ District\" on Morobe Province adds a district in Morobe. Use \"+ Add Region\" at the top for a new top-level area.",
  "help.locations.page.import": "Load or update organizations, wards / depts, sampling sites and geographic areas from CSV files, in the same format the system uses at installation. Nothing is saved until you review the preview and apply it.",
  "label.locations.page.compare": "Organization or sampling site: which do I need?",
  "label.locations.page.compare.orgTitle": "Add an organization when...",
  "label.locations.page.compare.siteTitle": "Add a sampling site when...",
  "label.locations.page.compare.orgExamples": "Examples: Port Moresby General Hospital, 9 Mile Urban Clinic, Central Public Health Laboratory",
  "label.locations.page.compare.siteExamples": "Examples: Bumbu Settlement light trap, Laloki River intake, Waigani air monitor",
  "help.locations.page.compare.org": "Add an organization when samples come from people seen there, when it orders tests or receives reports or referred samples, or when it has wards or departments that request tests.",
  "help.locations.page.compare.site": "Add a sampling site when samples come from the environment (water, soil, air or insects), when you collect at the same fixed spot again and again, or when you want results for that spot over time, on a map.",
  "help.locations.page.compare.tip": "A water tank at a hospital is still a sampling site: the hospital is an organization, and the tank is a site placed in the same area.",
  "label.locations.kind.facility": "Facility",
  "label.locations.kind.ward": "Ward / Dept",
  "label.locations.kind.wards": "wards / depts",
  "label.locations.kind.site": "Sampling site",
  "label.locations.kind.area": "Geographic area",
  "label.locations.kind.records": "records",
  "label.locations.column.name": "Name",
  "label.locations.column.code": "Code",
  "label.locations.column.type": "Type",
  "label.locations.column.wards": "Wards / Depts",
  "label.locations.column.location": "Location",
  "label.locations.column.inUse": "In use",
  "label.locations.column.level": "Level",
  "label.locations.column.children": "Child areas",
  "label.locations.column.siteType": "Site type",
  "label.locations.column.active": "Active",
  "label.locations.column.actions": "Actions",
  "label.locations.column.serviceType": "Service type",
  "label.locations.column.contact": "Contact name",
  "label.locations.column.phone": "Phone",
  "label.locations.column.email": "Email",
  "label.locations.column.gps": "GPS",
  "label.locations.open": "open",
  "label.locations.openOrders": "open orders",
  "label.locations.none": "none",
  "label.locations.empty": "(empty)",
  "label.locations.location.notSet": "not set",
  "label.locations.status.active": "Active",
  "label.locations.status.inactive": "Inactive",
  "label.locations.status.all": "All",
  "label.locations.source.registry": "Registry",
  "help.locations.registry": "Comes from the facility registry. The registry is the source of truth for this record.",
  "label.locations.filter.type": "Type",
  "label.locations.filter.type.all": "All types",
  "label.locations.filter.location": "Location (includes areas beneath)",
  "label.locations.filter.location.any": "Any area",
  "label.locations.filter.status": "Status",
  "label.locations.filter.clear": "Clear filters",
  "label.locations.filter.reviewOverdue": "Referral labs overdue for review or with expired accreditation only",
  "label.locations.filter.category.all": "All categories",
  "label.locations.filter.ownership.all": "All ownership",
  "label.locations.toolbar": "Filters",
  "placeholder.locations.search": "Search by name, code or any identifier",
  "placeholder.locations.area.search": "Search areas by name or code",
  "help.locations.status.inactive": "Inactive records are hidden from order entry and other pickers. They still appear on existing orders and reports.",
  "help.locations.field.location": "Pick the most specific area you know. A district is fine if you don't know the LLG.",
  "help.locations.field.gps": "Decimal degrees, WGS84",
  "help.locations.field.siteDescription": "Include directions so someone else can find the exact spot",
  "help.locations.identifiers": "Type any label, or pick one already used. The reporting code shows as Code in lists, exports and reports. Every identifier is searchable and used to match import rows.",
  "help.locations.ward": "Wards, departments or clinics inside this organization",
  "help.locations.ward.gps": "Leave GPS blank to use {parent}'s location. Address is always {parent}'s.",
  "label.locations.ward.inheritedGps": "{lat}, {lng} inherited from {parent}",
  "label.locations.inherited": "inherited",
  "label.locations.inherits": "inherits",
  "label.locations.draft": "Draft",
  "label.locations.ward.namePlaceholder": "Ward / dept name",
  "label.locations.optional": "Optional",
  "warning.locations.registry.edit": "This record comes from the facility registry. Changes to fields the registry supplies will be overwritten on the next sync. To change them for good, update the registry. Wards / depts and other local details you add here are kept.",
  "warning.locations.registry.deactivate": "This record comes from the facility registry. The next sync may reactivate it; to close it for good, update the registry.",
  "label.locations.registry.field": "From registry",
  "button.locations.add": "Add",
  "button.locations.import": "Import",
  "button.locations.export": "Export",
  "button.locations.deactivate": "Deactivate",
  "button.locations.reactivate": "Reactivate",
  "button.locations.exportSelected": "Export selected",
  "button.locations.addWard": "Add ward / dept",
  "button.locations.saveWards": "Save {count} new ward / dept",
  "button.locations.moveWard": "Move",
  "button.locations.history": "History",
  "button.locations.history.hide": "Hide history",
  "button.locations.identifier.add": "Add identifier",
  "button.locations.area.addChildLevel": "+ {level}",
  "button.locations.area.addTop": "Add {level}",
  "button.locations.area.expandAll": "Expand all",
  "button.locations.area.collapseAll": "Collapse all",
  "button.locations.undo": "Undo",
  "button.locations.template": "Download template",
  "button.locations.import.preview": "Preview",
  "button.locations.import.apply": "Apply",
  "button.locations.import.report": "Download result report",
  "label.locations.selectAll": "Select all rows",
  "label.locations.select": "Select",
  "label.locations.section.identity": "Identity",
  "label.locations.section.identifiers": "Identifiers",
  "label.locations.section.location": "Location",
  "label.locations.section.contact": "Contact",
  "label.locations.section.referral": "Referral laboratory",
  "label.locations.section.site": "Site details",
  "label.locations.section.wards": "Wards / Depts",
  "label.locations.form.jump": "Jump to",
  "label.locations.field.types": "Organization type(s)",
  "label.locations.field.shortName": "Short name",
  "label.locations.field.category": "Category",
  "label.locations.field.ownership": "Ownership",
  "label.locations.field.description": "Description",
  "label.locations.field.location": "Location",
  "label.locations.field.parentArea": "Parent area",
  "label.locations.field.streetAddress": "Street address",
  "label.locations.field.city": "City",
  "label.locations.field.state": "State / Province",
  "label.locations.field.zipCode": "Postal code",
  "label.locations.field.gpsLatitude": "GPS latitude",
  "label.locations.field.gpsLongitude": "GPS longitude",
  "label.locations.field.contactName": "Contact name",
  "label.locations.field.phone": "Phone",
  "label.locations.field.email": "Email",
  "label.locations.field.website": "Website",
  "label.locations.field.serviceType": "Service type",
  "label.locations.field.siteType": "Site type",
  "label.locations.field.subtype": "Subtype",
  "label.locations.field.zone": "Environmental zone",
  "label.locations.identifier.label": "Label",
  "label.locations.identifier.value": "Value",
  "label.locations.identifier.reporting": "Reporting code",
  "label.locations.identifier.labelPlaceholder": "e.g. DHIS2 ID",
  "label.locations.referral.approval": "Approval status",
  "label.locations.referral.approved": "Approved",
  "label.locations.referral.evaluation": "Under evaluation",
  "label.locations.referral.suspended": "Suspended",
  "label.locations.referral.notApproved": "Not approved",
  "label.locations.referral.accreditationBody": "Accreditation body",
  "label.locations.referral.accreditationNumber": "Accreditation number",
  "label.locations.referral.accreditationExpiry": "Accreditation expiry",
  "label.locations.referral.lastReview": "Last review date",
  "label.locations.referral.nextReview": "Next review due",
  "label.locations.referral.notes": "Review notes",
  "label.locations.referral.overdue": "Review overdue",
  "label.locations.referral.expired": "Accreditation expired",
  "message.locations.referral.overdueSince": "Review overdue since {date}. Record the review below, or change the approval status.",
  "label.locations.history.title": "History of {name}",
  "label.locations.history.filter": "Filter by action",
  "label.locations.history.allChanges": "All changes",
  "help.locations.history.readOnly": "Read-only. Kept for as long as the record exists.",
  "label.locations.history.formerly": "Formerly {name}",
  "label.locations.history.action.created": "Created",
  "label.locations.history.action.edited": "Edited",
  "label.locations.history.action.deactivated": "Deactivated",
  "label.locations.history.action.reactivated": "Reactivated",
  "label.locations.history.action.moved": "Moved",
  "label.locations.history.action.identifiers": "Identifiers changed",
  "label.locations.history.action.referralReview": "Referral review",
  "label.locations.history.action.imported": "Imported",
  "label.locations.history.action.registrySync": "Updated from registry",
  "label.locations.search.ward": "Ward / dept: {name}",
  "error.locations.name.required": "Name is required",
  "error.locations.types.required": "Choose at least one organization type",
  "error.locations.gps.range": "Enter decimal degrees: latitude -90 to 90, longitude -180 to 180",
  "error.locations.parent.kind": "A ward's parent must be a facility",
  "error.locations.parent.required": "Choose the parent area",
  "error.locations.referral.status": "Choose an approval status",
  "error.locations.identifier.duplicate": "{label} {value} is already used by {name}",
  "error.locations.reactivate.parentInactive": "Reactivate {parent} first.",
  "error.locations.save.conflict": "Another admin saved this record first. Their values are shown below; reapply your changes and save again.",
  "error.locations.save.failed": "The record was not saved.",
  "error.locations.request.failed": "The request could not be completed, so nothing was saved. Try again, and if it keeps failing tell your administrator.",
  "error.locations.save.check": "Not saved yet. Check: {fields}.",
  "error.locations.save.failedBecause": "The record was not saved: {reason}",
  "error.locations.save.conflictKept": "Another admin saved this record first. Your changes are kept, and their changes are filled in where you had not typed ({fields}). Check the form and save again.",
  "warning.locations.wards.unsaved": "{count, plural, one {# ward / dept is} other {# wards / depts are}} typed but not saved yet. Save them with Save wards, or remove them, then save the record.",
  "error.locations.ward.notSaved": "{name} was not saved: {reason}",
  "message.locations.wards.saved": "{count, plural, one {# ward / dept saved.} other {# wards / depts saved.}}",
  "warning.locations.import.ignoredColumns": "These columns are not imported and were ignored: {columns}",
  "label.locations.import.run.applied": "Applied",
  "label.locations.import.run.preview": "Preview",
  "warning.locations.identifiers.shared": "Some identifiers are used by more than one record. Give each record its own value.",
  "error.locations.load.failed": "The list could not be loaded. Try again.",
  "warning.locations.name.duplicate": "Another active {kind} named \"{name}\" exists",
  "message.locations.empty.none": "No records yet. Add one, or import a file.",
  "message.locations.empty.filtered": "No records match these filters.",
  "message.locations.search.elsewhere": "In {view}: {count, plural, one {# match} other {# matches}}",
  "message.locations.saved": "{name} saved.",
  "message.locations.added": "{name} added.",
  "message.locations.deactivated": "{name} deactivated.",
  "message.locations.reactivated": "{name} reactivated.",
  "message.locations.undo.deactivated": "{name} deactivated.",
  "message.locations.deactivate.inUse": "{name} has {open} open orders and {children} active {childKind}.",
  "message.locations.deactivate.confirm": "Deactivate {name}?",
  "button.locations.deactivate.record": "Deactivate {name}",
  "button.locations.deactivate.only": "Deactivate {name} only",
  "button.locations.deactivate.withChildren": "Deactivate {name} and its {count} {childKind}",
  "message.locations.area.inUse": "{name} still has active areas, organizations or sites inside it. Deactivate or move those first.",
  "message.locations.area.searchContext": "{count, plural, one {# match} other {# matches}}, shown with the areas they sit in",
  "message.locations.area.loadOnExpand": "Children load when a row is expanded.",
  "label.locations.area.new": "New",
  "label.locations.area.topLevel": "top level",
  "message.locations.unsaved": "You have unsaved changes. Leave without saving?",
  "label.locations.import.mode": "Import mode",
  "label.locations.import.mode.merge": "Add & update",
  "help.locations.import.mode.merge": "Add new records and update matching ones. Nothing else changes.",
  "label.locations.import.mode.replace": "Replace",
  "help.locations.import.mode.replace": "Also deactivate records of the types in this file that the file does not include. Nothing is deleted.",
  "label.locations.import.files": "Files",
  "label.locations.import.drop": "Drag CSV files here or click to browse (organizations-*.csv, *-levels.csv, *-values.csv)",
  "label.locations.import.area": "Area",
  "label.locations.import.area.organizations": "Facilities, wards & sites",
  "label.locations.import.area.levels": "Geographic levels",
  "label.locations.import.area.values": "Geographic areas",
  "label.locations.import.forThisFile": "For this file:",
  "label.locations.import.replaceScope": "This file has {types} rows. {untouched} will not change. Wards / depts will only be replaced at {parents}. Registry records are never deactivated.",
  "label.locations.import.rename.title": "Possible renames",
  "label.locations.import.rename.same": "Same place, renamed",
  "label.locations.import.rename.different": "Different places",
  "warning.locations.import.registryOverwrite": "Will be overwritten by the next registry sync",
  "warning.locations.import.wardAddressIgnored": "Line {line}: address is ignored for wards / depts, which use their organization's address",
  "label.locations.import.outcome.new": "New",
  "label.locations.import.outcome.updated": "Updated",
  "label.locations.import.outcome.unchanged": "Unchanged",
  "label.locations.import.outcome.reactivated": "Reactivated",
  "label.locations.import.outcome.deactivated": "Deactivated",
  "label.locations.import.outcome.decision": "Needs decision",
  "label.locations.import.outcome.rename": "Possible rename",
  "label.locations.import.outcome.rejected": "Rejected",
  "label.locations.import.decision.use": "Use this record",
  "label.locations.import.decision.new": "Create new",
  "label.locations.import.decision.skip": "Skip row",
  "label.locations.import.decision.remember": "Remember this name",
  "label.locations.import.willDeactivate": "Will be deactivated",
  "label.locations.import.rows": "Rows",
  "label.locations.import.column.line": "Line",
  "label.locations.import.column.outcome": "Outcome",
  "label.locations.import.column.type": "Type",
  "label.locations.import.column.code": "Code",
  "label.locations.import.column.name": "Name",
  "label.locations.import.column.detail": "Detail",
  "message.locations.import.nothingSaved": "Nothing has been saved.",
  "label.locations.import.confirm.title": "Apply this import?",
  "label.locations.import.confirm.replace": "I understand {count} records will be deactivated",
  "label.locations.import.complete": "Import complete",
  "label.locations.import.recent": "Recent imports",
  "message.locations.export.done": "Exported {count} records in the import format.",
  "label.locations.import.working": "Reading the file and matching every row. Large files take a moment.",
  "message.locations.import.failed": "The import could not be read: {reason}",
  "eqa.wizard.noSchemeTests": "This scheme has no tests a panel can use.",
  "eqa.performance.titleForScheme": "Participant performance: {scheme}",
  "eqa.cycle.trigger.first_shipment_sent": "First shipment sent",
  "eqa.cycle.trigger.all_shipments_delivered": "All shipments delivered",
  "eqa.cycle.trigger.score_intake": "Scores recorded",
  "eqa.cycle.trigger.panel_receipt": "Panel received",
  "eqa.cycle.trigger.last_validated_result": "Last result validated",
  "eqa.cycle.trigger.fhir_submit_success": "Results submitted to the provider",
  "eqa.cycle.trigger.panel_unblind": "Panel unblinded",
  "eqa.cycle.trigger.v1_backfill": "Carried over from an earlier distribution",
  "sampleAcceptance.banner.resampledFrom.accession": "This is a replacement created by a resample of sample {accession}.",
  "label.results.sampleStatus.markUsedUpConfirm.title": "Mark this sample used up?",
  "label.results.sampleStatus.markUsedUpConfirm.body": "Its remaining volume is set to zero. The sample stays in storage until it is disposed.",
  "alerts.acknowledge.note": "Acknowledgment Comment",
  "alerts.acknowledge.note.required": "A comment is required to acknowledge a critical alert",
  "alerts.resolve.button": "Resolve",
  "alerts.resolve.title": "Resolve Alert",
  "alerts.resolve.comment.required": "A resolution comment is required",
  "alerts.resolve.error": "Failed to resolve alert",
  "configuration.panel.manage": "Manage Panels",
  "sidenav.label.admin.testmgt.ViewtestCatalog": "View Test Catalog",
  "compliance.parameterGroup.deleted": "Parameter group deleted.",
  "compliance.parameterGroup.updated": "Parameter group updated.",
  "compliance.parameterGroup.deleteError": "Could not delete parameter group.",
  "compliance.validation.fillRequired": "Please fill in all required fields.",
  "compliance.parameterGroup.moveError": "Could not reorder parameter group.",
  "compliance.parameterGroup.moved": "Parameter group reordered.",
  "compliance.parameterGroup.created": "Parameter group added.",
  "compliance.testEditor.thresholdsDone": "Compliance thresholds updated for this test.",
  "compliance.testEditor.meta.loinc": "LOINC:",
  "compliance.testEditor.meta.resultType.select": "Select List",
  "compliance.testEditor.meta.resultType": "Result Type:",
  "compliance.testEditor.editHeader": "Edit Test:",
  "compliance.testEditor.meta.sampleType": "Sample Type:",
  "compliance.testThresholds.comboboxPlaceholder": "Search by name, code, or LOINC…",
  "label.button.done": "Done",
  "compliance.testEditor.meta.resultType.numeric": "Numeric",
  "compliance.multiLimit.advisoryNote.placeholder": "e.g., Requires re-sampling within 24h",
  "compliance.multiLimit.advisoryNote": "Advisory Note",
  "compliance.inlineEdit.editingMapping": "editing compliance mapping",
  "label.loading.message": "Loading…",
  "compliance.linkedTest.unlinked": "Test removed from the parameter group.",
  "compliance.linkedTest.unlinkError": "Could not remove this test from the group.",
  "compliance.threshold.testLinked": "Test linked to the parameter group.",
  "compliance.inlineEdit.editingLimits": "editing all limits",
  "search.possibleMatches.title": "Possible matches",
  "search.possibleMatches.intro": "These records look similar to the one you are creating. Use one of them, or create a new record.",
  "search.possibleMatches.use": "Use this one",
  "search.possibleMatches.createAnyway": "Create new anyway",
  "search.possibleMatches.confirm": "Create a new record even though {count} similar records exist?",
  "search.possibleMatches.confirm.button": "Create new record",
  "search.possibleMatches.back": "Back",
  "search.possibleMatches.matched": "Matched on: {fields}",
  "search.possibleMatches.field.name": "name",
  "search.possibleMatches.field.dateOfBirth": "date of birth",
  "search.possibleMatches.field.identifier": "identifier",
  "search.possibleMatches.field.code": "code",
  "search.possibleMatches.inactive": "Inactive",
  "search.possibleMatches.failed": "Similar records could not be checked. You can still create the new record.",
  "search.possibleMatches.recordFailed": "Your choice could not be recorded, so nothing was created. Try again.",
  "order.entry.patient.create": "Create patient",
  "order.entry.patient.willBeCreated": "The new patient is created when the order is saved.",
  "provider.title.none": "No title",
  "order.billing.reference": "Billing reference",
  "sample.handling.title": "Handling",
  "sample.handling.noRequirement": "No requirement",
  "sample.handling.processWithin": "process within {time}",
  "sample.handling.holding.minutes": "{minutes} min",
  "sample.handling.holding.hours": "{hours} h",
  "sample.handling.holding.hoursMinutes": "{hours} h {minutes} min",
  "sample.handling.requiredLabel": "Required:",
  "sample.handling.storedAtLabel": "Stored at:",
  "sample.handling.arrivedAs": "Arrived as",
  "sample.handling.measuredTemp": "Measured temperature (°C)",
  "sample.handling.measuredTemp.invalid": "Enter a temperature from -100 to 60 °C.",
  "sample.handling.sameForAll": "Same for all samples",
  "sample.handling.notStored": "Not stored yet",
  "sample.handling.storedAt.temperature": "{location} ({degrees} °C)",
  "sample.handling.mismatch": "Handling mismatch",
  "sample.handling.mismatch.detail": "Needs {required}; {actual}",
  "sample.handling.actual.arrived": "arrived as {condition}",
  "sample.handling.actual.measured": "measured {degrees} °C on arrival",
  "sample.handling.actual.stored": "stored at {degrees} °C",
  "sample.handling.reportNonConformity": "Report non-conformity",
  "sample.condition.roomTemp": "Room temperature",
  "sample.condition.refrigerated": "Refrigerated 2 to 8 °C",
  "sample.condition.frozen": "Frozen",
  "sample.condition.onIce": "On ice",
  "sample.condition.dryIce": "Dry ice",
  "common.notRecorded": "Not recorded",
  "sample.legacy.recordedBefore": "Recorded before this version",
  "order.continue.item.arrivalTemperature": "Measured temperature of {sample} is outside -100 to 60 °C",
  "order.entry.receivedBy.you": "Received by {name} (you)",
  "order.entry.receivedBy.other": "Received by {name}",
  "order.entry.receivedBy.search": "Received by",
  "common.change": "Change",
  "common.moreActions": "More actions",
  "order.tests.action.markTestedElsewhere": "Mark tested elsewhere",
  "order.tests.action.unmarkTestedElsewhere": "Not tested elsewhere",
  "order.tests.tag.testedElsewhere": "Tested elsewhere",
  "order.tests.testedElsewhere.help": "Result reported by another laboratory",
  "order.tests.testedElsewhereAt": "Tested elsewhere: {lab}",
  "order.tests.testedElsewhere.value": "Reported value",
  "order.tests.testedElsewhere.lab": "Performing laboratory",
  "order.tests.testedElsewhere.saveFailed": "Tested elsewhere was not saved: {reason}",
  "inventory.board.title": "Items",
  "inventory.board.purpose": "What you have and what to reorder. Expand a row to see its lots and where they are.",
  "inventory.board.column.item": "Item",
  "inventory.board.column.onHand": "On hand",
  "inventory.board.column.runsOut": "Runs out",
  "inventory.board.byLocation": "By location:",
  "inventory.board.empty": "No inventory items yet. Add an item to start tracking it, then receive stock.",
  "inventory.board.noMatches": "No items match your search and filters. Clear them to see the whole catalog.",
  "inventory.board.error": "The items board could not be loaded.",
  "inventory.filter.location": "Filter by Location",
  "inventory.projection.window": "{early} \u2013 {late}",
  "inventory.projection.windowOpen": "{early} or later",
  "inventory.projection.basis": "based on usage through {date}",
  "inventory.projection.stale": "Watch \u2014 usage data may be out of date",
  "inventory.projection.insufficient": "Too few days of use to project a run-out date",
  "inventory.projection.outOfStock": "Out of stock",
  "inventory.projection.trend": "Usage trend",
  "inventory.projection.trend.steady": "steady",
  "inventory.projection.trend.change": "{percent}% / {days}d",
  "inventory.projection.medianDailyUse": "Median daily use: {rate} {units}/day (last {days} days \u2014 the median smooths one-off spikes)",
  "inventory.orderBy.label": "Order by",
  "inventory.orderBy.pastDue": "past due",
  "inventory.orderBy.leadSet": "{days}d (set)",
  "inventory.orderBy.leadObserved": "~{days}d (observed)",
  "inventory.orderBy.leadDefault": "{days}d (default \u2014 set to improve)",
  "inventory.reorderStatus.now": "Reorder now",
  "inventory.reorderStatus.soon": "Reorder soon",
  "inventory.reorderStatus.adequate": "Adequate",
  "inventory.reorderStatus.buildingData": "Building data",
  "inventory.lots.useFirst": "Use first",
  "inventory.lots.disposeFailedQc": "Failed QC: dispose",
  "inventory.lots.flag": "Flag",
  "inventory.lots.none": "No lots recorded for this item yet. Receive stock to start tracking it.",
  "inventory.actions.forItem": "Actions for {item}",
  "inventory.actions.forLot": "Actions for lot {lot}",
  "inventory.actions.editItem": "Edit item details",
  "inventory.actions.editLot": "Edit lot and location",
  "inventory.lots.expiringInDays": "Expires in {days}d",
  "inventory.logUsage.button": "Log usage",
  "inventory.logUsage.title": "Log usage",
  "inventory.logUsage.help": "Record stock used at the bench. This feeds the run-out projection; use Adjust stock to correct a count instead.",
  "inventory.logUsage.quantityWithUnits": "Quantity used ({units})",
  "inventory.logUsage.onHand": "{quantity} {units} on hand. Lots are drawn earliest-expiry first.",
  "inventory.logUsage.error.noItem": "Choose an item to log usage against.",
  "inventory.logUsage.error.wholeUnits": "Enter a whole number of units, at least 1.",
  "inventory.receiveStock.button": "Receive stock",
  "label.testCatalog.basicInfo.opensMicrobiologyCase": "Opens a Microbiology case",
  "label.testCatalog.basicInfo.microbiologyCaseRole": "Case role",
  "label.testCatalog.basicInfo.microbiologyCaseRole.CULTURE": "Culture",
  "label.testCatalog.basicInfo.microbiologyCaseRole.DIRECT": "Direct",
  "label.testCatalog.basicInfo.microbiologyCaseRole.CASE": "Case",
  "label.testCatalog.basicInfo.collectedInSets": "Collected in sets",
  "microbiology.sets.warning.SINGLE_BOTTLE": "Only one bottle in this set",
  "microbiology.sets.warning.REPEATED_CONTAINER": "Repeated container type in this set",
  "microbiology.sets.warning.DIFFERENT_SITES": "Different collection sites in this set",
  "microbiology.sets.warning.COLLECTION_INTERVAL": "Collection times are more than {minutes} minutes apart",
  "microbiology.sets.title": "Culture sets",
  "microbiology.sets.count.sets": "{sets, plural, one {# set} other {# sets}}",
  "microbiology.sets.count.bottles": "{bottles, plural, one {# bottle} other {# bottles}}",
  "microbiology.sets.count.summary": "{sets}, {bottles}",
  "microbiology.sets.number": "Set {number}",
  "microbiology.sets.unassigned": "Set not recorded",
  "order.microPreview.title": "What this order will open",
  "order.microPreview.loading": "Updating order preview…",
  "order.microPreview.failed": "Order preview unavailable",
  "order.microPreview.failedDetail": "The preview could not be updated. Check your connection and try again.",
  "order.microPreview.opens": "Opens a case",
  "order.microPreview.ordinary": "Stays in Results",
  "order.microPreview.case": "{tests} case in {unit}: {samples}",
  "order.microPreview.sample": "{type} sample {number}",
  "order.microPreview.stays": "{test} stays in Results",
  "order.microPreview.splitTag": "Separate cases",
  "order.microPreview.split": "Sample {number} opens {count} cases: {units}.",
  "order.microPreview.reflex": "{name}: if {conditions}, may add {tests}.",
  "order.microPreview.component": "{test} — {component}",
  "order.microPreview.specimen": "{test} ({type})",
  "order.microPreview.and": " and ",
  "order.microPreview.or": " or ",
  "order.microPreview.condition.EQUALS": "{subject} result equals {value}",
  "order.microPreview.condition.NOT_EQUALS": "{subject} result does not equal {value}",
  "order.microPreview.condition.LESS_THAN": "{subject} result is less than {value}",
  "order.microPreview.condition.LESS_THAN_OR_EQUAL": "{subject} result is at most {value}",
  "order.microPreview.condition.GREATER_THAN": "{subject} result is greater than {value}",
  "order.microPreview.condition.GREATER_THAN_OR_EQUAL": "{subject} result is at least {value}",
  "order.microPreview.condition.BETWEEN": "{subject} result is between {value} and {value2}",
  "order.microPreview.condition.INSIDE_NORMAL_RANGE": "{subject} result is within the normal range",
  "order.microPreview.condition.OUTSIDE_NORMAL_RANGE": "{subject} result is outside the normal range",
  "order.microPreview.newUnitTag": "New lab unit",
  "order.microPreview.newUnit": "{test} opens a case in {unit}; this order has no other work in that lab unit.",
  "dictionary.containerPopulation": "Bottle population (sample containers)",
  "dictionary.containerPopulation.unspecified": "Not specified",
  "dictionary.containerPopulation.ADULT": "Adult",
  "dictionary.containerPopulation.PAEDIATRIC": "Paediatric",
  "dictionary.aedesAegyptiPathogens.chikungunya": "Chikungunya",
  "dictionary.aedesAegyptiPathogens.dengue": "Dengue",
  "dictionary.aedesAegyptiPathogens.yellowFever": "Yellow Fever",
  "dictionary.aedesAegyptiPathogens.zika": "Zika",
  "dictionary.aedesAlbopictusPathogens.chikungunya": "Chikungunya",
  "dictionary.aedesAlbopictusPathogens.dengue": "Dengue",
  "dictionary.aedesAlbopictusPathogens.zika": "Zika",
  "dictionary.afbSkinResults.1Plus": "1+",
  "dictionary.afbSkinResults.2Plus": "2+",
  "dictionary.afbSkinResults.3Plus": "3+",
  "dictionary.afbSkinResults.4Plus": "4+",
  "dictionary.afbSkinResults.5Plus": "5+",
  "dictionary.afbSkinResults.6Plus": "6+",
  "dictionary.afbSkinResults.negative": "Negative",
  "dictionary.afbSputumResults.1Plus": "1+",
  "dictionary.afbSputumResults.2Plus": "2+",
  "dictionary.afbSputumResults.3Plus": "3+",
  "dictionary.afbSputumResults.negative": "Negative",
  "dictionary.afbSputumResults.scanty": "Scanty",
  "dictionary.analyzerGeneXpertResults.detected": "DETECTED",
  "dictionary.analyzerGeneXpertResults.error": "ERROR",
  "dictionary.analyzerGeneXpertResults.high": "HIGH",
  "dictionary.analyzerGeneXpertResults.indeterminate": "INDETERMINATE",
  "dictionary.analyzerGeneXpertResults.low": "LOW",
  "dictionary.analyzerGeneXpertResults.medium": "MEDIUM",
  "dictionary.analyzerGeneXpertResults.mtbDetected": "MTB DETECTED",
  "dictionary.analyzerGeneXpertResults.noResult": "NO RESULT",
  "dictionary.analyzerGeneXpertResults.notDetected": "NOT DETECTED",
  "dictionary.analyzerGeneXpertResults.veryLow": "VERY LOW",
  "dictionary.analyzerGeneXpertRifResults.detected": "DETECTED",
  "dictionary.analyzerGeneXpertRifResults.indeterminate": "Indeterminate",
  "dictionary.analyzerGeneXpertRifResults.notDetected": "NOT DETECTED",
  "dictionary.anophelesPathogens.malaria": "Malaria",
  "dictionary.biolineHivResults.hiv1And2Positive": "HIV 1 and 2 Positive",
  "dictionary.biolineHivResults.hiv1Positive": "HIV 1 Positive",
  "dictionary.biolineHivResults.hiv2Positive": "HIV 2 Positive",
  "dictionary.biolineHivResults.indeterminate": "Indeterminate",
  "dictionary.biolineHivResults.negative": "Negative",
  "dictionary.candidaKohResults.hypa": "Hyphae",
  "dictionary.candidaKohResults.spora": "Spores",
  "dictionary.candidaKohResults.yeastCell": "Yeast cell",
  "dictionary.clinicalCollectionMethod.arterialPuncture": "Arterial Puncture",
  "dictionary.clinicalCollectionMethod.aspirate": "Aspirate",
  "dictionary.clinicalCollectionMethod.biopsy": "Biopsy",
  "dictionary.clinicalCollectionMethod.capillaryFingerPrick": "Capillary / Finger Prick",
  "dictionary.clinicalCollectionMethod.catheter": "Catheter",
  "dictionary.clinicalCollectionMethod.heelPrick": "Heel Prick",
  "dictionary.clinicalCollectionMethod.lumbarPuncture": "Lumbar Puncture",
  "dictionary.clinicalCollectionMethod.midstreamCleanCatch": "Midstream Clean Catch",
  "dictionary.clinicalCollectionMethod.other": "Other",
  "dictionary.clinicalCollectionMethod.sputumExpectoration": "Sputum Expectoration",
  "dictionary.clinicalCollectionMethod.swab": "Swab",
  "dictionary.clinicalCollectionMethod.venipuncture": "Venipuncture",
  "dictionary.confirmatoryResults.indeterminate": "Indeterminate",
  "dictionary.confirmatoryResults.invalid": "Invalid",
  "dictionary.confirmatoryResults.negative": "Negative",
  "dictionary.confirmatoryResults.positive": "Positive",
  "dictionary.culexPathogens.westNileVirus": "West Nile Virus",
  "dictionary.detectionResults.terdeteksi": "Detected",
  "dictionary.detectionResults.tidakMeyakinkan": "Inconclusive",
  "dictionary.detectionResults.tidakTerdeteksi": "Not Detected",
  "dictionary.envCollectionMethod.composite24H": "Composite 24h",
  "dictionary.envCollectionMethod.composite8H": "Composite 8h",
  "dictionary.envCollectionMethod.depthIntegrated": "Depth Integrated",
  "dictionary.envCollectionMethod.grabSample": "Grab Sample",
  "dictionary.envCollectionMethod.other": "Other",
  "dictionary.envCollectionMethod.passiveSampler": "Passive Sampler",
  "dictionary.envCollectionMethod.surfaceGrab": "Surface Grab",
  "dictionary.envWeather.clearSunny": "Clear / Sunny",
  "dictionary.envWeather.drizzle": "Drizzle",
  "dictionary.envWeather.foggy": "Foggy",
  "dictionary.envWeather.heavyRain": "Heavy Rain",
  "dictionary.envWeather.lightRain": "Light Rain",
  "dictionary.envWeather.other": "Other",
  "dictionary.envWeather.overcast": "Overcast",
  "dictionary.envWeather.partlyCloudy": "Partly Cloudy",
  "dictionary.envWeather.windy": "Windy",
  "dictionary.environmentalZone.agricultural": "Agricultural",
  "dictionary.environmentalZone.industrial": "Industrial",
  "dictionary.environmentalZone.periUrban": "Peri-Urban",
  "dictionary.environmentalZone.protectedArea": "Protected Area",
  "dictionary.environmentalZone.rural": "Rural",
  "dictionary.environmentalZone.urban": "Urban",
  "dictionary.fleaFullCycle.adult": "Adult",
  "dictionary.fleaFullCycle.egg": "Egg",
  "dictionary.fleaFullCycle.larva": "Larva",
  "dictionary.fleaFullCycle.pupa": "Pupa",
  "dictionary.flyStages.adult": "Adult",
  "dictionary.flyStages.larva": "Larva",
  "dictionary.flyStages.pupa": "Pupa",
  "dictionary.genieHivResults.hiv1": "HIV 1",
  "dictionary.genieHivResults.hiv2": "HIV 2",
  "dictionary.genieHivResults.hivDual": "HIV Dual",
  "dictionary.genieHivResults.indeterminate": "Indeterminate",
  "dictionary.genieHivResults.invalid": "Invalid",
  "dictionary.genieHivResults.negative": "Negative",
  "dictionary.gramStainGenitalResults.gramDiplococcusFound": "Gram(-) diplococcus found",
  "dictionary.gramStainGenitalResults.gramDiplococcusNotFound": "Gram(-) diplococcus not found",
  "dictionary.hBsAgResults.negative": "Negative",
  "dictionary.hBsAgResults.positive": "Positive",
  "dictionary.hivRapidResults.indeterminate": "Indeterminate",
  "dictionary.hivRapidResults.negative": "Negative",
  "dictionary.hivRapidResults.positive": "Positive",
  "dictionary.malariaResults.mixedInfection": "Mixed infection",
  "dictionary.malariaResults.noParasitesSeen": "No parasites seen",
  "dictionary.malariaResults.plasmodiumFalciparum": "Plasmodium falciparum",
  "dictionary.malariaResults.plasmodiumMalariae": "Plasmodium malariae",
  "dictionary.malariaResults.plasmodiumOvale": "Plasmodium ovale",
  "dictionary.malariaResults.plasmodiumVivax": "Plasmodium vivax",
  "dictionary.mosquitoFullCycle.adult": "Adult",
  "dictionary.mosquitoFullCycle.egg": "Egg",
  "dictionary.mosquitoFullCycle.larva": "Larva",
  "dictionary.mosquitoFullCycle.pupa": "Pupa",
  "dictionary.muscaPathogens.typhus": "Typhus",
  "dictionary.p24AgResults.hiv1": "HIV 1",
  "dictionary.p24AgResults.indeterminate": "Indeterminate",
  "dictionary.p24AgResults.negative": "Negative",
  "dictionary.phlebotomusPathogens.riftValleyFever": "Rift Valley Fever",
  "dictionary.positifNegatif.negatif": "Negative",
  "dictionary.positifNegatif.positif": "Positive",
  "dictionary.pregnancyTestResults.negative": "Negative",
  "dictionary.pregnancyTestResults.positive": "Positive",
  "dictionary.proteinuriaResults.negative": "Negative",
  "dictionary.proteinuriaResults.positivePlus": "Positive +",
  "dictionary.proteinuriaResults.positivePlusPlus": "Positive ++",
  "dictionary.proteinuriaResults.positivePlusPlusPlus": "Positive +++",
  "dictionary.qaChecklistItem.labelsVerified": "Labels have been printed and applied",
  "dictionary.qaChecklistItem.patientInfoVerified": "Patient information is correct",
  "dictionary.qaChecklistItem.samplesVerified": "Sample types and tests are correct",
  "dictionary.qaChecklistItem.storageVerified": "Storage locations have been assigned",
  "dictionary.rattusPathogens.plague": "Plague",
  "dictionary.rattusPathogens.typhus": "Typhus",
  "dictionary.rodentStages.adult": "Adult",
  "dictionary.sampleAcceptanceItem.coldChain": "Cold chain maintained",
  "dictionary.sampleAcceptanceItem.containerIntact": "Container intact / undamaged",
  "dictionary.sampleAcceptanceItem.labelLegible": "Label legible and matches request",
  "dictionary.sampleAcceptanceItem.paperwork": "Required paperwork present and complete",
  "dictionary.sampleAcceptanceItem.transit": "Acceptable transit time / condition",
  "dictionary.sampleAcceptanceItem.volumeAdequate": "Sample volume adequate",
  "dictionary.sampleContainer.1LHdpeBottle": "1L HDPE bottle",
  "dictionary.sampleContainer.250MLGlassBottle": "250mL glass bottle",
  "dictionary.sampleContainer.500MLGlassBottle": "500mL glass bottle",
  "dictionary.sampleContainer.compositeJerryCan5L": "Composite jerry can 5L",
  "dictionary.sampleContainer.filterMembrane": "Filter membrane",
  "dictionary.sampleContainer.other": "Other",
  "dictionary.sampleContainer.sterileBag": "Sterile bag",
  "dictionary.sampleType.hPlasma": "Plasma",
  "dictionary.sampleType.hSaliva": "Saliva",
  "dictionary.sampleType.hSerum": "Serum",
  "dictionary.sampleType.hTissue": "Tissue",
  "dictionary.sampleType.hUrine": "Urine",
  "dictionary.sampleType.hWholeBlood": "Whole Blood",
  "dictionary.samplingSiteType.airMonitoringStation": "Air Monitoring Station",
  "dictionary.samplingSiteType.distributionPoint": "Distribution Point",
  "dictionary.samplingSiteType.foodFacility": "Food Facility",
  "dictionary.samplingSiteType.monitoringStation": "Monitoring Station",
  "dictionary.samplingSiteType.other": "Other",
  "dictionary.samplingSiteType.soilSamplingSite": "Soil Sampling Site",
  "dictionary.samplingSiteType.treatmentPlant": "Treatment Plant",
  "dictionary.samplingSiteType.waterSource": "Water Source",
  "dictionary.specimenOrigin.communityField": "Community / Field",
  "dictionary.specimenOrigin.emergencyDepartment": "Emergency Department",
  "dictionary.specimenOrigin.inpatientWard": "Inpatient Ward",
  "dictionary.specimenOrigin.intensiveCare": "Intensive Care",
  "dictionary.specimenOrigin.operatingTheatre": "Operating Theatre",
  "dictionary.specimenOrigin.outpatientClinic": "Outpatient Clinic",
  "dictionary.specimenOrigin.referredFromExternalFacility": "Referred from External Facility",
  "dictionary.susceptibilityResults.intermediate": "Intermediate",
  "dictionary.susceptibilityResults.resistan": "Resistant",
  "dictionary.susceptibilityResults.sensitif": "Sensitive",
  "dictionary.testResults.detected": "Detected",
  "dictionary.testResults.inconclusive": "Inconclusive",
  "dictionary.testResults.indeterminate": "Indeterminate",
  "dictionary.testResults.negative": "Negative",
  "dictionary.testResults.nonReactive": "Non-Reactive",
  "dictionary.testResults.notDetected": "Not Detected",
  "dictionary.testResults.positive": "Positive",
  "dictionary.testResults.reactive": "Reactive",
  "dictionary.titerResults.1To10": "1:10",
  "dictionary.titerResults.1To160": "1:160",
  "dictionary.titerResults.1To20": "1:20",
  "dictionary.titerResults.1To320": "1:320",
  "dictionary.titerResults.1To40": "1:40",
  "dictionary.titerResults.1To640": "1:640",
  "dictionary.titerResults.1To80": "1:80",
  "dictionary.trichomonasResults.trichomonasNegative": "Trichomonas negative",
  "dictionary.trichomonasResults.trichomonasPositive": "Trichomonas positive",
  "dictionary.urinalysisResults.clear": "Clear",
  "dictionary.urinalysisResults.cloudy": "Cloudy",
  "dictionary.urinalysisResults.slightlyCloudy": "Slightly Cloudy",
  "dictionary.urinalysisResults.turbid": "Turbid",
  "dictionary.urineColor.amber": "Amber",
  "dictionary.urineColor.brown": "Brown",
  "dictionary.urineColor.darkYellow": "Dark Yellow",
  "dictionary.urineColor.red": "Red",
  "dictionary.urineColor.yellow": "Yellow",
  "dictionary.vecBloodmealHostSpecies.avianProxyToChicken": "Avian (proxy: chicken)",
  "dictionary.vecBloodmealHostSpecies.cattleBosTaurus": "Cattle (Bos taurus)",
  "dictionary.vecBloodmealHostSpecies.dogCanisFamiliaris": "Dog (Canis familiaris)",
  "dictionary.vecBloodmealHostSpecies.goatCapraHircus": "Goat (Capra hircus)",
  "dictionary.vecBloodmealHostSpecies.humanHomoSapiens": "Human (Homo sapiens)",
  "dictionary.vecBloodmealHostSpecies.mixedHostBloodmeal": "Mixed-host bloodmeal",
  "dictionary.vecBloodmealHostSpecies.noHostDetected": "No host detected",
  "dictionary.vecBloodmealHostSpecies.pigSusScrofa": "Pig (Sus scrofa)",
  "dictionary.vecCollectionTimeOfDay.dawn": "Dawn",
  "dictionary.vecCollectionTimeOfDay.daylight": "Daylight",
  "dictionary.vecCollectionTimeOfDay.dusk": "Dusk",
  "dictionary.vecCollectionTimeOfDay.night": "Night",
  "dictionary.vecCollectionTimeOfDay.unknown": "Unknown",
  "dictionary.vecInsecticideResistanceGenotype.heterozygote": "Heterozygote",
  "dictionary.vecInsecticideResistanceGenotype.indeterminate": "Indeterminate",
  "dictionary.vecInsecticideResistanceGenotype.resistantHomozygote": "Resistant homozygote",
  "dictionary.vecInsecticideResistanceGenotype.susceptibleHomozygote": "Susceptible homozygote",
  "dictionary.vecLifecycleStages.adult": "Adult",
  "dictionary.vecLifecycleStages.egg": "Egg",
  "dictionary.vecLifecycleStages.larva": "Larva",
  "dictionary.vecLifecycleStages.nymph": "Nymph",
  "dictionary.vecLifecycleStages.pupa": "Pupa",
  "dictionary.vecPathogenResult.equivocalIndeterminate": "Equivocal / Indeterminate",
  "dictionary.vecPathogenResult.invalid": "Invalid",
  "dictionary.vecPathogenResult.negative": "Negative",
  "dictionary.vecPathogenResult.positive": "Positive",
  "dictionary.vecPathogens.chikungunya": "Chikungunya",
  "dictionary.vecPathogens.dengue": "Dengue",
  "dictionary.vecPathogens.malaria": "Malaria",
  "dictionary.vecPathogens.plague": "Plague",
  "dictionary.vecPathogens.riftValleyFever": "Rift Valley Fever",
  "dictionary.vecPathogens.typhus": "Typhus",
  "dictionary.vecPathogens.westNileVirus": "West Nile Virus",
  "dictionary.vecPathogens.yellowFever": "Yellow Fever",
  "dictionary.vecPathogens.zika": "Zika",
  "dictionary.vecPhysiologicalState.bloodFed": "Blood-fed",
  "dictionary.vecPhysiologicalState.gravid": "Gravid",
  "dictionary.vecPhysiologicalState.halfGravid": "Half-gravid",
  "dictionary.vecPhysiologicalState.unfed": "Unfed",
  "dictionary.vecPhysiologicalState.unknownNotAssessed": "Unknown / not assessed",
  "dictionary.vecPlasmodiumDrugResistanceVariant.76T": "76T",
  "dictionary.vecPlasmodiumDrugResistanceVariant.a437G": "A437G",
  "dictionary.vecPlasmodiumDrugResistanceVariant.a581G": "A581G",
  "dictionary.vecPlasmodiumDrugResistanceVariant.a613S": "A613S",
  "dictionary.vecPlasmodiumDrugResistanceVariant.c580Y": "C580Y",
  "dictionary.vecPlasmodiumDrugResistanceVariant.d1246": "D1246",
  "dictionary.vecPlasmodiumDrugResistanceVariant.i164L": "I164L",
  "dictionary.vecPlasmodiumDrugResistanceVariant.i543T": "I543T",
  "dictionary.vecPlasmodiumDrugResistanceVariant.k540E": "K540E",
  "dictionary.vecPlasmodiumDrugResistanceVariant.k76WildType": "K76 (wild type)",
  "dictionary.vecPlasmodiumDrugResistanceVariant.n1042": "N1042",
  "dictionary.vecPlasmodiumDrugResistanceVariant.n51I": "N51I",
  "dictionary.vecPlasmodiumDrugResistanceVariant.otherVariantSequenceCaptured": "Other variant (sequence captured)",
  "dictionary.vecPlasmodiumDrugResistanceVariant.p553L": "P553L",
  "dictionary.vecPlasmodiumDrugResistanceVariant.r539T": "R539T",
  "dictionary.vecPlasmodiumDrugResistanceVariant.r59": "R59",
  "dictionary.vecPlasmodiumDrugResistanceVariant.s1034": "S1034",
  "dictionary.vecPlasmodiumDrugResistanceVariant.s108": "S108",
  "dictionary.vecPlasmodiumDrugResistanceVariant.wildTypePfkelch13": "Wild type (pfkelch13)",
  "dictionary.vecPlasmodiumDrugResistanceVariant.y184": "Y184",
  "dictionary.vecPlasmodiumDrugResistanceVariant.y493H": "Y493H",
  "dictionary.vecPlasmodiumDrugResistanceVariant.y86": "Y86",
  "dictionary.vecPlasmodiumSpecies.indeterminate": "Indeterminate",
  "dictionary.vecPlasmodiumSpecies.mixedInfection": "Mixed infection",
  "dictionary.vecPlasmodiumSpecies.pFalciparum": "P. falciparum",
  "dictionary.vecPlasmodiumSpecies.pKnowlesi": "P. knowlesi",
  "dictionary.vecPlasmodiumSpecies.pMalariae": "P. malariae",
  "dictionary.vecPlasmodiumSpecies.pOvale": "P. ovale",
  "dictionary.vecPlasmodiumSpecies.pVivax": "P. vivax",
  "dictionary.vecRestingContext.indoorEndophilic": "Indoor (endophilic)",
  "dictionary.vecRestingContext.outdoorExophilic": "Outdoor (exophilic)",
  "dictionary.vecRestingContext.unknown": "Unknown",
  "dictionary.vecTrapType.aspirator": "Aspirator",
  "dictionary.vecTrapType.bgSentinelTrap": "BG-Sentinel trap",
  "dictionary.vecTrapType.cdcLightTrap": "CDC light trap",
  "dictionary.vecTrapType.gravidTrap": "Gravid trap",
  "dictionary.vecTrapType.humanLandingCollection": "Human-landing collection",
  "dictionary.vecTrapType.otherSpecifyInNotes": "Other (specify in notes)",
  "dictionary.vecTrapType.ovitrap": "Ovitrap",
  "dictionary.vecTrapType.sweepNet": "Sweep net",
  "dictionary.vecVirusIsolationResult.inconclusive": "Inconclusive",
  "dictionary.vecVirusIsolationResult.isolated": "Isolated",
  "dictionary.vecVirusIsolationResult.notIsolated": "Not isolated",
  "dictionary.vecWhoInsecticideSusceptibilityClass.possiblyResistant": "Possibly resistant",
  "dictionary.vecWhoInsecticideSusceptibilityClass.resistant": "Resistant",
  "dictionary.vecWhoInsecticideSusceptibilityClass.susceptible": "Susceptible",
  "dictionary.waterClarity.agakKeruh": "Slightly Turbid",
  "dictionary.waterClarity.jernih": "Clear",
  "dictionary.waterClarity.keruh": "Turbid",
  "dictionary.waterColor.biru": "Blue",
  "dictionary.waterColor.cokelat": "Brown",
  "dictionary.waterColor.hijau": "Green",
  "dictionary.waterColor.hitam": "Black",
  "dictionary.waterColor.kuning": "Yellow",
  "dictionary.waterColor.merah": "Red",
  "dictionary.waterColor.putih": "White",
  "dictionary.waterColor.tidakBerwarna": "Colorless",
  "dictionary.xenopsyllaPathogens.plague": "Plague",
  "dictionary.xenopsyllaPathogens.typhus": "Typhus",
  "microbiology.sets.warning.MIXED_POPULATIONS": "This set contains paediatric and adult bottles.",
  "order.cultureSetNumber": "Set number",
  "order.cultureSetNumber.required": "Enter a positive whole set number.",
  "order.cultureBottle.duplicate": "Duplicate bottle",
  "microbiology.sets.container": "Container type",
  "microbiology.sets.bodySite": "Body site",
  "inventory.reorder.suggestions": "Reorder suggestions",
  "inventory.reorder.help": "Items at or below their threshold, or projected to reach it before a new order could arrive. Marking as ordered records that an order was placed \u2014 it does not place one.",
  "inventory.reorder.none": "Nothing needs ordering right now.",
  "inventory.reorder.markOrdered": "Mark as ordered",
  "inventory.reorder.onOrder": "On order",
  "inventory.reorder.note": "Note",
  "inventory.reorder.note.placeholder": "Requisition or PO reference",
  "inventory.reorder.expectedDate": "Expected date",
  "inventory.reorder.marked": "{count, plural, one {# item} other {# items}} marked as ordered.",
  "inventory.reorder.reviewAndOrder": "Review and mark as ordered",
  "inventory.reorder.clearOrdered": "Not ordered after all",
  "inventory.reorder.cleared": "{count, plural, one {# item} other {# items}} no longer marked as ordered.",
  "inventory.board.andMore": "and {count} more",
  "inventory.item.leadTime": "Lead time (days)",
  "inventory.item.leadTime.help": "How long this item takes to arrive after it is ordered. Leave blank to let it be learned from your own deliveries.",
  "inventory.item.leadTime.observedSuggest": "Your last few deliveries took about {days} days.",
  "inventory.item.leadTime.useObserved": "Use this",
  "inventory.item.tags": "Tags",
  "inventory.item.tags.help": "How this item is grouped, filtered and reported on. An item can carry more than one.",
  "inventory.item.tags.add": "Type to find or add a tag",
  "inventory.item.tags.remove": "Remove the tag {tag}",
  "inventory.item.autoConsume.help": "There is no auto-consume setting. Linking the item to a test in the Test Catalog lets the bench record its use when entering that test's results.",
  "inventory.search.placeholder.board": "Search by item name, code, tag or lot number",
  "inventory.filter.tags": "Filter by Tags",
  "inventory.filter.tags.clear": "Clear tags",
  "inventory.tags.manage": "Manage tags",
  "inventory.tags.help": "Tidy up your tags. Deactivating one stops it being suggested or offered as a filter. Items already carrying it keep it.",
  "inventory.tags.tag": "Tag",
  "inventory.tags.usage": "Items",
  "inventory.tags.status": "Status",
  "inventory.tags.active": "Active",
  "inventory.tags.deactivated": "Deactivated",
  "inventory.tags.deactivate": "Deactivate",
  "inventory.tags.reactivate": "Reactivate",
  "inventory.tags.showDeactivated": "Show deactivated",
  "inventory.tags.new": "New tag",
  "inventory.tags.add": "Add tag",
  "inventory.tags.none": "No tags yet. Add one here, or tag an item directly.",
  "inventory.tags.error.blank": "A tag needs a name.",
  "inventory.item.new": "New item",
  "inventory.item.created": "Item defined. Receive stock against it to start tracking quantities.",
  "inventory.item.showDeactivated": "Show deactivated",
  "inventory.item.deactivated": "Deactivated",
  "inventory.item.deactivate": "Deactivate item",
  "inventory.item.reactivate": "Reactivate item",
  "inventory.item.reactivated": "{item} is active again.",
  "inventory.item.deactivated.success": "{item} is deactivated. Show deactivated to find it again.",
  "inventory.item.deactivate.confirm.title": "Deactivate this item?",
  "inventory.item.deactivate.confirm": "Deactivate {item}?",
  "inventory.item.deactivate.implication.hidden": "It leaves the board and stops being offered when receiving or recording usage.",
  "inventory.item.deactivate.implication.stock": "Its lots and history are kept, and any stock it still holds is not written off.",
  "inventory.item.deactivate.implication.reversible": "You can reactivate it at any time from Show deactivated.",
  "catalog.item.catalogNumber": "Catalog number",
  "catalog.item.expirationAlertDays": "Warn this many days before expiry",
  "catalog.item.trackLots": "Track lots and expiry",
  "catalog.item.trackLots.help": "Turn on for anything received in batches with an expiry date. Turn off for consumables counted as a single pool.",
  "catalog.item.form.help": "This defines a kind of item. To add more of one that already exists, use Receive stock.",
  "inventory.item.form.title.add": "New item",
  "inventory.item.form.title.edit": "Edit item",
  "inventory.count.enter": "Count mode",
  "inventory.count.leave": "Leave count mode",
  "inventory.count.confirm": "Confirm count",
  "inventory.count.expected": "of {expected} {units}",
  "inventory.count.matches": "Matches",
  "inventory.count.perLot": "Count each lot below ({expected} {units} expected here)",
  "inventory.count.nothingHere": "Nothing here to count",
  "inventory.count.countOf": "Counted quantity for {item}",
  "inventory.count.tally": "{counted, plural, =0 {Nothing counted yet} one {# lot counted} other {# lots counted}}",
  "inventory.count.scoped": "Counting {location}. Only stock in this location is listed, and only what you type is committed.",
  "inventory.count.unscoped": "Counting everywhere. Filter by location to count one shelf at a time. Only what you type is committed.",
  "inventory.count.done": "Count recorded: {adjusted, plural, =0 {no corrections} one {# correction} other {# corrections}}, {confirmed, plural, =0 {none confirmed} one {# lot confirmed} other {# lots confirmed}}.",
  "inventory.count.lastCounted": "Counted {date}",
  "inventory.count.neverCounted": "Never counted",
  "inventory.count.column": "Last count",
  "inventory.delivery.purpose": "Enter a delivery. Scan a box, type how much arrived, add it, scan the next. Nothing is saved until you confirm the whole delivery.",
  "inventory.delivery.scan": "Scan the box",
  "inventory.delivery.scan.help": "A GS1 label fills in the product, batch and expiry. Anything it does not carry can be typed below.",
  "inventory.delivery.scan.unread": "That code was not recognised. Enter the line by hand.",
  "inventory.delivery.partialScan": "Partly scanned",
  "inventory.delivery.add": "Add to delivery",
  "inventory.delivery.remove": "Remove",
  "inventory.delivery.confirm": "Receive {count, plural, one {# line} other {# lines}}",
  "inventory.delivery.discard": "Discard delivery",
  "inventory.delivery.received": "{count, plural, one {# line} other {# lines}} received.",
  "inventory.delivery.expired": "This lot is already past its expiry date",
  "inventory.delivery.expired.help": "You can still receive it. Short-dated stock is a normal delivery, and the board will flag it.",
  "catalog.item.upc": "Product barcode (UPC or GTIN)",
  "catalog.item.upc.help": "The manufacturer's barcode for this product. Every box of it carries the same one, so scanning it says what an item is, not which batch arrived.",
  "inventory.receive.title": "Receive stock",
  "inventory.receive.submit": "Receive",
  "inventory.receive.success": "Received {quantity} {units}. It counts towards on-hand now, and can be used once its QC passes.",
  "inventory.receive.help": "Adds more of an item that already exists. To define something new, use New item.",
  "inventory.receive.scan": "Scan a product barcode",
  "inventory.receive.scan.help": "Scan or type a UPC to pick the item without searching.",
  "inventory.receive.scan.unknown": "No item carries that barcode",
  "inventory.receive.quantityWithUnits": "Quantity received ({units})",
  "inventory.receive.lotNumber.help": "Leave blank and one is generated from the item code and today's date.",
  "inventory.receive.location.optional": "Not assigned. You can set this now or from the lot later.",
  "inventory.receive.error.noItem": "Choose the item being received.",
  "inventory.receive.error.quantity": "Enter how much arrived.",
  "inventory.receive.error.locationAfterReceive": "The stock was received, but the storage location could not be assigned: {reason}",
  "reports.type.received": "Received",
  "reports.type.received.description": "What arrived in the period, by item and lot.",
  "reports.type.consumed": "Consumed",
  "reports.type.consumed.description": "What was used in the period, totalled by item.",
  "reports.type.stockOnHand": "Stock on hand",
  "reports.type.stockOnHand.description": "What you hold, lot by lot, with expiry dates.",
  "reports.type.expiring": "Expiring",
  "reports.type.expiring.description": "Lots whose expiry falls in a window you choose.",
  "reports.asOfDate": "As of",
  "reports.asOfDate.help": "Leave blank for stock as it stands now.",
  "reports.expiringFrom": "Expiring from",
  "reports.expiringTo": "Expiring to",
  "reports.tags": "Tags",
  "reports.tags.help": "Limit the report to items carrying any of these tags.",
  "reports.tags.placeholder": "Any tag",
  "reports.run": "Run report",
  "reports.running": "Running...",
  "reports.empty": "Nothing matched these filters.",
  "reports.empty.stockOnHandAsOf": "No stock movements are recorded on or before this date, so stock as it stood then cannot be reconstructed. This is not the same as having held nothing.",
  "reports.asOfDate.basis": "Reconstructed from recorded stock movements up to this date, not from a physical count.",
  "order.continue.item.eqaScheme": "Choose the EQA scheme",
  "order.eqa.cycle": "Cycle",
  "order.eqa.cycle.none": "No cycle",
  "order.eqa.cycleNotInScheme": "The chosen cycle is not an open cycle of this EQA scheme.",
  "order.eqa.newCycle": "New cycle",
  "order.eqa.noCycle.warning": "This sample is not linked to a cycle, so it will not be submitted or scored from OpenELIS.",
  "order.eqa.noEnrollments.link": "Enroll under My EQA Schemes",
  "order.eqa.noEnrollments.title": "This laboratory is not enrolled in any active EQA scheme.",
  "order.eqa.providerSampleId.codes": "Panel codes for this cycle: {codes}",
  "order.eqa.providerSampleId.noMatch": "This code matches none of the cycle's panel codes ({codes}).",
  "order.eqa.scheme": "EQA scheme",
  "order.eqa.scheme.choose": "Choose a scheme",
  "order.eqa.schemeRequired": "Choose the EQA scheme this sample belongs to.",
  "order.eqa.schemeUnknown": "The chosen EQA scheme is not one of this laboratory's active enrollments.",
  "order.save.requirement.eqaScheme": "the EQA scheme",
  "save.order.success.labNumber": "Order {labNumber} has been saved.",
  "qc.status.error.required": "Select a QC status.",
  "qc.status.error.notesRequired": "Say why QC failed.",
  "disposal.error.reasonRequired": "Select a disposal reason.",
  "common.error.notesRequiredForOther": "Add a note to explain the reason you chose.",
  "adjustment.error.negativeQuantity": "Quantity cannot be negative.",
  "adjustment.error.reasonRequired": "Select a reason for the adjustment.",
  "lot.error.numberRequired": "Lot number is required.",
  "lot.error.locationRequired": "Assign a storage location.",
  "lot.status.select": "Select lot status",
  "catalog.item.error.nameRequired": "Item name is required.",
  "sidenav.label.inventory.items": "Items",
  "sidenav.label.inventory.items.tooltip": "What you have and what to reorder",
  "sidenav.label.inventory.receive": "Receive",
  "sidenav.label.inventory.receive.tooltip": "Enter a delivery, scanning or typing each line",
  "sidenav.label.inventory.reports": "Reports",
  "sidenav.label.inventory.reports.tooltip": "Received, consumed, stock on hand and expiring",
  "inventory.import.button": "Import items",
  "inventory.import.title": "Import items from a file",
  "inventory.import.help": "Define many items at once from a CSV file. The preview shows what the file would do and saves nothing; only Apply writes anything. Re-importing a corrected file updates the same items rather than adding them again.",
  "inventory.import.template": "Download the template",
  "inventory.import.dropzone": "Add a CSV file",
  "inventory.import.preview": "Preview",
  "inventory.import.apply": "Apply",
  "inventory.import.plan.title": "What this file would do",
  "inventory.import.result.title": "What was imported",
  "inventory.import.column.line": "Line",
  "inventory.import.column.outcome": "Outcome",
  "inventory.import.column.reason": "Reason",
  "inventory.import.outcome.create": "New",
  "inventory.import.outcome.update": "Updated",
  "inventory.import.outcome.unchanged": "Unchanged",
  "inventory.import.outcome.skip": "Skipped",
  "inventory.import.count.created": "{count} new",
  "inventory.import.count.updated": "{count} updated",
  "inventory.import.count.unchanged": "{count} unchanged",
  "inventory.import.count.skipped": "{count} skipped",
  "inventory.import.error.rowsTitle": "Some rows cannot be used",
  "inventory.import.error.rowsMessage": "The rows listed below will be skipped. Applying saves the rest; fix those rows and add the file again to include them.",
  "inventory.import.error.unreadable": "That file could not be read.",
  "inventory.import.error.failed": "The file could not be imported.",
  "inventory.import.nothingToDo": "This file would change nothing",
  "inventory.import.nothingToDo.help": "Every item in it already matches what is stored.",
  "sidenav.label.reports.printQueue": "Report Print Queue",
  "reportQueue.title": "Report Print Queue",
  "reportQueue.subtitle": "Print, reprint and reissue released reports",
  "reportQueue.guidance.lead": "Reports land here when their first result is released.",
  "reportQueue.guidance.body": "Printed reports come back when more results are released or a printed result changes.",
  "reportQueue.legend.partial": "Some results are not released yet",
  "reportQueue.legend.final": "Every result is released",
  "reportQueue.legend.amended": "A printed result changed, or the report was reissued with a correction",
  "reportQueue.legend.unprinted": "The current content has not been printed yet",
  "reportQueue.legend.printed": "The last print matches what is released",
  "reportQueue.tile.toPrint": "To print",
  "reportQueue.tile.amendedToPrint": "Amended to print",
  "reportQueue.type.patient": "Patient report",
  "reportQueue.state.partial": "Partial {released}/{total}",
  "reportQueue.state.partialName": "Partial",
  "reportQueue.state.final": "Final",
  "reportQueue.state.amended": "Amended",
  "reportQueue.state.amendedPartial": "Amended {released}/{total}",
  "reportQueue.printStatus.unprinted": "Unprinted",
  "reportQueue.printStatus.printed": "Printed",
  "reportQueue.col.type": "Type",
  "reportQueue.col.labNoName": "Lab No / Name",
  "reportQueue.col.subject": "Subject",
  "reportQueue.col.details": "Details",
  "reportQueue.col.released": "Released / Submitted",
  "reportQueue.col.state": "State",
  "reportQueue.col.printStatus": "Print status",
  "reportQueue.col.version": "Version",
  "reportQueue.version.none": "Not issued",
  "reportQueue.version.value": "v{n}",
  "reportQueue.action.print": "Print",
  "reportQueue.print.disabled.nothingReleased": "Nothing released yet on this order",
  "reportQueue.print.success": "{count, plural, one {# report} other {# reports}} ready",
  "reportQueue.print.failed": "Could not prepare {count, plural, one {# report} other {# reports}}: {labNumbers}",
  "reportQueue.print.reprinted": "Reprinted version {n} of {labNumber}",
  "reportQueue.print.issued": "Printed version {n} of {labNumber}",
  "reportQueue.print.popupBlocked": "The browser blocked the report window for {labNumber}",
  "reportQueue.print.open": "Open the report",
  "reportQueue.filter.labNo.placeholder": "Scan or type lab number",
  "reportQueue.filter.labNo.helper": "Scanning a barcode applies the filter instantly",
  "reportQueue.filter.labNo.range": "Range",
  "reportQueue.filter.labNo.to": "To lab number",
  "reportQueue.filter.labNo.rangeReversed": "The To lab number is before the From lab number",
  "reportQueue.filter.patient": "Search by patient",
  "reportQueue.filter.state": "State",
  "reportQueue.filter.printStatus": "Print status",
  "reportQueue.filter.window": "Time window",
  "reportQueue.filter.window.24h": "Last 24 hours",
  "reportQueue.filter.window.7d": "Last 7 days",
  "reportQueue.filter.window.30d": "Last 30 days",
  "reportQueue.filter.window.all": "All time",
  "reportQueue.filter.window.custom": "Custom range",
  "reportQueue.filter.window.to": "To",
  "reportQueue.filter.window.helper": "Applies to printed reports; unprinted ones always show",
  "reportQueue.filter.facility": "Facility",
  "reportQueue.filter.ward": "Ward / Dept / Unit",
  "reportQueue.filter.ward.disabled": "Select a facility first",
  "reportQueue.filter.typeahead.helper": "Type 2 or more characters to search",
  "reportQueue.filter.clear": "Clear filters",
  "reportQueue.search.active.labNo": "Lab No: {labNo}",
  "reportQueue.search.active.labRange": "Lab No: {from} to {to}",
  "reportQueue.search.active.patient": "Patient: {name}",
  "reportQueue.search.clear": "Clear search",
  "reportQueue.search.disabledHelper": "Other filters are off while you look up a specific order",
  "reportQueue.empty": "Nothing to print. Every released report in this view has been printed.",
  "reportQueue.error.load": "Could not load the queue.",
  "reportQueue.detail.tests": "Tests",
  "reportQueue.detail.order": "Order",
  "reportQueue.detail.validatedBy": "Validated by",
  "reportQueue.detail.col.test": "Test",
  "reportQueue.detail.col.result": "Result",
  "reportQueue.detail.col.flag": "Flag",
  "reportQueue.detail.col.released": "Released",
  "reportQueue.detail.awaitingValidation": "Awaiting validation",
  "reportQueue.detail.inProgress": "In progress",
  "reportQueue.history.title": "Version history",
  "reportQueue.history.issued": "Issued",
  "reportQueue.history.by": "By",
  "reportQueue.history.change": "Change",
  "reportQueue.history.firstIssue": "First issue",
  "reportQueue.history.completeness": "Completeness",
  "reportQueue.history.fingerprint": "Fingerprint",
  "reportQueue.history.openPdf": "Open PDF",
  "reportQueue.history.reprinted": "Reprinted {date} by {user}",
  "reportQueue.history.notArchived": "Not archived (issued before {date})",
  "reportQueue.history.archiveFailed": "Archive failed",
  "reportQueue.history.none": "Nothing printed yet",
  "reportQueue.awaitingValidation": "Correction awaiting validation",
  "sidenav.label.reports.sentMessages": "Sent Messages",
  "sidenav.label.admin.notifications": "Notifications",
  "sidenav.label.admin.notifications.channels": "Channels",
  "sidenav.label.admin.notifications.templates": "Templates",
  "sidenav.label.admin.notifications.delivery": "Delivery Settings",
  "sidenav.label.admin.notifications.triggers": "Triggers",
  "delivery.sent.title": "Sent Messages",
  "delivery.sent.subtitle": "Every message the laboratory sent or tried to send: reports, alerts, notices, notification triggers and channel tests",
  "delivery.sent.empty": "Nothing sent in this period.",
  "delivery.sent.loadError": "The messages could not be loaded",
  "delivery.sent.resend": "Resend",
  "delivery.sent.resend.done": "Message queued again.",
  "delivery.sent.resend.failed": "The message could not be queued again.",
  "delivery.sent.sentBy.auto": "Automatic",
  "delivery.sent.col.time": "Time",
  "delivery.sent.col.product": "Product",
  "delivery.sent.col.labNo": "Lab number",
  "delivery.sent.col.recipient": "Recipient",
  "delivery.sent.col.channel": "Channel",
  "delivery.sent.col.status": "Status",
  "delivery.sent.col.attempts": "Attempts",
  "delivery.sent.col.sentBy": "Sent by",
  "delivery.sent.filter.product": "Product",
  "delivery.sent.filter.status": "Status",
  "delivery.sent.filter.channel": "Channel",
  "delivery.sent.filter.to": "To",
  "delivery.sent.filter.recipient": "Recipient",
  "delivery.sent.filter.all": "All",
  "delivery.sent.detail.subject": "Subject",
  "delivery.sent.detail.message": "Message",
  "delivery.sent.detail.attempts": "Attempts",
  "delivery.sent.detail.noAttempts": "No attempt yet",
  "delivery.sent.detail.nextAttempt": "Next attempt {time}",
  "delivery.sent.detail.rule": "Rule",
  "delivery.sent.detail.report": "Report version {n}, {format}",
  "delivery.sent.detail.openOrder": "Open the order",
  "delivery.sent.detail.openQueue": "Open in the Report Print Queue",
  "delivery.sent.detail.loadError": "The message could not be loaded",
  "delivery.status.queued": "Queued",
  "delivery.status.sent": "Sent",
  "delivery.status.failed": "Failed",
  "delivery.status.skipped": "Skipped",
  "delivery.product.report": "Report",
  "delivery.product.alert": "Alert",
  "delivery.product.notice": "Ready notice",
  "delivery.product.trigger": "Notification",
  "delivery.product.test": "Test",
  "delivery.format.protected": "Protected full report",
  "delivery.format.masked": "Masked copy",
  "delivery.channel.email": "Email",
  "delivery.channel.sms": "SMS",
  "delivery.channel.whatsapp": "WhatsApp",
  "delivery.channel.title": "Channels",
  "delivery.channel.subtitle": "Email, SMS and WhatsApp are set up here once and used by every message the laboratory sends",
  "delivery.channel.status.ready": "Ready",
  "delivery.channel.status.notSetUp": "Not set up",
  "delivery.channel.status.failing": "Failing",
  "delivery.channel.lastSuccess": "Last successful send",
  "delivery.channel.never": "Never",
  "delivery.channel.lastError": "Last error",
  "delivery.channel.active": "Active",
  "delivery.channel.host": "SMTP host",
  "delivery.channel.port": "Port",
  "delivery.channel.security": "Security",
  "delivery.channel.security.starttls": "STARTTLS",
  "delivery.channel.security.ssl": "SSL/TLS",
  "delivery.channel.security.none": "None",
  "delivery.channel.username": "Username",
  "delivery.channel.password": "Password",
  "delivery.channel.secretSet": "Set",
  "delivery.channel.secretHelper": "A secret is stored. Leave this blank to keep it.",
  "delivery.channel.replace": "Replace",
  "delivery.channel.senderAddress": "Sender address",
  "delivery.channel.senderName": "Sender name",
  "delivery.channel.replyTo": "Reply-to address",
  "delivery.channel.whatsapp.accountSid": "Account SID",
  "delivery.channel.whatsapp.token": "Auth token",
  "delivery.channel.whatsapp.from": "Sending number",
  "delivery.channel.whatsapp.address": "API address (optional)",
  "delivery.channel.countryCode": "Default country code",
  "delivery.channel.gateway": "Gateway",
  "delivery.channel.sms.note": "The SMS gateway (BMP or SMPP) keeps its settings in the server properties until its own change lands; this row shows whether one is enabled.",
  "delivery.channel.save": "Save",
  "delivery.channel.saved": "Channel saved.",
  "delivery.channel.saveFailed": "The channel could not be saved: check {field}.",
  "delivery.channel.sendTest": "Send test",
  "delivery.channel.test.title": "Send a test message",
  "delivery.channel.test.address": "Address",
  "delivery.channel.test.send": "Send",
  "delivery.channel.test.sent": "Test message sent.",
  "delivery.channel.test.failed": "The test message was not sent.",
  "delivery.settings.title": "Delivery Settings",
  "delivery.settings.subtitle": "Lab-wide rules for how reports, alerts and notices are sent",
  "delivery.settings.retryDelays": "Retry after (minutes, in order)",
  "delivery.settings.retryDelays.helper": "For example 1,5,15: a failed send is tried again after 1, 5 and 15 minutes, then marked Failed",
  "delivery.settings.defaultFormat": "Format for recipients without a password",
  "delivery.settings.hold": "Wait before sending a new version (minutes)",
  "delivery.settings.partials": "Send partial reports automatically",
  "delivery.settings.contact": "Lab contact line",
  "delivery.settings.contact.helper": "Phone, email and opening hours, as printed in notices",
  "delivery.settings.location": "Where reports are sent from",
  "delivery.settings.location.local": "This lab",
  "delivery.settings.location.central": "Central delivery service",
  "delivery.settings.centralAddress": "Central delivery service address",
  "delivery.settings.centralConfirm": "Reports, alerts and patient notices for this lab will be sent by the central service at {address}. This lab will stop sending them.",
  "delivery.settings.links": "Secure links",
  "delivery.settings.linkDays": "Link lifetime (days)",
  "delivery.settings.countryCode": "Default country code",
  "delivery.settings.save": "Save",
  "delivery.settings.saved": "Settings saved.",
  "delivery.settings.invalid": "The settings could not be saved: check {field}.",
  "externalconnections.password.set": "A password is stored. Leave this blank to keep it.",
  "notificationtrigger.referralrejected.name": "Referral result rejected",
  "notificationtrigger.referralrejected.description": "Sent when a result returned by the reference laboratory is rejected and the sample must be collected again.",
  "notificationtrigger.templates.referralrejected.description": "Sent to the ordering provider or the submitting user when a returned referral result is rejected.",
  "notificationtrigger.referralnudge.name": "Referral nudge",
  "notificationtrigger.referralnudge.description": "Sent to the reference laboratory's contact when a referral is overdue and a nudge is requested.",
  "notificationtrigger.templates.referralnudge.description": "Sent to the chain-of-custody contact at the reference laboratory when a result is awaited.",
  "notificationtrigger.sampleresampled.name": "Sample re-collection",
  "notificationtrigger.sampleresampled.description": "Sent when an order is marked for re-collection and a replacement order is created.",
  "notificationtrigger.templates.sampleresampled.description": "Sent to the ordering provider or the submitting user when a sample must be collected again.",
  "notificationtrigger.testresult.name": "Patient results ready",
  "notificationtrigger.testresult.description": "Sent to the patient or the provider when a test configured under Test Notifications has a released result.",
  "notificationtrigger.templates.testresult.description": "Sent to the patient or the provider when a configured test's result is released. It never names the patient.",
  "sideNav.title.managementOverview": "Management Overview",
  "label.mgmt.title": "Management Overview",
  "label.mgmt.subtitle": "{0} · {1} · {2} samples received",
  "label.dashboard.refresh": "Refresh",
  "label.dashboard.lastUpdated": "Updated {0}m ago",
  "label.dashboard.scope.last7days": "Last 7 days",
  "label.dashboard.scope.last30days": "Last 30 days",
  "label.dashboard.scope.last90days": "Last 90 days",
  "label.dashboard.scope.quarter": "Quarter",
  "label.dashboard.scope.yearToDate": "Year-to-date",
  "label.dashboard.scope.year": "Year",
  "label.mgmt.subtitle.noSiteName": "{0} · {1} samples received",
  "label.dashboard.scope": "Time scope",
  "label.mgmt.kpi.totalSamples": "Total samples",
  "label.mgmt.kpi.medianTat": "Median TAT",
  "label.mgmt.kpi.onTime": "On-time completion",
  "label.mgmt.kpi.rejectionRate": "Rejection rate",
  "label.mgmt.kpi.qcPassRate": "QC pass rate",
  "label.mgmt.kpi.vsPrior": "vs. prior period",
  "label.mgmt.kpi.noPrior": "No prior data",
  "label.mgmt.kpi.medianTat.tooltip": "Median time from sample receipt to result validation, counted per test, for samples received in this period.",
  "label.mgmt.workload.title": "Workload & turnaround time",
  "label.mgmt.workload.byCard": "Workload by section (daily, {0})",
  "label.mgmt.workload.tatTable": "TAT by section (median, {0})",
  "label.mgmt.workload.tatTable.section": "Section",
  "label.mgmt.workload.tatTable.samples": "Samples",
  "label.mgmt.workload.tatTable.median": "Median",
  "label.mgmt.workload.tatTable.p90": "P90",
  "label.mgmt.workload.tatTable.onTime": "On-time %",
  "label.mgmt.workload.tatTable.info": "How is TAT counted?",
  "label.mgmt.workload.tatTable.tooltip": "TAT is counted per test, from sample receipt to result validation. The Samples column counts samples, so a section that runs panels has more tests than samples.",
  "label.mgmt.workload.empty": "No samples were received in this period",
  "label.mgmt.equipment.title": "Equipment activity",
  "label.mgmt.equipment.subtitle": "Per-analyzer recent activity · sample counts in current scope ({0}) · maintenance & service tracked in a separate roadmap epic",
  "label.mgmt.equipment.status.active": "Active",
  "label.mgmt.equipment.status.quiet": "Quiet",
  "label.mgmt.equipment.status.noActivity": "No activity",
  "label.mgmt.equipment.lastActivity": "Last activity: {0}",
  "label.mgmt.equipment.samples": "{0} {count, plural, one {sample} other {samples}} · {1}",
  "label.mgmt.antibiogram.title": "Antibiogram — % resistant by organism × antibiotic",
  "label.mgmt.antibiogram.meta": "First isolate per patient per period",
  "label.mgmt.antibiogram.organismHeader": "Organism",
  "label.mgmt.antibiogram.organism": "{0} (n={1})",
  "label.mgmt.antibiogram.tested": "n={0}",
  "label.mgmt.antibiogram.tooFew": "Only {0} tested; a percentage needs at least 10",
  "label.mgmt.antibiogram.fallback": "No susceptibility results in this period. First isolates by organism:",
  "label.mgmt.antibiogram.none": "No first isolates were collected in this period",
  "label.mgmt.stock.title": "Stock & inventory",
  "label.mgmt.stock.criticalReagents": "Critical reagents — on hand",
  "label.mgmt.stock.expiringIn30": "Expiring in 30 days",
  "label.mgmt.stock.reorderAlerts": "Reorder alerts",
  "label.mgmt.stock.emptyState": "Inventory is being set up at this deployment. Stock alerts will appear as reagent receipts are recorded.",
  "label.mgmt.stock.inventoryLink": "Inventory module",
  "label.mgmt.stock.lotExpiry": "Lot {0} · exp {1}",
  "label.mgmt.stock.expiresIn": "Expires in {days, plural, one {# day} other {# days}}",
  "label.mgmt.stock.expired": "Expired",
  "label.mgmt.stock.expiredInStock": "{count, plural, one {# expired lot is} other {# expired lots are}} still in stock",
  "label.mgmt.stock.expiredLots": "Expired, still in stock",
  "label.mgmt.stock.lotRemaining": "{0} · Lot {1} · {2} remaining",
  "label.mgmt.stock.belowReorder": "Below reorder point",
  "label.mgmt.stock.approachingReorder": "Approaching reorder point",
  "label.mgmt.stock.onHandReorderAt": "{0} · {1} on hand, reorder at {2}",
  "label.mgmt.stock.orderPlaced": "order placed {0}",
  "label.mgmt.stock.orderBy": "order by {0}",
  "label.mgmt.stock.noneCritical": "No reagent has a reorder threshold yet",
  "label.mgmt.stock.noneExpiring": "Nothing expires in the next 30 days",
  "label.mgmt.stock.noneReorder": "No item needs reordering",
  "label.mgmt.weights.title": "Composite quality score weights",
  "label.mgmt.weights.help": "How much each component counts toward the composite quality score on the Management Overview. The weights must add up to 1.00.",
  "label.mgmt.weights.qc": "QC pass rate",
  "label.mgmt.weights.eqa": "EQA performance",
  "label.mgmt.weights.nceInverse": "NCE inverse",
  "label.mgmt.weights.amendmentInverse": "Amendment inverse",
  "label.mgmt.weights.total": "Total {0}",
  "label.mgmt.weights.saved": "Weights saved",
  "label.mgmt.weights.saveFailed": "The weights could not be saved",
  "label.mgmt.weights.offTotal": "Total {0}. Saving scales the weights so they add up to 1.00.",
  "label.mgmt.weights.invalid": "Enter every weight as a number from 0 to 1, with at least one above 0.",
  "label.mgmt.weights.scaleTitle": "Scale the weights to add up to 1.00?",
  "label.mgmt.weights.scaleBody": "The weights you entered add up to {0}. They will be saved as:",
  "label.mgmt.weights.scaleConfirm": "Save scaled weights",
  "label.mgmt.surveillance.metric.mtbDetected": "MTB detected",
  "label.mgmt.surveillance.metric.rifResistance": "RIF resistance",
  "label.mgmt.surveillance.metric.smearPositive": "Smear positive",
  "label.mgmt.surveillance.metric.hivPositive": "HIV positive",
  "label.mgmt.surveillance.metric.vlSuppressed": "VL suppressed (< 1000)",
  "label.mgmt.surveillance.metric.rdtPositive": "RDT positive",
  "label.mgmt.quality.title": "Quality rollup",
  "label.mgmt.quality.composite": "Composite quality",
  "label.mgmt.quality.components": "Components",
  "label.mgmt.quality.qcPass": "QC pass rate",
  "label.mgmt.quality.eqaPerf": "EQA performance",
  "label.mgmt.quality.nceInverse": "NCE inverse",
  "label.mgmt.quality.amendmentInverse": "Amendment rate inverse",
  "label.mgmt.quality.weightsConfigurable": "Weights resolve from QI Configuration per lab.",
  "label.mgmt.quality.editWeights": "Edit weights ↗",
  "label.mgmt.quality.qiDashboard": "QI Dashboard ↗",
  "label.mgmt.quality.weight": "weight {0}",
  "label.mgmt.quality.noData": "No data in this period for {0}; the other weights are rescaled to make up the score.",
  "label.mgmt.surveillance.title": "Disease surveillance",
  "label.mgmt.surveillance.subtitle": "Positivity and resistance rates over the current scope ({0})",
  "label.mgmt.surveillance.tb": "Tuberculosis",
  "label.mgmt.surveillance.hiv": "HIV",
  "label.mgmt.surveillance.malaria": "Malaria",
  "label.mgmt.surveillance.amr": "AMR",
  "label.mgmt.surveillance.testCount": "{0} tests · {1}",
  "label.mgmt.surveillance.ofTested": "{0} of {1} tested",
  "label.mgmt.surveillance.trendUp": "{0} ↑ {1}pp vs. prior period",
  "label.mgmt.surveillance.trendDown": "{0} ↓ {1}pp vs. prior period",
  "label.mgmt.surveillance.trendStable": "{0} stable vs. prior period",
  "label.mgmt.surveillance.setup": "Set these WHONET codes or organism groups in the microbiology reference data: {0}",
  "label.mgmt.surveillance.openDetail": "Open detail",
  "label.mgmt.export.title": "Export & share",
  "label.mgmt.export.pdf": "Export PDF",
  "label.mgmt.export.csv": "Download CSV",
  "label.mgmt.export.schedule": "Schedule report",
  "label.mgmt.export.scheduleTooltip": "Available in v2",
  "label.mgmt.export.chooseSections": "Choose the sections to download. Each one is saved as its own CSV file.",
  "label.mgmt.export.download": "Download",
  "label.mgmt.export.failed": "The export could not be completed. Try again.",
  "label.mgmt.export.lab": "Laboratory",
  "label.mgmt.export.generated": "Generated",
  "label.mgmt.export.chartUnavailable": "[Chart image unavailable]",
  "label.mgmt.export.page": "Page {0} of {1}",
  "label.mgmt.export.section.kpis": "Key indicators",
  "label.mgmt.export.col.indicator": "Indicator",
  "label.mgmt.export.col.value": "Value",
  "label.mgmt.export.col.prior": "Prior period",
  "label.mgmt.export.col.medianTatHours": "Median TAT (h)",
  "label.mgmt.export.col.p90TatHours": "P90 TAT (h)",
  "label.mgmt.export.col.analyzer": "Analyzer",
  "label.mgmt.export.col.status": "Status",
  "label.mgmt.export.col.lastActivity": "Last activity",
  "label.mgmt.export.col.isolates": "Isolates",
  "label.mgmt.export.col.antibiotic": "Antibiotic",
  "label.mgmt.export.col.tested": "Tested",
  "label.mgmt.export.col.percentResistant": "% resistant",
  "label.mgmt.export.col.weight": "Weight",
  "label.mgmt.export.col.list": "List",
  "label.mgmt.export.col.item": "Item",
  "label.mgmt.export.col.lot": "Lot",
  "label.mgmt.export.col.quantity": "Quantity",
  "label.mgmt.export.col.detail": "Detail",
  "label.mgmt.export.col.program": "Program",
  "label.mgmt.export.col.metric": "Metric",
  "label.mgmt.export.col.positive": "Positive",
  "label.mgmt.export.col.deltaPoints": "Change vs. prior (points)"
}
